/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 591);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(44);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["r"] = acos;
/* harmony export (immutable) */ __webpack_exports__["f"] = asin;
/* harmony export (immutable) */ __webpack_exports__["u"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(17);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35), __webpack_require__(244)(module)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(440)();
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMProperty = __webpack_require__(42);
var ReactDOMComponentFlags = __webpack_require__(201);

var invariant = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(515);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(516);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(517);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(518);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(519);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(522);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(523);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(525);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_DATA_BY_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_DATA_BY_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SELECTED_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_COMPARISON_COUNTRY; });
/* unused harmony export SET_SELECTED_COUNTRY_DATA */
/* unused harmony export SET_COMPARISON_COUNTRY_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return setDataByCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return setDataByIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return setSelectedCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return setComparisonCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return setSelectedCountryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return setComparisonCountryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_COUNTRY_DATA_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_COUNTRY_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_COUNTRY_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_COUNTRY_DATA_UNLOAD; });
/* unused harmony export LOAD_COUNTRY_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_COMPARISON_COUNTRY_DATA_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_COMPARISON_COUNTRY_DATA_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_COMPARISON_COUNTRY_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOAD_COMPARISON_COUNTRY_DATA_UNLOAD; });
/* unused harmony export LOAD_COMPARISON_COUNTRY_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COUNTRY_FACILITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return loadCountryFacilitation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return unloadCountryFacilitation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return THIRD_PILLAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return loadThirdPillar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return unloadThirdPillar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SEVEN_PILLARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return loadSevenPillars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return unloadSevenPillars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TFA_ARTICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadTfaArticles; });
/* unused harmony export unloadTfaArticles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TFA_PROVISIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return loadTfaProvisions; });
/* unused harmony export unloadTfaProvisions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LATEST_BY_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return loadLatestByIndicator; });
/* unused harmony export unlloadLatestByIndicator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return OPEN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLOSE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return openModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return closeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_COLOR_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return setColorMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_COUNTRY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return setCountryMode; });
var SET_DATA_BY_COUNTRY = 'SET_DATA_BY_COUNTRY';
var SET_DATA_BY_INDICATOR = 'SET_DATA_BY_INDICATOR';
var SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';
var SET_COMPARISON_COUNTRY = 'SET_COMPARISON_COUNTRY';
var SET_SELECTED_COUNTRY_DATA = 'SET_SELECTED_COUNTRY_DATA';
var SET_COMPARISON_COUNTRY_DATA = 'SET_COMPARISON_COUNTRY_DATA';

var setDataByCountry = function setDataByCountry() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: SET_DATA_BY_COUNTRY,
    payload: payload
  };
};

var setDataByIndicator = function setDataByIndicator() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: SET_DATA_BY_INDICATOR,
    payload: payload
  };
};

var setSelectedCountry = function setSelectedCountry() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_SELECTED_COUNTRY,
    payload: payload
  };
};

var setComparisonCountry = function setComparisonCountry() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_COMPARISON_COUNTRY,
    payload: payload
  };
};

var setSelectedCountryData = function setSelectedCountryData() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_SELECTED_COUNTRY_DATA,
    payload: payload
  };
};

var setComparisonCountryData = function setComparisonCountryData() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_COMPARISON_COUNTRY_DATA,
    payload: payload
  };
};

var LOAD_COUNTRY_DATA_LOADING = 'LOAD_COUNTRY_DATA_LOADING';
var LOAD_COUNTRY_DATA_ERROR = 'LOAD_COUNTRY_DATA_ERROR';
var LOAD_COUNTRY_DATA_SUCCESS = 'LOAD_COUNTRY_DATA_SUCCESS';
var LOAD_COUNTRY_DATA_UNLOAD = 'LOAD_COUNTRY_DATA_UNLOAD';
var LOAD_COUNTRY_DATA = 'LOAD_COUNTRY_DATA';

var LOAD_COMPARISON_COUNTRY_DATA_LOADING = 'LOAD_COMPARISON_COUNTRY_DATA_LOADING';
var LOAD_COMPARISON_COUNTRY_DATA_ERROR = 'LOAD_COMPARISON_COUNTRY_DATA_ERROR';
var LOAD_COMPARISON_COUNTRY_DATA_SUCCESS = 'LOAD_COMPARISON_COUNTRY_DATA_SUCCESS';
var LOAD_COMPARISON_COUNTRY_DATA_UNLOAD = 'LOAD_COMPARISON_COUNTRY_DATA_UNLOAD';
var LOAD_COMPARISON_COUNTRY_DATA = 'LOAD_COMPARISON_COUNTRY_DATA';

//export const loadCountryData = (payload) => { return { type: LOAD_COUNTRY_DATA, payload }}
//export const loadComparisonCountryData = () => ({ type: LOAD_COMPARISON_COUNTRY_DATA })


var COUNTRY_FACILITATION = 'COUNTRY_FACILITATION';
var loadCountryFacilitation = function loadCountryFacilitation() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: COUNTRY_FACILITATION,
    payload: payload
  };
};
var unloadCountryFacilitation = function unloadCountryFacilitation() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: 'COUNTRY_FACILITATION_UNLOAD',
    payload: payload
  };
};

var THIRD_PILLAR = 'THIRD_PILLAR';
var loadThirdPillar = function loadThirdPillar() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: THIRD_PILLAR,
    payload: payload
  };
};
var unloadThirdPillar = function unloadThirdPillar() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: 'THIRD_PILLAR_UNLOAD',
    payload: payload
  };
};

var SEVEN_PILLARS = 'SEVEN_PILLARS';
var loadSevenPillars = function loadSevenPillars() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SEVEN_PILLARS,
    payload: payload
  };
};
var unloadSevenPillars = function unloadSevenPillars() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: 'SEVEN_PILLARS_UNLOAD',
    payload: payload
  };
};

var TFA_ARTICLES = 'TFA_ARTICLES';
var loadTfaArticles = function loadTfaArticles() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: TFA_ARTICLES,
    payload: payload
  };
};
var unloadTfaArticles = function unloadTfaArticles() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: 'TFA_ARTICLES_UNLOAD',
    payload: payload
  };
};

var TFA_PROVISIONS = 'TFA_PROVISIONS';
var loadTfaProvisions = function loadTfaProvisions() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: TFA_PROVISIONS,
    payload: payload
  };
};
var unloadTfaProvisions = function unloadTfaProvisions() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: 'TFA_PROVISIONS_UNLOAD',
    payload: payload
  };
};

var LATEST_BY_INDICATOR = 'LATEST_BY_INDICATOR';
var loadLatestByIndicator = function loadLatestByIndicator() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: LATEST_BY_INDICATOR,
    payload: payload
  };
};
var unlloadLatestByIndicator = function unlloadLatestByIndicator() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: 'LATEST_BY_INDICATOR_UNLOAD',
    payload: payload
  };
};

var OPEN_MODAL = 'OPEN_MODAL';
var CLOSE_MODAL = 'CLOSE_MODAL';

var openModal = function openModal() {
  return {
    type: OPEN_MODAL
  };
};
var closeModal = function closeModal() {
  return {
    type: CLOSE_MODAL
  };
};

var SET_COLOR_MODE = 'SET_COLOR_MODE';
var setColorMode = function setColorMode(payload) {
  return {
    type: SET_COLOR_MODE,
    payload: payload
  };
};

var SET_COUNTRY_MODE = 'SET_COUNTRY_MODE';
var setCountryMode = function setCountryMode(payload) {
  return {
    type: SET_COUNTRY_MODE,
    payload: payload
  };
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.actions = exports.middleware = exports.reducer = exports.Origin = exports.Tooltip = undefined;

var _tooltip = __webpack_require__(559);

Object.defineProperty(exports, 'Tooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_tooltip).default;
  }
});

var _origin = __webpack_require__(556);

Object.defineProperty(exports, 'Origin', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_origin).default;
  }
});

var _reducer = __webpack_require__(557);

Object.defineProperty(exports, 'reducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer).default;
  }
});

var _middleware = __webpack_require__(555);

Object.defineProperty(exports, 'middleware', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_middleware).default;
  }
});

var _actions = __webpack_require__(61);

var actions = _interopRequireWildcard(_actions);

var _utils = __webpack_require__(77);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.actions = actions;
exports.utils = utils;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(527);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(528);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(530);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(126);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(276);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(277);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(145);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(146);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(278);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(288);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(289);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(150);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(280);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(281);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(282);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(147);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(148);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(284);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(285);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(286);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(287);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(152);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(153);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(290);
/* unused harmony reexport zip */





























/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var onElementResize = __webpack_require__(382);

var defaultContainerStyle = {
  width: '100%',
  height: '100%',
  padding: 0,
  border: 0
};

function defaultGetWidth(element) {
  return element.clientWidth;
}

function defaultGetHeight(element) {
  return element.clientHeight;
}

/**
 * Wraps a react component and adds properties `containerHeight` and
 * `containerWidth`. Useful for responsive design. Properties update on
 * window resize. **Note** that the parent element must have either a
 * height or a width, or nothing will be rendered
 *
 * Can be used as a
 * [higher-order component](http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers)
 * or as an [ES7 class decorator](https://github.com/wycats/javascript-decorators)
 * (see examples)
 *
 * @param {object} [options]
 * @param {function} [options.getHeight] A function that is passed an element and returns element
 * height, where element is the wrapper div. Defaults to `(element) => element.clientHeight`
 * @param {function} [options.getWidth]  A function that is passed an element and returns element
 * width, where element is the wrapper div. Defaults to `(element) => element.clientWidth`
 * @param {object} [options.containerStyle] A style object for the `<div>` that will wrap your component.
 * The dimensions of this `div` are what are passed as props to your component. The default style is
 * `{ width: '100%', height: '100%', padding: 0, border: 0 }` which will cause the `div` to fill its
 * parent in most cases. If you are using a flexbox layout you will want to change this default style.
 * @param {string} [options.className] Control the class name set on the wrapper `<div>`
 * @param {boolean} [options.elementResize=false] Set true to watch the wrapper `div` for changes in
 * size which are not a result of window resizing - e.g. changes to the flexbox and other layout.
 * @return {function}                   A higher-order component that can be
 * used to enhance a react component `Dimensions()(MyComponent)`
 *
 * @example
 * // ES2015
 * import React from 'react'
 * import Dimensions from 'react-dimensions'
 *
 * class MyComponent extends React.Component {
 *   render() (
 *     <div
 *       containerWidth={this.props.containerWidth}
 *       containerHeight={this.props.containerHeight}
 *     >
 *     </div>
 *   )
 * }
 *
 * export default Dimensions()(MyComponent) // Enhanced component
 *
 * @example
 * // ES5
 * var React = require('react')
 * var Dimensions = require('react-dimensions')
 *
 * var MyComponent = React.createClass({
 *   render: function() {(
 *     <div
 *       containerWidth={this.props.containerWidth}
 *       containerHeight={this.props.containerHeight}
 *     >
 *     </div>
 *   )}
 * }
 *
 * module.exports = Dimensions()(MyComponent) // Enhanced component
 *
 */
module.exports = function Dimensions() {
  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var _ref$getHeight = _ref.getHeight;
  var getHeight = _ref$getHeight === undefined ? defaultGetHeight : _ref$getHeight;
  var _ref$getWidth = _ref.getWidth;
  var getWidth = _ref$getWidth === undefined ? defaultGetWidth : _ref$getWidth;
  var _ref$containerStyle = _ref.containerStyle;
  var containerStyle = _ref$containerStyle === undefined ? defaultContainerStyle : _ref$containerStyle;
  var _ref$className = _ref.className;
  var className = _ref$className === undefined ? null : _ref$className;
  var _ref$elementResize = _ref.elementResize;
  var elementResize = _ref$elementResize === undefined ? false : _ref$elementResize;

  return function (ComposedComponent) {
    return function (_React$Component) {
      _inherits(DimensionsHOC, _React$Component);

      function DimensionsHOC() {
        var _Object$getPrototypeO;

        var _temp, _this, _ret;

        _classCallCheck(this, DimensionsHOC);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(DimensionsHOC)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {}, _this.updateDimensions = function () {
          var container = _this.refs.container;
          var containerWidth = getWidth(container);
          var containerHeight = getHeight(container);

          if (containerWidth !== _this.state.containerWidth || containerHeight !== _this.state.containerHeight) {
            _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
          }
        }, _this.onResize = function () {
          if (_this.rqf) return;
          _this.rqf = _this.getWindow().requestAnimationFrame(function () {
            _this.rqf = null;
            _this.updateDimensions();
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      // ES7 Class properties
      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#property-initializers


      // Using arrow functions and ES7 Class properties to autobind
      // http://babeljs.io/blog/2015/06/07/react-on-es6-plus/#arrow-functions


      _createClass(DimensionsHOC, [{
        key: 'getWindow',


        // If the component is mounted in a different window to the javascript
        // context, as with https://github.com/JakeGinnivan/react-popout
        // then the `window` global will be different from the `window` that
        // contains the component.
        // Depends on `defaultView` which is not supported <IE9
        value: function getWindow() {
          return this.refs.container ? this.refs.container.ownerDocument.defaultView || window : window;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (!this.refs.container) {
            throw new Error('Cannot find container div');
          }
          this.updateDimensions();
          if (elementResize) {
            // Experimental: `element-resize-event` fires when an element resizes.
            // It attaches its own window resize listener and also uses
            // requestAnimationFrame, so we can just call `this.updateDimensions`.
            onElementResize(this.refs.container, this.updateDimensions);
          } else {
            this.getWindow().addEventListener('resize', this.onResize, false);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.getWindow().removeEventListener('resize', this.onResize);
        }

        /**
         * Returns the underlying wrapped component instance.
         * Useful if you need to access a method or property of the component
         * passed to react-dimensions.
         *
         * @return {object} The rendered React component
         **/

      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          this.refs.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _state = this.state;
          var containerWidth = _state.containerWidth;
          var containerHeight = _state.containerHeight;

          if (!containerWidth && !containerHeight) {
            console.warn('Wrapper div has no height or width, try overriding style with `containerStyle` option');
          }
          return React.createElement(
            'div',
            { className: className, style: containerStyle, ref: 'container' },
            (containerWidth || containerHeight) && React.createElement(ComposedComponent, _extends({}, this.state, this.props, {
              updateDimensions: this.updateDimensions,
              ref: 'wrappedInstance'
            }))
          );
        }
      }]);

      return DimensionsHOC;
    }(React.Component);
  };
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(7);

var CallbackQueue = __webpack_require__(199);
var PooledClass = __webpack_require__(32);
var ReactFeatureFlags = __webpack_require__(204);
var ReactReconciler = __webpack_require__(43);
var Transaction = __webpack_require__(71);

var invariant = __webpack_require__(1);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["b"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["m"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["w"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["i"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["q"] = log;
/* harmony export (immutable) */ __webpack_exports__["d"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = sym('TASK');
var HELPER = sym('HELPER');
var MATCH = sym('MATCH');
var CANCEL = sym('CANCEL_PROMISE');
var SAGA_ACTION = sym('SAGA_ACTION');
var SELF_CANCELLATION = sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = konst(true);
var kFalse = konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  'from': function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_extent__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample__ = __webpack_require__(333);











var transformRadians = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__transform__["a" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */], // clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */], // clip extent
      delta2 = 0.5, projectResample = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clip_circle__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], 6 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clip_extent__["a" /* clipExtent */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math__["g" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math__["h" /* degrees */]];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resample__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__math__["n" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__fit__["b" /* fitSize */])(projection, size, object);
  };

  function recenter() {
    projectRotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__compose__["a" /* default */])(rotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__rotation__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var PooledClass = __webpack_require__(32);

var emptyFunction = __webpack_require__(17);
var warning = __webpack_require__(4);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(455);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCsvFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var downloadCSV = function downloadCSV(data, filename) {
  var csvContent = "data:text/csv;charset=utf-8,";
  data.forEach(function (row, index) {
    var dataString = row.join(",");
    csvContent += index < data.length ? dataString + "\n" : dataString;
  });
  var encodedUri = encodeURI(csvContent);
  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  link.click(); // This will download the data file named "my_data.csv".
};

var processData = function processData(data, countries, indicators) {
  var out = [];
  countries.forEach(function (country) {
    indicators.forEach(function (indicator) {
      var cData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data[indicator], '[' + country + ']', {});
      var years = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"])(cData).sort();
      years.forEach(function (year) {
        var row = [country, indicator, year, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(cData[year], 'v')];
        out.push(row);
      });
    });
  });
  return out;
};

var processDataTFAArticles = function processDataTFAArticles(data, countries, indicators) {
  var out = [];
  countries.forEach(function (country) {
    indicators.forEach(function (indicator) {
      var cData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data[indicator], '[' + country + ']', {});
      var row = [country, 'TFA Article ' + indicator, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(cData, 'date'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(cData, 'v')];
      out.push(row);
    });
  });
  return out;
};

var processDataTFAProvisions = function processDataTFAProvisions(data, countries, indicators) {
  var out = [];
  countries.forEach(function (country) {
    indicators.forEach(function (indicator) {
      var cData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data[indicator], '[' + country + ']', {});
      var row = [country, 'TFA Provision ' + indicator, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(cData, 'date'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(cData, 'v')];
      out.push(row);
    });
  });
  return out;
};

var getCsvFile = function getCsvFile(filename, countries) {
  var indicators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var articles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var provisions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  // in the form (countryCode, indicatorCode, year, value)
  var out = [["countryCode", "indicator", "year", "value"]];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* getJsonData */])("/data_by_indicator.json").then(function (data) {
    out = out.concat(processData(data, countries, indicators));
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* getJsonData */])("/tfa/data_tfa_articles.json");
  }).then(function (data2) {
    out = out.concat(processDataTFAArticles(data2, countries, articles));
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* getJsonData */])("/tfa/data_tfa_provisions.json");
  }).then(function (data3) {
    out = out.concat(processDataTFAProvisions(data3, countries, provisions));
    return downloadCSV(out, filename);
  });
};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/



Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(37);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(505);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(62);

var _classnames2 = _interopRequireDefault(_classnames);

var _utilsDefaultArrowRenderer = __webpack_require__(538);

var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);

var _utilsDefaultFilterOptions = __webpack_require__(225);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(226);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var _utilsDefaultClearRenderer = __webpack_require__(539);

var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);

var _Async = __webpack_require__(533);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(534);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(535);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Option = __webpack_require__(536);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(537);

var _Value2 = _interopRequireDefault(_Value);

function stringifyValue(value) {
	var valueType = typeof value;
	if (valueType === 'string') {
		return value;
	} else if (valueType === 'object') {
		return JSON.stringify(value);
	} else if (valueType === 'number' || valueType === 'boolean') {
		return String(value);
	} else {
		return '';
	}
}

var stringOrNode = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]);

var instanceId = 1;

var Select = (0, _createReactClass2['default'])({

	displayName: 'Select',

	propTypes: {
		addLabelText: _propTypes2['default'].string, // placeholder displayed when you want to add a label on a multi-value input
		'aria-describedby': _propTypes2['default'].string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2['default'].string, // Aria label (for assistive tech)
		'aria-labelledby': _propTypes2['default'].string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2['default'].func, // Create drop-down caret element
		autoBlur: _propTypes2['default'].bool, // automatically blur the component when an option is selected
		autofocus: _propTypes2['default'].bool, // autofocus the component on mount
		autosize: _propTypes2['default'].bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2['default'].string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2['default'].string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2['default'].func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2['default'].bool, // should it be possible to reset value
		deleteRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		delimiter: _propTypes2['default'].string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2['default'].bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2['default'].bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2['default'].func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2['default'].any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _propTypes2['default'].bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2['default'].bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2['default'].object, // custom attributes for the Input
		inputRenderer: _propTypes2['default'].func, // returns a custom input component
		instanceId: _propTypes2['default'].string, // set the components instanceId
		isLoading: _propTypes2['default'].bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2['default'].bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2['default'].string, // path of the label value in option objects
		matchPos: _propTypes2['default'].string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2['default'].string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2['default'].number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2['default'].object, // optional style to apply to the menu container
		menuRenderer: _propTypes2['default'].func, // renders a custom menu with options
		menuStyle: _propTypes2['default'].object, // optional style to apply to the menu
		multi: _propTypes2['default'].bool, // multi-value input
		name: _propTypes2['default'].string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2['default'].func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2['default'].bool, // whether input is cleared on blur
		onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
		onClose: _propTypes2['default'].func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2['default'].bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2['default'].func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2['default'].func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2['default'].func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2['default'].func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2['default'].func, // fires when the menu is opened
		onValueClick: _propTypes2['default'].func, // onClick handler for value labels: function (value, event) {}
		openAfterFocus: _propTypes2['default'].bool, // boolean to enable opening dropdown when focused
		openOnFocus: _propTypes2['default'].bool, // always open options menu on focus
		optionClassName: _propTypes2['default'].string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2['default'].func, // option component to render in dropdown
		optionRenderer: _propTypes2['default'].func, // optionRenderer: function (option) {}
		options: _propTypes2['default'].array, // array of options
		pageSize: _propTypes2['default'].number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _propTypes2['default'].bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2['default'].any, // value to use when you clear the control
		scrollMenuIntoView: _propTypes2['default'].bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2['default'].bool, // whether to enable searching feature or not
		simpleValue: _propTypes2['default'].bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2['default'].object, // optional style to apply to the control
		tabIndex: _propTypes2['default'].string, // optional tab index of the control
		tabSelectsValue: _propTypes2['default'].bool, // whether to treat tabbing out while focused to be value selection
		value: _propTypes2['default'].any, // initial field value
		valueComponent: _propTypes2['default'].func, // value component to render
		valueKey: _propTypes2['default'].string, // path of the label value in option objects
		valueRenderer: _propTypes2['default'].func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2['default'].object },

	// optional style to apply to the component wrapper
	statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },

	getDefaultProps: function getDefaultProps() {
		return {
			addLabelText: 'Add "{label}"?',
			arrowRenderer: _utilsDefaultArrowRenderer2['default'],
			autosize: true,
			backspaceRemoves: true,
			backspaceToRemoveMessage: 'Press backspace to remove {label}',
			clearable: true,
			clearAllText: 'Clear all',
			clearRenderer: _utilsDefaultClearRenderer2['default'],
			clearValueText: 'Clear value',
			deleteRemoves: true,
			delimiter: ',',
			disabled: false,
			escapeClearsValue: true,
			filterOptions: _utilsDefaultFilterOptions2['default'],
			ignoreAccents: true,
			ignoreCase: true,
			inputProps: {},
			isLoading: false,
			joinValues: false,
			labelKey: 'label',
			matchPos: 'any',
			matchProp: 'any',
			menuBuffer: 0,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			multi: false,
			noResultsText: 'No results found',
			onBlurResetsInput: true,
			onCloseResetsInput: true,
			optionComponent: _Option2['default'],
			pageSize: 5,
			placeholder: 'Select...',
			required: false,
			scrollMenuIntoView: true,
			searchable: true,
			simpleValue: false,
			tabSelectsValue: true,
			valueComponent: _Value2['default'],
			valueKey: 'value'
		};
	},

	getInitialState: function getInitialState() {
		return {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
	},

	componentWillMount: function componentWillMount() {
		this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
		var valueArray = this.getValueArray(this.props.value);

		if (this.props.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], this.props.multi)
			});
		}
	},

	componentDidMount: function componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var valueArray = this.getValueArray(nextProps.value, nextProps);

		if (nextProps.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], nextProps.multi)
			});
		}
	},

	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			this.toggleTouchOutsideEvent(nextState.isOpen);
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},

	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// focus to the selected option
		if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
			var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
			var menuNode = _reactDom2['default'].findDOMNode(this.menu);
			menuNode.scrollTop = focusedOptionNode.offsetTop;
			this.hasScrolledToOption = true;
		} else if (!this.state.isOpen) {
			this.hasScrolledToOption = false;
		}

		if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
			this._scrollToFocusedOptionOnUpdate = false;
			var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
			var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
			var focusedRect = focusedDOM.getBoundingClientRect();
			var menuRect = menuDOM.getBoundingClientRect();
			if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
				menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
			}
		}
		if (this.props.scrollMenuIntoView && this.menuContainer) {
			var menuContainerRect = this.menuContainer.getBoundingClientRect();
			if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
				window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
			}
		}
		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			this.closeMenu();
		}
	},

	componentWillUnmount: function componentWillUnmount() {
		if (!document.removeEventListener && document.detachEvent) {
			document.detachEvent('ontouchstart', this.handleTouchOutside);
		} else {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		}
	},

	toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
		if (enabled) {
			if (!document.addEventListener && document.attachEvent) {
				document.attachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.addEventListener('touchstart', this.handleTouchOutside);
			}
		} else {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	},

	handleTouchOutside: function handleTouchOutside(event) {
		// handle touch outside on ios to dismiss menu
		if (this.wrapper && !this.wrapper.contains(event.target)) {
			this.closeMenu();
		}
	},

	focus: function focus() {
		if (!this.input) return;
		this.input.focus();
	},

	blurInput: function blurInput() {
		if (!this.input) return;
		this.input.blur();
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.handleMouseDown(event);
	},

	handleTouchEndClearValue: function handleTouchEndClearValue(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Clear the value
		this.clearValue(event);
	},

	handleMouseDown: function handleMouseDown(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}

		if (event.target.tagName === 'INPUT') {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		// for the non-searchable select, toggle the menu
		if (!this.props.searchable) {
			this.focus();
			return this.setState({
				isOpen: !this.state.isOpen
			});
		}

		if (this.state.isFocused) {
			// On iOS, we can get into a state where we think the input is focused but it isn't really,
			// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
			// Call focus() again here to be safe.
			this.focus();

			var input = this.input;
			if (typeof input.getInput === 'function') {
				// Get the actual DOM input if the ref is an <AutosizeInput /> component
				input = input.getInput();
			}

			// clears the value so that the cursor will be at the end of input when the component re-renders
			input.value = '';

			// if the input is focused, ensure the menu is open
			this.setState({
				isOpen: true,
				isPseudoFocused: false
			});
		} else {
			// otherwise, focus the input and open the menu
			this._openAfterFocus = true;
			this.focus();
		}
	},

	handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},

	handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},

	closeMenu: function closeMenu() {
		if (this.props.onCloseResetsInput) {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: ''
			});
		} else {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: this.state.inputValue
			});
		}
		this.hasScrolledToOption = false;
	},

	handleInputFocus: function handleInputFocus(event) {
		if (this.props.disabled) return;
		var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},

	handleInputBlur: function handleInputBlur(event) {
		// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
		if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false
		};
		if (this.props.onBlurResetsInput) {
			onBlurredState.inputValue = '';
		}
		this.setState(onBlurredState);
	},

	handleInputChange: function handleInputChange(event) {
		var newInputValue = event.target.value;

		if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
			var nextState = this.props.onInputChange(newInputValue);
			// Note: != used deliberately here to catch undefined and null
			if (nextState != null && typeof nextState !== 'object') {
				newInputValue = '' + nextState;
			}
		}

		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: newInputValue
		});
	},

	handleKeyDown: function handleKeyDown(event) {
		if (this.props.disabled) return;

		if (typeof this.props.onInputKeyDown === 'function') {
			this.props.onInputKeyDown(event);
			if (event.defaultPrevented) {
				return;
			}
		}

		switch (event.keyCode) {
			case 8:
				// backspace
				if (!this.state.inputValue && this.props.backspaceRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			case 9:
				// tab
				if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
					return;
				}
				this.selectFocusedOption();
				return;
			case 13:
				// enter
				if (!this.state.isOpen) return;
				event.stopPropagation();
				this.selectFocusedOption();
				break;
			case 27:
				// escape
				if (this.state.isOpen) {
					this.closeMenu();
					event.stopPropagation();
				} else if (this.props.clearable && this.props.escapeClearsValue) {
					this.clearValue(event);
					event.stopPropagation();
				}
				break;
			case 38:
				// up
				this.focusPreviousOption();
				break;
			case 40:
				// down
				this.focusNextOption();
				break;
			case 33:
				// page up
				this.focusPageUpOption();
				break;
			case 34:
				// page down
				this.focusPageDownOption();
				break;
			case 35:
				// end key
				if (event.shiftKey) {
					return;
				}
				this.focusEndOption();
				break;
			case 36:
				// home key
				if (event.shiftKey) {
					return;
				}
				this.focusStartOption();
				break;
			case 46:
				// backspace
				if (!this.state.inputValue && this.props.deleteRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			default:
				return;
		}
		event.preventDefault();
	},

	handleValueClick: function handleValueClick(option, event) {
		if (!this.props.onValueClick) return;
		this.props.onValueClick(option, event);
	},

	handleMenuScroll: function handleMenuScroll(event) {
		if (!this.props.onMenuScrollToBottom) return;
		var target = event.target;

		if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
			this.props.onMenuScrollToBottom();
		}
	},

	handleRequired: function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	},

	getOptionLabel: function getOptionLabel(op) {
		return op[this.props.labelKey];
	},

	/**
  * Turns a value into an array from the given options
  * @param	{String|Number|Array}	value		- the value of the select input
  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
  * @returns	{Array}	the value of the select represented in an array
  */
	getValueArray: function getValueArray(value, nextProps) {
		var _this = this;

		/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
		var props = typeof nextProps === 'object' ? nextProps : this.props;
		if (props.multi) {
			if (typeof value === 'string') value = value.split(props.delimiter);
			if (!Array.isArray(value)) {
				if (value === null || value === undefined) return [];
				value = [value];
			}
			return value.map(function (value) {
				return _this.expandValue(value, props);
			}).filter(function (i) {
				return i;
			});
		}
		var expandedValue = this.expandValue(value, props);
		return expandedValue ? [expandedValue] : [];
	},

	/**
  * Retrieve a value from the given options and valueKey
  * @param	{String|Number|Array}	value	- the selected value(s)
  * @param	{Object}		props	- the Select component's props (or nextProps)
  */
	expandValue: function expandValue(value, props) {
		var valueType = typeof value;
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options;
		var valueKey = props.valueKey;

		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey] === value) return options[i];
		}
	},

	setValue: function setValue(value) {
		var _this2 = this;

		if (this.props.autoBlur) {
			this.blurInput();
		}
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required: required });
		}
		if (this.props.simpleValue && value) {
			value = this.props.multi ? value.map(function (i) {
				return i[_this2.props.valueKey];
			}).join(this.props.delimiter) : value[this.props.valueKey];
		}
		this.props.onChange(value);
	},

	selectValue: function selectValue(value) {
		var _this3 = this;

		//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
		this.hasScrolledToOption = false;
		if (this.props.multi) {
			this.setState({
				inputValue: '',
				focusedIndex: null
			}, function () {
				_this3.addValue(value);
			});
		} else {
			this.setState({
				isOpen: false,
				inputValue: '',
				isPseudoFocused: this.state.isFocused
			}, function () {
				_this3.setValue(value);
			});
		}
	},

	addValue: function addValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		var visibleOptions = this._visibleOptions.filter(function (val) {
			return !val.disabled;
		});
		var lastValueIndex = visibleOptions.indexOf(value);
		this.setValue(valueArray.concat(value));
		if (visibleOptions.length - 1 === lastValueIndex) {
			// the last option was selected; focus the second-last one
			this.focusOption(visibleOptions[lastValueIndex - 1]);
		} else if (visibleOptions.length > lastValueIndex) {
			// focus the option below the selected one
			this.focusOption(visibleOptions[lastValueIndex + 1]);
		}
	},

	popValue: function popValue() {
		var valueArray = this.getValueArray(this.props.value);
		if (!valueArray.length) return;
		if (valueArray[valueArray.length - 1].clearableValue === false) return;
		this.setValue(valueArray.slice(0, valueArray.length - 1));
	},

	removeValue: function removeValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		this.setValue(valueArray.filter(function (i) {
			return i !== value;
		}));
		this.focus();
	},

	clearValue: function clearValue(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, ignore it.
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();
		this.setValue(this.getResetValue());
		this.setState({
			isOpen: false,
			inputValue: ''
		}, this.focus);
	},

	getResetValue: function getResetValue() {
		if (this.props.resetValue !== undefined) {
			return this.props.resetValue;
		} else if (this.props.multi) {
			return [];
		} else {
			return null;
		}
	},

	focusOption: function focusOption(option) {
		this.setState({
			focusedOption: option
		});
	},

	focusNextOption: function focusNextOption() {
		this.focusAdjacentOption('next');
	},

	focusPreviousOption: function focusPreviousOption() {
		this.focusAdjacentOption('previous');
	},

	focusPageUpOption: function focusPageUpOption() {
		this.focusAdjacentOption('page_up');
	},

	focusPageDownOption: function focusPageDownOption() {
		this.focusAdjacentOption('page_down');
	},

	focusStartOption: function focusStartOption() {
		this.focusAdjacentOption('start');
	},

	focusEndOption: function focusEndOption() {
		this.focusAdjacentOption('end');
	},

	focusAdjacentOption: function focusAdjacentOption(dir) {
		var options = this._visibleOptions.map(function (option, index) {
			return { option: option, index: index };
		}).filter(function (option) {
			return !option.option.disabled;
		});
		this._scrollToFocusedOptionOnUpdate = true;
		if (!this.state.isOpen) {
			this.setState({
				isOpen: true,
				inputValue: '',
				focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
			});
			return;
		}
		if (!options.length) return;
		var focusedIndex = -1;
		for (var i = 0; i < options.length; i++) {
			if (this._focusedOption === options[i].option) {
				focusedIndex = i;
				break;
			}
		}
		if (dir === 'next' && focusedIndex !== -1) {
			focusedIndex = (focusedIndex + 1) % options.length;
		} else if (dir === 'previous') {
			if (focusedIndex > 0) {
				focusedIndex = focusedIndex - 1;
			} else {
				focusedIndex = options.length - 1;
			}
		} else if (dir === 'start') {
			focusedIndex = 0;
		} else if (dir === 'end') {
			focusedIndex = options.length - 1;
		} else if (dir === 'page_up') {
			var potentialIndex = focusedIndex - this.props.pageSize;
			if (potentialIndex < 0) {
				focusedIndex = 0;
			} else {
				focusedIndex = potentialIndex;
			}
		} else if (dir === 'page_down') {
			var potentialIndex = focusedIndex + this.props.pageSize;
			if (potentialIndex > options.length - 1) {
				focusedIndex = options.length - 1;
			} else {
				focusedIndex = potentialIndex;
			}
		}

		if (focusedIndex === -1) {
			focusedIndex = 0;
		}

		this.setState({
			focusedIndex: options[focusedIndex].index,
			focusedOption: options[focusedIndex].option
		});
	},

	getFocusedOption: function getFocusedOption() {
		return this._focusedOption;
	},

	getInputValue: function getInputValue() {
		return this.state.inputValue;
	},

	selectFocusedOption: function selectFocusedOption() {
		if (this._focusedOption) {
			return this.selectValue(this._focusedOption);
		}
	},

	renderLoading: function renderLoading() {
		if (!this.props.isLoading) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
			_react2['default'].createElement('span', { className: 'Select-loading' })
		);
	},

	renderValue: function renderValue(valueArray, isOpen) {
		var _this4 = this;

		var renderLabel = this.props.valueRenderer || this.getOptionLabel;
		var ValueComponent = this.props.valueComponent;
		if (!valueArray.length) {
			return !this.state.inputValue ? _react2['default'].createElement(
				'div',
				{ className: 'Select-placeholder' },
				this.props.placeholder
			) : null;
		}
		var onClick = this.props.onValueClick ? this.handleValueClick : null;
		if (this.props.multi) {
			return valueArray.map(function (value, i) {
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: _this4._instancePrefix + '-value-' + i,
						instancePrefix: _this4._instancePrefix,
						disabled: _this4.props.disabled || value.clearableValue === false,
						key: 'value-' + i + '-' + value[_this4.props.valueKey],
						onClick: onClick,
						onRemove: _this4.removeValue,
						value: value
					},
					renderLabel(value, i),
					_react2['default'].createElement(
						'span',
						{ className: 'Select-aria-only' },
						' '
					)
				);
			});
		} else if (!this.state.inputValue) {
			if (isOpen) onClick = null;
			return _react2['default'].createElement(
				ValueComponent,
				{
					id: this._instancePrefix + '-value-item',
					disabled: this.props.disabled,
					instancePrefix: this._instancePrefix,
					onClick: onClick,
					value: valueArray[0]
				},
				renderLabel(valueArray[0])
			);
		}
	},

	renderInput: function renderInput(valueArray, focusedOptionIndex) {
		var _classNames,
		    _this5 = this;

		var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
		var isOpen = !!this.state.isOpen;

		var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

		// TODO: Check how this project includes Object.assign()
		var inputProps = _extends({}, this.props.inputProps, {
			role: 'combobox',
			'aria-expanded': '' + isOpen,
			'aria-owns': ariaOwns,
			'aria-haspopup': '' + isOpen,
			'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
			'aria-describedby': this.props['aria-describedby'],
			'aria-labelledby': this.props['aria-labelledby'],
			'aria-label': this.props['aria-label'],
			className: className,
			tabIndex: this.props.tabIndex,
			onBlur: this.handleInputBlur,
			onChange: this.handleInputChange,
			onFocus: this.handleInputFocus,
			ref: function ref(_ref) {
				return _this5.input = _ref;
			},
			required: this.state.required,
			value: this.state.inputValue
		});

		if (this.props.inputRenderer) {
			return this.props.inputRenderer(inputProps);
		}

		if (this.props.disabled || !this.props.searchable) {
			var _props$inputProps = this.props.inputProps;
			var inputClassName = _props$inputProps.inputClassName;

			var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

			var _ariaOwns = (0, _classnames2['default'])(_defineProperty({}, this._instancePrefix + '-list', isOpen));

			return _react2['default'].createElement('div', _extends({}, divProps, {
				role: 'combobox',
				'aria-expanded': isOpen,
				'aria-owns': _ariaOwns,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				className: className,
				tabIndex: this.props.tabIndex || 0,
				onBlur: this.handleInputBlur,
				onFocus: this.handleInputFocus,
				ref: function (ref) {
					return _this5.input = ref;
				},
				'aria-readonly': '' + !!this.props.disabled,
				style: { border: 0, width: 1, display: 'inline-block' } }));
		}

		if (this.props.autosize) {
			return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
		}
		return _react2['default'].createElement(
			'div',
			{ className: className },
			_react2['default'].createElement('input', inputProps)
		);
	},

	renderClear: function renderClear() {

		if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
		var clear = this.props.clearRenderer();

		return _react2['default'].createElement(
			'span',
			{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				onMouseDown: this.clearValue,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEndClearValue
			},
			clear
		);
	},

	renderArrow: function renderArrow() {
		var onMouseDown = this.handleMouseDownOnArrow;
		var isOpen = this.state.isOpen;
		var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

		return _react2['default'].createElement(
			'span',
			{
				className: 'Select-arrow-zone',
				onMouseDown: onMouseDown
			},
			arrow
		);
	},

	filterOptions: function filterOptions(excludeOptions) {
		var filterValue = this.state.inputValue;
		var options = this.props.options || [];
		if (this.props.filterOptions) {
			// Maintain backwards compatibility with boolean attribute
			var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];

			return filterOptions(options, filterValue, excludeOptions, {
				filterOption: this.props.filterOption,
				ignoreAccents: this.props.ignoreAccents,
				ignoreCase: this.props.ignoreCase,
				labelKey: this.props.labelKey,
				matchPos: this.props.matchPos,
				matchProp: this.props.matchProp,
				valueKey: this.props.valueKey
			});
		} else {
			return options;
		}
	},

	onOptionRef: function onOptionRef(ref, isFocused) {
		if (isFocused) {
			this.focused = ref;
		}
	},

	renderMenu: function renderMenu(options, valueArray, focusedOption) {
		if (options && options.length) {
			return this.props.menuRenderer({
				focusedOption: focusedOption,
				focusOption: this.focusOption,
				instancePrefix: this._instancePrefix,
				labelKey: this.props.labelKey,
				onFocus: this.focusOption,
				onSelect: this.selectValue,
				optionClassName: this.props.optionClassName,
				optionComponent: this.props.optionComponent,
				optionRenderer: this.props.optionRenderer || this.getOptionLabel,
				options: options,
				selectValue: this.selectValue,
				valueArray: valueArray,
				valueKey: this.props.valueKey,
				onOptionRef: this.onOptionRef
			});
		} else if (this.props.noResultsText) {
			return _react2['default'].createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.noResultsText
			);
		} else {
			return null;
		}
	},

	renderHiddenField: function renderHiddenField(valueArray) {
		var _this6 = this;

		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this6.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2['default'].createElement('input', {
				type: 'hidden',
				ref: function (ref) {
					return _this6.value = ref;
				},
				name: this.props.name,
				value: value,
				disabled: this.props.disabled });
		}
		return valueArray.map(function (item, index) {
			return _react2['default'].createElement('input', { key: 'hidden.' + index,
				type: 'hidden',
				ref: 'value' + index,
				name: _this6.props.name,
				value: stringifyValue(item[_this6.props.valueKey]),
				disabled: _this6.props.disabled });
		});
	},

	getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return null;

		var valueKey = this.props.valueKey;
		var focusedOption = this.state.focusedOption || selectedOption;
		if (focusedOption && !focusedOption.disabled) {
			var focusedOptionIndex = -1;
			options.some(function (option, index) {
				var isOptionEqual = option[valueKey] === focusedOption[valueKey];
				if (isOptionEqual) {
					focusedOptionIndex = index;
				}
				return isOptionEqual;
			});
			if (focusedOptionIndex !== -1) {
				return focusedOptionIndex;
			}
		}

		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return i;
		}
		return null;
	},

	renderOuter: function renderOuter(options, valueArray, focusedOption) {
		var _this7 = this;

		var menu = this.renderMenu(options, valueArray, focusedOption);
		if (!menu) {
			return null;
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this7.menuContainer = ref;
				}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menu = ref;
					}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
					style: this.props.menuStyle,
					onScroll: this.handleMenuScroll,
					onMouseDown: this.handleMouseDownOnMenu },
				menu
			)
		);
	},

	render: function render() {
		var _this8 = this;

		var valueArray = this.getValueArray(this.props.value);
		var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
		var isOpen = this.state.isOpen;
		if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
		var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

		var focusedOption = null;
		if (focusedOptionIndex !== null) {
			focusedOption = this._focusedOption = options[focusedOptionIndex];
		} else {
			focusedOption = this._focusedOption = null;
		}
		var className = (0, _classnames2['default'])('Select', this.props.className, {
			'Select--multi': this.props.multi,
			'Select--single': !this.props.multi,
			'is-clearable': this.props.clearable,
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'is-searchable': this.props.searchable,
			'has-value': valueArray.length
		});

		var removeMessage = null;
		if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
			removeMessage = _react2['default'].createElement(
				'span',
				{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
				this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
			);
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this8.wrapper = ref;
				},
				className: className,
				style: this.props.wrapperStyle },
			this.renderHiddenField(valueArray),
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.control = ref;
					},
					className: 'Select-control',
					style: this.props.style,
					onKeyDown: this.handleKeyDown,
					onMouseDown: this.handleMouseDown,
					onTouchEnd: this.handleTouchEnd,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				},
				_react2['default'].createElement(
					'span',
					{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray, focusedOptionIndex)
				),
				removeMessage,
				this.renderLoading(),
				this.renderClear(),
				this.renderArrow()
			),
			isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
		);
	}

});

exports['default'] = Select;
module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeCancelable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thirdPillarMainTopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return thirdPillarTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return countryFacilitationTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sevenPillarsMainTopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sevenPillarsTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return allTFAArticles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return continentsColors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var makeCancelable = function makeCancelable(promise) {
  var hasCanceled_ = false;

  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
    }, function (error) {
      return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
    });
  });

  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};

var thirdPillarMainTopic = 'ETIB03';

var thirdPillarTopics = ['CUSTSERVIND', 'CLEAREFF', 'TABTIMEIMPDOC', 'TABTIMEIMPBORD', 'IMPTIMECOMPLIANCEIDX', 'TABCOSTIMPDOC', 'TABCOSTIMPBORD', 'IMPCOSTCOMPLIANCEIDX', 'TABTIMEEXPDOC', 'TABTIMEEXPBORD', 'EXPTIMECOMPLIANCEIDX', 'TABCOSTEXPDOC', 'TABCOSTEXPBORD', 'EXPCOSTCOMPLIANCEIDX', 'EOSQ147', 'EOSQ395', 'CUSTTRANSPIND'];

var countryFacilitationTopics = ['inf_availability', 'inv_community', 'adv_rulings', 'appeal_proc', 'fees_charges', 'form_docs', 'form_auto', 'form_proc', 'int_cooperation', 'ext_cooperation', 'gov_impartiality'];

var sevenPillarsMainTopic = 'ETI';
var sevenPillarsTopics = ['ETIA01', 'ETIA02', 'ETIB03', 'ETIC04', 'ETIC05', 'ETIC06', 'ETID07'];

var allTFAArticles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["range"])(1, 13).map(function (i) {
  return i.toString();
});

var continentsColors = {
  'EU': '#F9B233',
  'AS': '#C629CE',
  'AF': '#95C11F',
  'NA': '#1DE5EF',
  'SA': '#3990C4',
  'OC': '#EEDF24'

};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(141);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// https://d3js.org Version 4.9.1. Copyright 2017 Mike Bostock.
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
}(this, (function (exports) { 'use strict';

var version = "4.9.1";

var ascending = function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
};

var bisector = function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
};

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;

var pairs = function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
};

function pair(a, b) {
  return [a, b];
}

var cross = function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = pair;

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
};

var descending = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var number = function(x) {
  return x === null ? NaN : +x;
};

var variance = function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
};

var deviation = function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
};

var extent = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
};

var array = Array.prototype;

var slice = array.slice;
var map = array.map;

var constant = function(x) {
  return function() {
    return x;
  };
};

var identity = function(x) {
  return x;
};

var sequence = function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
};

var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);

var ticks = function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
};

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

var sturges = function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
};

var histogram = function() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = sequence(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisectRight(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
};

var threshold = function(values, p, valueof) {
  if (valueof == null) valueof = number;
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
};

var freedmanDiaconis = function(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
};

var scott = function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
};

var max = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
};

var mean = function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
};

var median = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return threshold(numbers.sort(ascending), 0.5);
};

var merge = function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
};

var min = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
};

var permute = function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
};

var scan = function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = ascending;

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
};

var shuffle = function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
};

var sum = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
};

var transpose = function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
};

function length(d) {
  return d.length;
}

var zip = function() {
  return transpose(arguments);
};

var slice$1 = Array.prototype.slice;

var identity$1 = function(x) {
  return x;
};

var top = 1;
var right = 2;
var bottom = 3;
var left = 4;
var epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$1) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = range[0] + 0.5,
        range1 = range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : identity$1)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice$1.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}

var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

var namespace = function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
};

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

var creator = function(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
};

var nextId = 0;

function local$1() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local$1.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};

var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

var matcher$1 = matcher;

var filterEvents = {};

exports.event = null;

if (typeof document !== "undefined") {
  var element$1 = document.documentElement;
  if (!("onmouseenter" in element$1)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = exports.event; // Events can be reentrant (e.g., focus).
    exports.event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      exports.event = event0;
    }
  };
}

function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

var selection_on = function(typename, value, capture) {
  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
};

function customEvent(event1, listener, that, args) {
  var event0 = exports.event;
  event1.sourceEvent = exports.event;
  exports.event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    exports.event = event0;
  }
}

var sourceEvent = function() {
  var current = exports.event, source;
  while (source = current.sourceEvent) current = source;
  return current;
};

var point = function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
};

var mouse = function(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
};

function none() {}

var selector = function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
};

var selection_select = function(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

function empty$1() {
  return [];
}

var selectorAll = function(selector) {
  return selector == null ? empty$1 : function() {
    return this.querySelectorAll(selector);
  };
};

var selection_selectAll = function(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
};

var selection_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

var sparse = function(update) {
  return new Array(update.length);
};

var selection_enter = function() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
};

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

var constant$1 = function(x) {
  return function() {
    return x;
  };
};

var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

var selection_data = function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$1(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
};

var selection_exit = function() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
};

var selection_merge = function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
};

var selection_order = function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
};

var selection_sort = function(compare) {
  if (!compare) compare = ascending$1;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
};

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

var selection_call = function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
};

var selection_nodes = function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
};

var selection_node = function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
};

var selection_size = function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
};

var selection_empty = function() {
  return !this.node();
};

var selection_each = function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
};

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

var selection_attr = function(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
};

var defaultView = function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
};

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

var selection_style = function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
};

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

var selection_property = function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
};

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

var selection_classed = function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
};

function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

var selection_text = function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
};

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

var selection_html = function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
};

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

var selection_raise = function() {
  return this.each(raise);
};

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

var selection_lower = function() {
  return this.each(lower);
};

var selection_append = function(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
};

function constantNull() {
  return null;
}

var selection_insert = function(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
};

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

var selection_remove = function() {
  return this.each(remove);
};

var selection_datum = function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
};

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

var selection_dispatch = function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
};

var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

var select = function(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
};

var selectAll = function(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
};

var touch = function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return point(node, touch);
    }
  }

  return null;
};

var touches = function(node, touches) {
  if (touches == null) touches = sourceEvent().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = point(node, touches[i]);
  }

  return points;
};

function nopropagation() {
  exports.event.stopImmediatePropagation();
}

var noevent = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var dragDisable = function(view) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", noevent, true);
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", noevent, true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
};

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection$$1.on("click.drag", noevent, true);
    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}

var constant$2 = function(x) {
  return function() {
    return x;
  };
};

function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$1() {
  return !exports.event.button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
}

var drag = function() {
  var filter = defaultFilter$1,
      container = defaultContainer,
      subject = defaultSubject,
      gestures = {},
      listeners = dispatch("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection$$1) {
    selection$$1
        .on("mousedown.drag", mousedowned)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
    if (!gesture) return;
    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(exports.event.view);
    nopropagation();
    mousemoving = false;
    mousedownx = exports.event.clientX;
    mousedowny = exports.event.clientY;
    gesture("start");
  }

  function mousemoved() {
    noevent();
    if (!mousemoving) {
      var dx = exports.event.clientX - mousedownx, dy = exports.event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(exports.event.view, mousemoving);
    noevent();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches$$1 = exports.event.changedTouches,
        c = container.apply(this, arguments),
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
        nopropagation();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        noevent();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        nopropagation();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$2(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant$2(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$2(_), drag) : subject;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
};

var define = function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
};

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*";
var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
var reHex3 = /^#([0-9a-f]{3})$/;
var reHex6 = /^#([0-9a-f]{6})$/;
var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

var Kn = 18;
var Xn = 0.950470;
var Yn = 1;
var Zn = 1.088830;
var t0 = 4 / 29;
var t1 = 6 / 29;
var t2 = 3 * t1 * t1;
var t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * deg2rad;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Rgb(
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));

var A = -0.14861;
var B = +1.78277;
var C = -0.29227;
var D = -0.90649;
var E = +1.97294;
var ED = E * D;
var EB = E * B;
var BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

var basis$1 = function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var basisClosed = function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var constant$3 = function(x) {
  return function() {
    return x;
  };
};

function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$3(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : constant$3(isNaN(a) ? b : a);
}

var interpolateRgb = ((function rgbGamma(y) {
  var color$$1 = gamma(y);

  function rgb$$1(start, end) {
    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
        g = color$$1(start.g, end.g),
        b = color$$1(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$$1.gamma = rgbGamma;

  return rgb$$1;
}))(1);

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color$$1;
    for (i = 0; i < n; ++i) {
      color$$1 = rgb(colors[i]);
      r[i] = color$$1.r || 0;
      g[i] = color$$1.g || 0;
      b[i] = color$$1.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color$$1.opacity = 1;
    return function(t) {
      color$$1.r = r(t);
      color$$1.g = g(t);
      color$$1.b = b(t);
      return color$$1 + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);
var rgbBasisClosed = rgbSpline(basisClosed);

var array$1 = function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
};

var date = function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
};

var reinterpolate = function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
};

var object = function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
};

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
var reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

var interpolateString = function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: reinterpolate(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
};

var interpolateValue = function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$3(b)
      : (t === "number" ? reinterpolate
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date
      : Array.isArray(b) ? array$1
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : reinterpolate)(a, b);
};

var interpolateRound = function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
};

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

var decompose = function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
};

var cssNode;
var cssRoot;
var cssView;
var svgNode;

function parseCss(value) {
  if (value === "none") return identity$2;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var rho = Math.SQRT2;
var rho2 = 2;
var rho4 = 4;
var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
var interpolateZoom = function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    };
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    };
  }

  i.duration = S * 1000;

  return i;
};

function hsl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hsl$2 = hsl$1(hue);
var hslLong = hsl$1(nogamma);

function lab$1(start, end) {
  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
      a = nogamma(start.a, end.a),
      b = nogamma(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

function hcl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
        c = nogamma(start.c, end.c),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hcl$2 = hcl$1(hue);
var hclLong = hcl$1(nogamma);

function cubehelix$1(hue$$1) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix$$1(start, end) {
      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix$$1.gamma = cubehelixGamma;

    return cubehelix$$1;
  })(1);
}

var cubehelix$2 = cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);

var quantize = function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
};

var frame = 0;
var timeout = 0;
var interval = 0;
var pokeDelay = 1000;
var taskHead;
var taskTail;
var clockLast = 0;
var clockNow = 0;
var clockSkew = 0;
var clock = typeof performance === "object" && performance.now ? performance : Date;
var setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, delay);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clockNow, interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

var timeout$1 = function(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
};

var interval$1 = function(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
};

var emptyOn = dispatch("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

var schedule = function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
};

function init(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
  return schedule;
}

function set$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
  return schedule;
}

function get$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout$1(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout$1(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

var interrupt = function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
};

var selection_interrupt = function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
};

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

var transition_tween = function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get$1(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
};

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set$1(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get$1(node, id).value[name];
  };
}

var interpolate$$1 = function(a, b) {
  var c;
  return (typeof b === "number" ? reinterpolate
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
};

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrConstantNS$1(fullname, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrFunction$1(name, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS$1(fullname, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

var transition_attr = function(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$$1;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value + ""));
};

function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

var transition_attrTween = function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
};

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

var transition_delay = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get$1(this.node(), id).delay;
};

function durationFunction(id, value) {
  return function() {
    set$1(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set$1(this, id).duration = value;
  };
}

var transition_duration = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get$1(this.node(), id).duration;
};

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set$1(this, id).ease = value;
  };
}

var transition_ease = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get$1(this.node(), id).ease;
};

var transition_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
};

var transition_merge = function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
};

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set$1;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

var transition_on = function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get$1(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
};

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

var transition_remove = function() {
  return this.on("end.remove", removeFunction(this._id));
};

var transition_select = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
};

var transition_selectAll = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
};

var Selection$1 = selection.prototype.constructor;

var transition_selection = function() {
  return new Selection$1(this._groups, this._parents);
};

function styleRemove$1(name, interpolate$$2) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, interpolate$$2, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value1);
  };
}

function styleFunction$1(name, interpolate$$2, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value10 = value1);
  };
}

var transition_style = function(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$$1;
  return value == null ? this
          .styleTween(name, styleRemove$1(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
          : styleConstant$1(name, i, value + ""), priority);
};

function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

var transition_styleTween = function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
};

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

var transition_text = function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction$1(tweenValue(this, "text", value))
      : textConstant$1(value == null ? "" : value + ""));
};

var transition_transition = function() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get$1(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
};

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return selection().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease
};

function linear$1(t) {
  return +t;
}

function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

var pi = Math.PI;
var halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}

function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

var b1 = 4 / 11;
var b2 = 6 / 11;
var b3 = 8 / 11;
var b4 = 3 / 4;
var b5 = 9 / 11;
var b6 = 10 / 11;
var b7 = 15 / 16;
var b8 = 21 / 22;
var b9 = 63 / 64;
var b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

var tau = 2 * Math.PI;
var amplitude = 1;
var period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

var selection_transition = function(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
};

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

var root$1 = [null];

var active = function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], root$1, name, +i);
      }
    }
  }

  return null;
};

var constant$4 = function(x) {
  return function() {
    return x;
  };
};

var BrushEvent = function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
};

function nopropagation$1() {
  exports.event.stopImmediatePropagation();
}

var noevent$1 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var MODE_DRAG = {name: "drag"};
var MODE_SPACE = {name: "space"};
var MODE_HANDLE = {name: "handle"};
var MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !exports.event.button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local$$1(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush$1(X);
}

function brushY() {
  return brush$1(Y);
}

var brush = function() {
  return brush$1(XY);
};

function brush$1(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = dispatch(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local$$1(this).extent;
          select(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection$$1) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(this, arguments) : selection$$1, state.extent),
                i = interpolateValue(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(that, args) : selection$$1, state.extent),
                emit = emitter(that, args).beforestart();

            interrupt(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = select(this),
        selection$$1 = local$$1(this).selection;

    if (selection$$1) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection$$1[0][0])
          .attr("y", selection$$1[0][1])
          .attr("width", selection$$1[1][0] - selection$$1[0][0])
          .attr("height", selection$$1[1][1] - selection$$1[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection$$1[1][0] - handleSize / 2 : selection$$1[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection$$1[1][1] - handleSize / 2 : selection$$1[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection$$1[1][0] - selection$$1[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection$$1[1][1] - selection$$1[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$1(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = exports.event.target.__data__.type,
        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local$$1(that),
        extent = state.extent,
        selection$$1 = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && exports.event.shiftKey,
        lockX,
        lockY,
        point0 = mouse(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection$$1 = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection$$1[0][0];
      n0 = selection$$1[0][1];
      e0 = selection$$1[1][0];
      s0 = selection$$1[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = select(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (exports.event.touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = select(exports.event.view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      dragDisable(exports.event.view);
    }

    nopropagation$1();
    interrupt(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = mouse(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      noevent$1();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection$$1 = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection$$1[0][0], e1 = selection$$1[1][0];
      if (lockY) n1 = selection$$1[0][1], s1 = selection$$1[1][1];

      if (selection$$1[0][0] !== w1
          || selection$$1[0][1] !== n1
          || selection$$1[1][0] !== e1
          || selection$$1[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      nopropagation$1();
      if (exports.event.touches) {
        if (exports.event.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        yesdrag(exports.event.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection$$1 = state.selection; // May be set by brush.move (on start)!
      if (empty(selection$$1)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }

    function keyupped() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (exports.event.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$4([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$4(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

var cos = Math.cos;
var sin = Math.sin;
var pi$1 = Math.PI;
var halfPi$1 = pi$1 / 2;
var tau$1 = pi$1 * 2;
var max$1 = Math.max;

function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

var chord = function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = sequence(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(sequence(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = max$1(0, tau$1 - padAngle * n) / k;
    dx = k ? padAngle : tau$1 / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
};

var slice$2 = Array.prototype.slice;

var constant$5 = function(x) {
  return function() {
    return x;
  };
};

var pi$2 = Math.PI;
var tau$2 = 2 * pi$2;
var epsilon$1 = 1e-6;
var tauEpsilon = tau$2 - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$2 + tau$2;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$2)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

var ribbon = function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = slice$2.call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - halfPi$1,
        sa1 = endAngle.apply(this, argv) - halfPi$1,
        sx0 = sr * cos(sa0),
        sy0 = sr * sin(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - halfPi$1,
        ta1 = endAngle.apply(this, argv) - halfPi$1;

    if (!context) context = buffer = path();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$5(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
};

var prefix = "$";

function Map() {}

Map.prototype = map$1.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map$1(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

var nest = function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) return rollup != null
        ? rollup(array) : (sortValues != null
        ? array.sort(sortValues)
        : array);

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = map$1(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
};

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return map$1();
}

function setMap(map, key, value) {
  map.set(key, value);
}

function Set() {}

var proto = map$1.prototype;

Set.prototype = set$2.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set$2(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

var keys = function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
};

var values = function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
};

var entries = function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
};

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

var dsv = function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      delimiterCode = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns;
    return rows;
  }

  function parseRows(text, f) {
    var EOL = {}, // sentinel value for end-of-line
        EOF = {}, // sentinel value for end-of-file
        rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // the current line number
        t, // the current token
        eol; // is the current token followed by EOL?

    function token() {
      if (I >= N) return EOF; // special case: end of file
      if (eol) return eol = false, EOL; // special case: end of line

      // special case: quotes
      var j = I, c;
      if (text.charCodeAt(j) === 34) {
        var i = j;
        while (i++ < N) {
          if (text.charCodeAt(i) === 34) {
            if (text.charCodeAt(i + 1) !== 34) break;
            ++i;
          }
        }
        I = i + 2;
        c = text.charCodeAt(i + 1);
        if (c === 13) {
          eol = true;
          if (text.charCodeAt(i + 2) === 10) ++I;
        } else if (c === 10) {
          eol = true;
        }
        return text.slice(j + 1, i).replace(/""/g, "\"");
      }

      // common case: find next delimiter or newline
      while (I < N) {
        var k = 1;
        c = text.charCodeAt(I++);
        if (c === 10) eol = true; // \n
        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
        else if (c !== delimiterCode) continue;
        return text.slice(j, I - k);
      }

      // special case: last token before EOF
      return text.slice(j);
    }

    while ((t = token()) !== EOF) {
      var a = [];
      while (t !== EOL && t !== EOF) {
        a.push(t);
        t = token();
      }
      if (f && (a = f(a, n++)) == null) continue;
      rows.push(a);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
};

var csv = dsv(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;

var tsv = dsv("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;

var center$1 = function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
};

var constant$6 = function(x) {
  return function() {
    return x;
  };
};

var jiggle = function() {
  return (Math.random() - 0.5) * 1e-6;
};

var tree_add = function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
};

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

var tree_cover = function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
};

var tree_data = function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
};

var tree_extent = function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
};

var Quad = function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
};

var tree_find = function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new Quad(node[3], xm, ym, x2, y2),
        new Quad(node[2], x1, ym, xm, y2),
        new Quad(node[1], xm, y1, x2, ym),
        new Quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
};

var tree_remove = function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
};

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

var tree_root = function() {
  return this._root;
};

var tree_size = function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
};

var tree_visit = function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
    }
  }
  return this;
};

var tree_visitAfter = function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
};

function defaultX(d) {
  return d[0];
}

var tree_x = function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
};

function defaultY(d) {
  return d[1];
}

var tree_y = function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
};

function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;

function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

var collide = function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = constant$6(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(), l += x * x;
            if (y === 0) y = jiggle(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : radius;
  };

  return force;
};

function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

var link = function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = constant$6(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle();
        y = target.y + target.vy - source.y - source.vy || jiggle();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = map$1(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$6(+_), initializeDistance(), force) : distance;
  };

  return force;
};

function x$1(d) {
  return d.x;
}

function y$1(d) {
  return d.y;
}

var initialRadius = 10;
var initialAngle = Math.PI * (3 - Math.sqrt(5));

var simulation = function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = map$1(),
      stepper = timer(step),
      event = dispatch("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
};

var manyBody = function() {
  var nodes,
      node,
      alpha,
      strength = constant$6(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, x$1, y$1).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, x$$1, y$$1, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x$$1 = y$$1 = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = q.value)) {
          strength += c, x$$1 += c * q.x, y$$1 += c * q.y;
        }
      }
      quad.x = x$$1 / strength;
      quad.y = y$$1 / strength;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x$$1 = quad.x - node.x,
        y$$1 = quad.y - node.y,
        w = x2 - x1,
        l = x$$1 * x$$1 + y$$1 * y$$1;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
        if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x$$1 * quad.value * alpha / l;
        node.vy += y$$1 * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
      if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x$$1 * w;
      node.vy += y$$1 * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
};

var x$2 = function(x) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = constant$6(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : x;
  };

  return force;
};

var y$2 = function(y) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = constant$6(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : y;
  };

  return force;
};

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
var formatDecimal = function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
};

var exponent$1 = function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
};

var formatGroup = function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
};

var formatNumerals = function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
};

var formatDefault = function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
};

var prefixExponent;

var formatPrefixAuto = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
};

var formatRounded = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
};

var formatTypes = {
  "": formatDefault,
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!formatTypes[type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};

var identity$3 = function(x) {
  return x;
};

var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];

var formatLocale = function(locale) {
  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$3,
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
};

var locale$1;



defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale$1 = formatLocale(definition);
  exports.format = locale$1.format;
  exports.formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

var precisionFixed = function(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
};

var precisionPrefix = function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
};

var precisionRound = function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
};

// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

var adder = function() {
  return new Adder;
};

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add$1(temp, y, this.t);
    add$1(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add$1(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}

var epsilon$2 = 1e-6;
var epsilon2$1 = 1e-12;
var pi$3 = Math.PI;
var halfPi$2 = pi$3 / 2;
var quarterPi = pi$3 / 4;
var tau$3 = pi$3 * 2;

var degrees$1 = 180 / pi$3;
var radians = pi$3 / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos$1 = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;

var log = Math.log;
var pow = Math.pow;
var sin$1 = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi$3 : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi$2 : x < -1 ? -halfPi$2 : Math.asin(x);
}

function haversin(x) {
  return (x = sin$1(x / 2)) * x;
}

function noop$1() {}

function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

var geoStream = function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
};

var areaRingSum = adder();

var areaSum = adder();
var lambda00;
var phi00;
var lambda0;
var cosPhi0;
var sinPhi0;

var areaStream = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? tau$3 + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$1;
  },
  sphere: function() {
    areaSum.add(tau$3);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
}

function areaPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = cos$1(phi),
      sinPhi = sin$1(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
      v = k * sdLambda * sin$1(adLambda);
  areaRingSum.add(atan2(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

var area = function(object) {
  areaSum.reset();
  geoStream(object, areaStream);
  return areaSum * 2;
};

function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

var lambda0$1;
var phi0;
var lambda1;
var phi1;
var lambda2;
var lambda00$1;
var phi00$1;
var p0;
var deltaSum = adder();
var ranges;
var range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    areaStream.polygonStart();
  },
  polygonEnd: function() {
    areaStream.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon$2) phi1 = 90;
    else if (deltaSum < -epsilon$2) phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2,
        sign$$1 = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * degrees$1 * sign$$1,
        phii,
        antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = inflection[1] * degrees$1;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = -inflection[1] * degrees$1;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda < lambda0$1) lambda0$1 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi;
  }
  areaStream.point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  areaStream.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream.lineEnd();
  if (abs(deltaSum) > epsilon$2) lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

var bounds = function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0$1 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0$1, phi0], [lambda1, phi1]];
};

var W0;
var W1;
var X0;
var Y0;
var Z0;
var X1;
var Y1;
var Z1;
var X2;
var Y2;
var Z2;
var lambda00$2;
var phi00$2;
var x0;
var y0;
var z0; // previous point

var centroidStream = {
  sphere: noop$1,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00$2, phi00$2);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00$2 = lambda, phi00$2 = phi;
  lambda *= radians, phi *= radians;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = sqrt(cx * cx + cy * cy + cz * cz),
      w = asin(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

var centroid = function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  geoStream(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < epsilon2$1) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < epsilon$2) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < epsilon2$1) return [NaN, NaN];
  }

  return [atan2(y, x) * degrees$1, asin(z / sqrt(m)) * degrees$1];
};

var constant$7 = function(x) {
  return function() {
    return x;
  };
};

var compose = function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
};

function rotationIdentity(lambda, phi) {
  return [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau$3) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos$1(deltaPhi),
      sinDeltaPhi = sin$1(deltaPhi),
      cosDeltaGamma = cos$1(deltaGamma),
      sinDeltaGamma = sin$1(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      asin(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      asin(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

var rotation = function(rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  };

  return forward;
};

// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos$1(radius),
      sinRadius = sin$1(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau$3;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$3;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau$3 - epsilon$2) % tau$3;
}

var circle = function() {
  var center = constant$7([0, 0]),
      radius = constant$7(90),
      precision = constant$7(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= degrees$1, x[1] *= degrees$1;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * radians,
        p = precision.apply(this, arguments) * radians;
    ring = [];
    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : constant$7([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$7(+_), circle) : precision;
  };

  return circle;
};

var clipBuffer = function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$1,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
};

var clipLine = function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
};

var pointEqual = function(a, b) {
  return abs(a[0] - b[0]) < epsilon$2 && abs(a[1] - b[1]) < epsilon$2;
};

function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (pointEqual(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link$1(subject);
  link$1(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
};

function link$1(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

var clipMax = 1e9;
var clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return abs(p[0] - x0) < epsilon$2 ? direction > 0 ? 0 : 3
        : abs(p[0] - x1) < epsilon$2 ? direction > 0 ? 2 : 1
        : abs(p[1] - y0) < epsilon$2 ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = clipBuffer(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = merge(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

var extent$1 = function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
};

var sum$1 = adder();

var polygonContains = function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [sin$1(lambda), -cos$1(lambda), 0],
      angle = 0,
      winding = 0;

  sum$1.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + quarterPi,
        sinPhi0 = sin$1(phi0),
        cosPhi0 = cos$1(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + quarterPi,
          sinPhi1 = sin$1(phi1),
          cosPhi1 = cos$1(phi1),
          delta = lambda1 - lambda0,
          sign$$1 = delta >= 0 ? 1 : -1,
          absDelta = sign$$1 * delta,
          antimeridian = absDelta > pi$3,
          k = sinPhi0 * sinPhi1;

      sum$1.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
      angle += antimeridian ? delta + sign$$1 * tau$3 : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -epsilon$2 || angle < epsilon$2 && sum$1 < -epsilon$2) ^ (winding & 1);
};

var lengthSum = adder();
var lambda0$2;
var sinPhi0$1;
var cosPhi0$1;

var lengthStream = {
  sphere: noop$1,
  point: noop$1,
  lineStart: lengthLineStart,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop$1;
}

function lengthPointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin$1(phi),
      cosPhi = cos$1(phi),
      delta = abs(lambda - lambda0$2),
      cosDelta = cos$1(delta),
      sinDelta = sin$1(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x * x + y * y), z));
  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
}

var length$1 = function(object) {
  lengthSum.reset();
  geoStream(object, lengthStream);
  return +lengthSum;
};

var coordinates = [null, null];
var object$1 = {type: "LineString", coordinates: coordinates};

var distance = function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length$1(object$1);
};

var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = distance(coordinates[0], coordinates[1]),
      ao = distance(coordinates[0], point),
      ob = distance(point, coordinates[1]);
  return ao + ob <= ab + epsilon$2;
}

function containsPolygon(coordinates, point) {
  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * radians, point[1] * radians];
}

var contains = function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
};

function graticuleX(y0, y1, dy) {
  var y = sequence(y0, y1 - epsilon$2, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = sequence(x0, x1 - epsilon$2, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return sequence(ceil(X0 / DX) * DX, X1, DX).map(X)
        .concat(sequence(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(sequence(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$2; }).map(x))
        .concat(sequence(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$2; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]])
      .extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
}

function graticule10() {
  return graticule()();
}

var interpolate$1 = function(a, b) {
  var x0 = a[0] * radians,
      y0 = a[1] * radians,
      x1 = b[0] * radians,
      y1 = b[1] * radians,
      cy0 = cos$1(y0),
      sy0 = sin$1(y0),
      cy1 = cos$1(y1),
      sy1 = sin$1(y1),
      kx0 = cy0 * cos$1(x0),
      ky0 = cy0 * sin$1(x0),
      kx1 = cy1 * cos$1(x1),
      ky1 = cy1 * sin$1(x1),
      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
      k = sin$1(d);

  var interpolate = d ? function(t) {
    var B = sin$1(t *= d) / k,
        A = sin$1(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      atan2(y, x) * degrees$1,
      atan2(z, sqrt(x * x + y * y)) * degrees$1
    ];
  } : function() {
    return [x0 * degrees$1, y0 * degrees$1];
  };

  interpolate.distance = d;

  return interpolate;
};

var identity$4 = function(x) {
  return x;
};

var areaSum$1 = adder();
var areaRingSum$1 = adder();
var x00;
var y00;
var x0$1;
var y0$1;

var areaStream$1 = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$1;
    areaSum$1.add(abs(areaRingSum$1));
    areaRingSum$1.reset();
  },
  result: function() {
    var area = areaSum$1 / 2;
    areaSum$1.reset();
    return area;
  }
};

function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}

function areaPointFirst$1(x, y) {
  areaStream$1.point = areaPoint$1;
  x00 = x0$1 = x, y00 = y0$1 = y;
}

function areaPoint$1(x, y) {
  areaRingSum$1.add(y0$1 * x - x0$1 * y);
  x0$1 = x, y0$1 = y;
}

function areaRingEnd$1() {
  areaPoint$1(x00, y00);
}

var x0$2 = Infinity;
var y0$2 = x0$2;
var x1 = -x0$2;
var y1 = x1;

var boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1,
  result: function() {
    var bounds = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds;
  }
};

function boundsPoint$1(x, y) {
  if (x < x0$2) x0$2 = x;
  if (x > x1) x1 = x;
  if (y < y0$2) y0$2 = y;
  if (y > y1) y1 = y;
}

// TODO Enforce positive area for exterior, negative area for interior?

var X0$1 = 0;
var Y0$1 = 0;
var Z0$1 = 0;
var X1$1 = 0;
var Y1$1 = 0;
var Z1$1 = 0;
var X2$1 = 0;
var Y2$1 = 0;
var Z2$1 = 0;
var x00$1;
var y00$1;
var x0$3;
var y0$3;

var centroidStream$1 = {
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.point = centroidPoint$1;
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  },
  result: function() {
    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
        : [NaN, NaN];
    X0$1 = Y0$1 = Z0$1 =
    X1$1 = Y1$1 = Z1$1 =
    X2$1 = Y2$1 = Z2$1 = 0;
    return centroid;
  }
};

function centroidPoint$1(x, y) {
  X0$1 += x;
  Y0$1 += y;
  ++Z0$1;
}

function centroidLineStart$1() {
  centroidStream$1.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream$1.point = centroidPointLine;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}

function centroidRingStart$1() {
  centroidStream$1.point = centroidPointFirstRing;
}

function centroidRingEnd$1() {
  centroidPointRing(x00$1, y00$1);
}

function centroidPointFirstRing(x, y) {
  centroidStream$1.point = centroidPointRing;
  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0$3,
      dy = y - y0$3,
      z = sqrt(dx * dx + dy * dy);

  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;

  z = y0$3 * x - x0$3 * y;
  X2$1 += z * (x0$3 + x);
  Y2$1 += z * (y0$3 + y);
  Z2$1 += z * 3;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau$3);
        break;
      }
    }
  },
  result: noop$1
};

var lengthSum$1 = adder();
var lengthRing;
var x00$2;
var y00$2;
var x0$4;
var y0$4;

var lengthStream$1 = {
  point: noop$1,
  lineStart: function() {
    lengthStream$1.point = lengthPointFirst$1;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint$1(x00$2, y00$2);
    lengthStream$1.point = noop$1;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum$1;
    lengthSum$1.reset();
    return length;
  }
};

function lengthPointFirst$1(x, y) {
  lengthStream$1.point = lengthPoint$1;
  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
}

function lengthPoint$1(x, y) {
  x0$4 -= x, y0$4 -= y;
  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
  x0$4 = x, y0$4 = y;
}

function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle$1(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle$1(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle$1(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

var index$1 = function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    geoStream(object, projectionStream(areaStream$1));
    return areaStream$1.result();
  };

  path.measure = function(object) {
    geoStream(object, projectionStream(lengthStream$1));
    return lengthStream$1.result();
  };

  path.bounds = function(object) {
    geoStream(object, projectionStream(boundsStream$1));
    return boundsStream$1.result();
  };

  path.centroid = function(object) {
    geoStream(object, projectionStream(centroidStream$1));
    return centroidStream$1.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$4) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
};

var clip = function(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = clipBuffer(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
};

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi$2 - epsilon$2 : halfPi$2 - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - halfPi$2 - epsilon$2 : halfPi$2 - b[1]);
}

var clipAntimeridian = clip(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi$3, -halfPi$2]
);

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi$3 : -pi$3,
          delta = abs(lambda1 - lambda0);
      if (abs(delta - pi$3) < epsilon$2) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$2 : -halfPi$2);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi$3) { // line crosses antimeridian
        if (abs(lambda0 - sign0) < epsilon$2) lambda0 -= sign0 * epsilon$2; // handle degeneracies
        if (abs(lambda1 - sign1) < epsilon$2) lambda1 -= sign1 * epsilon$2;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon$2
      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi$2;
    stream.point(-pi$3, phi);
    stream.point(0, phi);
    stream.point(pi$3, phi);
    stream.point(pi$3, 0);
    stream.point(pi$3, -phi);
    stream.point(0, -phi);
    stream.point(-pi$3, -phi);
    stream.point(-pi$3, 0);
    stream.point(-pi$3, phi);
  } else if (abs(from[0] - to[0]) > epsilon$2) {
    var lambda = from[0] < to[0] ? pi$3 : -pi$3;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

var clipCircle = function(radius, delta) {
  var cr = cos$1(radius),
      smallRadius = cr > 0,
      notHemisphere = abs(cr) > epsilon$2; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return cos$1(lambda) * cos$1(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? pi$3 : -pi$3), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
            point1[0] += epsilon$2;
            point1[1] += epsilon$2;
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = cartesian(a),
        pb = cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = cartesianCross(pa, pb),
        n2n2 = cartesianDot(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = cartesianCross(n1, n2),
        A = cartesianScale(n1, c1),
        B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = cartesianDot(A, u),
        uu = cartesianDot(u, u),
        t2 = w * w - uu * (cartesianDot(A, A) - 1);

    if (t2 < 0) return;

    var t = sqrt(t2),
        q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = spherical(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = abs(delta - pi$3) < epsilon$2,
        meridian = polar || delta < epsilon$2;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$2 ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > pi$3 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi$3 - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$3, radius - pi$3]);
};

var transform = function(methods) {
  return {
    stream: transformer(methods)
  };
};

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};

function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  geoStream(object, projection.stream(boundsStream$1));

  var b = boundsStream$1.result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

var maxDepth = 16;
var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)

var resample = function(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
};

function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample$1(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = sqrt(a * a + b * b + c * c),
          phi2 = asin(c /= m),
          lambda2 = abs(abs(c) - 1) < epsilon$2 || abs(lambda0 - lambda1) < epsilon$2 ? (lambda0 + lambda1) / 2 : atan2(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = clipAntimeridian, // clip angle
      x0 = null, y0, x1, y1, postclip = identity$4, // clip extent
      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * radians, point[1] * radians);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * degrees$1, point[1] * degrees$1];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return fitExtent(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return fitSize(projection, size, object);
  };

  function recenter() {
    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = pi$3 / 3,
      m = projectionMutator(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
  };

  return p;
}

function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos$1(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}

function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (abs(n) < epsilon$2) return cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;

  function project(x, y) {
    var r = sqrt(c - 2 * n * sin$1(y)) / n;
    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

var conicEqualArea = function() {
  return conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
};

var albers = function() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
};

// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
var albersUsa = function() {
  var cache,
      cacheStream,
      lower48 = albers(), lower48Point,
      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + epsilon$2, y + 0.120 * k + epsilon$2], [x - 0.214 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + epsilon$2, y + 0.166 * k + epsilon$2], [x - 0.115 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return fitExtent(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return fitSize(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
};

function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos$1(x),
        cy = cos$1(y),
        k = scale(cx * cy);
    return [
      k * cy * sin$1(x),
      k * sin$1(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = sqrt(x * x + y * y),
        c = angle(z),
        sc = sin$1(c),
        cc = cos$1(c);
    return [
      atan2(x * sc, z * cc),
      asin(z && y * sc / z)
    ];
  }
}

var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});

var azimuthalEqualArea = function() {
  return projection(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
};

var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin$1(c);
});

azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});

var azimuthalEquidistant = function() {
  return projection(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
};

function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi$2 + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi$2];
};

var mercator = function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / tau$3);
};

function mercatorProjection(project) {
  var m = projection(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = pi$3 * scale(),
        t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

function tany(y) {
  return tan((halfPi$2 + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : log(cy0 / cos$1(y1)) / log(tany(y1) / tany(y0)),
      f = cy0 * pow(tany(y0), n) / n;

  if (!n) return mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -halfPi$2 + epsilon$2) y = -halfPi$2 + epsilon$2; }
    else { if (y > halfPi$2 - epsilon$2) y = halfPi$2 - epsilon$2; }
    var r = f / pow(tany(y), n);
    return [r * sin$1(n * x), f - r * cos$1(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi$2];
  };

  return project;
}

var conicConformal = function() {
  return conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
};

function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

var equirectangular = function() {
  return projection(equirectangularRaw)
      .scale(152.63);
};

function conicEquidistantRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (abs(n) < epsilon$2) return equirectangularRaw;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin$1(nx), g - gy * cos$1(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
  };

  return project;
}

var conicEquidistant = function() {
  return conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
};

function gnomonicRaw(x, y) {
  var cy = cos$1(y), k = cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

gnomonicRaw.invert = azimuthalInvert(atan);

var gnomonic = function() {
  return projection(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
};

function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$4 : transformer({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

var identity$5 = function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity$4, // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = identity$4, // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return fitExtent(projection, extent, object);
    },
    fitSize: function(size, object) {
      return fitSize(projection, size, object);
    }
  };
};

function orthographicRaw(x, y) {
  return [cos$1(y) * sin$1(x), sin$1(y)];
}

orthographicRaw.invert = azimuthalInvert(asin);

var orthographic = function() {
  return projection(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + epsilon$2);
};

function stereographicRaw(x, y) {
  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});

var stereographic = function() {
  return projection(stereographicRaw)
      .scale(250)
      .clipAngle(142);
};

function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi$2 + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi$2];
};

var transverseMercator = function() {
  var m = mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
};

function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

var cluster = function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
};

function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

var node_count = function() {
  return this.eachAfter(count);
};

var node_each = function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
};

var node_eachBefore = function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
};

var node_eachAfter = function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
};

var node_sum = function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
};

var node_sort = function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
};

var node_path = function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
};

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

var node_ancestors = function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
};

var node_descendants = function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
};

var node_leaves = function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
};

var node_links = function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
};

function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy
};

function Node$2(value) {
  this._ = value;
  this.next = null;
}

var shuffle$1 = function(array) {
  var i,
      n = (array = array.slice()).length,
      head = null,
      node = head;

  while (n) {
    var next = new Node$2(array[n - 1]);
    if (node) node = node.next = next;
    else node = head = next;
    array[i] = array[--n];
  }

  return {
    head: head,
    tail: node
  };
};

var enclose = function(circles) {
  return encloseN(shuffle$1(circles), []);
};

function encloses(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r - b.r;
  return dr * dr + 1e-6 > dx * dx + dy * dy;
}

// Returns the smallest circle that contains circles L and intersects circles B.
function encloseN(L, B) {
  var circle,
      l0 = null,
      l1 = L.head,
      l2,
      p1;

  switch (B.length) {
    case 1: circle = enclose1(B[0]); break;
    case 2: circle = enclose2(B[0], B[1]); break;
    case 3: circle = enclose3(B[0], B[1], B[2]); break;
  }

  while (l1) {
    p1 = l1._, l2 = l1.next;
    if (!circle || !encloses(circle, p1)) {

      // Temporarily truncate L before l1.
      if (l0) L.tail = l0, l0.next = null;
      else L.head = L.tail = null;

      B.push(p1);
      circle = encloseN(L, B); // Note: reorders L!
      B.pop();

      // Move l1 to the front of L and reconnect the truncated list L.
      if (L.head) l1.next = L.head, L.head = l1;
      else l1.next = null, L.head = L.tail = l1;
      l0 = L.tail, l0.next = l2;

    } else {
      l0 = l1;
    }
    l1 = l2;
  }

  L.tail = l0;
  return circle;
}

function enclose1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function enclose2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function enclose3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = 2 * (x1 - x2),
      b2 = 2 * (y1 - y2),
      c2 = 2 * (r2 - r1),
      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
      a3 = 2 * (x1 - x3),
      b3 = 2 * (y1 - y3),
      c3 = 2 * (r3 - r1),
      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / ab - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / ab - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (xa * xb + ya * yb + r1),
      C = xa * xa + ya * ya - r1 * r1,
      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
  return {
    x: xa + xb * r + x1,
    y: ya + yb * r + y1,
    r: r
  };
}

function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function distance2(node, x, y) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab - x,
      dy = (a.y * b.r + b.y * a.r) / ab - y;
  return dx * dx + dy * dy;
}

function Node$1(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the weighted centroid.
  var aa = a.r * a.r,
      ba = b.r * b.r,
      ca = c.r * c.r,
      oa = aa + ba + ca,
      ox = aa * a.x + ba * b.x + ca * c.x,
      oy = aa * a.y + ba * b.y + ca * c.y,
      cx, cy, i, j, k, sj, sk;

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node$1(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Update the weighted centroid.
    oa += ca = c._.r * c._.r;
    ox += ca * c._.x;
    oy += ca * c._.y;

    // Compute the new closest circle pair to the centroid.
    aa = distance2(a, cx = ox / oa, cy = oy / oa);
    while ((c = c.next) !== b) {
      if ((ca = distance2(c, cx, cy)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

var siblings = function(circles) {
  packEnclose(circles);
  return circles;
};

function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

function constantZero() {
  return 0;
}

var constant$8 = function(x) {
  return function() {
    return x;
  };
};

function defaultRadius$1(d) {
  return Math.sqrt(d.value);
}

var index$2 = function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius$1))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant$8(+x), pack) : padding;
  };

  return pack;
};

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

var roundNode = function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
};

var treemapDice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
};

var partition = function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
};

var keyPrefix$1 = "$";
var preroot = {depth: -1};
var ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

var stratify = function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix$1 + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix$1 + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
};

function defaultSeparation$1(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
var tree = function() {
  var separation = defaultSeparation$1,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
};

var treemapSlice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
};

var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

var squarify = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
}))(phi);

var index$3 = function() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$8(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$8(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$8(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$8(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$8(+x), treemap) : paddingLeft;
  };

  return treemap;
};

var binary = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
};

var sliceDice = function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
};

var resquarify = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
}))(phi);

var area$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
};

var centroid$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
};

// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var cross$1 = function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
};

function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

var hull = function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
};

var contains$1 = function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
};

var length$2 = function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
};

var slice$3 = [].slice;

var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = slice$3.call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke$1(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke$1(q) {
  if (!q._start) {
    try { start$1(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start$1(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke$1(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}

var defaultSource$1 = function() {
  return Math.random();
};

var uniform = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
}))(defaultSource$1);

var normal = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
}))(defaultSource$1);

var logNormal = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = normal.source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
}))(defaultSource$1);

var irwinHall = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
}))(defaultSource$1);

var bates = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
}))(defaultSource$1);

var exponential$1 = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
}))(defaultSource$1);

var request = function(url, callback) {
  var request,
      event = dispatch("beforesend", "progress", "load", "error"),
      mimeType,
      headers = map$1(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
};

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}

var type$1 = function(defaultMimeType, response) {
  return function(url, callback) {
    var r = request(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
};

var html = type$1("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});

var json = type$1("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});

var text = type$1("text/plain", function(xhr) {
  return xhr.responseText;
});

var xml = type$1("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
});

var dsv$1 = function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = request(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
};

function responseOf(parse, row) {
  return function(request$$1) {
    return parse(request$$1.responseText, row);
  };
}

var csv$1 = dsv$1("text/csv", csvParse);

var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);

var array$2 = Array.prototype;

var map$3 = array$2.map;
var slice$4 = array$2.slice;

var implicit = {name: "implicit"};

function ordinal(range) {
  var index = map$1(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : slice$4.call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = map$1();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$4.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range$$1 = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range$$1[1] < range$$1[0],
        start = range$$1[reverse - 0],
        stop = range$$1[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
  };

  scale.rangeRound = function(_) {
    return range$$1 = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range$$1)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$1() {
  return pointish(band().paddingInner(1));
}

var constant$9 = function(x) {
  return function() {
    return x;
  };
};

var number$1 = function(x) {
  return +x;
};

var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant$9(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range$$1, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range$$1, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range$$1.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range$$1 = range$$1.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range$$1 = unit,
      interpolate$$1 = interpolateValue,
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$1), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), rescale()) : range$$1.slice();
  };

  scale.rangeRound = function(_) {
    return range$$1 = slice$4.call(_), interpolate$$1 = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
  };

  return rescale();
}

var tickFormat = function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = tickStep(start, stop, count == null ? 10 : count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return exports.formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return exports.format(specifier);
};

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return tickFormat(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear$2() {
  var scale = continuous(deinterpolateLinear, reinterpolate);

  scale.copy = function() {
    return copy(scale, linear$2());
  };

  return linearish(scale);
}

function identity$6() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$1), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity$6().domain(domain);
  };

  return linearish(scale);
}

var nice = function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
};

function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : constant$9(b);
}

function reinterpolate$1(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log$1() {
  var scale = continuous(deinterpolate, reinterpolate$1).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = exports.format(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return copy(scale, log$1().base(base));
  };

  return scale;
}

function raise$1(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow$1() {
  var exponent = 1,
      scale = continuous(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise$1(b, exponent) - (a = raise$1(a, exponent)))
        ? function(x) { return (raise$1(x, exponent) - a) / b; }
        : constant$9(b);
  }

  function reinterpolate(a, b) {
    b = raise$1(b, exponent) - (a = raise$1(a, exponent));
    return function(t) { return raise$1(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return copy(scale, pow$1().exponent(exponent));
  };

  return linearish(scale);
}

function sqrt$1() {
  return pow$1().exponent(0.5);
}

function quantile$$1() {
  var domain = [],
      range$$1 = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range$$1.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range$$1[bisectRight(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), rescale()) : range$$1.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile$$1()
        .domain(domain)
        .range(range$$1);
  };

  return scale;
}

function quantize$1() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range$$1 = [0, 1];

  function scale(x) {
    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range$$1 = slice$4.call(_)).length - 1, rescale()) : range$$1.slice();
  };

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize$1()
        .domain([x0, x1])
        .range(range$$1);
  };

  return linearish(scale);
}

function threshold$1() {
  var domain = [0.5],
      range$$1 = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = slice$4.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
  };

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold$1()
        .domain(domain)
        .range(range$$1);
  };

  return scale;
}

var t0$1 = new Date;
var t1$1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var milliseconds = millisecond.range;

var durationSecond$1 = 1e3;
var durationMinute$1 = 6e4;
var durationHour$1 = 36e5;
var durationDay$1 = 864e5;
var durationWeek$1 = 6048e5;

var second = newInterval(function(date) {
  date.setTime(Math.floor(date / durationSecond$1) * durationSecond$1);
}, function(date, step) {
  date.setTime(+date + step * durationSecond$1);
}, function(start, end) {
  return (end - start) / durationSecond$1;
}, function(date) {
  return date.getUTCSeconds();
});

var seconds = second.range;

var minute = newInterval(function(date) {
  date.setTime(Math.floor(date / durationMinute$1) * durationMinute$1);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getMinutes();
});

var minutes = minute.range;

var hour = newInterval(function(date) {
  var offset = date.getTimezoneOffset() * durationMinute$1 % durationHour$1;
  if (offset < 0) offset += durationHour$1;
  date.setTime(Math.floor((+date - offset) / durationHour$1) * durationHour$1 + offset);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getHours();
});

var hours = hour.range;

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1;
}, function(date) {
  return date.getDate() - 1;
});

var days = day.range;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var months = month.range;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var years = year.range;

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getUTCMinutes();
});

var utcMinutes = utcMinute.range;

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getUTCHours();
});

var utcHours = utcHour.range;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay$1;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDays = utcDay.range;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek$1;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcMonths = utcMonth.range;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYears = utcYear.range;

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"};
var numberRe = /^\s*\d+/;
var percentRe = /^%/;
var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(year(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(year(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

var locale$2;





defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$2 = formatLocale$1(definition);
  exports.timeFormat = locale$2.format;
  exports.timeParse = locale$2.parse;
  exports.utcFormat = locale$2.utcFormat;
  exports.utcParse = locale$2.utcParse;
  return locale$2;
}

var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : exports.utcFormat(isoSpecifier);

function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : exports.utcParse(isoSpecifier);

var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

function date$1(t) {
  return new Date(t);
}

function number$2(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
  var scale = continuous(deinterpolateLinear, reinterpolate),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second$$1,  1,      durationSecond],
    [second$$1,  5,  5 * durationSecond],
    [second$$1, 15, 15 * durationSecond],
    [second$$1, 30, 30 * durationSecond],
    [minute$$1,  1,      durationMinute],
    [minute$$1,  5,  5 * durationMinute],
    [minute$$1, 15, 15 * durationMinute],
    [minute$$1, 30, 30 * durationMinute],
    [  hour$$1,  1,      durationHour  ],
    [  hour$$1,  3,  3 * durationHour  ],
    [  hour$$1,  6,  6 * durationHour  ],
    [  hour$$1, 12, 12 * durationHour  ],
    [   day$$1,  1,      durationDay   ],
    [   day$$1,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month$$1,  1,      durationMonth ],
    [ month$$1,  3,  3 * durationMonth ],
    [  year$$1,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second$$1(date) < date ? formatMillisecond
        : minute$$1(date) < date ? formatSecond
        : hour$$1(date) < date ? formatMinute
        : day$$1(date) < date ? formatHour
        : month$$1(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year$$1(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval);
        interval = year$$1;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = tickStep(start, stop, interval);
        interval = millisecond$$1;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(map$3.call(_, number$2)) : domain().map(date$1);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
  };

  return scale;
}

var time = function() {
  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
};

var utcTime = function() {
  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
};

var colors = function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
};

var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var rainbow = cubehelix();

var rainbow$1 = function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
};

function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));

var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return linearish(scale);
}

var constant$10 = function(x) {
  return function constant() {
    return x;
  };
};

var abs$1 = Math.abs;
var atan2$1 = Math.atan2;
var cos$2 = Math.cos;
var max$2 = Math.max;
var min$1 = Math.min;
var sin$2 = Math.sin;
var sqrt$2 = Math.sqrt;

var epsilon$3 = 1e-12;
var pi$4 = Math.PI;
var halfPi$3 = pi$4 / 2;
var tau$4 = 2 * pi$4;

function acos$1(x) {
  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
}

function asin$1(x) {
  return x >= 1 ? halfPi$3 : x <= -1 ? -halfPi$3 : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt$2(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt$2(max$2(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

var arc = function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$10(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi$3,
        a1 = endAngle.apply(this, arguments) - halfPi$3,
        da = abs$1(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$3)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$4 - epsilon$3) {
      context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$3) {
        context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon$3) && (padRadius ? +padRadius.apply(this, arguments) : sqrt$2(r0 * r0 + r1 * r1)),
          rc = min$1(abs$1(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$3) {
        var p0 = asin$1(rp / r0 * sin$2(ap)),
            p1 = asin$1(rp / r1 * sin$2(ap));
        if ((da0 -= p0 * 2) > epsilon$3) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$3) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos$2(a01),
          y01 = r1 * sin$2(a01),
          x10 = r0 * cos$2(a10),
          y10 = r0 * sin$2(a10);

      // Apply rounded corners?
      if (rc > epsilon$3) {
        var x11 = r1 * cos$2(a11),
            y11 = r1 * sin$2(a11),
            x00 = r0 * cos$2(a00),
            y00 = r0 * sin$2(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < pi$4) {
          var oc = da0 > epsilon$3 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$2(ax * ax + ay * ay) * sqrt$2(bx * bx + by * by))) / 2),
              lc = sqrt$2(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min$1(rc, (r0 - lc) / (kc - 1));
          rc1 = min$1(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$3)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$3) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$3) || !(da0 > epsilon$3)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$3) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$4 / 2;
    return [cos$2(a) * r, sin$2(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
};

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

var curveLinear = function(context) {
  return new Linear(context);
};

function x$3(p) {
  return p[0];
}

function y$3(p) {
  return p[1];
}

var line = function() {
  var x$$1 = x$3,
      y$$1 = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$10(+_), line) : x$$1;
  };

  line.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$10(+_), line) : y$$1;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
};

var area$2 = function() {
  var x0 = x$3,
      x1 = null,
      y0 = constant$10(0),
      y1 = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
};

var descending$1 = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var identity$7 = function(d) {
  return d;
};

var pie = function() {
  var value = identity$7,
      sortValues = descending$1,
      sort = null,
      startAngle = constant$10(0),
      endAngle = constant$10(tau$4),
      padAngle = constant$10(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau$4, Math.max(-tau$4, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : padAngle;
  };

  return pie;
};

var curveRadialLinear = curveRadial(curveLinear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

function radialLine(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

var radialLine$1 = function() {
  return radialLine(line().curve(curveRadialLinear));
};

var radialArea = function() {
  var a = area$2().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
};

var slice$5 = Array.prototype.slice;

var radialPoint = function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
};

function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link$2(curve) {
  var source = linkSource,
      target = linkTarget,
      x$$1 = x$3,
      y$$1 = y$3,
      context = null;

  function link() {
    var buffer, argv = slice$5.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = path();
    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$10(+_), link) : x$$1;
  };

  link.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$10(+_), link) : y$$1;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial$1(context, x0, y0, x1, y1) {
  var p0 = radialPoint(x0, y0),
      p1 = radialPoint(x0, y0 = (y0 + y1) / 2),
      p2 = radialPoint(x1, y0),
      p3 = radialPoint(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link$2(curveHorizontal);
}

function linkVertical() {
  return link$2(curveVertical);
}

function linkRadial() {
  var l = link$2(curveRadial$1);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

var circle$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi$4);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$4);
  }
};

var cross$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};

var tan30 = Math.sqrt(1 / 3);
var tan30_2 = tan30 * 2;

var diamond = {
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};

var ka = 0.89081309152928522810;
var kr = Math.sin(pi$4 / 10) / Math.sin(7 * pi$4 / 10);
var kx = Math.sin(tau$4 / 10) * kr;
var ky = -Math.cos(tau$4 / 10) * kr;

var star = {
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau$4 * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};

var square = {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};

var sqrt3 = Math.sqrt(3);

var triangle = {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};

var c = -0.5;
var s = Math.sqrt(3) / 2;
var k = 1 / Math.sqrt(12);
var a = (k / 2 + 1) * 3;

var wye = {
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
};

var symbols = [
  circle$2,
  cross$2,
  diamond,
  square,
  star,
  triangle,
  wye
];

var symbol = function() {
  var type = constant$10(circle$2),
      size = constant$10(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$10(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$10(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
};

var noop$2 = function() {};

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$2(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basis$2 = function(context) {
  return new Basis(context);
};

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisClosed$1 = function(context) {
  return new BasisClosed(context);
};

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisOpen = function(context) {
  return new BasisOpen(context);
};

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

var bundle = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
}))(0.85);

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$3(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinal = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalClosed = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalOpen = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function point$4(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon$3) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon$3) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRom = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomClosed = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomOpen = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

var linearClosed = function(context) {
  return new LinearClosed(context);
};

function sign$1(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$5(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point$5(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point$5(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point$5(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

var natural = function(context) {
  return new Natural(context);
};

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

var step = function(context) {
  return new Step(context, 0.5);
};

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

var none$1 = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
};

var none$2 = function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
};

function stackValue(d, key) {
  return d[key];
}

var stack = function() {
  var keys = constant$10([]),
      order = none$2,
      offset = none$1,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$10(slice$5.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none$2 : typeof _ === "function" ? _ : constant$10(slice$5.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
  };

  return stack;
};

var expand = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none$1(series, order);
};

var diverging = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
};

var silhouette = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  none$1(series, order);
};

var wiggle = function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  none$1(series, order);
};

var ascending$2 = function(series) {
  var sums = series.map(sum$2);
  return none$2(series).sort(function(a, b) { return sums[a] - sums[b]; });
};

function sum$2(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

var descending$2 = function(series) {
  return ascending$2(series).reverse();
};

var insideOut = function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum$2),
      order = none$2(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
};

var reverse = function(series) {
  return none$2(series).reverse();
};

var constant$11 = function(x) {
  return function() {
    return x;
  };
};

function x$4(d) {
  return d[0];
}

function y$4(d) {
  return d[1];
}

function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$4
            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$4)) {
      delete edges[i];
    }
  }
}

function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > epsilon$4 || Math.abs(endY - startY) > epsilon$4) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < epsilon$4 && y1 - endY > epsilon$4 ? [x0, Math.abs(startX - x0) < epsilon$4 ? startY : y1]
              : Math.abs(endY - y1) < epsilon$4 && x1 - endX > epsilon$4 ? [Math.abs(startY - y1) < epsilon$4 ? startX : x1, y1]
              : Math.abs(endX - x1) < epsilon$4 && endY - y0 > epsilon$4 ? [x1, Math.abs(startX - x1) < epsilon$4 ? startY : y0]
              : Math.abs(endY - y0) < epsilon$4 && endX - x0 > epsilon$4 ? [Math.abs(startY - y0) < epsilon$4 ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2$2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < epsilon$4
      && Math.abs(y - lArc.circle.cy) < epsilon$4) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < epsilon$4
      && Math.abs(y - rArc.circle.cy) < epsilon$4) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > epsilon$4) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > epsilon$4) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -epsilon$4) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -epsilon$4) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

var epsilon$4 = 1e-6;
var epsilon2$2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new RedBlackTree;
  circles = new RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
};

var voronoi = function() {
  var x$$1 = x$4,
      y$$1 = y$4,
      extent = null;

  function voronoi(data) {
    return new Diagram(data.map(function(d, i) {
      var s = [Math.round(x$$1(d, i, data) / epsilon$4) * epsilon$4, Math.round(y$$1(d, i, data) / epsilon$4) * epsilon$4];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$11(+_), voronoi) : x$$1;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$11(+_), voronoi) : y$$1;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
};

var constant$12 = function(x) {
  return function() {
    return x;
  };
};

function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}

function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity$8 = new Transform(1, 0, 0);

transform$1.prototype = Transform.prototype;

function transform$1(node) {
  return node.__zoom || identity$8;
}

function nopropagation$2() {
  exports.event.stopImmediatePropagation();
}

var noevent$2 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$2() {
  return !exports.event.button;
}

function defaultExtent$1() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || identity$8;
}

var zoom = function() {
  var filter = defaultFilter$2,
      extent = defaultExtent$1,
      k0 = 0,
      k1 = Infinity,
      x0 = -k1,
      x1 = k1,
      y0 = x0,
      y1 = x1,
      duration = 250,
      interpolate$$1 = interpolateZoom,
      gestures = [],
      listeners = dispatch("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection$$1) {
    selection$$1
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .property("__zoom", defaultTransform);
  }

  zoom.transform = function(collection, transform) {
    var selection$$1 = collection.selection ? collection.selection() : collection;
    selection$$1.property("__zoom", defaultTransform);
    if (collection !== selection$$1) {
      schedule(collection, transform);
    } else {
      selection$$1.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection$$1, k) {
    zoom.scaleTo(selection$$1, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection$$1, k) {
    zoom.transform(selection$$1, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e);
    });
  };

  zoom.translateBy = function(selection$$1, x, y) {
    zoom.transform(selection$$1, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments));
    });
  };

  function scale(transform, k) {
    k = Math.max(k0, Math.min(k1, k));
    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
  }

  function constrain(transform, extent) {
    var dx0 = transform.invertX(extent[0][0]) - x0,
        dx1 = transform.invertX(extent[1][0]) - x1,
        dy0 = transform.invertY(extent[0][1]) - y0,
        dy1 = transform.invertY(extent[1][1]) - y1;
    return transform.translate(
      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
    );
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition$$1, transform, center) {
    transition$$1
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate$$1(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500))),
        p = mouse(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      interrupt(this);
      g.start();
    }

    noevent$2();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = mouse(this),
        x0 = exports.event.clientX,
        y0 = exports.event.clientY;

    dragDisable(exports.event.view);
    nopropagation$2();
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt(this);
    g.start();

    function mousemoved() {
      noevent$2();
      if (!g.moved) {
        var dx = exports.event.clientX - x0, dy = exports.event.clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(exports.event.view, g.moved);
      noevent$2();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = mouse(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));

    noevent$2();
    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
    else select(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        started,
        n = touches$$1.length, i, t, p;

    nopropagation$2();
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = select(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      interrupt(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t, p, l;

    noevent$2();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t;

    nopropagation$2();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$12(!!_), zoom) : filter;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$12([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate$$1 = _, zoom) : interpolate$$1;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };
    
  return zoom;
};

exports.version = version;
exports.bisect = bisectRight;
exports.bisectRight = bisectRight;
exports.bisectLeft = bisectLeft;
exports.ascending = ascending;
exports.bisector = bisector;
exports.cross = cross;
exports.descending = descending;
exports.deviation = deviation;
exports.extent = extent;
exports.histogram = histogram;
exports.thresholdFreedmanDiaconis = freedmanDiaconis;
exports.thresholdScott = scott;
exports.thresholdSturges = sturges;
exports.max = max;
exports.mean = mean;
exports.median = median;
exports.merge = merge;
exports.min = min;
exports.pairs = pairs;
exports.permute = permute;
exports.quantile = threshold;
exports.range = sequence;
exports.scan = scan;
exports.shuffle = shuffle;
exports.sum = sum;
exports.ticks = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
exports.transpose = transpose;
exports.variance = variance;
exports.zip = zip;
exports.axisTop = axisTop;
exports.axisRight = axisRight;
exports.axisBottom = axisBottom;
exports.axisLeft = axisLeft;
exports.brush = brush;
exports.brushX = brushX;
exports.brushY = brushY;
exports.brushSelection = brushSelection;
exports.chord = chord;
exports.ribbon = ribbon;
exports.nest = nest;
exports.set = set$2;
exports.map = map$1;
exports.keys = keys;
exports.values = values;
exports.entries = entries;
exports.color = color;
exports.rgb = rgb;
exports.hsl = hsl;
exports.lab = lab;
exports.hcl = hcl;
exports.cubehelix = cubehelix;
exports.dispatch = dispatch;
exports.drag = drag;
exports.dragDisable = dragDisable;
exports.dragEnable = yesdrag;
exports.dsvFormat = dsv;
exports.csvParse = csvParse;
exports.csvParseRows = csvParseRows;
exports.csvFormat = csvFormat;
exports.csvFormatRows = csvFormatRows;
exports.tsvParse = tsvParse;
exports.tsvParseRows = tsvParseRows;
exports.tsvFormat = tsvFormat;
exports.tsvFormatRows = tsvFormatRows;
exports.easeLinear = linear$1;
exports.easeQuad = quadInOut;
exports.easeQuadIn = quadIn;
exports.easeQuadOut = quadOut;
exports.easeQuadInOut = quadInOut;
exports.easeCubic = cubicInOut;
exports.easeCubicIn = cubicIn;
exports.easeCubicOut = cubicOut;
exports.easeCubicInOut = cubicInOut;
exports.easePoly = polyInOut;
exports.easePolyIn = polyIn;
exports.easePolyOut = polyOut;
exports.easePolyInOut = polyInOut;
exports.easeSin = sinInOut;
exports.easeSinIn = sinIn;
exports.easeSinOut = sinOut;
exports.easeSinInOut = sinInOut;
exports.easeExp = expInOut;
exports.easeExpIn = expIn;
exports.easeExpOut = expOut;
exports.easeExpInOut = expInOut;
exports.easeCircle = circleInOut;
exports.easeCircleIn = circleIn;
exports.easeCircleOut = circleOut;
exports.easeCircleInOut = circleInOut;
exports.easeBounce = bounceOut;
exports.easeBounceIn = bounceIn;
exports.easeBounceOut = bounceOut;
exports.easeBounceInOut = bounceInOut;
exports.easeBack = backInOut;
exports.easeBackIn = backIn;
exports.easeBackOut = backOut;
exports.easeBackInOut = backInOut;
exports.easeElastic = elasticOut;
exports.easeElasticIn = elasticIn;
exports.easeElasticOut = elasticOut;
exports.easeElasticInOut = elasticInOut;
exports.forceCenter = center$1;
exports.forceCollide = collide;
exports.forceLink = link;
exports.forceManyBody = manyBody;
exports.forceSimulation = simulation;
exports.forceX = x$2;
exports.forceY = y$2;
exports.formatDefaultLocale = defaultLocale;
exports.formatLocale = formatLocale;
exports.formatSpecifier = formatSpecifier;
exports.precisionFixed = precisionFixed;
exports.precisionPrefix = precisionPrefix;
exports.precisionRound = precisionRound;
exports.geoArea = area;
exports.geoBounds = bounds;
exports.geoCentroid = centroid;
exports.geoCircle = circle;
exports.geoClipExtent = extent$1;
exports.geoContains = contains;
exports.geoDistance = distance;
exports.geoGraticule = graticule;
exports.geoGraticule10 = graticule10;
exports.geoInterpolate = interpolate$1;
exports.geoLength = length$1;
exports.geoPath = index$1;
exports.geoAlbers = albers;
exports.geoAlbersUsa = albersUsa;
exports.geoAzimuthalEqualArea = azimuthalEqualArea;
exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
exports.geoAzimuthalEquidistant = azimuthalEquidistant;
exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
exports.geoConicConformal = conicConformal;
exports.geoConicConformalRaw = conicConformalRaw;
exports.geoConicEqualArea = conicEqualArea;
exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
exports.geoConicEquidistant = conicEquidistant;
exports.geoConicEquidistantRaw = conicEquidistantRaw;
exports.geoEquirectangular = equirectangular;
exports.geoEquirectangularRaw = equirectangularRaw;
exports.geoGnomonic = gnomonic;
exports.geoGnomonicRaw = gnomonicRaw;
exports.geoIdentity = identity$5;
exports.geoProjection = projection;
exports.geoProjectionMutator = projectionMutator;
exports.geoMercator = mercator;
exports.geoMercatorRaw = mercatorRaw;
exports.geoOrthographic = orthographic;
exports.geoOrthographicRaw = orthographicRaw;
exports.geoStereographic = stereographic;
exports.geoStereographicRaw = stereographicRaw;
exports.geoTransverseMercator = transverseMercator;
exports.geoTransverseMercatorRaw = transverseMercatorRaw;
exports.geoRotation = rotation;
exports.geoStream = geoStream;
exports.geoTransform = transform;
exports.cluster = cluster;
exports.hierarchy = hierarchy;
exports.pack = index$2;
exports.packSiblings = siblings;
exports.packEnclose = enclose;
exports.partition = partition;
exports.stratify = stratify;
exports.tree = tree;
exports.treemap = index$3;
exports.treemapBinary = binary;
exports.treemapDice = treemapDice;
exports.treemapSlice = treemapSlice;
exports.treemapSliceDice = sliceDice;
exports.treemapSquarify = squarify;
exports.treemapResquarify = resquarify;
exports.interpolate = interpolateValue;
exports.interpolateArray = array$1;
exports.interpolateBasis = basis$1;
exports.interpolateBasisClosed = basisClosed;
exports.interpolateDate = date;
exports.interpolateNumber = reinterpolate;
exports.interpolateObject = object;
exports.interpolateRound = interpolateRound;
exports.interpolateString = interpolateString;
exports.interpolateTransformCss = interpolateTransformCss;
exports.interpolateTransformSvg = interpolateTransformSvg;
exports.interpolateZoom = interpolateZoom;
exports.interpolateRgb = interpolateRgb;
exports.interpolateRgbBasis = rgbBasis;
exports.interpolateRgbBasisClosed = rgbBasisClosed;
exports.interpolateHsl = hsl$2;
exports.interpolateHslLong = hslLong;
exports.interpolateLab = lab$1;
exports.interpolateHcl = hcl$2;
exports.interpolateHclLong = hclLong;
exports.interpolateCubehelix = cubehelix$2;
exports.interpolateCubehelixLong = cubehelixLong;
exports.quantize = quantize;
exports.path = path;
exports.polygonArea = area$1;
exports.polygonCentroid = centroid$1;
exports.polygonHull = hull;
exports.polygonContains = contains$1;
exports.polygonLength = length$2;
exports.quadtree = quadtree;
exports.queue = queue;
exports.randomUniform = uniform;
exports.randomNormal = normal;
exports.randomLogNormal = logNormal;
exports.randomBates = bates;
exports.randomIrwinHall = irwinHall;
exports.randomExponential = exponential$1;
exports.request = request;
exports.html = html;
exports.json = json;
exports.text = text;
exports.xml = xml;
exports.csv = csv$1;
exports.tsv = tsv$1;
exports.scaleBand = band;
exports.scalePoint = point$1;
exports.scaleIdentity = identity$6;
exports.scaleLinear = linear$2;
exports.scaleLog = log$1;
exports.scaleOrdinal = ordinal;
exports.scaleImplicit = implicit;
exports.scalePow = pow$1;
exports.scaleSqrt = sqrt$1;
exports.scaleQuantile = quantile$$1;
exports.scaleQuantize = quantize$1;
exports.scaleThreshold = threshold$1;
exports.scaleTime = time;
exports.scaleUtc = utcTime;
exports.schemeCategory10 = category10;
exports.schemeCategory20b = category20b;
exports.schemeCategory20c = category20c;
exports.schemeCategory20 = category20;
exports.interpolateCubehelixDefault = cubehelix$3;
exports.interpolateRainbow = rainbow$1;
exports.interpolateWarm = warm;
exports.interpolateCool = cool;
exports.interpolateViridis = viridis;
exports.interpolateMagma = magma;
exports.interpolateInferno = inferno;
exports.interpolatePlasma = plasma;
exports.scaleSequential = sequential;
exports.creator = creator;
exports.local = local$1;
exports.matcher = matcher$1;
exports.mouse = mouse;
exports.namespace = namespace;
exports.namespaces = namespaces;
exports.select = select;
exports.selectAll = selectAll;
exports.selection = selection;
exports.selector = selector;
exports.selectorAll = selectorAll;
exports.style = styleValue;
exports.touch = touch;
exports.touches = touches;
exports.window = defaultView;
exports.customEvent = customEvent;
exports.arc = arc;
exports.area = area$2;
exports.line = line;
exports.pie = pie;
exports.radialArea = radialArea;
exports.radialLine = radialLine$1;
exports.linkHorizontal = linkHorizontal;
exports.linkVertical = linkVertical;
exports.linkRadial = linkRadial;
exports.symbol = symbol;
exports.symbols = symbols;
exports.symbolCircle = circle$2;
exports.symbolCross = cross$2;
exports.symbolDiamond = diamond;
exports.symbolSquare = square;
exports.symbolStar = star;
exports.symbolTriangle = triangle;
exports.symbolWye = wye;
exports.curveBasisClosed = basisClosed$1;
exports.curveBasisOpen = basisOpen;
exports.curveBasis = basis$2;
exports.curveBundle = bundle;
exports.curveCardinalClosed = cardinalClosed;
exports.curveCardinalOpen = cardinalOpen;
exports.curveCardinal = cardinal;
exports.curveCatmullRomClosed = catmullRomClosed;
exports.curveCatmullRomOpen = catmullRomOpen;
exports.curveCatmullRom = catmullRom;
exports.curveLinearClosed = linearClosed;
exports.curveLinear = curveLinear;
exports.curveMonotoneX = monotoneX;
exports.curveMonotoneY = monotoneY;
exports.curveNatural = natural;
exports.curveStep = step;
exports.curveStepAfter = stepAfter;
exports.curveStepBefore = stepBefore;
exports.stack = stack;
exports.stackOffsetExpand = expand;
exports.stackOffsetDiverging = diverging;
exports.stackOffsetNone = none$1;
exports.stackOffsetSilhouette = silhouette;
exports.stackOffsetWiggle = wiggle;
exports.stackOrderAscending = ascending$2;
exports.stackOrderDescending = descending$2;
exports.stackOrderInsideOut = insideOut;
exports.stackOrderNone = none$2;
exports.stackOrderReverse = reverse;
exports.timeInterval = newInterval;
exports.timeMillisecond = millisecond;
exports.timeMilliseconds = milliseconds;
exports.utcMillisecond = millisecond;
exports.utcMilliseconds = milliseconds;
exports.timeSecond = second;
exports.timeSeconds = seconds;
exports.utcSecond = second;
exports.utcSeconds = seconds;
exports.timeMinute = minute;
exports.timeMinutes = minutes;
exports.timeHour = hour;
exports.timeHours = hours;
exports.timeDay = day;
exports.timeDays = days;
exports.timeWeek = sunday;
exports.timeWeeks = sundays;
exports.timeSunday = sunday;
exports.timeSundays = sundays;
exports.timeMonday = monday;
exports.timeMondays = mondays;
exports.timeTuesday = tuesday;
exports.timeTuesdays = tuesdays;
exports.timeWednesday = wednesday;
exports.timeWednesdays = wednesdays;
exports.timeThursday = thursday;
exports.timeThursdays = thursdays;
exports.timeFriday = friday;
exports.timeFridays = fridays;
exports.timeSaturday = saturday;
exports.timeSaturdays = saturdays;
exports.timeMonth = month;
exports.timeMonths = months;
exports.timeYear = year;
exports.timeYears = years;
exports.utcMinute = utcMinute;
exports.utcMinutes = utcMinutes;
exports.utcHour = utcHour;
exports.utcHours = utcHours;
exports.utcDay = utcDay;
exports.utcDays = utcDays;
exports.utcWeek = utcSunday;
exports.utcWeeks = utcSundays;
exports.utcSunday = utcSunday;
exports.utcSundays = utcSundays;
exports.utcMonday = utcMonday;
exports.utcMondays = utcMondays;
exports.utcTuesday = utcTuesday;
exports.utcTuesdays = utcTuesdays;
exports.utcWednesday = utcWednesday;
exports.utcWednesdays = utcWednesdays;
exports.utcThursday = utcThursday;
exports.utcThursdays = utcThursdays;
exports.utcFriday = utcFriday;
exports.utcFridays = utcFridays;
exports.utcSaturday = utcSaturday;
exports.utcSaturdays = utcSaturdays;
exports.utcMonth = utcMonth;
exports.utcMonths = utcMonths;
exports.utcYear = utcYear;
exports.utcYears = utcYears;
exports.timeFormatDefaultLocale = defaultLocale$1;
exports.timeFormatLocale = formatLocale$1;
exports.isoFormat = formatIso;
exports.isoParse = parseIso;
exports.now = now;
exports.timer = timer;
exports.timerFlush = timerFlush;
exports.timeout = timeout$1;
exports.interval = interval$1;
exports.transition = transition;
exports.active = active;
exports.interrupt = interrupt;
exports.voronoi = voronoi;
exports.zoom = zoom;
exports.zoomTransform = transform$1;
exports.zoomIdentity = identity$8;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(109);
var setInnerHTML = __webpack_require__(73);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(117);
var setTextContent = __webpack_require__(217);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(478);
var ReactInstrumentation = __webpack_require__(18);

var warning = __webpack_require__(4);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var ReactBaseClasses = __webpack_require__(228);
var ReactChildren = __webpack_require__(542);
var ReactDOMFactories = __webpack_require__(543);
var ReactElement = __webpack_require__(45);
var ReactPropTypes = __webpack_require__(544);
var ReactVersion = __webpack_require__(545);

var createReactClass = __webpack_require__(546);
var onlyChild = __webpack_require__(550);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(25);

var warning = __webpack_require__(4);
var canDefineProperty = __webpack_require__(232);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(230);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["g"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);


function spherical(cartesian) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(cartesian[1], cartesian[0]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  return [cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda), cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x),
        cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x),
      k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(c),
        cc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(c);
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x * sc, z * cc),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(99);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(173);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(98);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(174);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(176);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(177);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(179);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(343);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(345);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(178);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(338);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(339);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(337);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(336);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(340);
/* unused harmony reexport quantize */



















/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(175);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(346);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(352);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(353);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(182);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(354);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(355);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(356);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(359);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(183);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(361);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(347);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(349);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(350);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(348);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(351);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(357);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(362);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(358);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(360);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var EventPluginRegistry = __webpack_require__(110);
var EventPluginUtils = __webpack_require__(111);
var ReactErrorUtils = __webpack_require__(115);

var accumulateInto = __webpack_require__(210);
var forEachAccumulated = __webpack_require__(211);
var invariant = __webpack_require__(1);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(56);
var EventPluginUtils = __webpack_require__(111);

var accumulateInto = __webpack_require__(210);
var forEachAccumulated = __webpack_require__(211);
var warning = __webpack_require__(4);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(24);

var getEventTarget = __webpack_require__(120);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefix = prefix;
exports.createAction = createAction;
exports.delay = delay;
function prefix(name) {
  return 'redux-tooltip/' + name;
}

// NOTE: No compatibility with redux-actions.
function createAction(type) {
  return function (payload) {
    return { type: type, payload: payload };
  };
}

var SHOW = exports.SHOW = prefix('SHOW');
var HIDE = exports.HIDE = prefix('HIDE');
var TOGGLE = exports.TOGGLE = prefix('TOGGLE');
var KEEP = exports.KEEP = prefix('KEEP');
var CONTENT = exports.CONTENT = prefix('CONTENT');
var PLACE = exports.PLACE = prefix('PLACE');

var show = exports.show = createAction(SHOW);
var hide = exports.hide = createAction(HIDE);
var toggle = exports.toggle = createAction(TOGGLE);
var keep = exports.keep = createAction(KEEP);
var content = exports.content = createAction(CONTENT);
var place = exports.place = createAction(PLACE);

var DELAY = exports.DELAY = prefix('DELAY');
var DURATION = 1500;
function delay(action) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { duration: DURATION },
      duration = _ref.duration,
      callback = _ref.callback;

  if (!action.meta) {
    action.meta = {};
  }
  if (typeof duration === 'undefined' || duration === true) {
    duration = DURATION;
  }
  action.meta[DELAY] = { duration: parseInt(duration), callback: callback };
  return action;
}

var START_TIMEOUT = exports.START_TIMEOUT = prefix('START_TIMEOUT');
var END_TIMEOUT = exports.END_TIMEOUT = prefix('END_TIMEOUT');

var startTimeout = exports.startTimeout = createAction(START_TIMEOUT);
var endTimeout = exports.endTimeout = createAction(END_TIMEOUT);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);



function rotationIdentity(lambda, phi) {
  return [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */]) ? (deltaPhi || deltaGamma ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(deltaPhi),
      sinDeltaPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(deltaPhi),
      cosDeltaGamma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(deltaGamma),
      sinDeltaGamma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
        x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(lambda) * cosPhi,
        y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda) * cosPhi,
        z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
        x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(lambda) * cosPhi,
        y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda) * cosPhi,
        z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformer;
/* unused harmony default export */ var _unused_webpack_default_export = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(181);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var EventPluginRegistry = __webpack_require__(110);
var ReactEventEmitterMixin = __webpack_require__(470);
var ViewportMetrics = __webpack_require__(209);

var getVendorPrefixedEventName = __webpack_require__(502);
var isEventSupported = __webpack_require__(121);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(59);
var ViewportMetrics = __webpack_require__(209);

var getEventModifierState = __webpack_require__(119);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);
var DOMNamespaces = __webpack_require__(109);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(117);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);


var BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["k" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["e"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["d"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["b"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(236);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["o" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["o" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, 'channel.take\'s callback must be a function');

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, 'channel.flush\' callback must be a function');
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return { take: take, put: put, flush: flush, close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["p" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, 'channel.take\'s matcher argument must be a function');
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["o" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["b"] = put;
/* unused harmony export all */
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["c"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["d"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* unused harmony export select */
/* harmony export (immutable) */ __webpack_exports__["f"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(235);



var IO = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* deprecate */])(take.maybe, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* deprecate */])(put.resolve, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'join(task): argument task is undefined');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'cancel(task): argument task is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* ident */];
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: createAsEffectType(TAKE),
  put: createAsEffectType(PUT),
  all: createAsEffectType(ALL),
  race: createAsEffectType(RACE),
  call: createAsEffectType(CALL),
  cps: createAsEffectType(CPS),
  fork: createAsEffectType(FORK),
  join: createAsEffectType(JOIN),
  cancel: createAsEffectType(CANCEL),
  select: createAsEffectType(SELECT),
  actionChannel: createAsEffectType(ACTION_CHANNEL),
  cancelled: createAsEffectType(CANCELLED),
  flush: createAsEffectType(FLUSH),
  getContext: createAsEffectType(GET_CONTEXT),
  setContext: createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.position = position;
exports.placement = placement;
exports.complete = complete;
exports.intersection = intersection;
exports.strip = strip;
exports.amend = amend;
exports.overDirs = overDirs;
exports.adjust = adjust;
exports.resolve = resolve;
exports.deprecatedWarning = deprecatedWarning;
exports.originOrEl = originOrEl;

var _isDom = __webpack_require__(426);

var _isDom2 = _interopRequireDefault(_isDom);

var _actions = __webpack_require__(61);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function dimension(el) {
  var rect = el.getBoundingClientRect();
  return { width: rect.width, height: rect.height };
}

/**
 * Returns a position of given DOM element.
 *
 * @param {Object} el - DOM element.
 * @return {Object}
 */
function position(el) {
  var pos = el.getBoundingClientRect();
  var _window = window,
      pageYOffset = _window.pageYOffset,
      pageXOffset = _window.pageXOffset;
  var _document$documentEle = document.documentElement,
      scrollTop = _document$documentEle.scrollTop,
      clientTop = _document$documentEle.clientTop,
      scrollLeft = _document$documentEle.scrollLeft,
      clientLeft = _document$documentEle.clientLeft;

  var winTop = (pageYOffset || scrollTop) - clientTop;
  var winLeft = (pageXOffset || scrollLeft) - clientLeft;

  return {
    top: pos.top + winTop,
    left: pos.left + winLeft,
    right: pos.right + winLeft,
    bottom: pos.bottom + winTop,
    width: pos.width,
    height: pos.height
  };
}

/**
 * Calculates a position of the tooltip.
 *
 * @param {string} place - 'top', 'right', 'bottom', or 'left'.
 * @param {Object} content - DOM element that contains a content.
 * @param {Object} origin - DOM element or position object.
 * @return {Object} contains 'top', 'left', and extra keys.
 */
function placement(place, content, origin) {
  var gap = 12;
  var dim = dimension(content);
  var pos = (0, _isDom2.default)(origin) ? position(origin) : { top: origin.y, right: origin.x, bottom: origin.y, left: origin.x, width: 0, height: 0 };

  var offset = { width: dim.width, height: dim.height };
  switch (place) {
    case 'top':case 'bottom':
      offset.left = pos.left + pos.width * 0.5 - dim.width * 0.5 + 'px';
      break;
    case 'left':case 'right':
      offset.top = pos.top + pos.height * 0.5 - dim.height * 0.5 + 'px';
      break;
  }

  switch (place) {
    case 'top':
      offset.top = pos.top - dim.height - gap + 'px';
      break;
    case 'right':
      offset.left = pos.right + gap + 'px';
      break;
    case 'bottom':
      offset.top = pos.top + pos.height + gap + 'px';
      break;
    case 'left':
      offset.left = pos.left - dim.width - gap + 'px';
      break;
  }

  return offset;
}

/**
 * Completes missing directions in given direction(s).
 *
 * @param {string|Array} dir - a direction or a list of directions.
 * @return {Array}
 */
var DIRS = ['top', 'right', 'bottom', 'left'];
function complete(dir) {
  if (typeof dir === 'string') {
    dir = [dir];
  } else {
    dir = [].concat(_toConsumableArray(dir));
  }

  var missings = DIRS.filter(function (d) {
    return dir.indexOf(d) === -1;
  });
  return dir.concat(missings);
}

/**
 * Calculates an intersection of two areas.
 *
 * @param {Object} area1
 * @param {Object} area2
 * @return {Object} an intersection.
 */
function intersection(area1, area2) {
  var area = {};
  area.top = Math.max(area1.top, area2.top);
  area.right = Math.min(area1.left + area1.width, area2.left + area2.width);
  area.bottom = Math.min(area1.top + area1.height, area2.top + area2.height);
  area.left = Math.max(area1.left, area2.left);
  area.height = area.bottom - area.top;
  area.width = area.right - area.left;
  return area;
}

function scrollOffset() {
  var list = [document.documentElement, document.body.parentNode, document.body];
  return {
    top: list.map(function (el) {
      return el.scrollTop;
    }).reduce(function (p, v) {
      return p || v;
    }),
    left: list.map(function (el) {
      return el.scrollLeft;
    }).reduce(function (p, v) {
      return p || v;
    })
  };
}

// Returns current content area
function contentArea() {
  return _extends({}, scrollOffset(), {
    height: window.innerHeight,
    width: window.innerWidth
  });
}

// Strip unit string from property values and convert to float
var STRIP_FOR = ['top', 'left', 'right', 'bottom', 'width', 'height'];
function strip(obj) {
  var data = _extends({}, obj);
  STRIP_FOR.forEach(function (prop) {
    if (typeof data[prop] === 'string') {
      data[prop] = parseFloat(data[prop].replace('px', ''));
    }
  });
  return data;
}

// Make full area data from minimum data
function amend(area) {
  var data = strip(area);
  if (typeof data.top !== 'number') {
    data.top = 0;
  }
  if (typeof data.left !== 'number') {
    data.left = 0;
  }
  if (typeof data.right !== 'number' && typeof data.width === 'number') {
    data.right = data.left + data.width;
  }
  if (typeof data.bottom !== 'number' && typeof data.height === 'number') {
    data.bottom = data.top + data.height;
  }
  return data;
}

// Returns directions which are not in target rectangle
function overDirs(tip, el) {
  tip = amend(tip);
  var area = amend(contentArea());
  if (el && (typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'object') {
    area = intersection(area, position(el));
  }

  var dirs = [];
  if (tip.top < area.top) {
    dirs.push('top');
  }
  if (area.right < tip.right) {
    dirs.push('right');
  }
  if (area.bottom < tip.bottom) {
    dirs.push('bottom');
  }
  if (tip.left < area.left) {
    dirs.push('left');
  }

  return dirs;
}

/**
 * Places and adjusts a tooltip.
 *
 * @param {Object} content - DOM element which contans a content.
 * @param {Object} props - props set from Tooltip component.
 * @return {Object} 'offset': style data to locate, 'place': final direction of the tooltip
 */
function adjust(content, props) {
  var auto = props.auto,
      within = props.within;

  var origin = originOrEl(props);
  var place = props.place;

  if (typeof place === 'string') {
    place = place.split(',').map(function (p) {
      return p.trim();
    });
  }
  if (auto) {
    place = complete(place);
  }

  var pos = void 0,
      dirs = void 0,
      current = void 0,
      first = void 0;
  var tries = [].concat(_toConsumableArray(place));
  while (0 < tries.length) {
    current = tries.shift();
    pos = placement(current, content, origin);
    if (typeof first === 'undefined') {
      first = { offset: pos, place: current };
    }
    dirs = overDirs(pos, within && within());
    if (dirs.length === 0) {
      return { offset: pos, place: current };
    }
  }
  return first;
}

/**
 * Resolves names of target tooltip from action or props.
 *
 * @param {Object} action or props.
 * @return {Array} a list of tooltip names.
 */
function resolve(obj) {
  var names = void 0;
  if (obj && obj.payload && obj.payload.name) {
    names = obj.payload.name;
  } else if (obj && obj.name) {
    names = obj.name;
  } else {
    names = ['default'];
  }

  if (typeof names === 'string') {
    names = [names];
  }

  return names;
}

var actionTypes = Object.keys(actions).map(function (k) {
  return actions[k];
}).filter(function (e) {
  return typeof e === 'string';
});
function deprecatedWarning(action) {
  var type = action.type,
      payload = action.payload;

  if (actionTypes.indexOf(action.type) === -1) {
    return; // Ignore non-related actions
  }
  if (payload && payload.el) {
    console.warn('DEPRECATED: Use \'origin\' instead of \'el\' in props for Tooltip component or \'show\' action.');
  }
  if (payload && payload.el && payload.origin) {
    console.warn('Do not pass both \'origin\' and \'el\' props at the same time.');
  }
}

function originOrEl(props) {
  return props.origin || props.el;
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  var out$ = typeof exports != 'undefined' && exports || "function" != 'undefined' && {} || this;

  var doctype = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [<!ENTITY nbsp "&#160;">]>';

  function isElement(obj) {
    return obj instanceof HTMLElement || obj instanceof SVGElement;
  }

  function requireDomNode(el) {
    if (!isElement(el)) {
      throw new Error('an HTMLElement or SVGElement is required; got ' + el);
    }
  }

  function isExternal(url) {
    return url && url.lastIndexOf('http',0) == 0 && url.lastIndexOf(window.location.host) == -1;
  }

  function inlineImages(el, callback) {
    requireDomNode(el);

    var images = el.querySelectorAll('image'),
        left = images.length,
        checkDone = function() {
          if (left === 0) {
            callback();
          }
        };

    checkDone();
    for (var i = 0; i < images.length; i++) {
      (function(image) {
        var href = image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
        if (href) {
          if (isExternal(href.value)) {
            console.warn("Cannot render embedded images linking to external hosts: "+href.value);
            return;
          }
        }
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var img = new Image();
        img.crossOrigin="anonymous";
        href = href || image.getAttribute('href');
        if (href) {
          img.src = href;
          img.onload = function() {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            image.setAttributeNS("http://www.w3.org/1999/xlink", "href", canvas.toDataURL('image/png'));
            left--;
            checkDone();
          }
          img.onerror = function() {
            console.log("Could not load "+href);
            left--;
            checkDone();
          }
        } else {
          left--;
          checkDone();
        }
      })(images[i]);
    }
  }

  function styles(el, options, cssLoadedCallback) {
    var selectorRemap = options.selectorRemap;
    var modifyStyle = options.modifyStyle;
    var css = "";
    // each font that has extranl link is saved into queue, and processed
    // asynchronously
    var fontsQueue = [];
    var sheets = document.styleSheets;
    for (var i = 0; i < sheets.length; i++) {
      try {
        var rules = sheets[i].cssRules;
      } catch (e) {
        console.warn("Stylesheet could not be loaded: "+sheets[i].href);
        continue;
      }

      if (rules != null) {
        for (var j = 0, match; j < rules.length; j++, match = null) {
          var rule = rules[j];
          if (typeof(rule.style) != "undefined") {
            var selectorText;

            try {
              selectorText = rule.selectorText;
            } catch(err) {
              console.warn('The following CSS rule has an invalid selector: "' + rule + '"', err);
            }

            try {
              if (selectorText) {
                match = el.querySelector(selectorText) || el.parentNode.querySelector(selectorText);
              }
            } catch(err) {
              console.warn('Invalid CSS selector "' + selectorText + '"', err);
            }

            if (match) {
              var selector = selectorRemap ? selectorRemap(rule.selectorText) : rule.selectorText;
              var cssText = modifyStyle ? modifyStyle(rule.style.cssText) : rule.style.cssText;
              css += selector + " { " + cssText + " }\n";
            } else if(rule.cssText.match(/^@font-face/)) {
              // below we are trying to find matches to external link. E.g.
              // @font-face {
              //   // ...
              //   src: local('Abel'), url(https://fonts.gstatic.com/s/abel/v6/UzN-iejR1VoXU2Oc-7LsbvesZW2xOQ-xsNqO47m55DA.woff2);
              // }
              //
              // This regex will save extrnal link into first capture group
              var fontUrlRegexp = /url\(["']?(.+?)["']?\)/;
              // TODO: This needs to be changed to support multiple url declarations per font.
              var fontUrlMatch = rule.cssText.match(fontUrlRegexp);

              var externalFontUrl = (fontUrlMatch && fontUrlMatch[1]) || '';
              var fontUrlIsDataURI = externalFontUrl.match(/^data:/);
              if (fontUrlIsDataURI) {
                // We should ignore data uri - they are already embedded
                externalFontUrl = '';
              }

              if (externalFontUrl) {
                // okay, we are lucky. We can fetch this font later

                //handle url if relative
                if (externalFontUrl.startsWith('../')) {
                  externalFontUrl = sheets[i].href + '/../' + externalFontUrl
                } else if (externalFontUrl.startsWith('./')) {
                  externalFontUrl = sheets[i].href + '/.' + externalFontUrl
                }

                fontsQueue.push({
                  text: rule.cssText,
                  // Pass url regex, so that once font is downladed, we can run `replace()` on it
                  fontUrlRegexp: fontUrlRegexp,
                  format: getFontMimeTypeFromUrl(externalFontUrl),
                  url: externalFontUrl
                });
              } else {
                // otherwise, use previous logic
                css += rule.cssText + '\n';
              }
            }
          }
        }
      }
    }

    // Now all css is processed, it's time to handle scheduled fonts
    processFontQueue(fontsQueue);

    function getFontMimeTypeFromUrl(fontUrl) {
      var supportedFormats = {
        'woff2': 'font/woff2',
        'woff': 'font/woff',
        'otf': 'application/x-font-opentype',
        'ttf': 'application/x-font-ttf',
        'eot': 'application/vnd.ms-fontobject',
        'sfnt': 'application/font-sfnt',
        'svg': 'image/svg+xml'
      };
      var extensions = Object.keys(supportedFormats);
      for (var i = 0; i < extensions.length; ++i) {
        var extension = extensions[i];
        // TODO: This is not bullet proof, it needs to handle edge cases...
        if (fontUrl.indexOf('.' + extension) > 0) {
          return supportedFormats[extension];
        }
      }

      // If you see this error message, you probably need to update code above.
      console.error('Unknown font format for ' + fontUrl+ '; Fonts may not be working correctly');
      return 'application/octet-stream';
    }

    function processFontQueue(queue) {
      if (queue.length > 0) {
        // load fonts one by one until we have anything in the queue:
        var font = queue.pop();
        processNext(font);
      } else {
        // no more fonts to load.
        cssLoadedCallback(css);
      }

      function processNext(font) {
        // TODO: This could benefit from caching.
        var oReq = new XMLHttpRequest();
        oReq.addEventListener('load', fontLoaded);
        oReq.addEventListener('error', transferFailed);
        oReq.addEventListener('abort', transferFailed);
        oReq.open('GET', font.url);
        oReq.responseType = 'arraybuffer';
        oReq.send();

        function fontLoaded() {
          // TODO: it may be also worth to wait until fonts are fully loaded before
          // attempting to rasterize them. (e.g. use https://developer.mozilla.org/en-US/docs/Web/API/FontFaceSet )
          var fontBits = oReq.response;
          var fontInBase64 = arrayBufferToBase64(fontBits);
          updateFontStyle(font, fontInBase64);
        }

        function transferFailed(e) {
          console.warn('Failed to load font from: ' + font.url);
          console.warn(e)
          css += font.text + '\n';
          processFontQueue();
        }

        function updateFontStyle(font, fontInBase64) {
          var dataUrl = 'url("data:' + font.format + ';base64,' + fontInBase64 + '")';
          css += font.text.replace(font.fontUrlRegexp, dataUrl) + '\n';

          // schedule next font download on next tick.
          setTimeout(function() {
            processFontQueue(queue)
          }, 0);
        }

      }
    }

    function arrayBufferToBase64(buffer) {
      var binary = '';
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;

      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
      }

      return window.btoa(binary);
    }
  }

  function getDimension(el, clone, dim) {
    var v = (el.viewBox && el.viewBox.baseVal && el.viewBox.baseVal[dim]) ||
      (clone.getAttribute(dim) !== null && !clone.getAttribute(dim).match(/%$/) && parseInt(clone.getAttribute(dim))) ||
      el.getBoundingClientRect()[dim] ||
      parseInt(clone.style[dim]) ||
      parseInt(window.getComputedStyle(el).getPropertyValue(dim));
    return (typeof v === 'undefined' || v === null || isNaN(parseFloat(v))) ? 0 : v;
  }

  function reEncode(data) {
    data = encodeURIComponent(data);
    data = data.replace(/%([0-9A-F]{2})/g, function(match, p1) {
      var c = String.fromCharCode('0x'+p1);
      return c === '%' ? '%25' : c;
    });
    return decodeURIComponent(data);
  }

  out$.prepareSvg = function(el, options, cb) {
    requireDomNode(el);

    options = options || {};
    options.scale = options.scale || 1;
    options.responsive = options.responsive || false;
    var xmlns = "http://www.w3.org/2000/xmlns/";

    inlineImages(el, function() {
      var outer = document.createElement("div");
      var clone = el.cloneNode(true);
      var width, height;
      if(el.tagName == 'svg') {
        width = options.width || getDimension(el, clone, 'width');
        height = options.height || getDimension(el, clone, 'height');
      } else if(el.getBBox) {
        var box = el.getBBox();
        width = box.x + box.width;
        height = box.y + box.height;
        clone.setAttribute('transform', clone.getAttribute('transform').replace(/translate\(.*?\)/, ''));

        var svg = document.createElementNS('http://www.w3.org/2000/svg','svg')
        svg.appendChild(clone)
        clone = svg;
      } else {
        console.error('Attempted to render non-SVG element', el);
        return;
      }

      clone.setAttribute("version", "1.1");
      if (!clone.getAttribute('xmlns')) {
        clone.setAttributeNS(xmlns, "xmlns", "http://www.w3.org/2000/svg");
      }
      if (!clone.getAttribute('xmlns:xlink')) {
        clone.setAttributeNS(xmlns, "xmlns:xlink", "http://www.w3.org/1999/xlink");
      }

      if (options.responsive) {
        clone.removeAttribute('width');
        clone.removeAttribute('height');
        clone.setAttribute('preserveAspectRatio', 'xMinYMin meet');
      } else {
        clone.setAttribute("width", width * options.scale);
        clone.setAttribute("height", height * options.scale);
      }

      clone.setAttribute("viewBox", [
        options.left || 0,
        options.top || 0,
        width,
        height
      ].join(" "));

      var fos = clone.querySelectorAll('foreignObject > *');
      for (var i = 0; i < fos.length; i++) {
        if (!fos[i].getAttribute('xmlns')) {
          fos[i].setAttributeNS(xmlns, "xmlns", "http://www.w3.org/1999/xhtml");
        }
      }

      outer.appendChild(clone);

      // In case of custom fonts we need to fetch font first, and then inline
      // its url into data-uri format (encode as base64). That's why style
      // processing is done asynchonously. Once all inlining is finshed
      // cssLoadedCallback() is called.
      styles(el, options, cssLoadedCallback);

      function cssLoadedCallback(css) {
        // here all fonts are inlined, so that we can render them properly.
        var s = document.createElement('style');
        s.setAttribute('type', 'text/css');
        s.innerHTML = "<![CDATA[\n" + css + "\n]]>";
        var defs = document.createElement('defs');
        defs.appendChild(s);
        clone.insertBefore(defs, clone.firstChild);

        if (cb) {
          var outHtml = outer.innerHTML;
          outHtml = outHtml.replace(/NS\d+:href/gi, 'xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href');
          cb(outHtml, width, height);
        }
      }
    });
  }

  out$.svgAsDataUri = function(el, options, cb) {
    out$.prepareSvg(el, options, function(svg) {
      var uri = 'data:image/svg+xml;base64,' + window.btoa(reEncode(doctype + svg));
      if (cb) {
        cb(uri);
      }
    });
  }

  out$.svgAsPngUri = function(el, options, cb) {
    requireDomNode(el);

    options = options || {};
    options.encoderType = options.encoderType || 'image/png';
    options.encoderOptions = options.encoderOptions || 0.8;

    var convertToPng = function(src, w, h) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = w;
      canvas.height = h;

      if(options.canvg) {
        options.canvg(canvas, src);
      } else {
        context.drawImage(src, 0, 0);
      }

      if(options.backgroundColor){
        context.globalCompositeOperation = 'destination-over';
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
      }

      var png;
      try {
        png = canvas.toDataURL(options.encoderType, options.encoderOptions);
      } catch (e) {
        if ((typeof SecurityError !== 'undefined' && e instanceof SecurityError) || e.name == "SecurityError") {
          console.error("Rendered SVG images cannot be downloaded in this browser.");
          return;
        } else {
          throw e;
        }
      }
      cb(png);
    }

    if(options.canvg) {
      out$.prepareSvg(el, options, convertToPng);
    } else {
      out$.svgAsDataUri(el, options, function(uri) {
        var image = new Image();

        image.onload = function() {
          convertToPng(image, image.width, image.height);
        }

        image.onerror = function() {
          console.error(
            'There was an error loading the data URI as an image on the following SVG\n',
            window.atob(uri.slice(26)), '\n',
            "Open the following link to see browser's diagnosis\n",
            uri);
        }

        image.src = uri;
      });
    }
  }

  out$.download = function(name, uri) {
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(uriToBlob(uri), name);
    } else {
      var saveLink = document.createElement('a');
      var downloadSupported = 'download' in saveLink;
      if (downloadSupported) {
        saveLink.download = name;
        saveLink.style.display = 'none';
        document.body.appendChild(saveLink);
        try {
          var blob = uriToBlob(uri);
          var url = URL.createObjectURL(blob);
          saveLink.href = url;
          saveLink.onclick = function() {
            requestAnimationFrame(function() {
              URL.revokeObjectURL(url);
            })
          };
        } catch (e) {
          console.warn('This browser does not support object URLs. Falling back to string URL.');
          saveLink.href = uri;
        }
        saveLink.click();
        document.body.removeChild(saveLink);
      }
      else {
        window.open(uri, '_temp', 'menubar=no,toolbar=no,status=no');
      }
    }
  }

  function uriToBlob(uri) {
    var byteString = window.atob(uri.split(',')[1]);
    var mimeString = uri.split(',')[0].split(':')[1].split(';')[0]
    var buffer = new ArrayBuffer(byteString.length);
    var intArray = new Uint8Array(buffer);
    for (var i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([buffer], {type: mimeString});
  }

  out$.saveSvg = function(el, name, options) {
    requireDomNode(el);

    options = options || {};
    out$.svgAsDataUri(el, options, function(uri) {
      out$.download(name, uri);
    });
  }

  out$.saveSvgAsPng = function(el, name, options) {
    requireDomNode(el);

    options = options || {};
    out$.svgAsPngUri(el, options, function(uri) {
      out$.download(name, uri);
    });
  }

  // if define is defined create as an AMD module
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return out$;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }

})();


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_scale__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_save_svg_as_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_csvdownload__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var d3 = __webpack_require__(40);

var Opath = __WEBPACK_IMPORTED_MODULE_7_redux_tooltip__["Origin"].wrapBy('path');
var Oline = __WEBPACK_IMPORTED_MODULE_7_redux_tooltip__["Origin"].wrapBy('line');

var INCLUDED_TOPICS = ['ETIA01', 'ETIA02', 'ETIB03', 'ETIC04', 'ETIC05', 'ETIC06', 'ETID07'];

var BubbleAndBarChart = function (_React$PureComponent) {
  _inherits(BubbleAndBarChart, _React$PureComponent);

  function BubbleAndBarChart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BubbleAndBarChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BubbleAndBarChart.__proto__ || Object.getPrototypeOf(BubbleAndBarChart)).call.apply(_ref, [this].concat(args))), _this), _this.downloadPng = function (e) {
      var countryCode = _this.props.countryCode;

      var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);
      var dk = node.querySelector(".download-links");
      dk.classList.add("hide");
      var donly = node.querySelector(".download-only");
      if (donly) {
        donly.classList.remove("hide");
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__["saveSvgAsPng"])(node, countryCode + '-circle-bars.png', { backgroundColor: '#fff' });
      dk.classList.remove("hide");
      if (donly) {
        donly.classList.add("hide");
      }
    }, _this.downloadCsv = function (e) {
      var countryCode = _this.props.countryCode;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_csvdownload__["a" /* getCsvFile */])(countryCode + '-seven-pillars.csv', [countryCode], ['ETI'].concat(INCLUDED_TOPICS));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BubbleAndBarChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          countries = _props.countries,
          indicators = _props.indicators,
          latestDataByIndicator = _props.latestDataByIndicator,
          countryCode = _props.countryCode,
          _props$borderColor = _props.borderColor,
          borderColor = _props$borderColor === undefined ? '#0D66A5' : _props$borderColor,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? 40 : _props$margin,
          _props$innerFraction = _props.innerFraction,
          innerFraction = _props$innerFraction === undefined ? 0.20 : _props$innerFraction,
          _props$includedTopics = _props.includedTopics,
          includedTopics = _props$includedTopics === undefined ? INCLUDED_TOPICS : _props$includedTopics,
          _props$yellowTopic = _props.yellowTopic,
          yellowTopic = _props$yellowTopic === undefined ? 'ETIB03' : _props$yellowTopic,
          _props$circleTopic = _props.circleTopic,
          circleTopic = _props$circleTopic === undefined ? 'ETI' : _props$circleTopic,
          _props$showCountryLab = _props.showCountryLabel,
          showCountryLabel = _props$showCountryLab === undefined ? true : _props$showCountryLab,
          _props$showDownloads = _props.showDownloads,
          showDownloads = _props$showDownloads === undefined ? false : _props$showDownloads,
          _props$height = _props.height,
          height = _props$height === undefined ? null : _props$height,
          containerWidth = _props.containerWidth;


      var width = 800 - margin * 2;
      var maxRadius = Number(width / 2);
      var minRadius = maxRadius * innerFraction;

      var sector = Math.PI / (includedTopics.length + 1);
      var chartHeight = height === null ? containerWidth : height;

      var gridScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["a" /* scaleLinear */])().range([minRadius, maxRadius]).domain([0, 7]);

      var gridValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["range"])(0, 8);
      var arcs = gridValues.map(function (value) {
        return d3.arc().startAngle(-Math.PI / 2).endAngle(Math.PI / 2).innerRadius(minRadius).outerRadius(gridScale(value));
      });

      var center = [800 / 2, 800 / 2 + 800 / 6];
      var countryValues = includedTopics.map(function (topic) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(latestDataByIndicator[topic][countryCode], 'v', 0);
      }
      //const minCountryValue = min(countryValues)
      // const avgCountryValue = mean(countryValues)
      );var avgCountryValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(latestDataByIndicator[circleTopic][countryCode], 'v', 0);
      var avgArc = d3.arc().startAngle(-Math.PI / 2).endAngle(Math.PI / 2).innerRadius(minRadius).outerRadius(gridScale(avgCountryValue));
      var minArc = d3.arc().startAngle(-Math.PI / 2).endAngle(Math.PI / 2).innerRadius(minRadius - 10).outerRadius(minRadius - 2);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { className: 'BubbleAndBarChart__svg', viewBox: '0 0 800 800',
          style: { border: borderColor ? 'solid ' + borderColor + ' 1px' : undefined },
          height: chartHeight, width: containerWidth },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + margin + ', ' + margin + ')', className: '' + (showCountryLabel ? '' : 'hide download-only') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2, className: 'BubbleAndBarChart__country_label' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["d" /* Link */],
              { to: '//countries/' + countryCode },
              countries[countryCode]
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + margin + ', ' + (800 - margin / 2) + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { className: 'BubbleAndBarChart__source_label' },
            'Source: Global Alliance for Trade Facilitation / World Economic Forum; Enabling Trade Index'
          )
        ),
        showDownloads && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { className: 'download-links', transform: 'translate(' + margin + ', ' + margin + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2, className: 'SunBurstChart__download_title' },
            'DOWNLOAD'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2 + 40 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              { className: 'SunBurstChart__download_label pointer', onClick: this.downloadCsv },
              'CSV'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              null,
              '\xA0\xA0\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              { className: 'SunBurstChart__download_label pointer', onClick: this.downloadPng },
              'VIZ'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + center[0] + ', ' + center[1] + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Opath, { content: indicators[circleTopic].shortTitle + ': ' + avgCountryValue.toFixed(2), d: avgArc(), className: 'BubbleAndBarChart__average' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + center[0] + ', ' + center[1] + ')' },
          arcs.map(function (arc, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { key: i, d: arc(), className: 'BubbleAndBarChart__grid' });
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + center[0] + ', ' + (center[1] + 24) + ')' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["range"])(1, 8).map(function (value) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { key: value, className: 'BubbleAndBarChart__axis_label', x: gridScale(value) },
              value
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          includedTopics.map(function (topic, i) {
            var datum = countryValues[i];
            var scaledDatum = gridScale(datum);
            var angle = -Math.PI / 2 + sector * (i + 1);
            var x = Math.sin(angle);
            var y = Math.cos(angle);
            var x1 = center[0] + x * minRadius;
            var y1 = center[1] - y * minRadius;
            var x2 = center[0] + x * maxRadius;
            var y2 = center[1] - y * maxRadius;

            var x2v = center[0] + x * scaledDatum;
            var y2v = center[1] - y * scaledDatum;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'g',
              { key: topic },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', { x1: x1, y1: y1, x2: x2, y2: y2, className: 'BubbleAndBarChart__grid--radial' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Oline, { x1: x1, y1: y1, x2: x2v, y2: y2v,
                content: indicators[topic].shortTitle + ': ' + datum,
                className: '' + (topic === yellowTopic ? 'BubbleAndBarChart__bars--orange' : 'BubbleAndBarChart__bars--blue') })
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + center[0] + ', ' + center[1] + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: minArc(), className: 'BubbleAndBarChart__min_arc' })
        )
      );
    }
  }]);

  return BubbleAndBarChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    countries: state.countries,
    indicators: state.indicators
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4_react_dimensions___default()()(BubbleAndBarChart)));

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_geo__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_topojson_client__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_scale__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BubbleAndBarChart__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_save_svg_as_png__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_save_svg_as_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_save_svg_as_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_csvdownload__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var worldData = __webpack_require__(585);
var worldFeatures = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_topojson_client__["a" /* feature */])(worldData, worldData.objects.countries).features;
var Gpath = __WEBPACK_IMPORTED_MODULE_9_redux_tooltip__["Origin"].wrapBy('path');

var MapChart = function (_React$PureComponent) {
  _inherits(MapChart, _React$PureComponent);

  function MapChart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MapChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapChart.__proto__ || Object.getPrototypeOf(MapChart)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectCountry = function (countryCode) {
      return function (e) {
        if (!_this.props.topic || _this.props.interactive === false) {
          return;
        }
        _this.props.setSelectedCountry(countryCode);
        if (countryCode === null) {
          _this.props.setComparisonCountry(null);
        }
      };
    }, _this.downloadPng = function (e) {
      var topic = _this.props.topic;

      var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this).querySelector('svg');
      var dk = node.querySelector(".download-links");
      dk.classList.add("hide");
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_save_svg_as_png__["saveSvgAsPng"])(node, (topic ? topic + "-" : '') + 'MAP.png', { backgroundColor: '#fff' });
      dk.classList.remove("hide");
    }, _this.downloadCsv = function (e) {
      var _this$props = _this.props,
          countries = _this$props.countries,
          topic = _this$props.topic,
          _this$props$tfa = _this$props.tfa,
          tfa = _this$props$tfa === undefined ? false : _this$props$tfa;

      return tfa ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_csvdownload__["a" /* getCsvFile */])(topic + '.csv', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(countries).sort(), [], [topic]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_csvdownload__["a" /* getCsvFile */])(topic + '.csv', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(countries).sort(), [topic]);
    }, _this.getTooltipContent = function (d) {
      var _this$props2 = _this.props,
          countries = _this$props2.countries,
          topic = _this$props2.topic,
          dataMap = _this$props2.dataMap,
          _this$props2$tfa = _this$props2.tfa,
          tfa = _this$props2$tfa === undefined ? false : _this$props2$tfa;

      if (tfa) {
        return countries[d.id] ? countries[d.id] + ' ' + (topic ? ": " + (dataMap[d.id] || "no data") : '') : 'no data';
      }
      return countries[d.id] ? countries[d.id] + ' ' + (topic ? ": " + (dataMap[d.id] || "no data") : '') : 'no data';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MapChart, [{
    key: 'projection',
    value: function projection() {
      var _props$height = this.props.height,
          height = _props$height === undefined ? 300 : _props$height;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_geo__["a" /* geoMercator */])().scale(100).translate([800 / 2, height / 2]);
    }
  }, {
    key: 'getFillOpacity',
    value: function getFillOpacity(d, scale) {
      var _props = this.props,
          emptyFill = _props.emptyFill,
          dataMap = _props.dataMap;

      if (dataMap[d.id]) {
        var out = scale(dataMap[d.id]);
        return out;
      }
      return emptyFill ? 1 : 0;
    }
  }, {
    key: 'getFill',
    value: function getFill(d, scale) {
      var _props2 = this.props,
          dataMap = _props2.dataMap,
          _props2$fill = _props2.fill,
          fill = _props2$fill === undefined ? "#0D66A5" : _props2$fill,
          emptyFill = _props2.emptyFill;

      if (dataMap[d.id] !== undefined) {
        return fill;
      }
      return emptyFill || 'transparent';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          latestDataByIndicator = _props3.latestDataByIndicator,
          height = _props3.height,
          dataMap = _props3.dataMap,
          _props3$stroke = _props3.stroke,
          stroke = _props3$stroke === undefined ? "#0D66A5" : _props3$stroke,
          _props3$borderColor = _props3.borderColor,
          borderColor = _props3$borderColor === undefined ? '#0D66A5' : _props3$borderColor,
          maxScale = _props3.maxScale,
          minScale = _props3.minScale,
          _props3$decreasing = _props3.decreasing,
          decreasing = _props3$decreasing === undefined ? false : _props3$decreasing,
          selectedCountry = _props3.selectedCountry,
          comparisonCountry = _props3.comparisonCountry,
          _props3$showDownloads = _props3.showDownloads,
          showDownloads = _props3$showDownloads === undefined ? false : _props3$showDownloads;


      var dataValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["values"])(dataMap);
      var margin = 10;
      var maxValue = maxScale || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["max"])(dataValues
      // # TODO: should we use minValue?
      // let minValue = minScale || min(dataValues)
      );var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_d3_scale__["a" /* scaleLinear */])().domain([0, maxValue]).range(decreasing ? [1, 0] : [0, 1]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: 'relative' } },
        selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MapChart__chart_container', onClick: this.handleSelectCountry(null) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'MapChart__overlay border-blue' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + (comparisonCountry ? 'MapChart__overlay__box--double' : 'MapChart__overlay__box'),
                onClick: function onClick(e) {
                  e.stopPropagation();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BubbleAndBarChart__["a" /* default */], { latestDataByIndicator: latestDataByIndicator, countryCode: selectedCountry })
            ),
            comparisonCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'MapChart__overlay__box--double', onClick: function onClick(e) {
                  e.stopPropagation();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BubbleAndBarChart__["a" /* default */], { latestDataByIndicator: latestDataByIndicator, countryCode: comparisonCountry })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          { className: 'MapChart__svg', style: { borderColor: borderColor }, height: height, width: '100%', viewBox: '0 0 ' + 800 + ' ' + height },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            worldFeatures.map(function (d, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gpath, {
                key: 'path-' + i,
                content: _this2.getTooltipContent(d),
                d: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_geo__["b" /* geoPath */])().projection(_this2.projection())(d),
                className: 'country',
                onClick: _this2.handleSelectCountry(d.id),
                fill: _this2.getFill(d),
                fillOpacity: _this2.getFillOpacity(d, scale),
                stroke: stroke,
                strokeOpacity: 0.2,
                strokeWidth: 0.5
              });
            })
          ),
          showDownloads && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            { className: 'download-links', transform: 'translate(' + 0 + ', ' + margin + ')' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { y: margin / 2, className: 'MapChart__download_title' },
              'DOWNLOAD'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { y: margin / 2 + 20 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tspan',
                { className: 'MapChart__download_label pointer', onClick: this.downloadCsv },
                'CSV'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tspan',
                null,
                '\xA0\xA0'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tspan',
                { className: 'MapChart__download_label pointer', onClick: this.downloadPng },
                'VIZ'
              )
            )
          )
        )
      );
    }
  }]);

  return MapChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    countries: state.countries,
    selectedCountry: state.selectedCountry,
    comparisonCountry: state.comparisonCountry
  };
};

var mapDispatchToProps = { setSelectedCountry: __WEBPACK_IMPORTED_MODULE_7__state_actions__["B" /* setSelectedCountry */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_7__state_actions__["A" /* setComparisonCountry */] };

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MapChart));

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Modal = function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.openModal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.closeModal();
    }
  }, {
    key: 'render',
    value: function render() {
      var close = this.props.close;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'vh-100 dt w-100 viz-modal', onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'viz-modal-body h-container', onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dib viz-modal-close pointer', onClick: close },
            'x'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'h-100', style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            this.props.children
          )
        )
      );
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapDispatchToProps = {
  openModal: __WEBPACK_IMPORTED_MODULE_2__state_actions__["G" /* openModal */], closeModal: __WEBPACK_IMPORTED_MODULE_2__state_actions__["H" /* closeModal */]
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, mapDispatchToProps)(Modal));

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SelectedCountryInput__ = __webpack_require__(255);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    selectedCountry: state.selectedCountry,
    selectedCountryData: state.selectedCountryData,
    comparisonCountry: state.comparisonCountry,
    comparisonCountryData: state.comparisonCountryData
  };
};

var mapDispatchToProps = { setSelectedCountry: __WEBPACK_IMPORTED_MODULE_2__state_actions__["B" /* setSelectedCountry */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_2__state_actions__["A" /* setComparisonCountry */] };

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(function (_React$PureComponent) {
  _inherits(_class2, _React$PureComponent);

  function _class2() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectCountry = function (countryCode) {
      return function (e) {
        _this.props.setSelectedCountry(countryCode);
        if (countryCode === null && _this.props.comparisonCountry) {
          _this.props.setSelectedCountry(_this.props.comparisonCountry);
          _this.props.setComparisonCountry(null);
        }
      };
    }, _this.handleSelectComparisonCountry = function (countryCode) {
      return function (e) {
        _this.props.setComparisonCountry(countryCode);
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class2, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          setSelectedCountry = _props.setSelectedCountry,
          setComparisonCountry = _props.setComparisonCountry,
          countries = _props.countries,
          selectedCountry = _props.selectedCountry,
          comparisonCountry = _props.comparisonCountry;


      var countryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(countries);
      var countryItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(countryCodes.map(function (code) {
        return { label: countries[code], value: code };
      }), 'label');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pv3 cf mb2 mt3' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'text-blue' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'small',
              null,
              'SELECT COUNTRY'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            selectedCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SelectedCountryInput__["a" /* default */], {
              countries: countries,
              inputProps: { className: "CountrySelector__Autocomplete--lower background-blue" },
              items: countryItems,
              selectCountry: setSelectedCountry,
              selectedCountry: selectedCountry }),
            selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf', style: { paddingTop: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { cursor: 'pointer' }, className: 'fl', onClick: this.handleSelectCountry(null) },
                'x'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'fl' },
                countries[selectedCountry]
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'text-orange mt4 cf' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'small',
              null,
              'COMPARE WITH'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            comparisonCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SelectedCountryInput__["a" /* default */], {
              countries: countries,
              inputProps: { className: "CountrySelector__Autocomplete--lower border-orange" },
              items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(countryItems.filter(function (item) {
                return item.value !== selectedCountry;
              }), 'label'),
              selectCountry: setComparisonCountry,
              selectedCountry: comparisonCountry }),
            comparisonCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { cursor: 'pointer' }, className: 'fl', onClick: this.handleSelectComparisonCountry(null) },
                'x'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'fl' },
                countries[comparisonCountry]
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cf' })
      );
    }
  }]);

  return _class2;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent)));

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrendChart__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TrendChartTFAArticle__ = __webpack_require__(256);





var SideCountryTrends = function SideCountryTrends(_ref) {
  var countries = _ref.countries,
      indicators = _ref.indicators,
      selectedCountry = _ref.selectedCountry,
      selectedCountryData = _ref.selectedCountryData,
      comparisonCountry = _ref.comparisonCountry,
      comparisonCountryData = _ref.comparisonCountryData,
      _ref$indicatorsList = _ref.indicatorsList,
      indicatorsList = _ref$indicatorsList === undefined ? [] : _ref$indicatorsList,
      _ref$tfaArticlesList = _ref.tfaArticlesList,
      tfaArticlesList = _ref$tfaArticlesList === undefined ? [] : _ref$tfaArticlesList,
      tfaArticles = _ref.tfaArticles,
      _ref$tfaArticlesDescr = _ref.tfaArticlesDescriptions,
      tfaArticlesDescriptions = _ref$tfaArticlesDescr === undefined ? {} : _ref$tfaArticlesDescr,
      tfaMeta = _ref.tfaMeta;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'w-100 mb5' },
    selectedCountryData.data && indicatorsList.map(function (indicator) {
      if (comparisonCountryData && comparisonCountryData.data) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indicator.globalId },
          indicator.shortTitle,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TrendChart__["a" /* default */], {
            indicatorData: indicator,
            countryCode: selectedCountry,
            dataByCountry: selectedCountryData.data[indicator.globalId],
            comparisonCountryCode: comparisonCountry,
            comparisonDataByCountry: comparisonCountryData.data[indicator.globalId]
          })
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indicator.globalId },
          indicator.shortTitle,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TrendChart__["a" /* default */], {
            indicatorData: indicator,
            countryCode: selectedCountry,
            dataByCountry: selectedCountryData.data[indicator.globalId]
          })
        );
      }
    }),
    true && tfaArticlesList.map(function (indicator) {
      var max = tfaMeta[indicator].max;

      if (comparisonCountryData && comparisonCountryData.data) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indicator, className: 'border-bottom-blue' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'mb2 mt2' },
            'TFA article ',
            indicator,
            ': ',
            tfaArticlesDescriptions[indicator]
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TrendChartTFAArticle__["a" /* default */], {
            tfaArticle: indicator,
            countryCode: selectedCountry,
            dataByCountry: tfaArticles[indicator][selectedCountry],
            comparisonCountryCode: comparisonCountry,
            valueMax: max,
            comparisonDataByCountry: tfaArticles[indicator][comparisonCountry]
          })
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: indicator, className: 'border-bottom-blue' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'mb2 mt2' },
            'TFA article ',
            indicator,
            ': ',
            tfaArticlesDescriptions[indicator]
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TrendChartTFAArticle__["a" /* default */], {
            tfaArticle: indicator,
            indicatorData: indicator,
            countryCode: selectedCountry,
            valueMax: max,
            dataByCountry: tfaArticles[indicator][selectedCountry]
          })
        );
      }
    })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    selectedCountry: state.selectedCountry,
    selectedCountryData: state.selectedCountryData,
    comparisonCountry: state.comparisonCountry,
    comparisonCountryData: state.comparisonCountryData
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(SideCountryTrends));

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);



var Spinner = function Spinner(_ref) {
  var _ref$fullpage = _ref.fullpage,
      fullpage = _ref$fullpage === undefined ? false : _ref$fullpage;

  return fullpage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: {
        height: '100%',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 999999,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { zIndex: 9999999, color: 'white' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'sk-wave' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect1' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect2' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect3' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect4' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect5' })
      )
    )
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { paddingTop: 50, textAlign: 'center' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'sk-wave' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect1' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect2' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect3' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect4' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sk-rect sk-rect5' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var d3 = __webpack_require__(40);
var Ocircle = __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__["Origin"].wrapBy('circle');

var makeTrend = function makeTrend(indicatorData, years, dataByCountry, numYears, containerWidth, height, margin) {

  var plotData = years.map(function (year) {
    return dataByCountry && dataByCountry[year] ? Object.assign({
      year: year
    }, dataByCountry[year]) : null;
  });

  var yearWidth = (containerWidth - margin * 2) / numYears;
  //SCALE direction depends on indicator "rankDirection"
  var rangeForIndicator = void 0;
  if (indicatorData.rankDirection === "1") {
    rangeForIndicator = [margin, height - margin * 2];
  } else {
    rangeForIndicator = [height - margin * 2, margin];
  }

  var scale = d3.scaleLinear().domain(indicatorData.domain).range(rangeForIndicator);
  var trendLines = plotData.reduce(function (accumulator, currentValue, currentIndex) {
    if (currentIndex === plotData.length) {
      return accumulator;
    }
    if (currentValue !== null) {
      var nextIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["findIndex"])(plotData, function (item, i) {
        return i > currentIndex && item;
      });
      if (nextIndex !== -1) {
        accumulator.push({
          x1: margin + currentIndex * yearWidth, y1: scale(currentValue.v),
          x2: margin + nextIndex * yearWidth, y2: scale(plotData[nextIndex].v),
          virtual: nextIndex > currentIndex + 1
        });
      }
    }
    return accumulator;
  }, []);

  return { plotData: plotData, trendLines: trendLines, yearWidth: yearWidth, scale: scale };
};

var TrendChart = function (_React$PureComponent) {
  _inherits(TrendChart, _React$PureComponent);

  function TrendChart() {
    _classCallCheck(this, TrendChart);

    return _possibleConstructorReturn(this, (TrendChart.__proto__ || Object.getPrototypeOf(TrendChart)).apply(this, arguments));
  }

  _createClass(TrendChart, [{
    key: 'render',
    value: function render() {

      //const { dataByCountry, countryCode, indicatorData, height=50, numYears=7, containerWidth } = this.props
      var _props = this.props,
          countries = _props.countries,
          indicatorData = _props.indicatorData,
          _props$height = _props.height,
          height = _props$height === undefined ? 50 : _props$height,
          containerWidth = _props.containerWidth,
          _props$showScores = _props.showScores,
          showScores = _props$showScores === undefined ? true : _props$showScores,
          _props$numYears = _props.numYears,
          numYears = _props$numYears === undefined ? 7 : _props$numYears,
          countryCode = _props.countryCode,
          dataByCountry = _props.dataByCountry,
          _props$comparisonCoun = _props.comparisonCountryCode,
          comparisonCountryCode = _props$comparisonCoun === undefined ? null : _props$comparisonCoun,
          _props$comparisonData = _props.comparisonDataByCountry,
          comparisonDataByCountry = _props$comparisonData === undefined ? null : _props$comparisonData;


      if (!indicatorData.domain) {
        return null;
      }

      var existingYearsCountry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(dataByCountry);
      var existingYearsComparisonCountry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(comparisonDataByCountry);

      var existingYears = existingYearsCountry.length ? existingYearsCountry : existingYearsComparisonCountry.length ? existingYearsComparisonCountry : [];
      var maxYearCountry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(existingYearsCountry.map(function (i) {
        return parseInt(i, 10);
      }));
      var maxYearComparisonCountry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(existingYearsComparisonCountry.map(function (i) {
        return parseInt(i, 10);
      }));

      var maxValueCountry = dataByCountry ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(dataByCountry, '[' + maxYearCountry + '].v') : null;
      var maxValueComparisonCountry = comparisonDataByCountry ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(comparisonDataByCountry, '[' + maxYearComparisonCountry + '].v') : null;

      var margin = 4;
      var maxYear = void 0,
          years = void 0;

      if (!existingYears.length) {
        maxYear = 2016;
      } else {
        maxYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(existingYears.map(function (i) {
          return parseInt(i, 10);
        }));
      }
      years = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["range"])(maxYear - numYears + 1, maxYear + 1).map(function (i) {
        return i.toString();
      });

      var comparisonPlotData = [],
          comparisonTrendLines = [];

      var _makeTrend = makeTrend(indicatorData, years, dataByCountry, numYears, containerWidth, height, margin),
          plotData = _makeTrend.plotData,
          trendLines = _makeTrend.trendLines,
          yearWidth = _makeTrend.yearWidth,
          scale = _makeTrend.scale;

      if (comparisonCountryCode && comparisonDataByCountry) {
        var comparisonData = makeTrend(indicatorData, years, comparisonDataByCountry, numYears, containerWidth, height, margin);
        comparisonPlotData = comparisonData.plotData;
        comparisonTrendLines = comparisonData.trendLines;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { height: height, className: 'TrendChart__svg' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          years.map(function (year, i) {
            return i < years.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { key: year, height: height - margin * 2, width: yearWidth, x: margin + i * yearWidth, y: margin, className: 'rect-grid' });
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          trendLines.map(function (trendLine, i) {
            var lineAttrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(trendLine, ['virtual']);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', Object.assign({ key: i }, lineAttrs, { className: 'trend-line ' + (trendLine.virtual ? 'virtual' : '') }));
          })
        ),
        comparisonCountryCode && comparisonDataByCountry && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          comparisonTrendLines.map(function (trendLine, i) {
            var lineAttrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(trendLine, ['virtual']);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', Object.assign({ key: i }, lineAttrs, { className: 'trend-line-comparison ' + (trendLine.virtual ? 'virtual' : '') }));
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          plotData.map(function (datum, i) {
            return datum && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ocircle, {
              key: i, r: 3, cx: margin + i * yearWidth, cy: scale(datum.v),
              className: 'circle-datum', content: countries[countryCode] + ': ' + datum.v + ' (' + datum.year + ')' });
          })
        ),
        comparisonCountryCode && comparisonDataByCountry && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          comparisonPlotData.map(function (datum, i) {
            return datum && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ocircle, {
              key: i, r: 3, cx: margin + i * yearWidth, cy: scale(datum.v),
              className: 'circle-datum-comparison', content: countries[comparisonCountryCode] + ': ' + datum.v + ' (' + datum.year + ')' });
          })
        ),
        showScores && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + (yearWidth * (numYears - 1) + yearWidth / 2 - margin * 2) + ' ,0)' },
          maxValueCountry !== null && maxValueComparisonCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { y: height / 2 + margin, className: 'TrendChart__score_country' },
              maxValueCountry
            )
          ),
          maxValueCountry !== null && maxValueComparisonCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { y: height / 3 + margin, className: 'TrendChart__score_country--multi' },
              maxValueCountry
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { y: height / 3 * 2 + margin, className: 'TrendChart__score_comparison' },
              maxValueComparisonCountry
            )
          )
        )
      );
    }
  }]);

  return TrendChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    //dataByCountry : getTrendDataByCountryAndIndicator(state, props),
    //indicators: state.indicators,
    countries: state.countries
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3_react_dimensions___default()()(TrendChart)));

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_autocomplete__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    selectedCountry: state.selectedCountry,
    colorMode: state.colorMode,
    countryMode: state.countryMode
  };
};

var mapDispatchToProps = { setSelectedCountry: __WEBPACK_IMPORTED_MODULE_6__state_actions__["B" /* setSelectedCountry */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_6__state_actions__["A" /* setComparisonCountry */], setColorMode: __WEBPACK_IMPORTED_MODULE_6__state_actions__["E" /* setColorMode */], setCountryMode: __WEBPACK_IMPORTED_MODULE_6__state_actions__["F" /* setCountryMode */] };

var menuStyle = {
  backgroundColor: 'none',
  padding: '2px 0',
  position: 'fixed',
  overflow: 'auto',
  maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
  color: "#222"
};

var CountrySelector = function (_React$Component) {
  _inherits(CountrySelector, _React$Component);

  function CountrySelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CountrySelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountrySelector.__proto__ || Object.getPrototypeOf(CountrySelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CountrySelector, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          countries = _props.countries,
          setSelectedCountry = _props.setSelectedCountry,
          selectedCountry = _props.selectedCountry;

      var value = selectedCountry ? countries[selectedCountry] : this.state.value;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_autocomplete___default.a, {
        inputProps: { className: "CountrySelector__Autocomplete background-blue w-100 bb", placeholder: "Search for a country" },
        wrapperProps: { className: "w-100" },
        menuStyle: menuStyle,
        getItemValue: function getItemValue(item) {
          return item.value;
        },
        items: items,
        shouldItemRender: function shouldItemRender(item, value) {
          return item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        renderItem: function renderItem(item, isHighlighted) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'background-blue text-white pa1'
              //  style={{ background: isHighlighted ? 'lightgray' : '#222' }}
            },
            item.label
          );
        },
        value: value,
        onChange: function onChange(e) {
          return _this2.setState({ value: e.target.value });
        },
        onSelect: function onSelect(val) {
          setSelectedCountry(val);
        }

      });
    }
  }]);

  return CountrySelector;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var CountrySelectorConnected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CountrySelector);

var colorModeOptions = [{ value: 'performance', label: 'Performance' }, { value: 'continent', label: 'Continent' }];

var countryModeOptions = [{ value: 'all', label: 'All countries' }, { value: 'top', label: 'Top 25' }, { value: 'bottom', label: 'Last 25' }];

var countryModeOptionsSort = [{ value: 'all', label: 'Alphabetically' }, { value: 'top', label: 'Best first' }, { value: 'bottom', label: 'Worst first' }];

var TrendFacilitationHeader = function (_React$Component2) {
  _inherits(TrendFacilitationHeader, _React$Component2);

  function TrendFacilitationHeader() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, TrendFacilitationHeader);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = TrendFacilitationHeader.__proto__ || Object.getPrototypeOf(TrendFacilitationHeader)).call.apply(_ref2, [this].concat(args))), _this3), _this3.handleColorModeChange = function (item) {
      _this3.props.setColorMode(item.value);
    }, _this3.handleCountryModeChange = function (item) {
      _this3.props.setCountryMode(item.value);
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(TrendFacilitationHeader, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          selectedCountry = _props2.selectedCountry,
          countries = _props2.countries,
          setSelectedCountry = _props2.setSelectedCountry,
          setComparisonCountry = _props2.setComparisonCountry,
          colorMode = _props2.colorMode,
          setColorMode = _props2.setColorMode,
          countryMode = _props2.countryMode,
          setCountryMode = _props2.setCountryMode,
          _props2$hasShowSort = _props2.hasShowSort,
          hasShowSort = _props2$hasShowSort === undefined ? true : _props2$hasShowSort,
          _props2$showSortMode = _props2.showSortMode,
          showSortMode = _props2$showSortMode === undefined ? 'show' : _props2$showSortMode;


      if (!countries) {
        return null;
      }

      var countryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(countries);
      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(countryCodes.map(function (code) {
        return { label: countries[code], value: code };
      }), 'label');
      var showSortTitle = showSortMode === 'show' ? 'SHOW' : 'SORT';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'background-blue text-white relative' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'h-container cf TrendFacilitationHeader' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-100 w40-l' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fl w-third pa3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                'SELECT COUNTRY'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100', style: { paddingTop: 1 } },
                selectedCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountrySelectorConnected, { items: items }),
                selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { padding: '8px 0px' }, className: 'cf bb' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { cursor: 'pointer', marginRight: 5 }, className: 'fl',
                      onClick: function onClick() {
                        setSelectedCountry(null);
                        setComparisonCountry(null);
                      } },
                    'x'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'fl' },
                    countries[selectedCountry]
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fl w-third pa3' },
              'COLOUR',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select___default.a, {
                className: 'TopSelect',
                name: 'select_colormode',
                value: colorMode,
                clearable: false,
                options: colorModeOptions,
                onChange: this.handleColorModeChange
              })
            ),
            hasShowSort && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fl w-third pa3' },
              showSortTitle,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select___default.a, {
                className: 'TopSelect',
                name: 'select_countrymode',
                value: countryMode,
                clearable: false,
                options: showSortMode === 'show' ? countryModeOptions : countryModeOptionsSort,
                onChange: this.handleCountryModeChange
              })
            )
          )
        )
      );
    }
  }]);

  return TrendFacilitationHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(TrendFacilitationHeader));

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(46);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["a"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(90);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipExtent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygon__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(16);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 0 : 3
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 2 : 1
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__buffer__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_array__["i" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__polygon__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__line__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(22);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math__["a" /* pi */] / 3,
      m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__ = __webpack_require__(329);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0), n = (sy0 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(c - 2 * n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)) / n;
    return [r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x *= n), r0 - r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(r0y)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(r0y), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds__ = __webpack_require__(168);



function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */]));

  var b = __WEBPACK_IMPORTED_MODULE_1__path_bounds__["a" /* default */].result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(22);




function mercatorRaw(lambda, phi) {
  return [lambda, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
};

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math__["b" /* tau */]);
});

function mercatorProjection(project) {
  var m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math__["a" /* pi */] * scale(),
        t = m(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__rotation__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(175);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(186);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(12);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* unused harmony reexport timeThursday */
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* unused harmony reexport utcThursday */
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(566);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(583);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(34);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(434);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(8);

var _require = __webpack_require__(28),
    findDOMNode = _require.findDOMNode;

var scrollIntoView = __webpack_require__(378);

var IMPERATIVE_API = ['blur', 'checkValidity', 'click', 'focus', 'select', 'setCustomValidity', 'setSelectionRange', 'setRangeText'];

function getScrollOffset() {
  return {
    x: window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
    y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
  };
}

var Autocomplete = function (_React$Component) {
  _inherits(Autocomplete, _React$Component);

  function Autocomplete(props) {
    _classCallCheck(this, Autocomplete);

    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));

    _this.state = {
      isOpen: false,
      highlightedIndex: null
    };
    _this._debugStates = [];
    _this.exposeAPI = _this.exposeAPI.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    return _this;
  }

  _createClass(Autocomplete, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // this.refs is frozen, so we need to assign a new object to it
      this.refs = {};
      this._ignoreBlur = false;
      this._ignoreFocus = false;
      this._scrollOffset = null;
      this._scrollTimer = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._scrollTimer);
      this._scrollTimer = null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.highlightedIndex !== null) {
        this.setState(this.ensureHighlightedIndex);
      }
      if (nextProps.autoHighlight && (this.props.value !== nextProps.value || this.state.highlightedIndex === null)) {
        this.setState(this.maybeAutoCompleteText);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isOpen()) {
        this.setMenuPositions();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isOpen && !prevState.isOpen || 'open' in this.props && this.props.open && !prevProps.open) this.setMenuPositions();

      this.maybeScrollItemIntoView();
      if (prevState.isOpen !== this.state.isOpen) {
        this.props.onMenuVisibilityChange(this.state.isOpen);
      }
    }
  }, {
    key: 'exposeAPI',
    value: function exposeAPI(el) {
      var _this2 = this;

      this.refs.input = el;
      IMPERATIVE_API.forEach(function (ev) {
        return _this2[ev] = el && el[ev] && el[ev].bind(el);
      });
    }
  }, {
    key: 'maybeScrollItemIntoView',
    value: function maybeScrollItemIntoView() {
      if (this.isOpen() && this.state.highlightedIndex !== null) {
        var itemNode = this.refs['item-' + this.state.highlightedIndex];
        var menuNode = this.refs.menu;
        scrollIntoView(findDOMNode(itemNode), findDOMNode(menuNode), { onlyScrollIfNeeded: true });
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (Autocomplete.keyDownHandlers[event.key]) Autocomplete.keyDownHandlers[event.key].call(this, event);else if (!this.isOpen()) {
        this.setState({
          isOpen: true
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.props.onChange(event, event.target.value);
    }
  }, {
    key: 'getFilteredItems',
    value: function getFilteredItems(props) {
      var items = props.items;

      if (props.shouldItemRender) {
        items = items.filter(function (item) {
          return props.shouldItemRender(item, props.value);
        });
      }

      if (props.sortItems) {
        items.sort(function (a, b) {
          return props.sortItems(a, b, props.value);
        });
      }

      return items;
    }
  }, {
    key: 'maybeAutoCompleteText',
    value: function maybeAutoCompleteText(state, props) {
      var highlightedIndex = state.highlightedIndex;
      var value = props.value,
          getItemValue = props.getItemValue;

      var index = highlightedIndex === null ? 0 : highlightedIndex;
      var matchedItem = this.getFilteredItems(props)[index];
      if (value !== '' && matchedItem) {
        var itemValue = getItemValue(matchedItem);
        var itemValueDoesMatch = itemValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
        if (itemValueDoesMatch) {
          return { highlightedIndex: index };
        }
      }
      return { highlightedIndex: null };
    }
  }, {
    key: 'ensureHighlightedIndex',
    value: function ensureHighlightedIndex(state, props) {
      if (state.highlightedIndex >= this.getFilteredItems(props).length) {
        return { highlightedIndex: null };
      }
    }
  }, {
    key: 'setMenuPositions',
    value: function setMenuPositions() {
      var node = this.refs.input;
      var rect = node.getBoundingClientRect();
      var computedStyle = global.window.getComputedStyle(node);
      var marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
      var marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
      var marginRight = parseInt(computedStyle.marginRight, 10) || 0;
      this.setState({
        menuTop: rect.bottom + marginBottom,
        menuLeft: rect.left + marginLeft,
        menuWidth: rect.width + marginLeft + marginRight
      });
    }
  }, {
    key: 'highlightItemFromMouse',
    value: function highlightItemFromMouse(index) {
      this.setState({ highlightedIndex: index });
    }
  }, {
    key: 'selectItemFromMouse',
    value: function selectItemFromMouse(item) {
      var _this3 = this;

      var value = this.props.getItemValue(item);
      // The menu will de-render before a mouseLeave event
      // happens. Clear the flag to release control over focus
      this.setIgnoreBlur(false);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, function () {
        _this3.props.onSelect(value, item);
      });
    }
  }, {
    key: 'setIgnoreBlur',
    value: function setIgnoreBlur(ignore) {
      this._ignoreBlur = ignore;
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this4 = this;

      var items = this.getFilteredItems(this.props).map(function (item, index) {
        var element = _this4.props.renderItem(item, _this4.state.highlightedIndex === index, { cursor: 'default' });
        return React.cloneElement(element, {
          onMouseEnter: function onMouseEnter() {
            return _this4.highlightItemFromMouse(index);
          },
          onClick: function onClick() {
            return _this4.selectItemFromMouse(item);
          },
          ref: function ref(e) {
            return _this4.refs['item-' + index] = e;
          }
        });
      });
      var style = {
        left: this.state.menuLeft,
        top: this.state.menuTop,
        minWidth: this.state.menuWidth
      };
      var menu = this.props.renderMenu(items, this.props.value, style);
      return React.cloneElement(menu, {
        ref: function ref(e) {
          return _this4.refs.menu = e;
        },
        // Ignore blur to prevent menu from de-rendering before we can process click
        onMouseEnter: function onMouseEnter() {
          return _this4.setIgnoreBlur(true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this4.setIgnoreBlur(false);
        }
      });
    }
  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur(event) {
      if (this._ignoreBlur) {
        this._ignoreFocus = true;
        this._scrollOffset = getScrollOffset();
        this.refs.input.focus();
        return;
      }
      this.setState({
        isOpen: false,
        highlightedIndex: null
      });
      var onBlur = this.props.inputProps.onBlur;

      if (onBlur) {
        onBlur(event);
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(event) {
      var _this5 = this;

      if (this._ignoreFocus) {
        this._ignoreFocus = false;
        var _scrollOffset = this._scrollOffset,
            x = _scrollOffset.x,
            y = _scrollOffset.y;

        this._scrollOffset = null;
        // Focus will cause the browser to scroll the <input> into view.
        // This can cause the mouse coords to change, which in turn
        // could cause a new highlight to happen, cancelling the click
        // event (when selecting with the mouse)
        window.scrollTo(x, y);
        // Some browsers wait until all focus event handlers have been
        // processed before scrolling the <input> into view, so let's
        // scroll again on the next tick to ensure we're back to where
        // the user was before focus was lost. We could do the deferred
        // scroll only, but that causes a jarring split second jump in
        // some browsers that scroll before the focus event handlers
        // are triggered.
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(function () {
          _this5._scrollTimer = null;
          window.scrollTo(x, y);
        }, 0);
        return;
      }
      this.setState({ isOpen: true });
      var onFocus = this.props.inputProps.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    }
  }, {
    key: 'isInputFocused',
    value: function isInputFocused() {
      var el = this.refs.input;
      return el.ownerDocument && el === el.ownerDocument.activeElement;
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick() {
      // Input will not be focused if it's disabled
      if (this.isInputFocused() && !this.isOpen()) this.setState({ isOpen: true });
    }
  }, {
    key: 'composeEventHandlers',
    value: function composeEventHandlers(internal, external) {
      return external ? function (e) {
        internal(e);external(e);
      } : internal;
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return 'open' in this.props ? this.props.open : this.state.isOpen;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.debug) {
        // you don't like it, you love it
        this._debugStates.push({
          id: this._debugStates.length,
          state: this.state
        });
      }

      var inputProps = this.props.inputProps;

      var open = this.isOpen();
      return React.createElement(
        'div',
        _extends({ style: _extends({}, this.props.wrapperStyle) }, this.props.wrapperProps),
        React.createElement('input', _extends({}, inputProps, {
          role: 'combobox',
          'aria-autocomplete': 'list',
          'aria-expanded': open,
          autoComplete: 'off',
          ref: this.exposeAPI,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          onChange: this.handleChange,
          onKeyDown: this.composeEventHandlers(this.handleKeyDown, inputProps.onKeyDown),
          onClick: this.composeEventHandlers(this.handleInputClick, inputProps.onClick),
          value: this.props.value
        })),
        open && this.renderMenu(),
        this.props.debug && React.createElement(
          'pre',
          { style: { marginLeft: 300 } },
          JSON.stringify(this._debugStates.slice(Math.max(0, this._debugStates.length - 5), this._debugStates.length), null, 2)
        )
      );
    }
  }]);

  return Autocomplete;
}(React.Component);

Autocomplete.propTypes = {
  /**
   * The items to display in the dropdown menu
   */
  items: PropTypes.array.isRequired,
  /**
   * The value to display in the input field
   */
  value: PropTypes.any,
  /**
   * Arguments: `event: Event, value: String`
   *
   * Invoked every time the user changes the input's value.
   */
  onChange: PropTypes.func,
  /**
   * Arguments: `value: String, item: Any`
   *
   * Invoked when the user selects an item from the dropdown menu.
   */
  onSelect: PropTypes.func,
  /**
   * Arguments: `item: Any, value: String`
   *
   * Invoked for each entry in `items` and its return value is used to
   * determine whether or not it should be displayed in the dropdown menu.
   * By default all items are always rendered.
   */
  shouldItemRender: PropTypes.func,
  /**
   * Arguments: `itemA: Any, itemB: Any, value: String`
   *
   * The function which is used to sort `items` before display.
   */
  sortItems: PropTypes.func,
  /**
   * Arguments: `item: Any`
   *
   * Used to read the display value from each entry in `items`.
   */
  getItemValue: PropTypes.func.isRequired,
  /**
   * Arguments: `item: Any, isHighlighted: Boolean, styles: Object`
   *
   * Invoked for each entry in `items` that also passes `shouldItemRender` to
   * generate the render tree for each item in the dropdown menu. `styles` is
   * an optional set of styles that can be applied to improve the look/feel
   * of the items in the dropdown menu.
   */
  renderItem: PropTypes.func.isRequired,
  /**
   * Arguments: `items: Array<Any>, value: String, styles: Object`
   *
   * Invoked to generate the render tree for the dropdown menu. Ensure the
   * returned tree includes `items` or else no items will be rendered.
   * `styles` will contain { top, left, minWidth } which are the coordinates
   * of the top-left corner and the width of the dropdown menu.
   */
  renderMenu: PropTypes.func,
  /**
   * Styles that are applied to the dropdown menu in the default `renderMenu`
   * implementation. If you override `renderMenu` and you want to use
   * `menuStyles` you must manually apply them (`this.props.menuStyles`).
   */
  menuStyle: PropTypes.object,
  /**
   * Props that are applied to the `<input />` element rendered by
   * `Autocomplete`. Any properties supported by `HTMLInputElement` can be
   * specified, apart from the following which are set by `Autocomplete`:
   * value, autoComplete, role, aria-autocomplete
   */
  inputProps: PropTypes.object,
  /**
   * Props that are applied to the element which wraps the `<input />` and
   * dropdown menu elements rendered by `Autocomplete`.
   */
  wrapperProps: PropTypes.object,
  /**
   * This is a shorthand for `wrapperProps={{ style: <your styles> }}`.
   * Note that `wrapperStyle` is applied before `wrapperProps`, so the latter
   * will win if it contains a `style` entry.
   */
  wrapperStyle: PropTypes.object,
  /**
   * Whether or not to automatically highlight the top match in the dropdown
   * menu.
   */
  autoHighlight: PropTypes.bool,
  /**
   * Arguments: `isOpen: Boolean`
   *
   * Invoked every time the dropdown menu's visibility changes (i.e. every
   * time it is displayed/hidden).
   */
  onMenuVisibilityChange: PropTypes.func,
  /**
   * Used to override the internal logic which displays/hides the dropdown
   * menu. This is useful if you want to force a certain state based on your
   * UX/business logic. Use it together with `onMenuVisibilityChange` for
   * fine-grained control over the dropdown menu dynamics.
   */
  open: PropTypes.bool,
  debug: PropTypes.bool
};
Autocomplete.defaultProps = {
  value: '',
  wrapperProps: {},
  wrapperStyle: {
    display: 'inline-block'
  },
  inputProps: {},
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  renderMenu: function renderMenu(items, value, style) {
    return React.createElement('div', { style: _extends({}, style, this.menuStyle), children: items });
  },

  menuStyle: {
    borderRadius: '3px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
    background: 'rgba(255, 255, 255, 0.9)',
    padding: '2px 0',
    fontSize: '90%',
    position: 'fixed',
    overflow: 'auto',
    maxHeight: '50%' },
  autoHighlight: true,
  onMenuVisibilityChange: function onMenuVisibilityChange() {}
};
Autocomplete.keyDownHandlers = {
  ArrowDown: function ArrowDown(event) {
    event.preventDefault();
    var itemsLength = this.getFilteredItems(this.props).length;
    if (!itemsLength) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? 0 : highlightedIndex + 1;
    this.setState({
      highlightedIndex: index,
      isOpen: true
    });
  },
  ArrowUp: function ArrowUp(event) {
    event.preventDefault();
    var itemsLength = this.getFilteredItems(this.props).length;
    if (!itemsLength) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === 0 || highlightedIndex === null ? itemsLength - 1 : highlightedIndex - 1;
    this.setState({
      highlightedIndex: index,
      isOpen: true
    });
  },
  Enter: function Enter(event) {
    var _this6 = this;

    if (!this.isOpen()) {
      // menu is closed so there is no selection to accept -> do nothing
      return;
    } else if (this.state.highlightedIndex == null) {
      // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
      this.setState({
        isOpen: false
      }, function () {
        _this6.refs.input.select();
      });
    } else {
      // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
      event.preventDefault();
      var item = this.getFilteredItems(this.props)[this.state.highlightedIndex];
      var value = this.props.getItemValue(item);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, function () {
        //this.refs.input.focus() // TODO: file issue
        _this6.refs.input.setSelectionRange(value.length, value.length);
        _this6.props.onSelect(value, item);
      });
    }
  },
  Escape: function Escape() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
    this.setState({
      highlightedIndex: null,
      isOpen: false
    });
  },
  Tab: function Tab() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
  }
};


module.exports = Autocomplete;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(41);
var Danger = __webpack_require__(447);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInstrumentation = __webpack_require__(18);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(117);
var setInnerHTML = __webpack_require__(73);
var setTextContent = __webpack_require__(217);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactErrorUtils = __webpack_require__(115);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactPropTypesSecret = __webpack_require__(476);
var propTypesFactory = __webpack_require__(196);

var React = __webpack_require__(44);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(25);
var ReactInstanceMap = __webpack_require__(58);
var ReactInstrumentation = __webpack_require__(18);
var ReactUpdates = __webpack_require__(20);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var emptyFunction = __webpack_require__(17);
var warning = __webpack_require__(4);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict;

  var _compilePath = compilePath(path, { end: exact, strict: strict }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["a"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* unused harmony reexport all */
/* unused harmony reexport race */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* unused harmony reexport select */
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export feature */
/* harmony export (immutable) */ __webpack_exports__["b"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reverse__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__(132);



/* harmony default export */ __webpack_exports__["a"] = (function(topology, o) {
  return o.type === "GeometryCollection"
      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature(topology, o); })}
      : feature(topology, o);
});

function feature(topology, o) {
  var id = o.id,
      bbox = o.bbox,
      properties = o.properties == null ? {} : o.properties,
      geometry = object(topology, o);
  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
}

function object(topology, o) {
  var transformPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transform__["a" /* default */])(topology.transform),
      arcs = topology.arcs;

  function arc(i, points) {
    if (points.length) points.pop();
    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
      points.push(transformPoint(a[k], k));
    }
    if (i < 0) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__reverse__["a" /* default */])(points, n);
  }

  function point(p) {
    return transformPoint(p);
  }

  function line(arcs) {
    var points = [];
    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
    return points;
  }

  function ring(arcs) {
    var points = line(arcs);
    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
    return points;
  }

  function polygon(arcs) {
    return arcs.map(ring);
  }

  function geometry(o) {
    var type = o.type, coordinates;
    switch (type) {
      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
      case "Point": coordinates = point(o.coordinates); break;
      case "MultiPoint": coordinates = o.coordinates.map(point); break;
      case "LineString": coordinates = line(o.arcs); break;
      case "MultiLineString": coordinates = o.arcs.map(line); break;
      case "Polygon": coordinates = polygon(o.arcs); break;
      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
      default: return null;
    }
    return {type: type, coordinates: coordinates};
  }

  return geometry(o);
}


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(241);


/* harmony default export */ __webpack_exports__["a"] = (function(transform) {
  if (transform == null) return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */];
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2, n = input.length, output = new Array(n);
    output[0] = (x0 += input[0]) * kx + dx;
    output[1] = (y0 += input[1]) * ky + dy;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
});


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = {
	"EOSQ051": {
		"UNK": null,
		"NOR": {
			"v": 6.17,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.81,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.65,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.51,
			"r": "51",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.76,
			"r": "135",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.46,
			"r": "26",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.03,
			"r": "90",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.63,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.45,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.87,
			"r": "42",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.24,
			"r": "71",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.71,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.17,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.02,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.33,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.29,
			"r": "31",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.29,
			"r": "66",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.92,
			"r": "12",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.64,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.25,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.07,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.38,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.84,
			"r": "106",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.12,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.36,
			"r": "59",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.22,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.08,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.81,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.37,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.95,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.27,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.27,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.41,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.01,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.25,
			"r": "70",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.51,
			"r": "141",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.99,
			"r": "95",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.49,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.47,
			"r": "2",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.07,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.24,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.19,
			"r": "77",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.89,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.85,
			"r": "104",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.99,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.84,
			"r": "91",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.94,
			"r": "100",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.69,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.53,
			"r": "120",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.97,
			"r": "131",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.49,
			"r": "1",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.13,
			"r": "80",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.61,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.71,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.35,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.72,
			"r": "109",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.25,
			"r": "122",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.02,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.07,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.95,
			"r": "95",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.91,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 4.68,
			"r": "51",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.73,
			"r": "21",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 4.09,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.45,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.85,
			"r": "15",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.67,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 2.87,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.15,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.24,
			"r": "72",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.66,
			"r": "47",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.74,
			"r": "44",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.19,
			"r": "125",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.28,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.37,
			"r": "58",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 5.03,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.14,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.36,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.78,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.96,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.62,
			"r": "136",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.36,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.05,
			"r": "130",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.21,
			"r": "7",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.74,
			"r": "114",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.43,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.98,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.27,
			"r": "69",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.17,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.01,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.57,
			"r": "137",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.19,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.23,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.32,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.22,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.63,
			"r": "117",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.06,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.54,
			"r": "119",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.74,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5.45,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.51,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.18,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.84,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.92,
			"r": "13",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.76,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.96,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.29,
			"r": "65",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.77,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.28,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.77,
			"r": "43",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.48,
			"r": "53",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.75,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.5,
			"r": "109",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 3.94,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.52,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.19,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.27,
			"r": "68",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.48,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.54,
			"r": "25",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.52,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.61,
			"r": "23",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.35,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.17,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.01,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.81,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.03,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.31,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.84,
			"r": "105",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.11,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.83,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.76,
			"r": "112",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.32,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.24,
			"r": "34",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.49,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.74,
			"r": "20",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.14,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.05,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.58,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.44,
			"r": "55",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.18,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.08,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.78,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.8,
			"r": "132",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.94,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.18,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.9,
			"r": "14",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.15,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.6,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.9,
			"r": "41",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIB03": {
		"UNK": null,
		"NOR": {
			"v": 5.93,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.36,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.41,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.85,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.99,
			"r": "129",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.81,
			"r": "58",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.7,
			"r": "67",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.83,
			"r": "19",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.7,
			"r": "28",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.73,
			"r": "65",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.35,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.44,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.59,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5,
			"r": "47",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.77,
			"r": "63",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.85,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.52,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.54,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.51,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.59,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.09,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.44,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.27,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.77,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.29,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.64,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.27,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.89,
			"r": "107",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.63,
			"r": "31",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.48,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 1.7,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.32,
			"r": "121",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.29,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.31,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.06,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.97,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.22,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.88,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.22,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.97,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.05,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5,
			"r": "49",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.92,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.08,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.4,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.13,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.11,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.22,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.85,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.8,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.81,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.52,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.81,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.69,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.99,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.38,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.94,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.62,
			"r": "32",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.89,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.71,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.98,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.82,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.89,
			"r": "53",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.15,
			"r": "89",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.21,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.15,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.96,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.52,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.35,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.07,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.87,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.86,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "12",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.76,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.78,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.19,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.1,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.63,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.81,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.9,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.74,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.39,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.11,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.18,
			"r": "127",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.83,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.99,
			"r": "50",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.88,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.71,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.4,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.98,
			"r": "130",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.29,
			"r": "5",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.01,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.2,
			"r": "84",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.53,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.26,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.29,
			"r": "39",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.53,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.2,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.45,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.75,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.72,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.18,
			"r": "87",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.93,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.15,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.91,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.89,
			"r": "17",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.06,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.06,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.8,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.96,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.06,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.4,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.28,
			"r": "122",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.34,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.53,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.75,
			"r": "114",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.14,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.19,
			"r": "85",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.19,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.72,
			"r": "25",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.64,
			"r": "69",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.35,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.12,
			"r": "90",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.89,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.71,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.95,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.69,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.8,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.82,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.76,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.6,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"int_cooperation": {
		"UNK": null,
		"NOR": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 1,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 2,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.75,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.33,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.33,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.67,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2012",
			"m": 88
		},
		"EGY": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"TJK": null,
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 2,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.67,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 2,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.33,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 2,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.67,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.33,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 1.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 0.67,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 2,
			"y": "2012",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 6": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ146": {
		"UNK": null,
		"NOR": {
			"v": 6.03,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.93,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.24,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 2.86,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.06,
			"r": "131",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.19,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "49",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 2.54,
			"r": "115",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5,
			"r": "24",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.51,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.72,
			"r": "60",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.34,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.58,
			"r": "32",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.24,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.37,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.67,
			"r": "31",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.49,
			"r": "70",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 3.91,
			"r": "44",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.36,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.47,
			"r": "118",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.71,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.4,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.51,
			"r": "68",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.88,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.09,
			"r": "89",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.91,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.34,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 2.38,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.64,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.81,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.56,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.15,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.36,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.02,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.92,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.84,
			"r": "139",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.24,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 3.94,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.28,
			"r": "2",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.48,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.5,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4,
			"r": "47",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.65,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.27,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.45,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.63,
			"r": "108",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.53,
			"r": "67",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.05,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.31,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.1,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.19,
			"r": "85",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.09,
			"r": "133",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.98,
			"r": "8",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.82,
			"r": "135",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.17,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.34,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.6,
			"r": "16",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.49,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.15,
			"r": "81",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 2.89,
			"r": "88",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 1.93,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.55,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.15,
			"r": "44",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 2.88,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.73,
			"r": "103",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.46,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.93,
			"r": "100",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.48,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.63,
			"r": "15",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.98,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 2.71,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.69,
			"r": "53",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.28,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3.05,
			"r": "91",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.81,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.2,
			"r": "128",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.81,
			"r": "14",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.64,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.32,
			"r": "39",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.16,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.92,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.86,
			"r": "13",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.58,
			"r": "112",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.01,
			"r": "135",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.54,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 1.76,
			"r": "136",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.86,
			"r": "12",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.57,
			"r": "113",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.01,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.75,
			"r": "59",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.61,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 2.37,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.59,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.44,
			"r": "120",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.96,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.9,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.17,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.13,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.29,
			"r": "81",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.3,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.24,
			"r": "84",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.4,
			"r": "75",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.77,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.21,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.15,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.95,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.93,
			"r": "99",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.72,
			"r": "30",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.92,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.87,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.9,
			"r": "101",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.9,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.41,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.22,
			"r": "42",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.43,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.03,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 2.11,
			"r": "131",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.49,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.09,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.05,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.08,
			"r": "90",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.05,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.77,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.14,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.9,
			"r": "26",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.33,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.36,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.6,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.96,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.45,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.23,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.86,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.18,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.39,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.89,
			"r": "55",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.1,
			"r": "6",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.79,
			"r": "58",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.52,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.15,
			"r": "5",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.75,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.44,
			"r": "121",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.7,
			"r": "109",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.83,
			"r": "57",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.45,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.31,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.94,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.18,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.18,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.59,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.32,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.44,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.46,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.27,
			"r": "40",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIB": {
		"UNK": null,
		"NOR": {
			"v": 5.93,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.36,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.41,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.85,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.99,
			"r": "129",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.81,
			"r": "58",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.7,
			"r": "67",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.83,
			"r": "19",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.7,
			"r": "28",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.73,
			"r": "65",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.35,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.44,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.59,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5,
			"r": "47",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.77,
			"r": "63",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.85,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.52,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.54,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.51,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.59,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.09,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.44,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.27,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.77,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.29,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.64,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.27,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.89,
			"r": "107",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.63,
			"r": "31",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.48,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 1.7,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.32,
			"r": "121",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.29,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.31,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.06,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.97,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.22,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.88,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.22,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.97,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.05,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5,
			"r": "49",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.92,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.08,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.4,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.13,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.11,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.22,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.85,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.8,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.81,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.52,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.81,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.69,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.99,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.38,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.94,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.62,
			"r": "32",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.89,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.71,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.98,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.82,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.89,
			"r": "53",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.15,
			"r": "89",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.21,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.15,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.96,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.52,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.35,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.07,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.87,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.86,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "12",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.76,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.78,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.19,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.1,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.63,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.81,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.9,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.74,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.39,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.11,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.18,
			"r": "127",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.83,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.99,
			"r": "50",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.88,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.71,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.4,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.98,
			"r": "130",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.29,
			"r": "5",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.01,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.2,
			"r": "84",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.53,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.26,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.29,
			"r": "39",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.53,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.2,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.45,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.75,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.72,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.18,
			"r": "87",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.93,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.15,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.91,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.89,
			"r": "17",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.06,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.06,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.8,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.96,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.06,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.4,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.28,
			"r": "122",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.34,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.53,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.75,
			"r": "114",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.14,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.19,
			"r": "85",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.19,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.72,
			"r": "25",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.64,
			"r": "69",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.35,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.12,
			"r": "90",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.89,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.71,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.95,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.69,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.8,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.82,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.76,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.6,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TABTIMEIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1090,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 180,
			"r": "125",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 84,
			"r": "101",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 208.8,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 120,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"r": "26",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 38,
			"r": "74",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 72,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 72,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 32,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 10,
			"r": "55",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.62,
			"r": "33",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 24.33,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 16,
			"r": "61",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 44,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 132,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 96,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 84,
			"r": "101",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 17.56,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 13.33,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 140,
			"r": "118",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 36,
			"r": "70",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 48,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 180,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 172.71,
			"r": "124",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 1,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 48,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 138.38,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 192,
			"r": "126",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 10.45,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 270,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 63.46,
			"r": "85",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 36,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 265,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0.5,
			"r": "1",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 147,
			"r": "120",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 36,
			"r": "70",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 96,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1.56,
			"r": "31",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 120,
			"r": "107",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 54.86,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 26,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 72,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 156,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 24,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 13.5,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 44,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 174,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 6,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.5,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 120,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 126,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4,
			"r": "46",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 26,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.75,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 33,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 89.14,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 8,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 192,
			"r": "126",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 1.67,
			"r": "34",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.5,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.31,
			"r": "44",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 1.56,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 132.88,
			"r": "114",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 72,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 156,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 58,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 96,
			"r": "104",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 1.32,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 216,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 36,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 76,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 2,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 172,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 28,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 0.81,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 31.5,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 248.73,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 8,
			"r": "51",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 77,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 23,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 4,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 144,
			"r": "119",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0.5,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 72,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 8.62,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 324,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 72,
			"r": "89",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 36,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 131.08,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 2,
			"r": "35",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 134,
			"r": "115",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 64,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 96,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 61.29,
			"r": "84",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 26.92,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 76,
			"r": "97",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 42.5,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 65.7,
			"r": "88",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 7.5,
			"r": "50",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 11.08,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.35,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 72,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 168,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 3,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 58.67,
			"r": "83",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 64,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 2.5,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 216,
			"r": "129",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.25,
			"r": "43",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 137.14,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 12,
			"r": "58",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 8,
			"r": "51",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 48,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 81,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 120,
			"r": "107",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 72,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 163,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 114.67,
			"r": "106",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 44,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 240,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 57.64,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 1,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 1,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 40.62,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 74,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"MOBBBSUBPC": {
		"UNK": null,
		"NOR": {
			"v": 92.83,
			"r": "19",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 75.42,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 42.97,
			"r": "75",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 68.81,
			"r": "41",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 7.56,
			"r": "129",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 131.78,
			"r": "4",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 11.95,
			"r": "121",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 35.09,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 74.65,
			"r": "36",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 109.67,
			"r": "12",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 60.92,
			"r": "53",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 53.51,
			"r": "64",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 77.71,
			"r": "31",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 63.17,
			"r": "50",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 10.08,
			"r": "122",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 89.94,
			"r": "21",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 41.29,
			"r": "79",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 9.37,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 7.22,
			"r": "130",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 56.19,
			"r": "60",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 56.06,
			"r": "61",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 42.8,
			"r": "76",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 41.58,
			"r": "78",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 15.5,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 37.7,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 50.36,
			"r": "72",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 19.94,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 74.22,
			"r": "37",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 63.53,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 4.48,
			"r": "132",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 57.61,
			"r": "57",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 67.04,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 5.85,
			"r": "131",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 69.57,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 19.33,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 20.95,
			"r": "105",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 52.04,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 144.05,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 21.1,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 18.31,
			"r": "110",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 20.52,
			"r": "106",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 43.65,
			"r": "74",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 20.02,
			"r": "107",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 16.59,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 12.13,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 50.66,
			"r": "70",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 81.29,
			"r": "27",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 13.02,
			"r": "119",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 75.28,
			"r": "34",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 30.98,
			"r": "100",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 80.56,
			"y": "2014",
			"m": 100
		},
		"CHE": {
			"v": 97.61,
			"r": "15",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 88.62,
			"r": "22",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 35.58,
			"r": "93",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 95.52,
			"r": "16",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 25.88,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 52.03,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 0.23,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 66.55,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 39.61,
			"r": "85",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 32.22,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 43.99,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 32.66,
			"r": "98",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 66.59,
			"r": "48",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 33.12,
			"r": "97",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 12.08,
			"r": "120",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 112.86,
			"r": "10",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 39.28,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 39.8,
			"r": "84",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 19.14,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 40.39,
			"r": "82",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 82.06,
			"r": "26",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 56.41,
			"r": "58",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 67.3,
			"r": "45",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 87.79,
			"r": "23",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 59.97,
			"r": "55",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 67.31,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 51.94,
			"r": "68",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 42.05,
			"r": "77",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 116.8,
			"r": "7",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 17.23,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 13.93,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 15.77,
			"r": "113",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 33.85,
			"r": "95",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 107.02,
			"r": "14",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 8.47,
			"r": "127",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 59.47,
			"r": "56",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 38.98,
			"r": "89",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 54.81,
			"r": "63",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 67.53,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 1.38,
			"r": "136",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 0.16,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 95.05,
			"r": "17",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 60.18,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 122.09,
			"r": "6",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 10.02,
			"r": "123",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 40.11,
			"r": "83",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 45.65,
			"r": "73",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 291900,
			"r": "81",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 18.84,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 78.26,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 17.04,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 61.83,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 82.14,
			"r": "25",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 70.54,
			"r": "40",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 13.45,
			"r": "118",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 68.57,
			"r": "42",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 80.03,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 37.03,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 5.97,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 53.43,
			"r": "65",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 39.23,
			"r": "87",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 111.67,
			"r": "11",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 50.45,
			"r": "71",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 13.79,
			"r": "117",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 23.1,
			"r": "103",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 15.29,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 9.36,
			"r": "125",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 62.63,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 71.75,
			"r": "38",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 66.82,
			"r": "47",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 71.29,
			"r": "39",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 114.27,
			"r": "8",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 56.03,
			"r": "62",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 109.23,
			"r": "13",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 50.94,
			"r": "69",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 126.44,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 36.71,
			"r": "92",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 75.1,
			"r": "35",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 8.1,
			"r": "128",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 142.2,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 4.24,
			"r": "134",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 40.97,
			"r": "80",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 93.43,
			"r": "18",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 14.16,
			"r": "116",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 83.33,
			"r": "24",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 62.07,
			"r": "52",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 15.22,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 91.99,
			"r": "20",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 33.48,
			"r": "96",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 33.52,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 39.03,
			"r": "88",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 139.31,
			"r": "3",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 26.42,
			"r": "101",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 4.27,
			"r": "133",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 76.02,
			"r": "32",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 37.52,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 3.19,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 9.01,
			"r": "126",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 56.32,
			"r": "59",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 114.22,
			"r": "9",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 80.2,
			"r": "28",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 54.86,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TABTIMEEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.13,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 288,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 58.67,
			"r": "90",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 70.6,
			"r": "99",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 56.91,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 96,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 13.38,
			"r": "36",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 29.44,
			"r": "59",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 57.71,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 120,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 24,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 36,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 48,
			"r": "73",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 38.54,
			"r": "70",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 78,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 60,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 8.5,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 36,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 48,
			"r": "73",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 42.46,
			"r": "71",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 21,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 20.39,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 38,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 9,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.38,
			"r": "16",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 117,
			"r": "124",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 60,
			"r": "91",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 24,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 90,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 240,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 135.43,
			"r": "130",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 36,
			"r": "62",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 56.29,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 70.5,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 193,
			"r": "132",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 7.61,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 101,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 85.12,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 96,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 48,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.4,
			"r": "26",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 75,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 51,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 20,
			"r": "44",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 72,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1,
			"r": "17",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 49.04,
			"r": "80",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 38.14,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 20,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 97.33,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 72,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 84,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 16,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 60,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 112,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 24,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 96,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 75.33,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 35.5,
			"r": "61",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 19,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 82,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 109.71,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 21,
			"r": "47",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 24,
			"r": "50",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 133,
			"r": "129",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 8,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 53.28,
			"r": "84",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 88,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 72,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 43,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 48,
			"r": "73",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 18.55,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 515.04,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 100,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 57.73,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 18,
			"r": "41",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 106,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 28,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.83,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 109.33,
			"r": "121",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 118.14,
			"r": "125",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 9,
			"r": "32",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 48.22,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 52,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 5,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 99.69,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 29.83,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 48,
			"r": "73",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 48,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 96,
			"r": "110",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 120,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 69,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 13.5,
			"r": "37",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 148,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 72,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 75,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 106.12,
			"r": "119",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 50.46,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.67,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 108,
			"r": "120",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 96,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 2,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 25.93,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"r": "18",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 15.75,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 22.6,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 48,
			"r": "73",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 36,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 26,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 12,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 78,
			"r": "105",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 112,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 36,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 12,
			"r": "34",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 120,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 54.86,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 27,
			"r": "58",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.21,
			"r": "28",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 144,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 71.67,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 72,
			"r": "101",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 61.45,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 202,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 62,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 96,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 96,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 69.82,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 38,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 16.85,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 41,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TARIFPEAK": {
		"UNK": null,
		"NOR": {
			"v": 8.44,
			"r": "88",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 1.09,
			"r": "50",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.79,
			"r": "41",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.27,
			"r": "30",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.51,
			"r": "60",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 2.72,
			"r": "62",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 0.73,
			"r": "39",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 9.76,
			"r": "92",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 0.26,
			"r": "29",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 0.65,
			"r": "37",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 17.46,
			"r": "134",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.95,
			"r": "65",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 1.28,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 7.84,
			"r": "87",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 4.73,
			"r": "70",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 10.38,
			"r": "97",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.26,
			"r": "72",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 0.75,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 9.81,
			"r": "94",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 1.7,
			"r": "57",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 2.91,
			"r": "64",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 22.65,
			"r": "136",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 0,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 6.43,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 0,
			"r": "1",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 1.05,
			"r": "48",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.83,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 1.2,
			"r": "51",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 11.89,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 6.03,
			"r": "75",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 0.11,
			"r": "27",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 0.48,
			"r": "36",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 10.9,
			"r": "102",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 1.27,
			"r": "53",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 7.36,
			"r": "82",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 3.04,
			"r": "66",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 7.64,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 0.02,
			"r": "25",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 18.15,
			"r": "135",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.05,
			"r": "58",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 0.83,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 10.9,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 0.81,
			"r": "42",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 9.14,
			"r": "90",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 1.47,
			"r": "55",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 10.9,
			"r": "102",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 0.7,
			"r": "38",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 0.21,
			"r": "28",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.28,
			"r": "77",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.91,
			"r": "47",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0,
			"r": "1",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 10.9,
			"r": "102",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.2,
			"r": "68",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 9.83,
			"r": "96",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 5.44,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 2.69,
			"r": "61",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 0.89,
			"r": "46",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"r": "52",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 4.9,
			"r": "71",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 9.78,
			"r": "93",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 7.6,
			"r": "83",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 10.9,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 10.9,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0,
			"r": "1",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 11.98,
			"r": "132",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 1.09,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 10.9,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 10.9,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 0,
			"r": "1",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 10.9,
			"r": "102",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 0.27,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 10.51,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 7.72,
			"r": "86",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.27,
			"r": "30",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 17.27,
			"r": "133",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.85,
			"r": "63",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 6.69,
			"r": "80",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 3.15,
			"r": "67",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 10.9,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 1.62,
			"r": "56",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 10.43,
			"r": "98",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 11.37,
			"r": "130",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 9.33,
			"r": "91",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 10.48,
			"r": "99",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 10.9,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 6.35,
			"r": "78",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 0.06,
			"r": "26",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 0,
			"r": "1",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.42,
			"r": "59",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 7.72,
			"r": "85",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 4.51,
			"r": "69",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 10.9,
			"r": "102",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 9.81,
			"r": "94",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 0.27,
			"r": "30",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 6.05,
			"r": "76",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 6.71,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 0.27,
			"r": "30",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 0.44,
			"r": "35",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 0.83,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 8.62,
			"r": "89",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 5.58,
			"r": "74",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 10.87,
			"r": "101",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"CUSTSERVIND": {
		"UNK": null,
		"NOR": {
			"v": 0.69,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.55,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 0.4,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.73,
			"r": "32",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.38,
			"r": "102",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.64,
			"r": "56",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0.49,
			"r": "86",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 0.61,
			"r": "62",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 0.75,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 0.91,
			"r": "7",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 0.71,
			"r": "35",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 0.58,
			"r": "66",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 0.36,
			"r": "107",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 0.7,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 0.53,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 0.47,
			"r": "90",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.59,
			"r": "65",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": null,
		"NIC": {
			"v": 0.64,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 0.23,
			"r": "115",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 0.81,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 0.58,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.71,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 0.51,
			"r": "80",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 0.42,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 0.45,
			"r": "92",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 0.71,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.8,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 0.56,
			"r": "74",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 0.82,
			"r": "15",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.73,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.31,
			"y": "2015",
			"m": 18
		},
		"NGA": {
			"v": 0.49,
			"r": "85",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 0.47,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.9,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 0.38,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.36,
			"r": "106",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.42,
			"r": "95",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 0.56,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0.47,
			"y": "2009",
			"m": 96
		},
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.5,
			"y": "2009",
			"m": 87
		},
		"EGY": {
			"v": 0.33,
			"r": "109",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 0.68,
			"r": "47",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 0.64,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 0.87,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 0.58,
			"r": "66",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 0.81,
			"r": "18",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 0.57,
			"r": "71",
			"m": 88,
			"y": "2016"
		},
		"JOR": {
			"v": 0.68,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0.7,
			"r": "38",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 0.32,
			"r": "111",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 0.79,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": {
			"v": 0.33,
			"y": "2009",
			"m": 104
		},
		"DOM": {
			"v": 0.56,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 0.21,
			"r": "117",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 0.41,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.62,
			"r": "59",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0.38,
			"r": "105",
			"m": 94,
			"y": "2015"
		},
		"TJK": null,
		"AUS": {
			"v": 0.89,
			"r": "11",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0.65,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.73,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 0.51,
			"r": "80",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 0.91,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.5,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0.62,
			"r": "59",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 0.91,
			"r": "7",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0.25,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": {
			"v": 0.75,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 0.73,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 0.47,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 0.23,
			"r": "116",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 0.38,
			"r": "102",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 0.67,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 0.42,
			"r": "95",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 0.65,
			"r": "51",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 0.58,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 0.64,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.75,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 0.8,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.77,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.92,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 0.51,
			"r": "83",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.69,
			"r": "42",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 0.57,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 0.69,
			"r": "42",
			"m": 51,
			"y": "2015"
		},
		"MLI": null,
		"OMN": {
			"v": 0.54,
			"r": "77",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 0.38,
			"y": "2009",
			"m": 86
		},
		"ITA": {
			"v": 0.92,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.92,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 0.35,
			"r": "108",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 0.92,
			"r": "3",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 0.48,
			"r": "87",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.58,
			"r": "69",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.63,
			"r": "58",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.41,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.61,
			"r": "63",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 0.8,
			"r": "20",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.26,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 0.48,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"TUN": null,
		"SRB": {
			"v": 0.54,
			"r": "77",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0.69,
			"r": "40",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 0.69,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.82,
			"r": "15",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 0.65,
			"r": "50",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 0.82,
			"r": "15",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0.62,
			"r": "59",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 0.88,
			"r": "12",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 0.65,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 0.83,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 0.33,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 0.98,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 0.26,
			"r": "113",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 0.51,
			"r": "80",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 0.69,
			"r": "40",
			"m": 96,
			"y": "2015"
		},
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 0.67,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": null,
		"SLE": {
			"v": 0.28,
			"r": "112",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 0.95,
			"r": "2",
			"m": 74,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 0.43,
			"r": "94",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": {
			"v": 0.6,
			"r": "64",
			"m": 97,
			"y": "2015"
		},
		"ESH": null,
		"SEN": null,
		"CMR": {
			"v": 0.42,
			"r": "95",
			"m": 92,
			"y": "2015"
		},
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.44,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 0.79,
			"r": "23",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 0.79,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 0.79,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 0.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TOTTARIFRT": {
		"UNK": null,
		"NOR": {
			"v": 2.95,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 11.82,
			"r": "120",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 9.62,
			"r": "97",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.95,
			"r": "52",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 13.03,
			"r": "121",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 9.89,
			"r": "107",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 7.08,
			"r": "86",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 7.71,
			"r": "89",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 9.65,
			"r": "98",
			"m": 96,
			"y": "2011"
		},
		"SLB": null,
		"URY": {
			"v": 8.02,
			"r": "92",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 3.4,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 4.52,
			"r": "63",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.59,
			"r": "64",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 7.58,
			"r": "88",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 3.86,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.11,
			"r": "71",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 2.96,
			"r": "44",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 9.13,
			"r": "95",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.57,
			"r": "49",
			"m": 103,
			"y": "2013"
		},
		"COK": null,
		"KEN": {
			"v": 9.59,
			"r": "96",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 6.47,
			"r": "83",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 5.02,
			"r": "68",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 4.18,
			"r": "61",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 1.74,
			"r": "35",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 3.24,
			"r": "45",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 6.4,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 9.7,
			"r": "101",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 16.8,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 9.68,
			"r": "100",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 10.73,
			"r": "114",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 3.53,
			"r": "48",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 27.98,
			"r": "136",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 9.92,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 13.64,
			"r": "125",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 1.04,
			"r": "5",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 16.57,
			"r": "132",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 6.85,
			"r": "85",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 5.55,
			"r": "72",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 3.98,
			"r": "57",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 11.5,
			"r": "119",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 7.44,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.65,
			"r": "50",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 9.67,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 1.04,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 6.16,
			"r": "77",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 10.8,
			"r": "116",
			"m": 104,
			"y": "2008"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.66,
			"r": "65",
			"m": 103,
			"y": "2013"
		},
		"SYR": null,
		"BEL": {
			"v": 1.04,
			"r": "5",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 13.45,
			"r": "123",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 5.79,
			"r": "74",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 2.06,
			"r": "37",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 10.38,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 9.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 22.65,
			"r": "135",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 11.12,
			"r": "118",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 1.04,
			"r": "5",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.81,
			"r": "75",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 6.39,
			"r": "80",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 3.28,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 4.43,
			"r": "62",
			"m": 96,
			"y": "2013"
		},
		"DNK": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 3.95,
			"r": "53",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 17.62,
			"r": "134",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 8.89,
			"r": "94",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 10.18,
			"r": "111",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 6.19,
			"r": "78",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 7.91,
			"r": "91",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 1.04,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 14.32,
			"r": "129",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.04,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 14.31,
			"r": "128",
			"m": 96,
			"y": "2012"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 13.76,
			"r": "126",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.37,
			"r": "39",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 9.89,
			"r": "103",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 4.14,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 1.04,
			"r": "5",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 1.04,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 13.46,
			"r": "124",
			"m": 86,
			"y": "2007"
		},
		"AUT": {
			"v": 1.04,
			"r": "5",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.97,
			"r": "55",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.73,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.92,
			"r": "67",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.64,
			"r": "84",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 4.08,
			"r": "58",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 0.86,
			"r": "4",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 10.63,
			"r": "113",
			"m": 105,
			"y": "2013"
		},
		"MRT": {
			"v": 9.93,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 13.03,
			"r": "122",
			"m": 96,
			"y": "2009"
		},
		"TUN": {
			"v": 10.8,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 5.06,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 10.16,
			"r": "110",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 5.78,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 1.04,
			"r": "5",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 11.07,
			"r": "117",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 1.38,
			"r": "33",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.02,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 2.11,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 1.82,
			"r": "36",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 1.04,
			"r": "5",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.83,
			"r": "41",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 0.03,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 9.89,
			"r": "106",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 6.36,
			"r": "79",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 2.89,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 8.18,
			"r": "93",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 1.04,
			"r": "5",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 6.44,
			"r": "82",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 13.83,
			"r": "127",
			"m": 104,
			"y": "2006"
		},
		"ARE": {
			"v": 3.97,
			"r": "56",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 4.83,
			"r": "66",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 14.6,
			"r": "131",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.96,
			"r": "54",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 9.89,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 14.56,
			"r": "130",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 4.08,
			"r": "59",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 9.84,
			"r": "102",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 7.73,
			"r": "90",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 2.81,
			"r": "40",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 1.51,
			"r": "34",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 5.04,
			"r": "69",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"HOMICIDERT": {
		"UNK": null,
		"NOR": {
			"v": 0.6,
			"r": "11",
			"m": 103,
			"y": "2014"
		},
		"HRV": {
			"v": 0.8,
			"r": "21",
			"m": 96,
			"y": "2014"
		},
		"VEN": {
			"v": 62,
			"r": "134",
			"m": 105,
			"y": "2014"
		},
		"TON": null,
		"CZE": {
			"v": 0.7,
			"r": "13",
			"m": 92,
			"y": "2014"
		},
		"BDI": {
			"v": 4,
			"r": "81",
			"m": 81,
			"y": "2014"
		},
		"BHR": {
			"v": 0.5,
			"r": "6",
			"m": 86,
			"y": "2011"
		},
		"ETH": {
			"v": 8,
			"r": "105",
			"m": 94,
			"y": "2012"
		},
		"ECU": {
			"v": 8.2,
			"r": "106",
			"m": 94,
			"y": "2014"
		},
		"FRA": {
			"v": 1.2,
			"r": "36",
			"m": 94,
			"y": "2014"
		},
		"SJM": null,
		"KOR": {
			"v": 0.7,
			"r": "13",
			"m": 97,
			"y": "2014"
		},
		"AZE": {
			"v": 2.5,
			"r": "59",
			"m": 81,
			"y": "2014"
		},
		"JAM": {
			"v": 36.1,
			"r": "132",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 7.8,
			"r": "101",
			"m": 105,
			"y": "2014"
		},
		"MLT": {
			"v": 1.4,
			"r": "39",
			"m": 100,
			"y": "2014"
		},
		"BVT": null,
		"GTM": {
			"v": 31.2,
			"r": "130",
			"m": 96,
			"y": "2014"
		},
		"MYS": {
			"v": 1.9,
			"r": "55",
			"m": 101,
			"y": "2010"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2,
			"r": "57",
			"m": 78,
			"y": "2013"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.6,
			"r": "75",
			"m": 100,
			"y": "2010"
		},
		"NIC": {
			"v": 11.5,
			"r": "118",
			"m": 102,
			"y": "2012"
		},
		"MKD": {
			"v": 1.6,
			"r": "46",
			"m": 100,
			"y": "2014"
		},
		"ISR": {
			"v": 1.7,
			"r": "49",
			"m": 96,
			"y": "2012"
		},
		"KHM": {
			"v": 1.8,
			"r": "51",
			"m": 97,
			"y": "2011"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 9.9,
			"r": "112",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 5.9,
			"r": "90",
			"m": 97,
			"y": "2014"
		},
		"COM": null,
		"LSO": {
			"v": 38,
			"r": "133",
			"m": 100,
			"y": "2010"
		},
		"MEX": {
			"v": 15.7,
			"r": "123",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 64.2,
			"r": "135",
			"m": 104,
			"y": "2014"
		},
		"CYM": null,
		"LTU": {
			"v": 5.5,
			"r": "88",
			"m": 100,
			"y": "2014"
		},
		"ROU": {
			"v": 1.5,
			"r": "41",
			"m": 103,
			"y": "2014"
		},
		"BRN": {
			"v": 0.5,
			"r": "6",
			"m": 91,
			"y": "2013"
		},
		"CHL": {
			"v": 3.6,
			"r": "75",
			"m": 91,
			"y": "2014"
		},
		"LVA": {
			"v": 3.9,
			"r": "78",
			"m": 100,
			"y": "2014"
		},
		"YEM": {
			"v": 6.7,
			"r": "93",
			"m": 105,
			"y": "2013"
		},
		"CPV": {
			"v": 10.6,
			"y": "2013",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 9.8,
			"y": "2012",
			"m": 12
		},
		"NGA": {
			"v": 10.1,
			"r": "114",
			"m": 102,
			"y": "2012"
		},
		"PRT": {
			"v": 0.9,
			"r": "24",
			"m": 103,
			"y": "2014"
		},
		"SGS": null,
		"FIN": {
			"v": 1.6,
			"r": "46",
			"m": 94,
			"y": "2014"
		},
		"NPL": {
			"v": 2.9,
			"r": "65",
			"m": 103,
			"y": "2011"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 11.8,
			"r": "119",
			"m": 105,
			"y": "2014"
		},
		"LBR": {
			"v": 3.2,
			"r": "70",
			"m": 99,
			"y": "2012"
		},
		"MNE": {
			"v": 3.2,
			"r": "70",
			"m": 100,
			"y": "2014"
		},
		"IRN": {
			"v": 4.8,
			"r": "86",
			"m": 96,
			"y": "2012"
		},
		"SPM": null,
		"MWI": {
			"v": 1.8,
			"r": "51",
			"m": 100,
			"y": "2012"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 34.4,
			"y": "2014",
			"m": 88
		},
		"EGY": {
			"v": 3.2,
			"r": "70",
			"m": 94,
			"y": "2011"
		},
		"BGR": {
			"v": 1.6,
			"r": "46",
			"m": 86,
			"y": "2014"
		},
		"CUB": null,
		"PAK": {
			"v": 7.8,
			"r": "101",
			"m": 103,
			"y": "2012"
		},
		"IMN": null,
		"THA": {
			"v": 3.9,
			"r": "78",
			"m": 104,
			"y": "2014"
		},
		"KGZ": {
			"v": 3.7,
			"r": "77",
			"m": 97,
			"y": "2014"
		},
		"LBY": {
			"v": 2.5,
			"y": "2012",
			"m": 100
		},
		"CHE": {
			"v": 0.5,
			"r": "6",
			"m": 91,
			"y": "2014"
		},
		"MAC": null,
		"BRA": {
			"v": 24.6,
			"r": "127",
			"m": 88,
			"y": "2014"
		},
		"JOR": {
			"v": 2.3,
			"r": "58",
			"m": 96,
			"y": "2012"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 10,
			"r": "113",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 4.9,
			"r": "87",
			"m": 103,
			"y": "2010"
		},
		"ATA": null,
		"SVN": {
			"v": 0.7,
			"r": "13",
			"m": 104,
			"y": "2014"
		},
		"GUY": {
			"v": 20.4,
			"y": "2013",
			"m": 96
		},
		"SUR": {
			"v": 9.5,
			"y": "2012",
			"m": 104
		},
		"DOM": {
			"v": 17.4,
			"r": "125",
			"m": 92,
			"y": "2014"
		},
		"CUW": null,
		"TTO": {
			"v": 25.9,
			"r": "128",
			"m": 104,
			"y": "2014"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.2,
			"y": "2012",
			"m": 105
		},
		"PAN": {
			"v": 17.4,
			"r": "125",
			"m": 103,
			"y": "2013"
		},
		"SYR": null,
		"BEL": {
			"v": 1.8,
			"r": "51",
			"m": 82,
			"y": "2014"
		},
		"GAB": {
			"v": 9.4,
			"r": "109",
			"m": 94,
			"y": "2012"
		},
		"TJK": {
			"v": 1.4,
			"r": "39",
			"m": 104,
			"y": "2013"
		},
		"AUS": {
			"v": 1,
			"r": "30",
			"m": 79,
			"y": "2014"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"r": "30",
			"m": 100,
			"y": "2014"
		},
		"PNG": null,
		"HUN": {
			"v": 1.5,
			"r": "41",
			"m": 96,
			"y": "2014"
		},
		"SYC": {
			"v": 2.1,
			"y": "2010",
			"m": 104
		},
		"CIV": {
			"v": 11.4,
			"r": "116",
			"m": 92,
			"y": "2012"
		},
		"ABW": null,
		"ESP": {
			"v": 0.7,
			"r": "13",
			"m": 94,
			"y": "2014"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.7,
			"r": "60",
			"m": 91,
			"y": "2014"
		},
		"ARG": {
			"v": 7.6,
			"r": "100",
			"m": 76,
			"y": "2014"
		},
		"GBR": {
			"v": 0.9,
			"r": "24",
			"m": 95,
			"y": "2013"
		},
		"SXM": null,
		"KAZ": {
			"v": 7.4,
			"r": "98",
			"m": 97,
			"y": "2013"
		},
		"BWA": {
			"v": 14.8,
			"r": "122",
			"m": 91,
			"y": "2010"
		},
		"MDA": {
			"v": 3.2,
			"r": "70",
			"m": 100,
			"y": "2014"
		},
		"CXR": null,
		"IDN": {
			"v": 0.5,
			"r": "6",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 1,
			"r": "30",
			"m": 92,
			"y": "2014"
		},
		"HND": {
			"v": 74.6,
			"r": "136",
			"m": 96,
			"y": "2014"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 8.7,
			"y": "2012",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.9,
			"r": "65",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 12.4,
			"r": "120",
			"m": 88,
			"y": "2012"
		},
		"NFK": null,
		"HKG": {
			"v": 0.9,
			"r": "24",
			"m": 96,
			"y": "2013"
		},
		"COD": {
			"v": 12.5,
			"r": "121",
			"m": 92,
			"y": "2012"
		},
		"ZAF": {
			"v": 33,
			"r": "131",
			"m": 105,
			"y": "2014"
		},
		"VNM": {
			"v": 1.5,
			"r": "41",
			"m": 105,
			"y": "2011"
		},
		"CYP": {
			"v": 0.1,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"TCA": null,
		"SVK": {
			"v": 1.1,
			"r": "33",
			"m": 104,
			"y": "2014"
		},
		"NER": null,
		"TCD": {
			"v": 9.2,
			"r": "108",
			"m": 104,
			"y": "2012"
		},
		"HTI": {
			"v": 10,
			"y": "2012",
			"m": 96
		},
		"IRL": {
			"v": 1.1,
			"r": "33",
			"m": 96,
			"y": "2014"
		},
		"IRQ": null,
		"POL": {
			"v": 0.7,
			"r": "13",
			"m": 103,
			"y": "2014"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.9,
			"r": "24",
			"m": 104,
			"y": "2014"
		},
		"PLW": null,
		"GMB": {
			"v": 9.4,
			"r": "109",
			"m": 96,
			"y": "2012"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.5,
			"r": "41",
			"m": 93,
			"y": "2014"
		},
		"GRC": {
			"v": 0.1,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"FSM": null,
		"ALB": {
			"v": 4,
			"r": "81",
			"m": 46,
			"y": "2014"
		},
		"MLI": {
			"v": 10.2,
			"r": "115",
			"m": 100,
			"y": "2012"
		},
		"OMN": {
			"v": 1.1,
			"r": "33",
			"m": 103,
			"y": "2011"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 17.4,
			"y": "2010",
			"m": 104
		},
		"BLR": {
			"v": 3.6,
			"y": "2014",
			"m": 86
		},
		"ITA": {
			"v": 0.8,
			"r": "21",
			"m": 96,
			"y": "2014"
		},
		"NLD": {
			"v": 0.7,
			"r": "13",
			"m": 103,
			"y": "2013"
		},
		"BGD": {
			"v": 2.8,
			"r": "64",
			"m": 86,
			"y": "2014"
		},
		"AUT": {
			"v": 0.5,
			"r": "6",
			"m": 80,
			"y": "2014"
		},
		"QAT": {
			"v": 7.2,
			"r": "96",
			"m": 103,
			"y": "2012"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.7,
			"r": "60",
			"m": 100,
			"y": "2011"
		},
		"ATG": null,
		"AFG": {
			"v": 6.6,
			"y": "2012",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 4.3,
			"r": "83",
			"m": 98,
			"y": "2014"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 8.8,
			"r": "107",
			"m": 103,
			"y": "2014"
		},
		"LCA": null,
		"SAU": {
			"v": 6.2,
			"r": "91",
			"m": 104,
			"y": "2012"
		},
		"GRL": null,
		"GEO": {
			"v": 2.7,
			"r": "60",
			"m": 95,
			"y": "2014"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.8,
			"r": "89",
			"m": 105,
			"y": "2010"
		},
		"MRT": {
			"v": 11.4,
			"r": "116",
			"m": 100,
			"y": "2012"
		},
		"DMA": null,
		"BFA": {
			"v": 0.7,
			"y": "2012",
			"m": 84
		},
		"IND": {
			"v": 3.2,
			"r": "70",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 3.1,
			"r": "68",
			"m": 104,
			"y": "2012"
		},
		"SRB": {
			"v": 1.3,
			"r": "37",
			"m": 104,
			"y": "2014"
		},
		"GHA": {
			"v": 1.7,
			"r": "49",
			"m": 95,
			"y": "2011"
		},
		"RUS": {
			"v": 9.5,
			"r": "111",
			"m": 103,
			"y": "2014"
		},
		"EST": {
			"v": 3.1,
			"r": "68",
			"m": 94,
			"y": "2014"
		},
		"SMR": null,
		"CHN": {
			"v": 0.8,
			"r": "21",
			"m": 91,
			"y": "2012"
		},
		"NIU": null,
		"USA": {
			"v": 3.9,
			"r": "78",
			"m": 105,
			"y": "2013"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.3,
			"r": "83",
			"m": 104,
			"y": "2012"
		},
		"JPN": {
			"v": 0.3,
			"r": "3",
			"m": 96,
			"y": "2014"
		},
		"PER": {
			"v": 6.7,
			"r": "93",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 0.9,
			"r": "24",
			"m": 92,
			"y": "2014"
		},
		"STP": null,
		"UKR": {
			"v": 4.4,
			"r": "85",
			"m": 105,
			"y": "2010"
		},
		"SGP": {
			"v": 0.3,
			"r": "3",
			"m": 104,
			"y": "2014"
		},
		"GRD": null,
		"BEN": {
			"v": 6.3,
			"r": "92",
			"m": 83,
			"y": "2012"
		},
		"COL": {
			"v": 27.9,
			"r": "129",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 0.3,
			"r": "3",
			"m": 96,
			"y": "2013"
		},
		"LAO": {
			"v": 7.3,
			"r": "97",
			"m": 98,
			"y": "2012"
		},
		"FLK": null,
		"LUX": {
			"v": 0.7,
			"r": "13",
			"m": 100,
			"y": "2014"
		},
		"ERI": null,
		"NAM": {
			"v": 16.9,
			"r": "124",
			"m": 101,
			"y": "2012"
		},
		"SLE": {
			"v": 1.9,
			"r": "55",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 0.7,
			"r": "13",
			"m": 71,
			"y": "2014"
		},
		"GNB": null,
		"BIH": {
			"v": 1.3,
			"r": "37",
			"m": 86,
			"y": "2014"
		},
		"MMR": {
			"v": 2.5,
			"y": "2012",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 6.7,
			"r": "93",
			"m": 105,
			"y": "2012"
		},
		"KWT": {
			"v": 1.8,
			"r": "51",
			"m": 97,
			"y": "2012"
		},
		"ESH": null,
		"SEN": {
			"v": 7.9,
			"r": "103",
			"m": 104,
			"y": "2012"
		},
		"CMR": {
			"v": 2.7,
			"r": "60",
			"m": 92,
			"y": "2012"
		},
		"MNG": {
			"v": 7.5,
			"r": "99",
			"m": 100,
			"y": "2014"
		},
		"TLS": {
			"v": 3.7,
			"y": "2010",
			"m": 104
		},
		"TZA": {
			"v": 7.9,
			"r": "103",
			"m": 104,
			"y": "2012"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.6,
			"r": "11",
			"m": 100,
			"y": "2010"
		},
		"BLM": null,
		"CAN": {
			"v": 1.5,
			"r": "41",
			"m": 91,
			"y": "2014"
		},
		"NZL": {
			"v": 0.9,
			"r": "24",
			"m": 103,
			"y": "2014"
		},
		"TWN": {
			"v": 3,
			"r": "67",
			"m": 104,
			"y": "2011"
		},
		"BRB": {
			"v": 8.8,
			"y": "2014",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"LINERSHIPIDX": {
		"UNK": null,
		"NOR": {
			"v": 5.89,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 32.51,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 8.46,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": {
			"v": 26.48,
			"r": "55",
			"m": 86,
			"y": "2016"
		},
		"ETH": null,
		"ECU": {
			"v": 31.36,
			"r": "49",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 83.9,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 115.61,
			"r": "3",
			"m": 97,
			"y": "2016"
		},
		"AZE": null,
		"JAM": {
			"v": 20.05,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 34.93,
			"r": "45",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 57.68,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 20.3,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 106.79,
			"r": "4",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": {
			"v": 9.51,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 8.84,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"MKD": null,
		"ISR": {
			"v": 37.36,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 5.61,
			"r": "93",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 17.81,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 13.66,
			"r": "70",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 50.88,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 8.93,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.22,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 29.89,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.86,
			"r": "101",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 36.3,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.62,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 5.76,
			"r": "91",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.1,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 29.67,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 21.93,
			"r": "59",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 48.16,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 9.64,
			"r": "77",
			"m": 94,
			"y": "2016"
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": {
			"v": 7.78,
			"r": "85",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.19,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 24.63,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 7.8,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 62.5,
			"r": "20",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.86,
			"r": "98",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 36.58,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 44.32,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"KGZ": null,
		"LBY": {
			"v": 4.86,
			"y": "2016",
			"m": 100
		},
		"CHE": null,
		"MAC": null,
		"BRA": {
			"v": 39.93,
			"r": "37",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 29.27,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 11.49,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"RWA": null,
		"ATA": null,
		"SVN": {
			"v": 33.23,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.52,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 4.98,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 24.55,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 17.39,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 53.42,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 88.64,
			"r": "10",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 9.38,
			"r": "80",
			"m": 94,
			"y": "2016"
		},
		"TJK": null,
		"AUS": {
			"v": 30.64,
			"r": "50",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 64.72,
			"r": "17",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": null,
		"SYC": {
			"v": 7.92,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 22.01,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 86.13,
			"r": "11",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 36.38,
			"r": "42",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 97.23,
			"r": "8",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": {
			"v": 27.19,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 54.85,
			"r": "24",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 9.96,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 8.92,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 63.21,
			"r": "18",
			"m": 100,
			"y": "2016"
		},
		"BOL": null,
		"NFK": null,
		"HKG": {
			"v": 101.02,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 4.07,
			"r": "100",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 37.1,
			"r": "40",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 62.84,
			"r": "19",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 19.32,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": {
			"v": 6.31,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 9.49,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 52.5,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 58.84,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 6.04,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.55,
			"r": "94",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 47.41,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.37,
			"r": "103",
			"m": 62,
			"y": "2016"
		},
		"MLI": null,
		"OMN": {
			"v": 47.35,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 67.41,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 95.73,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 12.62,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"AUT": null,
		"QAT": {
			"v": 5.2,
			"r": "97",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 28.64,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 35.1,
			"r": "44",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": {
			"v": 61.79,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.73,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": null,
		"MRT": {
			"v": 6.26,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 46.24,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 5.35,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.96,
			"y": "2007",
			"m": 104
		},
		"GHA": {
			"v": 20.7,
			"r": "61",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 42.57,
			"r": "36",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.4,
			"r": "95",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 167.48,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 98.7,
			"r": "6",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 49.61,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 78.9,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 37.8,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 97.75,
			"r": "7",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 31.37,
			"r": "48",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 122.7,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 18.34,
			"r": "65",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 52.98,
			"r": "26",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.36,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": {
			"v": 14.32,
			"r": "69",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 7.61,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 70.57,
			"r": "15",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": null,
		"MMR": {
			"v": 6.37,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": null,
		"KWT": {
			"v": 8.89,
			"r": "82",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 12.77,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 15.01,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MNG": null,
		"TLS": null,
		"TZA": {
			"v": 9.67,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 10.73,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 42.64,
			"r": "35",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 20.81,
			"r": "60",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 75.75,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.92,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"BBSUBPC": {
		"UNK": null,
		"NOR": {
			"v": 38.94,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 23.18,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 8.24,
			"r": "73",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 27.9,
			"r": "25",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.03,
			"r": "131",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 18.61,
			"r": "47",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0.66,
			"r": "111",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 9.17,
			"r": "71",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 41.34,
			"r": "4",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 40.25,
			"r": "5",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 19.76,
			"r": "44",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 5.83,
			"r": "81",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 26.27,
			"r": "33",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 37.85,
			"r": "7",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.83,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 8.95,
			"r": "72",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 9.58,
			"r": "69",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 0.08,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 1.86,
			"r": "98",
			"m": 102,
			"y": "2015"
		},
		"MKD": {
			"v": 17.19,
			"r": "50",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 27.44,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 0.53,
			"r": "113",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.4,
			"r": "91",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 0.28,
			"r": "117",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 0.1,
			"r": "125",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 11.65,
			"r": "64",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 5.49,
			"r": "84",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 27.79,
			"r": "27",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 19.77,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 7.99,
			"r": "75",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 15.17,
			"r": "56",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 25.09,
			"r": "34",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 1.55,
			"r": "102",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 3.26,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.67,
			"y": "2015",
			"m": 17
		},
		"NGA": {
			"v": 0.01,
			"r": "133",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 29.62,
			"r": "21",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 31.7,
			"r": "16",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 1.06,
			"r": "107",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.32,
			"r": "116",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.16,
			"r": "123",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 18.08,
			"r": "49",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 10.86,
			"r": "67",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 0,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 4.52,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 22.41,
			"r": "40",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 0.95,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 9.24,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 3.71,
			"r": "89",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 0.97,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 44.79,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 12.24,
			"r": "61",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 4.16,
			"r": "88",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 11.17,
			"r": "65",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 0.17,
			"r": "122",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 27.63,
			"r": "29",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 6.65,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 9.61,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 6.44,
			"r": "79",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 20.68,
			"r": "42",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 6.02,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 7.93,
			"r": "76",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 36.85,
			"r": "11",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0.63,
			"r": "112",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 0.07,
			"r": "128",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 27.85,
			"r": "26",
			"m": 79,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.38,
			"r": "92",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 27.43,
			"r": "31",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 14.31,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 0.52,
			"r": "115",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 28.31,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.56,
			"r": "90",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 16.08,
			"r": "53",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 37.72,
			"r": "8",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 13.05,
			"r": "58",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 1.79,
			"r": "99",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 15.55,
			"r": "55",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 1.09,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 42.51,
			"r": "2",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.34,
			"r": "97",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 0.01,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 3.1,
			"r": "94",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 1.64,
			"r": "101",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 31.94,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0,
			"r": "135",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 5.25,
			"r": "85",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 8.14,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 22.38,
			"r": "41",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 23.34,
			"r": "37",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 0.08,
			"r": "126",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 0.01,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 27.71,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 19.47,
			"r": "45",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 36.07,
			"r": "14",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 0.18,
			"r": "121",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.57,
			"r": "83",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 30.73,
			"r": "19",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 7.6,
			"r": "77",
			"m": 49,
			"y": "2015"
		},
		"MLI": {
			"v": 0.02,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 5.61,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.47,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 31.36,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 23.8,
			"r": "36",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 41.73,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.41,
			"r": "96",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 28.58,
			"r": "23",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 10.06,
			"r": "68",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 15.74,
			"r": "54",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 0.33,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 22.76,
			"r": "39",
			"m": 98,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.14,
			"r": "93",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 12.01,
			"r": "62",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 14.63,
			"r": "57",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 0.15,
			"r": "124",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 0.24,
			"r": "119",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 0.04,
			"y": "2015",
			"m": 85
		},
		"IND": {
			"v": 1.34,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 4.34,
			"r": "87",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 16.75,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0.28,
			"r": "118",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 18.77,
			"r": "46",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 28.68,
			"r": "22",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 18.56,
			"r": "48",
			"m": 91,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 31.53,
			"r": "18",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 12.39,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 30.49,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 6.42,
			"r": "80",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 37.19,
			"r": "9",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 11.81,
			"r": "63",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 26.45,
			"r": "32",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 0.67,
			"r": "109",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 11.16,
			"r": "66",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 36.95,
			"r": "10",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 0.52,
			"r": "114",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 36.48,
			"r": "12",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 1.72,
			"r": "100",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0,
			"r": "134",
			"m": 104,
			"y": "2007"
		},
		"ARE": {
			"v": 12.81,
			"r": "59",
			"m": 73,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 16.62,
			"r": "52",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 0.06,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.09,
			"r": "105",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 1.37,
			"r": "103",
			"m": 97,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 0.67,
			"r": "110",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 0.07,
			"r": "129",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 7.12,
			"r": "78",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 0.09,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 0.2,
			"r": "120",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.07,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 36.41,
			"r": "13",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 31.55,
			"r": "17",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 24.26,
			"r": "35",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 27.23,
			"y": "2015",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"inv_community": {
		"UNK": null,
		"NOR": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.25,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.6,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.25,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.6,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.25,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.25,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.4,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.25,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.4,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.6,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.5,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.25,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.8,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.33,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.67,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.6,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.75,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.4,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.6,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.2,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.75,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.5,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.6,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.6,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.25,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 0.75,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.6,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.6,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.25,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.4,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.25,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.75,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.5,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.8,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.4,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.6,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.4,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1.5,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.25,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.33,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.75,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.67,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.6,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.8,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 8": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 11": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 1": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 2": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"DBENFORCECONTRACTS": {
		"UNK": null,
		"NOR": {
			"v": 78.99,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 75.87,
			"r": "7",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 48.97,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 60.36,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 45.74,
			"r": "114",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 54.53,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 59.06,
			"r": "66",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 56.68,
			"r": "79",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 73.04,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 84.15,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 65.66,
			"r": "40",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 53.6,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 54.44,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 62.17,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 34.55,
			"r": "130",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 66.61,
			"r": "39",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 69.71,
			"r": "27",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 27.32,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 58.58,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 67.79,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 57.93,
			"r": "74",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 32.67,
			"r": "134",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 49.24,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 58.27,
			"r": "72",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 57.18,
			"r": "77",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 67.01,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 55.2,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 77.88,
			"r": "6",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 71.08,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 57.25,
			"r": "76",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 62.81,
			"r": "49",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 71.66,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 48.52,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 65.76,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 26.26,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 48.59,
			"r": "107",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 73.01,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 69.4,
			"r": "29",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 45.26,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 60.6,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 33.92,
			"r": "132",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 66.75,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 60,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 46.48,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 50.11,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 40.9,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 65.09,
			"r": "43",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 43.49,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 64.54,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 48.57,
			"r": "109",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 48.41,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 67.1,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 67.41,
			"r": "35",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 52.42,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 52.41,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 56.76,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 52.97,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 57.62,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 25.94,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 51.03,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 36.55,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 67.26,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 48.1,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 64.25,
			"r": "46",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 32.84,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 63.49,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 79.72,
			"r": "3",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 62.34,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 75.79,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 51.25,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 55.74,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 69.48,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 65.36,
			"r": "41",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 64.81,
			"r": "44",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 69.36,
			"r": "30",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 75.7,
			"r": "9",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 50.95,
			"r": "102",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 60.87,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 38.15,
			"r": "125",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 71.23,
			"r": "24",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 45.54,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 53.87,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 39.31,
			"r": "123",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 51.57,
			"r": "100",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 72.57,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 36.06,
			"r": "128",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 54.1,
			"r": "91",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 60.22,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 48.59,
			"r": "107",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 58.92,
			"r": "68",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 44.58,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 52.49,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 57.88,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 63.44,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 72.04,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 54.84,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 55.49,
			"r": "83",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 50.19,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 53.66,
			"r": "93",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 43.73,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 61.55,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 33.94,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 70.36,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 54.79,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 59.94,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 22.21,
			"r": "136",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 75.49,
			"r": "10",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 52.79,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 68.65,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 31.76,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 51.7,
			"r": "99",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 59.77,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 55.07,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 73.21,
			"r": "16",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 49.89,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 58.58,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 41.05,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 35.19,
			"r": "129",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 59.33,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 61.41,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 54,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 74.96,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 75.16,
			"r": "11",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 77.98,
			"r": "5",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 72.61,
			"r": "20",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 68.87,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 65.26,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 60.7,
			"r": "56",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 73.17,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 58.96,
			"r": "67",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 83.61,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 36.34,
			"r": "127",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 34.29,
			"r": "131",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 69.1,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 58.07,
			"r": "73",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 73.32,
			"r": "15",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 56.03,
			"r": "80",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 55.92,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 71.14,
			"r": "25",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 60.6,
			"r": "57",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 24.53,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 38.73,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 60.51,
			"r": "59",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 48.15,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 41.76,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 58.48,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 6.13,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 61.66,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 42.85,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 54.35,
			"r": "90",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 74.25,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 73.49,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 38.02,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"adv_rulings": {
		"UNK": null,
		"NOR": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.57,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.14,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.44,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.33,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 0.86,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0.5,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.3,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 2,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.14,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.43,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.86,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.11,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1.29,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.57,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.44,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.86,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 0.67,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.2,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.29,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.33,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.3,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.62,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.33,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.5,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.86,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 2,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.29,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.83,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.57,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.71,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 0.33,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.3,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.29,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.86,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.33,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.56,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.33,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.83,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 0,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.57,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.14,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 0.86,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.14,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 0.33,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.86,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.57,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 1.56,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.62,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.29,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.71,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.44,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 2,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 1.17,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.7,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.8,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.56,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 0,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.33,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.29,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.29,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.33,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.4,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.43,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.7,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.9,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.33,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.57,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.3,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 0,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.86,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.86,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.75,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.2,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.86,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.86,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 3.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 4.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 1.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 2.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 1.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 4.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 6.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 3.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 1.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 4.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 5.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TABCOSTIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 400,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 1025,
			"r": "135",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 130,
			"r": "81",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 750,
			"r": "130",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 75,
			"r": "55",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 26.75,
			"r": "32",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 200,
			"r": "103",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 90,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 285,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 140,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 60,
			"r": "49",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 100,
			"r": "68",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 171,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 86.11,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 50,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 70,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 120,
			"r": "78",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 50,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 115,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 90,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 100,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 66.67,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 125,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 460,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 564.29,
			"r": "128",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 80,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 295.62,
			"r": "113",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 527.5,
			"r": "125",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 100,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 196.67,
			"r": "102",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 161.54,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 75,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 1000,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0,
			"r": "1",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 785.71,
			"r": "131",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 43.45,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 200,
			"r": "103",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 60,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 75,
			"r": "55",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 106.94,
			"r": "74",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 30,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 75,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 121.07,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 63,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 40,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 40,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 250,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 292,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 50,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 170,
			"r": "96",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 260,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 100,
			"r": "68",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 116.44,
			"r": "77",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 93,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 266.67,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 120,
			"r": "78",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 66.62,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 41.11,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 164.4,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 70,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 180,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 282.78,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 30,
			"r": "33",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 56.8,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 875,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 213.33,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 182.5,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 50,
			"r": "40",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 500,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 150,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 75,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 151.88,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 399.78,
			"r": "120",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 10,
			"r": "30",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 375,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 20,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 76,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 0,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 370,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 616.89,
			"r": "129",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 165.62,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 900,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 135,
			"r": "83",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 135,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 390.38,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 189,
			"r": "101",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 175,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 400,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 197,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 134.83,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 144.44,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 35,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 474,
			"r": "123",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 152.5,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 170.89,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 100,
			"r": "68",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 141.62,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 100,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 80,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 212,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 40,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 529,
			"r": "126",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 50,
			"r": "40",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 115,
			"r": "75",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 62.5,
			"r": "50",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 387.14,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 283.33,
			"r": "111",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 96.5,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 210,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 150,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 331.82,
			"r": "114",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 545,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 849,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 82.56,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 115,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 375,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 149.55,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 162.5,
			"r": "93",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 80,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 90.15,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 146,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"form_proc": {
		"UNK": null,
		"NOR": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.27,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 0.94,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 1,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.41,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.36,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.13,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.44,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.5,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.7,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 1.1,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 0.87,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.47,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 0.79,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1.12,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.31,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.8,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.36,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 0.86,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.86,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 0.75,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 0.88,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.47,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.73,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.88,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.33,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.41,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.47,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.85,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.12,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.55,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.93,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.38,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.62,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.31,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.27,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.35,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.33,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.2,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.47,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.22,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.44,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.38,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.56,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.07,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.25,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.62,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.27,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.35,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.13,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.12,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1.14,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.89,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.4,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.22,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.47,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 0.89,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.27,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.75,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.4,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.07,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.8,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.6,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.31,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.44,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.29,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.44,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.18,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.12,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.41,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.69,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.2,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1.36,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.44,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.07,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.18,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.14,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.53,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.87,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 0.93,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.25,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.69,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.27,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0.47,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.53,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1.07,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 0.73,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.06,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.27,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.18,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.69,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.8,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1.38,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.31,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1.12,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.12,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.07,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.2,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.79,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.88,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.81,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.4,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.3,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.64,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.87,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.88,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"NETUSERPCT": {
		"UNK": null,
		"NOR": {
			"v": 96.81,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 69.8,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 61.87,
			"r": "61",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 81.3,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 4.87,
			"r": "132",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 93.48,
			"r": "5",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 11.6,
			"r": "125",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 48.94,
			"r": "80",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 84.69,
			"r": "23",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 89.9,
			"r": "13",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 77,
			"r": "33",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 43.18,
			"r": "88",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 64.6,
			"r": "57",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 76.18,
			"r": "34",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 27.1,
			"r": "98",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 71.06,
			"r": "45",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 58.25,
			"r": "64",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 9,
			"r": "128",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 19.7,
			"r": "112",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 70.38,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 78.89,
			"r": "31",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 19,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 40.7,
			"r": "90",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 45.62,
			"r": "83",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 16.07,
			"r": "122",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 57.43,
			"r": "65",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 26.92,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 71.38,
			"r": "43",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 55.76,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 71.2,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 64.29,
			"r": "59",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 79.2,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 25.1,
			"r": "101",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 43.02,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 12.4,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 47.44,
			"r": "82",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 68.63,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 92.65,
			"r": "9",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 17.58,
			"r": "119",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 19.22,
			"r": "113",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 5.9,
			"r": "130",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 64.56,
			"r": "58",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 44.08,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 9.3,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 41.59,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 35.9,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 56.66,
			"r": "67",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 18,
			"r": "117",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 39.32,
			"r": "92",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 30.25,
			"r": "95",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 19.02,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 87.97,
			"r": "18",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 59.08,
			"r": "63",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 53.4,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 59.76,
			"r": "62",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 18,
			"r": "117",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 73.1,
			"r": "39",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 38.2,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 42.76,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 51.93,
			"r": "73",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 69.2,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 42.8,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 51.21,
			"r": "75",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 85.05,
			"r": "20",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 23.5,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 18.98,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 84.56,
			"r": "24",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 57.08,
			"r": "66",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 72.83,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 58.12,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 21,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 78.69,
			"r": "32",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 39.8,
			"r": "91",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 69.4,
			"r": "49",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 92,
			"r": "10",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 72.87,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 27.5,
			"r": "97",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 49.84,
			"r": "78",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 21.98,
			"r": "105",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 96.33,
			"r": "4",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 20.36,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 4.7,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 29.99,
			"r": "96",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 45.1,
			"r": "85",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 84.95,
			"r": "22",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.8,
			"r": "134",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 51.92,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 52.72,
			"r": "72",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 71.72,
			"r": "42",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 85.02,
			"r": "21",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.7,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 12.2,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 80.12,
			"r": "29",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 68,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 90.61,
			"r": "12",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 17.12,
			"r": "120",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 38.2,
			"r": "93",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 66.83,
			"r": "53",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 63.25,
			"r": "60",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 10.34,
			"r": "126",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 74.17,
			"r": "36",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 30.38,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 62.23,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 65.57,
			"r": "54",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 93.1,
			"r": "7",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 14.4,
			"r": "124",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 83.93,
			"r": "25",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 92.88,
			"r": "8",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 50.14,
			"r": "77",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 8.26,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 74,
			"r": "37",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 44.38,
			"r": "86",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 69.62,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 45.16,
			"r": "84",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 21,
			"r": "108",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 15.2,
			"r": "123",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 11.39,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 26,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 48.52,
			"r": "81",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 65.32,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 23.48,
			"r": "103",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 73.41,
			"r": "38",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 88.41,
			"r": "15",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 50.3,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 74.55,
			"r": "35",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 53.74,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 93.33,
			"r": "6",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 40.9,
			"r": "89",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 87.59,
			"r": "19",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 49.26,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 82.1,
			"r": "26",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 6.79,
			"r": "129",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 55.9,
			"r": "68",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 98.2,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 18.2,
			"r": "116",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 97.33,
			"r": "2",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 22.31,
			"r": "104",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.5,
			"r": "136",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 91.24,
			"r": "11",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 65.07,
			"r": "56",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 21.8,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 16.36,
			"r": "121",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 82.08,
			"r": "27",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 21.69,
			"r": "106",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 20.68,
			"r": "110",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 21.44,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 13.4,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 5.36,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.17,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 88.47,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 88.22,
			"r": "16",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 87.98,
			"r": "17",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 76.11,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETIC0401": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ061": {
		"UNK": null,
		"NOR": {
			"v": 5.84,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.14,
			"r": "78",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.69,
			"r": "129",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.34,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.59,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.87,
			"r": "46",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.67,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 5.14,
			"r": "39",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.87,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.69,
			"r": "21",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.32,
			"r": "36",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 5.02,
			"r": "41",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.44,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.56,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.87,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.7,
			"r": "20",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.38,
			"r": "67",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.56,
			"r": "25",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.41,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.55,
			"r": "109",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.78,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.4,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.85,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.25,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.84,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 1.05,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.58,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.3,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.36,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.75,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.08,
			"r": "84",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.85,
			"r": "47",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.14,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.22,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.74,
			"r": "102",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 3.3,
			"r": "117",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.2,
			"r": "119",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.44,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.24,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.65,
			"r": "131",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.19,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.25,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.1,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.43,
			"r": "111",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.36,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 4.39,
			"r": "76",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 4.77,
			"r": "52",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.14,
			"r": "77",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.99,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.95,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.88,
			"r": "126",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.42,
			"r": "139",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.11,
			"r": "8",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.92,
			"r": "95",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.33,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.61,
			"r": "59",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.65,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.34,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.83,
			"r": "93",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.64,
			"r": "104",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.81,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.28,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 5.28,
			"r": "44",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 6.21,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.22,
			"r": "125",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.7,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.62,
			"r": "108",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.34,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.28,
			"r": "37",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.73,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.3,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.91,
			"r": "47",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 5.24,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.85,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.69,
			"r": "104",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.06,
			"r": "87",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.76,
			"r": "18",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.01,
			"r": "90",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.01,
			"r": "89",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.92,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.52,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.83,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.08,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.49,
			"r": "136",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.62,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.91,
			"r": "96",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.62,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.78,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.99,
			"r": "10",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.06,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.92,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.43,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.95,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.89,
			"r": "127",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.57,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.32,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.68,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.13,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.24,
			"r": "117",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.94,
			"r": "43",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.36,
			"r": "68",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.51,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.74,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.56,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.6,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.46,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.25,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.32,
			"r": "35",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.2,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.75,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.09,
			"r": "82",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.64,
			"r": "132",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.88,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.04,
			"r": "88",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.18,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.38,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.03,
			"r": "126",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.49,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.87,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.95,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.95,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.44,
			"r": "65",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.45,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.81,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.09,
			"r": "9",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.41,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.59,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.13,
			"r": "80",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.89,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.72,
			"r": "103",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.85,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.23,
			"r": "118",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.21,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.96,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.77,
			"r": "100",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.47,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.63,
			"r": "57",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.69,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.75,
			"r": "2",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.6,
			"r": "133",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.62,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.63,
			"r": "107",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.64,
			"r": "106",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.06,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.66,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.11,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.16,
			"r": "143",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.17,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.17,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.84,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.66,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.33,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.34,
			"r": "32",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIC04": {
		"UNK": null,
		"NOR": {
			"v": 3.7,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.66,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.42,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.11,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.42,
			"r": "123",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.04,
			"r": "40",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.23,
			"r": "80",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "48",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.13,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.71,
			"r": "11",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.99,
			"r": "42",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.38,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.09,
			"r": "87",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.86,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.7,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.02,
			"r": "17",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.87,
			"r": "98",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.64,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.73,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.31,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.16,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 2.57,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.55,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.33,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.24,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.2,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.15,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.94,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.98,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.39,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 3.9,
			"r": "46",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.72,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.12,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 2.55,
			"r": "117",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.75,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 4.89,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.06,
			"r": "135",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.57,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.67,
			"r": "107",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.73,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.49,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.4,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.73,
			"r": "56",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 3.12,
			"r": "85",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.17,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.18,
			"r": "132",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.33,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.22,
			"r": "82",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 3.59,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.57,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.28,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.64,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.82,
			"r": "54",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.01,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.51,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.25,
			"r": "15",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.49,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.01,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.87,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.33,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.63,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.67,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.09,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.21,
			"r": "131",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.41,
			"r": "73",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.73,
			"r": "10",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.53,
			"r": "67",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.52,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.74,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.59,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.88,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.11,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.91,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.48,
			"r": "120",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.4,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.03,
			"r": "136",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.52,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.58,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.84,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.67,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.42,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 4.11,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.88,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.81,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.22,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3,
			"r": "92",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.86,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 2.64,
			"r": "111",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 2.63,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.5,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.79,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.04,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.66,
			"r": "109",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.7,
			"r": "24",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.63,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.74,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.19,
			"r": "83",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.67,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.5,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.35,
			"r": "76",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.79,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.22,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.53,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.96,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.92,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 2.85,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.14,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 3.84,
			"r": "53",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.58,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.08,
			"r": "7",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.54,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.1,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.96,
			"r": "95",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.05,
			"r": "8",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.43,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.69,
			"r": "106",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.96,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.94,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.41,
			"r": "125",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.58,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.87,
			"r": "49",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.55,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.34,
			"r": "2",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.36,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.07,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.43,
			"r": "71",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.42,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.37,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.75,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.16,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.29,
			"r": "14",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.03,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.22,
			"r": "16",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIA01": {
		"UNK": null,
		"NOR": {
			"v": 5.22,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.43,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.81,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.41,
			"r": "32",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.88,
			"r": "82",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.22,
			"r": "59",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.34,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.2,
			"r": "106",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.34,
			"r": "46",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.73,
			"r": "85",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.3,
			"r": "102",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.28,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.95,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.21,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 6.09,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.35,
			"r": "43",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.42,
			"r": "99",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 4.91,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 5.92,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 5.52,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.73,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.19,
			"r": "107",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.57,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.44,
			"r": "98",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.17,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 5.93,
			"r": "10",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 5.88,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.36,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.42,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 6.02,
			"r": "7",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 6.41,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.39,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 4.47,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.7,
			"r": "120",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.41,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.36,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.9,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.73,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.33,
			"r": "129",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 5.64,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 2.39,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.83,
			"r": "83",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.83,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5.39,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.01,
			"r": "133",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.67,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.62,
			"r": "122",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 4.6,
			"r": "90",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.97,
			"r": "109",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.9,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.9,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.78,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.38,
			"r": "37",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 5.17,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.34,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.98,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.29,
			"r": "53",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.51,
			"r": "125",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.45,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.82,
			"r": "15",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.57,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.37,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.79,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.29,
			"r": "52",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.11,
			"r": "108",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.24,
			"r": "105",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.21,
			"r": "60",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.85,
			"r": "111",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 5.38,
			"r": "38",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 5.16,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.41,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.3,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 5.8,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.76,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.55,
			"r": "92",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.56,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.95,
			"r": "76",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.94,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.34,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.42,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.28,
			"r": "130",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.31,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.35,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.28,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.41,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.69,
			"r": "121",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 5.33,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6,
			"r": "8",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 4.26,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5.46,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.28,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.19,
			"r": "62",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.37,
			"r": "127",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.43,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.05,
			"r": "71",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 6.15,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.47,
			"r": "96",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.16,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.89,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.93,
			"r": "9",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.94,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.75,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.84,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.98,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.6,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.86,
			"r": "110",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.85,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.4,
			"r": "34",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.33,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.26,
			"r": "56",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.69,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.34,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.83,
			"r": "14",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.29,
			"r": "51",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.47,
			"r": "24",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.97,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.78,
			"r": "116",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 5.16,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.68,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 5.16,
			"r": "67",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.4,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.34,
			"r": "45",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.06,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.09,
			"r": "70",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.26,
			"r": "57",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.51,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.16,
			"r": "66",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.75,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.02,
			"r": "132",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.47,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.63,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.5,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.63,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.08,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.96,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"appeal_proc": {
		"UNK": null,
		"NOR": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.25,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.38,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.12,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.67,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.57,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.75,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.5,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.62,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.12,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.5,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.38,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.83,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.43,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.38,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.62,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.62,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.14,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 1.12,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.33,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.38,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.14,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.25,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 0.88,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 2,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.5,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.43,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1.17,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.5,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.25,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.62,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.43,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1.29,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.29,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.57,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.71,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.86,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.75,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.2,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.88,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.75,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.62,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.67,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 0.88,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.43,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.62,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.88,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.14,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.25,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.17,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1.12,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.12,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.38,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.75,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.38,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.62,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.71,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.5,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0.75,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.57,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 1.12,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.29,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 0.88,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1.14,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.67,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.88,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"EXPTIMECOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"CLEAREFF": {
		"UNK": null,
		"NOR": {
			"v": 3.57,
			"r": "20",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.07,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 1.99,
			"r": "126",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.58,
			"r": "19",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.02,
			"r": "123",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.14,
			"r": "41",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.6,
			"r": "78",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.64,
			"r": "74",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.71,
			"r": "17",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.45,
			"r": "26",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.57,
			"r": "79",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.37,
			"r": "99",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 2.78,
			"r": "59",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 2.78,
			"r": "60",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.47,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.17,
			"r": "40",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.95,
			"r": "129",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.49,
			"r": "85",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.48,
			"r": "86",
			"m": 102,
			"y": "2015"
		},
		"MKD": {
			"v": 2.21,
			"r": "113",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.5,
			"r": "23",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.62,
			"r": "76",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.61,
			"r": "77",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.17,
			"r": "39",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 1.91,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 2.88,
			"r": "54",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.37,
			"r": "97",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.42,
			"r": "28",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3,
			"r": "50",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 2.78,
			"r": "58",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.19,
			"r": "35",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.11,
			"r": "45",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 1.62,
			"r": "136",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.8,
			"y": "2015",
			"m": 17
		},
		"NGA": {
			"v": 2.46,
			"r": "88",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.37,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 4.01,
			"r": "4",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 1.93,
			"r": "130",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.97,
			"r": "51",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.07,
			"r": "121",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.22,
			"r": "111",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.33,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.79,
			"r": "57",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 2.75,
			"r": "66",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.4,
			"r": "91",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.66,
			"r": "72",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.11,
			"r": "46",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 1.8,
			"r": "135",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 1.88,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 3.88,
			"r": "10",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 2.76,
			"r": "63",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 2.55,
			"r": "82",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.33,
			"r": "102",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 2.93,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 2.88,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.4,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.39,
			"r": "94",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.38,
			"r": "96",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.32,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.13,
			"r": "42",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 3.83,
			"r": "13",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.07,
			"r": "120",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 1.93,
			"r": "130",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.54,
			"r": "22",
			"m": 79,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.22,
			"r": "110",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.02,
			"r": "49",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.67,
			"r": "71",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.48,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.21,
			"r": "114",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 2.63,
			"r": "75",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 3.98,
			"r": "5",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.52,
			"r": "83",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.05,
			"r": "48",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.39,
			"r": "92",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 2.69,
			"r": "70",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.82,
			"r": "14",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.21,
			"r": "112",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.28,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.56,
			"r": "81",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 1.97,
			"r": "127",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 3.94,
			"r": "7",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.22,
			"r": "109",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.6,
			"r": "18",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 2.75,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 3.11,
			"r": "44",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.28,
			"r": "32",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.08,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.7,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.47,
			"r": "25",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.27,
			"r": "33",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 3.92,
			"r": "8",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.06,
			"r": "122",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.37,
			"r": "98",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.85,
			"r": "55",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.23,
			"r": "108",
			"m": 50,
			"y": "2015"
		},
		"MLI": {
			"v": 2.45,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 2.76,
			"r": "62",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.06,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.45,
			"r": "27",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.12,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.57,
			"r": "80",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 3.79,
			"r": "15",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.55,
			"r": "21",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.25,
			"r": "106",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.01,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.73,
			"r": "67",
			"m": 98,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.38,
			"r": "95",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 2.69,
			"r": "69",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.26,
			"r": "105",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.25,
			"r": "107",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 2.14,
			"r": "117",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.55,
			"y": "2015",
			"m": 85
		},
		"IND": {
			"v": 3.17,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 1.96,
			"r": "128",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.5,
			"r": "84",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.46,
			"r": "89",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.01,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.41,
			"r": "29",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.32,
			"r": "31",
			"m": 91,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 3.75,
			"r": "16",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.18,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 3.85,
			"r": "11",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.76,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.12,
			"r": "2",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.3,
			"r": "104",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.18,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.2,
			"r": "116",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.21,
			"r": "115",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.13,
			"r": "43",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 1.85,
			"r": "134",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 3.9,
			"r": "9",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.65,
			"r": "73",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 1.91,
			"r": "133",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.84,
			"r": "12",
			"m": 73,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.69,
			"r": "68",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.43,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2,
			"r": "125",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 2.83,
			"r": "56",
			"m": 97,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.31,
			"r": "103",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.09,
			"r": "118",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.39,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.78,
			"r": "61",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.33,
			"r": "101",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 3.95,
			"r": "6",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.18,
			"r": "37",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.23,
			"r": "34",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"IMPTIMECOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETI": {
		"UNK": null,
		"NOR": {
			"v": 5.27,
			"r": "17",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.76,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.85,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.12,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.41,
			"r": "125",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.79,
			"r": "42",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.72,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.14,
			"r": "81",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.37,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.04,
			"r": "27",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.3,
			"r": "71",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.03,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.37,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.95,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.32,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.9,
			"r": "37",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.32,
			"r": "68",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.88,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.24,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.52,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.99,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.96,
			"r": "98",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.13,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.2,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.15,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.55,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.25,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.01,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.61,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.27,
			"r": "72",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.26,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.86,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.95,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.25,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.01,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.6,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.84,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.11,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.53,
			"r": "120",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.46,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.16,
			"r": "132",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.93,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.72,
			"r": "116",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.54,
			"r": "53",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.51,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.45,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.76,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.45,
			"r": "11",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.8,
			"r": "110",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.73,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.52,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.59,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.96,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.2,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.86,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.52,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.45,
			"r": "10",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.24,
			"r": "129",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.74,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.1,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.6,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.89,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.87,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.28,
			"r": "15",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.98,
			"r": "92",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.98,
			"r": "94",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.52,
			"r": "8",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.05,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.41,
			"r": "65",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.2,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.3,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.42,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.08,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.9,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.78,
			"r": "112",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.66,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.03,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.52,
			"r": "55",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.26,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.61,
			"r": "47",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.93,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.93,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.27,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.96,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.61,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.95,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.51,
			"r": "121",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.55,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.51,
			"r": "60",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.71,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.67,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.91,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.7,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.48,
			"r": "123",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.52,
			"r": "7",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.78,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.89,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.03,
			"r": "90",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.86,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.33,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.8,
			"r": "41",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.97,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.18,
			"r": "131",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 3.91,
			"r": "102",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.02,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.41,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.93,
			"r": "100",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.79,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.32,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.49,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.24,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.52,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.28,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.54,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.49,
			"r": "9",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.97,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.97,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.48,
			"r": "124",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.1,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.27,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.98,
			"r": "93",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.63,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.25,
			"r": "75",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.25,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.23,
			"r": "23",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.12,
			"r": "83",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.4,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.07,
			"r": "87",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.97,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.2,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.66,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.74,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.8,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.15,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.27,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.92,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ058": {
		"UNK": null,
		"NOR": {
			"v": 3.62,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.73,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.48,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.55,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"BDI": null,
		"BHR": null,
		"ETH": {
			"v": 3.4,
			"r": "53",
			"m": 94,
			"y": "2016"
		},
		"ECU": null,
		"FRA": {
			"v": 5.84,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.52,
			"r": "9",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.15,
			"r": "31",
			"m": 81,
			"y": "2016"
		},
		"JAM": null,
		"SLB": null,
		"URY": {
			"v": 1.23,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": {
			"v": 5.06,
			"r": "15",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.74,
			"r": "75",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 2.99,
			"r": "57",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.43,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"NIC": null,
		"MKD": {
			"v": 2.74,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.48,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 1.62,
			"r": "117",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.97,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.84,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 2.91,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"SLV": null,
		"CYM": null,
		"LTU": {
			"v": 4.46,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.4,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"BRN": null,
		"CHL": {
			"v": 2.39,
			"r": "93",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.08,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 1.48,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.16,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.66,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.59,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.76,
			"r": "74",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.91,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.48,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.84,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1.42,
			"r": "125",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 2.61,
			"r": "82",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.05,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.08,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 2.52,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.37,
			"r": "94",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.57,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.89,
			"r": "109",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 2.53,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.76,
			"r": "114",
			"m": 92,
			"y": "2016"
		},
		"RWA": null,
		"ATA": null,
		"SVN": {
			"v": 2.97,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.42,
			"r": "24",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.25,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.89,
			"r": "58",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.88,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.8,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.74,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.96,
			"r": "39",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.92,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.55,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 2.67,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.59,
			"r": "8",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 2.13,
			"r": "101",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.78,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.26,
			"r": "28",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.24,
			"r": "56",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.7,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.82,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.7,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.42,
			"r": "122",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.59,
			"r": "47",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 1.91,
			"r": "108",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.36,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 1.54,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.8,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.15,
			"r": "58",
			"m": 105,
			"y": "2016"
		},
		"CYP": null,
		"TCA": null,
		"SVK": {
			"v": 4.58,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 3.98,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.34,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.11,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.97,
			"r": "64",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.84,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 1.35,
			"r": "130",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 2.19,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.1,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.11,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.64,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.65,
			"r": "81",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.32,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": {
			"v": 2.99,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.85,
			"r": "41",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.57,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.97,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 1.83,
			"r": "109",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.48,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.81,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.15,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 1.77,
			"r": "113",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.44,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.02,
			"r": "35",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.07,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.13,
			"r": "13",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.03,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.66,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 1.92,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.36,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.01,
			"r": "36",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.74,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 1.56,
			"r": "119",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 1.4,
			"r": "128",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 5.06,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.24,
			"r": "55",
			"m": 102,
			"y": "2016"
		},
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": {
			"v": 2.05,
			"r": "102",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 1.79,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.28,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"KWT": null,
		"ESH": null,
		"SEN": {
			"v": 2.17,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.36,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.73,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.53,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.81,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.83,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3.41,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.39,
			"r": "10",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ394": {
		"UNK": null,
		"NOR": {
			"v": 6.18,
			"r": "14",
			"m": 103,
			"y": "2014"
		},
		"HRV": {
			"v": 5.65,
			"r": "34",
			"m": 96,
			"y": "2014"
		},
		"VEN": {
			"v": 1.95,
			"r": "142",
			"m": 105,
			"y": "2014"
		},
		"TON": null,
		"CZE": {
			"v": 5.6,
			"r": "36",
			"m": 92,
			"y": "2014"
		},
		"BDI": {
			"v": 3.77,
			"r": "103",
			"m": 81,
			"y": "2013"
		},
		"BHR": {
			"v": 5.33,
			"r": "42",
			"m": 86,
			"y": "2014"
		},
		"ETH": {
			"v": 4.35,
			"r": "86",
			"m": 94,
			"y": "2014"
		},
		"ECU": {
			"v": 4.6,
			"r": "69",
			"m": 94,
			"y": "2013"
		},
		"FRA": {
			"v": 5.84,
			"r": "25",
			"m": 94,
			"y": "2014"
		},
		"SJM": null,
		"KOR": {
			"v": 5.96,
			"r": "24",
			"m": 97,
			"y": "2014"
		},
		"AZE": {
			"v": 4.89,
			"r": "56",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 4.02,
			"r": "94",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 4.22,
			"r": "89",
			"m": 105,
			"y": "2014"
		},
		"MLT": {
			"v": 5.74,
			"r": "32",
			"m": 100,
			"y": "2014"
		},
		"BVT": null,
		"GTM": {
			"v": 4.82,
			"r": "58",
			"m": 96,
			"y": "2014"
		},
		"MYS": {
			"v": 5.59,
			"r": "37",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.73,
			"r": "65",
			"m": 78,
			"y": "2014"
		},
		"PRI": {
			"v": 6.41,
			"r": "5",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.15,
			"r": "125",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 3.46,
			"r": "112",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 4.33,
			"r": "87",
			"m": 100,
			"y": "2014"
		},
		"ISR": {
			"v": 5.33,
			"r": "41",
			"m": 96,
			"y": "2014"
		},
		"KHM": {
			"v": 3.16,
			"r": "124",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.44,
			"r": "113",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 3.86,
			"r": "100",
			"m": 97,
			"y": "2014"
		},
		"COM": null,
		"LSO": {
			"v": 4.36,
			"r": "85",
			"m": 100,
			"y": "2014"
		},
		"MEX": {
			"v": 3.66,
			"r": "109",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 4.58,
			"r": "74",
			"m": 104,
			"y": "2014"
		},
		"CYM": null,
		"LTU": {
			"v": 5.49,
			"r": "39",
			"m": 100,
			"y": "2014"
		},
		"ROU": {
			"v": 4.38,
			"r": "83",
			"m": 103,
			"y": "2014"
		},
		"BRN": {
			"v": 4.51,
			"r": "75",
			"m": 91,
			"y": "2013"
		},
		"CHL": {
			"v": 5.1,
			"r": "47",
			"m": 91,
			"y": "2014"
		},
		"LVA": {
			"v": 5.08,
			"r": "49",
			"m": 100,
			"y": "2014"
		},
		"YEM": {
			"v": 3.29,
			"r": "121",
			"m": 105,
			"y": "2014"
		},
		"CPV": {
			"v": 4.39,
			"r": "82",
			"m": 92,
			"y": "2014"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.9,
			"r": "143",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.88,
			"r": "132",
			"m": 102,
			"y": "2014"
		},
		"PRT": {
			"v": 6.2,
			"r": "12",
			"m": 103,
			"y": "2014"
		},
		"SGS": null,
		"FIN": {
			"v": 6.45,
			"r": "4",
			"m": 94,
			"y": "2014"
		},
		"NPL": {
			"v": 3.42,
			"r": "115",
			"m": 103,
			"y": "2014"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.54,
			"r": "110",
			"m": 105,
			"y": "2014"
		},
		"LBR": {
			"v": 3.31,
			"r": "119",
			"m": 99,
			"y": "2013"
		},
		"MNE": {
			"v": 4.73,
			"r": "64",
			"m": 100,
			"y": "2014"
		},
		"IRN": {
			"v": 4.7,
			"r": "69",
			"m": 96,
			"y": "2014"
		},
		"SPM": null,
		"MWI": {
			"v": 3.9,
			"r": "98",
			"m": 100,
			"y": "2014"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.92,
			"r": "96",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 4.71,
			"r": "68",
			"m": 86,
			"y": "2014"
		},
		"CUB": null,
		"PAK": {
			"v": 4.24,
			"r": "88",
			"m": 103,
			"y": "2014"
		},
		"IMN": null,
		"THA": {
			"v": 5.15,
			"r": "45",
			"m": 104,
			"y": "2014"
		},
		"KGZ": {
			"v": 3.69,
			"r": "106",
			"m": 97,
			"y": "2014"
		},
		"LBY": {
			"v": 1.36,
			"r": "144",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.51,
			"r": "3",
			"m": 91,
			"y": "2014"
		},
		"MAC": null,
		"BRA": {
			"v": 5.51,
			"r": "38",
			"m": 88,
			"y": "2014"
		},
		"JOR": {
			"v": 4.96,
			"r": "51",
			"m": 96,
			"y": "2014"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.37,
			"r": "84",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 4.4,
			"r": "81",
			"m": 103,
			"y": "2013"
		},
		"ATA": null,
		"SVN": {
			"v": 6.21,
			"r": "11",
			"m": 104,
			"y": "2014"
		},
		"GUY": {
			"v": 3.84,
			"r": "101",
			"m": 96,
			"y": "2014"
		},
		"SUR": {
			"v": 2.71,
			"r": "135",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 3.01,
			"r": "129",
			"m": 92,
			"y": "2014"
		},
		"CUW": null,
		"TTO": {
			"v": 4.76,
			"r": "63",
			"m": 104,
			"y": "2014"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.36,
			"r": "118",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 6.03,
			"r": "21",
			"m": 82,
			"y": "2014"
		},
		"GAB": {
			"v": 2.97,
			"r": "130",
			"m": 94,
			"y": "2014"
		},
		"TJK": {
			"v": 3.44,
			"r": "114",
			"m": 104,
			"y": "2014"
		},
		"AUS": {
			"v": 6.15,
			"r": "15",
			"m": 79,
			"y": "2014"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.21,
			"r": "43",
			"m": 100,
			"y": "2014"
		},
		"PNG": null,
		"HUN": {
			"v": 4.78,
			"r": "59",
			"m": 96,
			"y": "2014"
		},
		"SYC": {
			"v": 5.03,
			"r": "49",
			"m": 104,
			"y": "2013"
		},
		"CIV": {
			"v": 3.11,
			"r": "126",
			"m": 92,
			"y": "2014"
		},
		"ABW": null,
		"ESP": {
			"v": 6.08,
			"r": "18",
			"m": 94,
			"y": "2014"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.87,
			"r": "53",
			"m": 91,
			"y": "2014"
		},
		"ARG": {
			"v": 3.92,
			"r": "97",
			"m": 76,
			"y": "2014"
		},
		"GBR": {
			"v": 6.06,
			"r": "19",
			"m": 95,
			"y": "2014"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.72,
			"r": "66",
			"m": 97,
			"y": "2014"
		},
		"BWA": {
			"v": 4.45,
			"r": "78",
			"m": 91,
			"y": "2014"
		},
		"MDA": {
			"v": 4.64,
			"r": "72",
			"m": 100,
			"y": "2014"
		},
		"CXR": null,
		"IDN": {
			"v": 4.56,
			"r": "75",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 5.43,
			"r": "40",
			"m": 92,
			"y": "2014"
		},
		"HND": {
			"v": 3.08,
			"r": "128",
			"m": 96,
			"y": "2014"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.23,
			"r": "138",
			"m": 95,
			"y": "2013"
		},
		"CAF": null,
		"LKA": {
			"v": 4.43,
			"r": "79",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 3.67,
			"r": "107",
			"m": 88,
			"y": "2014"
		},
		"NFK": null,
		"HKG": {
			"v": 6.57,
			"r": "2",
			"m": 96,
			"y": "2014"
		},
		"COD": null,
		"ZAF": {
			"v": 3.66,
			"r": "108",
			"m": 105,
			"y": "2014"
		},
		"VNM": {
			"v": 4.77,
			"r": "61",
			"m": 105,
			"y": "2014"
		},
		"CYP": {
			"v": 5.77,
			"r": "29",
			"m": 92,
			"y": "2014"
		},
		"TCA": null,
		"SVK": {
			"v": 5.69,
			"r": "33",
			"m": 104,
			"y": "2014"
		},
		"NER": null,
		"TCD": {
			"v": 2.28,
			"r": "137",
			"m": 104,
			"y": "2014"
		},
		"HTI": {
			"v": 2.21,
			"r": "138",
			"m": 96,
			"y": "2014"
		},
		"IRL": {
			"v": 5.83,
			"r": "27",
			"m": 96,
			"y": "2014"
		},
		"IRQ": null,
		"POL": {
			"v": 4.77,
			"r": "62",
			"m": 103,
			"y": "2014"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.01,
			"r": "22",
			"m": 104,
			"y": "2014"
		},
		"PLW": null,
		"GMB": {
			"v": 4.41,
			"r": "80",
			"m": 96,
			"y": "2014"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.8,
			"r": "103",
			"m": 93,
			"y": "2014"
		},
		"GRC": {
			"v": 5.09,
			"r": "48",
			"m": 96,
			"y": "2014"
		},
		"FSM": null,
		"ALB": {
			"v": 4.83,
			"r": "57",
			"m": 48,
			"y": "2014"
		},
		"MLI": {
			"v": 3.33,
			"r": "119",
			"m": 100,
			"y": "2014"
		},
		"OMN": {
			"v": 4.68,
			"r": "70",
			"m": 103,
			"y": "2014"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.61,
			"r": "73",
			"m": 104,
			"y": "2014"
		},
		"BLR": null,
		"ITA": {
			"v": 4.45,
			"r": "77",
			"m": 96,
			"y": "2014"
		},
		"NLD": {
			"v": 6.18,
			"r": "13",
			"m": 103,
			"y": "2014"
		},
		"BGD": {
			"v": 3.37,
			"r": "116",
			"m": 86,
			"y": "2014"
		},
		"AUT": {
			"v": 6.01,
			"r": "23",
			"m": 80,
			"y": "2014"
		},
		"QAT": {
			"v": 6.11,
			"r": "17",
			"m": 103,
			"y": "2014"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.82,
			"r": "28",
			"m": 100,
			"y": "2014"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.7,
			"r": "105",
			"m": 98,
			"y": "2014"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.94,
			"r": "131",
			"m": 103,
			"y": "2014"
		},
		"LCA": null,
		"SAU": {
			"v": 5.04,
			"r": "50",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 3.98,
			"r": "95",
			"m": 95,
			"y": "2014"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.22,
			"r": "90",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 2.83,
			"r": "133",
			"m": 100,
			"y": "2014"
		},
		"DMA": null,
		"BFA": {
			"v": 4.02,
			"r": "93",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.03,
			"r": "91",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 4.85,
			"r": "56",
			"m": 104,
			"y": "2014"
		},
		"SRB": {
			"v": 5.18,
			"r": "44",
			"m": 104,
			"y": "2014"
		},
		"GHA": {
			"v": 3.53,
			"r": "111",
			"m": 95,
			"y": "2014"
		},
		"RUS": {
			"v": 4.04,
			"r": "93",
			"m": 103,
			"y": "2013"
		},
		"EST": {
			"v": 5.74,
			"r": "31",
			"m": 94,
			"y": "2014"
		},
		"SMR": null,
		"CHN": {
			"v": 4.78,
			"r": "60",
			"m": 91,
			"y": "2014"
		},
		"NIU": null,
		"USA": {
			"v": 5.62,
			"r": "35",
			"m": 105,
			"y": "2014"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.89,
			"r": "52",
			"m": 104,
			"y": "2014"
		},
		"JPN": {
			"v": 6.77,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"PER": {
			"v": 4.03,
			"r": "92",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 6.14,
			"r": "16",
			"m": 92,
			"y": "2014"
		},
		"STP": null,
		"UKR": {
			"v": 4.66,
			"r": "71",
			"m": 105,
			"y": "2014"
		},
		"SGP": {
			"v": 6.41,
			"r": "6",
			"m": 104,
			"y": "2014"
		},
		"GRD": null,
		"BEN": {
			"v": 3.51,
			"r": "111",
			"m": 83,
			"y": "2013"
		},
		"COL": {
			"v": 4.71,
			"r": "67",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 6.35,
			"r": "8",
			"m": 96,
			"y": "2014"
		},
		"LAO": {
			"v": 4.51,
			"r": "76",
			"m": 98,
			"y": "2014"
		},
		"FLK": null,
		"LUX": {
			"v": 6.22,
			"r": "10",
			"m": 100,
			"y": "2014"
		},
		"ERI": null,
		"NAM": {
			"v": 4.87,
			"r": "54",
			"m": 101,
			"y": "2014"
		},
		"SLE": {
			"v": 2.15,
			"r": "141",
			"m": 104,
			"y": "2014"
		},
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": {
			"v": 2.82,
			"r": "134",
			"m": 100,
			"y": "2014"
		},
		"REU": null,
		"ZWE": {
			"v": 3.08,
			"r": "127",
			"m": 105,
			"y": "2014"
		},
		"KWT": {
			"v": 2.6,
			"r": "136",
			"m": 97,
			"y": "2014"
		},
		"ESH": null,
		"SEN": {
			"v": 3.81,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"CMR": {
			"v": 3.29,
			"r": "122",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 3.22,
			"r": "123",
			"m": 100,
			"y": "2014"
		},
		"TLS": {
			"v": 2.18,
			"r": "139",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.32,
			"r": "120",
			"m": 104,
			"y": "2014"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.36,
			"r": "117",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 5.75,
			"r": "30",
			"m": 91,
			"y": "2014"
		},
		"NZL": {
			"v": 6.25,
			"r": "9",
			"m": 103,
			"y": "2014"
		},
		"TWN": {
			"v": 6.38,
			"r": "7",
			"m": 104,
			"y": "2014"
		},
		"BRB": {
			"v": 6.06,
			"r": "20",
			"m": 89,
			"y": "2014"
		},
		"MHL": null,
		"AND": null
	},
	"EXPCOSTCOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SHAREDUTYFREE": {
		"UNK": null,
		"NOR": {
			"v": 95.23,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 95.13,
			"r": "7",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 26.66,
			"r": "114",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 94.04,
			"r": "15",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 68.63,
			"r": "68",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 42.27,
			"r": "99",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 12.02,
			"r": "123",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 59.77,
			"r": "83",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 90.51,
			"r": "29",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 66.66,
			"r": "71",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 31.49,
			"r": "110",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 53.73,
			"r": "92",
			"m": 96,
			"y": "2011"
		},
		"SLB": null,
		"URY": {
			"v": 56.86,
			"r": "89",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 84.16,
			"r": "46",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 83.01,
			"r": "49",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 89.83,
			"r": "31",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 56.25,
			"r": "90",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 51.24,
			"r": "94",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 78.98,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 89.04,
			"r": "34",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 86.88,
			"r": "43",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 44.51,
			"r": "97",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 65.73,
			"r": "73",
			"m": 103,
			"y": "2013"
		},
		"COK": null,
		"KEN": {
			"v": 46.03,
			"r": "96",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 86.82,
			"r": "44",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 92.51,
			"r": "22",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 82.25,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 91.66,
			"r": "25",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 94.77,
			"r": "9",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 91.54,
			"r": "26",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 92.52,
			"r": "21",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 93.24,
			"r": "18",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 30.68,
			"r": "112",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 5.11,
			"r": "130",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 94.08,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 91.76,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 5.87,
			"r": "129",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 61.28,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.02,
			"r": "135",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 87.06,
			"r": "42",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0,
			"r": "136",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 66.5,
			"r": "72",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 59.24,
			"r": "84",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 93.06,
			"r": "19",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 11.24,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 75.3,
			"r": "61",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 26.23,
			"r": "115",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 94.21,
			"r": "13",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 31.31,
			"r": "111",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 80.57,
			"r": "51",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 78.26,
			"r": "57",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 63.63,
			"r": "75",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 92.87,
			"r": "20",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 57.41,
			"r": "87",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 63.47,
			"r": "76",
			"m": 104,
			"y": "2008"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 39.52,
			"r": "103",
			"m": 103,
			"y": "2013"
		},
		"SYR": null,
		"BEL": {
			"v": 88.03,
			"r": "39",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 22.1,
			"r": "117",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 22.9,
			"r": "116",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 57.87,
			"r": "85",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 70.69,
			"r": "66",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 92.19,
			"r": "23",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 10.85,
			"r": "125",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 88.21,
			"r": "38",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 67.37,
			"r": "69",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 42.32,
			"r": "98",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 84.19,
			"r": "45",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 40.11,
			"r": "101",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 96.67,
			"r": "3",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 55.75,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 62.1,
			"r": "78",
			"m": 96,
			"y": "2013"
		},
		"DNK": {
			"v": 88.88,
			"r": "36",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 72.66,
			"r": "64",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 63.3,
			"r": "77",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 51.45,
			"r": "93",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 100,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0.34,
			"r": "133",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 73.99,
			"r": "63",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 70.94,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 90.82,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 94.63,
			"r": "11",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 16.2,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 89.33,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 91.13,
			"r": "27",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 87.82,
			"r": "40",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 21.35,
			"r": "118",
			"m": 96,
			"y": "2012"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 33.76,
			"r": "108",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 90.33,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 89.47,
			"r": "32",
			"m": 54,
			"y": "2015"
		},
		"MLI": {
			"v": 34.5,
			"r": "106",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 60.16,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 87.74,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 83.23,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 16.18,
			"r": "120",
			"m": 86,
			"y": "2007"
		},
		"AUT": {
			"v": 95.43,
			"r": "4",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 34.15,
			"r": "107",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 94.5,
			"r": "12",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 42.23,
			"r": "100",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 57.15,
			"r": "88",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 27.26,
			"r": "113",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 95.22,
			"r": "6",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 80.45,
			"r": "52",
			"m": 105,
			"y": "2013"
		},
		"MRT": {
			"v": 8.69,
			"r": "128",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 13.41,
			"r": "122",
			"m": 96,
			"y": "2009"
		},
		"TUN": {
			"v": 80.4,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 80.17,
			"r": "54",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 15.89,
			"r": "121",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 39.71,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 93.61,
			"r": "17",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 50.19,
			"r": "95",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 77.3,
			"r": "58",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 70.58,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 79.05,
			"r": "55",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 74.03,
			"r": "62",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 88.37,
			"r": "37",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 60.37,
			"r": "80",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 99.97,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 10.35,
			"r": "126",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 60.35,
			"r": "81",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 94.95,
			"r": "8",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 75.97,
			"r": "59",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 93.82,
			"r": "16",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 94.73,
			"r": "10",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0.31,
			"r": "134",
			"m": 104,
			"y": "2006"
		},
		"ARE": {
			"v": 35.97,
			"r": "105",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 83.17,
			"r": "48",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 64.35,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 39.36,
			"r": "104",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 8.96,
			"r": "127",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 4.9,
			"r": "131",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 2.13,
			"r": "132",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 57.6,
			"r": "86",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 31.75,
			"r": "109",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 88.93,
			"r": "35",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 75.6,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 66.76,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"fees_charges": {
		"UNK": null,
		"NOR": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.67,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 0.75,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.33,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.25,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.75,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.75,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.75,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.75,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.5,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 0.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.25,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.75,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.67,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.67,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 0.67,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.25,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.67,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.33,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.67,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.33,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.67,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.75,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0.67,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.67,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.5,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 1.33,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 0.75,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.33,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.5,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.5,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ469": {
		"UNK": null,
		"NOR": {
			"v": 5,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.16,
			"r": "112",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 4.07,
			"r": "50",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.78,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.2,
			"r": "109",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.81,
			"r": "21",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.79,
			"r": "70",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.57,
			"r": "85",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.71,
			"r": "26",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.23,
			"r": "43",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.04,
			"r": "52",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.5,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.27,
			"r": "41",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.5,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.84,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.89,
			"r": "17",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.55,
			"r": "87",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.92,
			"r": "123",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.34,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.94,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.16,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.62,
			"r": "79",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.26,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.45,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.28,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.77,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.99,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.36,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.94,
			"r": "121",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4,
			"r": "55",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.82,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.04,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.64,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.26,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 2.53,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 3.92,
			"r": "62",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.46,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.59,
			"r": "84",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.99,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.63,
			"r": "78",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.22,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.2,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.07,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.76,
			"r": "72",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.81,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.55,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.28,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.22,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.68,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.58,
			"r": "131",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.13,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.67,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.7,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.55,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.75,
			"r": "69",
			"m": 96,
			"y": "2015"
		},
		"SUR": null,
		"DOM": {
			"v": 3.57,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.86,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.45,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.12,
			"r": "11",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.7,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.01,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.3,
			"r": "39",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.6,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.92,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.54,
			"r": "90",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3.98,
			"r": "58",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.67,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.81,
			"r": "126",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.17,
			"r": "10",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.65,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.59,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.83,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.36,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.42,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.98,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.86,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.52,
			"r": "29",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.74,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.75,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.65,
			"r": "27",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.93,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.49,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.38,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.43,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.12,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 3.59,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.99,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.03,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.8,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.45,
			"r": "95",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.52,
			"r": "133",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.5,
			"r": "92",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 2.99,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.47,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.39,
			"r": "90",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.21,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.78,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.16,
			"r": "113",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.35,
			"r": "7",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.21,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.2,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.84,
			"r": "66",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.03,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.41,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.59,
			"r": "82",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.04,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.32,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.31,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.33,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.89,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.19,
			"r": "110",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.24,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.86,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.16,
			"r": "45",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.95,
			"r": "14",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.4,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.46,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.43,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.91,
			"r": "15",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.04,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.71,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.07,
			"r": "114",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.48,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.36,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.09,
			"r": "49",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.25,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.81,
			"r": "68",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.68,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 4.75,
			"r": "24",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.05,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.82,
			"r": "121",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.21,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.1,
			"r": "48",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.18,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.24,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.21,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.02,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.94,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.74,
			"r": "25",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.9,
			"r": "16",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.64,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.64,
			"r": "77",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"form_docs": {
		"UNK": null,
		"NOR": {
			"v": 1.14,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.17,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 0.86,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.5,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 0.86,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.71,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 0.67,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 0.83,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.83,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.83,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.33,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.17,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 0.67,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 0.83,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 0.86,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.33,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.67,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.14,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0.4,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.5,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.67,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.4,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.5,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 0.17,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.86,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.33,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.17,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.83,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.2,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.43,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.43,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.8,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.33,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.2,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.5,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.5,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.17,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.57,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 0.83,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 0.83,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.4,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 0.71,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0.2,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.83,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 0.86,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.43,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.67,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.83,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.17,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.86,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.29,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.83,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.83,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.83,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.17,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.43,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 0.83,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.17,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0.71,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.17,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.33,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.83,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.67,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.67,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.4,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.57,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.83,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.83,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.17,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.4,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.83,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.83,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.83,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.29,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.33,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TABTIMEIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.14,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 240,
			"r": "127",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 154.3,
			"r": "116",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 54,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 203.31,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 24,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6,
			"r": "39",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 30.14,
			"r": "56",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 80,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 13,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 1.56,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 72,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 72,
			"r": "82",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 41.04,
			"r": "62",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 14,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 72,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 7.5,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 64,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 7.5,
			"r": "40",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 72,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 180,
			"r": "118",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.5,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 44.22,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 39.67,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.38,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 48,
			"r": "66",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 54,
			"r": "72",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 60,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 276,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 283.71,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 60.78,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 154.25,
			"r": "115",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 217,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 23.22,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 141,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 63.69,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 48,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 240,
			"r": "127",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0.5,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 129.29,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 50.18,
			"r": "69",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 37,
			"r": "58",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 79,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 63.13,
			"r": "78",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 75.14,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 80,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 85.67,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 84,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 48,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 24,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 78,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 111,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 24,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 84,
			"r": "95",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 107.83,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 39,
			"r": "59",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 106,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 97,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 125.14,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 60,
			"r": "75",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 3,
			"r": "31",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 2,
			"r": "27",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.42,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.39,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 99.36,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 96,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 91,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 72,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 114,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 18.55,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 588,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 144,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 61.97,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 14.67,
			"r": "46",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 242,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 83,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 87,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 327.39,
			"r": "133",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0.5,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 10,
			"r": "42",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 98.33,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 70.29,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 5,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 1,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 183,
			"r": "121",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 88,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 51,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 96,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 180,
			"r": "118",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 48,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 228,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 15,
			"r": "47",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 163,
			"r": "117",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 84,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 102,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 283.35,
			"r": "131",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 80,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 89.43,
			"r": "100",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 96,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 92.31,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"r": "25",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 41.08,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 39.6,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 72,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 72,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 35.43,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 82,
			"r": "94",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 112,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 24,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 13.5,
			"r": "44",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.5,
			"r": "37",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 181.71,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 54,
			"r": "72",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.95,
			"r": "38",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 232,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 227.67,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 214.91,
			"r": "123",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 53.33,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 271,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 48,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 100,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 402,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 98.73,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 25,
			"r": "55",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 47.38,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 104,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETIC0402": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TERRORISMINCIDENCE": {
		"UNK": null,
		"NOR": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"HRV": {
			"v": 6.98,
			"r": "51",
			"m": 96,
			"y": "2014"
		},
		"VEN": {
			"v": 6.94,
			"r": "68",
			"m": 105,
			"y": "2014"
		},
		"TON": null,
		"CZE": {
			"v": 6.91,
			"r": "74",
			"m": 92,
			"y": "2014"
		},
		"BDI": {
			"v": 4.8,
			"r": "113",
			"m": 81,
			"y": "2014"
		},
		"BHR": {
			"v": 5.77,
			"r": "109",
			"m": 86,
			"y": "2014"
		},
		"ETH": {
			"v": 6.52,
			"r": "95",
			"m": 94,
			"y": "2014"
		},
		"ECU": {
			"v": 6.97,
			"r": "54",
			"m": 94,
			"y": "2014"
		},
		"FRA": {
			"v": 5.49,
			"r": "110",
			"m": 94,
			"y": "2014"
		},
		"SJM": null,
		"KOR": {
			"v": 6.99,
			"r": "38",
			"m": 97,
			"y": "2014"
		},
		"AZE": {
			"v": 6.97,
			"r": "54",
			"m": 81,
			"y": "2014"
		},
		"JAM": {
			"v": 6.99,
			"r": "38",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"MLT": {
			"v": 6.98,
			"r": "42",
			"m": 100,
			"y": "2014"
		},
		"BVT": null,
		"GTM": {
			"v": 6.93,
			"r": "71",
			"m": 96,
			"y": "2014"
		},
		"MYS": {
			"v": 6.73,
			"r": "90",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.97,
			"r": "57",
			"m": 78,
			"y": "2014"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.99,
			"r": "106",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 6.89,
			"r": "77",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 6.92,
			"r": "73",
			"m": 100,
			"y": "2014"
		},
		"ISR": {
			"v": 2.95,
			"r": "120",
			"m": 96,
			"y": "2014"
		},
		"KHM": {
			"v": 6.98,
			"r": "42",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1,
			"r": "126",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 1.92,
			"r": "123",
			"m": 97,
			"y": "2014"
		},
		"COM": null,
		"LSO": {
			"v": 6.98,
			"r": "49",
			"m": 100,
			"y": "2014"
		},
		"MEX": {
			"v": 6.21,
			"r": "104",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"ROU": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"BRN": {
			"v": 7,
			"r": "1",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 6.74,
			"r": "89",
			"m": 91,
			"y": "2014"
		},
		"LVA": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"YEM": {
			"v": 1,
			"r": "126",
			"m": 105,
			"y": "2014"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 7,
			"y": "2014",
			"m": 16
		},
		"NGA": {
			"v": 1,
			"r": "126",
			"m": 102,
			"y": "2014"
		},
		"PRT": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"SGS": null,
		"FIN": {
			"v": 6.93,
			"r": "72",
			"m": 94,
			"y": "2014"
		},
		"NPL": {
			"v": 5.44,
			"r": "111",
			"m": 103,
			"y": "2014"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 6.52,
			"r": "96",
			"m": 105,
			"y": "2014"
		},
		"LBR": {
			"v": 6.99,
			"r": "33",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 6.98,
			"r": "52",
			"m": 100,
			"y": "2014"
		},
		"IRN": {
			"v": 6.39,
			"r": "98",
			"m": 96,
			"y": "2014"
		},
		"SPM": null,
		"MWI": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 6.99,
			"y": "2014",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"r": "126",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 6.95,
			"r": "65",
			"m": 86,
			"y": "2014"
		},
		"CUB": null,
		"PAK": {
			"v": 1,
			"r": "126",
			"m": 103,
			"y": "2014"
		},
		"IMN": null,
		"THA": {
			"v": 1,
			"r": "126",
			"m": 104,
			"y": "2014"
		},
		"KGZ": {
			"v": 6.96,
			"r": "63",
			"m": 97,
			"y": "2014"
		},
		"LBY": {
			"v": 1,
			"y": "2014",
			"m": 100
		},
		"CHE": {
			"v": 6.98,
			"r": "42",
			"m": 91,
			"y": "2014"
		},
		"MAC": null,
		"BRA": {
			"v": 6.89,
			"r": "76",
			"m": 88,
			"y": "2014"
		},
		"JOR": {
			"v": 6.86,
			"r": "85",
			"m": 96,
			"y": "2014"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 7,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 6.7,
			"r": "91",
			"m": 103,
			"y": "2014"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"GUY": {
			"v": 7,
			"y": "2014",
			"m": 96
		},
		"SUR": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"DOM": {
			"v": 6.88,
			"r": "80",
			"m": 92,
			"y": "2014"
		},
		"CUW": null,
		"TTO": {
			"v": 6.97,
			"r": "59",
			"m": 104,
			"y": "2014"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 6.99,
			"y": "2014",
			"m": 105
		},
		"PAN": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 6.96,
			"r": "61",
			"m": 82,
			"y": "2014"
		},
		"GAB": {
			"v": 7,
			"r": "1",
			"m": 94,
			"y": "2014"
		},
		"TJK": {
			"v": 6.89,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"AUS": {
			"v": 6.83,
			"r": "86",
			"m": 79,
			"y": "2014"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.99,
			"r": "33",
			"m": 100,
			"y": "2014"
		},
		"PNG": null,
		"HUN": {
			"v": 6.98,
			"r": "42",
			"m": 96,
			"y": "2014"
		},
		"SYC": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"CIV": {
			"v": 6.82,
			"r": "88",
			"m": 92,
			"y": "2014"
		},
		"ABW": null,
		"ESP": {
			"v": 6.93,
			"r": "70",
			"m": 94,
			"y": "2014"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.99,
			"r": "33",
			"m": 91,
			"y": "2014"
		},
		"ARG": {
			"v": 6.97,
			"r": "57",
			"m": 76,
			"y": "2014"
		},
		"GBR": {
			"v": 3.9,
			"r": "117",
			"m": 95,
			"y": "2014"
		},
		"SXM": null,
		"KAZ": {
			"v": 6.97,
			"r": "60",
			"m": 97,
			"y": "2014"
		},
		"BWA": {
			"v": 7,
			"r": "1",
			"m": 91,
			"y": "2014"
		},
		"MDA": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"CXR": null,
		"IDN": {
			"v": 5.89,
			"r": "107",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 6.94,
			"r": "67",
			"m": 92,
			"y": "2014"
		},
		"HND": {
			"v": 6.96,
			"r": "64",
			"m": 96,
			"y": "2014"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 6.95,
			"y": "2014",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 6.33,
			"r": "99",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 7,
			"r": "1",
			"m": 88,
			"y": "2014"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"COD": {
			"v": 1.84,
			"r": "124",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 6.55,
			"r": "94",
			"m": 105,
			"y": "2014"
		},
		"VNM": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"CYP": {
			"v": 6.87,
			"r": "83",
			"m": 92,
			"y": "2014"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"NER": null,
		"TCD": {
			"v": 4.56,
			"r": "115",
			"m": 104,
			"y": "2014"
		},
		"HTI": {
			"v": 7,
			"y": "2014",
			"m": 96
		},
		"IRL": {
			"v": 6.3,
			"r": "101",
			"m": 96,
			"y": "2014"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.65,
			"r": "92",
			"m": 104,
			"y": "2014"
		},
		"PLW": null,
		"GMB": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.83,
			"r": "108",
			"m": 93,
			"y": "2014"
		},
		"GRC": {
			"v": 6.08,
			"r": "105",
			"m": 96,
			"y": "2014"
		},
		"FSM": null,
		"ALB": {
			"v": 6.94,
			"r": "68",
			"m": 48,
			"y": "2014"
		},
		"MLI": {
			"v": 2.05,
			"r": "122",
			"m": 100,
			"y": "2014"
		},
		"OMN": {
			"v": 7,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"BLR": {
			"v": 7,
			"y": "2014",
			"m": 86
		},
		"ITA": {
			"v": 6.83,
			"r": "87",
			"m": 96,
			"y": "2014"
		},
		"NLD": {
			"v": 6.98,
			"r": "52",
			"m": 103,
			"y": "2014"
		},
		"BGD": {
			"v": 1,
			"r": "126",
			"m": 86,
			"y": "2014"
		},
		"AUT": {
			"v": 6.99,
			"r": "41",
			"m": 80,
			"y": "2014"
		},
		"QAT": {
			"v": 6.99,
			"r": "38",
			"m": 103,
			"y": "2014"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"ATG": null,
		"AFG": {
			"v": 1,
			"y": "2014",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 1.07,
			"r": "125",
			"m": 98,
			"y": "2014"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.51,
			"r": "97",
			"m": 103,
			"y": "2014"
		},
		"LCA": null,
		"SAU": {
			"v": 4.41,
			"r": "116",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 6.95,
			"r": "66",
			"m": 95,
			"y": "2014"
		},
		"MYT": null,
		"ZMB": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"DMA": null,
		"BFA": {
			"v": 6.9,
			"y": "2014",
			"m": 85
		},
		"IND": {
			"v": 1,
			"r": "126",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 5.3,
			"r": "112",
			"m": 104,
			"y": "2014"
		},
		"SRB": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"GHA": {
			"v": 6.98,
			"r": "49",
			"m": 95,
			"y": "2014"
		},
		"RUS": {
			"v": 3.4,
			"r": "119",
			"m": 103,
			"y": "2014"
		},
		"EST": {
			"v": 6.98,
			"r": "42",
			"m": 94,
			"y": "2014"
		},
		"SMR": null,
		"CHN": {
			"v": 3.48,
			"r": "118",
			"m": 91,
			"y": "2014"
		},
		"NIU": null,
		"USA": {
			"v": 4.65,
			"r": "114",
			"m": 105,
			"y": "2014"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1,
			"r": "126",
			"m": 104,
			"y": "2014"
		},
		"JPN": {
			"v": 6.88,
			"r": "78",
			"m": 96,
			"y": "2014"
		},
		"PER": {
			"v": 6.63,
			"r": "93",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 6.33,
			"r": "100",
			"m": 92,
			"y": "2014"
		},
		"STP": null,
		"UKR": {
			"v": 1,
			"r": "126",
			"m": 105,
			"y": "2014"
		},
		"SGP": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"GRD": null,
		"BEN": {
			"v": 7,
			"r": "1",
			"m": 83,
			"y": "2014"
		},
		"COL": {
			"v": 1,
			"r": "126",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 6.99,
			"r": "33",
			"m": 96,
			"y": "2014"
		},
		"LAO": {
			"v": 6.98,
			"r": "42",
			"m": 98,
			"y": "2014"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"ERI": null,
		"NAM": {
			"v": 7,
			"r": "1",
			"m": 101,
			"y": "2014"
		},
		"SLE": {
			"v": 7,
			"r": "1",
			"m": 104,
			"y": "2014"
		},
		"ARE": {
			"v": 6.97,
			"r": "54",
			"m": 71,
			"y": "2014"
		},
		"GNB": null,
		"BIH": {
			"v": 6.88,
			"r": "81",
			"m": 86,
			"y": "2014"
		},
		"MMR": {
			"v": 5.64,
			"y": "2014",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 6.96,
			"r": "62",
			"m": 105,
			"y": "2014"
		},
		"KWT": {
			"v": 6.23,
			"r": "103",
			"m": 97,
			"y": "2014"
		},
		"ESH": null,
		"SEN": {
			"v": 6.88,
			"r": "82",
			"m": 104,
			"y": "2014"
		},
		"CMR": {
			"v": 2.79,
			"r": "121",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 7,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"TLS": {
			"v": 7,
			"y": "2014",
			"m": 104
		},
		"TZA": {
			"v": 6.26,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 6.88,
			"r": "79",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 6.86,
			"r": "84",
			"m": 91,
			"y": "2014"
		},
		"NZL": {
			"v": 6.99,
			"r": "33",
			"m": 103,
			"y": "2014"
		},
		"TWN": {
			"v": 6.98,
			"r": "42",
			"m": 104,
			"y": "2014"
		},
		"BRB": {
			"v": 7,
			"y": "2014",
			"m": 89
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ034": {
		"UNK": null,
		"NOR": {
			"v": 5.82,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.58,
			"r": "19",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.62,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.27,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.33,
			"r": "119",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.37,
			"r": "31",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.09,
			"r": "91",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.73,
			"r": "109",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.8,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.91,
			"r": "55",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.55,
			"r": "20",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 2.32,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.74,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.42,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.38,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.85,
			"r": "60",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5.42,
			"r": "27",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 3.29,
			"r": "122",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.34,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 5.07,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.42,
			"r": "77",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.96,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.25,
			"r": "84",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.72,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.76,
			"r": "128",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.37,
			"r": "2",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.65,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 1.8,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.13,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.26,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.03,
			"r": "50",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.22,
			"r": "86",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.32,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.65,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.05,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 3.57,
			"r": "114",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.09,
			"r": "121",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.9,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.37,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.07,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.63,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.08,
			"r": "92",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.38,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.38,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.26,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.82,
			"r": "132",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 2.92,
			"r": "124",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4,
			"r": "97",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.86,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.97,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.98,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.47,
			"r": "138",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.71,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.66,
			"r": "129",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.86,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.22,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 6.33,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.75,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.63,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 4.31,
			"r": "78",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 3.08,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.45,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.42,
			"r": "71",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.52,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 6.62,
			"r": "1",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.09,
			"r": "48",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 4.56,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.88,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.13,
			"r": "45",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.4,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.67,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.16,
			"r": "88",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.78,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.42,
			"r": "26",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.66,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.49,
			"r": "115",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.12,
			"r": "47",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.21,
			"r": "40",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.3,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.85,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.94,
			"r": "102",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.41,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.39,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.61,
			"r": "112",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.99,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.59,
			"r": "72",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.08,
			"r": "9",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 4.19,
			"r": "89",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 2.44,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.67,
			"r": "68",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.32,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.82,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.96,
			"r": "126",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.2,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.03,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.81,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.27,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.6,
			"r": "71",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.99,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.77,
			"r": "66",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.6,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.28,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.67,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.99,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.21,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.58,
			"r": "114",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.51,
			"r": "22",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.37,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.19,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.89,
			"r": "104",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.75,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.74,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.5,
			"r": "23",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.7,
			"r": "67",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.42,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.81,
			"r": "103",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.36,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.06,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.37,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.2,
			"r": "88",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.5,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.53,
			"r": "21",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.9,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.61,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.45,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.32,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.81,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.8,
			"r": "63",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.48,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.15,
			"r": "7",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.31,
			"r": "82",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.8,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.15,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.89,
			"r": "57",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.78,
			"r": "13",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.16,
			"r": "90",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.81,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.43,
			"r": "1",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.04,
			"r": "96",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.36,
			"r": "120",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 4.79,
			"r": "65",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.34,
			"r": "32",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.66,
			"r": "69",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.89,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 5.15,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.84,
			"r": "99",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.21,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.64,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.3,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.4,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.47,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.94,
			"r": "101",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ048": {
		"UNK": null,
		"NOR": {
			"v": 4.17,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.02,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.39,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 2.8,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.02,
			"r": "102",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.65,
			"r": "10",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.6,
			"r": "55",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 2.22,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 2.76,
			"r": "115",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 2.99,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.31,
			"r": "17",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.14,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.09,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.46,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.43,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.91,
			"r": "6",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.74,
			"r": "42",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 2.43,
			"r": "138",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.19,
			"r": "90",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.78,
			"r": "114",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.68,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.69,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.5,
			"r": "65",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.72,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.89,
			"r": "36",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 4.23,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.71,
			"r": "118",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 2.69,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.18,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.68,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.31,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 3.48,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.3,
			"r": "85",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.07,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.62,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.66,
			"r": "128",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.97,
			"r": "107",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 2.83,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 4.51,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.1,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.74,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.91,
			"r": "34",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.55,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.12,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.4,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.9,
			"r": "101",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.51,
			"r": "63",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.49,
			"r": "66",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.4,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.51,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.51,
			"r": "60",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.45,
			"r": "134",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 4.82,
			"r": "7",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.68,
			"r": "137",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 3.74,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.57,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.47,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 2.74,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.39,
			"r": "73",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.22,
			"r": "93",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 2.82,
			"r": "110",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.25,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.31,
			"r": "50",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 3.75,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.48,
			"r": "129",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 3.24,
			"r": "89",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.37,
			"r": "79",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.48,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.39,
			"r": "77",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.56,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 2.64,
			"r": "123",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.2,
			"r": "16",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.04,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 2.8,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.68,
			"r": "48",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.23,
			"r": "132",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.05,
			"r": "25",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.83,
			"r": "38",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.49,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.8,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.88,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 3.3,
			"r": "84",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.68,
			"r": "121",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.5,
			"r": "62",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.58,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.53,
			"r": "127",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.23,
			"r": "4",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.62,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 2.98,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.24,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.97,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 2.33,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.16,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.09,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.65,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 2.7,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.09,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.35,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.25,
			"r": "86",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.4,
			"r": "129",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.65,
			"r": "11",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.42,
			"r": "73",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 3.71,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.46,
			"r": "66",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 1.96,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 3.98,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.16,
			"r": "93",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 3.67,
			"r": "50",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.05,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.8,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.04,
			"r": "101",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.45,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.04,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.81,
			"r": "8",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.68,
			"r": "47",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.18,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.6,
			"r": "56",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.09,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.99,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.44,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.51,
			"r": "62",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.01,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.09,
			"r": "24",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.15,
			"r": "21",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.04,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.45,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.61,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.21,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.28,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.41,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.59,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.34,
			"r": "81",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.62,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.32,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.91,
			"r": "35",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.53,
			"r": "12",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.98,
			"r": "32",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.35,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.33,
			"r": "3",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.58,
			"r": "125",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.94,
			"r": "111",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.35,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 2.89,
			"r": "108",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.66,
			"r": "51",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.38,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.33,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.1,
			"r": "100",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.52,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.16,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 3.77,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.05,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 3.99,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.51,
			"r": "64",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ055": {
		"UNK": null,
		"NOR": {
			"v": 6.48,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.87,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.93,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.55,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.2,
			"r": "133",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.66,
			"r": "32",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.88,
			"r": "91",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "90",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.76,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.3,
			"r": "40",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.27,
			"r": "74",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.79,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.24,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.99,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 2.73,
			"r": "125",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.39,
			"r": "37",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.41,
			"r": "66",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 4.81,
			"r": "43",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.75,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.7,
			"r": "98",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 4.98,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.08,
			"r": "41",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.02,
			"r": "117",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.45,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.86,
			"r": "92",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.7,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 2.51,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 2.27,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.72,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.19,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.69,
			"r": "56",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.91,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.18,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.22,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.27,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.81,
			"r": "129",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.99,
			"r": "118",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.71,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.79,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.8,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.99,
			"r": "87",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.58,
			"r": "101",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.72,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.3,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.77,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.95,
			"r": "124",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.33,
			"r": "111",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 3.53,
			"r": "103",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.11,
			"r": "115",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.61,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.23,
			"r": "113",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2,
			"r": "143",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.56,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.42,
			"r": "109",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.99,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.47,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 6.44,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.49,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 2.79,
			"r": "131",
			"m": 96,
			"y": "2014"
		},
		"SUR": {
			"v": 4.45,
			"r": "54",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 2.36,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.76,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.47,
			"r": "55",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.69,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.61,
			"r": "97",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.88,
			"r": "25",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.94,
			"r": "89",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.82,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 6.26,
			"r": "11",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.8,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.33,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.12,
			"r": "2",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.05,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.19,
			"r": "15",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.55,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.97,
			"r": "119",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.06,
			"r": "20",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.08,
			"r": "84",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.84,
			"r": "49",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.21,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.32,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.97,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 2.5,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.04,
			"r": "5",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.21,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.48,
			"r": "129",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.21,
			"r": "6",
			"m": 96,
			"y": "2014"
		},
		"COD": {
			"v": 3.67,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.32,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.16,
			"r": "81",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.45,
			"r": "63",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.58,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.87,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.01,
			"r": "120",
			"m": 96,
			"y": "2014"
		},
		"IRL": {
			"v": 6.11,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.09,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.72,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.93,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.65,
			"r": "59",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.73,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.03,
			"r": "44",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.58,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.26,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.57,
			"r": "50",
			"m": 104,
			"y": "2014"
		},
		"BLR": null,
		"ITA": {
			"v": 4.32,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.23,
			"r": "14",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.09,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.18,
			"r": "16",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.27,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.75,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.51,
			"r": "104",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.78,
			"r": "122",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.84,
			"r": "26",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.31,
			"r": "39",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.4,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.13,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.05,
			"r": "77",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.74,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.3,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.73,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.69,
			"r": "57",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.5,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.07,
			"r": "19",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.69,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.97,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.35,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.13,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 2.56,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.34,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.53,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.55,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.08,
			"r": "85",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.39,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.41,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.43,
			"r": "65",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.24,
			"r": "13",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.44,
			"r": "64",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.51,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.42,
			"r": "7",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.95,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.86,
			"r": "126",
			"m": 100,
			"y": "2014"
		},
		"REU": null,
		"ZWE": {
			"v": 3.5,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.07,
			"r": "43",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.07,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.34,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.15,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.58,
			"r": "104",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.27,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.91,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.27,
			"r": "10",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.61,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.46,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.5,
			"r": "34",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ147": {
		"UNK": null,
		"NOR": {
			"v": 6.21,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.26,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.83,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.8,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.21,
			"r": "93",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.53,
			"r": "26",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.08,
			"r": "100",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "66",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.08,
			"r": "34",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.51,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.33,
			"r": "85",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.17,
			"r": "95",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.11,
			"r": "33",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.66,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.13,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.68,
			"r": "43",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.58,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 4.89,
			"r": "39",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.53,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.88,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.08,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.54,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 2.43,
			"r": "127",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.72,
			"r": "114",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.68,
			"r": "117",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.26,
			"r": "131",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.44,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.51,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.99,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.3,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.73,
			"r": "42",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.73,
			"r": "23",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.62,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 1.77,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.94,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.95,
			"r": "139",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 1.9,
			"r": "134",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.21,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.65,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.33,
			"r": "129",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.69,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.61,
			"r": "74",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.82,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.3,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.79,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.07,
			"r": "139",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.31,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.34,
			"r": "83",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.99,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.25,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.54,
			"r": "125",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.37,
			"r": "130",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.24,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.09,
			"r": "99",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.62,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.66,
			"r": "73",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.84,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.48,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 2.78,
			"r": "112",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 2.85,
			"r": "108",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 2.75,
			"r": "112",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.84,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.99,
			"r": "87",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.01,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.51,
			"r": "122",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.78,
			"r": "22",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.23,
			"r": "92",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.08,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.99,
			"r": "17",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.75,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.75,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.51,
			"r": "77",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.44,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.75,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.39,
			"r": "49",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.42,
			"r": "128",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.94,
			"r": "18",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.07,
			"r": "61",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.31,
			"r": "54",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.74,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.42,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.13,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.2,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.79,
			"r": "140",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 2.93,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.65,
			"r": "121",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.17,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.7,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.11,
			"r": "59",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 2.8,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.49,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.34,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.8,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.34,
			"r": "131",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.4,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.82,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.29,
			"r": "7",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.78,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.65,
			"r": "119",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.03,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.17,
			"r": "58",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 2.58,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.9,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.5,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.36,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.08,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 1.96,
			"r": "133",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.88,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.19,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.18,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.65,
			"r": "120",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.66,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.19,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.92,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.12,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.9,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 2.73,
			"r": "113",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.31,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.58,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 2.76,
			"r": "110",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.68,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.05,
			"r": "16",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.33,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.29,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.86,
			"r": "68",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.19,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.35,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.29,
			"r": "30",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.65,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.61,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.27,
			"r": "130",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.58,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.59,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.13,
			"r": "97",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.24,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.99,
			"r": "64",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 1.97,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.31,
			"r": "6",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.3,
			"r": "90",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.29,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.83,
			"r": "107",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.46,
			"r": "79",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.31,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.76,
			"r": "111",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.34,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.37,
			"r": "128",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 2.86,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.58,
			"r": "123",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.63,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.45,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.47,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.87,
			"r": "67",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-CLEAREFF": {
		"UNK": null,
		"NOR": {
			"v": 4.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 2.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 3.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 3.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 3.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 2.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 3.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 4.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 4.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 2.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 2.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 3.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 3.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 3.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 2.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 2.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 2.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 3.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 2.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 2.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 2.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 3.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 2.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 3.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 5.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 5.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COG": null,
		"LBN": {
			"v": 3.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 2.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 2.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 3.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 3.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 2.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 3.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 2.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 2.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 2.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 4.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 4.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 2.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 6.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 1.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 1.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 4.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 4.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 1.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 4.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 2.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"OPENMULTRDRULE": {
		"UNK": null,
		"NOR": {
			"v": 81.4,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 89.4,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 50.8,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 82.8,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 50.9,
			"r": "117",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 74.5,
			"r": "45",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 34.2,
			"r": "133",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 65.4,
			"r": "74",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 82.8,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 77.5,
			"r": "35",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 80.4,
			"r": "27",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 54.8,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 66.8,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 68.1,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 64.5,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 59.8,
			"r": "93",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 77.5,
			"r": "35",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 49.9,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 59.1,
			"r": "95",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 84.5,
			"r": "11",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 60.3,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 56.4,
			"r": "104",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 65.1,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 64.8,
			"r": "77",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 57.8,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 77.5,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 66.4,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 80.5,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 87.5,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 45.2,
			"r": "127",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 74.7,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 69.4,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 34.7,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 70.6,
			"r": "56",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 77.6,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 77.8,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 44.1,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 56.6,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 63.3,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 82.8,
			"r": "14",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 48.4,
			"r": "121",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 45.4,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 73.8,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 82,
			"r": "18",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 55.6,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 52.9,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 61,
			"r": "89",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 80,
			"r": "28",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 60,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 61.6,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 67.9,
			"r": "67",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 71.8,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 92.2,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 65.2,
			"r": "75",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 62.2,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 67.7,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 86.3,
			"r": "7",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 62.3,
			"r": "84",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 54,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 80.5,
			"r": "23",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 72.5,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 89.4,
			"r": "3",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 57.2,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 83.8,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 33.6,
			"r": "134",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 73.3,
			"r": "51",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 73.9,
			"r": "49",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 70.6,
			"r": "56",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 55.4,
			"r": "106",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 74.8,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 47.4,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 85.2,
			"r": "8",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 70,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 59,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 45.9,
			"r": "124",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 47,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 59.7,
			"r": "94",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 55.2,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 80.5,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 87.5,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 36.9,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 74.3,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 77.3,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 80.5,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 51.3,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 65.5,
			"r": "73",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 85.2,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 74,
			"r": "48",
			"m": 63,
			"y": "2016"
		},
		"MLI": {
			"v": 61.8,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 75.5,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 81.8,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 80,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 56.5,
			"r": "103",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 82,
			"r": "18",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 62.4,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 69.1,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 60.7,
			"r": "90",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 79.7,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 58.8,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 72.3,
			"r": "53",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 64.6,
			"r": "78",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 49.9,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 63.8,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 61.8,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 89.6,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 65.7,
			"r": "72",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 71.8,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 82.2,
			"r": "17",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 83.9,
			"r": "12",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 81.3,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 77.4,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 69.2,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 69.7,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 84.7,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 78.8,
			"r": "32",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 62.5,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 54.8,
			"r": "109",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 68.1,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 66.9,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 42,
			"r": "130",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 80,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 42.2,
			"r": "129",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 45.9,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 57.1,
			"r": "100",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 74.6,
			"r": "44",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 55.4,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 53.3,
			"r": "112",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 57,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 52,
			"r": "115",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 68.1,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 53.2,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 75.9,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 69.1,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 74.3,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"MARGINPREF": {
		"UNK": null,
		"NOR": {
			"v": 29.61,
			"r": "96",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 56.88,
			"r": "25",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 10.24,
			"r": "123",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 53.34,
			"r": "38",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 41.03,
			"r": "75",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 41.84,
			"r": "72",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 25.64,
			"r": "102",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 43.71,
			"r": "64",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 45.82,
			"r": "60",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 13.03,
			"r": "118",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 32.11,
			"r": "93",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 63.31,
			"r": "12",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 40.79,
			"r": "79",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 41.79,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 56.4,
			"r": "27",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 23.02,
			"r": "109",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 62.27,
			"r": "16",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 61.69,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 64.01,
			"r": "11",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 62.65,
			"r": "14",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 31.46,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 63.21,
			"r": "13",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 35.8,
			"r": "83",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 68.28,
			"r": "9",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 84.44,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 48.71,
			"r": "52",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 77.09,
			"r": "4",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 42.82,
			"r": "68",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 51.12,
			"r": "45",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 48.7,
			"r": "53",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 45.37,
			"r": "61",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 40.42,
			"r": "80",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 43.15,
			"r": "66",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 7.3,
			"r": "128",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 48.47,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 33.26,
			"r": "90",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 89.89,
			"r": "2",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 72.29,
			"r": "5",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 40.94,
			"r": "77",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 56.51,
			"r": "26",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0,
			"r": "136",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 65.71,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 48.99,
			"r": "51",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 43.24,
			"r": "65",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 24.77,
			"r": "103",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 33.48,
			"r": "89",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 49.06,
			"r": "50",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 24.39,
			"r": "106",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 18.38,
			"r": "112",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 62.28,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 32.54,
			"r": "91",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 34.28,
			"r": "85",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 53.49,
			"r": "37",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 41,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 42.06,
			"r": "70",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 22.48,
			"r": "110",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 51.24,
			"r": "44",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 5.83,
			"r": "132",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 12.53,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 5.75,
			"r": "133",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 54.66,
			"r": "33",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 50.74,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 42.2,
			"r": "69",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 57.09,
			"r": "24",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 69.93,
			"r": "7",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 50.3,
			"r": "48",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 32.35,
			"r": "92",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 28.24,
			"r": "98",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 28.53,
			"r": "97",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 52.71,
			"r": "40",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 24.62,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 47.12,
			"r": "56",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 71.27,
			"r": "6",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 14.78,
			"r": "116",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 54.61,
			"r": "34",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 7.71,
			"r": "127",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 13.45,
			"r": "117",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 34.08,
			"r": "86",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 31.67,
			"r": "94",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 37.93,
			"r": "82",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 51.04,
			"r": "46",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 12.31,
			"r": "121",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 46.67,
			"r": "57",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 55.8,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 39.52,
			"r": "81",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 58.51,
			"r": "21",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 33.97,
			"r": "87",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 54.96,
			"r": "31",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 58.19,
			"r": "22",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 25.78,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 21.87,
			"r": "111",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 41.63,
			"r": "74",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 54.01,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 61.17,
			"r": "18",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 47.71,
			"r": "55",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.49,
			"r": "134",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 93.11,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 49.1,
			"r": "49",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 28.09,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 16.03,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 57.79,
			"r": "23",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 42.89,
			"r": "67",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 24.42,
			"r": "105",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 8.75,
			"r": "124",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 52.8,
			"r": "39",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 51.3,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 34.74,
			"r": "84",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 12.37,
			"r": "120",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 44.68,
			"r": "63",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 6.75,
			"r": "129",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 23.45,
			"r": "108",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 40.9,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 6.67,
			"r": "130",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 54.75,
			"r": "32",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 41.98,
			"r": "71",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 24.13,
			"r": "107",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 33.97,
			"r": "88",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 16.46,
			"r": "114",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 45.99,
			"r": "59",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 52.41,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 52.06,
			"r": "42",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 53.98,
			"r": "36",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 45.21,
			"r": "62",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 10.6,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 8.16,
			"r": "125",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 59.92,
			"r": "19",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 55.7,
			"r": "30",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 6.13,
			"r": "131",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 56.1,
			"r": "28",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 46.48,
			"r": "58",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 1.59,
			"r": "135",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 58.64,
			"r": "20",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 69.53,
			"r": "8",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 25.67,
			"r": "101",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 18.26,
			"r": "113",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 7.81,
			"r": "126",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"gov_impartiality": {
		"UNK": null,
		"NOR": {
			"v": 1.44,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 0.8,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.33,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.43,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.86,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.57,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0.83,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.43,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.29,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.75,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.43,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.57,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.57,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.86,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.38,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.62,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.67,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.43,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1.14,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.88,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.17,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.62,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.83,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0.86,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.75,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.75,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.57,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.67,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.67,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.75,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 0.33,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.62,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.17,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.14,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 0.17,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.88,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.22,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.2,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.25,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1.71,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.44,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.89,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1.14,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.5,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.89,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.17,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.71,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.43,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.25,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.88,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.62,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.71,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.89,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.78,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.67,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.5,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 0.8,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.43,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.4,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.89,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.14,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.89,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 0.62,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1.14,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0.43,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.12,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.62,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 0.83,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0.5,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.38,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.89,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.57,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.89,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.89,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.8,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1.29,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.5,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0.25,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.5,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.67,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.62,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.86,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TABTIMEEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 2,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 528,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 120,
			"r": "119",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 24,
			"r": "68",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 91,
			"r": "115",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 24,
			"r": "68",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"r": "18",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 33,
			"r": "82",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 47,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 24,
			"r": "68",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 48,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 10,
			"r": "58",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2,
			"r": "28",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 70.33,
			"r": "106",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 48,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 2,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 12.5,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 132,
			"r": "124",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 72,
			"r": "107",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 19,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 8,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 9.33,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 2.5,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 163,
			"r": "129",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 24,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 2,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 48,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 169,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 131.43,
			"r": "123",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 1,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 18.64,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 63.75,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 186,
			"r": "131",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 5.41,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 152,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 83,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 38,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 88,
			"r": "111",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 1.75,
			"r": "27",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 59,
			"r": "97",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 11.27,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 21,
			"r": "65",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 72,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 1.56,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 18,
			"r": "62",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 2,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 24,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 42,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 200,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 12,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 10,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 32,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 174,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 6,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.5,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 60,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 66,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 7,
			"r": "52",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 25.62,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.75,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 44,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 120,
			"r": "119",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 9,
			"r": "54",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 30,
			"r": "78",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4,
			"r": "45",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 128,
			"r": "121",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 24,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 48,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 61.32,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0.5,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 48,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 139,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 76,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 192,
			"r": "132",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 0.67,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 697.85,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 68,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 50,
			"r": "95",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 2,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.5,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 87,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 22,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 1,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 61.33,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 149.14,
			"r": "127",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 1,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6,
			"r": "49",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 48,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 22,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 4,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0.5,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.5,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 147,
			"r": "126",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0.5,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 9.78,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 9,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 228,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 48,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 24,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 90,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 2,
			"r": "28",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 130,
			"r": "122",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 50.67,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 84,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 38.39,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.33,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 89.33,
			"r": "112",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 25.4,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.5,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 21.2,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 1.5,
			"r": "25",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 2.37,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 48,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 1,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 96,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 2,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 48,
			"r": "86",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 60,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 2,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 216,
			"r": "133",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0.5,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 90,
			"r": "113",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 133.71,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.22,
			"r": "51",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.33,
			"r": "46",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 144,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 99,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 32.4,
			"r": "81",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 26,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 66,
			"r": "103",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 168,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 33,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 96,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 48.91,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 1,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 31.38,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 54,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETI_INSTITQUALITY": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ052": {
		"UNK": null,
		"NOR": {
			"v": 5.99,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.78,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.99,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.89,
			"r": "32",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.65,
			"r": "136",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.04,
			"r": "30",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.76,
			"r": "88",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.69,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.01,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.41,
			"r": "49",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.1,
			"r": "71",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.45,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.84,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.87,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.9,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.33,
			"r": "27",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.83,
			"r": "84",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.9,
			"r": "9",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.16,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.96,
			"r": "131",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.92,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.73,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 2.99,
			"r": "130",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.04,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.96,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.98,
			"r": "75",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.16,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.36,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.34,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.13,
			"r": "70",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.3,
			"r": "58",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.34,
			"r": "52",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.25,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.27,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.74,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.26,
			"r": "138",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 3.36,
			"r": "112",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.77,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.45,
			"r": "2",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.37,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.52,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.68,
			"r": "94",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.51,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.18,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.31,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.27,
			"r": "81",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.24,
			"r": "124",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.35,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.39,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.29,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.35,
			"r": "115",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 1.78,
			"r": "143",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.46,
			"r": "1",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.05,
			"r": "73",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.91,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.52,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.26,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.69,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.26,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 2.69,
			"r": "128",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 3.95,
			"r": "77",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.61,
			"r": "98",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.86,
			"r": "52",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.81,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.49,
			"r": "72",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.99,
			"r": "11",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.59,
			"r": "102",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.22,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.8,
			"r": "18",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.31,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.8,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.83,
			"r": "75",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.75,
			"r": "90",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.6,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.49,
			"r": "46",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.58,
			"r": "103",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.09,
			"r": "7",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.14,
			"r": "69",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.3,
			"r": "56",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.35,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.35,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.63,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.14,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.22,
			"r": "138",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.51,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.74,
			"r": "135",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.98,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.51,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.74,
			"r": "21",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.7,
			"r": "92",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.29,
			"r": "59",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.32,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.82,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.34,
			"r": "137",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.04,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.09,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.09,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.78,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.4,
			"r": "108",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.27,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.32,
			"r": "118",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.89,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.83,
			"r": "36",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.46,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.33,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.22,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.99,
			"r": "129",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.84,
			"r": "17",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.76,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.49,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.24,
			"r": "123",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.37,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.85,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.6,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.23,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.76,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.42,
			"r": "85",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.53,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.93,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.17,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.93,
			"r": "78",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.33,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.45,
			"r": "26",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.25,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.86,
			"r": "16",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.66,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.94,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.6,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.8,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.22,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.84,
			"r": "83",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.18,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.71,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.64,
			"r": "96",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.37,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.67,
			"r": "40",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.27,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.7,
			"r": "24",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.93,
			"r": "132",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.78,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.64,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.75,
			"r": "89",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.3,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.28,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.29,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.46,
			"r": "135",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.59,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.41,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.86,
			"r": "15",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.15,
			"r": "6",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.15,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.41,
			"r": "48",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ext_cooperation": {
		"UNK": null,
		"NOR": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 2,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 0,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.5,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"MLT": null,
		"BVT": null,
		"GTM": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 0.5,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 2,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 0.67,
			"y": "2015",
			"m": 103
		},
		"BRN": null,
		"CHL": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 0.5,
			"y": "2015",
			"m": 100
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 1,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 2,
			"y": "2015",
			"m": 94
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.75,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.5,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 0.25,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.67,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0.5,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 2,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 1.33,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 2,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": null,
		"BWA": {
			"v": 1.25,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": null,
		"DNK": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.5,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.67,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0,
			"y": "2015",
			"m": 100
		},
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"BLR": null,
		"ITA": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.67,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 2,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.75,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.5,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 0.5,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 0,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.67,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 0,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.5,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 0.5,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": null,
		"COL": {
			"v": 1.5,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1.5,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 2,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.5,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TARIFDISP": {
		"UNK": null,
		"NOR": {
			"v": 35.89,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 7.16,
			"r": "64",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 11.81,
			"r": "112",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 5.61,
			"r": "14",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 11.52,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 23,
			"r": "130",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 51.28,
			"r": "135",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 8.08,
			"r": "82",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 12.61,
			"r": "116",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 6.99,
			"r": "61",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 6.32,
			"r": "22",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 20.4,
			"r": "128",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.9,
			"r": "58",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 7.29,
			"r": "69",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 6.97,
			"r": "59",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 8.55,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 10.34,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 9.36,
			"r": "91",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.55,
			"r": "25",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 11.72,
			"r": "110",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 11.49,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 11.28,
			"r": "103",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 7.68,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3.35,
			"r": "7",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 0.29,
			"r": "2",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 5.28,
			"r": "12",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 7.45,
			"r": "75",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 9.89,
			"r": "98",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 11.82,
			"r": "113",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 7.37,
			"r": "70",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 5.7,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 28.36,
			"r": "132",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 12.2,
			"r": "115",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 141.83,
			"r": "136",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 6.87,
			"r": "30",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 9.13,
			"r": "90",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 16.14,
			"r": "123",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 7.21,
			"r": "66",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 37.09,
			"r": "134",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 8.44,
			"r": "84",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 14.72,
			"r": "121",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 7.74,
			"r": "79",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 11.75,
			"r": "111",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 6.87,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 9.04,
			"r": "89",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 11.21,
			"r": "102",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 7.86,
			"r": "80",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 6.87,
			"r": "30",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 9.66,
			"r": "95",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 6.18,
			"r": "21",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 2.62,
			"r": "5",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 16.96,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 7.4,
			"r": "71",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 14.01,
			"r": "118",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 8.56,
			"r": "87",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 6.87,
			"r": "30",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 7.27,
			"r": "68",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 11.46,
			"r": "105",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 6.38,
			"r": "23",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 7.87,
			"r": "81",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 6.74,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 18.49,
			"r": "125",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 8.98,
			"r": "88",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 5.99,
			"r": "20",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 11.67,
			"r": "109",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 11.02,
			"r": "101",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 6.87,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 9.47,
			"r": "93",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.87,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 7.53,
			"r": "76",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 10.18,
			"r": "99",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 5.22,
			"r": "11",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 7.4,
			"r": "71",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 9.82,
			"r": "97",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.87,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 6.87,
			"r": "30",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 9.47,
			"r": "94",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 6.87,
			"r": "30",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 5.7,
			"r": "16",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.96,
			"r": "9",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 11.38,
			"r": "104",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.71,
			"r": "27",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 6.44,
			"r": "24",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 5.92,
			"r": "19",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 9.76,
			"r": "96",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 7,
			"r": "62",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 14.58,
			"r": "120",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 13.06,
			"r": "117",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 7.24,
			"r": "67",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 6.86,
			"r": "29",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 7.18,
			"r": "65",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 6.87,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 7.6,
			"r": "77",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 5.66,
			"r": "15",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 25.38,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 15.89,
			"r": "122",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 3.89,
			"r": "8",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 6.87,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 5.07,
			"r": "10",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 1.11,
			"r": "4",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 7.4,
			"r": "71",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 8.37,
			"r": "83",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 22.37,
			"r": "129",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 8.45,
			"r": "85",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 6.87,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 11.49,
			"r": "106",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 7.04,
			"r": "63",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 5.71,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 6.65,
			"r": "26",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 19.61,
			"r": "127",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 5.42,
			"r": "13",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 7.4,
			"r": "71",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 9.46,
			"r": "92",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 0.72,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 11.88,
			"r": "114",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 6.97,
			"r": "60",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 19.23,
			"r": "126",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 2.77,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 14.25,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ366": {
		"UNK": null,
		"NOR": {
			"v": 5.87,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.22,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.92,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.8,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.03,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.72,
			"r": "54",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.71,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.05,
			"r": "95",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.82,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.9,
			"r": "5",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.85,
			"r": "50",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.12,
			"r": "87",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.57,
			"r": "67",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.62,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.58,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.72,
			"r": "13",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.53,
			"r": "69",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.24,
			"r": "32",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.53,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.43,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.38,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.58,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.33,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.57,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.87,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.24,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.49,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.25,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.71,
			"r": "14",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.97,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.64,
			"r": "58",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.13,
			"r": "37",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.62,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.92,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.12,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.59,
			"r": "142",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 4.3,
			"r": "77",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.13,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.3,
			"r": "31",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.36,
			"r": "127",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.61,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.64,
			"r": "117",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.11,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.82,
			"r": "107",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.1,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.05,
			"r": "96",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 5.02,
			"r": "40",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.66,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.19,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.96,
			"r": "101",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.53,
			"r": "143",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.76,
			"r": "12",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.01,
			"r": "41",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.61,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.78,
			"r": "52",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.06,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.86,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.27,
			"r": "75",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.42,
			"r": "123",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.33,
			"r": "74",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.03,
			"r": "97",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.94,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.28,
			"r": "32",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.47,
			"r": "123",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.73,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.51,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.32,
			"r": "76",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.59,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.01,
			"r": "96",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.86,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.96,
			"r": "44",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.55,
			"r": "120",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.37,
			"r": "73",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.4,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.74,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.74,
			"r": "110",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.22,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.43,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.7,
			"r": "15",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.29,
			"r": "78",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.99,
			"r": "136",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.68,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.2,
			"r": "131",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.44,
			"r": "27",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.27,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.81,
			"r": "51",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.86,
			"r": "49",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.98,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.59,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.53,
			"r": "138",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.52,
			"r": "120",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.3,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.07,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.17,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.42,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.42,
			"r": "125",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.23,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.61,
			"r": "118",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.29,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 3.87,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.05,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.72,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.11,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.76,
			"r": "109",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.51,
			"r": "25",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.41,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.87,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.69,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.73,
			"r": "112",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.64,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.09,
			"r": "89",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.66,
			"r": "115",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.91,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.31,
			"r": "128",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.57,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.54,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.09,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.08,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 5.26,
			"r": "33",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.9,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.14,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.38,
			"r": "2",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.9,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.87,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.29,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.81,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.15,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.58,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.87,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.63,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.6,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.09,
			"r": "91",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.63,
			"r": "18",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.99,
			"r": "98",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.77,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.64,
			"r": "17",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.28,
			"r": "80",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.31,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.18,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.72,
			"r": "56",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.55,
			"r": "68",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.98,
			"r": "100",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.37,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.66,
			"r": "140",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.8,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.08,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.69,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.56,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.01,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.26,
			"r": "81",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TRACKTRACE": {
		"UNK": null,
		"NOR": {
			"v": 3.82,
			"r": "22",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.16,
			"r": "52",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.48,
			"r": "98",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.84,
			"r": "21",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.68,
			"r": "83",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.32,
			"r": "44",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.18,
			"r": "120",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.65,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 4.02,
			"r": "15",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.78,
			"r": "24",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.14,
			"r": "123",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.38,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 2.84,
			"r": "73",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.12,
			"r": "56",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.46,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.46,
			"r": "36",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.02,
			"r": "129",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.75,
			"r": "79",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.47,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 2.32,
			"r": "113",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.72,
			"r": "26",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.7,
			"r": "81",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.86,
			"r": "72",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.42,
			"r": "38",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 1.92,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.4,
			"r": "42",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.78,
			"r": "75",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.68,
			"r": "27",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 2.95,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 2.91,
			"r": "68",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.5,
			"r": "34",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.42,
			"r": "39",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.21,
			"r": "118",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.21,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 2.7,
			"r": "82",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.65,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 4.04,
			"r": "11",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.47,
			"r": "101",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.01,
			"r": "59",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.07,
			"r": "124",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.37,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.44,
			"r": "103",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.63,
			"r": "87",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.15,
			"r": "54",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.72,
			"r": "80",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.91,
			"r": "67",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.2,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 2.39,
			"r": "105",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 1.85,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 4.04,
			"r": "12",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 3.28,
			"r": "45",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 2.96,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.77,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 3.04,
			"r": "58",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.27,
			"r": "46",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.9,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.63,
			"r": "88",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.28,
			"r": "116",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.05,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 2.95,
			"r": "63",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.22,
			"r": "4",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.07,
			"r": "126",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.04,
			"r": "127",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.87,
			"r": "19",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.34,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.4,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.62,
			"r": "89",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.82,
			"r": "23",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.2,
			"r": "119",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 3.26,
			"r": "47",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 4.13,
			"r": "7",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.86,
			"r": "70",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 2.89,
			"r": "69",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.67,
			"r": "85",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3.19,
			"r": "51",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.74,
			"r": "25",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.53,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.54,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.76,
			"r": "77",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 2.31,
			"r": "114",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.03,
			"r": "14",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.37,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.92,
			"r": "17",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 2.84,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.54,
			"r": "94",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.12,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.07,
			"r": "125",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.56,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.98,
			"r": "16",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.46,
			"r": "37",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.38,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2,
			"r": "131",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.86,
			"r": "71",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 3.59,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.15,
			"r": "121",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 2.36,
			"r": "110",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.09,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.16,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.86,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.17,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.59,
			"r": "91",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 4.36,
			"r": "2",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.5,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.34,
			"r": "111",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 1.77,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.75,
			"r": "78",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.3,
			"r": "115",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3.25,
			"r": "49",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.44,
			"r": "104",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.36,
			"r": "109",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 1.54,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.49,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.52,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 2.67,
			"r": "84",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.92,
			"r": "66",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.52,
			"r": "97",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.62,
			"r": "90",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.25,
			"r": "48",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.68,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.2,
			"r": "5",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.39,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.03,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.94,
			"r": "65",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.27,
			"r": "3",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.96,
			"r": "61",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.05,
			"r": "10",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.23,
			"r": "117",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.55,
			"r": "93",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.42,
			"r": "40",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 1.76,
			"r": "134",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.12,
			"r": "8",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.52,
			"r": "96",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 1.74,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.91,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.56,
			"r": "92",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.57,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.95,
			"r": "132",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.16,
			"r": "53",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.15,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.04,
			"r": "128",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.47,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.98,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.01,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 4.1,
			"r": "9",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.58,
			"r": "32",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.59,
			"r": "31",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ033": {
		"UNK": null,
		"NOR": {
			"v": 5.85,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 6.16,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 4.9,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.96,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.43,
			"r": "108",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.77,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.2,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 5.61,
			"r": "47",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.28,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.99,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.82,
			"r": "32",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 5.21,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 6.52,
			"r": "2",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.39,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.34,
			"r": "111",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.08,
			"r": "78",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5.8,
			"r": "33",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.95,
			"r": "31",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 4.33,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 6.28,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.77,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.39,
			"r": "125",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.76,
			"r": "95",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.1,
			"r": "120",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.58,
			"r": "137",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.71,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.79,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.01,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.63,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.67,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.27,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.29,
			"r": "65",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.87,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.14,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 5.21,
			"r": "70",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 4.77,
			"r": "96",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.96,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 6.12,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.43,
			"r": "3",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.36,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.7,
			"r": "123",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.25,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 5.25,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.5,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 6.23,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 4.95,
			"r": "105",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 2.66,
			"r": "135",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.45,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.7,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.01,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.18,
			"r": "118",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.43,
			"r": "142",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.87,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 6.21,
			"r": "10",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.54,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.94,
			"r": "23",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 6.23,
			"r": "9",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.88,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.96,
			"r": "88",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 6.21,
			"r": "15",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 5.78,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.15,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.51,
			"r": "112",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 5.96,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 6.6,
			"r": "3",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.85,
			"r": "87",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 5.37,
			"r": "61",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 5.02,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.41,
			"r": "55",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.65,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.83,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.6,
			"r": "105",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.9,
			"r": "84",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.37,
			"r": "60",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.65,
			"r": "44",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 5.53,
			"r": "51",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.78,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.57,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 5.8,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 5.54,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.22,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.09,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.42,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 5.47,
			"r": "62",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 5.55,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 5.86,
			"r": "29",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.19,
			"r": "11",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 5.38,
			"r": "59",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.31,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.17,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.48,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.83,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.64,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 5.18,
			"r": "79",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.11,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.48,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.04,
			"r": "20",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.35,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.55,
			"r": "102",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 5.35,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.4,
			"r": "56",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.25,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.09,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 5.54,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 5.07,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.4,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.21,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.8,
			"r": "35",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 6.09,
			"r": "17",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.86,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.03,
			"r": "130",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.74,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.5,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.69,
			"r": "38",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.77,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.19,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.87,
			"r": "128",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.01,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.23,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.13,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.84,
			"r": "88",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.58,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.18,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.97,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.52,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.12,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.08,
			"r": "77",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.48,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.9,
			"r": "85",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.21,
			"r": "128",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.62,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.74,
			"r": "97",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.93,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.35,
			"r": "4",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.98,
			"r": "82",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.66,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.16,
			"r": "14",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.66,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.27,
			"r": "7",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.16,
			"r": "73",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.23,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 6.35,
			"r": "5",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.29,
			"r": "66",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.82,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.65,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 6.08,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 4.91,
			"r": "92",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.71,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.76,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.28,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.69,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.66,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.86,
			"r": "27",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 5": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"LOGICOMP": {
		"UNK": null,
		"NOR": {
			"v": 3.7,
			"r": "24",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.21,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.34,
			"r": "110",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.65,
			"r": "26",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.46,
			"r": "102",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.38,
			"r": "33",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.37,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.66,
			"r": "84",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.82,
			"r": "19",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.69,
			"r": "25",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.14,
			"r": "123",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.31,
			"r": "113",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 3.01,
			"r": "53",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 2.85,
			"r": "67",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.3,
			"r": "116",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.34,
			"r": "35",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.21,
			"r": "121",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.44,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.55,
			"r": "94",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 2.36,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.6,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.6,
			"r": "87",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.7,
			"r": "77",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.24,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 2.16,
			"r": "122",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.14,
			"r": "48",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.66,
			"r": "83",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.49,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 2.82,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 2.57,
			"r": "91",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 2.97,
			"r": "56",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.29,
			"r": "37",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.21,
			"r": "120",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.31,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 2.74,
			"r": "74",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.15,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 3.88,
			"r": "16",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.13,
			"r": "124",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.93,
			"r": "57",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.07,
			"r": "130",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.31,
			"r": "114",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.67,
			"r": "82",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.86,
			"r": "66",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.2,
			"r": "43",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.06,
			"r": "52",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.82,
			"r": "70",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.14,
			"r": "49",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 1.96,
			"r": "132",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 2.5,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 3.95,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 3.12,
			"r": "50",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 2.89,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.55,
			"r": "92",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 2.87,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.2,
			"r": "44",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.66,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.68,
			"r": "79",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.28,
			"r": "118",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.39,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.18,
			"r": "45",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.07,
			"r": "6",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.12,
			"r": "126",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.12,
			"r": "127",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.87,
			"r": "17",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2.59,
			"r": "89",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.35,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.62,
			"r": "86",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.73,
			"r": "23",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.3,
			"r": "117",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 2.83,
			"r": "68",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 4.05,
			"r": "7",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.57,
			"r": "90",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 2.74,
			"r": "75",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.48,
			"r": "99",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3,
			"r": "55",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 4.01,
			"r": "9",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.44,
			"r": "105",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.54,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.91,
			"r": "61",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 1.9,
			"r": "134",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4,
			"r": "11",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.33,
			"r": "111",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.75,
			"r": "22",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 2.88,
			"r": "63",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.72,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.12,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.06,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.68,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.79,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.39,
			"r": "31",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.25,
			"r": "2",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.22,
			"r": "119",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.91,
			"r": "59",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.91,
			"r": "60",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.48,
			"r": "97",
			"m": 52,
			"y": "2015"
		},
		"MLI": {
			"v": 2.46,
			"r": "101",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.26,
			"r": "38",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.32,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.77,
			"r": "21",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.22,
			"r": "3",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.67,
			"r": "80",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 4.18,
			"r": "4",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.54,
			"r": "29",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.48,
			"r": "98",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.15,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.45,
			"r": "103",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.69,
			"r": "78",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3,
			"r": "54",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.08,
			"r": "129",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.42,
			"r": "106",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 1.74,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.78,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.39,
			"r": "32",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 2.59,
			"r": "88",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.79,
			"r": "71",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.54,
			"r": "95",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.76,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.18,
			"r": "46",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.62,
			"r": "27",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.01,
			"r": "8",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.31,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 3.99,
			"r": "12",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.87,
			"r": "65",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.28,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.55,
			"r": "93",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.09,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.47,
			"r": "100",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.67,
			"r": "81",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.26,
			"r": "39",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.1,
			"r": "128",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.01,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.63,
			"r": "85",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 1.85,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.82,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.52,
			"r": "96",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.36,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2.13,
			"r": "125",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 2.79,
			"r": "72",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.39,
			"r": "107",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.32,
			"r": "112",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.31,
			"r": "115",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.92,
			"r": "58",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.93,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 3.9,
			"r": "15",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.22,
			"r": "41",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.95,
			"r": "13",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"GOVONLINESERVIDX": {
		"UNK": null,
		"NOR": {
			"v": 0.8,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.75,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 0.43,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0.48,
			"r": "88",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 0.15,
			"r": "122",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 0.83,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 0.53,
			"r": "79",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 0.63,
			"r": "57",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0.94,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 0.94,
			"r": "5",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 0.68,
			"r": "47",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 0.36,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 0.78,
			"r": "28",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 0.8,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 0.67,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 0.72,
			"r": "40",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.43,
			"r": "97",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 0.2,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 0.38,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 0.61,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 0.86,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 0.05,
			"r": "134",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.67,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 0.56,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 0.14,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 0.85,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 0.49,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0.83,
			"r": "22",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.46,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 0.51,
			"r": "83",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 0.78,
			"r": "28",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.61,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 0.14,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 0.46,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.35,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 0.41,
			"r": "99",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0.75,
			"r": "33",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.94,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 0.4,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.5,
			"r": "85",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 0.24,
			"r": "115",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 0.68,
			"r": "47",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 0.33,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 0.22,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.32,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 0.47,
			"r": "89",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0.57,
			"r": "74",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 0.33,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 0.55,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 0.43,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 0.11,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 0.6,
			"r": "64",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 0.73,
			"r": "37",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 0.46,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0.64,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 0.46,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0.85,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 0.28,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 0.3,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 0.51,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 0.53,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.69,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 0.33,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0.71,
			"r": "43",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 0.15,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 0.12,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 0.98,
			"r": "2",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0.74,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0.63,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 0.41,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 0.19,
			"r": "121",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0.91,
			"r": "11",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.32,
			"r": "109",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 0.71,
			"r": "43",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 1,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0.77,
			"r": "31",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 0.28,
			"r": "111",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 0.59,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 0.36,
			"r": "104",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0.78,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 0.31,
			"r": "110",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 0.09,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 0.65,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 0.49,
			"r": "86",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 0.09,
			"r": "131",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 0.56,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 0.57,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 0.54,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.44,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 0.14,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 0.17,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 0.72,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0.7,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0.88,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 0.2,
			"r": "120",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.07,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0.58,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 0.59,
			"r": "67",
			"m": 60,
			"y": "2016"
		},
		"MLI": {
			"v": 0.09,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 0.59,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.28,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 0.49,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0.87,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0.93,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 0.62,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0.91,
			"r": "11",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 0.67,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.7,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 0.3,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 0.51,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.6,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 0.67,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 0.64,
			"r": "55",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 0.37,
			"r": "103",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 0.07,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 0.19,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 0.75,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 0.72,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 0.82,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 0.45,
			"r": "93",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 0.73,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0.89,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 0.77,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 0.93,
			"r": "9",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 0.6,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 0.88,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 0.63,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0.84,
			"r": "21",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 0.59,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 0.97,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 0.14,
			"r": "124",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 0.79,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 0.62,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 0.28,
			"r": "111",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0.72,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 0.28,
			"r": "111",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 0.12,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 0.89,
			"r": "13",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 0.45,
			"r": "93",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 0.16,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 0.26,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 0.65,
			"r": "53",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 0.38,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 0.22,
			"r": "117",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 0.51,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 0.22,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 0.57,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.22,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 0.96,
			"r": "4",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 0.94,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"TWN": null,
		"BRB": {
			"v": 0.44,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ088": {
		"UNK": null,
		"NOR": {
			"v": 5.19,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.41,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.88,
			"r": "71",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.4,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.41,
			"r": "131",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.7,
			"r": "23",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.67,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.14,
			"r": "108",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.26,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.48,
			"r": "91",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.3,
			"r": "100",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.63,
			"r": "80",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.28,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.51,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.71,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.68,
			"r": "25",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.92,
			"r": "70",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 2.8,
			"r": "73",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.21,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.85,
			"r": "67",
			"m": 102,
			"y": "2014"
		},
		"MKD": {
			"v": 4.33,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.67,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.78,
			"r": "75",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.29,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.27,
			"r": "49",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 1.73,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.79,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.2,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.13,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.6,
			"r": "85",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.83,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.51,
			"r": "89",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.18,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.16,
			"r": "122",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.6,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 3.66,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.19,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.14,
			"r": "54",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.6,
			"r": "83",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.39,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 2.8,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.65,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 2.31,
			"r": "106",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 1.86,
			"r": "129",
			"m": 94,
			"y": "2014"
		},
		"BGR": {
			"v": 4.08,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.28,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.48,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.63,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 1.52,
			"r": "142",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.15,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.6,
			"r": "84",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.87,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.31,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.04,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.18,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.33,
			"r": "37",
			"m": 96,
			"y": "2014"
		},
		"SUR": {
			"v": 2.35,
			"r": "111",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.12,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.75,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.68,
			"r": "96",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 5.22,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.35,
			"r": "101",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.96,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.97,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.11,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.08,
			"r": "14",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.58,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.61,
			"r": "29",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.6,
			"r": "25",
			"m": 104,
			"y": "2013"
		},
		"CIV": {
			"v": 2.69,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3.57,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.99,
			"r": "66",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.97,
			"r": "116",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.27,
			"r": "48",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.56,
			"r": "88",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.94,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.07,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.67,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.13,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.27,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.19,
			"r": "119",
			"m": 95,
			"y": "2013"
		},
		"CAF": null,
		"LKA": {
			"v": 4.12,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.47,
			"r": "34",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 4.49,
			"r": "5",
			"m": 96,
			"y": "2014"
		},
		"COD": {
			"v": 2.96,
			"r": "118",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.17,
			"r": "12",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.62,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 2.55,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.75,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.56,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.33,
			"r": "112",
			"m": 96,
			"y": "2014"
		},
		"IRL": {
			"v": 3.5,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.34,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.38,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 2.95,
			"r": "119",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.88,
			"r": "121",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 1.75,
			"r": "134",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.19,
			"r": "105",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.43,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.67,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 2.7,
			"r": "81",
			"m": 104,
			"y": "2014"
		},
		"BLR": null,
		"ITA": {
			"v": 2.98,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.19,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.4,
			"r": "95",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.84,
			"r": "19",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.6,
			"r": "2",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.34,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.43,
			"r": "36",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.38,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.05,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.23,
			"r": "51",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.42,
			"r": "93",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.05,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 1.64,
			"r": "138",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.42,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.29,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.85,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.25,
			"r": "103",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 2.98,
			"r": "114",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.57,
			"r": "30",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.47,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.31,
			"r": "7",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.1,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.34,
			"r": "6",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.43,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.05,
			"r": "15",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.03,
			"r": "111",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.47,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.58,
			"r": "128",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.07,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.51,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.92,
			"r": "69",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.2,
			"r": "9",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.81,
			"r": "73",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.6,
			"r": "126",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.04,
			"r": "16",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.97,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 1.37,
			"r": "144",
			"m": 100,
			"y": "2014"
		},
		"REU": null,
		"ZWE": {
			"v": 2.78,
			"r": "123",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.38,
			"r": "41",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.3,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.35,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.99,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.52,
			"r": "94",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.7,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.94,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.68,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.74,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.38,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.02,
			"r": "112",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"inf_availability": {
		"UNK": null,
		"NOR": {
			"v": 1.41,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.6,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.33,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.4,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.8,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.6,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.9,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.61,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.89,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.8,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.2,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.9,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.6,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.8,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.7,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.47,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 1.4,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.7,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.06,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.9,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.47,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.67,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.3,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1.4,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.39,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.44,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 1.4,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.22,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1.4,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 1.33,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 1.1,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1.8,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 1.7,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.9,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 1.8,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 1.56,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.7,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.4,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.7,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 1.8,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 1.67,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 0.12,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.9,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0.89,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 1.9,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.11,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.33,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 0.2,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.89,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 1.7,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.61,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.9,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 1.8,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.67,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 1.5,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.78,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.7,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.78,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1.9,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.6,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0.25,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 2,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.8,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 2,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.39,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 1.61,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.39,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.44,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.9,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.8,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.22,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 0.6,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1.6,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 0.78,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.33,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.56,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.6,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.78,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.4,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1.5,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.4,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 0.7,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1.6,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1.4,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.9,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1.7,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1.2,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1.4,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.39,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.8,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.67,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.28,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.71,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 1.7,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.39,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 1.7,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 1.33,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.9,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 1,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.75,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 1.2,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.6,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 1.11,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 1.2,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.4,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 1.3,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1.44,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 0.6,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.9,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.6,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.83,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.61,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 1.4,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TARIFACED": {
		"UNK": null,
		"NOR": {
			"v": 3.76,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.54,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 4.73,
			"r": "121",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.53,
			"r": "40",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.58,
			"r": "16",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 4.66,
			"r": "116",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.42,
			"r": "10",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 3.79,
			"r": "87",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.54,
			"r": "50",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.39,
			"r": "32",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 4.87,
			"r": "128",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 3.88,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 4.61,
			"r": "115",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.53,
			"r": "45",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 3.77,
			"r": "84",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.88,
			"r": "97",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.91,
			"r": "99",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.34,
			"r": "7",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 3.74,
			"r": "79",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.93,
			"r": "100",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.62,
			"r": "68",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 2.16,
			"r": "1",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.87,
			"r": "25",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.75,
			"r": "80",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 2.54,
			"r": "14",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.7,
			"r": "73",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 3.79,
			"r": "86",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.54,
			"r": "64",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3.53,
			"r": "38",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3.86,
			"r": "95",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 2.31,
			"r": "5",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.54,
			"r": "53",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.4,
			"r": "9",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 4.45,
			"r": "113",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.54,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 3.54,
			"r": "61",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.47,
			"r": "12",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.35,
			"r": "8",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.63,
			"r": "20",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 3.95,
			"r": "103",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 5.01,
			"r": "134",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.3,
			"r": "3",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.59,
			"r": "66",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.53,
			"r": "39",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 3.66,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.83,
			"r": "91",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 4.25,
			"r": "111",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 3.47,
			"r": "35",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 4.77,
			"r": "122",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 3.46,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.08,
			"r": "27",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 2.47,
			"r": "11",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.53,
			"r": "45",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.8,
			"r": "89",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 3.91,
			"r": "98",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.76,
			"r": "83",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 3.54,
			"r": "63",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 4.69,
			"r": "119",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 4.34,
			"r": "112",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 4.67,
			"r": "117",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.51,
			"r": "36",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.53,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 3.74,
			"r": "78",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.54,
			"r": "62",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 9.62,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 4.79,
			"r": "123",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 3.54,
			"r": "48",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.86,
			"r": "127",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.74,
			"r": "77",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 3.66,
			"r": "70",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3.32,
			"r": "29",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.54,
			"r": "49",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 3.76,
			"r": "81",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.15,
			"r": "109",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 3.73,
			"r": "76",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.83,
			"r": "124",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.38,
			"r": "31",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.96,
			"r": "104",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 3.29,
			"r": "28",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 3.53,
			"r": "43",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.53,
			"r": "44",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.48,
			"r": "13",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 3.54,
			"r": "60",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.53,
			"r": "42",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 3.54,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 3.33,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.85,
			"r": "94",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 3.54,
			"r": "59",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 3.94,
			"r": "101",
			"m": 55,
			"y": "2015"
		},
		"MLI": {
			"v": 2.58,
			"r": "18",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 4.68,
			"r": "118",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 3.54,
			"r": "57",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 3.54,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.81,
			"r": "23",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 3.54,
			"r": "65",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 4.86,
			"r": "126",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.72,
			"r": "75",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.69,
			"r": "72",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.8,
			"r": "88",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 4.91,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 3.66,
			"r": "71",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.57,
			"r": "15",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 3.04,
			"r": "26",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.17,
			"r": "110",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 3.84,
			"r": "92",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 3.97,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 3.81,
			"r": "90",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 4.99,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.54,
			"r": "54",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 4.49,
			"r": "114",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.89,
			"r": "130",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.85,
			"r": "93",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.94,
			"r": "132",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.69,
			"r": "22",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 3.54,
			"r": "58",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 4.01,
			"r": "106",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 3.45,
			"r": "33",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.68,
			"r": "21",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 3.51,
			"r": "37",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 2.83,
			"r": "24",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.26,
			"r": "2",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 3.54,
			"r": "51",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 3.72,
			"r": "74",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.61,
			"r": "19",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 4.88,
			"r": "129",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 4.09,
			"r": "107",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.78,
			"r": "85",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 4.85,
			"r": "125",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.58,
			"r": "17",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 3.6,
			"r": "67",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 4.1,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.34,
			"r": "6",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.31,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 4.69,
			"r": "120",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 3.94,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 5.06,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIA": {
		"UNK": null,
		"NOR": {
			"v": 4.43,
			"r": "78",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.03,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.06,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.97,
			"r": "29",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.89,
			"r": "38",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.26,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "103",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.12,
			"r": "96",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.82,
			"r": "47",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.08,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.57,
			"r": "119",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.42,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.13,
			"r": "93",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.69,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.26,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.35,
			"r": "85",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.46,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.31,
			"r": "12",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 5.3,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 5.01,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.77,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 5.04,
			"r": "23",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.04,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.62,
			"r": "66",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 5.71,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 5.09,
			"r": "19",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 5.46,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.78,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.94,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.07,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.83,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.76,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 4.79,
			"r": "49",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.07,
			"r": "131",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.89,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 4.64,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.68,
			"r": "63",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.37,
			"r": "7",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.1,
			"r": "97",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.97,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 2.08,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.35,
			"r": "9",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.09,
			"r": "98",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.81,
			"r": "48",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.29,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.18,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.73,
			"r": "110",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 4.16,
			"r": "92",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.24,
			"r": "130",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.88,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.08,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.78,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.96,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.56,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.12,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.2,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.87,
			"r": "41",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.86,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.56,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.02,
			"r": "101",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.58,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.91,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.91,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.96,
			"r": "30",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.61,
			"r": "117",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.84,
			"r": "108",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.55,
			"r": "73",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.29,
			"r": "129",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.5,
			"r": "75",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.79,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.62,
			"r": "67",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.82,
			"r": "45",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 5.34,
			"r": "10",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.32,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.48,
			"r": "76",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 4.57,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.51,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.29,
			"r": "87",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.51,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.7,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.94,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.7,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 4.82,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.97,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.7,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.12,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.7,
			"r": "112",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.95,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.18,
			"r": "17",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 4.35,
			"r": "83",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.07,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.73,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.87,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.35,
			"r": "84",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.9,
			"r": "37",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 3.52,
			"r": "121",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.86,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.37,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.36,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.61,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.25,
			"r": "15",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.95,
			"r": "33",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.9,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.77,
			"r": "135",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.63,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.86,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.81,
			"r": "109",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3,
			"r": "133",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.83,
			"r": "44",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 3.35,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 3.91,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.3,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.68,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.53,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.74,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.38,
			"r": "80",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.49,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.93,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.74,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.37,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 5.32,
			"r": "11",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.97,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.74,
			"r": "58",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.52,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 3.6,
			"r": "118",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.77,
			"r": "53",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.96,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.62,
			"r": "115",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.55,
			"r": "72",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.65,
			"r": "114",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.5,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 5.13,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.24,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.21,
			"r": "89",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.62,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 3.46,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ROADQUALIDX": {
		"UNK": null,
		"NOR": {
			"v": 4.02,
			"r": "87",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.34,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 5.62,
			"r": "41",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 6.18,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.41,
			"r": "109",
			"m": 81,
			"y": "2016"
		},
		"BHR": null,
		"ETH": {
			"v": 2.92,
			"r": "119",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.97,
			"r": "89",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.6,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": null,
		"AZE": {
			"v": 4.05,
			"r": "86",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.23,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.49,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"MLT": null,
		"BVT": null,
		"GTM": {
			"v": 1.95,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 2.61,
			"r": "123",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.51,
			"r": "108",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 4.37,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.91,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.87,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 6.01,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.83,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.35,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.46,
			"r": "78",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.73,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 6.61,
			"r": "7",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.51,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.07,
			"r": "21",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.97,
			"r": "65",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 5.68,
			"r": "36",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 6.44,
			"r": "14",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.89,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.17,
			"r": "114",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 4.99,
			"r": "63",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 6.41,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.26,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.06,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.64,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.59,
			"r": "106",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.66,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 5.63,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.9,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.29,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.93,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 5.02,
			"r": "61",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.21,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.27,
			"r": "112",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.63,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.82,
			"r": "72",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.3,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.54,
			"r": "107",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 2.63,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.18,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 4.86,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.77,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.25,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 6.2,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.12,
			"r": "127",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.09,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 6.4,
			"r": "16",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.75,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.85,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.41,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.94,
			"r": "3",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1,
			"r": "129",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 6.56,
			"r": "11",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.83,
			"r": "29",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.14,
			"r": "59",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 6.46,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.72,
			"r": "73",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.07,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.71,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.71,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.73,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.39,
			"r": "110",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": null,
		"COD": {
			"v": 3.8,
			"r": "99",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 6.65,
			"r": "5",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.66,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.36,
			"r": "50",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.56,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.83,
			"r": "98",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.58,
			"r": "42",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.72,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.82,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.98,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.83,
			"r": "30",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 5.01,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.36,
			"r": "111",
			"m": 64,
			"y": "2016"
		},
		"MLI": {
			"v": 4.35,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 6.55,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.04,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.93,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.06,
			"r": "117",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.86,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.53,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.92,
			"r": "91",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.84,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 6.96,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.89,
			"r": "69",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.03,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.72,
			"r": "74",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.89,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.57,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.53,
			"r": "76",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 5.68,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.68,
			"r": "37",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 6.3,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 7,
			"r": "1",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.85,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.2,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.9,
			"r": "93",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.61,
			"r": "6",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.36,
			"r": "51",
			"m": 105,
			"y": "2016"
		},
		"SGP": null,
		"GRD": null,
		"BEN": {
			"v": 5.46,
			"r": "48",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.88,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.45,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.23,
			"r": "126",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": {
			"v": 6.57,
			"r": "10",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.45,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.77,
			"r": "32",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.95,
			"r": "90",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 5.81,
			"r": "31",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.49,
			"r": "47",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.3,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.6,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.71,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.29,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.37,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.6,
			"r": "8",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.2,
			"r": "56",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.95,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETI_PROPERTYPROTECT": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 6.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 1.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 5.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EGY": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 1.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 5.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 6.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 5.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 4.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 2.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COG": null,
		"LBN": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 6.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 5.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 4.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 5.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 6.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TABCOSTEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 125,
			"r": "33",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1250,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 105.86,
			"r": "31",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 47.22,
			"r": "18",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 144,
			"r": "37",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 560,
			"r": "112",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 184.72,
			"r": "48",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 214.14,
			"r": "52",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 876,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 1095,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 325,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 310,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 321.16,
			"r": "77",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 100,
			"r": "29",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 601.67,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 150,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 102.5,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 150,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 375,
			"r": "86",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 456,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 142.5,
			"r": "36",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 150,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 400,
			"r": "93",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 128.33,
			"r": "34",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 58,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 340,
			"r": "82",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 290,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 150,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 630,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 735,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 785.71,
			"r": "125",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 212.5,
			"r": "51",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 287.86,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 286.88,
			"r": "65",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 755,
			"r": "123",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 158.18,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 565.38,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 242.94,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 710,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 258,
			"r": "58",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 55,
			"r": "21",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 426.43,
			"r": "97",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 222.56,
			"r": "53",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 445,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 575,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 200.56,
			"r": "50",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 958.7,
			"r": "129",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 131.29,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 375,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 183.33,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 378,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 468,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 487.5,
			"r": "105",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 498.5,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 278,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 270,
			"r": "61",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 1633,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 313.33,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 749,
			"r": "121",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 155.77,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 332,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 387.07,
			"r": "92",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 59.17,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 150,
			"r": "38",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 280,
			"r": "62",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 573.5,
			"r": "114",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 316.54,
			"r": "75",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 76.11,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 253.74,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 601.26,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 778,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 366.11,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 65,
			"r": "25",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 281.82,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2222.69,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 428.33,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 309.13,
			"r": "72",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 300,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 319,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 368,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 305,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 55,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 380.56,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 592.89,
			"r": "115",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 300,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 54.67,
			"r": "20",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 241.67,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 222.86,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 134,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 108,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 408.17,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 381.67,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 302.62,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 453,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 410,
			"r": "95",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 815,
			"r": "126",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 264.17,
			"r": "59",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 383.33,
			"r": "91",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 370,
			"r": "85",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 749,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 261,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 413.1,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 469.08,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 47.25,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 490,
			"r": "106",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 765,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 522.44,
			"r": "108",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 175,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 376.38,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 264.86,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 460,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 345,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 75,
			"r": "27",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 335,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 487.44,
			"r": "104",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 545,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 655,
			"r": "119",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 73,
			"r": "26",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 745,
			"r": "120",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 551.86,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 461.67,
			"r": "102",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 106,
			"r": "32",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 432,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 285,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 602,
			"r": "118",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 546.73,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 982.75,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 191.11,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 350,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 1160,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 867.73,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 166.67,
			"r": "45",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 337,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 335.38,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 350,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"ETI_FINANCE": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 4": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 4.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 3.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 2.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 6.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 1.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 2.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 5.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 1.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 2.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 6.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 6.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 6.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 5.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 1.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-EOSQ147": {
		"UNK": null,
		"NOR": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 3.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 2.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 2.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 4.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 1.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 5.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 2.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 3.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 2.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 4.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 2.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 6.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 2.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 2.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 2.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 2.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 1.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 6.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 3.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 3.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 3.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 1.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 3.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TARIFCOMPL": {
		"UNK": null,
		"NOR": {
			"v": 3.12,
			"r": "107",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 6.57,
			"r": "32",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 6.38,
			"r": "46",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 6.69,
			"r": "13",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 6.5,
			"r": "37",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 4.96,
			"r": "84",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 5.02,
			"r": "83",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 6.1,
			"r": "64",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 5.48,
			"r": "74",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 6.66,
			"r": "23",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 6.66,
			"r": "24",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 4.46,
			"r": "97",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.72,
			"r": "102",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 6.68,
			"r": "16",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 6.56,
			"r": "33",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.26,
			"r": "77",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 5.17,
			"r": "79",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 5.54,
			"r": "71",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 6.18,
			"r": "61",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 6.39,
			"r": "45",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 4.9,
			"r": "87",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 6.23,
			"r": "59",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 6.37,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 5.25,
			"r": "78",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 6.99,
			"r": "2",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 6.13,
			"r": "62",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 6.68,
			"r": "21",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 6.35,
			"r": "52",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 6.38,
			"r": "48",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 6.29,
			"r": "56",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 5.12,
			"r": "81",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 5.16,
			"r": "80",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 6.46,
			"r": "38",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.4,
			"r": "76",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.99,
			"r": "108",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 6.37,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 4.23,
			"r": "100",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 3.49,
			"r": "104",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 1.74,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 6.62,
			"r": "26",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 4.86,
			"r": "91",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.45,
			"r": "39",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 6.38,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 2.99,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 6.53,
			"r": "36",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 5.53,
			"r": "72",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.44,
			"r": "40",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 2.99,
			"r": "108",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 6.58,
			"r": "31",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 6.3,
			"r": "55",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 6.82,
			"r": "5",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.63,
			"r": "69",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 6.68,
			"r": "17",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.3,
			"r": "54",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 6.62,
			"r": "27",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 2.99,
			"r": "108",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.47,
			"r": "106",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 4.9,
			"r": "88",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 5.45,
			"r": "75",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 6.27,
			"r": "57",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 6.61,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 5.49,
			"r": "73",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 6.12,
			"r": "63",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 6.74,
			"r": "6",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 4.9,
			"r": "89",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 5.73,
			"r": "68",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 2.99,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 6.59,
			"r": "30",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 2.99,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 6.67,
			"r": "22",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 6.56,
			"r": "34",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 5.57,
			"r": "70",
			"m": 55,
			"y": "2015"
		},
		"MLI": {
			"v": 6.68,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 6.43,
			"r": "42",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 2.99,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 2.99,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 6.53,
			"r": "35",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 2.99,
			"r": "108",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 6.69,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.07,
			"r": "82",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.83,
			"r": "92",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.69,
			"r": "12",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 6.65,
			"r": "25",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 4.43,
			"r": "98",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 6.24,
			"r": "58",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 6.7,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.92,
			"r": "85",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 6.44,
			"r": "41",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 6.01,
			"r": "65",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 6.7,
			"r": "7",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 3.48,
			"r": "105",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 2.99,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 6.4,
			"r": "43",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 3.7,
			"r": "103",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.24,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.11,
			"r": "101",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 5.78,
			"r": "67",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 2.99,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 5.93,
			"r": "66",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 6.94,
			"r": "3",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 6.68,
			"r": "17",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 6.39,
			"r": "44",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 4.51,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 6.18,
			"r": "60",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 2.99,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 4.9,
			"r": "86",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 6.69,
			"r": "11",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 6.69,
			"r": "15",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 4.72,
			"r": "93",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 4.52,
			"r": "95",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 6.7,
			"r": "9",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 6.68,
			"r": "17",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 6.59,
			"r": "29",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 6.92,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 6.37,
			"r": "49",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 6.7,
			"r": "8",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 4.67,
			"r": "94",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 6.3,
			"r": "53",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 4.88,
			"r": "90",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"RAILROADQUALITY": {
		"UNK": null,
		"NOR": {
			"v": 3.62,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 2.73,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1.48,
			"r": "102",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.55,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"BDI": null,
		"BHR": null,
		"ETH": {
			"v": 3.4,
			"r": "48",
			"m": 94,
			"y": "2016"
		},
		"ECU": null,
		"FRA": {
			"v": 5.84,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.52,
			"r": "9",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.15,
			"r": "29",
			"m": 81,
			"y": "2016"
		},
		"JAM": null,
		"SLB": null,
		"URY": {
			"v": 1.23,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": {
			"v": 5.06,
			"r": "15",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.74,
			"r": "66",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.43,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"NIC": null,
		"MKD": {
			"v": 2.74,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.48,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 1.62,
			"r": "98",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1.97,
			"r": "89",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 2.84,
			"r": "61",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 2.91,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"SLV": null,
		"CYM": null,
		"LTU": {
			"v": 4.46,
			"r": "24",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.4,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"BRN": null,
		"CHL": {
			"v": 2.39,
			"r": "80",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.08,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 1.48,
			"r": "103",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.16,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.66,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 1.59,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.76,
			"r": "65",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 2.91,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.48,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.84,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 2.61,
			"r": "73",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.05,
			"r": "54",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.08,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 2.52,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.37,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.57,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.89,
			"r": "93",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 2.53,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.76,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"RWA": null,
		"ATA": null,
		"SVN": {
			"v": 2.97,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.25,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.88,
			"r": "17",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.8,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.74,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.96,
			"r": "36",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.92,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.55,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 2.67,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.59,
			"r": "8",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": {
			"v": 2.13,
			"r": "87",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.78,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.26,
			"r": "26",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.24,
			"r": "51",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.7,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.82,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.7,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.59,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 1.91,
			"r": "92",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.36,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 1.54,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.8,
			"r": "40",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.15,
			"r": "52",
			"m": 105,
			"y": "2016"
		},
		"CYP": null,
		"TCA": null,
		"SVK": {
			"v": 4.58,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 3.98,
			"r": "35",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.34,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.11,
			"r": "30",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.97,
			"r": "57",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.84,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 1.35,
			"r": "105",
			"m": 63,
			"y": "2016"
		},
		"MLI": {
			"v": 2.19,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.11,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.64,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.65,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.32,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": {
			"v": 2.99,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.85,
			"r": "38",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.57,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 1.97,
			"r": "90",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.48,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.81,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.15,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 1.77,
			"r": "96",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.44,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.02,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.07,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.13,
			"r": "13",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.03,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.66,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 1.92,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.36,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.01,
			"r": "34",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.74,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 1.56,
			"r": "100",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 1.4,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 5.06,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.24,
			"r": "50",
			"m": 101,
			"y": "2016"
		},
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": {
			"v": 2.05,
			"r": "88",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.28,
			"r": "83",
			"m": 105,
			"y": "2016"
		},
		"KWT": null,
		"ESH": null,
		"SEN": {
			"v": 2.17,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.36,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.73,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.53,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.81,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.83,
			"r": "18",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3.41,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.39,
			"r": "10",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ360": {
		"UNK": null,
		"NOR": {
			"v": 4.88,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.92,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.05,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.36,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.53,
			"r": "136",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.93,
			"r": "28",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.88,
			"r": "73",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.64,
			"r": "88",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.92,
			"r": "29",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.9,
			"r": "30",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.48,
			"r": "42",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.85,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.94,
			"r": "69",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.94,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.55,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.36,
			"r": "13",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.81,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 4.93,
			"r": "33",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.18,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.9,
			"r": "129",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.39,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.68,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.51,
			"r": "99",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.06,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.06,
			"r": "60",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.55,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 3.96,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.55,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.66,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.3,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.99,
			"r": "67",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.71,
			"r": "32",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.52,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.62,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.6,
			"r": "89",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 1.88,
			"r": "143",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.37,
			"r": "137",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.6,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.86,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.02,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.5,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.42,
			"r": "106",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.79,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.68,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.21,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4,
			"r": "66",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.9,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.66,
			"r": "87",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.69,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.32,
			"r": "110",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 1.55,
			"r": "144",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.71,
			"r": "6",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.65,
			"r": "133",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.21,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.48,
			"r": "101",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.47,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.21,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.05,
			"r": "58",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.25,
			"r": "110",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.06,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.85,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.47,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.19,
			"r": "20",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.95,
			"r": "126",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.21,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.7,
			"r": "33",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.91,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.37,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 5.14,
			"r": "20",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.75,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.4,
			"r": "45",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.57,
			"r": "94",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.75,
			"r": "131",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.34,
			"r": "15",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.29,
			"r": "50",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.06,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.23,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.03,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.23,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.7,
			"r": "83",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.99,
			"r": "139",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.26,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.94,
			"r": "127",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.32,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.8,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.12,
			"r": "58",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.59,
			"r": "90",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.33,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.04,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.6,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.21,
			"r": "138",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.66,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.43,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.1,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.17,
			"r": "120",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.54,
			"r": "98",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.42,
			"r": "105",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.33,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.18,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.73,
			"r": "81",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.58,
			"r": "93",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.01,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.59,
			"r": "91",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.12,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.26,
			"r": "16",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.66,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.41,
			"r": "107",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.33,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.41,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.96,
			"r": "26",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.68,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.73,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.26,
			"r": "109",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.56,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.08,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.26,
			"r": "114",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.75,
			"r": "81",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.26,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.05,
			"r": "22",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.49,
			"r": "41",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.49,
			"r": "9",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.48,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.46,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.43,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.24,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.77,
			"r": "79",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.25,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.19,
			"r": "118",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.27,
			"r": "113",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.35,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.58,
			"r": "92",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.55,
			"r": "8",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.29,
			"r": "51",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.74,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.95,
			"r": "4",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.93,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.87,
			"r": "127",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.05,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.82,
			"r": "76",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.04,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.28,
			"r": "112",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.25,
			"r": "115",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.49,
			"r": "136",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.46,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.16,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.25,
			"r": "17",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.98,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.55,
			"r": "7",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 5.01,
			"r": "23",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIC06": {
		"UNK": null,
		"NOR": {
			"v": 6.37,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.1,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.9,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.52,
			"r": "34",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 1.73,
			"r": "135",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.99,
			"r": "22",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 2.3,
			"r": "130",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.84,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.04,
			"r": "21",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.44,
			"r": "6",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 5.19,
			"r": "48",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.98,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.48,
			"r": "36",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.84,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.87,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.51,
			"r": "35",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.31,
			"r": "77",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.34,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.25,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.77,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.88,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.35,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.33,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.64,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.87,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.52,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.84,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.81,
			"r": "27",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.57,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.23,
			"r": "80",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.29,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.54,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.28,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.42,
			"r": "102",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.32,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.44,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.02,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.6,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.54,
			"r": "122",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.94,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.46,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 1.84,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.96,
			"r": "86",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 5.15,
			"r": "50",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 2.5,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.69,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.76,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 6.17,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.25,
			"r": "45",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.36,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.17,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 2.95,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.45,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.81,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.78,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.28,
			"r": "79",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.82,
			"r": "26",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.31,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.75,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 6.3,
			"r": "11",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.67,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.13,
			"r": "52",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.38,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.73,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.39,
			"r": "103",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 5.14,
			"r": "51",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.69,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.25,
			"r": "46",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.84,
			"r": "94",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.39,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.89,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 6.46,
			"r": "4",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.11,
			"r": "111",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.95,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.52,
			"r": "98",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.26,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 1.82,
			"r": "134",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.7,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.58,
			"r": "66",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.58,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.37,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 1.53,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.63,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.27,
			"r": "44",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.51,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.13,
			"r": "110",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.3,
			"r": "108",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.92,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.28,
			"r": "78",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 2.97,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.97,
			"r": "54",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.61,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.49,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.07,
			"r": "112",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 6.09,
			"r": "18",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.69,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.71,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.39,
			"r": "72",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.93,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.36,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.61,
			"r": "65",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.76,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.49,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 3.43,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.58,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 5.21,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4,
			"r": "83",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 5.46,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 6.33,
			"r": "10",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.66,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.18,
			"r": "15",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.38,
			"r": "74",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.42,
			"r": "7",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.15,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.15,
			"r": "17",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.38,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.47,
			"r": "126",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.77,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.09,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.36,
			"r": "128",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.28,
			"r": "12",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.48,
			"r": "99",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.46,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.09,
			"r": "19",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.08,
			"r": "82",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.81,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.3,
			"r": "42",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.35,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.52,
			"r": "123",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.99,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 2.82,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.07,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.65,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 6.33,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.98,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIC0404": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIC": {
		"UNK": null,
		"NOR": {
			"v": 5.1,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.41,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.05,
			"r": "111",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.91,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.54,
			"r": "130",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.94,
			"r": "34",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 2.98,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "72",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.86,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.8,
			"r": "10",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.25,
			"r": "55",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.59,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.22,
			"r": "59",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.77,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.39,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.17,
			"r": "22",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.51,
			"r": "92",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 2.84,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.09,
			"r": "109",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.92,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.04,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.21,
			"r": "106",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.54,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.79,
			"r": "79",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.72,
			"r": "126",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.29,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.63,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.94,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.84,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.84,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.62,
			"r": "42",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.64,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.48,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.08,
			"r": "110",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.01,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.65,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.78,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.05,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.74,
			"r": "125",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.75,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.56,
			"r": "90",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.62,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4,
			"r": "67",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.13,
			"r": "63",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.34,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.44,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.02,
			"r": "115",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.73,
			"r": "11",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.22,
			"r": "58",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.08,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.84,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.48,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.58,
			"r": "43",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.75,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.77,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.44,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.6,
			"r": "15",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.9,
			"r": "120",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.92,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.5,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.33,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.49,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.49,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.68,
			"r": "13",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.03,
			"r": "114",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.14,
			"r": "62",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.02,
			"r": "5",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.25,
			"r": "54",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.83,
			"r": "77",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.61,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.91,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.54,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.21,
			"r": "105",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.94,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.04,
			"r": "113",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.19,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2.33,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.67,
			"r": "38",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.11,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.24,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.56,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.21,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.03,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.64,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.72,
			"r": "12",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.26,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.35,
			"r": "98",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.41,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.5,
			"r": "93",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 2.98,
			"r": "117",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.64,
			"r": "41",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 5.08,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.14,
			"r": "3",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.1,
			"r": "108",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.5,
			"r": "19",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.17,
			"r": "23",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.15,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.72,
			"r": "85",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.31,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.79,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.84,
			"r": "73",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.01,
			"r": "116",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.44,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.19,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.72,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.03,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.49,
			"r": "94",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.46,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.01,
			"r": "32",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.06,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.93,
			"r": "8",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.48,
			"r": "46",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.07,
			"r": "4",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.67,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.99,
			"r": "7",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.93,
			"r": "69",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.15,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.79,
			"r": "123",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.83,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.04,
			"r": "29",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.66,
			"r": "127",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.59,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.77,
			"r": "81",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.51,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6,
			"r": "6",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.24,
			"r": "103",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.88,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.25,
			"r": "56",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.22,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.62,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.25,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.15,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.36,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.44,
			"r": "21",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.11,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.57,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ095": {
		"UNK": null,
		"NOR": {
			"v": 5.18,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.92,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.66,
			"r": "137",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.3,
			"r": "26",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.2,
			"r": "132",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.49,
			"r": "18",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.68,
			"r": "117",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.05,
			"r": "134",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.85,
			"r": "50",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.16,
			"r": "97",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.39,
			"r": "84",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 5.37,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.65,
			"r": "11",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.35,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.35,
			"r": "24",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.02,
			"r": "41",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.34,
			"r": "88",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.02,
			"r": "23",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 4.45,
			"r": "79",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.79,
			"r": "55",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 5.14,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.04,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.44,
			"r": "80",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.15,
			"r": "99",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.36,
			"r": "86",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.94,
			"r": "108",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 5.18,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.13,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.65,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 5.13,
			"r": "34",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.07,
			"r": "103",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.41,
			"r": "20",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.98,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.31,
			"r": "128",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.6,
			"r": "70",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.61,
			"r": "141",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 5.13,
			"r": "33",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.53,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.02,
			"r": "5",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.7,
			"r": "116",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.15,
			"r": "31",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.62,
			"r": "120",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.17,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.18,
			"r": "133",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 4.71,
			"r": "64",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.63,
			"r": "121",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.78,
			"r": "114",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.86,
			"r": "112",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.95,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.79,
			"r": "56",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.75,
			"r": "115",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.96,
			"r": "135",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.62,
			"r": "12",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.07,
			"r": "104",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.52,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.96,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.75,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.94,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.45,
			"r": "72",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.8,
			"r": "112",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 5.02,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.84,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 5.09,
			"r": "74",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 5.67,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.87,
			"r": "112",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 5.52,
			"r": "16",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 4.56,
			"r": "72",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.91,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.85,
			"r": "49",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 5.05,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.05,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.11,
			"r": "101",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.78,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.79,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.49,
			"r": "125",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.47,
			"r": "126",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.96,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.23,
			"r": "92",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.75,
			"r": "60",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.15,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.3,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.44,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.82,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.41,
			"r": "127",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.63,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.57,
			"r": "123",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.39,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 4.68,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.74,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.2,
			"r": "94",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.74,
			"r": "62",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.52,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.24,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.66,
			"r": "117",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 6.43,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.64,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.05,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.77,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.96,
			"r": "135",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 3.84,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.77,
			"r": "59",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.63,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.15,
			"r": "100",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.4,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.37,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.55,
			"r": "13",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.53,
			"r": "74",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.4,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.61,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.05,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.44,
			"r": "81",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.21,
			"r": "27",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.63,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.36,
			"r": "23",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.11,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.68,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.62,
			"r": "53",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.58,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.31,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.1,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.55,
			"r": "73",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.54,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.67,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.43,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.94,
			"r": "46",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.94,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.08,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.18,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.84,
			"r": "51",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.24,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.11,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.16,
			"r": "96",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.51,
			"r": "76",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.59,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.88,
			"r": "111",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.9,
			"r": "7",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.47,
			"r": "77",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.46,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.54,
			"r": "14",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.44,
			"r": "127",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.47,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.23,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.21,
			"r": "131",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.32,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.41,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.59,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.61,
			"r": "119",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.21,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.98,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.85,
			"r": "48",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.95,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 4.35,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.72,
			"r": "63",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"form_auto": {
		"UNK": null,
		"NOR": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"HRV": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"VEN": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"TON": null,
		"CZE": {
			"v": 1.43,
			"y": "2015",
			"m": 92
		},
		"BDI": {
			"v": 0.5,
			"y": "2015",
			"m": 81
		},
		"BHR": {
			"v": 1.75,
			"y": "2015",
			"m": 86
		},
		"ETH": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"ECU": {
			"v": 1.25,
			"y": "2015",
			"m": 94
		},
		"FRA": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"SJM": null,
		"KOR": {
			"v": 1.57,
			"y": "2015",
			"m": 97
		},
		"AZE": {
			"v": 1.25,
			"y": "2015",
			"m": 81
		},
		"JAM": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"SLB": null,
		"URY": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"MLT": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"BVT": null,
		"GTM": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"MYS": {
			"v": 1.25,
			"y": "2015",
			"m": 101
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1.67,
			"y": "2015",
			"m": 78
		},
		"PRI": null,
		"MOZ": {
			"v": 0.67,
			"y": "2015",
			"m": 100
		},
		"NIC": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"MKD": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ISR": {
			"v": 1.71,
			"y": "2015",
			"m": 96
		},
		"KHM": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"COK": null,
		"KEN": {
			"v": 1.25,
			"y": "2015",
			"m": 97
		},
		"COM": null,
		"LSO": {
			"v": 0.33,
			"y": "2015",
			"m": 100
		},
		"MEX": {
			"v": 1.83,
			"y": "2015",
			"m": 100
		},
		"SLV": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"CYM": null,
		"LTU": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"ROU": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"BRN": {
			"v": 1,
			"y": "2015",
			"m": 91
		},
		"CHL": {
			"v": 1.71,
			"y": "2015",
			"m": 91
		},
		"LVA": {
			"v": 1.75,
			"y": "2015",
			"m": 100
		},
		"YEM": {
			"v": 0.33,
			"y": "2015",
			"m": 105
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.75,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 0.75,
			"y": "2015",
			"m": 102
		},
		"PRT": {
			"v": 1.86,
			"y": "2015",
			"m": 103
		},
		"SGS": null,
		"FIN": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"NPL": {
			"v": 0,
			"y": "2015",
			"m": 103
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"LBR": {
			"v": 0.33,
			"y": "2015",
			"m": 99
		},
		"MNE": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IRN": null,
		"SPM": null,
		"MWI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 0.75,
			"y": "2015",
			"m": 94
		},
		"BGR": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"CUB": null,
		"PAK": {
			"v": 0.75,
			"y": "2015",
			"m": 103
		},
		"IMN": null,
		"THA": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"KGZ": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"LBY": null,
		"CHE": {
			"v": 2,
			"y": "2015",
			"m": 91
		},
		"MAC": null,
		"BRA": {
			"v": 1.5,
			"y": "2015",
			"m": 88
		},
		"JOR": {
			"v": 1.25,
			"y": "2015",
			"m": 96
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1.8,
			"y": "2015",
			"m": 92
		},
		"RWA": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"ATA": null,
		"SVN": {
			"v": 2,
			"y": "2015",
			"m": 104
		},
		"GUY": null,
		"SUR": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 1.25,
			"y": "2015",
			"m": 92
		},
		"CUW": null,
		"TTO": {
			"v": 0.67,
			"y": "2015",
			"m": 104
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 0,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 0.5,
			"y": "2015",
			"m": 103
		},
		"SYR": null,
		"BEL": {
			"v": 1.86,
			"y": "2015",
			"m": 82
		},
		"GAB": {
			"v": 0.5,
			"y": "2015",
			"m": 94
		},
		"TJK": {
			"v": 1.25,
			"y": "2015",
			"m": 104
		},
		"AUS": {
			"v": 1.71,
			"y": "2015",
			"m": 80
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 2,
			"y": "2015",
			"m": 100
		},
		"PNG": null,
		"HUN": {
			"v": 1.43,
			"y": "2015",
			"m": 96
		},
		"SYC": null,
		"CIV": {
			"v": 0.25,
			"y": "2015",
			"m": 92
		},
		"ABW": null,
		"ESP": {
			"v": 1.57,
			"y": "2015",
			"m": 94
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0,
			"y": "2015",
			"m": 91
		},
		"ARG": {
			"v": 2,
			"y": "2015",
			"m": 76
		},
		"GBR": {
			"v": 1.43,
			"y": "2015",
			"m": 95
		},
		"SXM": null,
		"KAZ": {
			"v": 0.75,
			"y": "2015",
			"m": 97
		},
		"BWA": {
			"v": 1.33,
			"y": "2015",
			"m": 91
		},
		"MDA": {
			"v": 1.33,
			"y": "2015",
			"m": 100
		},
		"CXR": null,
		"IDN": {
			"v": 1.5,
			"y": "2015",
			"m": 96
		},
		"DNK": {
			"v": 1.29,
			"y": "2015",
			"m": 92
		},
		"HND": {
			"v": 1,
			"y": "2015",
			"m": 96
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 1.25,
			"y": "2015",
			"m": 100
		},
		"BOL": {
			"v": 1.25,
			"y": "2015",
			"m": 88
		},
		"NFK": null,
		"HKG": {
			"v": 1.8,
			"y": "2015",
			"m": 96
		},
		"COD": {
			"v": 0,
			"y": "2015",
			"m": 92
		},
		"ZAF": {
			"v": 1.75,
			"y": "2015",
			"m": 105
		},
		"VNM": {
			"v": 1.25,
			"y": "2015",
			"m": 105
		},
		"CYP": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"TCA": null,
		"SVK": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"HTI": null,
		"IRL": {
			"v": 2,
			"y": "2015",
			"m": 96
		},
		"IRQ": null,
		"POL": {
			"v": 1.86,
			"y": "2015",
			"m": 103
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1.71,
			"y": "2015",
			"m": 104
		},
		"PLW": null,
		"GMB": {
			"v": 0.75,
			"y": "2015",
			"m": 96
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.5,
			"y": "2015",
			"m": 93
		},
		"GRC": {
			"v": 1.43,
			"y": "2015",
			"m": 96
		},
		"FSM": null,
		"ALB": {
			"v": 1.5,
			"y": "2015",
			"m": 58
		},
		"MLI": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"OMN": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 0.33,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 1.14,
			"y": "2015",
			"m": 96
		},
		"NLD": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"BGD": {
			"v": 1.25,
			"y": "2015",
			"m": 86
		},
		"AUT": {
			"v": 1.71,
			"y": "2015",
			"m": 80
		},
		"QAT": {
			"v": 1.25,
			"y": "2015",
			"m": 103
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 1.5,
			"y": "2015",
			"m": 99
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.5,
			"y": "2015",
			"m": 103
		},
		"LCA": null,
		"SAU": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GRL": null,
		"GEO": {
			"v": 1.75,
			"y": "2015",
			"m": 95
		},
		"MYT": null,
		"ZMB": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 1,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 1.75,
			"y": "2015",
			"m": 96
		},
		"TUN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"SRB": {
			"v": 1.5,
			"y": "2015",
			"m": 104
		},
		"GHA": {
			"v": 1,
			"y": "2015",
			"m": 95
		},
		"RUS": {
			"v": 1,
			"y": "2015",
			"m": 103
		},
		"EST": {
			"v": 1.71,
			"y": "2015",
			"m": 94
		},
		"SMR": null,
		"CHN": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"NIU": null,
		"USA": {
			"v": 1.71,
			"y": "2015",
			"m": 105
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.83,
			"y": "2015",
			"m": 104
		},
		"JPN": {
			"v": 1.14,
			"y": "2015",
			"m": 96
		},
		"PER": {
			"v": 2,
			"y": "2015",
			"m": 103
		},
		"VIR": null,
		"DEU": {
			"v": 1.71,
			"y": "2015",
			"m": 92
		},
		"STP": null,
		"UKR": {
			"v": 0.75,
			"y": "2015",
			"m": 105
		},
		"SGP": {
			"v": 1.8,
			"y": "2015",
			"m": 104
		},
		"GRD": null,
		"BEN": {
			"v": 0.75,
			"y": "2015",
			"m": 83
		},
		"COL": {
			"v": 1.4,
			"y": "2015",
			"m": 92
		},
		"MCO": null,
		"ISL": null,
		"LAO": {
			"v": 0.25,
			"y": "2015",
			"m": 98
		},
		"FLK": null,
		"LUX": {
			"v": 1.29,
			"y": "2015",
			"m": 100
		},
		"ERI": null,
		"NAM": {
			"v": 0.75,
			"y": "2015",
			"m": 101
		},
		"SLE": {
			"v": 0,
			"y": "2015",
			"m": 104
		},
		"ARE": {
			"v": 1.75,
			"y": "2015",
			"m": 75
		},
		"GNB": null,
		"BIH": {
			"v": 0.75,
			"y": "2015",
			"m": 86
		},
		"MMR": {
			"v": 0.25,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 1.5,
			"y": "2015",
			"m": 105
		},
		"KWT": {
			"v": 0.25,
			"y": "2015",
			"m": 98
		},
		"ESH": null,
		"SEN": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"CMR": {
			"v": 1.75,
			"y": "2015",
			"m": 92
		},
		"MNG": {
			"v": 1.5,
			"y": "2015",
			"m": 100
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"y": "2015",
			"m": 104
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1,
			"y": "2015",
			"m": 100
		},
		"BLM": null,
		"CAN": {
			"v": 1.29,
			"y": "2015",
			"m": 91
		},
		"NZL": {
			"v": 1.71,
			"y": "2015",
			"m": 103
		},
		"TWN": {
			"v": 1.75,
			"y": "2015",
			"m": 104
		},
		"BRB": {
			"v": 0.33,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TFA Article 9": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIC05": {
		"UNK": null,
		"NOR": {
			"v": 5.24,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.48,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.83,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.1,
			"r": "25",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.46,
			"r": "105",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.78,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.41,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.91,
			"r": "75",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.39,
			"r": "17",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.25,
			"r": "21",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.58,
			"r": "97",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.42,
			"r": "108",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.09,
			"r": "63",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.61,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.6,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.98,
			"r": "29",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.35,
			"r": "112",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.54,
			"r": "101",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.28,
			"r": "117",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 3.68,
			"r": "89",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.08,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.71,
			"r": "87",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.73,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.39,
			"r": "52",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.06,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.17,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.91,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.06,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.96,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.9,
			"r": "77",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.67,
			"r": "39",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.67,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.04,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.27,
			"r": "118",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.96,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.61,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.25,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.97,
			"r": "70",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.01,
			"r": "128",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.57,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.71,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.63,
			"r": "91",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.3,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.11,
			"r": "62",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.02,
			"r": "64",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.46,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.13,
			"r": "123",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.68,
			"r": "10",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.2,
			"r": "58",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.29,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.77,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.22,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.67,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.6,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.52,
			"r": "102",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.52,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.73,
			"r": "7",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.9,
			"r": "130",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.02,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.33,
			"r": "19",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.99,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.71,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.43,
			"r": "106",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.21,
			"r": "23",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.5,
			"r": "103",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.86,
			"r": "80",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.64,
			"r": "11",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.98,
			"r": "68",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.15,
			"r": "61",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.7,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.24,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.28,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.41,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.95,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.12,
			"r": "124",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.91,
			"r": "2",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.15,
			"r": "122",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.79,
			"r": "35",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.15,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.31,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.65,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.68,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.35,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.76,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.84,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.42,
			"r": "107",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.74,
			"r": "84",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.44,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.59,
			"r": "95",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.34,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.44,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.83,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.88,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.55,
			"r": "100",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.71,
			"r": "8",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.18,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.99,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.58,
			"r": "96",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.33,
			"r": "114",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.49,
			"r": "47",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.57,
			"r": "98",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.49,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.62,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.6,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.64,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.97,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.62,
			"r": "92",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.77,
			"r": "82",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.86,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.94,
			"r": "32",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.55,
			"r": "14",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.53,
			"r": "45",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.68,
			"r": "9",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.9,
			"r": "78",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.78,
			"r": "6",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.98,
			"r": "69",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.9,
			"r": "3",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.22,
			"r": "120",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.75,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.09,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.19,
			"r": "121",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.92,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 3.95,
			"r": "73",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 2.51,
			"r": "136",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.57,
			"r": "13",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.28,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 2.76,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4,
			"r": "65",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.32,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.92,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.38,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.88,
			"r": "79",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.87,
			"r": "131",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.39,
			"r": "16",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.96,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.5,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"CUSTTRANSPIND": {
		"UNK": null,
		"NOR": {
			"v": 0.9,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0.93,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 0.7,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.1,
			"r": "115",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.43,
			"r": "109",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0.9,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 1,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 0.9,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 1,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 0.9,
			"r": "40",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 0.7,
			"r": "86",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 0.73,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 0.8,
			"r": "66",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 0.9,
			"r": "40",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": null,
		"NIC": {
			"v": 0.93,
			"r": "36",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 0.5,
			"r": "105",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 0.83,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 0.07,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0.5,
			"r": "105",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 0.9,
			"r": "40",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": null,
		"MEX": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 0.5,
			"r": "105",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 0.9,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0.8,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 0.2,
			"r": "112",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 1,
			"r": "1",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0.9,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 0.57,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 1,
			"r": "1",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 0.6,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0.93,
			"r": "36",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 0.73,
			"r": "81",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.73,
			"r": "81",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 0.7,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 0.9,
			"r": "40",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0.4,
			"y": "2009",
			"m": 96
		},
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 0.8,
			"y": "2009",
			"m": 87
		},
		"EGY": {
			"v": 0.12,
			"r": "114",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 0.79,
			"r": "78",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 0.8,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 0.88,
			"r": "61",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 1,
			"r": "1",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 1,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 1,
			"r": "1",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 0.73,
			"r": "81",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": {
			"v": 0,
			"y": "2009",
			"m": 104
		},
		"DOM": {
			"v": 0.8,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 0.8,
			"r": "66",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 0.6,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 1,
			"r": "1",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0.7,
			"r": "86",
			"m": 94,
			"y": "2015"
		},
		"TJK": null,
		"AUS": {
			"v": 1,
			"r": "1",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 0.7,
			"r": "86",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 0.9,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0.8,
			"r": "66",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0.9,
			"r": "40",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 1,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0.77,
			"r": "79",
			"m": 97,
			"y": "2015"
		},
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": {
			"v": 0.53,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 0.6,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 0.7,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 0.8,
			"r": "66",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 0.7,
			"r": "86",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 1,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 0.6,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 0.73,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0.9,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": {
			"v": 0.88,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 1,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 0.6,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0.4,
			"y": "2009",
			"m": 92
		},
		"GRC": {
			"v": 0.6,
			"r": "96",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 0.83,
			"r": "63",
			"m": 52,
			"y": "2015"
		},
		"MLI": null,
		"OMN": {
			"v": 0.92,
			"r": "39",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 0.4,
			"y": "2009",
			"m": 86
		},
		"ITA": {
			"v": 0.9,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 1,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 0.38,
			"r": "111",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 1,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 0.8,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 0.83,
			"r": "63",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 0.9,
			"r": "40",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0.2,
			"r": "112",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.6,
			"r": "96",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 0.7,
			"r": "86",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": {
			"v": 0.2,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 0.8,
			"r": "66",
			"m": 96,
			"y": "2016"
		},
		"TUN": null,
		"SRB": {
			"v": 0.67,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0.9,
			"r": "40",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 0.6,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 1,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 0.9,
			"r": "40",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 1,
			"r": "1",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 0.9,
			"r": "40",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 0.9,
			"r": "40",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 0.4,
			"r": "110",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 1,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 0.9,
			"r": "40",
			"m": 96,
			"y": "2015"
		},
		"LAO": null,
		"FLK": null,
		"LUX": {
			"v": 1,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": null,
		"SLE": {
			"v": 0.7,
			"r": "86",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 0.8,
			"r": "66",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 0.8,
			"r": "66",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": {
			"v": 0.8,
			"r": "66",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": null,
		"CMR": {
			"v": 0.5,
			"r": "105",
			"m": 92,
			"y": "2015"
		},
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0.77,
			"r": "79",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 0.9,
			"r": "40",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 0.9,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 1,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 0.8,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"INTLAIRSEATKM": {
		"UNK": null,
		"NOR": {
			"v": 404.48,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 108.12,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 117.6,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 235.9,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 1.42,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 177.35,
			"r": "70",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 388.81,
			"r": "52",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 147.77,
			"r": "74",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 3648.21,
			"r": "8",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 2433.18,
			"r": "14",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 100.39,
			"r": "82",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 157.27,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 66.38,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 93.73,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 45.01,
			"r": "101",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 1483.4,
			"r": "20",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 45.36,
			"r": "100",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 27.1,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 24.92,
			"r": "115",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 22.1,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 569.88,
			"r": "39",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 103.69,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 979.16,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 248.93,
			"r": "60",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 0.28,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 1355.33,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 104.57,
			"r": "80",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 64.12,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 257.72,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 49.97,
			"r": "98",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 463.24,
			"r": "43",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 76.9,
			"r": "88",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 0.6,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 254.61,
			"r": "59",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 857.8,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 452.2,
			"r": "44",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 97.49,
			"r": "83",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 45.4,
			"r": "99",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 10.06,
			"r": "129",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 20.86,
			"r": "120",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 212.46,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 8.14,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 574.06,
			"r": "38",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 125.05,
			"r": "76",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 446.47,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 2632.56,
			"r": "11",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 64.78,
			"r": "90",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 1067.86,
			"r": "27",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1472.99,
			"r": "21",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 198.88,
			"r": "66",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 162.56,
			"r": "71",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 24.22,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 16.21,
			"r": "124",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 427.85,
			"r": "49",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 57.1,
			"r": "94",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 439.8,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 670.89,
			"r": "33",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 32.49,
			"r": "106",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 62.12,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3081.73,
			"r": "9",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 465.89,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 188.1,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 64.6,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 3779.58,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.04,
			"r": "133",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 610.27,
			"r": "35",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 7148.08,
			"r": "2",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 161.32,
			"r": "72",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 7,
			"r": "132",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 29.28,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 1090.59,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 587.06,
			"r": "37",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 24.3,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 351.98,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 52.93,
			"r": "97",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 2767.97,
			"r": "10",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 30.71,
			"r": "108",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 884.66,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 651.23,
			"r": "34",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 212.21,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 36.4,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 10.17,
			"r": "128",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 588.48,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 428.99,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 541.65,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 13.16,
			"r": "126",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 202.33,
			"r": "65",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 715,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 19.36,
			"r": "122",
			"m": 61,
			"y": "2016"
		},
		"MLI": {
			"v": 32.33,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 299.29,
			"r": "55",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 2188.71,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 1977.01,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 282.98,
			"r": "56",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 511.95,
			"r": "41",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 1682.39,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 197.13,
			"r": "67",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 180.36,
			"r": "69",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 29.11,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 1400.5,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 55.34,
			"r": "95",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 37.45,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 11.17,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2185.92,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 137.88,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 87.4,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 116.94,
			"r": "78",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 1390.86,
			"r": "24",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 27.99,
			"r": "112",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5192.51,
			"r": "4",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 13928.58,
			"r": "1",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 2257.55,
			"r": "15",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3857.79,
			"r": "6",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 425.58,
			"r": "50",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5052.86,
			"r": "5",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 262.5,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 2479.77,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 14.97,
			"r": "125",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 434.39,
			"r": "47",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 218.44,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 24.92,
			"r": "116",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 39.25,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 40.2,
			"r": "102",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 7.69,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5966.15,
			"r": "3",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 19.16,
			"r": "123",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 20.55,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 300.99,
			"r": "54",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 84.69,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 54.36,
			"r": "96",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 26.59,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 90.9,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 29.06,
			"r": "111",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2566.75,
			"r": "12",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 756.62,
			"r": "31",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 1423.14,
			"r": "22",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ138": {
		"UNK": null,
		"NOR": {
			"v": 4.26,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.09,
			"r": "128",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.69,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.07,
			"r": "69",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.43,
			"r": "115",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.95,
			"r": "10",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.69,
			"r": "103",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 3.78,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.24,
			"r": "120",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.36,
			"r": "37",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.44,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.68,
			"r": "20",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.56,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.47,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.58,
			"r": "24",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5,
			"r": "8",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 3.71,
			"r": "104",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.33,
			"r": "119",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.92,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.39,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.4,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.25,
			"r": "49",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.75,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.02,
			"r": "73",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.58,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.35,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.09,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 3.42,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.68,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.12,
			"r": "126",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.79,
			"r": "15",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.04,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 4.22,
			"r": "51",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.75,
			"r": "18",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.45,
			"r": "143",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 4.49,
			"r": "27",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.97,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 3.91,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.16,
			"r": "124",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.79,
			"r": "16",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.77,
			"r": "88",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.71,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.22,
			"r": "122",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.72,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.31,
			"r": "126",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.5,
			"r": "112",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.18,
			"r": "54",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.94,
			"r": "76",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.24,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.07,
			"r": "70",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 3.5,
			"r": "116",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 4.14,
			"r": "61",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.18,
			"r": "123",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 3.71,
			"r": "97",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.9,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.12,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.7,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.47,
			"r": "30",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.71,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.66,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.74,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 4.87,
			"r": "58",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.01,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 2.34,
			"r": "142",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.08,
			"r": "67",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.83,
			"r": "135",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.42,
			"r": "35",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 3.03,
			"r": "130",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.62,
			"r": "105",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.01,
			"r": "7",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 3.7,
			"r": "102",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.43,
			"r": "34",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.33,
			"r": "43",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.9,
			"r": "133",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 4.77,
			"r": "17",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 4.07,
			"r": "68",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.34,
			"r": "42",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.23,
			"r": "121",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.69,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.14,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.14,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.61,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 4.16,
			"r": "64",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 3.11,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.82,
			"r": "84",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 4.26,
			"r": "47",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.89,
			"r": "81",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 2.55,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.98,
			"r": "75",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.15,
			"r": "58",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.08,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.51,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 4.76,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.93,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.58,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.18,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.1,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.08,
			"r": "129",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.08,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.65,
			"r": "1",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 4.2,
			"r": "52",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 2.99,
			"r": "131",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.44,
			"r": "119",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.16,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.48,
			"r": "28",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.59,
			"r": "108",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 3.92,
			"r": "77",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.95,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 3.89,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.76,
			"r": "90",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5.16,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.62,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.07,
			"r": "6",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.94,
			"r": "12",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.71,
			"r": "96",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.7,
			"r": "15",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.16,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.43,
			"r": "137",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.76,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.5,
			"r": "26",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.78,
			"r": "86",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 3.59,
			"r": "107",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.35,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.19,
			"r": "53",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.82,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 3.45,
			"r": "114",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.36,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.09,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.9,
			"r": "79",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 3.71,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.47,
			"r": "29",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.33,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.47,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.34,
			"r": "41",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.51,
			"r": "2",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 2.95,
			"r": "132",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 4.43,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.42,
			"r": "3",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.37,
			"r": "118",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.95,
			"r": "80",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.29,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.66,
			"r": "104",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.7,
			"r": "19",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.25,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.87,
			"r": "134",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.55,
			"r": "111",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.74,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.03,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 3.73,
			"r": "94",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.26,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 3.48,
			"r": "113",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.14,
			"r": "125",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-CUSTTRANSPIND": {
		"UNK": null,
		"NOR": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 1.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 3.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 1.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 1.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 2.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COG": null,
		"LBN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 1.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 4.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ057": {
		"UNK": null,
		"NOR": {
			"v": 4.07,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 5.51,
			"r": "18",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.84,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.1,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.87,
			"r": "117",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.14,
			"r": "25",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.67,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 5.15,
			"r": "24",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 6.05,
			"r": "6",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.59,
			"r": "14",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.44,
			"r": "50",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 3.81,
			"r": "79",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.21,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 3.19,
			"r": "100",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.38,
			"r": "92",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.46,
			"r": "20",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.78,
			"r": "81",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.19,
			"r": "29",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 2.43,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.57,
			"r": "84",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.73,
			"r": "82",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.94,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.38,
			"r": "93",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.07,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.19,
			"r": "61",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.2,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.33,
			"r": "58",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.94,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.87,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 2.6,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.7,
			"r": "41",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.01,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 3.24,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.52,
			"r": "129",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.08,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.26,
			"r": "138",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.62,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.91,
			"r": "9",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.67,
			"r": "12",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 2.85,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.48,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.12,
			"r": "104",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.17,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 4.07,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.95,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.04,
			"r": "103",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 3.04,
			"r": "107",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.37,
			"r": "94",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.83,
			"r": "77",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.21,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 2.49,
			"r": "131",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.11,
			"r": "142",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.02,
			"r": "7",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.96,
			"r": "111",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.33,
			"r": "57",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.72,
			"r": "125",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.99,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.42,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.19,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.95,
			"r": "70",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.36,
			"r": "54",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.1,
			"r": "63",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 3.92,
			"r": "54",
			"m": 105,
			"y": "2007"
		},
		"PAN": {
			"v": 4.51,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.95,
			"r": "68",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 4.88,
			"r": "35",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.8,
			"r": "121",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.05,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.76,
			"r": "40",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.36,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.06,
			"r": "69",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.2,
			"r": "59",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.7,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.52,
			"r": "17",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.81,
			"r": "80",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.15,
			"r": "103",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.13,
			"r": "27",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.02,
			"r": "108",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.13,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.46,
			"r": "132",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.86,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.71,
			"r": "10",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.84,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 1.94,
			"r": "140",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.69,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.11,
			"r": "105",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.16,
			"r": "3",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.14,
			"r": "137",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.03,
			"r": "29",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.47,
			"r": "89",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.93,
			"r": "34",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.1,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.62,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.34,
			"r": "135",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.96,
			"r": "32",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 3.97,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.29,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.92,
			"r": "74",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.24,
			"r": "96",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.3,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.35,
			"r": "56",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.23,
			"r": "97",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 5.51,
			"r": "19",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4.41,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.55,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.14,
			"r": "4",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 2.92,
			"r": "113",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.99,
			"r": "8",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.14,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.67,
			"r": "44",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 2.77,
			"r": "124",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.24,
			"r": "136",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.87,
			"r": "37",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.83,
			"r": "78",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.55,
			"r": "85",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.28,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 2.46,
			"r": "132",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.43,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.5,
			"r": "87",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.91,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.53,
			"r": "86",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 2.77,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.67,
			"r": "45",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.77,
			"r": "39",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.61,
			"r": "13",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 5.04,
			"r": "28",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 6.12,
			"r": "5",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.01,
			"r": "110",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.55,
			"r": "16",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.41,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.28,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.91,
			"r": "114",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 2.8,
			"r": "120",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.77,
			"r": "38",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.42,
			"r": "91",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.57,
			"r": "15",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.15,
			"r": "23",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 2.79,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.5,
			"r": "1",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.88,
			"r": "116",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.33,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.19,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.4,
			"r": "53",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.03,
			"r": "71",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.5,
			"r": "130",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.01,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 1.92,
			"r": "144",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.44,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.03,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.25,
			"r": "22",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 4.53,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.7,
			"r": "11",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.45,
			"r": "49",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETID07": {
		"UNK": null,
		"NOR": {
			"v": 5.63,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.89,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.76,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.22,
			"r": "132",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.15,
			"r": "23",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "97",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.86,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.99,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.57,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.63,
			"r": "44",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.75,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.9,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.04,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.1,
			"r": "26",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.55,
			"r": "50",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.53,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.07,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.61,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.63,
			"r": "43",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.99,
			"r": "94",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.87,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.97,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.92,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.06,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.63,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.67,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.38,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.29,
			"r": "69",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.98,
			"r": "29",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.56,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.83,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.52,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.87,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.8,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.84,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.07,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.06,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.23,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.77,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.77,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.74,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.24,
			"r": "71",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "130",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.08,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.89,
			"r": "102",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.77,
			"r": "5",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.62,
			"r": "123",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.76,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.31,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.29,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.47,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.99,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.74,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.74,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.34,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.82,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.54,
			"r": "51",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.24,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.59,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.46,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.09,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.66,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.4,
			"r": "57",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.77,
			"r": "115",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.3,
			"r": "16",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.49,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.33,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.88,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.32,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.24,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.9,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.33,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.73,
			"r": "120",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.86,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.51,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.35,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.23,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.41,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.56,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.01,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.31,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.5,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.65,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.32,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.82,
			"r": "111",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.01,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.38,
			"r": "59",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.62,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.95,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.14,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.39,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.5,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.39,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.43,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.83,
			"r": "108",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.23,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.67,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.84,
			"r": "33",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.38,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.19,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.23,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.99,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.04,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.24,
			"r": "70",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.79,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.28,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.65,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.22,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.23,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.31,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.17,
			"r": "80",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.27,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.53,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.81,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.9,
			"r": "101",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.49,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.14,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.2,
			"r": "79",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.8,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.29,
			"r": "67",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.76,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.58,
			"r": "9",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.84,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.41,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.29,
			"r": "68",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.21,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.83,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.93,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.81,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.14,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.59,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.03,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TABCOSTEXPDOC": {
		"UNK": null,
		"NOR": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 375,
			"r": "133",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 150,
			"r": "96",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 211.11,
			"r": "113",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 175,
			"r": "103",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 140,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 11.1,
			"r": "20",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 300,
			"r": "125",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 90,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 231,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 25,
			"r": "23",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 105,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 45,
			"r": "36",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 150,
			"r": "96",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 220,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 46.67,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 45,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 72.5,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 100,
			"r": "78",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 52.5,
			"r": "46",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 190.5,
			"r": "108",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 90,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 60,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 50,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 28,
			"r": "26",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 90,
			"r": "68",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 35,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 125,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 240,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 250,
			"r": "120",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 70,
			"r": "57",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 85,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 101.88,
			"r": "81",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 627.5,
			"r": "134",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 66.67,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 143.33,
			"r": "94",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 341.76,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 28,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 100,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 51.67,
			"r": "45",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 307.14,
			"r": "127",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 96.86,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 145,
			"r": "95",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 50,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 75,
			"r": "59",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 226.39,
			"r": "116",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 16.4,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 80,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 110,
			"r": "86",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 78,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 40,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 15,
			"r": "21",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 250,
			"r": "120",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 292,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 60,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 200,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 330,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 264,
			"r": "122",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 106.92,
			"r": "84",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 115,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 136.11,
			"r": "90",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 50,
			"r": "40",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 60,
			"r": "49",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 25,
			"r": "23",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 320,
			"r": "128",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 179.23,
			"r": "105",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 43.89,
			"r": "35",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 138.8,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 80,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 128,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 57.58,
			"r": "48",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 25,
			"r": "23",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 56.8,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 2500,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 170,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 139.23,
			"r": "92",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 50,
			"r": "40",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 187.5,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 48,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 75,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 40,
			"r": "33",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 182.78,
			"r": "106",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 374.44,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 30,
			"r": "27",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 10,
			"r": "19",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 33.33,
			"r": "28",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 107.14,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 76,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 140,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 225,
			"r": "115",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 150,
			"r": "96",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 128.12,
			"r": "89",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 344,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 100,
			"r": "78",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 120,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 105,
			"r": "82",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 35,
			"r": "29",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 200,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 92,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 86,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 91.88,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 200,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 35,
			"r": "29",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 155,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 92,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 84.57,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 60,
			"r": "49",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 87,
			"r": "67",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 60.41,
			"r": "53",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 50,
			"r": "40",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 45,
			"r": "36",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 292,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 37,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 80,
			"r": "61",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 90,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 40,
			"r": "33",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 235,
			"r": "119",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 347.5,
			"r": "131",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 227.14,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 177.78,
			"r": "104",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 91.5,
			"r": "72",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 140,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 170,
			"r": "101",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 191,
			"r": "109",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 96,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 305.5,
			"r": "126",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 63.89,
			"r": "54",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 100,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 275,
			"r": "123",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 116.82,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 155.56,
			"r": "100",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 67,
			"r": "56",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 84,
			"r": "64",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 109,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TIMESHIP": {
		"UNK": null,
		"NOR": {
			"v": 3.77,
			"r": "39",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.39,
			"r": "67",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.71,
			"r": "115",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.94,
			"r": "28",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 3.45,
			"r": "63",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.58,
			"r": "51",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.37,
			"r": "128",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 3.23,
			"r": "75",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 4.25,
			"r": "13",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 4.03,
			"r": "23",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.57,
			"r": "125",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.64,
			"r": "122",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 3.47,
			"r": "59",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.61,
			"r": "50",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.98,
			"r": "96",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.65,
			"r": "47",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.6,
			"r": "124",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.04,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.68,
			"r": "121",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.13,
			"r": "86",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 4.27,
			"r": "10",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 3.3,
			"r": "73",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.35,
			"r": "70",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.7,
			"r": "46",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 2.35,
			"r": "129",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3.38,
			"r": "68",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 3.29,
			"r": "74",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 4.14,
			"r": "17",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3.22,
			"r": "79",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3.19,
			"r": "82",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.71,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.62,
			"r": "49",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.78,
			"r": "111",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.59,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 3.04,
			"r": "92",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.95,
			"r": "27",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 4.14,
			"r": "16",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.93,
			"r": "100",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.7,
			"r": "45",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.73,
			"r": "113",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.69,
			"r": "119",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.81,
			"r": "107",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.99,
			"r": "95",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.63,
			"r": "48",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 3.31,
			"r": "72",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "58",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.56,
			"r": "52",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 2.72,
			"r": "114",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 2.83,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 4.24,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 3.39,
			"r": "66",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 3.34,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.98,
			"r": "97",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 3.35,
			"r": "69",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.47,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 3.12,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 3.06,
			"r": "90",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.79,
			"r": "110",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.83,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.74,
			"r": "41",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.43,
			"r": "4",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.52,
			"r": "126",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.04,
			"r": "136",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 4.04,
			"r": "21",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.2,
			"r": "81",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.88,
			"r": "33",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.71,
			"r": "116",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 4,
			"r": "26",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.7,
			"r": "117",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 3.47,
			"r": "61",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 4.33,
			"r": "8",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.06,
			"r": "89",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.72,
			"r": "43",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 3.16,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 3.46,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.92,
			"r": "30",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.91,
			"r": "103",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.38,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 3.12,
			"r": "87",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 2.79,
			"r": "109",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.29,
			"r": "9",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.94,
			"r": "98",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 4.02,
			"r": "24",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 3.5,
			"r": "56",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 3.79,
			"r": "38",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.81,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.25,
			"r": "132",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 2.02,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.94,
			"r": "29",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.8,
			"r": "37",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.45,
			"r": "3",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.46,
			"r": "127",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.08,
			"r": "88",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 3.85,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 3.05,
			"r": "91",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 2.93,
			"r": "101",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.5,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 3.04,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 4.03,
			"r": "22",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 4.41,
			"r": "5",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.9,
			"r": "104",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 4.37,
			"r": "7",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.83,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.88,
			"r": "105",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.61,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.86,
			"r": "106",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.93,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3.53,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.8,
			"r": "108",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.74,
			"r": "112",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 2.14,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 3.13,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.74,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 3,
			"r": "94",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 3.23,
			"r": "77",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 3.21,
			"r": "80",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 3.15,
			"r": "85",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 4.08,
			"r": "20",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.9,
			"r": "31",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 4.25,
			"r": "11",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.75,
			"r": "40",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 4.21,
			"r": "15",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 3.23,
			"r": "78",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 4.45,
			"r": "2",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 3.51,
			"r": "54",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 4.4,
			"r": "6",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.69,
			"r": "118",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 3.23,
			"r": "76",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.88,
			"r": "32",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.68,
			"r": "120",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.8,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 3.19,
			"r": "83",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.23,
			"r": "133",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 4.13,
			"r": "18",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.94,
			"r": "99",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.85,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2.13,
			"r": "135",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.51,
			"r": "55",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.61,
			"r": "123",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 2.29,
			"r": "131",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 3.4,
			"r": "65",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 3.44,
			"r": "64",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.35,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 4.01,
			"r": "25",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 4.12,
			"r": "19",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 4.25,
			"r": "12",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ365": {
		"UNK": null,
		"NOR": {
			"v": 6.11,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.51,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.6,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.4,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.09,
			"r": "137",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.25,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.57,
			"r": "131",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.53,
			"r": "78",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.5,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.22,
			"r": "39",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.94,
			"r": "47",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.82,
			"r": "59",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.71,
			"r": "64",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.42,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.93,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.62,
			"r": "22",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.48,
			"r": "83",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.47,
			"r": "33",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 4.05,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.95,
			"r": "116",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.52,
			"r": "80",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 5.83,
			"r": "13",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.55,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.7,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 5.26,
			"r": "35",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.33,
			"r": "136",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.9,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.23,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.29,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.62,
			"r": "74",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.43,
			"r": "89",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.29,
			"r": "33",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.09,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 3.74,
			"r": "124",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 4.45,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 3.05,
			"r": "142",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 4.58,
			"r": "75",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.46,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.87,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.62,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.51,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.73,
			"r": "126",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.38,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.95,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.61,
			"r": "129",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.7,
			"r": "65",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.91,
			"r": "51",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.71,
			"r": "127",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.11,
			"r": "41",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.53,
			"r": "134",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 3.67,
			"r": "132",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 6.09,
			"r": "2",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.75,
			"r": "62",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 5.03,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.03,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.89,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.12,
			"r": "40",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.16,
			"r": "106",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.73,
			"r": "130",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.79,
			"r": "60",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.38,
			"r": "93",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.25,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.73,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.84,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.96,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.53,
			"r": "26",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.36,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.9,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.31,
			"r": "98",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 4.35,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5,
			"r": "46",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.95,
			"r": "118",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.92,
			"r": "119",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 6.04,
			"r": "3",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.4,
			"r": "91",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.53,
			"r": "79",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.09,
			"r": "107",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.82,
			"r": "58",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.84,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.73,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.51,
			"r": "134",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.85,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.73,
			"r": "125",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.68,
			"r": "20",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.49,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.49,
			"r": "28",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.84,
			"r": "57",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.43,
			"r": "88",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.31,
			"r": "32",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.05,
			"r": "138",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.35,
			"r": "137",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.68,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.69,
			"r": "67",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.03,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 3.92,
			"r": "120",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.56,
			"r": "132",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.34,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.01,
			"r": "113",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 4.07,
			"r": "109",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.4,
			"r": "90",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.91,
			"r": "118",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.66,
			"r": "70",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.02,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.88,
			"r": "121",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.81,
			"r": "17",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.77,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.79,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4,
			"r": "114",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.76,
			"r": "123",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.22,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.34,
			"r": "100",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.23,
			"r": "104",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.03,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 4.2,
			"r": "106",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.47,
			"r": "84",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.04,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.35,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.43,
			"r": "87",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 4.69,
			"r": "68",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.83,
			"r": "16",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5,
			"r": "45",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.84,
			"r": "12",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.91,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.94,
			"r": "6",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.53,
			"r": "77",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.83,
			"r": "14",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 4.2,
			"r": "105",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.89,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.35,
			"r": "97",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.63,
			"r": "72",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.83,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.24,
			"r": "102",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.86,
			"r": "10",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.93,
			"r": "48",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.53,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.94,
			"r": "7",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.12,
			"r": "106",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 3.25,
			"r": "138",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 4.09,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.64,
			"r": "71",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.62,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.37,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 4.92,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 3.11,
			"r": "141",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 4.27,
			"r": "101",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.47,
			"r": "85",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.62,
			"r": "23",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.57,
			"r": "25",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.58,
			"r": "24",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.68,
			"r": "69",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ395": {
		"UNK": null,
		"NOR": {
			"v": 5.48,
			"r": "12",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.09,
			"r": "138",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.91,
			"r": "26",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.08,
			"r": "124",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 4.74,
			"r": "36",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.83,
			"r": "77",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.73,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.81,
			"r": "32",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.32,
			"r": "50",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 3.77,
			"r": "83",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.02,
			"r": "66",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.77,
			"r": "34",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.84,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.68,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 4.91,
			"r": "25",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.9,
			"r": "76",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.03,
			"r": "25",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.54,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.77,
			"r": "133",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.52,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.6,
			"r": "40",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.79,
			"r": "79",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.46,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.76,
			"r": "85",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.67,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.32,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.5,
			"r": "42",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.12,
			"r": "59",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.79,
			"r": "81",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.97,
			"r": "23",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.43,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.79,
			"r": "132",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.6,
			"r": "94",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2,
			"r": "142",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.99,
			"r": "128",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.06,
			"r": "20",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.96,
			"r": "3",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.59,
			"r": "95",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.6,
			"r": "93",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.77,
			"r": "84",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.15,
			"r": "56",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.28,
			"r": "115",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.31,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.37,
			"r": "107",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.04,
			"r": "63",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.7,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.7,
			"r": "89",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.85,
			"r": "138",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 5.49,
			"r": "9",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.37,
			"r": "137",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.19,
			"r": "54",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.82,
			"r": "78",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.03,
			"r": "21",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.65,
			"r": "38",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.78,
			"r": "79",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 3.74,
			"r": "86",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.2,
			"r": "53",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.22,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.71,
			"r": "37",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.14,
			"r": "19",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.42,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 3.92,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.92,
			"r": "24",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.97,
			"r": "71",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.86,
			"r": "29",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.2,
			"r": "51",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 3.36,
			"r": "108",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.49,
			"r": "43",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.98,
			"r": "69",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.5,
			"r": "136",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.46,
			"r": "13",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.96,
			"r": "72",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.98,
			"r": "70",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.68,
			"r": "90",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.04,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.77,
			"r": "33",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.31,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 3.22,
			"r": "114",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "65",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.99,
			"r": "127",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.17,
			"r": "120",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.76,
			"r": "86",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.56,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.47,
			"r": "44",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.83,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.63,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.51,
			"r": "138",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.89,
			"r": "4",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.33,
			"r": "49",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.77,
			"r": "5",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.09,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.04,
			"r": "126",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.06,
			"r": "62",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.37,
			"r": "106",
			"m": 67,
			"y": "2016"
		},
		"MLI": {
			"v": 3.17,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.21,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.41,
			"r": "109",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.07,
			"r": "61",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.52,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.49,
			"r": "100",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.48,
			"r": "10",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 4.98,
			"r": "22",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.6,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.12,
			"r": "123",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.39,
			"r": "47",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.12,
			"r": "58",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.4,
			"r": "15",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.93,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.59,
			"r": "135",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.7,
			"r": "90",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.42,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 2.91,
			"r": "129",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.44,
			"r": "103",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.49,
			"r": "99",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.43,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.46,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.36,
			"r": "48",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.87,
			"r": "28",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.17,
			"r": "55",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.48,
			"r": "11",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.13,
			"r": "57",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.9,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.22,
			"r": "118",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.08,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.12,
			"r": "122",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.78,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.34,
			"r": "17",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 3.79,
			"r": "80",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.39,
			"r": "16",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.02,
			"r": "67",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.26,
			"r": "116",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.53,
			"r": "6",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.19,
			"r": "119",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.97,
			"r": "129",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 2.81,
			"r": "130",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.35,
			"r": "109",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.95,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.79,
			"r": "131",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.33,
			"r": "110",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.94,
			"r": "136",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.32,
			"r": "112",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.04,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.77,
			"r": "35",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.5,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.18,
			"r": "18",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 3.59,
			"r": "96",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TABCOSTIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 125,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 1500,
			"r": "134",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 443.57,
			"r": "85",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 397,
			"r": "80",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 668.18,
			"r": "114",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 250,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 314.64,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 423,
			"r": "84",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 906,
			"r": "124",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 375,
			"r": "73",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 230,
			"r": "51",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 405,
			"r": "82",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 321.16,
			"r": "66",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 100,
			"r": "31",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 353.67,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 399.78,
			"r": "81",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 150,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 306.67,
			"r": "63",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 240,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 579.5,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 832.5,
			"r": "123",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 150,
			"r": "39",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 450,
			"r": "86",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 128.33,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 395,
			"r": "78",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 290,
			"r": "58",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"YEM": null,
		"CPV": {
			"v": 588,
			"y": "2016",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 935,
			"y": "2016",
			"m": 19
		},
		"NGA": {
			"v": 1076.79,
			"r": "127",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 190,
			"r": "45",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 489.19,
			"r": "90",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 660,
			"r": "112",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 305.56,
			"r": "62",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 660.38,
			"r": "113",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 143.46,
			"r": "37",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 688,
			"y": "2016",
			"m": 88
		},
		"EGY": {
			"v": 553.67,
			"r": "97",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 0,
			"r": "1",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 957.14,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 232.55,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 511.5,
			"r": "93",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 637,
			"y": "2016",
			"m": 100
		},
		"CHE": {
			"v": 200.56,
			"r": "46",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 969.57,
			"r": "126",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 180.71,
			"r": "44",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 420,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 282.14,
			"r": "57",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 265,
			"y": "2016",
			"m": 96
		},
		"SUR": {
			"v": 658,
			"y": "2016",
			"m": 104
		},
		"DOM": {
			"v": 579.17,
			"r": "100",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 635,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 278,
			"y": "2016",
			"m": 105
		},
		"PAN": {
			"v": 490,
			"r": "91",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 0,
			"r": "1",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 1320,
			"r": "131",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 223.33,
			"r": "49",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 525,
			"r": "94",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 228.11,
			"r": "50",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 341,
			"y": "2016",
			"m": 104
		},
		"CIV": {
			"v": 455.71,
			"r": "87",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 110.11,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 1200,
			"r": "129",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 0,
			"r": "1",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 98.08,
			"r": "30",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 82.78,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 382.59,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 482.76,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 909,
			"y": "2016",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 299.67,
			"r": "61",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 315,
			"r": "65",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 265.62,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3039,
			"r": "135",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 656.67,
			"r": "111",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 392.08,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 335,
			"r": "68",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 669,
			"r": "115",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 583,
			"y": "2016",
			"m": 96
		},
		"IRL": {
			"v": 253,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 325.62,
			"r": "67",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 465.87,
			"r": "88",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 77.3,
			"r": "28",
			"m": 65,
			"y": "2016"
		},
		"MLI": {
			"v": 297.5,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 353.57,
			"r": "69",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 134,
			"y": "2016",
			"m": 104
		},
		"BLR": {
			"v": 0,
			"y": "2016",
			"m": 86
		},
		"ITA": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 1293.75,
			"r": "130",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 0,
			"r": "1",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 754.44,
			"r": "119",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 372.12,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": {
			"v": 750,
			"y": "2016",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 695,
			"r": "117",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 500,
			"r": "92",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 778.85,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 396.43,
			"r": "79",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 380,
			"r": "74",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 582,
			"r": "102",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 265,
			"y": "2016",
			"m": 86
		},
		"IND": {
			"v": 574.04,
			"r": "99",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 596.15,
			"r": "105",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 52,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 552.86,
			"r": "96",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 1125,
			"r": "128",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 776.61,
			"r": "120",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 175,
			"r": "43",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 655.27,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 299.21,
			"r": "60",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 582.67,
			"r": "103",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 100,
			"r": "31",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 220,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 599.11,
			"r": "106",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 545,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 655,
			"r": "109",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 152.5,
			"r": "41",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 145,
			"r": "38",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 781.71,
			"r": "122",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 677.78,
			"r": "116",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 108.5,
			"r": "33",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 457,
			"y": "2016",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 561.67,
			"r": "98",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 645.57,
			"r": "108",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 701.67,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 1406.88,
			"r": "133",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 209.78,
			"r": "47",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 410,
			"y": "2016",
			"m": 104
		},
		"TZA": {
			"v": 1350,
			"r": "132",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 595,
			"r": "104",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 171.88,
			"r": "42",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 366.5,
			"r": "71",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 389.23,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 1585,
			"y": "2016",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"IMPCOSTCOMPLIANCEIDX": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"MOBSUBPC": {
		"UNK": null,
		"NOR": {
			"v": 113.58,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 103.77,
			"r": "92",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 92.97,
			"r": "104",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 129.21,
			"r": "47",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 46.22,
			"r": "132",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 185.26,
			"r": "5",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 42.76,
			"r": "134",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 79.43,
			"r": "120",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 102.61,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 118.46,
			"r": "63",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 111.28,
			"r": "79",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 111.51,
			"r": "77",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 160.21,
			"r": "12",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 129.3,
			"r": "45",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 111.48,
			"r": "78",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 143.91,
			"r": "27",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 115.15,
			"r": "70",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 74.24,
			"r": "124",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 116.11,
			"r": "67",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 105.38,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 133.47,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 133,
			"r": "35",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 118.13,
			"r": "64",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 80.68,
			"r": "119",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 105.52,
			"r": "88",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 85.3,
			"r": "112",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 145.26,
			"r": "25",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 139.52,
			"r": "32",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 107.14,
			"r": "86",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 108.13,
			"r": "83",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 129.47,
			"r": "44",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 126.97,
			"r": "51",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 67.98,
			"r": "127",
			"m": 105,
			"y": "2015"
		},
		"CPV": {
			"v": 118.58,
			"y": "2015",
			"m": 92
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 60.84,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 82.19,
			"r": "116",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 110.41,
			"r": "81",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 135.5,
			"r": "33",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 96.75,
			"r": "98",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 50.37,
			"r": "131",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 81.09,
			"r": "118",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 162.16,
			"r": "11",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 93.38,
			"r": "102",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 35.34,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 60.97,
			"y": "2015",
			"m": 88
		},
		"EGY": {
			"v": 110.99,
			"r": "80",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 129.27,
			"r": "46",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 66.92,
			"r": "128",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 125.81,
			"r": "54",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 132.8,
			"r": "37",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 157,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 142.01,
			"r": "29",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 126.59,
			"r": "53",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 179.43,
			"r": "6",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 150.66,
			"r": "20",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 70.48,
			"r": "126",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 113.22,
			"r": "74",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 67.19,
			"y": "2015",
			"m": 96
		},
		"SUR": {
			"v": 136.83,
			"y": "2015",
			"m": 104
		},
		"DOM": {
			"v": 82.59,
			"r": "115",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 157.67,
			"r": "16",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 73.32,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 174.19,
			"r": "8",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 115.69,
			"r": "69",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 168.92,
			"r": "10",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 98.59,
			"r": "97",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 132.8,
			"r": "36",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 126.87,
			"r": "52",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 118.91,
			"r": "62",
			"m": 96,
			"y": "2015"
		},
		"SYC": {
			"v": 158.12,
			"y": "2015",
			"m": 104
		},
		"CIV": {
			"v": 119.31,
			"r": "61",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 107.9,
			"r": "85",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 87.12,
			"r": "109",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 143.91,
			"r": "28",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 125.75,
			"r": "55",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 187.17,
			"r": "4",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 169,
			"r": "9",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 108.04,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 132.35,
			"r": "38",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 128.34,
			"r": "49",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 95.54,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 87.17,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 112.83,
			"r": "76",
			"m": 100,
			"y": "2015"
		},
		"BOL": {
			"v": 92.18,
			"r": "105",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 228.83,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 52.99,
			"r": "130",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 159.27,
			"r": "15",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 130.64,
			"r": "40",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 95.4,
			"r": "101",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 122.31,
			"r": "58",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 40.17,
			"r": "135",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 68.84,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 103.71,
			"r": "93",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 148.71,
			"r": "21",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 130.38,
			"r": "41",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 131.26,
			"r": "39",
			"m": 96,
			"y": "2015"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 113.03,
			"r": "75",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 113.98,
			"r": "72",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 4151900,
			"r": "87",
			"m": 53,
			"y": "2015"
		},
		"MLI": {
			"v": 139.61,
			"r": "31",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 159.86,
			"r": "14",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 73.2,
			"y": "2015",
			"m": 104
		},
		"BLR": {
			"v": 123.64,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 151.32,
			"r": "19",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 123.54,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 83.36,
			"r": "114",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 157.41,
			"r": "17",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 153.59,
			"r": "18",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 140.57,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": {
			"v": 61.58,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 87.07,
			"r": "110",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 105.39,
			"r": "89",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 176.59,
			"r": "7",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 128.95,
			"r": "48",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 74.47,
			"r": "123",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 89.32,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 80.64,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 78.84,
			"r": "121",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 129.93,
			"r": "42",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 120.52,
			"r": "60",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 129.74,
			"r": "43",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 159.95,
			"r": "13",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 148.69,
			"r": "22",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 93.16,
			"r": "103",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 117.59,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 96.02,
			"r": "99",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 125.05,
			"r": "56",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 109.87,
			"r": "82",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 116.71,
			"r": "66",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 144.02,
			"r": "26",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 146.14,
			"r": "24",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 85.64,
			"r": "111",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 115.74,
			"r": "68",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 114.01,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 53.1,
			"r": "129",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 148.51,
			"r": "23",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 102.1,
			"r": "95",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 89.53,
			"r": "107",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 187.35,
			"r": "3",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 90.15,
			"r": "106",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 75.68,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 84.79,
			"r": "113",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 231.76,
			"r": "1",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 99.95,
			"r": "96",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 71.85,
			"r": "125",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 104.96,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"TLS": {
			"v": 117.4,
			"y": "2015",
			"m": 104
		},
		"TZA": {
			"v": 75.86,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 46.02,
			"r": "133",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 81.93,
			"r": "117",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 121.83,
			"r": "59",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 127.3,
			"r": "50",
			"m": 104,
			"y": "2015"
		},
		"BRB": {
			"v": 116.46,
			"y": "2015",
			"m": 90
		},
		"MHL": null,
		"AND": null
	},
	"TARIFNUMB": {
		"UNK": null,
		"NOR": {
			"v": 736,
			"r": "99",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 18,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 18,
			"r": "43",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 22,
			"r": "54",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 6,
			"r": "21",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 395,
			"r": "91",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 169,
			"r": "77",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 274,
			"r": "79",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 11,
			"r": "32",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 18,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 8,
			"r": "28",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 102,
			"r": "73",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 1686,
			"r": "104",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 5,
			"r": "10",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 12,
			"r": "35",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 344,
			"r": "89",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 492,
			"r": "97",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 15,
			"r": "39",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 15,
			"r": "39",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 18,
			"r": "43",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 321,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 81,
			"r": "71",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 11,
			"r": "32",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 61,
			"r": "68",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 2,
			"r": "2",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 5,
			"r": "10",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 5,
			"r": "10",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 50,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 18,
			"r": "43",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 122,
			"r": "74",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 287,
			"r": "81",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 24,
			"r": "60",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 9,
			"r": "30",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 33,
			"r": "63",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 1924,
			"r": "108",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 61,
			"r": "68",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 764,
			"r": "100",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 1810,
			"r": "105",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 6710,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 19,
			"r": "52",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 16,
			"r": "41",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 14,
			"r": "38",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 18,
			"r": "43",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 1924,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 7,
			"r": "25",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 37,
			"r": "64",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 57,
			"r": "67",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 1924,
			"r": "108",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 5,
			"r": "10",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 222,
			"r": "78",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 20,
			"r": "53",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 18,
			"r": "43",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 5,
			"r": "10",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 9,
			"r": "30",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 18,
			"r": "43",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 1924,
			"r": "108",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 1820,
			"r": "106",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 321,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 409,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 76,
			"r": "70",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 13,
			"r": "36",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 274,
			"r": "79",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 8,
			"r": "28",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 1,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 5,
			"r": "10",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 321,
			"r": "84",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 42,
			"r": "65",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 1924,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 5,
			"r": "10",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 1924,
			"r": "108",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 4,
			"r": "4",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 4,
			"r": "4",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 6,
			"r": "21",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 5,
			"r": "10",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 22,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 1924,
			"r": "108",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 1924,
			"r": "108",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 31,
			"r": "62",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 1924,
			"r": "108",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 22,
			"r": "54",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 308,
			"r": "83",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 384,
			"r": "90",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 24,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 22,
			"r": "54",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 467,
			"r": "96",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 147,
			"r": "75",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 4,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 716,
			"r": "98",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 7,
			"r": "25",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 16,
			"r": "41",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 4,
			"r": "4",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 1820,
			"r": "106",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 1924,
			"r": "108",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 98,
			"r": "72",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 1307,
			"r": "103",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 452,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 764,
			"r": "100",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 3,
			"r": "3",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 1924,
			"r": "108",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 151,
			"r": "76",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 7,
			"r": "25",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 5,
			"r": "10",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 13,
			"r": "36",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 405,
			"r": "92",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 6,
			"r": "21",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 1924,
			"r": "108",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 321,
			"r": "84",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 6,
			"r": "21",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 22,
			"r": "54",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 798,
			"r": "102",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 420,
			"r": "94",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 22,
			"r": "54",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 5,
			"r": "10",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 5,
			"r": "10",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 4,
			"r": "4",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 18,
			"r": "43",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4,
			"r": "4",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 329,
			"r": "88",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 11,
			"r": "32",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 299,
			"r": "82",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 7": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SHIPAFFORD": {
		"UNK": null,
		"NOR": {
			"v": 3.62,
			"r": "25",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 3.12,
			"r": "51",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 2.47,
			"r": "108",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 3.65,
			"r": "18",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 2.42,
			"r": "113",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 3.33,
			"r": "41",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 2.56,
			"r": "98",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 2.95,
			"r": "65",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 3.64,
			"r": "20",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 3.58,
			"r": "27",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.57,
			"r": "95",
			"m": 81,
			"y": "2013"
		},
		"JAM": {
			"v": 2.44,
			"r": "111",
			"m": 96,
			"y": "2015"
		},
		"SLB": null,
		"URY": {
			"v": 2.91,
			"r": "69",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 3.09,
			"r": "55",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 2.41,
			"r": "114",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 3.48,
			"r": "32",
			"m": 101,
			"y": "2015"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.22,
			"r": "128",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.06,
			"r": "58",
			"m": 100,
			"y": "2015"
		},
		"NIC": {
			"v": 2.5,
			"r": "103",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 2.45,
			"r": "110",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 3.38,
			"r": "37",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 3.11,
			"r": "52",
			"m": 97,
			"y": "2015"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.01,
			"r": "60",
			"m": 103,
			"y": "2015"
		},
		"COK": null,
		"KEN": {
			"v": 3.24,
			"r": "46",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 1.84,
			"r": "136",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 3,
			"r": "61",
			"m": 100,
			"y": "2015"
		},
		"SLV": {
			"v": 2.82,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 3.49,
			"r": "31",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 3.06,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 3,
			"r": "62",
			"m": 91,
			"y": "2015"
		},
		"CHL": {
			"v": 3.3,
			"r": "43",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 3.28,
			"r": "44",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 2.35,
			"r": "118",
			"m": 105,
			"y": "2013"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.37,
			"y": "2015",
			"m": 19
		},
		"NGA": {
			"v": 2.43,
			"r": "112",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 3.24,
			"r": "47",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 3.51,
			"r": "30",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 2.5,
			"r": "105",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.88,
			"r": "74",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 2.22,
			"r": "127",
			"m": 99,
			"y": "2015"
		},
		"MNE": {
			"v": 2.56,
			"r": "97",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 2.67,
			"r": "86",
			"m": 96,
			"y": "2015"
		},
		"SPM": null,
		"MWI": {
			"v": 2.63,
			"r": "89",
			"m": 100,
			"y": "2013"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.27,
			"r": "45",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 2.93,
			"r": "67",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 2.93,
			"r": "66",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 3.37,
			"r": "38",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 2.1,
			"r": "132",
			"m": 97,
			"y": "2015"
		},
		"LBY": {
			"v": 2.4,
			"y": "2015",
			"m": 100
		},
		"CHE": {
			"v": 3.69,
			"r": "14",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 2.9,
			"r": "72",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 3.17,
			"r": "49",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 2.89,
			"r": "73",
			"m": 92,
			"y": "2015"
		},
		"RWA": {
			"v": 3.05,
			"r": "59",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 3.1,
			"r": "53",
			"m": 104,
			"y": "2015"
		},
		"GUY": {
			"v": 2.66,
			"y": "2015",
			"m": 96
		},
		"SUR": null,
		"DOM": {
			"v": 2.67,
			"r": "85",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 2.31,
			"r": "122",
			"m": 104,
			"y": "2015"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": {
			"v": 2.36,
			"y": "2015",
			"m": 105
		},
		"PAN": {
			"v": 3.65,
			"r": "16",
			"m": 103,
			"y": "2015"
		},
		"SYR": null,
		"BEL": {
			"v": 4.05,
			"r": "3",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 2.28,
			"r": "125",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 2.12,
			"r": "131",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 3.63,
			"r": "21",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.09,
			"r": "54",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 3.44,
			"r": "34",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 2.54,
			"r": "101",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 3.63,
			"r": "22",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 2.5,
			"r": "104",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 2.76,
			"r": "80",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 3.77,
			"r": "11",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.75,
			"r": "81",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 2.91,
			"r": "70",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 2.6,
			"r": "91",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 2.9,
			"r": "71",
			"m": 96,
			"y": "2015"
		},
		"DNK": {
			"v": 3.66,
			"r": "15",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 2.58,
			"r": "94",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.38,
			"y": "2015",
			"m": 95
		},
		"CAF": null,
		"LKA": {
			"v": 2.56,
			"r": "96",
			"m": 100,
			"y": "2013"
		},
		"BOL": {
			"v": 2.4,
			"r": "116",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 4.05,
			"r": "2",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.33,
			"r": "121",
			"m": 92,
			"y": "2015"
		},
		"ZAF": {
			"v": 3.62,
			"r": "23",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 3.12,
			"r": "50",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 2.8,
			"r": "78",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 3.41,
			"r": "36",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 2.41,
			"r": "115",
			"m": 104,
			"y": "2015"
		},
		"HTI": {
			"v": 1.81,
			"y": "2015",
			"m": 96
		},
		"IRL": {
			"v": 3.83,
			"r": "10",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 3.44,
			"r": "33",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4,
			"r": "4",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 2.67,
			"r": "86",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.8,
			"r": "77",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 2.97,
			"r": "64",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 2.48,
			"r": "106",
			"m": 54,
			"y": "2015"
		},
		"MLI": {
			"v": 2.48,
			"r": "107",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 3.35,
			"r": "40",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": {
			"v": 2.62,
			"y": "2015",
			"m": 86
		},
		"ITA": {
			"v": 3.65,
			"r": "17",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 3.94,
			"r": "6",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 2.73,
			"r": "82",
			"m": 86,
			"y": "2015"
		},
		"AUT": {
			"v": 3.85,
			"r": "9",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 3.58,
			"r": "26",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 2.62,
			"r": "90",
			"m": 100,
			"y": "2013"
		},
		"ATG": null,
		"AFG": {
			"v": 2.38,
			"y": "2015",
			"m": 6
		},
		"COG": null,
		"LBN": {
			"v": 2.84,
			"r": "75",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.58,
			"r": "93",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 3.23,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"GRL": null,
		"GEO": {
			"v": 2.35,
			"r": "119",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.51,
			"r": "102",
			"m": 105,
			"y": "2015"
		},
		"MRT": {
			"v": 2,
			"r": "134",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": {
			"v": 2.73,
			"y": "2015",
			"m": 86
		},
		"IND": {
			"v": 3.36,
			"r": "39",
			"m": 96,
			"y": "2015"
		},
		"TUN": {
			"v": 2.33,
			"r": "120",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 2.63,
			"r": "88",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 2.71,
			"r": "83",
			"m": 95,
			"y": "2015"
		},
		"RUS": {
			"v": 2.45,
			"r": "109",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 3.07,
			"r": "56",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 3.7,
			"r": "12",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 3.65,
			"r": "19",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.41,
			"r": "35",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 3.69,
			"r": "13",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 2.91,
			"r": "68",
			"m": 103,
			"y": "2015"
		},
		"VIR": null,
		"DEU": {
			"v": 3.86,
			"r": "8",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 2.59,
			"r": "92",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 3.96,
			"r": "5",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 2.55,
			"r": "100",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 2.55,
			"r": "99",
			"m": 92,
			"y": "2015"
		},
		"MCO": null,
		"ISL": {
			"v": 3.32,
			"r": "42",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 2.18,
			"r": "129",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 4.24,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 2.69,
			"r": "84",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 2.31,
			"r": "123",
			"m": 104,
			"y": "2015"
		},
		"ARE": {
			"v": 3.89,
			"r": "7",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 2.28,
			"r": "124",
			"m": 86,
			"y": "2015"
		},
		"MMR": {
			"v": 2.23,
			"y": "2015",
			"m": 100
		},
		"REU": null,
		"ZWE": {
			"v": 2.08,
			"r": "133",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 3.62,
			"r": "24",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 2.25,
			"r": "126",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 1.98,
			"r": "135",
			"m": 92,
			"y": "2015"
		},
		"MNG": {
			"v": 2.37,
			"r": "117",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 2.98,
			"r": "63",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 2.17,
			"r": "130",
			"m": 100,
			"y": "2015"
		},
		"BLM": null,
		"CAN": {
			"v": 3.56,
			"r": "29",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 2.77,
			"r": "79",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 3.57,
			"r": "28",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 1.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 4.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 2.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 1.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 2.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 5.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 4.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 5.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 4.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 5.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 2.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 3.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 6.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 4.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 3.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 2.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 4.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 5.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 1.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 4.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABCOSTIMPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 5.23,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 5.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 2.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 5.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 5.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 6.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 1.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 6.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 5.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 5.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 1.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 3.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.51,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 4.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 2.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 3.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 6.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 4.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.57,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.62,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"TARIFSPECIAL": {
		"UNK": null,
		"NOR": {
			"v": 9.75,
			"r": "102",
			"m": 103,
			"y": "2015"
		},
		"HRV": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"VEN": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"TON": null,
		"CZE": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"BDI": {
			"v": 0.2,
			"r": "51",
			"m": 81,
			"y": "2015"
		},
		"BHR": {
			"v": 0.26,
			"r": "57",
			"m": 86,
			"y": "2015"
		},
		"ETH": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"ECU": {
			"v": 5.05,
			"r": "94",
			"m": 94,
			"y": "2015"
		},
		"FRA": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"SJM": null,
		"KOR": {
			"v": 0.72,
			"r": "72",
			"m": 97,
			"y": "2015"
		},
		"AZE": {
			"v": 2.68,
			"r": "82",
			"m": 81,
			"y": "2015"
		},
		"JAM": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2014"
		},
		"SLB": null,
		"URY": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"MLT": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"BVT": null,
		"GTM": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"MYS": {
			"v": 0.88,
			"r": "74",
			"m": 101,
			"y": "2014"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 13.7,
			"r": "132",
			"m": 78,
			"y": "2015"
		},
		"PRI": null,
		"MOZ": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"NIC": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.23,
			"r": "83",
			"m": 100,
			"y": "2015"
		},
		"ISR": {
			"v": 5.34,
			"r": "95",
			"m": 96,
			"y": "2015"
		},
		"KHM": {
			"v": 0.12,
			"r": "50",
			"m": 97,
			"y": "2014"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"COK": null,
		"KEN": {
			"v": 0.2,
			"r": "51",
			"m": 97,
			"y": "2015"
		},
		"COM": null,
		"LSO": {
			"v": 3.82,
			"r": "84",
			"m": 100,
			"y": "2015"
		},
		"MEX": {
			"v": 0.48,
			"r": "68",
			"m": 100,
			"y": "2014"
		},
		"SLV": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"CYM": null,
		"LTU": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"ROU": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"BRN": {
			"v": 0.55,
			"r": "69",
			"m": 91,
			"y": "2014"
		},
		"CHL": {
			"v": 0,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"LVA": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"YEM": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 0,
			"r": "1",
			"m": 102,
			"y": "2015"
		},
		"PRT": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"SGS": null,
		"FIN": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"NPL": {
			"v": 0.8,
			"r": "73",
			"m": 103,
			"y": "2015"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 0.2,
			"r": "51",
			"m": 105,
			"y": "2015"
		},
		"LBR": {
			"v": 1.87,
			"r": "78",
			"m": 99,
			"y": "2014"
		},
		"MNE": {
			"v": 2.17,
			"r": "80",
			"m": 100,
			"y": "2015"
		},
		"IRN": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2011"
		},
		"SPM": null,
		"MWI": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 0.27,
			"r": "62",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 11.89,
			"r": "104",
			"m": 86,
			"y": "2015"
		},
		"CUB": null,
		"PAK": {
			"v": 0.67,
			"r": "71",
			"m": 103,
			"y": "2015"
		},
		"IMN": null,
		"THA": {
			"v": 7.55,
			"r": "100",
			"m": 104,
			"y": "2015"
		},
		"KGZ": {
			"v": 14.74,
			"r": "133",
			"m": 97,
			"y": "2015"
		},
		"LBY": null,
		"CHE": {
			"v": 80.84,
			"r": "136",
			"m": 91,
			"y": "2015"
		},
		"MAC": null,
		"BRA": {
			"v": 0,
			"r": "1",
			"m": 88,
			"y": "2015"
		},
		"JOR": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"RWA": {
			"v": 0.2,
			"r": "51",
			"m": 103,
			"y": "2015"
		},
		"ATA": null,
		"SVN": {
			"v": 11.89,
			"r": "104",
			"m": 104,
			"y": "2015"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"CUW": null,
		"TTO": {
			"v": 0.45,
			"r": "67",
			"m": 104,
			"y": "2013"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 0.32,
			"r": "64",
			"m": 103,
			"y": "2014"
		},
		"SYR": null,
		"BEL": {
			"v": 11.89,
			"r": "104",
			"m": 82,
			"y": "2015"
		},
		"GAB": {
			"v": 0,
			"r": "1",
			"m": 94,
			"y": "2015"
		},
		"TJK": {
			"v": 1.97,
			"r": "79",
			"m": 104,
			"y": "2015"
		},
		"AUS": {
			"v": 0.29,
			"r": "63",
			"m": 80,
			"y": "2015"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"PNG": null,
		"HUN": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"SYC": null,
		"CIV": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2015"
		},
		"ABW": null,
		"ESP": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 0,
			"r": "1",
			"m": 91,
			"y": "2015"
		},
		"ARG": {
			"v": 0,
			"r": "1",
			"m": 76,
			"y": "2015"
		},
		"GBR": {
			"v": 11.89,
			"r": "104",
			"m": 95,
			"y": "2015"
		},
		"SXM": null,
		"KAZ": {
			"v": 14.77,
			"r": "134",
			"m": 97,
			"y": "2015"
		},
		"BWA": {
			"v": 3.82,
			"r": "84",
			"m": 91,
			"y": "2015"
		},
		"MDA": {
			"v": 4.14,
			"r": "90",
			"m": 100,
			"y": "2015"
		},
		"CXR": null,
		"IDN": {
			"v": 0.65,
			"r": "70",
			"m": 96,
			"y": "2014"
		},
		"DNK": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"HND": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 3.88,
			"r": "88",
			"m": 100,
			"y": "2014"
		},
		"BOL": {
			"v": 0,
			"r": "1",
			"m": 88,
			"y": "2015"
		},
		"NFK": null,
		"HKG": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"ZAF": {
			"v": 3.82,
			"r": "84",
			"m": 105,
			"y": "2015"
		},
		"VNM": {
			"v": 0,
			"r": "1",
			"m": 105,
			"y": "2015"
		},
		"CYP": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"TCA": null,
		"SVK": {
			"v": 11.89,
			"r": "104",
			"m": 104,
			"y": "2015"
		},
		"NER": null,
		"TCD": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"HTI": null,
		"IRL": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"IRQ": null,
		"POL": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 11.89,
			"r": "104",
			"m": 104,
			"y": "2015"
		},
		"PLW": null,
		"GMB": {
			"v": 0,
			"r": "1",
			"m": 96,
			"y": "2013"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 0,
			"r": "1",
			"m": 93,
			"y": "2015"
		},
		"GRC": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"FSM": null,
		"ALB": {
			"v": 0,
			"r": "1",
			"m": 56,
			"y": "2015"
		},
		"MLI": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"OMN": {
			"v": 0.26,
			"r": "56",
			"m": 103,
			"y": "2015"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 11.89,
			"r": "104",
			"m": 96,
			"y": "2015"
		},
		"NLD": {
			"v": 11.89,
			"r": "104",
			"m": 103,
			"y": "2015"
		},
		"BGD": {
			"v": 0.38,
			"r": "66",
			"m": 86,
			"y": "2013"
		},
		"AUT": {
			"v": 11.89,
			"r": "104",
			"m": 80,
			"y": "2015"
		},
		"QAT": {
			"v": 0.26,
			"r": "57",
			"m": 103,
			"y": "2015"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.77,
			"r": "93",
			"m": 100,
			"y": "2015"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 6.23,
			"r": "97",
			"m": 99,
			"y": "2015"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2015"
		},
		"LCA": null,
		"SAU": {
			"v": 0.26,
			"r": "57",
			"m": 104,
			"y": "2014"
		},
		"GRL": null,
		"GEO": {
			"v": 4.53,
			"r": "92",
			"m": 95,
			"y": "2015"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.37,
			"r": "81",
			"m": 105,
			"y": "2014"
		},
		"MRT": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 6.06,
			"r": "96",
			"m": 96,
			"y": "2014"
		},
		"TUN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"SRB": {
			"v": 0.01,
			"r": "47",
			"m": 104,
			"y": "2015"
		},
		"GHA": {
			"v": 0,
			"r": "1",
			"m": 95,
			"y": "2013"
		},
		"RUS": {
			"v": 14.77,
			"r": "134",
			"m": 103,
			"y": "2015"
		},
		"EST": {
			"v": 11.89,
			"r": "104",
			"m": 94,
			"y": "2015"
		},
		"SMR": null,
		"CHN": {
			"v": 0.34,
			"r": "65",
			"m": 92,
			"y": "2015"
		},
		"NIU": null,
		"USA": {
			"v": 9.84,
			"r": "103",
			"m": 105,
			"y": "2015"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 1.67,
			"r": "76",
			"m": 104,
			"y": "2015"
		},
		"JPN": {
			"v": 6.85,
			"r": "99",
			"m": 96,
			"y": "2015"
		},
		"PER": {
			"v": 0,
			"r": "1",
			"m": 103,
			"y": "2014"
		},
		"VIR": null,
		"DEU": {
			"v": 11.89,
			"r": "104",
			"m": 92,
			"y": "2015"
		},
		"STP": null,
		"UKR": {
			"v": 1,
			"r": "75",
			"m": 105,
			"y": "2015"
		},
		"SGP": {
			"v": 0.06,
			"r": "48",
			"m": 104,
			"y": "2015"
		},
		"GRD": null,
		"BEN": {
			"v": 0,
			"r": "1",
			"m": 83,
			"y": "2015"
		},
		"COL": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"MCO": null,
		"ISL": {
			"v": 4.53,
			"r": "91",
			"m": 96,
			"y": "2015"
		},
		"LAO": {
			"v": 0,
			"r": "1",
			"m": 98,
			"y": "2015"
		},
		"FLK": null,
		"LUX": {
			"v": 11.89,
			"r": "104",
			"m": 100,
			"y": "2015"
		},
		"ERI": null,
		"NAM": {
			"v": 3.82,
			"r": "84",
			"m": 101,
			"y": "2015"
		},
		"SLE": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2012"
		},
		"ARE": {
			"v": 0.26,
			"r": "57",
			"m": 75,
			"y": "2015"
		},
		"GNB": null,
		"BIH": {
			"v": 7.75,
			"r": "101",
			"m": 86,
			"y": "2015"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 6.59,
			"r": "98",
			"m": 105,
			"y": "2015"
		},
		"KWT": {
			"v": 0.26,
			"r": "57",
			"m": 98,
			"y": "2015"
		},
		"ESH": null,
		"SEN": {
			"v": 0,
			"r": "1",
			"m": 104,
			"y": "2015"
		},
		"CMR": {
			"v": 0,
			"r": "1",
			"m": 92,
			"y": "2014"
		},
		"MNG": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2015"
		},
		"TLS": null,
		"TZA": {
			"v": 0.2,
			"r": "51",
			"m": 104,
			"y": "2015"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 0,
			"r": "1",
			"m": 100,
			"y": "2014"
		},
		"BLM": null,
		"CAN": {
			"v": 3.98,
			"r": "89",
			"m": 91,
			"y": "2015"
		},
		"NZL": {
			"v": 0.11,
			"r": "49",
			"m": 103,
			"y": "2015"
		},
		"TWN": {
			"v": 1.85,
			"r": "77",
			"m": 104,
			"y": "2015"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-EOSQ395": {
		"UNK": null,
		"NOR": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 2.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.74,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 4.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 3.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 4.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 2.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 4.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 2.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 5.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 3.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 4.15,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 3.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 4.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.03,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.14,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 3.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 4.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 3.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 3.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 2.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 5.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 3.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 4.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 2.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 3.44,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 3.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 3.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.22,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 3.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.34,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.39,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.53,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.19,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 2.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 3.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 2.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 3.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETI_OPENFRXPART": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEEXPBORD": {
		"UNK": null,
		"NOR": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 4.65,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 4.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 4.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 5.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.66,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.84,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 2.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 1.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 2.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 5.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 3.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 3.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 5.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 2.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 1.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.26,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.69,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.28,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 2.63,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.01,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.24,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 1.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 2.76,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 4.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.85,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 2.68,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.37,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.08,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 5.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 2.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.56,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 6.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 4.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 5.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 4.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 4.52,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 4.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.48,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETID": {
		"UNK": null,
		"NOR": {
			"v": 5.63,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.24,
			"r": "72",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.89,
			"r": "135",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.76,
			"r": "35",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 3.22,
			"r": "132",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.15,
			"r": "23",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.95,
			"r": "97",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.86,
			"r": "105",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.99,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.57,
			"r": "47",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.63,
			"r": "44",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.06,
			"r": "88",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.75,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.9,
			"r": "31",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.04,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.1,
			"r": "26",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.55,
			"r": "50",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.53,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.07,
			"r": "85",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.61,
			"r": "45",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.63,
			"r": "43",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.99,
			"r": "94",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 3.87,
			"r": "104",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 3.97,
			"r": "96",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 3.92,
			"r": "99",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.06,
			"r": "87",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.63,
			"r": "121",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.67,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.38,
			"r": "58",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.29,
			"r": "69",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.98,
			"r": "29",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.56,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.83,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.52,
			"r": "126",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.87,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.8,
			"r": "4",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 3.84,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.07,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.06,
			"r": "86",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.23,
			"r": "74",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.77,
			"r": "116",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.77,
			"r": "114",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3.74,
			"r": "118",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.24,
			"r": "71",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.49,
			"r": "130",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.08,
			"r": "83",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.89,
			"r": "102",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.77,
			"r": "5",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.62,
			"r": "123",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.76,
			"r": "36",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.31,
			"r": "66",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 5.29,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.47,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.99,
			"r": "93",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.74,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 4.74,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.34,
			"r": "13",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.82,
			"r": "110",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.54,
			"r": "51",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.24,
			"r": "21",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.59,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.46,
			"r": "55",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.09,
			"r": "82",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.66,
			"r": "41",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.4,
			"r": "57",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.77,
			"r": "115",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.3,
			"r": "16",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.49,
			"r": "53",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.33,
			"r": "62",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.88,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.32,
			"r": "64",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.24,
			"r": "20",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 3.9,
			"r": "100",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.33,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 3.73,
			"r": "120",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.86,
			"r": "1",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.51,
			"r": "127",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.35,
			"r": "61",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.23,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.41,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.56,
			"r": "48",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.01,
			"r": "134",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 5.31,
			"r": "15",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.5,
			"r": "52",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.65,
			"r": "6",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.32,
			"r": "65",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.82,
			"r": "111",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.01,
			"r": "91",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.38,
			"r": "59",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 3.62,
			"r": "122",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.95,
			"r": "30",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.14,
			"r": "81",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 5.39,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.5,
			"r": "128",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.39,
			"r": "12",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.43,
			"r": "10",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.78,
			"r": "34",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.83,
			"r": "108",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.23,
			"r": "75",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.67,
			"r": "39",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.84,
			"r": "33",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.38,
			"r": "60",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 3.19,
			"r": "133",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.23,
			"r": "76",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.99,
			"r": "95",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.04,
			"r": "90",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 4.24,
			"r": "70",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.79,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.28,
			"r": "18",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.65,
			"r": "42",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.22,
			"r": "22",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.23,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.31,
			"r": "14",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.17,
			"r": "80",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.27,
			"r": "19",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.53,
			"r": "125",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.81,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.9,
			"r": "101",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.49,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.14,
			"r": "25",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.2,
			"r": "79",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.8,
			"r": "3",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.29,
			"r": "67",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.76,
			"r": "117",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.58,
			"r": "9",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.84,
			"r": "107",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 3.41,
			"r": "131",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.29,
			"r": "68",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.21,
			"r": "78",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.83,
			"r": "109",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.93,
			"r": "98",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 4,
			"r": "92",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.81,
			"r": "112",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.14,
			"r": "24",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.59,
			"r": "8",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.03,
			"r": "27",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 3": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETIA02": {
		"UNK": null,
		"NOR": {
			"v": 3.64,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.63,
			"r": "28",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.3,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.53,
			"r": "38",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 4.91,
			"r": "19",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 3.3,
			"r": "109",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 4.57,
			"r": "32",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.04,
			"r": "82",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.3,
			"r": "58",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 3.43,
			"r": "105",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 2.85,
			"r": "114",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.56,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.31,
			"r": "108",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.18,
			"r": "70",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.43,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 3.35,
			"r": "107",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.5,
			"r": "40",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 5.71,
			"r": "7",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 4.68,
			"r": "26",
			"m": 103,
			"y": "2016"
		},
		"MKD": {
			"v": 4.5,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 3.81,
			"r": "93",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 5.9,
			"r": "5",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.52,
			"r": "39",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.81,
			"r": "24",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.24,
			"r": "2",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.26,
			"r": "66",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 5.04,
			"r": "17",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.21,
			"r": "68",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 4.46,
			"r": "43",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.13,
			"r": "74",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.25,
			"r": "13",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.14,
			"r": "72",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 5.11,
			"r": "15",
			"m": 105,
			"y": "2016"
		},
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 2.43,
			"r": "123",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.38,
			"r": "51",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 3.92,
			"r": "87",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 6.46,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 6.02,
			"r": "3",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 4.86,
			"r": "21",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.3,
			"r": "59",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 1.77,
			"r": "136",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.87,
			"r": "6",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.36,
			"r": "54",
			"m": 94,
			"y": "2016"
		},
		"BGR": {
			"v": 4.23,
			"r": "67",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.57,
			"r": "101",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 3.7,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.84,
			"r": "91",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 3.71,
			"r": "95",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.51,
			"r": "122",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.86,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.26,
			"r": "65",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.79,
			"r": "25",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 4.53,
			"r": "37",
			"m": 104,
			"y": "2016"
		},
		"GUY": null,
		"SUR": null,
		"DOM": {
			"v": 3.95,
			"r": "86",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.9,
			"r": "89",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.43,
			"r": "106",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.46,
			"r": "42",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 2.2,
			"r": "128",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.67,
			"r": "119",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 2.21,
			"r": "127",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.59,
			"r": "30",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 4.45,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.03,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.64,
			"r": "27",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 3.1,
			"r": "112",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.45,
			"r": "103",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 3.9,
			"r": "90",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.74,
			"r": "116",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.63,
			"r": "99",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 4.41,
			"r": "49",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.83,
			"r": "92",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.34,
			"r": "55",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.89,
			"r": "20",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 2.89,
			"r": "113",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.41,
			"r": "48",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 2.15,
			"r": "130",
			"m": 96,
			"y": "2016"
		},
		"COD": {
			"v": 3.45,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 3.62,
			"r": "100",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.07,
			"r": "79",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.07,
			"r": "80",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.46,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 4.12,
			"r": "76",
			"m": 104,
			"y": "2016"
		},
		"HTI": null,
		"IRL": {
			"v": 4.33,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.6,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 4.11,
			"r": "77",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.84,
			"r": "23",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.7,
			"r": "97",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.57,
			"r": "31",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.36,
			"r": "52",
			"m": 59,
			"y": "2016"
		},
		"MLI": {
			"v": 4.45,
			"r": "46",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 2.69,
			"r": "118",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 4.17,
			"r": "71",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.55,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 5.33,
			"r": "12",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 4.36,
			"r": "53",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 2,
			"r": "134",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 5.57,
			"r": "9",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.28,
			"r": "61",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.56,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 2.33,
			"r": "125",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.56,
			"r": "33",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.97,
			"r": "18",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 4.04,
			"r": "81",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 2.69,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 4.27,
			"r": "62",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 4.13,
			"r": "75",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.76,
			"r": "94",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 2.16,
			"r": "129",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.27,
			"r": "64",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 2.38,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 2.57,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 3.91,
			"r": "88",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 2.02,
			"r": "133",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 5.23,
			"r": "14",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 4.18,
			"r": "69",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.28,
			"r": "110",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 4.02,
			"r": "84",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 4.09,
			"r": "78",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.32,
			"r": "57",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.05,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 5.49,
			"r": "10",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.55,
			"r": "36",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.14,
			"r": "73",
			"m": 101,
			"y": "2016"
		},
		"SLE": {
			"v": 3.97,
			"r": "85",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 2.12,
			"r": "131",
			"m": 75,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 4.29,
			"r": "60",
			"m": 86,
			"y": "2016"
		},
		"MMR": null,
		"REU": null,
		"ZWE": {
			"v": 4.4,
			"r": "50",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 2.08,
			"r": "132",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.36,
			"r": "11",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 4.27,
			"r": "63",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 2.53,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 5.62,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.97,
			"r": "4",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 2.79,
			"r": "115",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 3.16,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 1.97,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"ETI_SECURITY": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 12": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"SUN-CUSTSERVIND": {
		"UNK": null,
		"NOR": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 4.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 3.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 3.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 4.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 4.55,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 4.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 2.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 4.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 5.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 3.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 5.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 4.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 5.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 3.79,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 3.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 4.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 5.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 4.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 5.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.43,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 5.21,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 2.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 2.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 3.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 3.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.32,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 5.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 2.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 5.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 3.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 2.35,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 3.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 5.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 5.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 4.41,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 6.5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 3.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 5.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 3.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 4.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 5.12,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 5.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.9,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.25,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 4.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 2.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.86,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 2.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 4.04,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.17,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 2.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.6,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 3.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 5.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"ETIC0403": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"TFA Article 10": {
		"UNK": null,
		"NOR": null,
		"HRV": null,
		"VEN": null,
		"TON": null,
		"CZE": null,
		"BDI": null,
		"BHR": null,
		"ETH": null,
		"ECU": null,
		"FRA": null,
		"SJM": null,
		"KOR": null,
		"AZE": null,
		"JAM": null,
		"SLB": null,
		"URY": null,
		"MLT": null,
		"BVT": null,
		"GTM": null,
		"MYS": null,
		"PSE": null,
		"PCN": null,
		"ARM": null,
		"PRI": null,
		"MOZ": null,
		"NIC": null,
		"MKD": null,
		"ISR": null,
		"KHM": null,
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": null,
		"COK": null,
		"KEN": null,
		"COM": null,
		"LSO": null,
		"MEX": null,
		"SLV": null,
		"CYM": null,
		"LTU": null,
		"ROU": null,
		"BRN": null,
		"CHL": null,
		"LVA": null,
		"YEM": null,
		"CPV": null,
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": null,
		"PRT": null,
		"SGS": null,
		"FIN": null,
		"NPL": null,
		"SOM": null,
		"VCT": null,
		"UGA": null,
		"LBR": null,
		"MNE": null,
		"IRN": null,
		"SPM": null,
		"MWI": null,
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": null,
		"BGR": null,
		"CUB": null,
		"PAK": null,
		"IMN": null,
		"THA": null,
		"KGZ": null,
		"LBY": null,
		"CHE": null,
		"MAC": null,
		"BRA": null,
		"JOR": null,
		"FRO": null,
		"MNP": null,
		"CRI": null,
		"RWA": null,
		"ATA": null,
		"SVN": null,
		"GUY": null,
		"SUR": null,
		"DOM": null,
		"CUW": null,
		"TTO": null,
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": null,
		"SYR": null,
		"BEL": null,
		"GAB": null,
		"TJK": null,
		"AUS": null,
		"UMI": null,
		"AIA": null,
		"MAR": null,
		"PNG": null,
		"HUN": null,
		"SYC": null,
		"CIV": null,
		"ABW": null,
		"ESP": null,
		"GUF": null,
		"TKL": null,
		"BTN": null,
		"ARG": null,
		"GBR": null,
		"SXM": null,
		"KAZ": null,
		"BWA": null,
		"MDA": null,
		"CXR": null,
		"IDN": null,
		"DNK": null,
		"HND": null,
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": null,
		"BOL": null,
		"NFK": null,
		"HKG": null,
		"COD": null,
		"ZAF": null,
		"VNM": null,
		"CYP": null,
		"TCA": null,
		"SVK": null,
		"NER": null,
		"TCD": null,
		"HTI": null,
		"IRL": null,
		"IRQ": null,
		"POL": null,
		"DJI": null,
		"LIE": null,
		"SWE": null,
		"PLW": null,
		"GMB": null,
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": null,
		"GRC": null,
		"FSM": null,
		"ALB": null,
		"MLI": null,
		"OMN": null,
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": null,
		"NLD": null,
		"BGD": null,
		"AUT": null,
		"QAT": null,
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": null,
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": null,
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": null,
		"LCA": null,
		"SAU": null,
		"GRL": null,
		"GEO": null,
		"MYT": null,
		"ZMB": null,
		"MRT": null,
		"DMA": null,
		"BFA": null,
		"IND": null,
		"TUN": null,
		"SRB": null,
		"GHA": null,
		"RUS": null,
		"EST": null,
		"SMR": null,
		"CHN": null,
		"NIU": null,
		"USA": null,
		"ATF": null,
		"BMU": null,
		"TUR": null,
		"JPN": null,
		"PER": null,
		"VIR": null,
		"DEU": null,
		"STP": null,
		"UKR": null,
		"SGP": null,
		"GRD": null,
		"BEN": null,
		"COL": null,
		"MCO": null,
		"ISL": null,
		"LAO": null,
		"FLK": null,
		"LUX": null,
		"ERI": null,
		"NAM": null,
		"SLE": null,
		"ARE": null,
		"GNB": null,
		"BIH": null,
		"MMR": null,
		"REU": null,
		"ZWE": null,
		"KWT": null,
		"ESH": null,
		"SEN": null,
		"CMR": null,
		"MNG": null,
		"TLS": null,
		"TZA": null,
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": null,
		"BLM": null,
		"CAN": null,
		"NZL": null,
		"TWN": null,
		"BRB": null,
		"MHL": null,
		"AND": null
	},
	"EOSQ353": {
		"UNK": null,
		"NOR": {
			"v": 5.41,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 4.57,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 2.65,
			"r": "119",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 3.36,
			"r": "97",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.33,
			"r": "123",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.09,
			"r": "30",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.54,
			"r": "90",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 4.73,
			"r": "40",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 5.28,
			"r": "23",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 5.21,
			"r": "27",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.31,
			"r": "59",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.71,
			"r": "41",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.79,
			"r": "39",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 5.25,
			"r": "25",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 3.69,
			"r": "86",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.44,
			"r": "17",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 2.37,
			"r": "122",
			"m": 79,
			"y": "2016"
		},
		"PRI": {
			"v": 5.43,
			"r": "22",
			"m": 103,
			"y": "2014"
		},
		"MOZ": {
			"v": 3.51,
			"r": "92",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 2.84,
			"r": "116",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 3.8,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.49,
			"r": "50",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 3.85,
			"r": "76",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 2.92,
			"r": "113",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.19,
			"r": "64",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.71,
			"r": "120",
			"m": 100,
			"y": "2014"
		},
		"MEX": {
			"v": 4.37,
			"r": "57",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 3.51,
			"r": "91",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.92,
			"r": "33",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.36,
			"r": "98",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 3.67,
			"r": "87",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 4.92,
			"r": "34",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 5.06,
			"r": "32",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.59,
			"r": "120",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.44,
			"r": "95",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": 2.68,
			"r": "121",
			"m": 17,
			"y": "2014"
		},
		"NGA": {
			"v": 2.82,
			"r": "117",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 5.15,
			"r": "29",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.25,
			"r": "7",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 1.33,
			"r": "136",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 2.5,
			"r": "121",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.5,
			"r": "93",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 4.02,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.93,
			"r": "73",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 2.15,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": {
			"v": 3.34,
			"r": "115",
			"m": 88,
			"y": "2011"
		},
		"EGY": {
			"v": 4.33,
			"r": "58",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.01,
			"r": "70",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.73,
			"r": "84",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 4.18,
			"r": "65",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 1.48,
			"r": "135",
			"m": 97,
			"y": "2016"
		},
		"LBY": {
			"v": 2.56,
			"r": "131",
			"m": 100,
			"y": "2014"
		},
		"CHE": {
			"v": 4.38,
			"r": "55",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 2.91,
			"r": "114",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.51,
			"r": "49",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 3.21,
			"r": "102",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 3.18,
			"r": "104",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 5.08,
			"r": "31",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 3.62,
			"r": "87",
			"m": 96,
			"y": "2015"
		},
		"SUR": {
			"v": 4.45,
			"r": "56",
			"m": 104,
			"y": "2014"
		},
		"DOM": {
			"v": 4.55,
			"r": "46",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 3.76,
			"r": "81",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.3,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"SYR": {
			"v": 3.36,
			"r": "112",
			"m": 104,
			"y": "2011"
		},
		"BEL": {
			"v": 6.3,
			"r": "6",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.23,
			"r": "101",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 2.01,
			"r": "133",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 4.86,
			"r": "36",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 4.82,
			"r": "38",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.2,
			"r": "103",
			"m": 96,
			"y": "2016"
		},
		"SYC": {
			"v": 4.96,
			"r": "34",
			"m": 104,
			"y": "2014"
		},
		"CIV": {
			"v": 5.17,
			"r": "28",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 5.52,
			"r": "16",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 1.86,
			"r": "134",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 3.8,
			"r": "79",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.6,
			"r": "12",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 3.13,
			"r": "107",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 3.02,
			"r": "109",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 2.18,
			"r": "127",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 3.91,
			"r": "75",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 5.73,
			"r": "9",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.49,
			"r": "51",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": 2.95,
			"r": "113",
			"m": 95,
			"y": "2014"
		},
		"CAF": null,
		"LKA": {
			"v": 4.26,
			"r": "60",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 2.24,
			"r": "126",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.35,
			"r": "4",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 2.27,
			"r": "124",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 4.85,
			"r": "37",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 3.84,
			"r": "77",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 4.25,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 3.01,
			"r": "110",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.04,
			"r": "131",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 2.56,
			"r": "123",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 5.23,
			"r": "26",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.13,
			"r": "66",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.6,
			"r": "13",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.03,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.17,
			"r": "105",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 4.54,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 4.22,
			"r": "62",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 2.27,
			"r": "125",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.58,
			"r": "44",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 3.45,
			"r": "95",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 4.37,
			"r": "56",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 6.78,
			"r": "1",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 3.54,
			"r": "89",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 3.92,
			"r": "74",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.53,
			"r": "15",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.21,
			"r": "63",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 3.78,
			"r": "80",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 3.11,
			"r": "108",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.64,
			"r": "42",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 3.98,
			"r": "71",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 2.18,
			"r": "128",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.87,
			"r": "115",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": 3.13,
			"r": "111",
			"m": 85,
			"y": "2014"
		},
		"IND": {
			"v": 4.53,
			"r": "48",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.31,
			"r": "100",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 2.75,
			"r": "118",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.75,
			"r": "82",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.98,
			"r": "72",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 5.58,
			"r": "14",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.59,
			"r": "43",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.7,
			"r": "10",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.49,
			"r": "52",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.32,
			"r": "22",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 3.56,
			"r": "88",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.62,
			"r": "11",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.41,
			"r": "96",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.66,
			"r": "2",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.71,
			"r": "85",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 3.74,
			"r": "83",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 5.88,
			"r": "8",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 2.01,
			"r": "132",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 4.43,
			"r": "53",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 5.25,
			"r": "24",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.01,
			"r": "111",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 6.38,
			"r": "3",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 2.16,
			"r": "129",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.62,
			"r": "122",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.16,
			"r": "106",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.06,
			"r": "67",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 4.43,
			"r": "54",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 2.96,
			"r": "112",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 1.3,
			"r": "137",
			"m": 100,
			"y": "2016"
		},
		"TLS": {
			"v": 2.15,
			"r": "138",
			"m": 104,
			"y": "2014"
		},
		"TZA": {
			"v": 3.35,
			"r": "99",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.46,
			"r": "94",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 5.4,
			"r": "19",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.33,
			"r": "21",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.34,
			"r": "20",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.91,
			"r": "35",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"EOSQ468": {
		"UNK": null,
		"NOR": {
			"v": 5.74,
			"r": "7",
			"m": 103,
			"y": "2016"
		},
		"HRV": {
			"v": 3.56,
			"r": "114",
			"m": 96,
			"y": "2016"
		},
		"VEN": {
			"v": 3.81,
			"r": "97",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 4.98,
			"r": "27",
			"m": 92,
			"y": "2016"
		},
		"BDI": {
			"v": 2.72,
			"r": "134",
			"m": 81,
			"y": "2016"
		},
		"BHR": {
			"v": 5.13,
			"r": "25",
			"m": 86,
			"y": "2016"
		},
		"ETH": {
			"v": 3.58,
			"r": "113",
			"m": 94,
			"y": "2016"
		},
		"ECU": {
			"v": 3.88,
			"r": "93",
			"m": 94,
			"y": "2016"
		},
		"FRA": {
			"v": 4.81,
			"r": "33",
			"m": 94,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 4.07,
			"r": "81",
			"m": 97,
			"y": "2016"
		},
		"AZE": {
			"v": 4.53,
			"r": "51",
			"m": 81,
			"y": "2016"
		},
		"JAM": {
			"v": 4.26,
			"r": "67",
			"m": 96,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 4.34,
			"r": "63",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 4.87,
			"r": "29",
			"m": 100,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 5.24,
			"r": "21",
			"m": 96,
			"y": "2016"
		},
		"MYS": {
			"v": 5.38,
			"r": "15",
			"m": 101,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 3.78,
			"r": "99",
			"m": 79,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 3.38,
			"r": "124",
			"m": 100,
			"y": "2016"
		},
		"NIC": {
			"v": 3.87,
			"r": "94",
			"m": 103,
			"y": "2015"
		},
		"MKD": {
			"v": 4.18,
			"r": "69",
			"m": 100,
			"y": "2016"
		},
		"ISR": {
			"v": 4.86,
			"r": "30",
			"m": 96,
			"y": "2016"
		},
		"KHM": {
			"v": 4.13,
			"r": "74",
			"m": 97,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.68,
			"r": "38",
			"m": 103,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 4.46,
			"r": "59",
			"m": 97,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 2.44,
			"r": "137",
			"m": 100,
			"y": "2016"
		},
		"MEX": {
			"v": 4.09,
			"r": "78",
			"m": 100,
			"y": "2016"
		},
		"SLV": {
			"v": 4.54,
			"r": "50",
			"m": 104,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 4.66,
			"r": "40",
			"m": 100,
			"y": "2016"
		},
		"ROU": {
			"v": 3.38,
			"r": "125",
			"m": 103,
			"y": "2016"
		},
		"BRN": {
			"v": 4.01,
			"r": "87",
			"m": 91,
			"y": "2016"
		},
		"CHL": {
			"v": 5.35,
			"r": "17",
			"m": 91,
			"y": "2016"
		},
		"LVA": {
			"v": 4.48,
			"r": "55",
			"m": 100,
			"y": "2016"
		},
		"YEM": {
			"v": 2.52,
			"r": "136",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": 3.47,
			"r": "118",
			"m": 92,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": null,
		"NGA": {
			"v": 3.73,
			"r": "101",
			"m": 102,
			"y": "2016"
		},
		"PRT": {
			"v": 4.49,
			"r": "53",
			"m": 103,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 5.56,
			"r": "9",
			"m": 94,
			"y": "2016"
		},
		"NPL": {
			"v": 4.09,
			"r": "77",
			"m": 103,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 4.03,
			"r": "84",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 3.75,
			"r": "100",
			"m": 99,
			"y": "2016"
		},
		"MNE": {
			"v": 3.53,
			"r": "116",
			"m": 100,
			"y": "2016"
		},
		"IRN": {
			"v": 3.47,
			"r": "117",
			"m": 96,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 3.54,
			"r": "115",
			"m": 100,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 4.49,
			"r": "54",
			"m": 94,
			"y": "2015"
		},
		"BGR": {
			"v": 4.47,
			"r": "57",
			"m": 86,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.72,
			"r": "102",
			"m": 103,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 5.15,
			"r": "23",
			"m": 104,
			"y": "2016"
		},
		"KGZ": {
			"v": 3.47,
			"r": "119",
			"m": 97,
			"y": "2016"
		},
		"LBY": null,
		"CHE": {
			"v": 5.95,
			"r": "3",
			"m": 91,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 3.89,
			"r": "92",
			"m": 89,
			"y": "2016"
		},
		"JOR": {
			"v": 4.59,
			"r": "46",
			"m": 96,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 4.15,
			"r": "72",
			"m": 92,
			"y": "2016"
		},
		"RWA": {
			"v": 4.26,
			"r": "66",
			"m": 104,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 3.66,
			"r": "106",
			"m": 104,
			"y": "2016"
		},
		"GUY": {
			"v": 4.03,
			"r": "82",
			"m": 96,
			"y": "2015"
		},
		"SUR": null,
		"DOM": {
			"v": 4.47,
			"r": "56",
			"m": 92,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 4.13,
			"r": "73",
			"m": 104,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 5.76,
			"r": "5",
			"m": 103,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 5.47,
			"r": "12",
			"m": 82,
			"y": "2016"
		},
		"GAB": {
			"v": 3.41,
			"r": "122",
			"m": 94,
			"y": "2016"
		},
		"TJK": {
			"v": 4.17,
			"r": "70",
			"m": 104,
			"y": "2016"
		},
		"AUS": {
			"v": 5.13,
			"r": "24",
			"m": 80,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 3.85,
			"r": "95",
			"m": 100,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 3.98,
			"r": "89",
			"m": 96,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 3.67,
			"r": "104",
			"m": 92,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 4.03,
			"r": "83",
			"m": 94,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 4.11,
			"r": "75",
			"m": 91,
			"y": "2016"
		},
		"ARG": {
			"v": 2.95,
			"r": "133",
			"m": 77,
			"y": "2016"
		},
		"GBR": {
			"v": 5.27,
			"r": "19",
			"m": 95,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 4.07,
			"r": "80",
			"m": 97,
			"y": "2016"
		},
		"BWA": {
			"v": 4.28,
			"r": "65",
			"m": 91,
			"y": "2016"
		},
		"MDA": {
			"v": 3.44,
			"r": "121",
			"m": 100,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.81,
			"r": "34",
			"m": 96,
			"y": "2016"
		},
		"DNK": {
			"v": 4.83,
			"r": "31",
			"m": 92,
			"y": "2016"
		},
		"HND": {
			"v": 4.58,
			"r": "47",
			"m": 96,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": null,
		"CAF": null,
		"LKA": {
			"v": 4.64,
			"r": "41",
			"m": 100,
			"y": "2016"
		},
		"BOL": {
			"v": 4.67,
			"r": "39",
			"m": 88,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 5.97,
			"r": "1",
			"m": 96,
			"y": "2015"
		},
		"COD": {
			"v": 3.16,
			"r": "129",
			"m": 92,
			"y": "2016"
		},
		"ZAF": {
			"v": 5.97,
			"r": "2",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 4.06,
			"r": "82",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 3.79,
			"r": "98",
			"m": 92,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 4.72,
			"r": "36",
			"m": 104,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 2.7,
			"r": "135",
			"m": 104,
			"y": "2016"
		},
		"HTI": {
			"v": 3.23,
			"r": "125",
			"m": 96,
			"y": "2015"
		},
		"IRL": {
			"v": 4.23,
			"r": "68",
			"m": 96,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 4.56,
			"r": "48",
			"m": 103,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 5.63,
			"r": "8",
			"m": 104,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 4.02,
			"r": "85",
			"m": 96,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 3.07,
			"r": "131",
			"m": 93,
			"y": "2016"
		},
		"GRC": {
			"v": 2.99,
			"r": "132",
			"m": 96,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 3.61,
			"r": "110",
			"m": 66,
			"y": "2016"
		},
		"MLI": {
			"v": 3.29,
			"r": "128",
			"m": 100,
			"y": "2016"
		},
		"OMN": {
			"v": 4.62,
			"r": "42",
			"m": 103,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": {
			"v": 4,
			"r": "83",
			"m": 104,
			"y": "2015"
		},
		"BLR": null,
		"ITA": {
			"v": 3.47,
			"r": "120",
			"m": 96,
			"y": "2016"
		},
		"NLD": {
			"v": 4.73,
			"r": "35",
			"m": 103,
			"y": "2016"
		},
		"BGD": {
			"v": 4.02,
			"r": "86",
			"m": 86,
			"y": "2016"
		},
		"AUT": {
			"v": 5.25,
			"r": "20",
			"m": 80,
			"y": "2016"
		},
		"QAT": {
			"v": 5.28,
			"r": "18",
			"m": 103,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 4.62,
			"r": "43",
			"m": 100,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 4.5,
			"r": "52",
			"m": 99,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 4.35,
			"r": "62",
			"m": 103,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.6,
			"r": "44",
			"m": 104,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 4.09,
			"r": "79",
			"m": 95,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4,
			"r": "88",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 2.27,
			"r": "138",
			"m": 100,
			"y": "2016"
		},
		"DMA": null,
		"BFA": null,
		"IND": {
			"v": 4.59,
			"r": "45",
			"m": 96,
			"y": "2016"
		},
		"TUN": {
			"v": 3.62,
			"r": "109",
			"m": 104,
			"y": "2016"
		},
		"SRB": {
			"v": 3.66,
			"r": "108",
			"m": 104,
			"y": "2016"
		},
		"GHA": {
			"v": 3.97,
			"r": "90",
			"m": 95,
			"y": "2016"
		},
		"RUS": {
			"v": 3.6,
			"r": "111",
			"m": 103,
			"y": "2016"
		},
		"EST": {
			"v": 4.92,
			"r": "28",
			"m": 94,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 4.34,
			"r": "64",
			"m": 92,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 5.75,
			"r": "6",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 4.44,
			"r": "60",
			"m": 104,
			"y": "2016"
		},
		"JPN": {
			"v": 5.36,
			"r": "16",
			"m": 96,
			"y": "2016"
		},
		"PER": {
			"v": 4.81,
			"r": "32",
			"m": 103,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 5.23,
			"r": "22",
			"m": 92,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.59,
			"r": "112",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 5.84,
			"r": "4",
			"m": 104,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 3.66,
			"r": "105",
			"m": 83,
			"y": "2016"
		},
		"COL": {
			"v": 4.41,
			"r": "61",
			"m": 92,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 4.71,
			"r": "37",
			"m": 96,
			"y": "2016"
		},
		"LAO": {
			"v": 4.15,
			"r": "71",
			"m": 98,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 5.55,
			"r": "10",
			"m": 100,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 4.55,
			"r": "49",
			"m": 102,
			"y": "2016"
		},
		"SLE": {
			"v": 3.34,
			"r": "127",
			"m": 104,
			"y": "2016"
		},
		"ARE": {
			"v": 5.4,
			"r": "13",
			"m": 76,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 3.39,
			"r": "123",
			"m": 86,
			"y": "2016"
		},
		"MMR": {
			"v": 2.83,
			"r": "131",
			"m": 100,
			"y": "2015"
		},
		"REU": null,
		"ZWE": {
			"v": 3.37,
			"r": "126",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.46,
			"r": "58",
			"m": 98,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 3.66,
			"r": "107",
			"m": 104,
			"y": "2016"
		},
		"CMR": {
			"v": 3.96,
			"r": "91",
			"m": 92,
			"y": "2016"
		},
		"MNG": {
			"v": 3.13,
			"r": "130",
			"m": 100,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 3.83,
			"r": "96",
			"m": 104,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 3.67,
			"r": "103",
			"m": 100,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 4.98,
			"r": "26",
			"m": 91,
			"y": "2016"
		},
		"NZL": {
			"v": 5.54,
			"r": "11",
			"m": 103,
			"y": "2016"
		},
		"TWN": {
			"v": 5.38,
			"r": "14",
			"m": 104,
			"y": "2016"
		},
		"BRB": {
			"v": 4.1,
			"r": "76",
			"m": 90,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	},
	"SUN-TABTIMEIMPDOC": {
		"UNK": null,
		"NOR": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HRV": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VEN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TON": null,
		"CZE": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BDI": {
			"v": 3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BHR": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ETH": {
			"v": 2.36,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ECU": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SJM": null,
		"KOR": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AZE": {
			"v": 6.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JAM": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLB": null,
		"URY": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLT": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BVT": null,
		"GTM": {
			"v": 6.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYS": {
			"v": 6.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PSE": null,
		"PCN": null,
		"ARM": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRI": null,
		"MOZ": {
			"v": 6.46,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIC": {
			"v": 6.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MKD": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ISR": {
			"v": 6.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KHM": {
			"v": 4.07,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PYF": null,
		"MDV": null,
		"SDN": null,
		"KIR": null,
		"PHL": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COK": null,
		"KEN": {
			"v": 5.13,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COM": null,
		"LSO": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MEX": {
			"v": 6.61,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLV": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYM": null,
		"LTU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ROU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRN": {
			"v": 3.89,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHL": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LVA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"YEM": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CPV": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUV": null,
		"BHS": null,
		"AGO": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NGA": {
			"v": 3.16,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PRT": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGS": null,
		"FIN": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NPL": {
			"v": 5.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SOM": null,
		"VCT": null,
		"UGA": {
			"v": 3.92,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBR": {
			"v": 2.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNE": {
			"v": 6.77,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRN": {
			"v": 1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SPM": null,
		"MWI": {
			"v": 5.59,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IOT": null,
		"MAF": null,
		"BLZ": null,
		"EGY": {
			"v": 1.11,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGR": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUB": null,
		"PAK": {
			"v": 3.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IMN": null,
		"THA": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KGZ": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LBY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CHE": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MAC": null,
		"BRA": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JOR": {
			"v": 5.78,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FRO": null,
		"MNP": null,
		"CRI": {
			"v": 6.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RWA": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATA": null,
		"SVN": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUY": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SUR": null,
		"DOM": {
			"v": 6.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CUW": null,
		"TTO": {
			"v": 6.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CCK": null,
		"GNQ": null,
		"GGY": null,
		"GLP": null,
		"UZB": null,
		"PAN": {
			"v": 6.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYR": null,
		"BEL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GAB": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TJK": {
			"v": 4.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUS": {
			"v": 6.91,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"UMI": null,
		"AIA": null,
		"MAR": {
			"v": 6.42,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PNG": null,
		"HUN": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SYC": null,
		"CIV": {
			"v": 5.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ABW": null,
		"ESP": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GUF": null,
		"TKL": null,
		"BTN": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARG": {
			"v": 2.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GBR": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SXM": null,
		"KAZ": {
			"v": 6.88,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BWA": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MDA": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CXR": null,
		"IDN": {
			"v": 4.05,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DNK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HND": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VGB": null,
		"VAT": null,
		"GIN": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CAF": null,
		"LKA": {
			"v": 5.71,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BOL": {
			"v": 4.87,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NFK": null,
		"HKG": {
			"v": 6.97,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COD": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ZAF": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VNM": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CYP": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TCA": null,
		"SVK": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NER": null,
		"TCD": {
			"v": 3.18,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"HTI": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRL": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IRQ": null,
		"POL": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DJI": null,
		"LIE": null,
		"SWE": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PLW": null,
		"GMB": {
			"v": 6.3,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TKM": null,
		"ALA": null,
		"GUM": null,
		"DZA": {
			"v": 1.47,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRC": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FSM": null,
		"ALB": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MLI": {
			"v": 5.29,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"OMN": {
			"v": 6.49,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NCL": null,
		"MTQ": null,
		"JEY": null,
		"SWZ": null,
		"BLR": null,
		"ITA": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NLD": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BGD": {
			"v": 3.8,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"AUT": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"QAT": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FJI": null,
		"SSD": null,
		"VUT": null,
		"TGO": null,
		"NRU": null,
		"HMD": null,
		"WSM": null,
		"MUS": {
			"v": 6.81,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATG": null,
		"AFG": null,
		"COG": null,
		"LBN": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MSR": null,
		"PRK": null,
		"KNA": null,
		"PRY": {
			"v": 6.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LCA": null,
		"SAU": {
			"v": 4.09,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRL": null,
		"GEO": {
			"v": 6.96,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MYT": null,
		"ZMB": {
			"v": 4.02,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MRT": {
			"v": 5.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"DMA": null,
		"BFA": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"IND": {
			"v": 5.64,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TUN": {
			"v": 6.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SRB": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GHA": {
			"v": 5.31,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"RUS": {
			"v": 6.06,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"EST": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SMR": null,
		"CHN": {
			"v": 5.54,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NIU": null,
		"USA": {
			"v": 6.83,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ATF": null,
		"BMU": null,
		"TUR": {
			"v": 6.75,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"JPN": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"PER": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"VIR": null,
		"DEU": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"STP": null,
		"UKR": {
			"v": 3.27,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SGP": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GRD": null,
		"BEN": {
			"v": 5.7,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"COL": {
			"v": 5.58,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MCO": null,
		"ISL": {
			"v": 6.94,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"LAO": {
			"v": 2.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"FLK": null,
		"LUX": {
			"v": 6.99,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ERI": null,
		"NAM": {
			"v": 6.93,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"SLE": {
			"v": 3.95,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ARE": {
			"v": 6.73,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GNB": null,
		"BIH": {
			"v": 6.82,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MMR": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"REU": null,
		"ZWE": {
			"v": 5.2,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"KWT": {
			"v": 4.33,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"ESH": null,
		"SEN": {
			"v": 5.4,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"CMR": {
			"v": 3.38,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MNG": {
			"v": 4.45,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TLS": null,
		"TZA": {
			"v": 1.67,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"GIB": null,
		"WLF": null,
		"ASM": null,
		"MDG": {
			"v": 5.72,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BLM": null,
		"CAN": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"NZL": {
			"v": 6.98,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"TWN": {
			"v": 6.1,
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"BRB": {
			"v": "n/a",
			"r": "n/a",
			"m": 105,
			"y": "2016"
		},
		"MHL": null,
		"AND": null
	}
};

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getJsonData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);


// Extract only body from response, when other stuff like response
// headers and so on are useless
var extractBody = function extractBody(_ref) {
  var body = _ref.body;
  return body;
};

var getJsonData = function getJsonData(filename) {
  return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get(filename).then(extractBody);
};

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autocomplete__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var menuStyle = {
  backgroundColor: '#fff',
  padding: '2px 0',
  magin: '0px',
  position: 'absolute',
  overflow: 'auto',
  maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
  color: "#222",
  width: "auto",
  fontSize: '14px',
  border: "solid #ccc 1px",
  borderTop: "none"
};

var DataExplorerSearch = function (_React$PureComponent) {
  _inherits(DataExplorerSearch, _React$PureComponent);

  function DataExplorerSearch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataExplorerSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataExplorerSearch.__proto__ || Object.getPrototypeOf(DataExplorerSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DataExplorerSearch, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          countries = _props.countries,
          indicators = _props.indicators,
          tfaMeta = _props.tfaMeta,
          _props$inputProps = _props.inputProps,
          inputProps = _props$inputProps === undefined ? {} : _props$inputProps;

      var value = this.state.value;

      var itemsCountries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["keys"])(countries).map(function (code) {
        return { group: 'COUNTRY', label: countries[code], value: code, search: [code, countries[code]], path: '/countries/' + code };
      });

      var itemsTfa = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["keys"])(tfaMeta).map(function (code) {
        return { group: 'TFA', label: 'Article ' + code, value: code, search: [code, 'Article ' + code], path: '/tfa/' + code };
      });

      var itemsIndicators = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["keys"])(indicators).map(function (code) {
        return { group: 'WEF', label: indicators[code].shortTitle, value: code, search: [code, indicators[code].shortTitle], path: '/topics/' + code };
      }).filter(function (x) {
        return x.label;
      });

      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sortBy"])(itemsCountries.concat(itemsIndicators).concat(itemsTfa), 'label');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_autocomplete___default.a, {
        getItemValue: function getItemValue(item) {
          return item.value;
        },
        menuStyle: menuStyle,
        inputProps: inputProps,
        items: items.sort(function (i) {
          return i.label;
        }),
        shouldItemRender: function shouldItemRender(item, value) {
          var truthy = item.search.map(function (x) {
            return x.toLowerCase().indexOf(value.toLowerCase()) !== -1;
          });
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["some"])(truthy);
        },
        renderItem: function renderItem(item, isHighlighted) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
            { className: 'no-underline link-blue', to: item.path },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pa1', style: { background: isHighlighted ? 'lightgray' : '#fff' } },
              '[',
              item.group,
              '] ',
              item.label
            )
          );
        },
        value: value,
        onChange: function onChange(e) {
          return _this2.setState({ value: e.target.value });
        },
        onSelect: function onSelect(val) {}

      });
    }
  }]);

  return DataExplorerSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    tfaMeta: state.tfaMeta
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(DataExplorerSearch));

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var d3 = __webpack_require__(40);

var Oline = __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__["Origin"].wrapBy('line');

var DistributionChart = function (_React$PureComponent) {
  _inherits(DistributionChart, _React$PureComponent);

  function DistributionChart() {
    _classCallCheck(this, DistributionChart);

    return _possibleConstructorReturn(this, (DistributionChart.__proto__ || Object.getPrototypeOf(DistributionChart)).apply(this, arguments));
  }

  _createClass(DistributionChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          distributionData = _props.distributionData,
          indicators = _props.indicators,
          countries = _props.countries,
          indicator = _props.indicator,
          countryCode = _props.countryCode,
          _props$height = _props.height,
          height = _props$height === undefined ? 50 : _props$height,
          containerWidth = _props.containerWidth;


      var countryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(distributionData);
      var plotData = countryCodes.map(function (country) {
        return distributionData[country] ? Object.assign({
          country: country
        }, distributionData[country]) : null;
      }).filter(function (datum) {
        return datum && datum.v !== null;
      });

      if (!plotData.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          '\xA0'
        );
      }

      //SCALE direction depends on indicator "rankDirection"
      var rangeForIndicator = void 0;
      if (indicators[indicator].rankDirection === "0") {
        rangeForIndicator = [1, containerWidth - 1];
      } else {
        rangeForIndicator = [containerWidth - 1, 1];
      }
      var plotDataValues = plotData.map(function (datum) {
        return datum.v;
      }
      //const scale = d3.scaleLinear().domain(indicators[indicator].domain).range(rangeForIndicator)
      );var scale = d3.scaleLinear().domain([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["min"])(plotDataValues), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(plotDataValues)]).range(rangeForIndicator);

      var countryValue = void 0,
          countryValueScaled = void 0;
      // let countryValueIdx=-1
      if (countryCode) {
        // countryValueIdx =  findIndex(dataByIndicator, datum => datum.country === countryCode)
        // if(countryValueIdx !== -1){
        //     countryValue = dataByIndicator[countryValueIdx]
        //     countryValueScaled = scale(countryValue.v)
        // }
        countryValue = distributionData[countryCode];
        countryValueScaled = scale(countryValue.v);
      }

      var avgValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["mean"])(plotDataValues).toFixed(2);
      var avgValueScaled = scale(avgValue);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { height: height, className: 'DistributionChart__svg' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { height: height, width: containerWidth - 1, className: 'DistributionChart__rect' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          plotData.map(function (datum, i) {
            var scaledX = scale(datum.v);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Oline, { key: i, x1: scaledX, x2: scaledX, y1: 0, y2: height, className: 'line-others', content: countries[datum.country] + ': ' + datum.v + ' (' + datum.y + ')' });
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          countryValueScaled !== undefined && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Oline, { x1: countryValueScaled, x2: countryValueScaled, y1: 0, y2: height, className: 'line-selected', content: countries[countryCode] + ': ' + countryValue.v + ' (' + countryValue.y + ')' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Oline, { x1: avgValueScaled, x2: avgValueScaled, y1: 0, y2: height, className: 'line-avg', content: 'Average: ' + avgValue })
        )
      );
    }
  }]);

  return DistributionChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    //dataByIndicator : getLastDataByIndicator(state, props),
    indicators: state.indicators,
    countries: state.countries
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3_react_dimensions___default()({ containerStyle: { width: '100%', height: '100%' } })(DistributionChart)));

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BLUE_TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StarChartBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_scale__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_save_svg_as_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_csvdownload__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Opolyline = __WEBPACK_IMPORTED_MODULE_7_redux_tooltip__["Origin"].wrapBy('polyline');

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    tfaMeta: state.tfaMeta
  };
};

var BLUE_TOPICS = ['inf_availability', 'inv_community', 'adv_rulings', 'appeal_proc', 'fees_charges', 'form_docs', 'form_auto', 'form_proc', 'int_cooperation', 'ext_cooperation', 'gov_impartiality'];

var Ray = function Ray(_ref) {
  var className = _ref.className,
      content = _ref.content,
      centerX = _ref.centerX,
      centerY = _ref.centerY,
      angle = _ref.angle,
      radius = _ref.radius,
      rayBase = _ref.rayBase,
      notFocused = _ref.notFocused;


  var x2 = centerX + Math.cos(angle) * radius;
  var y2 = centerY + Math.sin(angle) * radius;

  var xb2 = centerX + Math.cos(angle + Math.PI / 2) * rayBase;
  var yb2 = centerY + Math.sin(angle + Math.PI / 2) * rayBase;

  var xb1 = centerX + Math.cos(angle - Math.PI / 2) * rayBase;
  var yb1 = centerY + Math.sin(angle - Math.PI / 2) * rayBase;

  var points = xb1 + ',' + yb1 + ' ' + xb2 + ',' + yb2 + ' ' + xb2 + ',' + yb2 + ' ' + x2 + ',' + y2 + ' ' + x2 + ',' + y2 + ' ' + xb1 + ',' + yb1;
  var opacity = notFocused ? 0.3 : 1;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Opolyline, { points: points, className: className, content: content, style: { fillOpacity: opacity, strokeOpacity: opacity } });
};

var StarChartBlock_ = function (_React$PureComponent) {
  _inherits(StarChartBlock_, _React$PureComponent);

  function StarChartBlock_() {
    _classCallCheck(this, StarChartBlock_);

    return _possibleConstructorReturn(this, (StarChartBlock_.__proto__ || Object.getPrototypeOf(StarChartBlock_)).apply(this, arguments));
  }

  _createClass(StarChartBlock_, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          indicators = _props.indicators,
          tfaMeta = _props.tfaMeta,
          latestDataByIndicator = _props.latestDataByIndicator,
          tfaArticles = _props.tfaArticles,
          countryCode = _props.countryCode,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? 10 : _props$margin,
          _props$blueTopics = _props.blueTopics,
          blueTopics = _props$blueTopics === undefined ? BLUE_TOPICS : _props$blueTopics,
          _props$inlineColor = _props.inlineColor,
          inlineColor = _props$inlineColor === undefined ? null : _props$inlineColor,
          focusedOptions = _props.focusedOptions,
          containerWidth = _props.containerWidth;


      if (!indicators || !tfaArticles) {
        return null;
      }

      var allIndicators = blueTopics; //.concat(redTopics)
      var width = containerWidth - margin * 2;
      var maxRadius = width / 2;
      var centerX = containerWidth / 2;
      var centerY = containerWidth / 2;

      var RAYBASE = maxRadius / 40;

      var leftSector = Math.PI / (blueTopics.length + 1);

      var scales = allIndicators.reduce(function (a, v, i) {
        if (!indicators[v]) {
          console.error("missing indicator:", v);
          return a;
        }
        var range = indicators[v].rankDirection === "1" ? [maxRadius, 0] : [0, maxRadius];
        // let domain = indicators[v].domain
        var domain = [0, 2];
        a[v] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["a" /* scaleLinear */])().range(range).domain(domain);
        return a;
      }, {});

      var tfaArticlesKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(tfaArticles);

      var tfaScales = tfaArticlesKeys.reduce(function (a, v, i) {
        var range = [0, maxRadius];
        var domain = [0, tfaMeta[v]["max"]];
        a[v] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["a" /* scaleLinear */])().range(range).domain(domain);
        return a;
      }, {});

      var redTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(tfaArticles);
      var rightSector = Math.PI / (redTopics.length + 1);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        null,
        inlineColor && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { style: { fill: inlineColor, stroke: 'none', fillOpacity: 0.1 }, x: margin + 2, y: margin + 2, width: width - 4, height: width - 4 })
        ),
        blueTopics.map(function (topic, i) {
          if (!latestDataByIndicator[topic]) {
            // console.log("missing indicator", topic, countryCode)
            return null;
          }
          var countryData = latestDataByIndicator[topic][countryCode];
          var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(countryData, 'v');
          if (!value) {
            return null;
          }

          var angle = (i + 1) * leftSector + Math.PI / 2;
          var radius = scales[topic](value
          // const x2 = centerX + Math.cos(angle) * radius
          // const y2 = centerY + Math.sin(angle) * radius

          );var notFocused = false;
          if (focusedOptions) {
            notFocused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(focusedOptions, 'ind', []).indexOf(topic) === -1;
          }

          return (
            // <Oline key={topic} x1={center} y1={center} x2={x2} y2={y2} className="StarChart__blue"
            // content={`${indicators[topic].shortTitle || indicators[topic].globalId }: ${value} `}/>
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ray, { key: topic,
              centerX: centerX, centerY: centerY, angle: angle, radius: radius, rayBase: RAYBASE,
              content: (indicators[topic].shortTitle || indicators[topic].globalId) + ': ' + value + ' ',
              className: 'StarChart__blue', notFocused: notFocused })
          );
        }),
        tfaArticlesKeys.map(function (topic, i) {
          var countryData = tfaArticles[topic][countryCode];
          var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(countryData, 'v');
          if (!value) {
            return null;
          }

          var angle = Math.PI / 2 - (i + 1) * rightSector;

          var radius = tfaScales[topic](value);

          var notFocused = false;
          if (focusedOptions) {
            notFocused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(focusedOptions, 'tfa', []).indexOf(topic) === -1;
          }

          return (
            // <Oline key={topic} x1={center} y1={center} x2={x2} y2={y2} className="StarChart__red"
            // content={`${topic}: ${value} `}/>
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ray, { key: topic,
              centerX: centerX, centerY: centerY, angle: angle, radius: radius, rayBase: RAYBASE,
              content: 'Article ' + topic + ': ' + Math.round(value / tfaMeta[topic]["max"] * 1000) / 10,
              className: 'StarChart__red', notFocused: notFocused })
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: centerX, cy: centerY, r: RAYBASE })
        )
      );
    }
  }]);

  return StarChartBlock_;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var StarChartBlock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(StarChartBlock_);

var StarChart = function (_React$PureComponent2) {
  _inherits(StarChart, _React$PureComponent2);

  function StarChart() {
    var _ref2;

    var _temp, _this2, _ret;

    _classCallCheck(this, StarChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref2 = StarChart.__proto__ || Object.getPrototypeOf(StarChart)).call.apply(_ref2, [this].concat(args))), _this2), _this2.downloadPng = function (e) {
      var countryCode = _this2.props.countryCode;

      var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this2);

      var dk = node.querySelector(".download-links");
      dk.classList.add("hide");
      var donly = node.querySelector(".download-only");
      if (donly) {
        donly.classList.remove("hide");
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__["saveSvgAsPng"])(node, countryCode + '-star.png', { backgroundColor: '#fff' });
      dk.classList.remove("hide");
      if (donly) {
        donly.classList.add("hide");
      }
    }, _this2.downloadCsv = function (e) {
      var _this2$props = _this2.props,
          countryCode = _this2$props.countryCode,
          _this2$props$blueTopi = _this2$props.blueTopics,
          blueTopics = _this2$props$blueTopi === undefined ? BLUE_TOPICS : _this2$props$blueTopi,
          tfaArticles = _this2$props.tfaArticles;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_csvdownload__["a" /* getCsvFile */])(countryCode + '-country-facilitation.csv', [countryCode], blueTopics, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(tfaArticles));
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(StarChart, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          latestDataByIndicator = _props2.latestDataByIndicator,
          tfaArticles = _props2.tfaArticles,
          countryCode = _props2.countryCode,
          countries = _props2.countries,
          _props2$borderColor = _props2.borderColor,
          borderColor = _props2$borderColor === undefined ? '#0D66A5' : _props2$borderColor,
          _props2$margin = _props2.margin,
          margin = _props2$margin === undefined ? 40 : _props2$margin,
          _props2$blueTopics = _props2.blueTopics,
          blueTopics = _props2$blueTopics === undefined ? BLUE_TOPICS : _props2$blueTopics,
          _props2$redTopics = _props2.redTopics,
          redTopics = _props2$redTopics === undefined ? [] : _props2$redTopics,
          _props2$selectedTopic = _props2.selectedTopics,
          selectedTopics = _props2$selectedTopic === undefined ? [] : _props2$selectedTopic,
          _props2$showCountryLa = _props2.showCountryLabel,
          showCountryLabel = _props2$showCountryLa === undefined ? true : _props2$showCountryLa,
          _props2$showDownloads = _props2.showDownloads,
          showDownloads = _props2$showDownloads === undefined ? false : _props2$showDownloads,
          _props2$height = _props2.height,
          height = _props2$height === undefined ? null : _props2$height,
          inlineColor = _props2.inlineColor,
          focusedOptions = _props2.focusedOptions,
          containerWidth = _props2.containerWidth;


      var passProps = { latestDataByIndicator: latestDataByIndicator, tfaArticles: tfaArticles, countryCode: countryCode,
        margin: margin, blueTopics: blueTopics, redTopics: redTopics, selectedTopics: selectedTopics, containerWidth: 800, inlineColor: inlineColor, focusedOptions: focusedOptions };

      var chartHeight = height === null ? containerWidth : height;
      var ratificationDateOrPhrase = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(tfaArticles, '[1][' + countryCode + ']["date"]') || '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { className: 'StarChart__svg', viewBox: '0 0 800 800',
          style: { border: borderColor ? 'solid ' + borderColor + ' 1px' : undefined },
          height: chartHeight, width: containerWidth },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + margin + ', ' + margin + ')', className: '' + (showCountryLabel ? '' : 'hide download-only') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2, className: 'SunBurstChart__country_label' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["d" /* Link */],
              { to: '//countries/' + countryCode },
              countries[countryCode]
            )
          )
        ),
        showDownloads && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { className: 'download-links', transform: 'translate(' + margin + ', ' + margin + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2, className: 'SunBurstChart__download_title' },
            'DOWNLOAD'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2 + 40 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              { className: 'SunBurstChart__download_label pointer', onClick: this.downloadCsv },
              'CSV'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              null,
              '\xA0\xA0\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              { className: 'SunBurstChart__download_label pointer', onClick: this.downloadPng },
              'VIZ'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StarChartBlock, passProps),
        true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + 800 / 2 + ', ' + (800 - margin) + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2, className: 'StarChart__ratification_label' },
            ratificationDateOrPhrase.match(/^\d\d\.\d\d\.\d{4}$/) ? 'Has ratified the TFA on ' + ratificationDateOrPhrase : ratificationDateOrPhrase.match(/^Has/) ? ratificationDateOrPhrase : 'Has not ratified the TFA as of 18.07.2017'
          )
        )
      );
    }
  }]);

  return StarChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4_react_dimensions___default()()(StarChart)));

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_scale__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_save_svg_as_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_csvdownload__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var d3 = __webpack_require__(40);

var INCLUDED_TOPICS = ['SUN-CUSTSERVIND', //Customs services index
'SUN-CLEAREFF', //Efficency of the clearance process
'SUN-TABTIMEIMPDOC', //Time to import:Documentary compliance
'SUN-TABTIMEIMPBORD', //Time to import:Border compliance
'SUN-TABCOSTIMPDOC', //Cost to import:Documentary compliance
'SUN-TABCOSTIMPBORD', //Cost to import: Border compliance
'SUN-TABTIMEEXPDOC', //Time to export: Documentary compliance
'SUN-TABTIMEEXPBORD', //Time to export: Border compliance
'SUN-TABCOSTEXPDOC', //Cost to export: Documentary compliance
'SUN-TABCOSTEXPBORD', //Cost to export: Border compliance
'SUN-EOSQ147', //Irregular payments in exports and imports
'SUN-EOSQ395', //Time predictability of import procedures
'SUN-CUSTTRANSPIND'];

var Opath = __WEBPACK_IMPORTED_MODULE_8_redux_tooltip__["Origin"].wrapBy('path');

var SunBurstChart = function (_React$PureComponent) {
  _inherits(SunBurstChart, _React$PureComponent);

  function SunBurstChart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SunBurstChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SunBurstChart.__proto__ || Object.getPrototypeOf(SunBurstChart)).call.apply(_ref, [this].concat(args))), _this), _this.downloadPng = function (e) {
      var countryCode = _this.props.countryCode;

      var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);
      var dk = node.querySelector(".download-links");
      dk.classList.add("hide");
      var donly = node.querySelector(".download-only");
      if (donly) {
        donly.classList.remove("hide");
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_save_svg_as_png__["saveSvgAsPng"])(node, countryCode + '-sunburst.png', { backgroundColor: '#fff' });
      dk.classList.remove("hide");
      if (donly) {
        donly.classList.add("hide");
      }
    }, _this.downloadCsv = function (e) {
      var _this$props = _this.props,
          countryCode = _this$props.countryCode,
          _this$props$includedT = _this$props.includedTopics,
          includedTopics = _this$props$includedT === undefined ? INCLUDED_TOPICS : _this$props$includedT;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_csvdownload__["a" /* getCsvFile */])(countryCode + '-thirdpillar.csv', [countryCode], includedTopics);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SunBurstChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          countries = _props.countries,
          indicators = _props.indicators,
          latestDataByIndicator = _props.latestDataByIndicator,
          countryCode = _props.countryCode,
          _props$baseColor = _props.baseColor,
          baseColor = _props$baseColor === undefined ? '#00539B' : _props$baseColor,
          _props$borderColor = _props.borderColor,
          borderColor = _props$borderColor === undefined ? '#0D66A5' : _props$borderColor,
          _props$emptyFraction = _props.emptyFraction,
          emptyFraction = _props$emptyFraction === undefined ? 0.5 : _props$emptyFraction,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? 40 : _props$margin,
          _props$includedTopics = _props.includedTopics,
          includedTopics = _props$includedTopics === undefined ? INCLUDED_TOPICS : _props$includedTopics,
          _props$showCountryLab = _props.showCountryLabel,
          showCountryLabel = _props$showCountryLab === undefined ? true : _props$showCountryLab,
          _props$showDownloads = _props.showDownloads,
          showDownloads = _props$showDownloads === undefined ? false : _props$showDownloads,
          _props$height = _props.height,
          height = _props$height === undefined ? null : _props$height,
          containerWidth = _props.containerWidth;

      // #TODO: USE THESE?
      // const minValue = 1
      // const maxValue = 7

      var neutralColor = '#fff';

      // viewBox will be 800x800 if square

      // console.log("indicators", indicators)

      var width = 800 - margin * 4;
      var chartWidth = containerWidth;
      var chartHeight = height === null ? containerWidth : height;
      var maxRadius = width / 2;
      var minRadius = maxRadius * emptyFraction;
      var delta = (maxRadius - minRadius) / 7;
      var sectorAngle = Math.PI * 2 / includedTopics.length;

      var scales = includedTopics.reduce(function (a, v, i) {
        // const v = `SUN-${v}`
        // const range = indicators[v].rankDirection === "1" ? [maxRadius, minRadius] : [minRadius, maxRadius]
        // a[v] = scaleLinear().range(range).domain(indicators[v].domain || [0, 7])
        var range = indicators[v].rankDirection === 1 ? [maxRadius, minRadius + delta] : [minRadius + delta, maxRadius];
        a[v] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_d3_scale__["a" /* scaleLinear */])().range(range).domain(indicators[v].domain);
        return a;
      }, {});

      var colorScales = includedTopics.reduce(function (a, v, i) {
        // const v = `SUN-${v}`
        // console.log("xx", v, v, indicators[v])
        // const colorRange = indicators[v].rankDirection === "1" ? [baseColor, neutralColor] : [neutralColor, baseColor]
        // a[v] = scaleLinear().range(colorRange).domain(indicators[v].domain || [0, 7])
        var colorRange = indicators[v].rankDirection === 1 ? [baseColor, neutralColor] : [neutralColor, baseColor];
        a[v] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_d3_scale__["a" /* scaleLinear */])().range(colorRange).domain(indicators[v].domain);
        return a;
      }, {});

      var countryData = includedTopics.reduce(function (a, v, i) {
        a[v] = {};

        a[v]['value'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(latestDataByIndicator[v], '[' + countryCode + '].v', null);
        a[v]['year'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(latestDataByIndicator[v], '[' + countryCode + '].y', null);
        a[v]['plotValue'] = a[v]['value'] ? scales[v](a[v]['value']) : null;
        a[v]['fill'] = a[v]['value'] ? colorScales[v](a[v]['value']) : null;
        return a;
      }, {});

      console.log("countryData", countryData);

      var gridScale = d3.scaleLinear().range([minRadius, maxRadius]).domain([0, 7]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { className: 'SunBurstChart__svg', viewBox: '0 0 832 ' + 832,
          style: { border: borderColor ? 'solid ' + borderColor + ' 1px' : undefined }, height: chartHeight, width: chartWidth },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + margin + ', ' + margin + ')', className: '' + (showCountryLabel ? '' : 'hide download-only') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2, className: 'SunBurstChart__country_label' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Link */],
              { to: '//countries/' + countryCode },
              countries[countryCode]
            )
          )
        ),
        showDownloads && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { className: 'download-links', transform: 'translate(' + margin + ', ' + margin + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2, className: 'SunBurstChart__download_title' },
            'DOWNLOAD'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { y: margin / 2 + 40 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              { className: 'SunBurstChart__download_label pointer', onClick: this.downloadCsv },
              'CSV'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              null,
              '\xA0\xA0\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tspan',
              { className: 'SunBurstChart__download_label pointer', onClick: this.downloadPng },
              'VIZ'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(' + margin + ', ' + (800 - margin / 2) + ')' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { className: 'SunBurstChart__source_label' },
            'Source: Global Alliance for Trade Facilitation / World Economic Forum; Enabling Trade Index'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            { className: 'SunBurstChart__source_label', y: '24' },
            'The size of the rays reflects the normalized score on a 1 (worst) to 7 (best) scale'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { className: 'SunBurstChart__grid', r: minRadius, cx: 800 / 2, cy: 800 / 2 }),
          includedTopics.map(function (topic, i) {

            // if (!countryData[topic]['plotValue']){
            //   return null
            // }

            var gridRange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["range"])(0, 8).map(function (v) {
              return gridScale(v);
            }
            // .filter(v => countryData[topic]['plotValue'] && v < countryData[topic]['plotValue'])

            );var gridArcs = gridRange.map(function (value, o) {
              //countryData[topic]['plotValue']

              return d3.arc().startAngle(function (d) {
                return i * sectorAngle;
              }).endAngle(function (d) {
                return (i + 1) * sectorAngle;
              }).innerRadius(function (d) {
                return minRadius;
              }).outerRadius(function (d) {
                return value;
              });
            });

            var arc = d3.arc().startAngle(function (d) {
              return i * sectorAngle;
            }).endAngle(function (d) {
              return (i + 1) * sectorAngle;
            }).innerRadius(function (d) {
              return minRadius;
            }).outerRadius(function (d) {
              return countryData[topic]['plotValue'] || minRadius;
            });

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'g',
              { key: topic, transform: 'translate(' + 800 / 2 + ', ' + 800 / 2 + ')' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'g',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Opath, { className: 'SunBurstChart__sector',
                  d: arc(),
                  style: { fill: countryData[topic]['fill'] },
                  content: indicators[topic].shortTitle + ' : ' + countryData[topic]['value'] + ' (' + countryData[topic]['year'] + ')' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'g',
                null,
                gridArcs.map(function (garc, a) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { key: a, className: 'SunBurstChart__grid-2',
                    d: garc() });
                })
              )
            );
          })
        )
      );
    }
  }]);

  return SunBurstChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    countries: state.countries,
    indicators: state.indicators
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4_react_dimensions___default()()(SunBurstChart)));

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTrendDataByCountryAndIndicator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLatestFromData; });
/* unused harmony export getLastDataByIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



//
// const getVisibilityFilter = (state, props) =>
//   state.todoLists[props.listId].visibilityFilter
//
// const getTodos = (state, props) =>
//   state.todoLists[props.listId].todos
//
// const getVisibleTodos = createSelector(
//   [ getVisibilityFilter, getTodos ],
//   (visibilityFilter, todos) => {
//     switch (visibilityFilter) {
//       case 'SHOW_COMPLETED':
//         return todos.filter(todo => todo.completed)
//       case 'SHOW_ACTIVE':
//         return todos.filter(todo => !todo.completed)
//       default:
//         return todos
//     }
//   }
// )
//
// export default getVisibleTodos

var getDataByCountryAndIndicator = function getDataByCountryAndIndicator(state, props) {
  return state.dataByCountry[props.countryCode][props.indicator];
};

var getDataByIndicator = function getDataByIndicator(state, props) {
  return state.dataByIndicator[props.indicator];
};

var getTrendDataByCountryAndIndicator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDataByCountryAndIndicator], function (data) {
  var years = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"])(data).sort();
  return years.map(function (year) {
    return { year: year, v: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data[year], 'v') };
  });
});

var getLatestFromData = function getLatestFromData(data) {
  var countries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"])(data);
  return countries.map(function (country) {
    var years = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"])(data[country]).filter(function (year) {
      return data[country][year] && data[country][year]["v"] !== undefined;
    }).sort();
    if (!years.length) {
      return null;
    }
    var lastYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["last"])(years);
    return {
      country: country,
      year: lastYear,
      v: data[country][lastYear]["v"]
    };
  }).filter(function (datum) {
    return !!datum;
  });
};

var getLastDataByIndicator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDataByIndicator], function (data) {
  return getLatestFromData(data);
});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(563);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var emptyObject = __webpack_require__(68);
var _invariant = __webpack_require__(1);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(144);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(38);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(153);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(147);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(46);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(299);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(159);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(91);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(158);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(303);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(304);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(30);





var areaRingSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

var areaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math__["b" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  lambda0 = lambda, cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]), sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
      sinPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(adLambda),
      v = k * sdLambda * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(adLambda);
  areaRingSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  areaSum.reset();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation__ = __webpack_require__(64);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(radius),
      sinRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])([cosRadius, -sinRadius * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(t), -sinRadius * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(point), point[0] -= cosRadius;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["g" /* cartesianNormalizeInPlace */])(point);
  var radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["r" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([0, 0]),
      radius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(90),
      precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */];
    ring = [];
    rotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__rotation__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polygon__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__buffer__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_array__["i" /* merge */])(segments);
        var startInside = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__polygonContains__["a" /* default */])(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__polygon__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math__["k" /* halfPi */] - b[1]);
}


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual__ = __webpack_require__(169);


function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pointEqual__["a" /* default */])(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length__ = __webpack_require__(167);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__length__["a" /* default */])(object);
});


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream__ = __webpack_require__(30);





var lengthSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  lambda0 = lambda, sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi), cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */];
  var sinPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi),
      cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi),
      delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda - lambda0),
      cosDelta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(delta),
      sinDelta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__stream__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(27);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */];
});


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(2);




var sum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(lambda), -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
        sinPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(phi0),
        cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math__["q" /* quarterPi */],
          sinPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(phi1),
          cosPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* atan2 */])(k * sign * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["b" /* cartesianCross */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["a" /* cartesian */])(point1));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["g" /* cartesianNormalizeInPlace */])(arc);
        var intersection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["b" /* cartesianCross */])(normal, arc);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cartesian__["g" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["f" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea__["a" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(22);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(99);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(99);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(50);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(66);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(31);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(180);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["p" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["i" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["s" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["t" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(101);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(186);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(185);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(363);
/* unused harmony reexport isoParse */






/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(101);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(102);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(17);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(34);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(55);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(104);

var _PathUtils = __webpack_require__(54);

var _createTransitionManager = __webpack_require__(105);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(433);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 194 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(247);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(441);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(32);

var invariant = __webpack_require__(1);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(42);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInstrumentation = __webpack_require__(18);

var quoteAttributeValueForBrowser = __webpack_require__(503);
var warning = __webpack_require__(4);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var LinkedValueUtils = __webpack_require__(113);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(20);

var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(463);

var containsNode = __webpack_require__(414);
var focusNode = __webpack_require__(188);
var getActiveElement = __webpack_require__(189);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(41);
var DOMProperty = __webpack_require__(42);
var React = __webpack_require__(44);
var ReactBrowserEventEmitter = __webpack_require__(69);
var ReactCurrentOwner = __webpack_require__(25);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMContainerInfo = __webpack_require__(457);
var ReactDOMFeatureFlags = __webpack_require__(459);
var ReactFeatureFlags = __webpack_require__(204);
var ReactInstanceMap = __webpack_require__(58);
var ReactInstrumentation = __webpack_require__(18);
var ReactMarkupChecksum = __webpack_require__(473);
var ReactReconciler = __webpack_require__(43);
var ReactUpdateQueue = __webpack_require__(116);
var ReactUpdates = __webpack_require__(20);

var emptyObject = __webpack_require__(68);
var instantiateReactComponent = __webpack_require__(215);
var invariant = __webpack_require__(1);
var setInnerHTML = __webpack_require__(73);
var shouldUpdateReactComponent = __webpack_require__(122);
var warning = __webpack_require__(4);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var React = __webpack_require__(44);

var invariant = __webpack_require__(1);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(208);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(9);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(7);

var ReactCompositeComponent = __webpack_require__(454);
var ReactEmptyComponent = __webpack_require__(203);
var ReactHostComponent = __webpack_require__(205);

var getNextDebugID = __webpack_require__(548);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);
var escapeTextContentForBrowser = __webpack_require__(72);
var setInnerHTML = __webpack_require__(73);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(25);
var REACT_ELEMENT_TYPE = __webpack_require__(469);

var getIteratorFn = __webpack_require__(500);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(112);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(221);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(222);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(124);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(126);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact;
    var route = _ref2.route;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    var pathname = (location || route.location).pathname;

    return path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        component = _props.component,
        render = _props.render,
        children = _props.children;


    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props2 = this.props,
        children = _props2.children,
        component = _props2.component,
        render = _props2.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _stripDiacritics = __webpack_require__(227);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2['default'])(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

module.exports = filterOptions;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classnames = __webpack_require__(62);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption;
	var instancePrefix = _ref.instancePrefix;
	var labelKey = _ref.labelKey;
	var onFocus = _ref.onFocus;
	var onSelect = _ref.onSelect;
	var optionClassName = _ref.optionClassName;
	var optionComponent = _ref.optionComponent;
	var optionRenderer = _ref.optionRenderer;
	var options = _ref.options;
	var valueArray = _ref.valueArray;
	var valueKey = _ref.valueKey;
	var onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2['default'])(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2['default'].createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function (ref) {
					onOptionRef(ref, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

module.exports = menuRenderer;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

module.exports = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(60),
    _assign = __webpack_require__(7);

var ReactNoopUpdateQueue = __webpack_require__(231);

var canDefineProperty = __webpack_require__(232);
var emptyObject = __webpack_require__(68);
var invariant = __webpack_require__(1);
var lowPriorityWarning = __webpack_require__(549);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(60);

var ReactCurrentOwner = __webpack_require__(25);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["k" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* makeIterator */])(function () {
    throw error;
  }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* deprecate */])(runAllEffect, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["q" /* log */];
  var stdChannel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["b" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (false) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["r" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["g" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["s" /* CANCEL */]];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["t" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _cb;

          cb.cancel();
          completed = true;
          cb((_cb = {}, _cb[key] = res, _cb));
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(233);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["r" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEveryHelper;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatestHelper;
/* harmony export (immutable) */ __webpack_exports__["c"] = throttleHelper;
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__channel__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(74);





var done = { done: true, value: undefined };
var qEnd = {};

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function takeEveryHelper(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__io__["a" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_2__io__["d" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_0__channel__["a" /* END */] ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
}

function takeLatestHelper(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var yTake = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__io__["a" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_2__io__["d" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_0__channel__["a" /* END */] ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(patternOrChannel) + ', ' + worker.name + ')');
}

function throttleHelper(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__io__["f" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__io__["a" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_2__io__["d" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__io__["c" /* call */])(__WEBPACK_IMPORTED_MODULE_1__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_0__channel__["a" /* END */] ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}

var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};
var takeEvery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* deprecate */])(takeEveryHelper, deprecationWarning('takeEvery'));
var takeLatest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* deprecate */])(takeLatestHelper, deprecationWarning('takeLatest'));
var throttle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* deprecate */])(throttleHelper, deprecationWarning('throttle'));

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["b"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["c"] = flush;

var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var simple = exports.simple = {
  base: {
    borderRadius: '5px',
    background: '#fff',
    boxShadow: '0px 0px 14px rgba(0,0,0,0.3)',
    color: '#2c2c2c'
  },
  content: {
    fontSize: '14px',
    lineHeight: '16px',
    padding: '8px 10px'
  },
  border: {
    borderColor: 'white',
    marginBottom: '-2px'
  }
};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transform__ = __webpack_require__(132);


/* harmony default export */ __webpack_exports__["a"] = (function(topology) {
  var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transform__["a" /* default */])(topology.transform), key,
      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;

  function bboxPoint(p) {
    p = t(p);
    if (p[0] < x0) x0 = p[0];
    if (p[0] > x1) x1 = p[0];
    if (p[1] < y0) y0 = p[1];
    if (p[1] > y1) y1 = p[1];
  }

  function bboxGeometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
      case "Point": bboxPoint(o.coordinates); break;
      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
    }
  }

  topology.arcs.forEach(function(arc) {
    var i = -1, n = arc.length, p;
    while (++i < n) {
      p = t(arc[i], i);
      if (p[0] < x0) x0 = p[0];
      if (p[0] > x1) x1 = p[0];
      if (p[1] < y0) y0 = p[1];
      if (p[1] > y1) y1 = p[1];
    }
  });

  for (key in topology.objects) {
    bboxGeometry(topology.objects[key]);
  }

  return [x0, y0, x1, y1];
});


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(topology, arcs) {
  var stitchedArcs = {},
      fragmentByStart = {},
      fragmentByEnd = {},
      fragments = [],
      emptyIndex = -1;

  // Stitch empty arcs first, since they may be subsumed by other arcs.
  arcs.forEach(function(i, j) {
    var arc = topology.arcs[i < 0 ? ~i : i], t;
    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
    }
  });

  arcs.forEach(function(i) {
    var e = ends(i),
        start = e[0],
        end = e[1],
        f, g;

    if (f = fragmentByEnd[start]) {
      delete fragmentByEnd[f.end];
      f.push(i);
      f.end = end;
      if (g = fragmentByStart[end]) {
        delete fragmentByStart[g.start];
        var fg = g === f ? f : f.concat(g);
        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else if (f = fragmentByStart[end]) {
      delete fragmentByStart[f.start];
      f.unshift(i);
      f.start = start;
      if (g = fragmentByEnd[start]) {
        delete fragmentByEnd[g.end];
        var gf = g === f ? f : g.concat(f);
        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
      } else {
        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
      }
    } else {
      f = [i];
      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
    }
  });

  function ends(i) {
    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
    else p1 = arc[arc.length - 1];
    return i < 0 ? [p1, p0] : [p0, p1];
  }

  function flush(fragmentByEnd, fragmentByStart) {
    for (var k in fragmentByEnd) {
      var f = fragmentByEnd[k];
      delete fragmentByStart[f.start];
      delete f.start;
      delete f.end;
      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
      fragments.push(f);
    }
  }

  flush(fragmentByEnd, fragmentByStart);
  flush(fragmentByStart, fragmentByEnd);
  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });

  return fragments;
});


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(241);


/* harmony default export */ __webpack_exports__["a"] = (function(transform) {
  if (transform == null) return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */];
  var x0,
      y0,
      kx = transform.scale[0],
      ky = transform.scale[1],
      dx = transform.translate[0],
      dy = transform.translate[1];
  return function(input, i) {
    if (!i) x0 = y0 = 0;
    var j = 2,
        n = input.length,
        output = new Array(n),
        x1 = Math.round((input[0] - dx) / kx),
        y1 = Math.round((input[1] - dy) / ky);
    output[0] = x1 - x0, x0 = x1;
    output[1] = y1 - y0, y0 = y1;
    while (j < n) output[j] = input[j], ++j;
    return output;
  };
});


/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tachyons_css_tachyons_css__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tachyons_css_tachyons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_tachyons_css_tachyons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);







__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */], null), document.getElementById('root'));
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(438).enable();
  window.Promise = __webpack_require__(437);
}

// fetch() polyfill for making API calls.
__webpack_require__(584);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(7);


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_DataExplorer__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ThirdPillar__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_CountryFacilitationPolicies__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SevenPillars__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_actions__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










//pages







var mapDispatchToProps = { loadTfaArticles: __WEBPACK_IMPORTED_MODULE_11__state_actions__["a" /* loadTfaArticles */] };
var mapStateToProps = function mapStateToProps(state) {
  return {
    modalOpen: state.modalOpen
  };
};

var Routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(function (_React$PureComponent) {
  _inherits(_class, _React$PureComponent);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      //this.props.loadTfaArticles()
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          modalOpen = _props.modalOpen;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'blue-background ' + (modalOpen ? 'noscroll' : '') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_tooltip__["Tooltip"], { className: 'tooltip-with-width' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Switch */],
          { key: location.key, location: location },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */], { path: '/third-pillar/:countryCode?', component: __WEBPACK_IMPORTED_MODULE_8__pages_ThirdPillar__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */], { path: '/trade-facilitation-policies', component: __WEBPACK_IMPORTED_MODULE_9__pages_CountryFacilitationPolicies__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */], { path: '/enabling-trade-environment', component: __WEBPACK_IMPORTED_MODULE_10__pages_SevenPillars__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */], { from: '/', to: '/third-pillar' })
        )
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent));

var history = __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory___default()();

var ScrollToTopNoRouter = function (_PureComponent) {
  _inherits(ScrollToTopNoRouter, _PureComponent);

  function ScrollToTopNoRouter() {
    _classCallCheck(this, ScrollToTopNoRouter);

    return _possibleConstructorReturn(this, (ScrollToTopNoRouter.__proto__ || Object.getPrototypeOf(ScrollToTopNoRouter)).apply(this, arguments));
  }

  _createClass(ScrollToTopNoRouter, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTopNoRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var ScrollToTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(ScrollToTopNoRouter);

var App = function App() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_redux__["Provider"],
    { store: __WEBPACK_IMPORTED_MODULE_5__state__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Router */],
      { history: history },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ScrollToTop,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */], { component: Routes })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BubbleAndBarChart__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(36);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Ocircle = __WEBPACK_IMPORTED_MODULE_6_redux_tooltip__["Origin"].wrapBy('circle');

var BubbleOverlay = function (_React$PureComponent) {
  _inherits(BubbleOverlay, _React$PureComponent);

  function BubbleOverlay() {
    _classCallCheck(this, BubbleOverlay);

    return _possibleConstructorReturn(this, (BubbleOverlay.__proto__ || Object.getPrototypeOf(BubbleOverlay)).apply(this, arguments));
  }

  _createClass(BubbleOverlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // const node = ReactDOM.findDOMNode(this)
      // node.scrollIntoView(true)
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSelectCountry = _props.handleSelectCountry,
          selectedCountry = _props.selectedCountry,
          comparisonCountry = _props.comparisonCountry,
          latestDataByIndicator = _props.latestDataByIndicator;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'BubbleChart__chart_container', onClick: handleSelectCountry(null) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'BubbleChart__overlay border-blue' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + (comparisonCountry ? 'BubbleChart__overlay__box--double' : 'BubbleChart__overlay__box'),
              onClick: function onClick(e) {
                e.stopPropagation();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BubbleAndBarChart__["a" /* default */], { latestDataByIndicator: latestDataByIndicator, countryCode: selectedCountry })
          ),
          comparisonCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'BubbleChart__overlay__box--double', onClick: function onClick(e) {
                e.stopPropagation();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BubbleAndBarChart__["a" /* default */], { latestDataByIndicator: latestDataByIndicator, countryCode: comparisonCountry })
          )
        )
      );
    }
  }]);

  return BubbleOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var BubbleChart = function (_React$PureComponent2) {
  _inherits(BubbleChart, _React$PureComponent2);

  function BubbleChart() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, BubbleChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = BubbleChart.__proto__ || Object.getPrototypeOf(BubbleChart)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleSelectCountry = function (countryCode) {
      return function (e) {
        _this2.props.setSelectedCountry(countryCode);
        if (countryCode === null) {
          _this2.props.setComparisonCountry(null);
        }
      };
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(BubbleChart, [{
    key: 'getFillOpacity',
    value: function getFillOpacity(d, scale) {
      var _props2 = this.props,
          emptyFill = _props2.emptyFill,
          dataMap = _props2.dataMap;

      if (dataMap[d.id]) {
        var out = scale(dataMap[d.id]);
        return out;
      }
      return emptyFill ? 1 : 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          countries = _props3.countries,
          countriesContinents = _props3.countriesContinents,
          dataMap = _props3.dataMap,
          _props3$borderColor = _props3.borderColor,
          borderColor = _props3$borderColor === undefined ? '#0D66A5' : _props3$borderColor,
          maxScale = _props3.maxScale,
          minScale = _props3.minScale,
          _props3$decreasing = _props3.decreasing,
          decreasing = _props3$decreasing === undefined ? false : _props3$decreasing,
          containerWidth = _props3.containerWidth,
          _props3$itemSize = _props3.itemSize,
          itemSize = _props3$itemSize === undefined ? 50 : _props3$itemSize,
          _props3$itemMargin = _props3.itemMargin,
          itemMargin = _props3$itemMargin === undefined ? 5 : _props3$itemMargin,
          _props3$labelheight = _props3.labelheight,
          labelheight = _props3$labelheight === undefined ? 10 : _props3$labelheight,
          latestDataByIndicator = _props3.latestDataByIndicator,
          comparisonCountry = _props3.comparisonCountry,
          selectedCountry = _props3.selectedCountry,
          colorMode = _props3.colorMode,
          countryMode = _props3.countryMode;


      var dataValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["values"])(dataMap);
      var sortedValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["toPairs"])(dataMap), function (i) {
        return decreasing ? -i[1] : i[1];
      });

      var dataKeys = [];
      if (countryMode === 'top') {
        dataKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(sortedValues.reverse(), function (i) {
          return i[0];
        });
      } else if (countryMode === 'bottom') {
        dataKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(sortedValues, function (i) {
          return i[0];
        });
      } else {
        dataKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(dataMap).sort();
      }

      var maxValue = maxScale || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(dataValues
      // let minValue = minScale || min(dataValues)

      );var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["a" /* scaleLinear */])().domain([0, maxValue]).range(decreasing ? [itemSize / 2, 0] : [0, itemSize / 2]);

      var itemWidth = itemSize + itemMargin * 2;
      var itemHeight = itemSize + itemMargin * 2 + labelheight;
      var itemsPerRow = Math.floor(containerWidth / itemWidth);
      var numRows = Math.ceil(dataKeys.length / itemsPerRow
      // const plotItems = dataKeys.reduce((accumulator, currentValue, currentIndex) => {
      //   return accumulator}, [])

      );var dataRows = [];
      for (var i = 0; i < numRows; i++) {
        var row = [];
        for (var j = 0; j < itemsPerRow; j++) {
          var idx = i * itemsPerRow + j;
          if (idx < dataKeys.length) {
            row.push([dataKeys[idx], dataMap[dataKeys[idx]]]);
          }
        }
        dataRows.push(row);
      }

      var overlayProps = { handleSelectCountry: this.handleSelectCountry,
        selectedCountry: selectedCountry, comparisonCountry: comparisonCountry, latestDataByIndicator: latestDataByIndicator };

      var circleFill = function circleFill(countryCode) {
        return colorMode === 'continent' ? __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* continentsColors */][countriesContinents[countryCode]] : '#C3DDF1';
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: 'relative' } },
        selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BubbleOverlay, overlayProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          { className: 'MapChart__svg',
            style: { borderColor: borderColor }, height: itemHeight * (numRows + 1), width: containerWidth },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            dataRows.map(function (row, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'g',
                { key: i, transform: 'translate(0, ' + i * itemHeight + ')' },
                row.map(function (item, j) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'g',
                    { key: j, className: 'BubbleChart__container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { onClick: _this3.handleSelectCountry(item[0]), className: 'BubbleChart__element',
                      y: itemMargin, x: j * itemWidth,
                      width: itemWidth, height: itemWidth + labelheight }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ocircle, { onClick: _this3.handleSelectCountry(item[0]),
                      content: countries[item[0]] + ': ' + item[1], className: 'BubbleChart__circle',
                      style: { fill: circleFill(item[0]) },
                      cx: j * itemWidth + itemWidth / 2, cy: itemWidth / 2, r: scale(item[1]) }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'text',
                      { onClick: _this3.handleSelectCountry(item[0]), className: 'BubbleChart__label', x: j * itemWidth + itemWidth / 2, y: itemWidth + labelheight / 2 },
                      item[0]
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { onClick: _this3.handleSelectCountry(item[0]), r: 2, cx: j * itemWidth + itemWidth / 2, cy: itemWidth / 2 })
                  );
                })
              );
            })
          )
        )
      );
    }
  }]);

  return BubbleChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    countries: state.countries,
    countriesContinents: state.countriesContinents,
    selectedCountry: state.selectedCountry,
    comparisonCountry: state.comparisonCountry,
    colorMode: state.colorMode,
    countryMode: state.countryMode

  };
};

var mapDispatchToProps = { setSelectedCountry: __WEBPACK_IMPORTED_MODULE_7__state_actions__["B" /* setSelectedCountry */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_7__state_actions__["A" /* setComparisonCountry */] };

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_react_dimensions___default()()(BubbleChart)));

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataExplorerSearch__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DataExplorerHeader = function (_React$Component) {
  _inherits(DataExplorerHeader, _React$Component);

  function DataExplorerHeader() {
    _classCallCheck(this, DataExplorerHeader);

    return _possibleConstructorReturn(this, (DataExplorerHeader.__proto__ || Object.getPrototypeOf(DataExplorerHeader)).apply(this, arguments));
  }

  _createClass(DataExplorerHeader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'background-blue-map text-white' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'w-100 h-100 pa3 background-blue-map-overlay' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex flex-column h-container items-stretch' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'w-100 pa3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'f-subheadline headline-head tc text-bold', style: { marginTop: 10, marginBottom: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                  { to: '/', className: 'dim no-underline text-white' },
                  'Explore trade facilitation data'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'text-white tc mt3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                  { className: 'no-underline underline-hover text-white text-bold', to: '/third-pillar' },
                  'Explore the current status of the Trade Facilitation in the World'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DataExplorerHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DataExplorerHeader);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataExplorerSearch__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DataExplorerHeaderSmall = function (_React$Component) {
  _inherits(DataExplorerHeaderSmall, _React$Component);

  function DataExplorerHeaderSmall() {
    _classCallCheck(this, DataExplorerHeaderSmall);

    return _possibleConstructorReturn(this, (DataExplorerHeaderSmall.__proto__ || Object.getPrototypeOf(DataExplorerHeaderSmall)).apply(this, arguments));
  }

  _createClass(DataExplorerHeaderSmall, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'background-blue-map text-white' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'w-100 h-100 background-blue-map-overlay' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cf h-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fl-l w-50-l w-100 tc tl-l pa3-l pa3' })
          )
        )
      );
    }
  }]);

  return DataExplorerHeaderSmall;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DataExplorerHeaderSmall);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_StarChart__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(36);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MultiStarOverlay = function (_React$PureComponent) {
  _inherits(MultiStarOverlay, _React$PureComponent);

  function MultiStarOverlay() {
    _classCallCheck(this, MultiStarOverlay);

    return _possibleConstructorReturn(this, (MultiStarOverlay.__proto__ || Object.getPrototypeOf(MultiStarOverlay)).apply(this, arguments));
  }

  _createClass(MultiStarOverlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // const node = ReactDOM.findDOMNode(this)
      // node.scrollIntoView(true)
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          divStyle = _props.divStyle,
          handleSelectCountry = _props.handleSelectCountry,
          selectedCountry = _props.selectedCountry,
          comparisonCountry = _props.comparisonCountry,
          latestDataByIndicator = _props.latestDataByIndicator,
          tfaArticles = _props.tfaArticles,
          focusedOptions = _props.focusedOptions;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'MultiStarChart__chart_container', style: divStyle, onClick: handleSelectCountry(null) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'MultiStarChart__overlay border-blue' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: '' + (comparisonCountry ? 'MultiStarChart__overlay__box--double' : 'MultiStarChart__overlay__box'),
              onClick: function onClick(e) {
                e.stopPropagation();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_StarChart__["a" /* default */], { latestDataByIndicator: latestDataByIndicator, tfaArticles: tfaArticles, countryCode: selectedCountry, focusedOptions: focusedOptions })
          ),
          comparisonCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'MultiStarChart__overlay__box--double', onClick: function onClick(e) {
                e.stopPropagation();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_StarChart__["a" /* default */], { latestDataByIndicator: latestDataByIndicator, tfaArticles: tfaArticles, countryCode: comparisonCountry, focusedOptions: focusedOptions })
          )
        )
      );
    }
  }]);

  return MultiStarOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var MultiStarChart = function (_React$PureComponent2) {
  _inherits(MultiStarChart, _React$PureComponent2);

  function MultiStarChart() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, MultiStarChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = MultiStarChart.__proto__ || Object.getPrototypeOf(MultiStarChart)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleSelectCountry = function (countryCode) {
      return function (e) {
        _this2.props.setSelectedCountry(countryCode);
        if (countryCode === null) {
          _this2.props.setComparisonCountry(null);
        }
      };
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(MultiStarChart, [{
    key: 'getFillOpacity',
    value: function getFillOpacity(d, scale) {
      var _props2 = this.props,
          emptyFill = _props2.emptyFill,
          dataMap = _props2.dataMap;

      if (dataMap[d.id]) {
        var out = scale(dataMap[d.id]);
        return out;
      }
      return emptyFill ? 1 : 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          countries = _props3.countries,
          latestDataByIndicator = _props3.latestDataByIndicator,
          tfaArticles = _props3.tfaArticles,
          _props3$borderColor = _props3.borderColor,
          borderColor = _props3$borderColor === undefined ? '#0D66A5' : _props3$borderColor,
          containerWidth = _props3.containerWidth,
          _props3$itemSize = _props3.itemSize,
          itemSize = _props3$itemSize === undefined ? 100 : _props3$itemSize,
          _props3$itemMargin = _props3.itemMargin,
          itemMargin = _props3$itemMargin === undefined ? 5 : _props3$itemMargin,
          _props3$labelheight = _props3.labelheight,
          labelheight = _props3$labelheight === undefined ? 10 : _props3$labelheight,
          selectedCountry = _props3.selectedCountry,
          comparisonCountry = _props3.comparisonCountry,
          colorMode = _props3.colorMode,
          countryMode = _props3.countryMode,
          countriesContinents = _props3.countriesContinents,
          focusedOptions = _props3.focusedOptions;


      var countryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(countries).sort

      // filtering empty records and annotating for sorting
      ();var sortMap = {};
      countryCodes = countryCodes.filter(function (code) {
        // console.log("latestDataByIndicator", latestDataByIndicator)
        var tfaValues = [];
        var hasTfa = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(tfaArticles).reduce(function (acc, item) {
          var hasTfaArticle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(tfaArticles[item], '[' + code + '].v');
          hasTfaArticle && tfaValues.push(hasTfaArticle);
          return acc || hasTfaArticle;
        }, false);

        var indicatorValues = [];
        var hasIndicators = __WEBPACK_IMPORTED_MODULE_5__components_StarChart__["b" /* BLUE_TOPICS */].reduce(function (acc, item) {
          var hasIndicator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(latestDataByIndicator[item], '[' + code + '].v');
          hasIndicator && indicatorValues.push(hasIndicator);
          return acc || hasIndicator;
        }, false);

        return hasTfa || hasIndicators;
      }

      // if(countryMode === 'top' || countryMode === 'bottom'){
      //   const annotatedByETI = sortBy(
      //     keys(latestDataByIndicator['ETI'])
      //     .filter(key => get(latestDataByIndicator['ETI'][key], 'v'))
      //     .map(key => {
      //       return { code: key, value: latestDataByIndicator['ETI'][key].v}
      //     }), item => item.value).map(item => item.code)
      //
      //   if(countryMode === 'top'){
      //     countryCodes = takeRight(annotatedByETI, 25)
      //   }
      //
      //   if(countryMode === 'bottom'){
      //     countryCodes = take(annotatedByETI, 25)
      //   }
      // }

      );var itemWidth = itemSize + itemMargin * 2;
      var itemHeight = itemSize + itemMargin * 2 + labelheight;
      var itemsPerRow = Math.floor(containerWidth / itemWidth);
      var numRows = Math.ceil(countryCodes.length / itemsPerRow);

      var dataRows = [];
      for (var i = 0; i < numRows; i++) {
        var row = [];
        for (var j = 0; j < itemsPerRow; j++) {
          var idx = i * itemsPerRow + j;
          if (idx <= countryCodes.length) {
            row.push(countryCodes[idx]);
          }
        }
        dataRows.push(row);
      }

      var divStyle = { width: containerWidth, height: itemHeight * (numRows + 1) };

      var overlayProps = {
        divStyle: divStyle,
        handleSelectCountry: this.handleSelectCountry,
        selectedCountry: selectedCountry, comparisonCountry: comparisonCountry, latestDataByIndicator: latestDataByIndicator,
        tfaArticles: tfaArticles, focusedOptions: focusedOptions
      };

      var svgWidth = itemWidth * itemsPerRow;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: divStyle },
        selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MultiStarOverlay, overlayProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          { className: 'MultiStarChart__svg', style: { borderColor: borderColor, margin: '0 ' + (containerWidth - svgWidth) / 2 },

            width: svgWidth, height: itemHeight * numRows },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            dataRows.map(function (row, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'g',
                { key: i, transform: 'translate(0, ' + i * itemHeight + ')' },
                row.map(function (countryCode, j) {
                  var inlineColor = null;
                  if (colorMode === 'continent') {
                    inlineColor = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* continentsColors */][countriesContinents[countryCode]];
                  }

                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'g',
                    { key: j },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'g',
                      { transform: 'translate(' + j * itemWidth + ', 0)' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { onClick: _this3.handleSelectCountry(countryCode), className: 'MultiStarChart__element', y: itemMargin, x: itemMargin, width: itemWidth, height: itemHeight }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'g',
                        { transform: 'translate(' + itemMargin + ', 0)' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_StarChart__["c" /* StarChartBlock */], { containerWidth: itemWidth, inlineColor: inlineColor, latestDataByIndicator: latestDataByIndicator, tfaArticles: tfaArticles, countryCode: countryCode })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'text',
                        { onClick: _this3.handleSelectCountry(countryCode), className: 'MultiStarChart__label', x: itemWidth / 2, y: itemSize + labelheight / 2 },
                        countryCode
                      )
                    )
                  );
                })
              );
            })
          )
        )
      );
    }
  }]);

  return MultiStarChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    countries: state.countries,
    countriesContinents: state.countriesContinents,
    selectedCountry: state.selectedCountry,
    comparisonCountry: state.comparisonCountry,
    colorMode: state.colorMode,
    countryMode: state.countryMode
  };
};

var mapDispatchToProps = { setSelectedCountry: __WEBPACK_IMPORTED_MODULE_6__state_actions__["B" /* setSelectedCountry */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_6__state_actions__["A" /* setComparisonCountry */] };

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_react_dimensions___default()()(MultiStarChart)));

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var d3 = __webpack_require__(40);
var Ocircle = __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__["Origin"].wrapBy('circle');

var TrendLine = function (_React$PureComponent) {
  _inherits(TrendLine, _React$PureComponent);

  function TrendLine() {
    _classCallCheck(this, TrendLine);

    return _possibleConstructorReturn(this, (TrendLine.__proto__ || Object.getPrototypeOf(TrendLine)).apply(this, arguments));
  }

  _createClass(TrendLine, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          scale = _props.scale,
          margin = _props.margin,
          _props$numYears = _props.numYears,
          numYears = _props$numYears === undefined ? 5 : _props$numYears,
          containerWidth = _props.containerWidth,
          countryCode = _props.countryCode,
          dataByCountry = _props.dataByCountry,
          _props$maxYear = _props.maxYear,
          maxYear = _props$maxYear === undefined ? 2016 : _props$maxYear;

      var years = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["range"])(maxYear - numYears + 1, maxYear + 1).map(function (i) {
        return i.toString();
      });
      var plotData = years.map(function (year) {
        return dataByCountry[year] ? Object.assign({
          year: year
        }, dataByCountry[year]) : null;
      });
      var yearWidth = (containerWidth - margin * 2) / (numYears - 1);

      var trendLines = plotData.reduce(function (accumulator, currentValue, currentIndex) {
        if (currentIndex === plotData.length) {
          return accumulator;
        }
        if (currentValue !== null) {
          var nextIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["findIndex"])(plotData, function (item, i) {
            return i > currentIndex && item;
          });
          if (nextIndex !== -1) {
            accumulator.push({
              x1: margin + currentIndex * yearWidth, y1: scale(currentValue.v),
              x2: margin + nextIndex * yearWidth, y2: scale(plotData[nextIndex].v),
              virtual: nextIndex > currentIndex + 1
            });
          }
        }
        return accumulator;
      }, []);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        null,
        trendLines.map(function (trendLine, i) {
          var lineAttrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(trendLine, ['virtual']);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', Object.assign({ key: i }, lineAttrs, {
            className: 'trend-line ' + (trendLine.virtual ? 'virtual' : '')
            // content={`${countryCode}`}
          }));
        }),
        plotData.map(function (datum, i) {
          return datum && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ocircle, {
            key: i, r: 1, cx: margin + i * yearWidth, cy: scale(datum.v),
            className: 'circle-datum', content: countryCode + ' ' + datum.v + ' (' + datum.year + ')' });
        })
      );
    }
  }]);

  return TrendLine;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var MultiTrendChart = function (_React$PureComponent2) {
  _inherits(MultiTrendChart, _React$PureComponent2);

  function MultiTrendChart() {
    _classCallCheck(this, MultiTrendChart);

    return _possibleConstructorReturn(this, (MultiTrendChart.__proto__ || Object.getPrototypeOf(MultiTrendChart)).apply(this, arguments));
  }

  _createClass(MultiTrendChart, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          indicatorData = _props2.indicatorData,
          _props2$margin = _props2.margin,
          margin = _props2$margin === undefined ? 0 : _props2$margin,
          _props2$height = _props2.height,
          height = _props2$height === undefined ? 50 : _props2$height,
          _props2$numYears = _props2.numYears,
          numYears = _props2$numYears === undefined ? 5 : _props2$numYears,
          containerWidth = _props2.containerWidth,
          containerHeight = _props2.containerHeight,
          dataByIndicator = _props2.dataByIndicator;


      if (!indicatorData.domain) {
        return null;
      }
      //SCALE direction depends on indicator "rankDirection"
      var rangeForIndicator = void 0;
      if (indicatorData.rankDirection === "1") {
        rangeForIndicator = [margin, height - margin * 2];
      } else {
        rangeForIndicator = [height - margin * 2, margin];
      }
      var scale = d3.scaleLinear().domain(indicatorData.domain).range(rangeForIndicator);
      var countries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(dataByIndicator);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { height: height, width: containerWidth, className: 'MultiTrendChart__svg' },
        countries.map(function (country) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TrendLine, { key: country,
            containerWidth: containerWidth,
            indicatorData: indicatorData,
            height: containerHeight,
            maxYear: 2016,
            numYears: numYears,
            countryCode: country,
            scale: scale,
            margin: 0,
            dataByCountry: dataByIndicator[country] });
        })
      );
    }
  }]);

  return MultiTrendChart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    //dataByCountry : getTrendDataByCountryAndIndicator(state, props),
    //indicators: state.indicators,
    countries: state.countries
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3_react_dimensions___default()()(MultiTrendChart)));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SunBurstChart__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var d3 = __webpack_require__(40);
var Ocircle = __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__["Origin"].wrapBy('circle'

//# TODO: compute???
);var availableYears = ["2014", "2016"];

var ScatterPlot = function (_React$PureComponent) {
  _inherits(ScatterPlot, _React$PureComponent);

  function ScatterPlot() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScatterPlot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScatterPlot.__proto__ || Object.getPrototypeOf(ScatterPlot)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      yYear: availableYears[1],
      xYear: availableYears[0]
    }, _this.handleSelectCountry = function (countryCode) {
      return function (e) {
        _this.props.setSelectedCountry(countryCode);
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScatterPlot, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.latestDataByIndicator) {
        this.props.loadLatestByIndicator();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          containerWidth = _props.containerWidth,
          _props$margin = _props.margin,
          margin = _props$margin === undefined ? 20 : _props$margin,
          data = _props.data,
          countries = _props.countries,
          countriesContinents = _props.countriesContinents,
          colorMode = _props.colorMode,
          countryMode = _props.countryMode,
          selectedCountry = _props.selectedCountry,
          comparisonCountry = _props.comparisonCountry,
          latestDataByIndicator = _props.latestDataByIndicator;
      var _state = this.state,
          yYear = _state.yYear,
          xYear = _state.xYear;

      var countryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(data);
      var dataSeries = availableYears.reduce(function (accumulator, currentValue, currentIndex) {

        accumulator[currentValue] = countryCodes.reduce(function (acc, cv, ci) {
          acc[cv] = data[cv][currentValue];
          return acc;
        }, {});
        return accumulator;
      }, {});

      var height = containerWidth - margin * 2;
      var width = containerWidth - margin * 2;

      var containerStyle = {
        paddingLeft: margin
      };

      var labelsMargin = 150;
      var chartWidth = 800 - labelsMargin;
      var chartHeight = 800 - labelsMargin;

      var sortedValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(dataSeries[yYear]).map(function (i) {
        return { c: i, v: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(dataSeries[yYear][i], 'v') };
      }), 'v');

      var pickedValues = void 0,
          chartCountryCodes = void 0,
          maxDomain = 7,
          minDomain = 1;

      if (countryMode === 'top') {
        pickedValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["takeRight"])(sortedValues, 25);
        chartCountryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(pickedValues, 'c');
        maxDomain = Math.ceil(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(pickedValues, 'v')));
        minDomain = Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["min"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(pickedValues, 'v')));
      } else if (countryMode === 'bottom') {
        pickedValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["take"])(sortedValues, 25);
        maxDomain = Math.ceil(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(pickedValues, 'v')));
        minDomain = Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["min"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(pickedValues, 'v')));
        chartCountryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(pickedValues, 'c');
      } else {
        chartCountryCodes = countryCodes;
        // maxDomain = max(map(sortedValues, 'v'))
        // minDomain = min(map(sortedValues, 'v'))
      }

      var hScale = d3.scaleLinear().range([labelsMargin, 800]).domain([minDomain, maxDomain]);
      var vScale = d3.scaleLinear().range([chartHeight, 0]).domain([minDomain, maxDomain]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: containerStyle },
        selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ScatterPlot__chart_container', style: { height: height, width: width }, onClick: this.handleSelectCountry(null) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ScatterPlot__overlay border-blue' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' + (comparisonCountry ? 'ScatterPlot__overlay__box--double' : 'ScatterPlot__overlay__box'), onClick: function onClick(e) {
                  e.stopPropagation();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SunBurstChart__["a" /* default */], { latestDataByIndicator: latestDataByIndicator, countryCode: selectedCountry })
            ),
            comparisonCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'ScatterPlot__overlay__box--double', onClick: function onClick(e) {
                  e.stopPropagation();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SunBurstChart__["a" /* default */], { baseColor: '#F8A23A', latestDataByIndicator: latestDataByIndicator, countryCode: comparisonCountry })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          { height: height, width: width, className: 'ScatterPlot__svg', viewBox: '0 0 800 800' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { className: 'ScatterPlot__grid', x: labelsMargin, width: chartWidth, height: chartHeight }),
            [2, 3, 4, 5, 6].map(function (d, di) {
              if (d === minDomain || d === maxDomain) {
                return null;
              }
              var datum = d; //hScale.invert(labelsMargin + (d * chartWidth / 100))
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'g',
                { key: datum },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', { key: datum + '-vertical', className: 'ScatterPlot__grid', x1: hScale(datum), y1: vScale(minDomain), x2: hScale(datum), y2: vScale(maxDomain) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { x: hScale(datum), y: chartHeight + 10, key: datum + '-vertical-label', className: 'ScatterPlot__label--vertical' },
                  d.toFixed(1)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', { key: datum + '-horizontal', className: 'ScatterPlot__grid', x1: hScale(minDomain), y1: vScale(datum), x2: hScale(maxDomain), y2: vScale(datum) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { x: labelsMargin - 10, y: vScale(datum), key: datum + '-horizontal-label', className: 'ScatterPlot__label--horizontal' },
                  d.toFixed(1)
                )
              );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', { className: 'ScatterPlot__grid', x1: hScale(minDomain), y1: vScale(minDomain), x2: hScale(maxDomain), y2: vScale(maxDomain) })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { y: chartHeight - 40, className: 'ScatterPlot__ylabel' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tspan',
                { x: labelsMargin - 20, dx: 0, dy: 16 },
                'SCORE'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tspan',
                { className: 'ScatterPlot__bigger_label', x: labelsMargin - 20, dx: 0, dy: 20 },
                this.state.yYear
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              { y: chartHeight + 30, className: 'ScatterPlot__xlabel' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tspan',
                { x: labelsMargin },
                'SCORE'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tspan',
                { className: 'ScatterPlot__bigger_label', x: labelsMargin, dx: 0, dy: 20 },
                this.state.xYear
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            chartCountryCodes.map(function (countryCode) {
              if (!dataSeries[xYear][countryCode] || !dataSeries[yYear][countryCode]) {
                return null;
              }
              var cx = hScale(dataSeries[xYear][countryCode].v);
              var cy = vScale(dataSeries[yYear][countryCode].v);

              var cyMid = vScale(dataSeries[xYear][countryCode].v);

              var classModifier = '';
              if (colorMode === 'continent') {
                classModifier = countriesContinents[countryCode] || '';
              } else {
                classModifier = dataSeries[xYear][countryCode].v >= dataSeries[yYear][countryCode].v ? 'red' : 'blue';
              }

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'g',
                { key: countryCode },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ocircle, {
                  onClick: _this2.handleSelectCountry(countryCode),
                  className: selectedCountry ? 'ScatterPlot__disabled' : 'ScatterPlot_circle ScatterPlot__bisect ScatterPlot__bisect--' + classModifier,
                  r: 2, cx: cx, cy: cy,
                  content: countries[countryCode] + ' : ' + dataSeries[xYear][countryCode].v + ' (' + xYear + '), ' + dataSeries[yYear][countryCode].v + ' (' + yYear + ')' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', { className: selectedCountry ? 'ScatterPlot__disabled' : 'ScatterPlot__bisect ScatterPlot__bisect--' + classModifier, x1: cx, y1: cy, x2: cx, y2: cyMid })
              );
            })
          )
        )
      );
    }
  }]);

  return ScatterPlot;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    //dataByCountry : getTrendDataByCountryAndIndicator(state, props),
    //indicators: state.indicators,
    countries: state.countries,
    latestDataByIndicator: state.latestDataByIndicator.data,
    selectedCountry: state.selectedCountry,
    comparisonCountry: state.comparisonCountry,
    countriesContinents: state.countriesContinents,
    colorMode: state.colorMode,
    countryMode: state.countryMode
  };
};

var mapDispatchToProps = { setSelectedCountry: __WEBPACK_IMPORTED_MODULE_5__state_actions__["B" /* setSelectedCountry */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_5__state_actions__["A" /* setComparisonCountry */], loadLatestByIndicator: __WEBPACK_IMPORTED_MODULE_5__state_actions__["z" /* loadLatestByIndicator */] };

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_react_dimensions___default()()(ScatterPlot)));

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autocomplete__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_autocomplete__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var menuStyle = {
  backgroundColor: '#fff',
  padding: '2px 0',
  magin: '0px',
  position: 'absolute',
  overflow: 'auto',
  maxHeight: '50%', // TODO: don't cheat, let it flow to the bottom
  color: "#222",
  width: "auto",
  fontSize: '14px'
};

var SelectedCountryInput = function (_React$PureComponent) {
  _inherits(SelectedCountryInput, _React$PureComponent);

  function SelectedCountryInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectedCountryInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectedCountryInput.__proto__ || Object.getPrototypeOf(SelectedCountryInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectedCountryInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          countries = _props.countries,
          selectCountry = _props.selectCountry,
          selectedCountry = _props.selectedCountry,
          _props$inputProps = _props.inputProps,
          inputProps = _props$inputProps === undefined ? {} : _props$inputProps;

      var valueFromProps = selectedCountry ? countries[selectedCountry] : '';
      var value = this.state.value === null ? valueFromProps : this.state.value;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_autocomplete___default.a, {
        getItemValue: function getItemValue(item) {
          return item.value;
        },
        menuStyle: menuStyle,
        inputProps: inputProps,
        items: items.sort(function (i) {
          return i.label;
        }),
        shouldItemRender: function shouldItemRender(item, value) {
          return item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        },
        renderItem: function renderItem(item, isHighlighted) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pa1', style: { background: isHighlighted ? 'lightgray' : '#fff' } },
            item.label
          );
        },
        value: value,
        onChange: function onChange(e) {
          return _this2.setState({ value: e.target.value });
        },
        onSelect: function onSelect(val) {
          _this2.setState({ value: countries[val] });
          selectCountry(val);
        }

      });
    }
  }]);

  return SelectedCountryInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (SelectedCountryInput);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dimensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dimensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Otext = __WEBPACK_IMPORTED_MODULE_4_redux_tooltip__["Origin"].wrapBy('text');
var CAT_A_TOOLTIP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { style: { width: 300 } },
  'Provisions that the Member will implement by the time the Agreement enters into force (or in the case of a least-developed country Member within one year after entry into force)'
);
var CAT_B_TOOLTIP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { style: { width: 300 } },
  'Provisions that the Member will implement after a transitional period following the entry into force of the Agreement'
);
var CAT_C_TOOLTIP = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { style: { width: 300 } },
  'Provisions that the Member will implement on a date after a transitional period following the entry into force of the Agreement and requiring the acquisition of assistance and support for capacity building.'
);

var TrendChartTFAArticle = function (_React$PureComponent) {
  _inherits(TrendChartTFAArticle, _React$PureComponent);

  function TrendChartTFAArticle() {
    _classCallCheck(this, TrendChartTFAArticle);

    return _possibleConstructorReturn(this, (TrendChartTFAArticle.__proto__ || Object.getPrototypeOf(TrendChartTFAArticle)).apply(this, arguments));
  }

  _createClass(TrendChartTFAArticle, [{
    key: 'render',
    value: function render() {
      //const { dataByCountry, countryCode, indicatorData, height=50, numYears=7, containerWidth } = this.props
      var _props = this.props,
          _props$height = _props.height,
          height = _props$height === undefined ? 50 : _props$height,
          containerWidth = _props.containerWidth,
          _props$showScores = _props.showScores,
          showScores = _props$showScores === undefined ? true : _props$showScores,
          dataByCountry = _props.dataByCountry,
          _props$comparisonData = _props.comparisonDataByCountry,
          comparisonDataByCountry = _props$comparisonData === undefined ? null : _props$comparisonData,
          valueMax = _props.valueMax;

      // const margin = 4

      var pieceWidth = containerWidth / 4;

      var getNormalizedValue = function getNormalizedValue(dataset) {
        return function (label) {
          var absValue = dataset[label];
          var maxValue = valueMax;
          return (100 * absValue / maxValue).toFixed(0) + '%';
        };
      };

      var getNormalizedData = getNormalizedValue(dataByCountry);
      var getNormalizedComparison = getNormalizedValue(comparisonDataByCountry);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { height: height, className: 'TrendChartTFAArticle__svg' },
        showScores && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { transform: 'translate(0 ,0)' },
          dataByCountry && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(dataByCountry, 'v') !== null && comparisonDataByCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: 0,
                x: pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'SCORE'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country'
              },
              getNormalizedData('v')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Otext,
              {
                content: CAT_A_TOOLTIP,
                y: 0,
                x: pieceWidth + pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'CATEGORY A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country'
              },
              getNormalizedData('A')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Otext,
              {
                content: CAT_B_TOOLTIP,
                y: 0,
                x: pieceWidth * 2 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'CATEGORY B'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth * 2 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country'
              },
              getNormalizedData('B')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Otext,
              {
                content: CAT_C_TOOLTIP,
                y: 0,
                x: pieceWidth * 3 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'CATEGORY C'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth * 3 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country'
              },
              getNormalizedData('C')
            )
          ),
          dataByCountry && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(dataByCountry, 'v') !== null && comparisonDataByCountry && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(comparisonDataByCountry, 'v') !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'g',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: 0,
                x: pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'SCORE'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country--multi'
              },
              getNormalizedData('v'),
              '\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_comparison'
              },
              '\xA0',
              getNormalizedComparison('v')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Otext,
              {
                content: CAT_A_TOOLTIP,
                y: 0,
                x: pieceWidth + pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'CATEGORY A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country--multi'
              },
              getNormalizedComparison('A'),
              '\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_comparison'
              },
              '\xA0',
              getNormalizedData('A')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Otext,
              {
                content: CAT_B_TOOLTIP,
                y: 0,
                x: pieceWidth * 2 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'CATEGORY B'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth * 2 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country--multi'
              },
              getNormalizedData('B'),
              '\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth * 2 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_comparison'
              },
              '\xA0',
              getNormalizedComparison('B')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Otext,
              {
                content: CAT_C_TOOLTIP,
                y: 0,
                x: pieceWidth * 3 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__toplabel'
              },
              'CATEGORY C'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth * 3 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_country--multi'
              },
              getNormalizedData('C'),
              '\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'text',
              {
                y: height / 2,
                x: pieceWidth * 3 + pieceWidth / 2,
                className: 'TrendChartTFAArticle__score_comparison'
              },
              '\xA0',
              getNormalizedComparison('C')
            )
          )
        )
      );
    }
  }]);

  return TrendChartTFAArticle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    countries: state.countries,
    tfaMeta: state.tfaMeta
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3_react_dimensions___default()()(TrendChartTFAArticle)));

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TrendFacilitationHeader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SideCountriesSelector__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SideCountryTrends__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MultiStarChart__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_csvdownload__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CountryFacilitationPoliciesLegend = function CountryFacilitationPoliciesLegend(_ref) {
  var close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__components_Modal__["a" /* default */],
    { close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/legend/02.png', alt: 'Legend' })
  );
};

var INDICATORS_LIST = ['inf_availability', 'inv_community', 'adv_rulings', 'appeal_proc', 'fees_charges', 'form_docs', 'form_auto', 'form_proc', 'int_cooperation', 'ext_cooperation', 'gov_impartiality'];

var TFA_ARTICLES_LIST = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
var TFA_ARTICLES_DESCRIPTIONS = {
  '1': 'Publication and availability of information',
  '2': 'Opportunity to comment, information before entry into force and consultations',
  '3': 'Advance rulings',
  '4': 'Procedures for appeal or review',
  '5': 'Other measures to enhance impartiality, non-discrimination and transparency',
  '6': 'Disciplines on fees and charges imposed on or in connection with importation and exportation and penalties',
  '7': 'Release and clearance of goods',
  '8': 'Border agency cooperation',
  '9': 'Movement of goods intended for import under customs control',
  '10': 'Formalities connected with importation, exportation and transit',
  '11': 'Freedom of transit',
  '12': 'Customs cooperation'
};

var CountryFacilitationPolicies = function (_React$PureComponent) {
  _inherits(CountryFacilitationPolicies, _React$PureComponent);

  function CountryFacilitationPolicies() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, CountryFacilitationPolicies);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CountryFacilitationPolicies.__proto__ || Object.getPrototypeOf(CountryFacilitationPolicies)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      latestDataByIndicator: __webpack_require__(133),
      legend: false,
      focus: null
    }, _this.toggleLegend = function (e) {
      _this.setState({ legend: !_this.state.legend });
    }, _this.handleFocusChange = function (item) {
      _this.setState({ focus: item ? item.value : null });
    }, _this.downloadCsv = function (e) {
      var countries = _this.props.countries;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_csvdownload__["a" /* getCsvFile */])('country-facilitation.csv', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(countries).sort(), INDICATORS_LIST, TFA_ARTICLES_LIST);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CountryFacilitationPolicies, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loadCountryFacilitation();
      this.props.loadTfaArticles();
      this.props.loadTfaProvisions();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.unloadCountryFacilitation();
      this.props.setSelectedCountry(null);
      this.props.setSelectedCountryData(null);
      this.props.setComparisonCountry(null);
      this.props.setComparisonCountryData(null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          indicators = _props.indicators,
          selectedCountry = _props.selectedCountry,
          tfaArticles = _props.tfaArticles,
          tfaMeta = _props.tfaMeta;
      var focus = this.state.focus;

      //indicators list for SideCountryTrends

      var indicatorsList = INDICATORS_LIST.filter(function (code) {
        return indicators[code];
      }).map(function (code) {
        return indicators[code];
      }).filter(function (i) {
        return i.domain;
      });

      var tfaArticlesList = TFA_ARTICLES_LIST;

      var focusIndicatorOptions = indicatorsList.map(function (i) {
        return { label: i.shortTitle, value: i.globalId };
      }).concat(tfaArticlesList.map(function (i) {
        return { label: 'TFA Article ' + i, value: i };
      }));

      var activeByFocused = {
        inf_availability: { tfa: ['1'], ind: ['inf_availability'] },
        inv_community: { tfa: ['2'], ind: ['inv_community'] },
        adv_rulings: { tfa: ['3'], ind: ['adv_rulings'] },
        appeal_proc: { tfa: ['4'], ind: ['appeal_proc'] },
        fees_charges: { tfa: ['6'], ind: ['fees_charges'] },
        form_docs: { tfa: ['10'], ind: ['form_docs'] },
        form_auto: { tfa: ['7'], ind: ['form_auto'] },
        form_proc: { tfa: ['7', '10'], ind: ['form_proc'] },
        int_cooperation: { tfa: ['8'], ind: ['int_cooperation'] },
        ext_cooperation: { tfa: ['8'], ind: ['ext_cooperation'] },
        gov_impartiality: { tfa: [], ind: ['gov_impartiality'] },

        '1': { tfa: ['1'], ind: ['inf_availability'] },
        '2': { tfa: ['2'], ind: ['inv_community'] },
        '3': { tfa: ['3'], ind: ['adv_rulings'] },
        '4': { tfa: ['4'], ind: ['appeal_proc'] },
        '5': { tfa: ['5'], ind: [] },

        '6': { tfa: ['6'], ind: ['fees_charges'] },
        '7': { tfa: ['7'], ind: ['form_auto', 'form_proc'] },
        '8': { tfa: ['8'], ind: ['int_cooperation', 'int_cooperation'] },
        '9': { tfa: ['8'], ind: [] },
        '10': { tfa: ['10'], ind: ['form_docs', 'form_proc'] },
        '11': { tfa: ['11'], ind: [] },
        '12': { tfa: ['12'], ind: [] }
      };

      var focusedOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(activeByFocused, '[' + focus + ']', null);
      if (focus) {
        var validIndicators = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(activeByFocused, '[' + focus + '].ind', []);
        indicatorsList = indicatorsList.filter(function (i) {
          return validIndicators.indexOf(i.globalId) !== -1;
        });
        tfaArticlesList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(activeByFocused, '[' + focus + '].tfa', []);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_TrendFacilitationHeader__["a" /* default */], { showSortMode: 'sort', hasShowSort: false }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'h-container cf' },
          this.state.legend && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountryFacilitationPoliciesLegend, { close: this.toggleLegend }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-40-l ph4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'text-blue text-medium' },
              'Trade facilitation policies and TFA notifications'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-third fl tc' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  {
                    onClick: this.toggleLegend,
                    className: 'explore-link link-lightblue underline pointer',
                    to: '/topics/ETIB03'
                  },
                  'LEGEND'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-third fl tr' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  {
                    className: 'explore-link link-lightblue underline pointer',
                    onClick: this.downloadCsv
                  },
                  'DOWNLOAD'
                )
              )
            ),
            selectedCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'leftside-text text-gray' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Under the World Trade Organization\u2019s (WTO) Trade Facilitation Agreement (TFA) which entered into force in 2017, developing countries can ask for assistance from the international community to implement specific provisions of the agreement.',
                ' '
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'They are expected to send to the WTO a notification list categorising the TFA provisions under one of the following categories:',
                ' '
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u25AA Category A: Provisions that the Member will implement by the time the Agreement enters into force (or in the case of a least-developed country Member within one year after entry into force)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u25AA Category B: Category B: Provisions that the Member will implement after a transitional period following the entry into force of the Agreement',
                ' '
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u25AA Category C: Provisions that the Member will implement on a date after a transitional period following the entry into force of the Agreement and requiring the acquisition of assistance and support for capacity building.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'The figure provides an overview of the policies currently in place in the countries as measured by the OECD Trade Facilitation Indicators (blue petals) and of their notifications grouped by the 12 articles of the TFA (red petals). Longer rays represent, respectively, better trade facilitation policies and more comprehensive commitments with respect to the TFA articles.'
              )
            ),
            selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'mt3 text-blue pt3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'blue-text' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'small',
                    null,
                    'FOCUS ON TOPIC'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select___default.a, {
                  className: 'FocusSelect',
                  name: 'select_focus',
                  value: this.state.focus,
                  clearable: true,
                  options: focusIndicatorOptions,
                  onChange: this.handleFocusChange
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SideCountriesSelector__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SideCountryTrends__["a" /* default */], {
                indicatorsList: indicatorsList,
                tfaArticles: tfaArticles,
                tfaArticlesList: tfaArticlesList,
                tfaArticlesDescriptions: TFA_ARTICLES_DESCRIPTIONS,
                tfaMeta: tfaMeta
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-60-l' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf pa2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                {
                  className: 'link-orange no-underline hero-top-link fl pa2 mb3',
                  to: '/third-pillar'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'small',
                  null,
                  '< BORDER TRANSPARENCY AND EFFICIENCY'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                {
                  className: 'link-orange no-underline hero-top-link fr pa2 pr4 mb3',
                  to: '/enabling-trade-environment'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'small',
                  null,
                  'THE ENABLING TRADE ENVIRONMENT >'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_MultiStarChart__["a" /* default */], {
                focusedOptions: focusedOptions,
                latestDataByIndicator: this.state.latestDataByIndicator,
                tfaArticles: tfaArticles
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf ph2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                {
                  className: 'link-orange no-underline hero-top-link fl pa2 mb3',
                  to: '/third-pillar'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'small',
                  null,
                  '< BORDER TRANSPARENCY AND EFFICIENCY'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                {
                  className: 'link-orange no-underline hero-top-link fr pa2 pr4 mb3',
                  to: '/enabling-trade-environment'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'small',
                  null,
                  'SEVEN PILLARS >'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CountryFacilitationPolicies;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    selectedCountry: state.selectedCountry,
    selectedCountryData: state.selectedCountryData,
    comparisonCountry: state.comparisonCountry,
    comparisonCountryData: state.comparisonCountryData,
    countryFacilitationPolicies: state.countryFacilitationPolicies.data,
    tfaArticles: state.tfaArticles.data,
    tfaMeta: state.tfaMeta,
    tfaProvisions: state.tfaProvisions.data
  };
};

var mapDispatchToProps = {
  loadCountryFacilitation: __WEBPACK_IMPORTED_MODULE_10__state_actions__["I" /* loadCountryFacilitation */],
  unloadCountryFacilitation: __WEBPACK_IMPORTED_MODULE_10__state_actions__["J" /* unloadCountryFacilitation */],
  loadTfaArticles: __WEBPACK_IMPORTED_MODULE_10__state_actions__["a" /* loadTfaArticles */],
  loadTfaProvisions: __WEBPACK_IMPORTED_MODULE_10__state_actions__["K" /* loadTfaProvisions */],
  setSelectedCountry: __WEBPACK_IMPORTED_MODULE_10__state_actions__["B" /* setSelectedCountry */],
  setComparisonCountry: __WEBPACK_IMPORTED_MODULE_10__state_actions__["A" /* setComparisonCountry */],
  setSelectedCountryData: __WEBPACK_IMPORTED_MODULE_10__state_actions__["C" /* setSelectedCountryData */],
  setComparisonCountryData: __WEBPACK_IMPORTED_MODULE_10__state_actions__["D" /* setComparisonCountryData */]
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(CountryFacilitationPolicies));

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataExplorerHeader__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataExplorerHeaderSmall__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataExplorerIndex__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DataExplorerCountries__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataExplorerCountry__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DataExplorerTopics__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DataExplorerTopic__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DataExplorerTopicTFA__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DataExplorerSources__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var DataExplorer = function (_React$PureComponent) {
  _inherits(DataExplorer, _React$PureComponent);

  function DataExplorer() {
    _classCallCheck(this, DataExplorer);

    return _possibleConstructorReturn(this, (DataExplorer.__proto__ || Object.getPrototypeOf(DataExplorer)).apply(this, arguments));
  }

  _createClass(DataExplorer, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Switch */],
          { key: location.key, location: location },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/', exact: true, component: __WEBPACK_IMPORTED_MODULE_3__components_DataExplorerHeader__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/countries', exact: true, component: __WEBPACK_IMPORTED_MODULE_3__components_DataExplorerHeader__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/countries/:countryCode', exact: true, component: __WEBPACK_IMPORTED_MODULE_4__components_DataExplorerHeaderSmall__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/topics', exact: true, component: __WEBPACK_IMPORTED_MODULE_3__components_DataExplorerHeader__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/topics/:topic', exact: true, component: __WEBPACK_IMPORTED_MODULE_4__components_DataExplorerHeaderSmall__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/tfa/:topic', exact: true, component: __WEBPACK_IMPORTED_MODULE_4__components_DataExplorerHeaderSmall__["a" /* default */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/sources', exact: true, component: __WEBPACK_IMPORTED_MODULE_4__components_DataExplorerHeaderSmall__["a" /* default */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'cf ph5 pv3' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'h-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Switch */],
              { key: location.key, location: location },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/', exact: true, component: __WEBPACK_IMPORTED_MODULE_5__DataExplorerIndex__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/countries', exact: true, component: __WEBPACK_IMPORTED_MODULE_6__DataExplorerCountries__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/countries/:countryCode', exact: true, component: __WEBPACK_IMPORTED_MODULE_7__DataExplorerCountry__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/topics', exact: true, component: __WEBPACK_IMPORTED_MODULE_8__DataExplorerTopics__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/topics/:topic', exact: true, component: __WEBPACK_IMPORTED_MODULE_9__DataExplorerTopic__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/tfa/:topic', exact: true, component: __WEBPACK_IMPORTED_MODULE_10__DataExplorerTopicTFA__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/sources', exact: true, component: __WEBPACK_IMPORTED_MODULE_11__DataExplorerSources__["a" /* default */] })
            )
          )
        )
      );
    }
  }]);

  return DataExplorer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null, { setDataByCountry: __WEBPACK_IMPORTED_MODULE_12__state_actions__["N" /* setDataByCountry */], setDataByIndicator: __WEBPACK_IMPORTED_MODULE_12__state_actions__["O" /* setDataByIndicator */] })(DataExplorer)));

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DataExplorerCountries = function (_React$PureComponent) {
  _inherits(DataExplorerCountries, _React$PureComponent);

  function DataExplorerCountries() {
    _classCallCheck(this, DataExplorerCountries);

    return _possibleConstructorReturn(this, (DataExplorerCountries.__proto__ || Object.getPrototypeOf(DataExplorerCountries)).apply(this, arguments));
  }

  _createClass(DataExplorerCountries, [{
    key: 'render',
    value: function render() {
      var countries = this.props.countries;

      var countryCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(countries), function (i) {
        return countries[i];
      });
      var splitCountries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["chunk"])(countryCodes, countryCodes.length / 3 + 1);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'f2 lh-title text-orange' },
          'Countries'
        ),
        splitCountries.map(function (column, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: i, className: 'fl w-third pa1' },
            column.map(function (countryCode) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: countryCode },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                  { className: 'no-underline underline-hover text-blue Countries__country', to: '/countries/' + countryCode },
                  countries[countryCode]
                )
              );
            })
          );
        })
      );
    }
  }]);

  return DataExplorerCountries;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, undefined)(DataExplorerCountries));

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TrendChart__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DistributionChart__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SunBurstChart__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_StarChart__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_BubbleAndBarChart__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Spinner__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var thirdPillarIndicators = [__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* thirdPillarMainTopic */]].concat(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* thirdPillarTopics */]);
var sevenPillarsIndicators = [__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* sevenPillarsMainTopic */]].concat(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* sevenPillarsTopics */]);

var DtHeader = function DtHeader() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'cf pa3' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-30' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading' },
        'INDICATOR'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-25' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading' },
        'DISTRIBUTION'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-25' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading' },
        'TREND'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-20' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading' },
        'SCORE'
      )
    )
  );
};

var DtHeaderTFA = function DtHeaderTFA() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'cf pa3' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-20' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading' },
        'TFA ARTICLE'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-20' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading tl' },
        'CATEGORY A'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-20' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading tl' },
        'CATEGORY B'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-20' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading tl' },
        'CATEGORY C'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fl w-20' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        { className: 'f3 lh-copy DataExplorer__table_heading tl' },
        'SCORE'
      )
    )
  );
};

var DtBody = function DtBody(_ref) {
  var indicatorsForCountry = _ref.indicatorsForCountry,
      countryData = _ref.countryData,
      indicators = _ref.indicators,
      countryCode = _ref.countryCode,
      latestDataByIndicator = _ref.latestDataByIndicator,
      meta = _ref.meta;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    indicatorsForCountry.map(function (indicator) {
      //latest value
      var lastYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(countryData[indicator]));
      if (!lastYear) {
        return null;
      }
      var value = countryData[indicator][lastYear]['v'];
      var m = countryData[indicator][lastYear]['m'];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cf pa3 bb border-blue', key: indicator },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-30' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DataExplorer__Block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_redux_tooltip__["Origin"],
              {
                content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  indicators[indicator].titleWithUnits && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    indicators[indicator].titleWithUnits
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Rank direction:',
                    ' ',
                    indicators[indicator].rankDirection === '0' ? 'High is better' : 'Low is better'
                  ),
                  indicators[indicator].domain && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Domain: ',
                    indicators[indicator].domain[0],
                    ' -',
                    ' ',
                    indicators[indicator].domain[1],
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                  )
                )
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                {
                  className: 'no-underline underline-hover text-blue',
                  to: '/topics/' + indicator
                },
                indicators[indicator].shortTitle || indicators[indicator].globalId
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-25' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ph2 w-75' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_DistributionChart__["a" /* default */], {
              indicator: indicator,
              countryCode: countryCode,
              distributionData: latestDataByIndicator[indicator],
              style: { width: '100%' }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-25' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ph2 w-75' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_TrendChart__["a" /* default */], {
              showScores: false,
              indicatorData: indicators[indicator],
              countryCode: countryCode,
              dataByCountry: countryData[indicator]
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-20 cf' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DataExplorer__Block cf' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'w-100' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-25 tl' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'DataExplorer__Value' },
                  value
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-75 tr' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12_redux_tooltip__["Origin"],
                  {
                    content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { maxWidth: '300' } },
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(meta, m, '').replace(/\|/g, ' | ').split(';').map(function (piece) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { key: piece },
                          piece
                        );
                      })
                    )
                  },
                  'MORE INFO'
                )
              )
            )
          )
        )
      );
    })
  );
};

var DtBodyTFA = function DtBodyTFA(_ref2) {
  var indicatorsForCountry = _ref2.indicatorsForCountry,
      tfaArticles = _ref2.tfaArticles,
      tfaMeta = _ref2.tfaMeta,
      countryCode = _ref2.countryCode,
      latestDataByIndicator = _ref2.latestDataByIndicator,
      meta = _ref2.meta;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    indicatorsForCountry.map(function (indicator) {
      //latest value
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(tfaArticles[indicator], '[' + countryCode + '][\'v\']', null);
      var valueA = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(tfaArticles[indicator], '[' + countryCode + '][\'A\']', null);
      var valueB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(tfaArticles[indicator], '[' + countryCode + '][\'B\']', null);
      var valueC = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(tfaArticles[indicator], '[' + countryCode + '][\'C\']', null);
      var max = tfaMeta[indicator].max;

      var getPercent = function getPercent(val) {
        return (100 * val / max).toFixed(2) + '%';
      };

      if (value === null) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cf pa3 bb border-blue', key: indicator },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-20' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DataExplorer__Block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12_redux_tooltip__["Origin"],
              {
                content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  'TFA Article ' + indicator,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    'Domain: ',
                    '0',
                    ' - ',
                    tfaMeta[indicator].max,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
                  )
                )
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                {
                  className: 'no-underline underline-hover text-blue',
                  to: '//tfa/' + indicator
                },
                'TFA Article ' + indicator
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-20' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DataExplorer__Block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'DataExplorer__Value' },
              getPercent(valueA)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-20' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DataExplorer__Block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'DataExplorer__Value' },
              getPercent(valueB)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-20' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DataExplorer__Block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'DataExplorer__Value' },
              getPercent(valueC)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-20 cf' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'DataExplorer__Block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'w-100' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-25 tl' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'DataExplorer__Value' },
                  value.toFixed(2)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-75 tr' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12_redux_tooltip__["Origin"],
                  {
                    content: 'Ratified on ' + tfaArticles[indicator][countryCode].date
                  },
                  'MORE INFO'
                )
              )
            )
          )
        )
      );
    })
  );
};

// Render all indicators is very expansive so slpit
// the render of table in a component \w fixed props as dependencies
// (remove router / transition stuff that trigegger useless re renders)

var IndicatorsTable = function (_React$PureComponent) {
  _inherits(IndicatorsTable, _React$PureComponent);

  function IndicatorsTable() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, IndicatorsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = IndicatorsTable.__proto__ || Object.getPrototypeOf(IndicatorsTable)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      countryData: null,
      loading: true,
      latestDataByIndicator: __webpack_require__(133)
    }, _this.componentWillUnmount = function () {
      _this.fetcher.cancel();
    }, _this.componentWillMount = function () {
      var countryCode = _this.props.countryCode;

      var fileName = '/by_country/' + countryCode.toLowerCase() + '.json';
      _this.fetcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* makeCancelable */])(fetch(fileName));

      _this.fetcher.promise.then(function (response) {
        return response.json().then(function (data) {
          return _this.setState({ countryData: data, loading: false });
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IndicatorsTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          meta = _props.meta,
          indicators = _props.indicators,
          countryCode = _props.countryCode,
          tfaArticles = _props.tfaArticles,
          tfaMeta = _props.tfaMeta;
      var _state = this.state,
          countryData = _state.countryData,
          latestDataByIndicator = _state.latestDataByIndicator,
          loading = _state.loading;

      var indicatorsForCountry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(countryData).sort();

      if (loading) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Spinner__["a" /* default */], null);
      }

      var passPropsSunBurst = {
        indicatorsForCountry: indicatorsForCountry.filter(function (i) {
          return thirdPillarIndicators.indexOf(i) !== -1;
        }),
        countryData: countryData,
        indicators: indicators,
        countryCode: countryCode,
        latestDataByIndicator: latestDataByIndicator,
        meta: meta
      };

      var passPropsBubbles = {
        indicatorsForCountry: indicatorsForCountry.filter(function (i) {
          return sevenPillarsIndicators.indexOf(i) !== -1;
        }),
        countryData: countryData,
        indicators: indicators,
        countryCode: countryCode,
        latestDataByIndicator: latestDataByIndicator,
        meta: meta
      };

      var passPropsStar = {
        indicatorsForCountry: indicatorsForCountry.filter(function (i) {
          return __WEBPACK_IMPORTED_MODULE_9__utils__["g" /* countryFacilitationTopics */].indexOf(i) !== -1;
        }),
        countryData: countryData,
        indicators: indicators,
        countryCode: countryCode,
        latestDataByIndicator: latestDataByIndicator,
        meta: meta
      };

      var passPropsStarTFA = {
        indicatorsForCountry: __WEBPACK_IMPORTED_MODULE_9__utils__["h" /* allTFAArticles */],
        tfaArticles: tfaArticles,
        tfaMeta: tfaMeta,
        countryCode: countryCode,
        latestDataByIndicator: latestDataByIndicator,
        meta: meta
      };

      var hasTfa = __WEBPACK_IMPORTED_MODULE_9__utils__["h" /* allTFAArticles */].filter(function (a) {
        return tfaArticles[a][countryCode];
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cf' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'w-50-l fl-l w-100' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100 border-blue' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SunBurstChart__["a" /* default */], {
                  height: 400,
                  showCountryLabel: false,
                  showDownloads: true,
                  latestDataByIndicator: latestDataByIndicator,
                  countryCode: countryCode
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'w-50-l fl-l w-100 ph3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'text-orange' },
                'Efficiency and transparency of border administration'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'text-blue' },
                'The graph provides information about the 13 key indicators on the efficiency and transparency of border administration included in the Enabling Trade Index. The size of each ray reflects the performance of the economy on that indicator (longer rays indicate better performance)'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtHeader, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtBody, passPropsSunBurst),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'w-100' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf mt5' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl-l w-50-l w-100 DataExplorerCountry__Preview border-blue' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_StarChart__["a" /* default */], {
                  height: 400,
                  showCountryLabel: false,
                  showDownloads: true,
                  tfaArticles: tfaArticles,
                  latestDataByIndicator: latestDataByIndicator,
                  countryCode: countryCode
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-50-l fl-l w-100 ph3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'text-orange' },
                  'Trade facilitation policies and TFA notifications'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'text-blue' },
                  'The graph provides an overview of the trade facilitation policies in the country through the lenses of OECD Trade Facilitation Indicators (blue petals); and of its commitments under the Trade Facilitation Agreement (red petals). OECD indicators are based on a 0 (worst) to 2 (best) scale. Red petals represent the share (0-100) of provisions of each article of the TFA which have been notified under any of the three categories (A, B and C).'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtHeader, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtBody, passPropsStar),
          hasTfa && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtHeaderTFA, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtBodyTFA, passPropsStarTFA)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'w-100 pa3' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf mt5' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl-l w-50-l w-100 DataExplorerCountry__Preview border-blue' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_BubbleAndBarChart__["a" /* default */], {
                  height: 400,
                  showCountryLabel: false,
                  showDownloads: true,
                  latestDataByIndicator: latestDataByIndicator,
                  countryCode: countryCode
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-50-l fl-l w-100 ph3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'text-orange' },
                  'Enabling trade environment'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'text-blue' },
                  'In the graph, the length of the blue shaded area reflects the country\u2019s performance in the overall Enabling Trade Index, while the seven rays represent the seven underlying pillars. The third pillar on the efficiency and transparency of border administration is highlighted in orange.'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtHeader, null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DtBody, passPropsBubbles)
      );
    }
  }]);

  return IndicatorsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var DataExplorerCountry = function (_React$PureComponent2) {
  _inherits(DataExplorerCountry, _React$PureComponent2);

  function DataExplorerCountry() {
    _classCallCheck(this, DataExplorerCountry);

    return _possibleConstructorReturn(this, (DataExplorerCountry.__proto__ || Object.getPrototypeOf(DataExplorerCountry)).apply(this, arguments));
  }

  _createClass(DataExplorerCountry, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loadTfaArticles();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          countries = _props2.countries,
          indicators = _props2.indicators,
          meta = _props2.meta,
          tfaArticles = _props2.tfaArticles,
          tfaMeta = _props2.tfaMeta,
          match = _props2.match;
      var countryCode = match.params.countryCode;

      //if(!dataByCountry[countryCode]) { return null }

      //const countryData = dataByCountry[countryCode]

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'f3 lh-copy text-blue' },
          countries[countryCode]
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pa1 cf' },
          tfaArticles && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { minHeight: 500 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorsTable, {
              indicators: indicators,
              countryCode: countryCode,
              meta: meta,
              tfaArticles: tfaArticles,
              tfaMeta: tfaMeta
              // countryData={countryData}
            })
          )
        )
      );
    }
  }]);

  return DataExplorerCountry;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    meta: state.meta,
    tfaArticles: state.tfaArticles.data,
    tfaMeta: state.tfaMeta
    //dataByCountry: state.dataByCountry,
  };
};

var mapDispatchToProps = { loadTfaArticles: __WEBPACK_IMPORTED_MODULE_11__state_actions__["a" /* loadTfaArticles */] };

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(DataExplorerCountry));

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var menuStyle = {
  backgroundColor: '#fff',
  padding: '2px 0',
  magin: '0px',
  position: 'absolute',
  overflow: 'auto',
  color: "#222",
  width: "100%",
  fontSize: '14px',
  border: "solid #ccc 1px",
  borderTop: "none"
};

var DataExplorerIndex = function (_React$Component) {
  _inherits(DataExplorerIndex, _React$Component);

  function DataExplorerIndex() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataExplorerIndex);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataExplorerIndex.__proto__ || Object.getPrototypeOf(DataExplorerIndex)).call.apply(_ref, [this].concat(args))), _this), _this.handleCountryChange = function (item) {
      _this.props.history.push('/countries/' + item.value);
    }, _this.handleIndicatorChange = function (item) {
      _this.props.history.push('/topics/' + item.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DataExplorerIndex, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          countries = _props.countries,
          indicators = _props.indicators;

      var countryOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(countries).map(function (c) {
        return { label: countries[c], value: c };
      }), function (i) {
        return i.label;
      });
      var indicatorsOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(indicators).filter(function (i) {
        return indicators[i].domain;
      }).map(function (c) {
        return { label: indicators[c].title, value: c };
      }), function (i) {
        return i.label;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Home' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-50-l w-100 pa2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'ml4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Link */],
                { to: '/countries', className: 'no-underline underline-hover text-orange' },
                'Countries'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Link */],
              { to: '/countries' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'center pa2 dt DataExplorer__Preview border-blue DataExplorer__Preview--border' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'v-mid dtc tc' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/covers/cover1.png', className: '', alt: 'Countries cover' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pa2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'mt3 ph3 text-blue' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select___default.a, {
                  menuStyle: menuStyle,
                  className: 'Home__Select',
                  name: 'select_focus',
                  placeholder: 'Select country',
                  clearable: true,
                  options: countryOptions,
                  onChange: this.handleCountryChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-50-l w-100 pa2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'ml4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Link */],
                { to: '/topics', className: 'no-underline underline-hover text-orange' },
                'Topics and Unit of Analysis'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Link */],
              { to: '/topics' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'center pa2 dt DataExplorer__Preview border-blue DataExplorer__Preview--border' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'v-mid dtc tc' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/covers/cover3.png', className: '', alt: 'Topics cover' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pa2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'mt3 ph3 text-blue' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select___default.a, {
                  menuStyle: menuStyle,
                  className: 'Home__Select',
                  name: 'select_focus',
                  placeholder: 'Select indicator',
                  clearable: true,
                  options: indicatorsOptions,
                  onChange: this.handleIndicatorChange
                })
              )
            )
          )
        )
      );
    }
  }]);

  return DataExplorerIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators
  };
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(DataExplorerIndex));

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DataExplorerSources = function (_React$Component) {
  _inherits(DataExplorerSources, _React$Component);

  function DataExplorerSources() {
    _classCallCheck(this, DataExplorerSources);

    return _possibleConstructorReturn(this, (DataExplorerSources.__proto__ || Object.getPrototypeOf(DataExplorerSources)).apply(this, arguments));
  }

  _createClass(DataExplorerSources, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'f2 lh-title text-orange' },
          'Data sources'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fl w-third pa1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            '[WEF] Executive Opinion Survey'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            '[OECD] Trade Facilitation Indicators'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            '[WBTS] Logistics Performance Index'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            '[START] Global Terrorism Database'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            '[ITC] Market Access Map Database'
          )
        )
      );
    }
  }]);

  return DataExplorerSources;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DataExplorerSources);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TrendChart__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MultiTrendChart__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DistributionChart__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MapChart__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state_selectors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Spinner__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var DataExplorerTopic = function (_React$Component) {
  _inherits(DataExplorerTopic, _React$Component);

  function DataExplorerTopic() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataExplorerTopic);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataExplorerTopic.__proto__ || Object.getPrototypeOf(DataExplorerTopic)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      indicatorData: null,
      loading: true,
      latestDataByIndicator: __webpack_require__(133)
    }, _this.componentWillMount = function () {
      var match = _this.props.match;
      var topic = match.params.topic;

      var fileName = '/by_indicator/' + topic.toLowerCase() + '.json';

      _this.fetcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* makeCancelable */])(fetch(fileName));
      _this.fetcher.promise.then(function (response) {
        return response.json().then(function (data) {
          _this.setState({ indicatorData: data, loading: false });
        });
      });
    }, _this.componentWillUnmount = function () {
      _this.fetcher.cancel();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DataExplorerTopic, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          countries = _props.countries,
          indicators = _props.indicators,
          meta = _props.meta,
          match = _props.match;
      var topic = match.params.topic;
      var _state = this.state,
          indicatorData = _state.indicatorData,
          latestDataByIndicator = _state.latestDataByIndicator,
          loading = _state.loading;
      //const indicatorData = dataByIndicator[topic]

      var dataMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__state_selectors__["a" /* getLatestFromData */])(indicatorData).reduce(function (acc, val) {
        acc[val.country] = val.v;
        return acc;
      }, {});

      var countriesForIndicator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(indicatorData), function (i) {
        return countries[i];
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'f3 lh-copy text-blue' },
          indicators[topic].shortTitle || indicators[topic].globalId
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pa1 cf' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            indicators[topic].fullDescription
          ),
          loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Spinner__["a" /* default */], null),
          !loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100 pa3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DataExplorerCountry__Preview border-blue' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_MapChart__["a" /* default */], { dataMap: dataMap, height: 400,
                    topic: topic,
                    interactive: false,
                    showDownloads: true,
                    decreasing: indicators[topic].rankDirection === '1',
                    emptyFill: "#eee", minScale: 0, className: 'h-100' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100 pa3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DataExplorerCountry__Preview border-blue' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_DistributionChart__["a" /* default */], { indicator: topic, height: 50, distributionData: latestDataByIndicator[topic], style: { width: '100%' } })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100 pa3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DataExplorerCountry__Preview border-blue' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_MultiTrendChart__["a" /* default */], { indicatorData: indicators[topic],
                    height: 100, dataByIndicator: indicatorData, style: { width: '100%' } })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-third' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading' },
                  'COUNTRY'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-third' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading' },
                  'TREND'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-third' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading' },
                  'SCORE'
                )
              )
            ),
            countriesForIndicator.map(function (country) {

              //latest value
              var lastYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["max"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(indicatorData[country]));
              if (!lastYear) {
                return null;
              }
              var value = indicatorData[country][lastYear]['v'];
              var m = indicatorData[country][lastYear]['m'];

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cf pv3 bb border-blue', key: country },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'fl w-third' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DataExplorer__Block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                      { className: 'no-underline underline-hover text-blue', to: '/countries/' + country },
                      countries[country]
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'fl w-third' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'ph0' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_TrendChart__["a" /* default */], {
                      indicatorData: indicators[topic], showScores: false,
                      countryCode: country, dataByCountry: indicatorData[country] })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'fl w-third' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DataExplorer__Block cf' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'w-100' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'fl w-25 tl' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          { className: 'DataExplorer__Value' },
                          value
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'fl w-75 tr' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_11_redux_tooltip__["Origin"],
                          { content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { maxWidth: '300' } },
                              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(meta, m, "").replace(/\|/g, ' | ').split(";").map(function (piece) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  'div',
                                  { key: piece },
                                  piece
                                );
                              })
                            ) },
                          'MORE INFO'
                        )
                      )
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return DataExplorerTopic;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    meta: state.meta,
    dataByIndicator: state.dataByIndicator
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(DataExplorerTopic));

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MapChart__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var DataExplorerTopicTFA = function (_React$Component) {
  _inherits(DataExplorerTopicTFA, _React$Component);

  function DataExplorerTopicTFA() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataExplorerTopicTFA);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataExplorerTopicTFA.__proto__ || Object.getPrototypeOf(DataExplorerTopicTFA)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      indicatorData: null,
      loading: true
    }, _this.componentWillMount = function () {
      var match = _this.props.match;
      var topic = match.params.topic;

      var fileName = '/tfa/data_tfa_articles.json';

      _this.fetcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* makeCancelable */])(fetch(fileName));
      _this.fetcher.promise.then(function (response) {
        return response.json().then(function (data) {
          _this.setState({ indicatorData: data[topic], loading: false });
        });
      });
    }, _this.componentWillUnmount = function () {
      _this.fetcher.cancel();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DataExplorerTopicTFA, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          countries = _props.countries,
          match = _props.match;
      var topic = match.params.topic;
      var _state = this.state,
          indicatorData = _state.indicatorData,
          loading = _state.loading;

      //const indicatorData = dataByIndicator[topic]

      var dataMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(indicatorData).reduce(function (acc, val) {
        acc[val] = indicatorData[val].v;
        return acc;
      }, {});

      var countriesForIndicator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(indicatorData), function (i) {
        return countries[i];
      }).filter(function (i) {
        return countries[i];
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'f3 lh-copy text-blue' },
          'TFA Article ' + topic
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pa1 cf' },
          loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Spinner__["a" /* default */], null),
          !loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100 pa3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'DataExplorerCountry__Preview border-blue' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_MapChart__["a" /* default */], {
                    dataMap: dataMap,
                    height: 400,
                    topic: topic,
                    showDownloads: true,
                    tfa: true,
                    interactive: false,
                    decreasing: false,
                    emptyFill: '#eee',
                    minScale: 0,
                    className: 'h-100'
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100 pa3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DataExplorerCountry__Preview border-blue' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-100 pa3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'DataExplorerCountry__Preview border-blue' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-20' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading' },
                  'COUNTRY'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-20' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading tl' },
                  'CATEGORY A'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-20' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading tl' },
                  'CATEGORY B'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-20' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading tl' },
                  'CATEGORY C'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fl w-20' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'f3 lh-copy DataExplorer__table_heading tl' },
                  'SCORE'
                )
              )
            ),
            countriesForIndicator.map(function (country) {
              //latest value
              if (!indicatorData[country]) {
                return null;
              }
              var value = indicatorData[country]['v'];
              var valueA = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(indicatorData[country], 'A');
              var valueB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(indicatorData[country], 'B');
              var valueC = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(indicatorData[country], 'C'
              //const m = indicatorData[country][lastYear]['m']

              );return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cf pv3 bb border-blue', key: country },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'fl w-20' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DataExplorer__Block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                      {
                        className: 'no-underline underline-hover text-blue',
                        to: '//countries/' + country
                      },
                      country,
                      ' - ',
                      countries[country]
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'fl w-20' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DataExplorer__Block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'DataExplorer__Value' },
                      valueC.toFixed(2)
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'fl w-20 cf' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'DataExplorer__Block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'w-100' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'fl w-25 tl' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          { className: 'DataExplorer__Value' },
                          value.toFixed(2)
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'fl w-75 tr' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_7_redux_tooltip__["Origin"],
                          {
                            content: 'Ratified on ' + indicatorData[country].date
                          },
                          'MORE INFO'
                        )
                      )
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return DataExplorerTopicTFA;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    countries: state.countries,
    tfaMeta: state.tfaMeta
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(DataExplorerTopicTFA));

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DataExplorerTopic = function (_React$Component) {
  _inherits(DataExplorerTopic, _React$Component);

  function DataExplorerTopic() {
    _classCallCheck(this, DataExplorerTopic);

    return _possibleConstructorReturn(this, (DataExplorerTopic.__proto__ || Object.getPrototypeOf(DataExplorerTopic)).apply(this, arguments));
  }

  _createClass(DataExplorerTopic, [{
    key: 'render',
    value: function render() {
      var indicators = this.props.indicators;

      var indicatorsCodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keys"])(indicators).filter(function (code) {
        return indicators[code].shortTitle;
      }), function (i) {
        return indicators[i].shortTitle;
      });
      var splitIndicators = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["chunk"])(indicatorsCodes, indicatorsCodes.length / 3 + 1);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'f2 lh-title text-orange' },
          'Topics'
        ),
        splitIndicators.map(function (column, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: i, className: 'fl w-third pa1' },
            column.map(function (indicator) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: indicator },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                  { className: 'no-underline underline-hover text-blue Topics__topic', to: '/topics/' + indicator },
                  indicators[indicator].shortTitle
                )
              );
            })
          );
        })
      );
    }
  }]);

  return DataExplorerTopic;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    indicators: state.indicators
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(DataExplorerTopic));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TrendFacilitationHeader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SideCountriesSelector__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SideCountryTrends__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MapChart__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BubbleChart__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_csvdownload__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__state_selectors__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_css__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var vizOptions = [{ value: 'heatmap', label: 'Heatmap' }, { value: 'bubbles', label: 'Bubbles' }];

var INDICATORS_LIST = ['ETIA01', 'ETIA02', 'ETIB03', 'ETIC04', 'ETIC05', 'ETIC06', 'ETID07'];

var SevenPillarsLegend = function SevenPillarsLegend(_ref) {
  var close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__components_Modal__["a" /* default */],
    { close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/legend/03.png', alt: 'Legend' })
  );
};

var SevenPillars = function (_React$PureComponent) {
  _inherits(SevenPillars, _React$PureComponent);

  function SevenPillars() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, SevenPillars);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SevenPillars.__proto__ || Object.getPrototypeOf(SevenPillars)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      vizType: 'heatmap',
      legend: false
    }, _this.handleVizTypeChange = function (item) {
      _this.setState({ vizType: item.value });
    }, _this.toggleLegend = function (e) {
      _this.setState({ legend: !_this.state.legend });
    }, _this.downloadCsv = function (e) {
      var countries = _this.props.countries;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_csvdownload__["a" /* getCsvFile */])('seven-pillars.csv', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(countries).sort(), ['ETI'].concat(INDICATORS_LIST));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SevenPillars, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loadSevenPillars();
      if (!this.props.latestDataByIndicator) {
        this.props.loadLatestByIndicator();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.unloadSevenPillars();
      this.props.setSelectedCountry(null);
      this.props.setSelectedCountryData(null);
      this.props.setComparisonCountry(null);
      this.props.setComparisonCountryData(null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          indicators = _props.indicators,
          latestDataByIndicator = _props.latestDataByIndicator,
          selectedCountry = _props.selectedCountry,
          sevenPillarsData = _props.sevenPillarsData;
      var _state$vizType = this.state.vizType,
          vizType = _state$vizType === undefined ? 'heatmap' : _state$vizType;


      var dataForMap = sevenPillarsData.reduce(function (acc, val) {
        acc[val.country] = val.v;
        return acc;
      }, {});

      var topic = 'ETI';

      //indicators list for SideCountryTrends
      var indicatorsList = INDICATORS_LIST.filter(function (code) {
        return indicators[code];
      }).map(function (code) {
        return indicators[code];
      }).filter(function (i) {
        return i.domain;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TrendFacilitationHeader__["a" /* default */], { hasShowSort: vizType === 'bubbles', showSortMode: 'sort' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'h-container cf' },
          this.state.legend && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SevenPillarsLegend, { close: this.toggleLegend }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-40-l ph4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'text-blue text-medium' },
              'The enabling trade environment'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-third fl tc' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.toggleLegend,
                    className: 'explore-link link-lightblue underline pointer', to: '/topics/ETIB03' },
                  'LEGEND'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-third fl tr' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'explore-link link-lightblue underline pointer', onClick: this.downloadCsv },
                  'DOWNLOAD'
                )
              )
            ),
            selectedCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'leftside-text text-gray' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'While the efficiency and transparency of border processes are key factors to take into account when managing supply chains, other aspects are also relevant, including tariff structures, domestic infrastructure, logistics services and the broader operating environment of a country.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Through 57 indicators grouped into seven pillars, the Enabling Trade Index provides an overview of the institutions, policies, infrastructures and services facilitating the free flow of goods over borders and to their destination in 136 economies.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Results are expressed on a scale of 1 (worst) to 7 (best). ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                ' You can visualise a summary of the results through a heatmap or a bubble graph, and click on each country for a more detailed analysis.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pa1 text-blue' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'blue-text' },
                'VISUALISE AS'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select___default.a, {
                className: 'BubblesSelect',
                name: 'select_viztype',
                value: this.state.vizType,
                clearable: false,
                options: vizOptions,
                onChange: this.handleVizTypeChange
              })
            ),
            selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SideCountriesSelector__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SideCountryTrends__["a" /* default */], { indicatorsList: indicatorsList })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-60-l ph2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cf pt2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                  { className: 'link-orange no-underline hero-top-link fl pa2 mb3', to: '/trade-facilitation-policies' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'small',
                    null,
                    '< TRADE FACILITATION POLICIES'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '' },
              vizType === 'heatmap' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_MapChart__["a" /* default */], { dataMap: dataForMap, height: 500,
                topic: 'ETI',
                latestDataByIndicator: latestDataByIndicator,
                borderColor: 'transparent',
                decreasing: indicators[topic].rankDirection === '1',
                emptyFill: "#eee", minScale: 0 }),
              vizType === 'bubbles' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_BubbleChart__["a" /* default */], { dataMap: dataForMap,
                latestDataByIndicator: latestDataByIndicator,
                borderColor: 'transparent',
                decreasing: indicators[topic].rankDirection === '1',
                emptyFill: "#eee", minScale: 0 })
            )
          )
        )
      );
    }
  }]);

  return SevenPillars;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    selectedCountry: state.selectedCountry,
    selectedCountryData: state.selectedCountryData,
    comparisonCountry: state.comparisonCountry,
    comparisonCountryData: state.comparisonCountryData,
    sevenPillarsData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__state_selectors__["a" /* getLatestFromData */])(state.sevenPillars.data),
    latestDataByIndicator: state.latestDataByIndicator.data
  };
};

var mapDispatchToProps = { loadSevenPillars: __WEBPACK_IMPORTED_MODULE_13__state_actions__["x" /* loadSevenPillars */], unloadSevenPillars: __WEBPACK_IMPORTED_MODULE_13__state_actions__["y" /* unloadSevenPillars */],
  loadLatestByIndicator: __WEBPACK_IMPORTED_MODULE_13__state_actions__["z" /* loadLatestByIndicator */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_13__state_actions__["A" /* setComparisonCountry */], setSelectedCountry: __WEBPACK_IMPORTED_MODULE_13__state_actions__["B" /* setSelectedCountry */],
  setSelectedCountryData: __WEBPACK_IMPORTED_MODULE_13__state_actions__["C" /* setSelectedCountryData */], setComparisonCountryData: __WEBPACK_IMPORTED_MODULE_13__state_actions__["D" /* setComparisonCountryData */] };
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(SevenPillars));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_csvdownload__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TrendFacilitationHeader__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SideCountriesSelector__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SideCountryTrends__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ScatterPlot__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var INDICATORS_LIST = ['ETIB', 'CUSTSERVIND', 'CLEAREFF', 'TABTIMEIMPDOC', 'TABTIMEIMPBORD',
// 'IMPTIMECOMPLIANCEIDX',
'TABCOSTIMPDOC', 'TABCOSTIMPBORD',
// 'IMPCOSTCOMPLIANCEIDX',
'TABTIMEEXPDOC', 'TABTIMEEXPBORD',
// 'EXPTIMECOMPLIANCEIDX',
'TABCOSTEXPDOC', 'TABCOSTEXPBORD',
// 'EXPCOSTCOMPLIANCEIDX',
'EOSQ147', 'EOSQ395', 'CUSTTRANSPIND'];

var ThirdPillarLegend = function ThirdPillarLegend(_ref) {
  var close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__components_Modal__["a" /* default */],
    { close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: '/legend/01.png', alt: 'Legend' })
  );
};

var ThirdPillar = function (_React$PureComponent) {
  _inherits(ThirdPillar, _React$PureComponent);

  function ThirdPillar() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ThirdPillar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ThirdPillar.__proto__ || Object.getPrototypeOf(ThirdPillar)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      legend: false
    }, _this.toggleLegend = function (e) {
      _this.setState({ legend: !_this.state.legend });
    }, _this.downloadCsv = function (e) {
      var countries = _this.props.countries;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_csvdownload__["a" /* getCsvFile */])('third-pillar.csv', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["keys"])(countries).sort(), INDICATORS_LIST);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThirdPillar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loadThirdPillar();
      if (!this.props.latestDataByIndicator) {
        this.props.loadLatestByIndicator();
      }
      var _props = this.props,
          match = _props.match,
          setSelectedCountry = _props.setSelectedCountry;
      var countryCode = match.params.countryCode;

      if (countryCode) {
        setSelectedCountry(countryCode);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.unloadThirdPillar();
      this.props.setSelectedCountry(null);
      this.props.setSelectedCountryData(null);
      this.props.setComparisonCountry(null);
      this.props.setComparisonCountryData(null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          indicators = _props2.indicators,
          selectedCountry = _props2.selectedCountry,
          thirdPillarData = _props2.thirdPillarData;

      var indicatorsList = INDICATORS_LIST.map(function (code) {
        return indicators[code];
      }
      //const indicatorsList = indicatorsCodes.map(code => indicators[code]).filter(i => i.parentCategoryGlobalId ==  "ETI.B.03" && i.domain)

      );return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TrendFacilitationHeader__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'h-container cf' },
          this.state.legend && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThirdPillarLegend, { close: this.toggleLegend }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-40-l ph4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'text-blue text-medium' },
              'Efficiency and transparency of border administration'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'cf' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-third fl tc' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.toggleLegend,
                    className: 'explore-link link-lightblue underline pointer', to: '/topics/ETIB03' },
                  'LEGEND'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'w-third fl tr' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { className: 'explore-link link-lightblue underline pointer', onClick: this.downloadCsv },
                  'DOWNLOAD'
                )
              )
            ),
            selectedCountry === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'leftside-text text-gray' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Transparent and efficient procedures at borders are key for the smooth functioning of international trade.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Ranging on a scale from 1 (worst) to 7 (best), this indicator captures efficiency, transparency and costs  associated with importing and exporting goods. It  includes an assessment of the range, quality and  comprehensiveness of key services offered by  customs and related agencies, and the average time, costs and number of documents required to, respectively, import and export goods. The indicator also assesses the time predictability of border procedures, as well as the transparency of the process\u2014as measured by the availability and quality of information provided by border agencies\u2014and the prevalence of corruption.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'It is one of the pillars of the Enabling Trade Index, co-published in 2016 by the Global Alliance for Trade Facilitation and the World Economic Forum. It aggregates 13 indicators collected from different sources.                '
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'To explore the results of each economy, click on the dots of the scatterplot.'
              )
            ),
            selectedCountry !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_SideCountriesSelector__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SideCountryTrends__["a" /* default */], { indicatorsList: indicatorsList })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fl-l w-60-l ph5' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pt2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cf' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Link */],
                  { className: 'link-orange no-underline hero-top-link fr pa2 mb3', to: '/trade-facilitation-policies' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'small',
                    null,
                    'TRADE FACILITATION POLICIES >'
                  )
                )
              ),
              thirdPillarData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'ThirdPillar__chart_container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ScatterPlot__["a" /* default */], { data: thirdPillarData })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cf' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'no-underline hero-top-link fr pa2 mb3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'small',
                    null,
                    'Source: Global Alliance for Trade Facilitation \u2013 World Economic Forum; Enabling Trade Index'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThirdPillar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    countries: state.countries,
    indicators: state.indicators,
    selectedCountry: state.selectedCountry,
    comparisonCountry: state.comparisonCountry,
    thirdPillarData: state.thirdPillar.data,
    latestDataByIndicator: state.latestDataByIndicator.data
  };
};

var mapDispatchToProps = { loadThirdPillar: __WEBPACK_IMPORTED_MODULE_10__state_actions__["L" /* loadThirdPillar */], unloadThirdPillar: __WEBPACK_IMPORTED_MODULE_10__state_actions__["M" /* unloadThirdPillar */],
  loadLatestByIndicator: __WEBPACK_IMPORTED_MODULE_10__state_actions__["z" /* loadLatestByIndicator */], setSelectedCountry: __WEBPACK_IMPORTED_MODULE_10__state_actions__["B" /* setSelectedCountry */], setComparisonCountry: __WEBPACK_IMPORTED_MODULE_10__state_actions__["A" /* setComparisonCountry */],
  setSelectedCountryData: __WEBPACK_IMPORTED_MODULE_10__state_actions__["C" /* setSelectedCountryData */], setComparisonCountryData: __WEBPACK_IMPORTED_MODULE_10__state_actions__["D" /* setComparisonCountryData */] };

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ThirdPillar));

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

function register() {
  if ("production" === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      var swUrl = "" + '/service-worker.js';
      navigator.serviceWorker.register(swUrl).then(function (registration) {
        registration.onupdatefound = function () {
          var installingWorker = registration.installing;
          installingWorker.onstatechange = function () {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the old content will have been purged and
                // the fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in your web app.
                console.log('New content is available; please refresh.');
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log('Content is cached for offline use.');
              }
            }
          };
        };
      }).catch(function (error) {
        console.error('Error during service worker registration:', error);
      });
    });
  }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__saga__ = __webpack_require__(272);





var countries = __webpack_require__(587);
var indicators = __webpack_require__(588);
var tfaMeta = __webpack_require__(590);
var meta = __webpack_require__(589);
var countriesContinents = __webpack_require__(586);

var sagaMiddleware = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["a" /* default */])();
var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */], { countries: countries, indicators: indicators, meta: meta, tfaMeta: tfaMeta, countriesContinents: countriesContinents }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* compose */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* applyMiddleware */])(sagaMiddleware), window.devToolsExtension ? window.devToolsExtension() : function (f) {
  return f;
}));
sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_3__saga__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(11);




var countriesReducer = function countriesReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return prevState;
};
var indicatorsReducer = function indicatorsReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return prevState;
};

var metaReducer = function metaReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return prevState;
};

var tfaMetaReducer = function tfaMetaReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return prevState;
};

var countriesContinentsReducer = function countriesContinentsReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return prevState;
};

var modalReducer = function modalReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _ref = arguments[1];
  var type = _ref.type;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["r" /* OPEN_MODAL */]) {
    return true;
  }
  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["s" /* CLOSE_MODAL */]) {
    return false;
  }
  return prevState;
};

var dataByCountryReducer = function dataByCountryReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      payload = _ref2.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* SET_DATA_BY_COUNTRY */]) {
    return payload;
  }
  return prevState;
};

var dataByIndicatorReducer = function dataByIndicatorReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["u" /* SET_DATA_BY_INDICATOR */]) {
    return payload;
  }
  return prevState;
};

var selectedCountryReducer = function selectedCountryReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref4 = arguments[1];
  var type = _ref4.type,
      payload = _ref4.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* SET_SELECTED_COUNTRY */]) {
    return payload;
  }
  return prevState;
};

var comparisonCountryReducer = function comparisonCountryReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref5 = arguments[1];
  var type = _ref5.type,
      payload = _ref5.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* SET_COMPARISON_COUNTRY */]) {
    return payload;
  }
  return prevState;
};

var selectedCountryDataReducer = function selectedCountryDataReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loading: false, data: null, error: null };
  var _ref6 = arguments[1];
  var type = _ref6.type,
      payload = _ref6.payload,
      error = _ref6.error;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* LOAD_COUNTRY_DATA_LOADING */]) {
    return { loading: true, data: null, error: null };
  }
  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* LOAD_COUNTRY_DATA_SUCCESS */]) {
    return { loading: false, data: payload, error: null };
  }
  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* LOAD_COUNTRY_DATA_ERROR */]) {
    return { loading: false, data: null, error: error };
  }
  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* LOAD_COUNTRY_DATA_UNLOAD */]) {
    return { loading: false, data: null, error: null };
  }
  return prevState;
};

var comparisonCountryDataReducer = function comparisonCountryDataReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loading: false, data: null };
  var _ref7 = arguments[1];
  var type = _ref7.type,
      payload = _ref7.payload,
      error = _ref7.error;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* LOAD_COMPARISON_COUNTRY_DATA_LOADING */]) {
    return { loading: true, data: null, error: null };
  }
  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* LOAD_COMPARISON_COUNTRY_DATA_SUCCESS */]) {
    return { loading: false, data: payload, error: null };
  }
  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* LOAD_COMPARISON_COUNTRY_DATA_ERROR */]) {
    return { loading: false, data: payload, error: error };
  }
  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* LOAD_COMPARISON_COUNTRY_DATA_UNLOAD */]) {
    return { loading: false, data: null, error: null };
  }
  return prevState;
};

var colorModeReducer = function colorModeReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'performance';
  var _ref8 = arguments[1];
  var type = _ref8.type,
      payload = _ref8.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["v" /* SET_COLOR_MODE */]) {
    return payload;
  }
  return prevState;
};

var countryModeReducer = function countryModeReducer() {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var _ref9 = arguments[1];
  var type = _ref9.type,
      payload = _ref9.payload;

  if (type === __WEBPACK_IMPORTED_MODULE_2__actions__["w" /* SET_COUNTRY_MODE */]) {
    return payload;
  }
  return prevState;
};

var makePageReducer = function makePageReducer(prefix) {
  var innerReducer = function innerReducer() {
    var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loading: false, data: null };
    var _ref10 = arguments[1];
    var type = _ref10.type,
        payload = _ref10.payload,
        error = _ref10.error;

    if (type === prefix + '_LOADING') {
      return { loading: true, data: null, error: null };
    }
    if (type === prefix + '_SUCCESS') {
      return { loading: false, data: payload, error: null };
    }
    if (type === prefix + '_ERROR') {
      return { loading: false, data: null, error: error };
    }
    if (type === prefix + '_UNLOAD') {
      return { loading: false, data: null, error: null };
    }
    return prevState;
  };
  return innerReducer;
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  countries: countriesReducer,
  indicators: indicatorsReducer,
  meta: metaReducer,
  tfaMeta: tfaMetaReducer,
  countriesContinents: countriesContinentsReducer,

  dataByCountry: dataByCountryReducer,
  dataByIndicator: dataByIndicatorReducer,

  tooltip: __WEBPACK_IMPORTED_MODULE_1_redux_tooltip__["reducer"],
  modalOpen: modalReducer,
  //
  selectedCountry: selectedCountryReducer,
  selectedCountryData: selectedCountryDataReducer,
  comparisonCountry: comparisonCountryReducer,
  comparisonCountryData: comparisonCountryDataReducer,

  //color mode and countries selection for viz 1 and 3
  colorMode: colorModeReducer,
  countryMode: countryModeReducer,

  //pages
  countryFacilitationPolicies: makePageReducer('COUNTRY_FACILITATION'),
  thirdPillar: makePageReducer('THIRD_PILLAR'),
  sevenPillars: makePageReducer('SEVEN_PILLARS'),
  tfaArticles: makePageReducer('TFA_ARTICLES'),
  tfaProvisions: makePageReducer('TFA_PROVISIONS'),
  latestDataByIndicator: makePageReducer('LATEST_BY_INDICATOR')

}));

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeCollection */
/* unused harmony export arrayze */
/* unused harmony export takeEveryAndCancel */
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatestAndCancel;
/* unused harmony export takeLatestAndCancelGroupBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _marked = [takeEveryAndCancel, takeLatestAndCancel, takeLatestAndCancelGroupBy].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var normalizeCollection = function normalizeCollection(collection) {
  var byKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return {
    ids: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(collection, byKey),
    data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keyBy"])(collection, byKey)
  };
};

var arrayze = function arrayze(a) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"])(a) ? a : [a];
};

var mergePatterns = function mergePatterns() {
  for (var _len = arguments.length, patterns = Array(_len), _key = 0; _key < _len; _key++) {
    patterns[_key] = arguments[_key];
  }

  return patterns.reduce(function (finalPattern, pattern) {
    return [].concat(_toConsumableArray(finalPattern), _toConsumableArray(arrayze(pattern)));
  }, []);
};

var matchPattern = function matchPattern(action, pattern) {
  return pattern === '*' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["includes"])(action.type, arrayze(pattern));
};

function takeEveryAndCancel(pattern, cancelPattern, saga) {
  for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    args[_key2 - 3] = arguments[_key2];
  }

  var task;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function takeEveryAndCancel$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var pendingTasks, action, i, _task, _task2;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    pendingTasks = [];

                  case 1:
                    if (false) {
                      _context.next = 24;
                      break;
                    }

                    _context.next = 4;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* take */])(mergePatterns(pattern, cancelPattern));

                  case 4:
                    action = _context.sent;

                    if (!matchPattern(action, cancelPattern)) {
                      _context.next = 17;
                      break;
                    }

                    i = 0;

                  case 7:
                    if (!(i < pendingTasks.length)) {
                      _context.next = 14;
                      break;
                    }

                    _task = pendingTasks[i];
                    _context.next = 11;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* cancel */])(_task);

                  case 11:
                    i++;
                    _context.next = 7;
                    break;

                  case 14:
                    pendingTasks = [];
                    _context.next = 22;
                    break;

                  case 17:
                    _context.next = 19;
                    return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */].apply(undefined, [saga].concat(_toConsumableArray(args.concat(action))));

                  case 19:
                    _task2 = _context.sent;

                    pendingTasks.push(_task2);
                    pendingTasks = pendingTasks.filter(function (task) {
                      return !task.isRunning();
                    });

                  case 22:
                    _context.next = 1;
                    break;

                  case 24:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

        case 2:
          task = _context2.sent;
          return _context2.abrupt('return', task);

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[0], this);
}

function takeLatestAndCancel(pattern, cancelPattern, saga) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var task;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function takeLatestAndCancel$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var lastTask, action;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    lastTask = void 0;

                  case 1:
                    if (false) {
                      _context3.next = 14;
                      break;
                    }

                    _context3.next = 4;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* take */])(mergePatterns(pattern, cancelPattern)

                    // Cancel previous task
                    );

                  case 4:
                    action = _context3.sent;

                    if (!lastTask) {
                      _context3.next = 8;
                      break;
                    }

                    _context3.next = 8;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* cancel */])(lastTask);

                  case 8:
                    if (matchPattern(action, cancelPattern)) {
                      _context3.next = 12;
                      break;
                    }

                    _context3.next = 11;
                    return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */].apply(undefined, [saga].concat(_toConsumableArray(args.concat(action))));

                  case 11:
                    lastTask = _context3.sent;

                  case 12:
                    _context3.next = 1;
                    break;

                  case 14:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee2, this);
          }));

        case 2:
          task = _context4.sent;
          return _context4.abrupt('return', task);

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[1], this);
}

// Difficult: Perfect Master
function takeLatestAndCancelGroupBy(pattern, cancelPattern, groupBy, saga) {
  for (var _len4 = arguments.length, args = Array(_len4 > 4 ? _len4 - 4 : 0), _key4 = 4; _key4 < _len4; _key4++) {
    args[_key4 - 4] = arguments[_key4];
  }

  var task;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function takeLatestAndCancelGroupBy$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var pendingTasks, action, key;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    pendingTasks = {};

                  case 1:
                    if (false) {
                      _context5.next = 15;
                      break;
                    }

                    _context5.next = 4;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* take */])(mergePatterns(pattern, cancelPattern));

                  case 4:
                    action = _context5.sent;
                    key = groupBy(action

                    // Cancel previous task by key
                    );

                    if (!pendingTasks[key]) {
                      _context5.next = 9;
                      break;
                    }

                    _context5.next = 9;
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* cancel */])(pendingTasks[key]);

                  case 9:
                    if (matchPattern(action, cancelPattern)) {
                      _context5.next = 13;
                      break;
                    }

                    _context5.next = 12;
                    return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */].apply(undefined, [saga].concat(_toConsumableArray(args.concat(action))));

                  case 12:
                    pendingTasks[key] = _context5.sent;

                  case 13:
                    _context5.next = 1;
                    break;

                  case 15:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee3, this);
          }));

        case 2:
          task = _context6.sent;
          return _context6.abrupt('return', task);

        case 4:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rootSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__effects_take__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(11);


var _marked = [handleLoadCountryData, handleLoadComparisonCountryData, rootSaga].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);







function handleLoadCountryData(_ref) {
  var payload = _ref.payload;
  var data;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleLoadCountryData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* LOAD_COUNTRY_DATA_LOADING */] });

        case 2:
          _context.prev = 2;
          _context.next = 5;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* getJsonData */], '/by_country/' + payload.toLowerCase() + '.json');

        case 5:
          data = _context.sent;
          _context.next = 8;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* LOAD_COUNTRY_DATA_SUCCESS */], payload: data });

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context['catch'](2);
          _context.next = 14;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* LOAD_COUNTRY_DATA_ERROR */], error: _context.t0 });

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[2, 10]]);
}

function handleLoadComparisonCountryData(_ref2) {
  var payload = _ref2.payload;
  var data;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleLoadComparisonCountryData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* LOAD_COMPARISON_COUNTRY_DATA_LOADING */] });

        case 2:
          _context2.prev = 2;
          _context2.next = 5;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* getJsonData */], '/by_country/' + payload.toLowerCase() + '.json');

        case 5:
          data = _context2.sent;
          _context2.next = 8;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* LOAD_COMPARISON_COUNTRY_DATA_SUCCESS */], payload: data });

        case 8:
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2['catch'](2);
          _context2.next = 14;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* LOAD_COMPARISON_COUNTRY_DATA_ERROR */], error: _context2.t0 });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[2, 10]]);
}

var makePageSaga = function makePageSaga(prefix, filename) {
  var _marked2 = [handlePageLoad].map(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark);

  function handlePageLoad(_ref3) {
    var payload = _ref3.payload;
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handlePageLoad$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: prefix + '_LOADING' });

          case 2:
            _context3.prev = 2;
            _context3.next = 5;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* getJsonData */], filename);

          case 5:
            data = _context3.sent;
            _context3.next = 8;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: prefix + '_SUCCESS', payload: data });

          case 8:
            _context3.next = 14;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](2);
            _context3.next = 14;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* put */])({ type: prefix + '_ERROR', error: _context3.t0 });

          case 14:
          case 'end':
            return _context3.stop();
        }
      }
    }, _marked2[0], this, [[2, 10]]);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__effects_take__["a" /* takeLatestAndCancel */], '' + prefix, prefix + '_UNLOAD', handlePageLoad);

          case 2:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee, this);
  });
};

function rootSaga() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function rootSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__effects_take__["a" /* takeLatestAndCancel */], __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* SET_SELECTED_COUNTRY */], __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* LOAD_COUNTRY_DATA_UNLOAD */], handleLoadCountryData);

        case 2:
          _context5.next = 4;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__effects_take__["a" /* takeLatestAndCancel */], __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* SET_COMPARISON_COUNTRY */], __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* LOAD_COMPARISON_COUNTRY_DATA_UNLOAD */], handleLoadComparisonCountryData);

        case 4:
          _context5.next = 6;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(makePageSaga(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* COUNTRY_FACILITATION */], '/by_indicator/eti.json'));

        case 6:
          _context5.next = 8;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(makePageSaga(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* SEVEN_PILLARS */], '/by_indicator/eti.json'));

        case 8:
          _context5.next = 10;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(makePageSaga(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* THIRD_PILLAR */], '/by_indicator/etib03.json'));

        case 10:
          _context5.next = 12;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(makePageSaga(__WEBPACK_IMPORTED_MODULE_4__actions__["o" /* TFA_ARTICLES */], '/tfa/data_tfa_articles.json'));

        case 12:
          _context5.next = 14;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(makePageSaga(__WEBPACK_IMPORTED_MODULE_4__actions__["p" /* TFA_PROVISIONS */], '/tfa/data_tfa_provisions.json'));

        case 14:
          _context5.next = 16;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(makePageSaga(__WEBPACK_IMPORTED_MODULE_4__actions__["q" /* LATEST_BY_INDICATOR */], '/latest_by_indicator.json'));

        case 16:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[2], this);
}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = function blacklist (src) {
  var copy = {}
  var filter = arguments[1]

  if (typeof filter === 'string') {
    filter = {}
    for (var i = 1; i < arguments.length; i++) {
      filter[arguments[i]] = true
    }
  }

  for (var key in src) {
    // blacklist?
    if (filter[key]) continue

    copy[key] = src[key]
  }

  return copy
}


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(148);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(150);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(46);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(87);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(38);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(87);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(145);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(152);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(294);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(295);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(293);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(296);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(292);
/* unused harmony reexport entries */








/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(88);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) return rollup != null
        ? rollup(array) : (sortValues != null
        ? array.sort(sortValues)
        : array);

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(88);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(154);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(154);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(159);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(63);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(63);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(63);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_area__ = __webpack_require__(160);
/* unused harmony reexport geoArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_bounds__ = __webpack_require__(309);
/* unused harmony reexport geoBounds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_centroid__ = __webpack_require__(310);
/* unused harmony reexport geoCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_circle__ = __webpack_require__(161);
/* unused harmony reexport geoCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_clip_extent__ = __webpack_require__(92);
/* unused harmony reexport geoClipExtent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_contains__ = __webpack_require__(315);
/* unused harmony reexport geoContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_distance__ = __webpack_require__(166);
/* unused harmony reexport geoDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_graticule__ = __webpack_require__(316);
/* unused harmony reexport geoGraticule */
/* unused harmony reexport geoGraticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_interpolate__ = __webpack_require__(317);
/* unused harmony reexport geoInterpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_length__ = __webpack_require__(167);
/* unused harmony reexport geoLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_path_index__ = __webpack_require__(321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__src_path_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_projection_albers__ = __webpack_require__(171);
/* unused harmony reexport geoAlbers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_projection_albersUsa__ = __webpack_require__(324);
/* unused harmony reexport geoAlbersUsa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_projection_azimuthalEqualArea__ = __webpack_require__(325);
/* unused harmony reexport geoAzimuthalEqualArea */
/* unused harmony reexport geoAzimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_projection_azimuthalEquidistant__ = __webpack_require__(326);
/* unused harmony reexport geoAzimuthalEquidistant */
/* unused harmony reexport geoAzimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_projection_conicConformal__ = __webpack_require__(327);
/* unused harmony reexport geoConicConformal */
/* unused harmony reexport geoConicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_projection_conicEqualArea__ = __webpack_require__(95);
/* unused harmony reexport geoConicEqualArea */
/* unused harmony reexport geoConicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_projection_conicEquidistant__ = __webpack_require__(328);
/* unused harmony reexport geoConicEquidistant */
/* unused harmony reexport geoConicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_projection_equirectangular__ = __webpack_require__(172);
/* unused harmony reexport geoEquirectangular */
/* unused harmony reexport geoEquirectangularRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_projection_gnomonic__ = __webpack_require__(330);
/* unused harmony reexport geoGnomonic */
/* unused harmony reexport geoGnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_projection_identity__ = __webpack_require__(331);
/* unused harmony reexport geoIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_projection_index__ = __webpack_require__(22);
/* unused harmony reexport geoProjection */
/* unused harmony reexport geoProjectionMutator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_projection_mercator__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_22__src_projection_mercator__["a"]; });
/* unused harmony reexport geoMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_projection_orthographic__ = __webpack_require__(332);
/* unused harmony reexport geoOrthographic */
/* unused harmony reexport geoOrthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_projection_stereographic__ = __webpack_require__(334);
/* unused harmony reexport geoStereographic */
/* unused harmony reexport geoStereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_projection_transverseMercator__ = __webpack_require__(335);
/* unused harmony reexport geoTransverseMercator */
/* unused harmony reexport geoTransverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_rotation__ = __webpack_require__(64);
/* unused harmony reexport geoRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_stream__ = __webpack_require__(30);
/* unused harmony reexport geoStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_transform__ = __webpack_require__(65);
/* unused harmony reexport geoTransform */




 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).


























/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream__ = __webpack_require__(30);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area__["b" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math__["g" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math__["g" /* radians */]]);
  if (p0) {
    var normal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["b" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["b" /* cartesianCross */])(equatorial, normal);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["g" /* cartesianNormalizeInPlace */])(inflection);
    inflection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cartesian__["f" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */] * sign,
        phii,
        antimeridian = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area__["a" /* areaStream */].lineEnd();
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__math__["o" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math__["p" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__stream__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream__ = __webpack_require__(30);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  centroidPointCartesian(cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda), cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  x0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda);
  y0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda);
  z0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi),
      x = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda),
      y = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda),
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi),
      w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi);
  x0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda);
  y0 = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda);
  z0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */];
  var cosPhi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi),
      x = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(lambda),
      y = cosPhi * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(lambda),
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stream__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math__["w" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math__["w" /* epsilon2 */]) return [NaN, NaN];
  }

  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
});


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */],
          delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda1 - lambda0);
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */]) { // line crosses antimeridian
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; // handle degeneracies
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda0 - lambda1);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["l" /* atan */])((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi0) * (cosPhi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi1)) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda1)
          - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(phi1) * (cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(phi0)) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["d" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math__["k" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */], phi);
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math__["a" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(163);






/* harmony default export */ __webpack_exports__["a"] = (function(radius, delta) {
  var cr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(radius),
      smallRadius = cr > 0,
      notHemisphere = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__circle__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(lambda) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point2) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point1, point2)) {
            point1[0] += __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
            point1[1] += __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__pointEqual__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(a),
        pb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianCross */])(pa, pb),
        n2n2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["b" /* cartesianCross */])(n1, n2),
        A = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(n1, c1),
        B = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(n2, c2);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(A, u),
        uu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["c" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["n" /* sqrt */])(t2),
        q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(u, (-w - t) / uu);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(q, A);
    q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math__["o" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["d" /* cartesianScale */])(u, (-w + t) / uu);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["e" /* cartesianAddInPlace */])(q1, A);
      return [q, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["f" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math__["a" /* pi */]]);
});


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(2);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], coordinates[1]),
      ao = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(coordinates[0], point),
      ob = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__distance__["a" /* default */])(point, coordinates[1]);
  return ao + ob <= ab + __WEBPACK_IMPORTED_MODULE_2__math__["p" /* epsilon */];
}

function containsPolygon(coordinates, point) {
  return !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__polygonContains__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math__["g" /* radians */]];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export graticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);



function graticuleX(y0, y1, dy) {
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; }).map(x))
        .concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["v" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math__["g" /* radians */],
      cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      sy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0),
      cy1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1),
      sy1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y1),
      kx0 = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x0),
      ky0 = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x0),
      kx1 = cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x1),
      ky1 = cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x1),
      d = 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* haversin */])(y1 - y0) + cy0 * cy1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["u" /* haversin */])(x1 - x0))),
      k = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(t *= d) / k,
        A = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */],
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(z, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(27);




var areaSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    areaRingSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
    areaSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(27);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math__["b" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */]
};


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string__ = __webpack_require__(323);









/* harmony default export */ __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area__["a" /* default */].result();
  };

  path.measure = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure__["a" /* default */].result();
  };

  path.bounds = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds__["a" /* default */].result();
  };

  path.centroid = function(object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stream__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop__ = __webpack_require__(27);




var lengthSum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adder__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(96);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var cache,
      cacheStream,
      lower48 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__albers__["a" /* default */])(), lower48Point,
      alaska = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea__["a" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(22);




var azimuthalEqualAreaRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(cxcy) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(z / 2);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(22);




var azimuthalEquidistantRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["b" /* azimuthalRaw */])(function(c) {
  return (c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["r" /* acos */])(c)) && c / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator__ = __webpack_require__(97);




function tany(y) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      n = y0 === y1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(cy0 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1)) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator__["c" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]; }
    var r = f / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(tany(y), n);
    return [r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(n * x), f - r * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + fy * fy);
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(fy)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(fy), 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["t" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular__ = __webpack_require__(172);




function conicEquidistantRaw(y0, y1) {
  var cy0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y0),
      n = y0 === y1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y0) : (cy0 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular__["a" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(nx), g - gy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["e" /* atan2 */])(x, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["o" /* abs */])(gy)) / n * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(gy), g - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["s" /* sign */])(n) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["n" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__conic__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(22);




function gnomonicRaw(x, y) {
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y), k = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x) * cy;
  return [cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x) / k, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y) / k];
}

gnomonicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_extent__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit__ = __webpack_require__(96);





function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */], // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity__["a" /* default */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__clip_extent__["a" /* clipExtent */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["a" /* fitExtent */])(projection, extent, object);
    },
    fitSize: function(size, object) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fit__["b" /* fitSize */])(projection, size, object);
    }
  };
});


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(22);




function orthographicRaw(x, y) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y)];
}

orthographicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math__["f" /* asin */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math__["p" /* epsilon */]);
});


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform__ = __webpack_require__(65);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["c" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math__["g" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__transform__["a" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["n" /* sqrt */])(a * a + b * b + c * c),
          phi2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["f" /* asin */])(c /= m),
          lambda2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math__["p" /* epsilon */] ? (lambda0 + lambda1) / 2 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__math__["o" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cartesian__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(22);




function stereographicRaw(x, y) {
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(y), k = 1 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["c" /* cos */])(x) * cy;
  return [cy * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(x) / k, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["d" /* sin */])(y) / k];
}

stereographicRaw.invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__azimuthal__["a" /* azimuthalInvert */])(function(z) {
  return 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(z);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator__ = __webpack_require__(97);



function transverseMercatorRaw(lambda, phi) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["i" /* log */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["l" /* atan */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math__["k" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mercator__["b" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(50);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(50);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(50);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(50);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(344);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(342);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(182);



function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(52);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(52);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(52);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(52);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(49);



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(181);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(67);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(67);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, pow().exponent(exponent));
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(31);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(53);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(49);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(53);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(31);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(155);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(102);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(52);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(101);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["b" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* unused harmony export utcThursday */
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* unused harmony export thursday */
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(23);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(12);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(379);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(380);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset, ch, cw, containerScroll,
    diffTop, diffBottom, win,
    winScroll, ww, wh;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left,
      top: elemOffset.top - winScroll.top
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww),
      top: elemOffset.top + eh - (winScroll.top + wh)
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left +
      (parseFloat(util.css(container, 'borderLeftWidth')) || 0)),
      top: elemOffset.top - (containerOffset.top +
      (parseFloat(util.css(container, 'borderTopWidth')) || 0))
    };
    diffBottom = {
      left: elemOffset.left + ew -
      (containerOffset.left + cw +
      (parseFloat(util.css(container, 'borderRightWidth')) || 0)),
      top: elemOffset.top + eh -
      (containerOffset.top + ch +
      (parseFloat(util.css(container, 'borderBottomWidth')) || 0))
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box, x, y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {left: x, top: y};
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    //ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      //quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle) {
  var val = '';
  var d = elem.ownerDocument;

  // https://github.com/kissyteam/kissy/issues/61
  if ((computedStyle = (computedStyle || d.defaultView.getComputedStyle(elem, null)))) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/,
  CURRENT_STYLE = 'currentStyle',
  RUNTIME_STYLE = 'runtimeStyle',
  LEFT = 'left',
  PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style,
      left = style[LEFT],
      rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : (ret || 0);
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem),
    ret = {},
    current, key;

  for (key in offset) {
    current = parseFloat(css(elem, key)) || 0;
    ret[key] = current + offset[key] - old[key];
  }
  css(elem, ret);
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'],
  CONTENT_INDEX = -1,
  PADDING_INDEX = 2,
  BORDER_INDEX = 1,
  MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {},
    style = elem.style,
    name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    old[name] = style[name];
    style[name] = options[name];
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    style[name] = old[name];
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0, prop, j, i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /*jshint eqeqeq:false*/
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
      //firefox chrome documentElement.scrollHeight< body.scrollHeight
      //ie standard mode : documentElement.scrollHeight> body.scrollHeight
      d.documentElement['scroll' + name],
      //quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      d.body['scroll' + name],
      domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name,
      doc = win.document,
      body = doc.body,
      documentElement = doc.documentElement,
      documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp ||
      body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'],
    borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || (Number(cssBoxValue)) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'],
          which, computedStyle);
    } else {
      return cssBoxValue;
    }
  } else if (borderBoxValueOrIsBorderBox) {
    return val + (extra === BORDER_INDEX ? 0 :
        (extra === PADDING_INDEX ?
          -getPBMWidth(elem, ['border'], which, computedStyle) :
          getPBMWidth(elem, ['margin'], which, computedStyle)));
  } else {
    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra),
        which, computedStyle);
  }
}

var cssShow = {position: 'absolute', visibility: 'hidden', display: 'block'};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val, args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function css(el, name, value) {
  if (typeof name === 'object') {
    for (var i in name) {
      css(el, i, name[i]);
    }
    return;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
  } else {
    return getComputedStyleX(el, name);
  }
}

function mix(to, from) {
  for (var i in from) {
    to[i] = from[i];
  }
  return to;
}

var utils = module.exports = {
  getWindow: function (node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function (el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function (obj) {
    var ret = {};
    for (var i in obj) {
      ret[i] = obj[i];
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        ret.overflow[i] = obj.overflow[i];
      }
    }
    return ret;
  },
  mix: mix,
  scrollLeft: function (w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      } else {
        window.scrollTo(v, getScrollTop(w));
      }
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      } else {
        w.scrollLeft = v;
      }
    }
  },
  scrollTop: function (w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      } else {
        window.scrollTo(getScrollLeft(w), v);
      }
    } else {
      if (v === undefined) {
        return w.scrollTop;
      } else {
        w.scrollTop = v;
      }
    }
  },
  merge: function () {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function(factory) {
    'use strict';
    /* global window: false, define: false, module: false */
    var root = typeof window === 'undefined' ? null : window;

    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){ return factory(root); }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined') {
        module.exports = factory(root);
    } else {
        root.DOMPurify = factory(root);
    }
}(function factory(window) {
    'use strict';

    var DOMPurify = function(window) {
        return factory(window);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '0.8.9';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
        // not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }

    var document = window.document;
    var originalDocument = document;
    var DocumentFragment = window.DocumentFragment;
    var HTMLTemplateElement = window.HTMLTemplateElement;
    var Node = window.Node;
    var NodeFilter = window.NodeFilter;
    var NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap;
    var Text = window.Text;
    var Comment = window.Comment;
    var DOMParser = window.DOMParser;
    var useDOMParser = false; // See comment below

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        var template = document.createElement('template');
        if (template.content && template.content.ownerDocument) {
            document = template.content.ownerDocument;
        }
    }
    var implementation = document.implementation;
    var createNodeIterator = document.createNodeIterator;
    var getElementsByTagName = document.getElementsByTagName;
    var createDocumentFragment = document.createDocumentFragment;
    var importNode = originalDocument.importNode;

    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported =
        typeof implementation.createHTMLDocument !== 'undefined' &&
        document.documentMode !== 9;

    /* Add properties to a lookup table */
    var _addToSet = function(set, array) {
        var l = array.length;
        while (l--) {
            if (typeof array[l] === 'string') {
                array[l] = array[l].toLowerCase();
            }
            set[array[l]] = true;
        }
        return set;
    };

    /* Shallow clone an object */
    var _cloneObj = function(object) {
        var newObject = {};
        var property;
        for (property in object) {
            if (object.hasOwnProperty(property)) {
                newObject[property] = object[property];
            }
        }
        return newObject;
    };

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = _addToSet({}, [

        // HTML
        'a','abbr','acronym','address','area','article','aside','audio','b',
        'bdi','bdo','big','blink','blockquote','body','br','button','canvas',
        'caption','center','cite','code','col','colgroup','content','data',
        'datalist','dd','decorator','del','details','dfn','dir','div','dl','dt',
        'element','em','fieldset','figcaption','figure','font','footer','form',
        'h1','h2','h3','h4','h5','h6','head','header','hgroup','hr','html','i',
        'img','input','ins','kbd','label','legend','li','main','map','mark',
        'marquee','menu','menuitem','meter','nav','nobr','ol','optgroup',
        'option','output','p','pre','progress','q','rp','rt','ruby','s','samp',
        'section','select','shadow','small','source','spacer','span','strike',
        'strong','style','sub','summary','sup','table','tbody','td','template',
        'textarea','tfoot','th','thead','time','tr','track','tt','u','ul','var',
        'video','wbr',

        // SVG
        'svg','altglyph','altglyphdef','altglyphitem','animatecolor',
        'animatemotion','animatetransform','circle','clippath','defs','desc',
        'ellipse','filter','font','g','glyph','glyphref','hkern','image','line',
        'lineargradient','marker','mask','metadata','mpath','path','pattern',
        'polygon','polyline','radialgradient','rect','stop','switch','symbol',
        'text','textpath','title','tref','tspan','view','vkern',

        // SVG Filters
        'feBlend','feColorMatrix','feComponentTransfer','feComposite',
        'feConvolveMatrix','feDiffuseLighting','feDisplacementMap',
        'feFlood','feFuncA','feFuncB','feFuncG','feFuncR','feGaussianBlur',
        'feMerge','feMergeNode','feMorphology','feOffset',
        'feSpecularLighting','feTile','feTurbulence',

        //MathML
        'math','menclose','merror','mfenced','mfrac','mglyph','mi','mlabeledtr',
        'mmuliscripts','mn','mo','mover','mpadded','mphantom','mroot','mrow',
        'ms','mpspace','msqrt','mystyle','msub','msup','msubsup','mtable','mtd',
        'mtext','mtr','munder','munderover',

        //Text
        '#text'
    ]);

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = _addToSet({}, [

        // HTML
        'accept','action','align','alt','autocomplete','background','bgcolor',
        'border','cellpadding','cellspacing','checked','cite','class','clear','color',
        'cols','colspan','coords','datetime','default','dir','disabled',
        'download','enctype','face','for','headers','height','hidden','high','href',
        'hreflang','id','ismap','label','lang','list','loop', 'low','max',
        'maxlength','media','method','min','multiple','name','noshade','novalidate',
        'nowrap','open','optimum','pattern','placeholder','poster','preload','pubdate',
        'radiogroup','readonly','rel','required','rev','reversed','role','rows',
        'rowspan','spellcheck','scope','selected','shape','size','span',
        'srclang','start','src','step','style','summary','tabindex','title',
        'type','usemap','valign','value','width','xmlns',

        // SVG
        'accent-height','accumulate','additivive','alignment-baseline',
        'ascent','attributename','attributetype','azimuth','basefrequency',
        'baseline-shift','begin','bias','by','clip','clip-path','clip-rule',
        'color','color-interpolation','color-interpolation-filters','color-profile',
        'color-rendering','cx','cy','d','dx','dy','diffuseconstant','direction',
        'display','divisor','dur','edgemode','elevation','end','fill','fill-opacity',
        'fill-rule','filter','flood-color','flood-opacity','font-family','font-size',
        'font-size-adjust','font-stretch','font-style','font-variant','font-weight',
        'fx', 'fy','g1','g2','glyph-name','glyphref','gradientunits','gradienttransform',
        'image-rendering','in','in2','k','k1','k2','k3','k4','kerning','keypoints',
        'keysplines','keytimes','lengthadjust','letter-spacing','kernelmatrix',
        'kernelunitlength','lighting-color','local','marker-end','marker-mid',
        'marker-start','markerheight','markerunits','markerwidth','maskcontentunits',
        'maskunits','max','mask','mode','min','numoctaves','offset','operator',
        'opacity','order','orient','orientation','origin','overflow','paint-order',
        'path','pathlength','patterncontentunits','patterntransform','patternunits',
        'points','preservealpha','r','rx','ry','radius','refx','refy','repeatcount',
        'repeatdur','restart','result','rotate','scale','seed','shape-rendering',
        'specularconstant','specularexponent','spreadmethod','stddeviation','stitchtiles',
        'stop-color','stop-opacity','stroke-dasharray','stroke-dashoffset','stroke-linecap',
        'stroke-linejoin','stroke-miterlimit','stroke-opacity','stroke','stroke-width',
        'surfacescale','targetx','targety','transform','text-anchor','text-decoration',
        'text-rendering','textlength','u1','u2','unicode','values','viewbox',
        'visibility','vert-adv-y','vert-origin-x','vert-origin-y','word-spacing',
        'wrap','writing-mode','xchannelselector','ychannelselector','x','x1','x2',
        'y','y1','y2','z','zoomandpan',

        // MathML
        'accent','accentunder','bevelled','close','columnsalign','columnlines',
        'columnspan','denomalign','depth','display','displaystyle','fence',
        'frame','largeop','length','linethickness','lspace','lquote',
        'mathbackground','mathcolor','mathsize','mathvariant','maxsize',
        'minsize','movablelimits','notation','numalign','open','rowalign',
        'rowlines','rowspacing','rowspan','rspace','rquote','scriptlevel',
        'scriptminsize','scriptsizemultiplier','selection','separator',
        'separators','stretchy','subscriptshift','supscriptshift','symmetric',
        'voffset',

        // XML
        'xlink:href','xml:id','xlink:title','xml:space','xmlns:xlink'
    ]);

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for jQuery's $() factory? */
    var SAFE_FOR_JQUERY = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Specify template detection regex for SAFE_FOR_TEMPLATES mode */
    var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm;
    var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
    var RETURN_DOM_FRAGMENT = false;

    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify. */
    var RETURN_DOM_IMPORT = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = _addToSet({}, [
        'audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video'
    ]);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = _addToSet({}, [
        'audio', 'video', 'img', 'source', 'image'
    ]);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = _addToSet({}, [
        'alt','class','for','id','label','name','pattern','placeholder',
        'summary','title','value','style','xmlns'
    ]);

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    /**
     * _parseConfig
     *
     * @param  optional config literal
     */
    var _parseConfig = function(cfg) {
        /* Shield configuration object from tampering */
        if (typeof cfg !== 'object') {
            cfg = {};
        }

        /* Set configuration parameters */
        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ?
            _addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ?
            _addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
        FORBID_TAGS = 'FORBID_TAGS' in cfg ?
            _addToSet({}, cfg.FORBID_TAGS) : {};
        FORBID_ATTR = 'FORBID_ATTR' in cfg ?
            _addToSet({}, cfg.FORBID_ATTR) : {};
        ALLOW_ARIA_ATTR     = cfg.ALLOW_ARIA_ATTR     !== false; // Default true
        ALLOW_DATA_ATTR     = cfg.ALLOW_DATA_ATTR     !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        SAFE_FOR_JQUERY     = cfg.SAFE_FOR_JQUERY     ||  false; // Default false
        SAFE_FOR_TEMPLATES  = cfg.SAFE_FOR_TEMPLATES  ||  false; // Default false
        WHOLE_DOCUMENT      = cfg.WHOLE_DOCUMENT      ||  false; // Default false
        RETURN_DOM          = cfg.RETURN_DOM          ||  false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT ||  false; // Default false
        RETURN_DOM_IMPORT   = cfg.RETURN_DOM_IMPORT   ||  false; // Default false
        FORCE_BODY          = cfg.FORCE_BODY          ||  false; // Default false
        SANITIZE_DOM        = cfg.SANITIZE_DOM        !== false; // Default true
        KEEP_CONTENT        = cfg.KEEP_CONTENT        !== false; // Default true

        if (SAFE_FOR_TEMPLATES) {
            ALLOW_DATA_ATTR = false;
        }

        if (RETURN_DOM_FRAGMENT) {
            RETURN_DOM = true;
        }

        /* Merge configuration parameters */
        if (cfg.ADD_TAGS) {
            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
                ALLOWED_TAGS = _cloneObj(ALLOWED_TAGS);
            }
            _addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
        }
        if (cfg.ADD_ATTR) {
            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
                ALLOWED_ATTR = _cloneObj(ALLOWED_ATTR);
            }
            _addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
        }
        if (cfg.ADD_URI_SAFE_ATTR) {
            _addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
        }

        /* Add #text in case KEEP_CONTENT is set to true */
        if (KEEP_CONTENT) { ALLOWED_TAGS['#text'] = true; }

        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if (Object && 'freeze' in Object) { Object.freeze(cfg); }

        CONFIG = cfg;
    };

   /**
     * _forceRemove
     *
     * @param  a DOM node
     */
    var _forceRemove = function(node) {
        DOMPurify.removed.push({element: node});
        try {
            node.parentNode.removeChild(node);
        } catch (e) {
            node.outerHTML = '';
        }
    };

   /**
     * _removeAttribute
     *
     * @param  an Attribute name
     * @param  a DOM node
     */
    var _removeAttribute = function(name, node) {
        DOMPurify.removed.push({
            attribute: node.getAttributeNode(name),
            from: node
        });
        node.removeAttribute(name);
    };

   /**
     * _initDocument
     *
     * @param  a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */
    var _initDocument = function(dirty) {
        /* Create a HTML document */
        var doc, body;

        /* Fill body with bogus element */
        if (FORCE_BODY) {
            dirty = '<remove></remove>' + dirty;
        }

        /* Use DOMParser to workaround Firefox bug (see comment below) */
        if (useDOMParser) {
            try {
                doc = new DOMParser().parseFromString(dirty, 'text/html');
            } catch (e) {}
        }

        /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
           Safari (see comment below) */
        if (!doc || !doc.documentElement) {
            doc = implementation.createHTMLDocument('');
            body = doc.body;
            body.parentNode.removeChild(body.parentNode.firstElementChild);
            body.outerHTML = dirty;
        }

        /* Work on whole document or just its body */
        return getElementsByTagName.call(doc,
            WHOLE_DOCUMENT ? 'html' : 'body')[0];
    };

    // Safari 10.1+ (unfixed as of time of writing) has a catastrophic bug in
    // its implementation of DOMParser such that the following executes the
    // JavaScript:
    //
    // new DOMParser()
    //   .parseFromString('<svg onload=alert(document.domain)>', 'text/html');
    //
    // However, Firefox uses a different parser for innerHTML rather than
    // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
    // which means that you *must* use DOMParser, otherwise the output may
    // not be safe if used in a document.write context later.
    //
    // So we feature detect the Firefox bug and use the DOMParser if necessary.
    if (DOMPurify.isSupported) {
        (function () {
            var doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
            if (doc.querySelector('svg img')) {
                useDOMParser = true;
            }
        }());
    }

    /**
     * _createIterator
     *
     * @param  document/fragment to create iterator for
     * @return iterator instance
     */
    var _createIterator = function(root) {
        return createNodeIterator.call(root.ownerDocument || root,
            root,
            NodeFilter.SHOW_ELEMENT
            | NodeFilter.SHOW_COMMENT
            | NodeFilter.SHOW_TEXT,
            function() { return NodeFilter.FILTER_ACCEPT; },
            false
        );
    };

    /**
     * _isClobbered
     *
     * @param  element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */
    var _isClobbered = function(elm) {
        if (elm instanceof Text || elm instanceof Comment) {
            return false;
        }
        if (  typeof elm.nodeName !== 'string'
           || typeof elm.textContent !== 'string'
           || typeof elm.removeChild !== 'function'
           || !(elm.attributes instanceof NamedNodeMap)
           || typeof elm.removeAttribute !== 'function'
           || typeof elm.setAttribute !== 'function'
        ) {
            return true;
        }
        return false;
    };

    /**
     * _isNode
     *
     * @param object to check whether it's a DOM node
     * @return true is object is a DOM node
     */
    var _isNode = function(obj) {
        return (
            typeof Node === "object" ? obj instanceof Node : obj
                && typeof obj === "object" && typeof obj.nodeType === "number"
                && typeof obj.nodeName==="string"
        );
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   node to check for permission to exist
     * @return  true if node was killed, false if left alive
     */
    var _sanitizeElements = function(currentNode) {
        var tagName, content;

        /* Execute a hook if present */
        _executeHook('beforeSanitizeElements', currentNode, null);

        /* Check if element is clobbered or can clobber */
        if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }

        /* Now let's check the element's type and name */
        tagName = currentNode.nodeName.toLowerCase();

        /* Execute a hook if present */
        _executeHook('uponSanitizeElement', currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });

        /* Remove element if anything forbids its presence */
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            /* Keep content except for black-listed elements */
            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]
                    && typeof currentNode.insertAdjacentHTML === 'function') {
                try {
                    currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
                } catch (e) {}
            }
            _forceRemove(currentNode);
            return true;
        }

        /* Convert markup to cover jQuery behavior */
        if (SAFE_FOR_JQUERY && !currentNode.firstElementChild &&
                (!currentNode.content || !currentNode.content.firstElementChild) &&
                /</g.test(currentNode.textContent)) {
            DOMPurify.removed.push({element: currentNode.cloneNode()});
            currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
        }

        /* Sanitize element content to be template-safe */
        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
            /* Get the element's text content */
            content = currentNode.textContent;
            content = content.replace(MUSTACHE_EXPR, ' ');
            content = content.replace(ERB_EXPR, ' ');
            if (currentNode.textContent !== content) {
                DOMPurify.removed.push({element: currentNode.cloneNode()});
                currentNode.textContent = content;
            }
        }

        /* Execute a hook if present */
        _executeHook('afterSanitizeElements', currentNode, null);

        return false;
    };

    var DATA_ATTR = /^data-[\-\w.\u00B7-\uFFFF]/;
    var ARIA_ATTR = /^aria-[\-\w]+$/;
    var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;
    var IS_SCRIPT_OR_DATA = /^(?:\w+script|data):/i;
    /* This needs to be extensive thanks to Webkit/Blink's behavior */
    var ATTR_WHITESPACE = /[\x00-\x20\xA0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param   node to sanitize
     * @return  void
     */
    var _sanitizeAttributes = function(currentNode) {
        var attr, name, value, lcName, idAttr, attributes, hookEvent, l;
        /* Execute a hook if present */
        _executeHook('beforeSanitizeAttributes', currentNode, null);

        attributes = currentNode.attributes;

        /* Check if we have attributes; if not we might have a text node */
        if (!attributes) { return; }

        hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR
        };
        l = attributes.length;

        /* Go backwards over all attributes; safely remove bad ones */
        while (l--) {
            attr = attributes[l];
            name = attr.name;
            value = attr.value.trim();
            lcName = name.toLowerCase();

            /* Execute a hook if present */
            hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            _executeHook('uponSanitizeAttribute', currentNode, hookEvent );
            value = hookEvent.attrValue;

            /* Remove attribute */
            // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
            // remove a "name" attribute from an <img> tag that has an "id"
            // attribute at the time.
            if (lcName === 'name'  &&
                    currentNode.nodeName === 'IMG' && attributes.id) {
                idAttr = attributes.id;
                attributes = Array.prototype.slice.apply(attributes);
                _removeAttribute('id', currentNode);
                _removeAttribute(name, currentNode);
                if (attributes.indexOf(idAttr) > l) {
                    currentNode.setAttribute('id', idAttr.value);
                }
            } else if (
                  // This works around a bug in Safari, where input[type=file]
                  // cannot be dynamically set after type has been removed
                  currentNode.nodeName === 'INPUT' && lcName === 'type' &&
                  value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
                  continue;
            } else {
                // This avoids a crash in Safari v9.0 with double-ids.
                // The trick is to first set the id to be empty and then to
                // remove the attribute
                if (name === 'id') {
                    currentNode.setAttribute(name, '');
                }
                _removeAttribute(name, currentNode);
            }

            /* Did the hooks approve of the attribute? */
            if (!hookEvent.keepAttr) {
                continue;
            }

            /* Make sure attribute cannot clobber */
            if (SANITIZE_DOM &&
                    (lcName === 'id' || lcName === 'name') &&
                    (value in window || value in document || value in formElement)) {
                continue;
            }

            /* Sanitize attribute content to be template-safe */
            if (SAFE_FOR_TEMPLATES) {
                value = value.replace(MUSTACHE_EXPR, ' ');
                value = value.replace(ERB_EXPR, ' ');
            }

            /* Allow valid data-* attributes: At least one character after "-"
               (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
               XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
               We don't need to check the value; it's always URI safe. */
            if (ALLOW_DATA_ATTR && DATA_ATTR.test(lcName)) {
                // This attribute is safe
            }
            else if (ALLOW_ARIA_ATTR && ARIA_ATTR.test(lcName)) {
                // This attribute is safe
            }
            /* Otherwise, check the name is permitted */
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                continue;
            }
            /* Check value is safe. First, is attr inert? If so, is safe */
            else if (URI_SAFE_ATTRIBUTES[lcName]) {
                // This attribute is safe
            }
            /* Check no script, data or unknown possibly unsafe URI
               unless we know URI values are safe for that attribute */
            else if (IS_ALLOWED_URI.test(value.replace(ATTR_WHITESPACE,''))) {
                // This attribute is safe
            }
            /* Keep image data URIs alive if src/xlink:href is allowed */
            else if (
                (lcName === 'src' || lcName === 'xlink:href') &&
                value.indexOf('data:') === 0 &&
                DATA_URI_TAGS[currentNode.nodeName.toLowerCase()]) {
                // This attribute is safe
            }
            /* Allow unknown protocols: This provides support for links that
               are handled by protocol handlers which may be unknown ahead of
               time, e.g. fb:, spotify: */
            else if (
                ALLOW_UNKNOWN_PROTOCOLS &&
                !IS_SCRIPT_OR_DATA.test(value.replace(ATTR_WHITESPACE,''))) {
                // This attribute is safe
            }
            /* Check for binary attributes */
            else if (!value) {
                // binary attributes are safe at this point
            }
            /* Anything else, presume unsafe, do not add it back */
            else {
                continue;
            }

            /* Handle invalid data-* attribute set by try-catching it */
            try {
                currentNode.setAttribute(name, value);
                DOMPurify.removed.pop();
            } catch (e) {}
        }

        /* Execute a hook if present */
        _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  fragment to iterate over recursively
     * @return void
     */
    var _sanitizeShadowDOM = function(fragment) {
        var shadowNode;
        var shadowIterator = _createIterator(fragment);

        /* Execute a hook if present */
        _executeHook('beforeSanitizeShadowDOM', fragment, null);

        while ( (shadowNode = shadowIterator.nextNode()) ) {
            /* Execute a hook if present */
            _executeHook('uponSanitizeShadowNode', shadowNode, null);

            /* Sanitize tags and elements */
            if (_sanitizeElements(shadowNode)) {
                continue;
            }

            /* Deep shadow DOM detected */
            if (shadowNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(shadowNode.content);
            }

            /* Check attributes, sanitize if necessary */
            _sanitizeAttributes(shadowNode);
        }

        /* Execute a hook if present */
        _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode
     */
    var _executeHook = function(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) { return; }

        hooks[entryPoint].forEach(function(hook) {
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    };

    /**
     * sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    DOMPurify.sanitize = function(dirty, cfg) {
        var body, importedNode, currentNode, oldNode, nodeIterator, returnNode;
        /* Make sure we have a string to sanitize.
           DO NOT return early, as this will return the wrong type if
           the user has requested a DOM object rather than a string */
        if (!dirty) {
            dirty = '<!-->';
        }

        /* Stringify, in case dirty is an object */
        if (typeof dirty !== 'string' && !_isNode(dirty)) {
            if (typeof dirty.toString !== 'function') {
                throw new TypeError('toString is not a function');
            } else {
                dirty = dirty.toString();
            }
        }

        /* Check we can run. Otherwise fall back or ignore */
        if (!DOMPurify.isSupported) {
            if (typeof window.toStaticHTML === 'object'
                || typeof window.toStaticHTML === 'function') {
                if (typeof dirty === 'string') {
                    return window.toStaticHTML(dirty);
                } else if (_isNode(dirty)) {
                    return window.toStaticHTML(dirty.outerHTML);
                }
            }
            return dirty;
        }

        /* Assign config vars */
        _parseConfig(cfg);

        /* Clean up removed elements */
        DOMPurify.removed = [];

        if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
               elements being stripped by the parser */
            body = _initDocument('<!-->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
                /* Node is already a body, use as is */
                body = importedNode;
            } else {
                body.appendChild(importedNode);
            }
        } else {
            /* Exit directly if we have nothing to do */
            if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
                return dirty;
            }

            /* Initialize the document to work on */
            body = _initDocument(dirty);

            /* Check we have a DOM node from the data */
            if (!body) {
                return RETURN_DOM ? null : '';
            }
        }

        /* Remove first element node (ours) if FORCE_BODY is set */
        if (FORCE_BODY) {
            _forceRemove(body.firstChild);
        }

        /* Get node iterator */
        nodeIterator = _createIterator(body);

        /* Now start iterating over the created document */
        while ( (currentNode = nodeIterator.nextNode()) ) {

            /* Fix IE's strange behavior with manipulated textNodes #89 */
            if (currentNode.nodeType === 3 && currentNode === oldNode) {
                continue;
            }

            /* Sanitize tags and elements */
            if (_sanitizeElements(currentNode)) {
                continue;
            }

            /* Shadow DOM detected, sanitize it */
            if (currentNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(currentNode.content);
            }

            /* Check attributes, sanitize if necessary */
            _sanitizeAttributes(currentNode);

            oldNode = currentNode;
        }

        /* Return sanitized string or DOM */
        if (RETURN_DOM) {

            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);

                while (body.firstChild) {
                    returnNode.appendChild(body.firstChild);
                }
            } else {
                returnNode = body;
            }

            if (RETURN_DOM_IMPORT) {
                /* adoptNode() is not used because internal state is not reset
                   (e.g. the past names map of a HTMLFormElement), this is safe
                   in theory but we would rather not risk another attack vector.
                   The state that is cloned by importNode() is explicitly defined
                   by the specs. */
                returnNode = importNode.call(originalDocument, returnNode, true);
            }

            return returnNode;
        }

        return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    };

    /**
     * addHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint
     * @param {Function} hookFunction
     */
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') { return; }
        hooks[entryPoint] = hooks[entryPoint] || [];
        hooks[entryPoint].push(hookFunction);
    };

    /**
     * removeHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint
     * @return void
     */
    DOMPurify.removeHook = function(entryPoint) {
        if (hooks[entryPoint]) {
            hooks[entryPoint].pop();
        }
    };

    /**
     * removeHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint
     * @return void
     */
    DOMPurify.removeHooks = function(entryPoint) {
        if (hooks[entryPoint]) {
            hooks[entryPoint] = [];
        }
    };

    /**
     * removeAllHooks
     * Public method to remove all DOMPurify hooks
     *
     * @return void
     */
    DOMPurify.removeAllHooks = function() {
        hooks = {};
    };

    return DOMPurify;
}));


/***/ }),
/* 382 */
/***/ (function(module, exports) {

var requestFrame = (function () {
  var window = this
  var raf = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function fallbackRAF(func) {
      return window.setTimeout(func, 20)
    }
  return function requestFrameFunction(func) {
    return raf(func)
  }
})()

var cancelFrame = (function () {
  var window = this
  var cancel = window.cancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.clearTimeout
  return function cancelFrameFunction(id) {
    return cancel(id)
  }
})()

function resizeListener(e) {
  var win = e.target || e.srcElement
  if (win.__resizeRAF__) {
    cancelFrame(win.__resizeRAF__)
  }
  win.__resizeRAF__ = requestFrame(function () {
    var trigger = win.__resizeTrigger__
    trigger.__resizeListeners__.forEach(function (fn) {
      fn.call(trigger, e)
    })
  })
}

var exports = function exports(element, fn) {
  var window = this
  var document = window.document
  var isIE

  var attachEvent = document.attachEvent
  if (typeof navigator !== 'undefined') {
    isIE = navigator.userAgent.match(/Trident/) ||
      navigator.userAgent.match(/Edge/)
  }

  function objectLoad() {
    this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__
    this.contentDocument.defaultView.addEventListener('resize', resizeListener)
  }

  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = []
    if (attachEvent) {
      element.__resizeTrigger__ = element
      element.attachEvent('onresize', resizeListener)
    } else {
      if (getComputedStyle(element).position === 'static') {
        element.style.position = 'relative'
      }
      var obj = (element.__resizeTrigger__ = document.createElement('object'))
      obj.setAttribute(
        'style',
        'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1; opacity: 0;'
      )
      obj.setAttribute('class', 'resize-sensor')
      obj.__resizeElement__ = element
      obj.onload = objectLoad
      obj.type = 'text/html'
      if (isIE) {
        element.appendChild(obj)
      }
      obj.data = 'about:blank'
      if (!isIE) {
        element.appendChild(obj)
      }
    }
  }
  element.__resizeListeners__.push(fn)
}

module.exports = typeof window === 'undefined' ? exports : exports.bind(window)

module.exports.unbind = function (element, fn) {
  var attachEvent = document.attachEvent
  if (fn) {
    element.__resizeListeners__.splice(
      element.__resizeListeners__.indexOf(fn),
      1
    )
  } else {
    element.__resizeListeners__ = []
  }
  if (!element.__resizeListeners__.length) {
    if (attachEvent) {
      element.detachEvent('onresize', resizeListener)
    } else {
      element.__resizeTrigger__.contentDocument.defaultView.removeEventListener(
        'resize',
        resizeListener
      )
      delete element.__resizeTrigger__.contentDocument.defaultView.__resizeTrigger__
      element.__resizeTrigger__ = !element.removeChild(
        element.__resizeTrigger__
      )
    }
    delete element.__resizeListeners__
  }
}


/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(412);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(422);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(1);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(14);

var createArrayFromMixed = __webpack_require__(415);
var getMarkupWrap = __webpack_require__(417);
var invariant = __webpack_require__(1);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(14);

var invariant = __webpack_require__(1);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(419);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(421);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(34);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(55);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(104);

var _PathUtils = __webpack_require__(54);

var _createTransitionManager = __webpack_require__(105);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(34);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(54);

var _LocationUtils = __webpack_require__(104);

var _createTransitionManager = __webpack_require__(105);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = isNode

function isNode (val) {
  return (!val || typeof val !== 'object')
    ? false
    : (typeof window === 'object' && typeof window.Node === 'object')
      ? (val instanceof window.Node)
      : (typeof val.nodeType === 'number') &&
        (typeof val.nodeName === 'string')
}


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(431);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35)))

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(432);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(193);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(428);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(436)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(195);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(195);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(17);
var invariant = __webpack_require__(1);
var ReactPropTypesSecret = __webpack_require__(197);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(17);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var ReactPropTypesSecret = __webpack_require__(197);
var checkPropTypes = __webpack_require__(439);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(9);

var focusNode = __webpack_require__(188);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(57);
var ExecutionEnvironment = __webpack_require__(14);
var FallbackCompositionState = __webpack_require__(450);
var SyntheticCompositionEvent = __webpack_require__(487);
var SyntheticInputEvent = __webpack_require__(490);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(198);
var ExecutionEnvironment = __webpack_require__(14);
var ReactInstrumentation = __webpack_require__(18);

var camelizeStyleName = __webpack_require__(413);
var dangerousStyleValue = __webpack_require__(496);
var hyphenateStyleName = __webpack_require__(420);
var memoizeStringOnly = __webpack_require__(423);
var warning = __webpack_require__(4);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(56);
var EventPropagators = __webpack_require__(57);
var ExecutionEnvironment = __webpack_require__(14);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(20);
var SyntheticEvent = __webpack_require__(24);

var inputValueTracking = __webpack_require__(214);
var getEventTarget = __webpack_require__(120);
var isEventSupported = __webpack_require__(121);
var isTextInputElement = __webpack_require__(216);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(41);
var ExecutionEnvironment = __webpack_require__(14);

var createNodesFromMarkup = __webpack_require__(416);
var emptyFunction = __webpack_require__(17);
var invariant = __webpack_require__(1);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(9);
var SyntheticMouseEvent = __webpack_require__(70);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var PooledClass = __webpack_require__(32);

var getTextContentAccessor = __webpack_require__(213);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(42);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(43);

var instantiateReactComponent = __webpack_require__(215);
var KeyEscapeUtils = __webpack_require__(112);
var shouldUpdateReactComponent = __webpack_require__(122);
var traverseAllChildren = __webpack_require__(218);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(229);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(194)))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(108);
var ReactDOMIDOperations = __webpack_require__(460);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(7);

var React = __webpack_require__(44);
var ReactComponentEnvironment = __webpack_require__(114);
var ReactCurrentOwner = __webpack_require__(25);
var ReactErrorUtils = __webpack_require__(115);
var ReactInstanceMap = __webpack_require__(58);
var ReactInstrumentation = __webpack_require__(18);
var ReactNodeTypes = __webpack_require__(208);
var ReactReconciler = __webpack_require__(43);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(68);
var invariant = __webpack_require__(1);
var shallowEqual = __webpack_require__(103);
var shouldUpdateReactComponent = __webpack_require__(122);
var warning = __webpack_require__(4);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(9);
var ReactDefaultInjection = __webpack_require__(468);
var ReactMount = __webpack_require__(207);
var ReactReconciler = __webpack_require__(43);
var ReactUpdates = __webpack_require__(20);
var ReactVersion = __webpack_require__(481);

var findDOMNode = __webpack_require__(497);
var getHostComponentFromComposite = __webpack_require__(212);
var renderSubtreeIntoContainer = __webpack_require__(504);
var warning = __webpack_require__(4);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(7);

var AutoFocusUtils = __webpack_require__(443);
var CSSPropertyOperations = __webpack_require__(445);
var DOMLazyTree = __webpack_require__(41);
var DOMNamespaces = __webpack_require__(109);
var DOMProperty = __webpack_require__(42);
var DOMPropertyOperations = __webpack_require__(200);
var EventPluginHub = __webpack_require__(56);
var EventPluginRegistry = __webpack_require__(110);
var ReactBrowserEventEmitter = __webpack_require__(69);
var ReactDOMComponentFlags = __webpack_require__(201);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMInput = __webpack_require__(461);
var ReactDOMOption = __webpack_require__(462);
var ReactDOMSelect = __webpack_require__(202);
var ReactDOMTextarea = __webpack_require__(465);
var ReactInstrumentation = __webpack_require__(18);
var ReactMultiChild = __webpack_require__(474);
var ReactServerRenderingTransaction = __webpack_require__(479);

var emptyFunction = __webpack_require__(17);
var escapeTextContentForBrowser = __webpack_require__(72);
var invariant = __webpack_require__(1);
var isEventSupported = __webpack_require__(121);
var shallowEqual = __webpack_require__(103);
var inputValueTracking = __webpack_require__(214);
var validateDOMNesting = __webpack_require__(123);
var warning = __webpack_require__(4);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(123);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var DOMLazyTree = __webpack_require__(41);
var ReactDOMComponentTree = __webpack_require__(9);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(108);
var ReactDOMComponentTree = __webpack_require__(9);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(7);

var DOMPropertyOperations = __webpack_require__(200);
var LinkedValueUtils = __webpack_require__(113);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(20);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var React = __webpack_require__(44);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMSelect = __webpack_require__(202);

var warning = __webpack_require__(4);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

var getNodeForCharacterOffset = __webpack_require__(501);
var getTextContentAccessor = __webpack_require__(213);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(7);

var DOMChildrenOperations = __webpack_require__(108);
var DOMLazyTree = __webpack_require__(41);
var ReactDOMComponentTree = __webpack_require__(9);

var escapeTextContentForBrowser = __webpack_require__(72);
var invariant = __webpack_require__(1);
var validateDOMNesting = __webpack_require__(123);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(7);

var LinkedValueUtils = __webpack_require__(113);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(20);

var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var ReactUpdates = __webpack_require__(20);
var Transaction = __webpack_require__(71);

var emptyFunction = __webpack_require__(17);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(442);
var BeforeInputEventPlugin = __webpack_require__(444);
var ChangeEventPlugin = __webpack_require__(446);
var DefaultEventPluginOrder = __webpack_require__(448);
var EnterLeaveEventPlugin = __webpack_require__(449);
var HTMLDOMPropertyConfig = __webpack_require__(451);
var ReactComponentBrowserEnvironment = __webpack_require__(453);
var ReactDOMComponent = __webpack_require__(456);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMEmptyComponent = __webpack_require__(458);
var ReactDOMTreeTraversal = __webpack_require__(466);
var ReactDOMTextComponent = __webpack_require__(464);
var ReactDefaultBatchingStrategy = __webpack_require__(467);
var ReactEventListener = __webpack_require__(471);
var ReactInjection = __webpack_require__(472);
var ReactReconcileTransaction = __webpack_require__(477);
var SVGDOMPropertyConfig = __webpack_require__(482);
var SelectEventPlugin = __webpack_require__(483);
var SimpleEventPlugin = __webpack_require__(484);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(56);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var EventListener = __webpack_require__(187);
var ExecutionEnvironment = __webpack_require__(14);
var PooledClass = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(20);

var getEventTarget = __webpack_require__(120);
var getUnboundedScrollPosition = __webpack_require__(418);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(42);
var EventPluginHub = __webpack_require__(56);
var EventPluginUtils = __webpack_require__(111);
var ReactComponentEnvironment = __webpack_require__(114);
var ReactEmptyComponent = __webpack_require__(203);
var ReactBrowserEventEmitter = __webpack_require__(69);
var ReactHostComponent = __webpack_require__(205);
var ReactUpdates = __webpack_require__(20);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(495);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactComponentEnvironment = __webpack_require__(114);
var ReactInstanceMap = __webpack_require__(58);
var ReactInstrumentation = __webpack_require__(18);

var ReactCurrentOwner = __webpack_require__(25);
var ReactReconciler = __webpack_require__(43);
var ReactChildReconciler = __webpack_require__(452);

var emptyFunction = __webpack_require__(17);
var flattenChildren = __webpack_require__(498);
var invariant = __webpack_require__(1);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(1);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var CallbackQueue = __webpack_require__(199);
var PooledClass = __webpack_require__(32);
var ReactBrowserEventEmitter = __webpack_require__(69);
var ReactInputSelection = __webpack_require__(206);
var ReactInstrumentation = __webpack_require__(18);
var Transaction = __webpack_require__(71);
var ReactUpdateQueue = __webpack_require__(116);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(475);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(7);

var PooledClass = __webpack_require__(32);
var Transaction = __webpack_require__(71);
var ReactInstrumentation = __webpack_require__(18);
var ReactServerUpdateQueue = __webpack_require__(480);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(116);

var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(57);
var ExecutionEnvironment = __webpack_require__(14);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInputSelection = __webpack_require__(206);
var SyntheticEvent = __webpack_require__(24);

var getActiveElement = __webpack_require__(189);
var isTextInputElement = __webpack_require__(216);
var shallowEqual = __webpack_require__(103);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var EventListener = __webpack_require__(187);
var EventPropagators = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(9);
var SyntheticAnimationEvent = __webpack_require__(485);
var SyntheticClipboardEvent = __webpack_require__(486);
var SyntheticEvent = __webpack_require__(24);
var SyntheticFocusEvent = __webpack_require__(489);
var SyntheticKeyboardEvent = __webpack_require__(491);
var SyntheticMouseEvent = __webpack_require__(70);
var SyntheticDragEvent = __webpack_require__(488);
var SyntheticTouchEvent = __webpack_require__(492);
var SyntheticTransitionEvent = __webpack_require__(493);
var SyntheticUIEvent = __webpack_require__(59);
var SyntheticWheelEvent = __webpack_require__(494);

var emptyFunction = __webpack_require__(17);
var getEventCharCode = __webpack_require__(118);
var invariant = __webpack_require__(1);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(24);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(24);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(24);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(70);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(59);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(24);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(59);

var getEventCharCode = __webpack_require__(118);
var getEventKey = __webpack_require__(499);
var getEventModifierState = __webpack_require__(119);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(59);

var getEventModifierState = __webpack_require__(119);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(24);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(70);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(198);
var warning = __webpack_require__(4);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(25);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInstanceMap = __webpack_require__(58);

var getHostComponentFromComposite = __webpack_require__(212);
var invariant = __webpack_require__(1);
var warning = __webpack_require__(4);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(112);
var traverseAllChildren = __webpack_require__(218);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(229);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(194)))

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(118);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(14);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(72);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(207);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(8);
var createClass = __webpack_require__(37);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(124);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(511);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(220);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(220);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(222);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(512);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(124);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(15);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Router */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(15);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Router */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* unused harmony reexport default */


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Route */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [activeClassName, className].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

NavLink.defaultProps = {
  activeClassName: 'active'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* unused harmony reexport default */


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["e"]; });


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* unused harmony reexport default */


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* unused harmony reexport default */


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* unused harmony reexport default */


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Router__ = __webpack_require__(125);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (MemoryRouter);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (Prompt);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for updating the location programatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(125);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (StaticRouter);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(126);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(224);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(33);

var _Select2 = _interopRequireDefault(_Select);

var _utilsStripDiacritics = __webpack_require__(227);

var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);

var propTypes = {
	autoload: _propTypes2['default'].bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2['default'].any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2['default'].func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2['default'].bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2['default'].bool, // perform case-insensitive filtering; defaults to true
	loadingPlaceholder: _propTypes2['default'].oneOfType([// replaces the placeholder while options are loading
	_propTypes2['default'].string, _propTypes2['default'].node]),
	loadOptions: _propTypes2['default'].func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	multi: _propTypes2['default'].bool, // multi-value input
	options: _propTypes2['default'].array.isRequired, // array of options
	placeholder: _propTypes2['default'].oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2['default'].string, _propTypes2['default'].node]),
	noResultsText: _propTypes2['default'].oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
	searchPromptText: _propTypes2['default'].oneOfType([// label to prompt for search input
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onInputChange: _propTypes2['default'].func, // optional for keeping track of what is being typed
	value: _propTypes2['default'].any };

// initial field value
var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = (function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);

		this._cache = props.cache === defaultCache ? {} : props.cache;

		this.state = {
			isLoading: false,
			options: props.options
		};

		this._onInputChange = this._onInputChange.bind(this);
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;

			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			var _this = this;

			var propertiesToSync = ['options'];
			propertiesToSync.forEach(function (prop) {
				if (_this.props[prop] !== nextProps[prop]) {
					_this.setState(_defineProperty({}, prop, nextProps[prop]));
				}
			});
		}
	}, {
		key: 'clearOptions',
		value: function clearOptions() {
			this.setState({ options: [] });
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && cache.hasOwnProperty(inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}

			return inputValue;
		}
	}, {
		key: '_onInputChange',
		value: function _onInputChange(inputValue) {
			var _props = this.props;
			var ignoreAccents = _props.ignoreAccents;
			var ignoreCase = _props.ignoreCase;
			var onInputChange = _props.onInputChange;

			if (ignoreAccents) {
				inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
			}

			if (ignoreCase) {
				inputValue = inputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(inputValue);
			}

			return this.loadOptions(inputValue);
		}
	}, {
		key: 'inputValue',
		value: function inputValue() {
			if (this.select) {
				return this.select.state.inputValue;
			}
			return '';
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props;
			var loadingPlaceholder = _props2.loadingPlaceholder;
			var noResultsText = _props2.noResultsText;
			var searchPromptText = _props2.searchPromptText;
			var isLoading = this.state.isLoading;

			var inputValue = this.inputValue();

			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props;
			var children = _props3.children;
			var loadingPlaceholder = _props3.loadingPlaceholder;
			var placeholder = _props3.placeholder;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;

			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				},
				onChange: function onChange(newValues) {
					if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
						_this3.clearOptions();
					}
					_this3.props.onChange(newValues);
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this._onInputChange
			}));
		}
	}]);

	return Async;
})(_react.Component);

exports['default'] = Async;

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
}
module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(37);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Select = __webpack_require__(33);

var _Select2 = _interopRequireDefault(_Select);

function reduce(obj) {
	var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatable = (0, _createReactClass2['default'])({
	displayName: 'AsyncCreatableSelect',

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		return _react2['default'].createElement(
			_Select2['default'].Async,
			this.props,
			function (asyncProps) {
				return _react2['default'].createElement(
					_Select2['default'].Creatable,
					_this.props,
					function (creatableProps) {
						return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
							onInputChange: function (input) {
								creatableProps.onInputChange(input);
								return asyncProps.onInputChange(input);
							},
							ref: function (ref) {
								_this.select = ref;
								creatableProps.ref(ref);
								asyncProps.ref(ref);
							}
						}));
					}
				);
			}
		);
	}
});

module.exports = AsyncCreatable;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(37);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(33);

var _Select2 = _interopRequireDefault(_Select);

var _utilsDefaultFilterOptions = __webpack_require__(225);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(226);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var Creatable = (0, _createReactClass2['default'])({
	displayName: 'CreatableSelect',

	propTypes: {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2['default'].func,

		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2['default'].any,

		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2['default'].func,

		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2['default'].func,

		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2['default'].any,

		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2['default'].func,

		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2['default'].func,

		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2['default'].func,

		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2['default'].func,

		// See Select.propTypes.options
		options: _propTypes2['default'].array,

		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2['default'].func,

		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2['default'].func
	},

	// Default prop methods
	statics: {
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	},

	getDefaultProps: function getDefaultProps() {
		return {
			filterOptions: _utilsDefaultFilterOptions2['default'],
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		};
	},

	createNewOption: function createNewOption() {
		var _props = this.props;
		var isValidNewOption = _props.isValidNewOption;
		var newOptionCreator = _props.newOptionCreator;
		var onNewOptionClick = _props.onNewOptionClick;
		var _props$options = _props.options;
		var options = _props$options === undefined ? [] : _props$options;
		var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;

		if (isValidNewOption({ label: this.inputValue })) {
			var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
			var _isOptionUnique = this.isOptionUnique({ option: option });

			// Don't add the same option twice.
			if (_isOptionUnique) {
				if (onNewOptionClick) {
					onNewOptionClick(option);
				} else {
					options.unshift(option);

					this.select.selectValue(option);
				}
			}
		}
	},

	filterOptions: function filterOptions() {
		var _props2 = this.props;
		var filterOptions = _props2.filterOptions;
		var isValidNewOption = _props2.isValidNewOption;
		var options = _props2.options;
		var promptTextCreator = _props2.promptTextCreator;

		// TRICKY Check currently selected options as well.
		// Don't display a create-prompt for a value that's selected.
		// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
		var excludeOptions = arguments[2] || [];

		var filteredOptions = filterOptions.apply(undefined, arguments) || [];

		if (isValidNewOption({ label: this.inputValue })) {
			var _newOptionCreator = this.props.newOptionCreator;

			var option = _newOptionCreator({
				label: this.inputValue,
				labelKey: this.labelKey,
				valueKey: this.valueKey
			});

			// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
			// For multi-selects, this would remove it from the filtered list.
			var _isOptionUnique2 = this.isOptionUnique({
				option: option,
				options: excludeOptions.concat(filteredOptions)
			});

			if (_isOptionUnique2) {
				var _prompt = promptTextCreator(this.inputValue);

				this._createPlaceholderOption = _newOptionCreator({
					label: _prompt,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				filteredOptions.unshift(this._createPlaceholderOption);
			}
		}

		return filteredOptions;
	},

	isOptionUnique: function isOptionUnique(_ref2) {
		var option = _ref2.option;
		var options = _ref2.options;
		var isOptionUnique = this.props.isOptionUnique;

		options = options || this.select.filterOptions();

		return isOptionUnique({
			labelKey: this.labelKey,
			option: option,
			options: options,
			valueKey: this.valueKey
		});
	},

	menuRenderer: function menuRenderer(params) {
		var menuRenderer = this.props.menuRenderer;

		return menuRenderer(_extends({}, params, {
			onSelect: this.onOptionSelect,
			selectValue: this.onOptionSelect
		}));
	},

	onInputChange: function onInputChange(input) {
		var onInputChange = this.props.onInputChange;

		if (onInputChange) {
			onInputChange(input);
		}

		// This value may be needed in between Select mounts (when this.select is null)
		this.inputValue = input;
	},

	onInputKeyDown: function onInputKeyDown(event) {
		var _props3 = this.props;
		var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
		var onInputKeyDown = _props3.onInputKeyDown;

		var focusedOption = this.select.getFocusedOption();

		if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
			this.createNewOption();

			// Prevent decorated Select from doing anything additional with this keyDown event
			event.preventDefault();
		} else if (onInputKeyDown) {
			onInputKeyDown(event);
		}
	},

	onOptionSelect: function onOptionSelect(option, event) {
		if (option === this._createPlaceholderOption) {
			this.createNewOption();
		} else {
			this.select.selectValue(option);
		}
	},

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		var _props4 = this.props;
		var newOptionCreator = _props4.newOptionCreator;
		var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;

		var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

		var children = this.props.children;

		// We can't use destructuring default values to set the children,
		// because it won't apply work if `children` is null. A falsy check is
		// more reliable in real world use-cases.
		if (!children) {
			children = defaultChildren;
		}

		var props = _extends({}, restProps, {
			allowCreate: true,
			filterOptions: this.filterOptions,
			menuRenderer: this.menuRenderer,
			onInputChange: this.onInputChange,
			onInputKeyDown: this.onInputKeyDown,
			ref: function ref(_ref) {
				_this.select = _ref;

				// These values may be needed in between Select mounts (when this.select is null)
				if (_ref) {
					_this.labelKey = _ref.props.labelKey;
					_this.valueKey = _ref.props.valueKey;
				}
			}
		});

		return children(props);
	}
});

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option;
	var options = _ref3.options;
	var labelKey = _ref3.labelKey;
	var valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label;
	var labelKey = _ref5.labelKey;
	var valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

module.exports = Creatable;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(37);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(62);

var _classnames2 = _interopRequireDefault(_classnames);

var Option = (0, _createReactClass2['default'])({
	propTypes: {
		children: _propTypes2['default'].node,
		className: _propTypes2['default'].string, // className (based on mouse position)
		instancePrefix: _propTypes2['default'].string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2['default'].bool, // the option is disabled
		isFocused: _propTypes2['default'].bool, // the option is focused
		isSelected: _propTypes2['default'].bool, // the option is selected
		onFocus: _propTypes2['default'].func, // method to handle mouseEnter on option element
		onSelect: _propTypes2['default'].func, // method to handle click on option element
		onUnfocus: _propTypes2['default'].func, // method to handle mouseLeave on option element
		option: _propTypes2['default'].object.isRequired, // object that is base for that option
		optionIndex: _propTypes2['default'].number },
	// index of the option, used to generate unique ids for aria
	blockEvent: function blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	},

	handleMouseDown: function handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},

	handleMouseEnter: function handleMouseEnter(event) {
		this.onFocus(event);
	},

	handleMouseMove: function handleMouseMove(event) {
		this.onFocus(event);
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		this.handleMouseDown(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	onFocus: function onFocus(event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},
	render: function render() {
		var _props = this.props;
		var option = _props.option;
		var instancePrefix = _props.instancePrefix;
		var optionIndex = _props.optionIndex;

		var className = (0, _classnames2['default'])(this.props.className, option.className);

		return option.disabled ? _react2['default'].createElement(
			'div',
			{ className: className,
				onMouseDown: this.blockEvent,
				onClick: this.blockEvent },
			this.props.children
		) : _react2['default'].createElement(
			'div',
			{ className: className,
				style: option.style,
				role: 'option',
				onMouseDown: this.handleMouseDown,
				onMouseEnter: this.handleMouseEnter,
				onMouseMove: this.handleMouseMove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEnd,
				id: instancePrefix + '-option-' + optionIndex,
				title: option.title },
			this.props.children
		);
	}
});

module.exports = Option;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(37);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(8);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(62);

var _classnames2 = _interopRequireDefault(_classnames);

var Value = (0, _createReactClass2['default'])({

	displayName: 'Value',

	propTypes: {
		children: _propTypes2['default'].node,
		disabled: _propTypes2['default'].bool, // disabled prop passed to ReactSelect
		id: _propTypes2['default'].string, // Unique id for the value - used for aria
		onClick: _propTypes2['default'].func, // method to handle click on value label
		onRemove: _propTypes2['default'].func, // method to handle removal of the value
		value: _propTypes2['default'].object.isRequired },

	// the option object for this value
	handleMouseDown: function handleMouseDown(event) {
		if (event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		if (this.props.onClick) {
			event.stopPropagation();
			this.props.onClick(this.props.value, event);
			return;
		}
		if (this.props.value.href) {
			event.stopPropagation();
		}
	},

	onRemove: function onRemove(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onRemove(this.props.value);
	},

	handleTouchEndRemove: function handleTouchEndRemove(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.onRemove(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	renderRemoveIcon: function renderRemoveIcon() {
		if (this.props.disabled || !this.props.onRemove) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-value-icon',
				'aria-hidden': 'true',
				onMouseDown: this.onRemove,
				onTouchEnd: this.handleTouchEndRemove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove },
			'×'
		);
	},

	renderLabel: function renderLabel() {
		var className = 'Select-value-label';
		return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
			'a',
			{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
			this.props.children
		) : _react2['default'].createElement(
			'span',
			{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
			this.props.children
		);
	},

	render: function render() {
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
				style: this.props.value.style,
				title: this.props.value.title
			},
			this.renderRemoveIcon(),
			this.renderLabel()
		);
	}

});

module.exports = Value;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports["default"] = arrowRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2["default"].createElement("span", {
		className: "Select-arrow",
		onMouseDown: onMouseDown
	});
}

;
module.exports = exports["default"];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = clearRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function clearRenderer() {
	return _react2['default'].createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
}

;
module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(60);

var invariant = __webpack_require__(1);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(541);
var ReactElement = __webpack_require__(45);

var emptyFunction = __webpack_require__(17);
var traverseAllChildren = __webpack_require__(551);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(45);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(45),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(196);

module.exports = factory(isValidElement);

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(228),
    Component = _require.Component;

var _require2 = __webpack_require__(45),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(231);
var factory = __webpack_require__(141);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(60);

var ReactElement = __webpack_require__(45);

var invariant = __webpack_require__(1);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(60);

var ReactCurrentOwner = __webpack_require__(25);
var REACT_ELEMENT_TYPE = __webpack_require__(230);

var getIteratorFn = __webpack_require__(547);
var invariant = __webpack_require__(1);
var KeyEscapeUtils = __webpack_require__(540);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(234);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(75);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(74);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(235);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(21);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__effects__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(554);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);












/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(234);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__channel__["e" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* is */].object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["u" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(21);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(76);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(233);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = middleware;

var _actions = __webpack_require__(61);

var _utils = __webpack_require__(77);

function getToken(state, name) {
  var tooltips = state.tooltip;

  var tooltip = tooltips[name];
  if (tooltip) {
    return tooltip.timeout;
  }
}

var CANCEL_TYPES = [_actions.SHOW, _actions.HIDE];

function middleware(store) {
  return function (next) {
    return function (action) {
      var names = (0, _utils.resolve)(action);
      if (CANCEL_TYPES.indexOf(action.type) !== -1) {
        // Clear timeout
        names.forEach(function (name) {
          var token = getToken(store.getState(), name);
          token && clearTimeout(token);
        });
      }

      if (!action.meta || !action.meta[_actions.DELAY]) {
        return next(action);
      }

      // Setup timeout
      var _action$meta$DELAY = action.meta[_actions.DELAY],
          duration = _action$meta$DELAY.duration,
          callback = _action$meta$DELAY.callback;

      names.forEach(function (name) {
        var newToken = setTimeout(function () {
          // Ignore if token is cleared
          var token = getToken(store.getState(), name);
          if (token !== null) {
            // Clear timeout token
            next((0, _actions.endTimeout)({ name: name }));

            // Dispatch original action
            delete action.meta[_actions.DELAY];
            next(action);

            // Notify via callback
            callback && callback(action.type, duration, action);
          }
        }, duration);

        // Store timeout token
        next((0, _actions.startTimeout)({ name: name, token: newToken }));
      });

      return names;
    };
  };
}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _blacklist = __webpack_require__(273);

var _blacklist2 = _interopRequireDefault(_blacklist);

var _actions = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Origin = function (_Component) {
  _inherits(Origin, _Component);

  function Origin() {
    _classCallCheck(this, Origin);

    return _possibleConstructorReturn(this, (Origin.__proto__ || Object.getPrototypeOf(Origin)).apply(this, arguments));
  }

  _createClass(Origin, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // hide the tooltip
      this.props.dispatch((0, _actions.hide)(_extends({}, this.props)));
    }
  }, {
    key: 'createWithDelay',
    value: function createWithDelay(creator) {
      var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _props = this.props,
          duration = _props.delay,
          callback = _props.onTimeout;

      var action = creator(_extends({}, this.props, extras));
      if (duration || callback) {
        action = (0, _actions.delay)(action, { duration: duration, callback: callback });
      }
      return action;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = (0, _blacklist2.default)(this.props, 'name', 'content', 'place', 'tagName', 'delay', 'delayOn', 'dispatch', 'onTimeout', 'onHover', 'onLeave');

      if (!props.onMouseEnter) {
        props.onMouseEnter = function (e) {
          var action = ['show', 'both'].indexOf(_this2.props.delayOn) !== -1 ? _this2.createWithDelay(_actions.show, { origin: e.target }) : (0, _actions.show)(_extends({}, _this2.props, { origin: e.target }));
          _this2.props.dispatch(action);
          _this2.props.onHover && _this2.props.onHover(e);
        };
      }

      if (!props.onMouseLeave) {
        props.onMouseLeave = function (e) {
          var action = ['hide', 'both'].indexOf(_this2.props.delayOn) !== -1 ? _this2.createWithDelay(_actions.hide) : (0, _actions.hide)(_extends({}, _this2.props));
          _this2.props.dispatch(action);
          _this2.props.onLeave && _this2.props.onLeave(e);
        };
      }

      return _react2.default.createElement(this.props.tagName, _extends({}, props, { ref: 'wrapper'
      }));
    }
  }], [{
    key: 'wrapBy',
    value: function wrapBy(tagName) {
      var CustomOrigin = function (_Origin) {
        _inherits(CustomOrigin, _Origin);

        function CustomOrigin() {
          _classCallCheck(this, CustomOrigin);

          return _possibleConstructorReturn(this, (CustomOrigin.__proto__ || Object.getPrototypeOf(CustomOrigin)).apply(this, arguments));
        }

        _createClass(CustomOrigin, null, [{
          key: 'displayName',
          get: function get() {
            return Origin.displayName + '.' + tagName;
          }
        }, {
          key: 'defaultProps',
          get: function get() {
            return _extends({}, Origin.defaultProps, {
              tagName: tagName
            });
          }
        }]);

        return CustomOrigin;
      }(Origin);

      return (0, _reactRedux.connect)()(CustomOrigin);
    }
  }, {
    key: 'displayName',
    get: function get() {
      return 'Origin';
    }
  }, {
    key: 'propTypes',
    get: function get() {
      return {
        name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
        content: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object, _react.PropTypes.arrayOf(_react.PropTypes.object)]),
        place: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
        tagName: _react.PropTypes.string,
        delay: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.number, _react.PropTypes.string]),
        delayOn: _react.PropTypes.oneOf(['show', 'hide', 'both']),
        onTimeout: _react.PropTypes.func,
        onMouseEnter: _react.PropTypes.func,
        onMouseLeave: _react.PropTypes.func,
        onHover: _react.PropTypes.func,
        onLeave: _react.PropTypes.func
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        delayOn: 'hide',
        tagName: 'span'
      };
    }
  }]);

  return Origin;
}(_react.Component);

exports.default = (0, _reactRedux.connect)()(Origin);

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handlers;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _utils = __webpack_require__(77);

var _actions = __webpack_require__(61);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initial = {
  show: false,
  place: 'top',
  origin: null,
  el: null,
  auto: true,
  content: null,
  timeout: null
};

var SHOW_PROPS = ['origin', 'el', 'place', 'content'];

var handlers = (_handlers = {}, _defineProperty(_handlers, _actions.SHOW, function (state, action) {
  var props = {};
  SHOW_PROPS.forEach(function (name) {
    if (action.payload[name]) {
      props[name] = action.payload[name];
    } else {
      props[name] = initial[name];
    }
  });
  return _extends({}, state, { show: true }, props);
}), _defineProperty(_handlers, _actions.HIDE, function (state) {
  return _extends({}, state, { show: false });
}), _defineProperty(_handlers, _actions.TOGGLE, function (state) {
  return _extends({}, state, { show: !state.show });
}), _defineProperty(_handlers, _actions.KEEP, function (state) {
  return _extends({}, state, { timeout: null });
}), _defineProperty(_handlers, _actions.CONTENT, function (state, action) {
  return _extends({}, state, { content: action.payload });
}), _defineProperty(_handlers, _actions.PLACE, function (state, action) {
  return _extends({}, state, { place: action.payload });
}), _defineProperty(_handlers, _actions.START_TIMEOUT, function (state, action) {
  return _extends({}, state, { timeout: action.payload.token });
}), _defineProperty(_handlers, _actions.END_TIMEOUT, function (state) {
  return _extends({}, state, { timeout: null });
}), _handlers);

function tooltip() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
  var action = arguments[1];

  // Check usage of deprecated props
  (0, _utils.deprecatedWarning)(action);

  var handler = handlers[action.type];
  return handler ? handler(state, action) : state;
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var newState = _extends({}, state);
  var names = (0, _utils.resolve)(action);
  names.forEach(function (name) {
    newState = _extends({}, newState, _defineProperty({}, name, tooltip(newState[name], action)));
  });
  return newState;
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.border = exports.arrow = exports.content = exports.base = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _themes = __webpack_require__(237);

var themes = _interopRequireWildcard(_themes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var theme = themes.simple;

var base = exports.base = {
  padding: 0,
  fontSize: 0,
  lineHeight: 0,
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 9999,
  width: 'auto',
  overflow: 'visible'
};

var content = exports.content = {
  overflow: 'hidden'
};

var arrow = exports.arrow = {
  display: 'block',
  textAlign: 'center',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: -1
};

var vertical = {
  left: 0,
  right: 0,
  margin: '0 auto'
};

var horizontal = {
  top: '50%',
  marginTop: '-8px'
};

var border = exports.border = {
  base: {
    display: 'block',
    width: 0,
    height: 0,
    position: 'absolute',
    borderStyle: 'solid'
  },
  top: _extends({
    borderColor: theme.border.borderColor + ' transparent transparent transparent',
    borderWidth: '9px 9px 0px 9px',
    bottom: '-7px'
  }, vertical),
  right: _extends({
    borderColor: 'transparent ' + theme.border.borderColor + ' transparent transparent',
    borderWidth: '9px 9px 9px 0px',
    left: '-7px'
  }, horizontal),
  bottom: _extends({
    borderColor: 'transparent transparent ' + theme.border.borderColor + ' transparent',
    borderWidth: '0px 9px 9px 9px',
    top: '-7px'
  }, vertical),
  left: _extends({
    borderColor: 'transparent transparent transparent ' + theme.border.borderColor,
    borderWidth: '9px 0px 9px 9px',
    right: '-7px'
  }, horizontal)
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var _dompurify = __webpack_require__(381);

var _utils = __webpack_require__(77);

var _styles = __webpack_require__(558);

var styles = _interopRequireWildcard(_styles);

var _themes = __webpack_require__(237);

var themes = _interopRequireWildcard(_themes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  _createClass(Tooltip, null, [{
    key: 'displayName',
    get: function get() {
      return 'Tooltip';
    }
  }, {
    key: 'propTypes',
    get: function get() {
      return {
        // Props from state tree
        show: _react.PropTypes.bool.isRequired,
        origin: _react.PropTypes.object,
        el: _react.PropTypes.object,
        place: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]).isRequired,
        content: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object, _react.PropTypes.arrayOf(_react.PropTypes.object)]),
        auto: _react.PropTypes.bool.isRequired,
        within: _react.PropTypes.func,

        // Props from wrapper props
        name: _react.PropTypes.string,
        id: _react.PropTypes.string,
        className: _react.PropTypes.string,
        onHover: _react.PropTypes.func,
        onLeave: _react.PropTypes.func
      };
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        show: false,
        place: 'top',
        auto: true
      };
    }
  }]);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var place = nextProps.place,
          content = nextProps.content,
          children = nextProps.children;

      var origin = (0, _utils.originOrEl)(nextProps);
      if (origin && ((0, _utils.originOrEl)(this.props) != origin || this.props.place !== place || this.props.content !== content || this.props.children !== children)) {
        this.updatePosition(nextProps);
      }
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition(props) {
      var _this2 = this;

      // Render content into hidden DOM element to determine size
      var content = this.children(props);
      _reactDom2.default.render(_react2.default.createElement(
        'div',
        null,
        content
      ), this.refs.shadow, function () {
        var state = (0, _utils.adjust)(_this2.refs.shadow, props);
        _this2.setState(state);
      });
    }
  }, {
    key: 'children',
    value: function children() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var content = props.content;

      if (typeof content === 'string') {
        content = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _dompurify.sanitize)(content) } });
      }
      return content ? content : props.children;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          show = _props.show,
          onHover = _props.onHover,
          onLeave = _props.onLeave;

      var origin = (0, _utils.originOrEl)(this.props);
      var _state = this.state,
          place = _state.place,
          offset = _state.offset;

      var content = this.children();
      var visibility = origin && show ? 'visible' : 'hidden';
      var style = {
        base: _extends({}, styles.base, themes.simple.base, { visibility: visibility }, offset),
        content: _extends({}, styles.content, themes.simple.content),
        arrow: _extends({}, styles.arrow),
        border: _extends({}, themes.simple.border, styles.border.base, styles.border[place])
      };
      style.shadow = _extends({}, style.content, { visibility: 'hidden', position: 'absolute' });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            ref: 'tooltip',
            style: style.base,
            id: id,
            className: className,
            onMouseEnter: onHover,
            onMouseLeave: onLeave
          },
          _react2.default.createElement(
            'div',
            {
              ref: 'content',
              style: style.content,
              id: id + '-content',
              className: className + '-content'
            },
            content
          ),
          _react2.default.createElement(
            'div',
            {
              style: style.arrow,
              id: id + '-arrow',
              className: className + '-arrow',
              key: 'a-' + place
            },
            _react2.default.createElement('span', { ref: 'border', style: style.border, key: 'b-' + place })
          )
        ),
        _react2.default.createElement('div', {
          ref: 'shadow',
          style: style.shadow,
          id: id + '-shadow',
          className: className + '-shadow'
        })
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

function select(state, ownProps) {
  var tooltips = state.tooltip;

  var names = (0, _utils.resolve)(ownProps);
  if (1 < names.length) {
    console.error('<Tooltip> does not accept a list of names as \'name\' props: ' + names);
  }
  var name = names[0];
  var tooltip = tooltips[name];
  return _extends({}, tooltip, ownProps);
}

exports.default = (0, _reactRedux.connect)(select)(Tooltip);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(238);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(129);


function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('bindActionCreators expected a function actionCreator for key \'' + key + '\', instead received type \'' + typeof actionCreator + '\'.');
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(129);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(564);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsolute = function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
};

// About 1.5x faster than the two-arg version of Array#splice()
var spliceOne = function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }list.pop();
};

// This implementation is based heavily on node's url.parse
var resolvePathname = function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
};

module.exports = resolvePathname;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(274);
var RequestBase = __webpack_require__(569);
var isObject = __webpack_require__(130);
var isFunction = __webpack_require__(568);
var ResponseBase = __webpack_require__(570);
var shouldRetry = __webpack_require__(571);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
      status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if(this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can substitute for options
    options = pass;
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    }
  }

  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + btoa(user + ':' + pass));
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
      
    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
    break;  
  }
  return this;
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  // console.log(this._retries, this._maxRetries)
  if (this._maxRetries && this._retries++ < this._maxRetries && shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if (isFunction(this._sort)) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._appendQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn){
  var req = request('DELETE', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Check if `fn` is a function.
 *
 * @param {Function} fn
 * @return {Boolean}
 * @api private
 */
var isObject = __webpack_require__(130);

function isFunction(fn) {
  var tag = isObject(fn) ? Object.prototype.toString.call(fn) : '';
  return tag === '[object Function]';
}

module.exports = isFunction;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(130);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, read, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  return this;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {
  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
}

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on){
  // This is browser-only functionality. Node side is no-op.
  if(on==undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};


/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};


/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
}


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var utils = __webpack_require__(572);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field){
    return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};


/***/ }),
/* 571 */
/***/ (function(module, exports) {

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
module.exports = function shouldRetry(err, res) {
  if (err && err.code && ~ERROR_CODES.indexOf(err.code)) return true;
  if (res && res.status && res.status >= 500) return true;
  // Superagent timeout
  if (err && 'timeout' in err && err.code == 'ECONNABORTED') return true;
  if (err && 'crossDomain' in err) return true;
  return false;
};


/***/ }),
/* 572 */
/***/ (function(module, exports) {


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, shouldStripCookie){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  if (shouldStripCookie) {
    delete header['cookie'];
  }
  return header;
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(574);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(575);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35), __webpack_require__(244)(module)))

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bbox__ = __webpack_require__(240);
/* unused harmony reexport bbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_feature__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_feature__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_mesh__ = __webpack_require__(579);
/* unused harmony reexport mesh */
/* unused harmony reexport meshArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_merge__ = __webpack_require__(578);
/* unused harmony reexport merge */
/* unused harmony reexport mergeArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_neighbors__ = __webpack_require__(580);
/* unused harmony reexport neighbors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_quantize__ = __webpack_require__(581);
/* unused harmony reexport quantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_transform__ = __webpack_require__(132);
/* unused harmony reexport transform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_untransform__ = __webpack_require__(243);
/* unused harmony reexport untransform */










/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, x) {
  var lo = 0, hi = a.length;
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (a[mid] < x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
});


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mergeArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stitch__ = __webpack_require__(242);



function planarRingArea(ring) {
  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
  return Math.abs(area); // Note: doubled area!
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(topology) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, mergeArcs.apply(this, arguments));
});

function mergeArcs(topology, objects) {
  var polygonsByArc = {},
      polygons = [],
      groups = [];

  objects.forEach(geometry);

  function geometry(o) {
    switch (o.type) {
      case "GeometryCollection": o.geometries.forEach(geometry); break;
      case "Polygon": extract(o.arcs); break;
      case "MultiPolygon": o.arcs.forEach(extract); break;
    }
  }

  function extract(polygon) {
    polygon.forEach(function(ring) {
      ring.forEach(function(arc) {
        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
      });
    });
    polygons.push(polygon);
  }

  function area(ring) {
    return planarRingArea(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
  }

  polygons.forEach(function(polygon) {
    if (!polygon._) {
      var group = [],
          neighbors = [polygon];
      polygon._ = 1;
      groups.push(group);
      while (polygon = neighbors.pop()) {
        group.push(polygon);
        polygon.forEach(function(ring) {
          ring.forEach(function(arc) {
            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
              if (!polygon._) {
                polygon._ = 1;
                neighbors.push(polygon);
              }
            });
          });
        });
      }
    }
  });

  polygons.forEach(function(polygon) {
    delete polygon._;
  });

  return {
    type: "MultiPolygon",
    arcs: groups.map(function(polygons) {
      var arcs = [], n;

      // Extract the exterior (unique) arcs.
      polygons.forEach(function(polygon) {
        polygon.forEach(function(ring) {
          ring.forEach(function(arc) {
            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
              arcs.push(arc);
            }
          });
        });
      });

      // Stitch the arcs into one or more rings.
      arcs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stitch__["a" /* default */])(topology, arcs);

      // If more than one ring is returned,
      // at most one of these rings can be the exterior;
      // choose the one with the greatest absolute area.
      if ((n = arcs.length) > 1) {
        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
          if ((ki = area(arcs[i])) > k) {
            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
          }
        }
      }

      return arcs;
    })
  };
}


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export meshArcs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stitch__ = __webpack_require__(242);



/* unused harmony default export */ var _unused_webpack_default_export = (function(topology) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__feature__["b" /* object */])(topology, meshArcs.apply(this, arguments));
});

function meshArcs(topology, object, filter) {
  var arcs, i, n;
  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
  return {type: "MultiLineString", arcs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stitch__["a" /* default */])(topology, arcs)};
}

function extractArcs(topology, object, filter) {
  var arcs = [],
      geomsByArc = [],
      geom;

  function extract0(i) {
    var j = i < 0 ? ~i : i;
    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
  }

  function extract1(arcs) {
    arcs.forEach(extract0);
  }

  function extract2(arcs) {
    arcs.forEach(extract1);
  }

  function extract3(arcs) {
    arcs.forEach(extract2);
  }

  function geometry(o) {
    switch (geom = o, o.type) {
      case "GeometryCollection": o.geometries.forEach(geometry); break;
      case "LineString": extract1(o.arcs); break;
      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
      case "MultiPolygon": extract3(o.arcs); break;
    }
  }

  geometry(object);

  geomsByArc.forEach(filter == null
      ? function(geoms) { arcs.push(geoms[0].i); }
      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });

  return arcs;
}


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(577);


/* unused harmony default export */ var _unused_webpack_default_export = (function(objects) {
  var indexesByArc = {}, // arc index -> array of object indexes
      neighbors = objects.map(function() { return []; });

  function line(arcs, i) {
    arcs.forEach(function(a) {
      if (a < 0) a = ~a;
      var o = indexesByArc[a];
      if (o) o.push(i);
      else indexesByArc[a] = [i];
    });
  }

  function polygon(arcs, i) {
    arcs.forEach(function(arc) { line(arc, i); });
  }

  function geometry(o, i) {
    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
  }

  var geometryType = {
    LineString: line,
    MultiLineString: polygon,
    Polygon: polygon,
    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
  };

  objects.forEach(geometry);

  for (var i in indexesByArc) {
    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
      for (var k = j + 1; k < m; ++k) {
        var ij = indexes[j], ik = indexes[k], n;
        if ((n = neighbors[ij])[i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bisect__["a" /* default */])(n, ik)] !== ik) n.splice(i, 0, ik);
        if ((n = neighbors[ik])[i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bisect__["a" /* default */])(n, ij)] !== ij) n.splice(i, 0, ij);
      }
    }
  }

  return neighbors;
});


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bbox__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__untransform__ = __webpack_require__(243);



/* unused harmony default export */ var _unused_webpack_default_export = (function(topology, transform) {
  if (topology.transform) throw new Error("already quantized");

  if (!transform || !transform.scale) {
    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
    box = topology.bbox || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bbox__["a" /* default */])(topology);
    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
  } else {
    box = topology.bbox;
  }

  var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__untransform__["a" /* default */])(transform), box, key, inputs = topology.objects, outputs = {};

  function quantizePoint(point) {
    return t(point);
  }

  function quantizeGeometry(input) {
    var output;
    switch (input.type) {
      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
      default: return input;
    }
    if (input.id != null) output.id = input.id;
    if (input.bbox != null) output.bbox = input.bbox;
    if (input.properties != null) output.properties = input.properties;
    return output;
  }

  function quantizeArc(input) {
    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
    output[0] = t(input[0], 0);
    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
    output.length = j;
    return output;
  }

  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);

  return {
    type: "Topology",
    bbox: box,
    transform: transform,
    objects: outputs,
    arcs: topology.arcs.map(quantizeArc)
  };
});


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, n) {
  var t, j = array.length, i = j - n;
  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
    return valueEqual(item, b[index]);
  });

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ }),
/* 584 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {
	"type": "Topology",
	"objects": {
		"countries": {
			"type": "GeometryCollection",
			"geometries": [
				{
					"type": "Polygon",
					"arcs": [
						[
							0,
							1,
							2,
							3,
							4,
							5
						]
					],
					"id": "AFG"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								6,
								7,
								8,
								9
							]
						],
						[
							[
								10,
								11,
								12
							]
						]
					],
					"id": "AGO"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							13,
							14,
							15,
							16,
							17
						]
					],
					"id": "ALB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							18,
							19,
							20,
							21,
							22
						]
					],
					"id": "ARE"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								23,
								24
							]
						],
						[
							[
								25,
								26,
								27,
								28,
								29,
								30
							]
						]
					],
					"id": "ARG"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							31,
							32,
							33,
							34,
							35
						]
					],
					"id": "ARM"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								36
							]
						],
						[
							[
								37
							]
						],
						[
							[
								38
							]
						],
						[
							[
								39
							]
						],
						[
							[
								40
							]
						],
						[
							[
								41
							]
						],
						[
							[
								42
							]
						],
						[
							[
								43
							]
						]
					],
					"id": "ATA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							44
						]
					],
					"id": "ATF"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								45
							]
						],
						[
							[
								46
							]
						]
					],
					"id": "AUS"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							47,
							48,
							49,
							50,
							51,
							52,
							53
						]
					],
					"id": "AUT"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								54,
								-35
							]
						],
						[
							[
								55,
								56,
								-33,
								57,
								58
							]
						]
					],
					"id": "AZE"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							59,
							60,
							61
						]
					],
					"id": "BDI"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							62,
							63,
							64,
							65,
							66
						]
					],
					"id": "BEL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							67,
							68,
							69,
							70,
							71
						]
					],
					"id": "BEN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							72,
							73,
							74,
							-70,
							75,
							76
						]
					],
					"id": "BFA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							77,
							78,
							79
						]
					],
					"id": "BGD"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							80,
							81,
							82,
							83,
							84,
							85
						]
					],
					"id": "BGR"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								86
							]
						],
						[
							[
								87
							]
						],
						[
							[
								88
							]
						]
					],
					"id": "BHS"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							89,
							90,
							91
						]
					],
					"id": "BIH"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							92,
							93,
							94,
							95,
							96
						]
					],
					"id": "BLR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							97,
							98,
							99
						]
					],
					"id": "BLZ"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							100,
							101,
							102,
							103,
							-31
						]
					],
					"id": "BOL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-27,
							104,
							-103,
							105,
							106,
							107,
							108,
							109,
							110,
							111,
							112
						]
					],
					"id": "BRA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							113,
							114
						]
					],
					"id": "BRN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							115,
							116
						]
					],
					"id": "BTN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							117,
							118,
							119,
							120
						]
					],
					"id": "BWA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							121,
							122,
							123,
							124,
							125,
							126,
							127
						]
					],
					"id": "CAF"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								128
							]
						],
						[
							[
								129
							]
						],
						[
							[
								130
							]
						],
						[
							[
								131
							]
						],
						[
							[
								132
							]
						],
						[
							[
								133
							]
						],
						[
							[
								134
							]
						],
						[
							[
								135
							]
						],
						[
							[
								136
							]
						],
						[
							[
								137
							]
						],
						[
							[
								138,
								139,
								140,
								141
							]
						],
						[
							[
								142
							]
						],
						[
							[
								143
							]
						],
						[
							[
								144
							]
						],
						[
							[
								145
							]
						],
						[
							[
								146
							]
						],
						[
							[
								147
							]
						],
						[
							[
								148
							]
						],
						[
							[
								149
							]
						],
						[
							[
								150
							]
						],
						[
							[
								151
							]
						],
						[
							[
								152
							]
						],
						[
							[
								153
							]
						],
						[
							[
								154
							]
						],
						[
							[
								155
							]
						],
						[
							[
								156
							]
						],
						[
							[
								157
							]
						],
						[
							[
								158
							]
						],
						[
							[
								159
							]
						],
						[
							[
								160
							]
						]
					],
					"id": "CAN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-51,
							161,
							162,
							163
						]
					],
					"id": "CHE"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								-24,
								164
							]
						],
						[
							[
								-30,
								165,
								166,
								-101
							]
						]
					],
					"id": "CHL"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								167
							]
						],
						[
							[
								168,
								169,
								170,
								171,
								172,
								173,
								-117,
								174,
								175,
								176,
								177,
								-4,
								178,
								179,
								180,
								181,
								182,
								183
							]
						]
					],
					"id": "CHN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							184,
							185,
							186,
							187,
							-73,
							188
						]
					],
					"id": "CIV"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							189,
							190,
							191,
							192,
							193,
							194,
							-128,
							195
						]
					],
					"id": "CMR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							196,
							197,
							-60,
							198,
							199,
							200,
							201,
							-10,
							202,
							-13,
							203,
							-126,
							204
						]
					],
					"id": "COD"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-12,
							205,
							206,
							-196,
							-127,
							-204
						]
					],
					"id": "COG"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							207,
							208,
							209,
							210,
							211,
							-107,
							212
						]
					],
					"id": "COL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							213,
							214,
							215,
							216
						]
					],
					"id": "CRI"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							217
						]
					],
					"id": "CUB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							218,
							219
						]
					],
					"id": "-99"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							220,
							-220
						]
					],
					"id": "CYP"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-53,
							221,
							222,
							223
						]
					],
					"id": "CZE"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							224,
							225,
							-222,
							-52,
							-164,
							226,
							227,
							-64,
							228,
							229,
							230
						]
					],
					"id": "DEU"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							231,
							232,
							233,
							234
						]
					],
					"id": "DJI"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								235
							]
						],
						[
							[
								-231,
								236
							]
						]
					],
					"id": "DNK"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							237,
							238
						]
					],
					"id": "DOM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							239,
							240,
							241,
							242,
							243,
							244,
							245,
							246
						]
					],
					"id": "DZA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							247,
							-208,
							248
						]
					],
					"id": "ECU"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							249,
							250,
							251,
							252,
							253
						]
					],
					"id": "EGY"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							254,
							255,
							256,
							-235
						]
					],
					"id": "ERI"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							257,
							258,
							259,
							260
						]
					],
					"id": "ESP"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							261,
							262,
							263
						]
					],
					"id": "EST"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-234,
							264,
							265,
							266,
							267,
							268,
							269,
							-255
						]
					],
					"id": "ETH"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							270,
							271,
							272,
							273
						]
					],
					"id": "FIN"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								274
							]
						],
						[
							[
								275
							]
						]
					],
					"id": "FJI"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							276
						]
					],
					"id": "FLK"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								277,
								278,
								279,
								-111
							]
						],
						[
							[
								280
							]
						],
						[
							[
								281,
								-227,
								-163,
								282,
								283,
								-259,
								284,
								-66
							]
						]
					],
					"id": "FRA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							285,
							286,
							-190,
							-207
						]
					],
					"id": "GAB"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								287,
								288
							]
						],
						[
							[
								289
							]
						]
					],
					"id": "GBR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							290,
							291,
							-58,
							-32,
							292
						]
					],
					"id": "GEO"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							293,
							-189,
							-77,
							294
						]
					],
					"id": "GHA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							295,
							296,
							297,
							298,
							299,
							300,
							-187
						]
					],
					"id": "GIN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							301,
							302
						]
					],
					"id": "GMB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							303,
							304,
							-299
						]
					],
					"id": "GNB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							305,
							-191,
							-287
						]
					],
					"id": "GNQ"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								306
							]
						],
						[
							[
								307,
								-15,
								308,
								-84,
								309
							]
						]
					],
					"id": "GRC"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							310
						]
					],
					"id": "GRL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							311,
							312,
							-100,
							313,
							314,
							315
						]
					],
					"id": "GTM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							316,
							317,
							-109,
							318
						]
					],
					"id": "GUY"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							319,
							320,
							-315,
							321,
							322
						]
					],
					"id": "HND"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							323,
							-92,
							324,
							325,
							326,
							327
						]
					],
					"id": "HRV"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-239,
							328
						]
					],
					"id": "HTI"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-48,
							329,
							330,
							331,
							332,
							-328,
							333
						]
					],
					"id": "HUN"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								334
							]
						],
						[
							[
								335,
								336
							]
						],
						[
							[
								337
							]
						],
						[
							[
								338
							]
						],
						[
							[
								339
							]
						],
						[
							[
								340
							]
						],
						[
							[
								341
							]
						],
						[
							[
								342
							]
						],
						[
							[
								343,
								344
							]
						],
						[
							[
								345
							]
						],
						[
							[
								346
							]
						],
						[
							[
								347,
								348
							]
						],
						[
							[
								349
							]
						]
					],
					"id": "IDN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-177,
							350,
							-175,
							-116,
							-174,
							351,
							-80,
							352,
							353
						]
					],
					"id": "IND"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							354,
							-288
						]
					],
					"id": "IRL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							355,
							-6,
							356,
							357,
							358,
							359,
							-55,
							-34,
							-57,
							360
						]
					],
					"id": "IRN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							361,
							362,
							363,
							364,
							365,
							366,
							-359
						]
					],
					"id": "IRQ"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							367
						]
					],
					"id": "ISL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							368,
							369,
							370,
							-254,
							371,
							372,
							373
						]
					],
					"id": "ISR"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								374
							]
						],
						[
							[
								375
							]
						],
						[
							[
								376,
								377,
								-283,
								-162,
								-50
							]
						]
					],
					"id": "ITA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							378
						]
					],
					"id": "JAM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-369,
							379,
							-365,
							380,
							381,
							-371,
							382
						]
					],
					"id": "JOR"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								383
							]
						],
						[
							[
								384
							]
						],
						[
							[
								385
							]
						]
					],
					"id": "JPN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							386,
							387,
							388,
							389,
							-181,
							390
						]
					],
					"id": "KAZ"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							391,
							392,
							393,
							394,
							-267,
							395
						]
					],
					"id": "KEN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-391,
							-180,
							396,
							397
						]
					],
					"id": "KGZ"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							398,
							399,
							400,
							401
						]
					],
					"id": "KHM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							402,
							403
						]
					],
					"id": "KOR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-18,
							404,
							405,
							406
						]
					],
					"id": "-99"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							407,
							408,
							-363
						]
					],
					"id": "KWT"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							409,
							410,
							-172,
							411,
							-400
						]
					],
					"id": "LAO"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-373,
							412,
							413
						]
					],
					"id": "LBN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							414,
							415,
							-296,
							-186
						]
					],
					"id": "LBR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							416,
							-247,
							417,
							418,
							-252,
							419,
							420
						]
					],
					"id": "LBY"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							421
						]
					],
					"id": "LKA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							422
						]
					],
					"id": "LSO"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							423,
							424,
							425,
							-93,
							426
						]
					],
					"id": "LTU"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-228,
							-282,
							-65
						]
					],
					"id": "LUX"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							427,
							-264,
							428,
							-94,
							-426
						]
					],
					"id": "LVA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-244,
							429,
							430
						]
					],
					"id": "MAR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							431,
							432
						]
					],
					"id": "MDA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							433
						]
					],
					"id": "MDG"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							434,
							-98,
							-313,
							435,
							436
						]
					],
					"id": "MEX"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-407,
							437,
							-85,
							-309,
							-14
						]
					],
					"id": "MKD"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							438,
							-241,
							439,
							-74,
							-188,
							-301,
							440
						]
					],
					"id": "MLI"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							441,
							-78,
							-352,
							-173,
							-411,
							442
						]
					],
					"id": "MMR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							443,
							-325,
							-91,
							444,
							-405,
							-17
						]
					],
					"id": "MNE"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							445,
							-183
						]
					],
					"id": "MNG"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							446,
							447,
							448,
							449,
							450,
							451,
							452,
							453
						]
					],
					"id": "MOZ"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							454,
							455,
							456,
							-242,
							-439
						]
					],
					"id": "MRT"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-454,
							457,
							458
						]
					],
					"id": "MWI"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								459,
								460
							]
						],
						[
							[
								-348,
								461,
								-115,
								462
							]
						]
					],
					"id": "MYS"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							463,
							-8,
							464,
							-119,
							465
						]
					],
					"id": "NAM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							466
						]
					],
					"id": "NCL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-75,
							-440,
							-240,
							-417,
							467,
							-194,
							468,
							-71
						]
					],
					"id": "NER"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							469,
							-72,
							-469,
							-193
						]
					],
					"id": "NGA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							470,
							-323,
							471,
							-215
						]
					],
					"id": "NIC"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-229,
							-63,
							472
						]
					],
					"id": "NLD"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								473,
								-274,
								474,
								475
							]
						],
						[
							[
								476
							]
						],
						[
							[
								477
							]
						],
						[
							[
								478
							]
						]
					],
					"id": "NOR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-351,
							-176
						]
					],
					"id": "NPL"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								479
							]
						],
						[
							[
								480
							]
						]
					],
					"id": "NZL"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								481,
								482,
								-22,
								483
							]
						],
						[
							[
								-20,
								484
							]
						]
					],
					"id": "OMN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-178,
							-354,
							485,
							-357,
							-5
						]
					],
					"id": "PAK"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							486,
							-217,
							487,
							-210
						]
					],
					"id": "PAN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-167,
							488,
							-249,
							-213,
							-106,
							-102
						]
					],
					"id": "PER"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								489
							]
						],
						[
							[
								490
							]
						],
						[
							[
								491
							]
						],
						[
							[
								492
							]
						],
						[
							[
								493
							]
						],
						[
							[
								494
							]
						],
						[
							[
								495
							]
						]
					],
					"id": "PHL"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								496
							]
						],
						[
							[
								497
							]
						],
						[
							[
								-344,
								498
							]
						],
						[
							[
								499
							]
						]
					],
					"id": "PNG"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-226,
							500,
							501,
							-427,
							-97,
							502,
							503,
							-223
						]
					],
					"id": "POL"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							504
						]
					],
					"id": "PRI"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							505,
							506,
							-404,
							507,
							-169
						]
					],
					"id": "PRK"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-261,
							508
						]
					],
					"id": "PRT"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-104,
							-105,
							-26
						]
					],
					"id": "PRY"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-383,
							-370
						]
					],
					"id": "PSE"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							509,
							510
						]
					],
					"id": "QAT"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							511,
							-433,
							512,
							513,
							-81,
							514,
							-332
						]
					],
					"id": "ROU"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								515
							]
						],
						[
							[
								-502,
								516,
								-424
							]
						],
						[
							[
								517
							]
						],
						[
							[
								518
							]
						],
						[
							[
								519
							]
						],
						[
							[
								520
							]
						],
						[
							[
								521
							]
						],
						[
							[
								-506,
								-184,
								-446,
								-182,
								-390,
								522,
								-59,
								-292,
								523,
								524,
								-95,
								-429,
								-263,
								525,
								-271,
								-474,
								526
							]
						],
						[
							[
								527
							]
						],
						[
							[
								528
							]
						],
						[
							[
								529
							]
						]
					],
					"id": "RUS"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							530,
							-61,
							-198,
							531
						]
					],
					"id": "RWA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-243,
							-457,
							532,
							-430
						]
					],
					"id": "ESH"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							533,
							-381,
							-364,
							-409,
							534,
							-511,
							535,
							-23,
							-483,
							536
						]
					],
					"id": "SAU"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							537,
							538,
							-123,
							539,
							-420,
							-251,
							540,
							-256,
							-270,
							541
						]
					],
					"id": "SDN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							542,
							-268,
							-395,
							543,
							-205,
							-125,
							544,
							-538
						]
					],
					"id": "SSD"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							545,
							-455,
							-441,
							-300,
							-305,
							546,
							-303
						]
					],
					"id": "SEN"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								547
							]
						],
						[
							[
								548
							]
						],
						[
							[
								549
							]
						],
						[
							[
								550
							]
						],
						[
							[
								551
							]
						]
					],
					"id": "SLB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							552,
							-297,
							-416
						]
					],
					"id": "SLE"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							553,
							-316,
							-321
						]
					],
					"id": "SLV"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-265,
							-233,
							554,
							555
						]
					],
					"id": "-99"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-396,
							-266,
							-556,
							556
						]
					],
					"id": "SOM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-86,
							-438,
							-406,
							-445,
							-90,
							-324,
							-333,
							-515
						]
					],
					"id": "SRB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							557,
							-279,
							558,
							-110,
							-318
						]
					],
					"id": "SUR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-504,
							559,
							-330,
							-54,
							-224
						]
					],
					"id": "SVK"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-49,
							-334,
							-327,
							560,
							-377
						]
					],
					"id": "SVN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-475,
							-273,
							561
						]
					],
					"id": "SWE"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							562,
							-450
						]
					],
					"id": "SWZ"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-380,
							-374,
							-414,
							563,
							564,
							-366
						]
					],
					"id": "SYR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-468,
							-421,
							-540,
							-122,
							-195
						]
					],
					"id": "TCD"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							565,
							-295,
							-76,
							-69
						]
					],
					"id": "TGO"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							566,
							-461,
							567,
							-443,
							-410,
							-399
						]
					],
					"id": "THA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-397,
							-179,
							-3,
							568
						]
					],
					"id": "TJK"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-356,
							569,
							-388,
							570,
							-1
						]
					],
					"id": "TKM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							571,
							-336
						]
					],
					"id": "TLS"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							572
						]
					],
					"id": "TTO"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-246,
							573,
							-418
						]
					],
					"id": "TUN"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								-293,
								-36,
								-360,
								-367,
								-565,
								574
							]
						],
						[
							[
								-310,
								-83,
								575
							]
						]
					],
					"id": "TUR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							576
						]
					],
					"id": "TWN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-393,
							577,
							-447,
							-459,
							578,
							-201,
							579,
							-199,
							-62,
							-531,
							580
						]
					],
					"id": "TZA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-532,
							-197,
							-544,
							-394,
							-581
						]
					],
					"id": "UGA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-525,
							581,
							-513,
							-432,
							-512,
							-331,
							-560,
							-503,
							-96
						]
					],
					"id": "UKR"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-113,
							582,
							-28
						]
					],
					"id": "URY"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								583
							]
						],
						[
							[
								584
							]
						],
						[
							[
								585
							]
						],
						[
							[
								586
							]
						],
						[
							[
								587
							]
						],
						[
							[
								588,
								-437,
								589,
								-139
							]
						],
						[
							[
								590
							]
						],
						[
							[
								591
							]
						],
						[
							[
								592
							]
						],
						[
							[
								-141,
								593
							]
						]
					],
					"id": "USA"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-571,
							-387,
							-398,
							-569,
							-2
						]
					],
					"id": "UZB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							594,
							-319,
							-108,
							-212
						]
					],
					"id": "VEN"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							595,
							-401,
							-412,
							-171
						]
					],
					"id": "VNM"
				},
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								596
							]
						],
						[
							[
								597
							]
						]
					],
					"id": "VUT"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							598,
							-537,
							-482
						]
					],
					"id": "YEM"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-466,
							-118,
							599,
							-451,
							-563,
							-449,
							600
						],
						[
							-423
						]
					],
					"id": "ZAF"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-458,
							-453,
							601,
							-120,
							-465,
							-7,
							-202,
							-579
						]
					],
					"id": "ZMB"
				},
				{
					"type": "Polygon",
					"arcs": [
						[
							-600,
							-121,
							-602,
							-452
						]
					],
					"id": "ZWE"
				}
			]
		},
		"land": {
			"type": "GeometryCollection",
			"geometries": [
				{
					"type": "MultiPolygon",
					"arcs": [
						[
							[
								595,
								401,
								566,
								459,
								567,
								441,
								78,
								352,
								485,
								357,
								361,
								407,
								534,
								509,
								535,
								18,
								484,
								20,
								483,
								598,
								533,
								381,
								249,
								540,
								256,
								231,
								554,
								556,
								391,
								577,
								447,
								600,
								463,
								8,
								202,
								10,
								205,
								285,
								305,
								191,
								469,
								67,
								565,
								293,
								184,
								414,
								552,
								297,
								303,
								546,
								301,
								545,
								455,
								532,
								430,
								244,
								573,
								418,
								252,
								371,
								412,
								563,
								574,
								290,
								523,
								581,
								513,
								81,
								575,
								307,
								15,
								443,
								325,
								560,
								377,
								283,
								259,
								508,
								257,
								284,
								66,
								472,
								229,
								236,
								224,
								500,
								516,
								424,
								427,
								261,
								525,
								271,
								561,
								475,
								526,
								506,
								402,
								507,
								169
							],
							[
								123,
								544,
								538
							],
							[
								199,
								579
							],
							[
								542,
								268,
								541
							],
							[
								388,
								522,
								55,
								360,
								569
							]
						],
						[
							[
								24,
								164
							]
						],
						[
							[
								582,
								28,
								165,
								488,
								247,
								208,
								486,
								213,
								470,
								319,
								553,
								311,
								435,
								589,
								139,
								593,
								141,
								588,
								434,
								98,
								313,
								321,
								471,
								215,
								487,
								210,
								594,
								316,
								557,
								279,
								111
							],
							[
								558,
								277
							]
						],
						[
							[
								36
							]
						],
						[
							[
								37
							]
						],
						[
							[
								38
							]
						],
						[
							[
								39
							]
						],
						[
							[
								40
							]
						],
						[
							[
								41
							]
						],
						[
							[
								42
							]
						],
						[
							[
								43
							]
						],
						[
							[
								44
							]
						],
						[
							[
								45
							]
						],
						[
							[
								46
							]
						],
						[
							[
								86
							]
						],
						[
							[
								87
							]
						],
						[
							[
								88
							]
						],
						[
							[
								461,
								113,
								462,
								348
							]
						],
						[
							[
								128
							]
						],
						[
							[
								129
							]
						],
						[
							[
								130
							]
						],
						[
							[
								131
							]
						],
						[
							[
								132
							]
						],
						[
							[
								133
							]
						],
						[
							[
								134
							]
						],
						[
							[
								135
							]
						],
						[
							[
								136
							]
						],
						[
							[
								137
							]
						],
						[
							[
								142
							]
						],
						[
							[
								143
							]
						],
						[
							[
								144
							]
						],
						[
							[
								145
							]
						],
						[
							[
								146
							]
						],
						[
							[
								147
							]
						],
						[
							[
								148
							]
						],
						[
							[
								149
							]
						],
						[
							[
								150
							]
						],
						[
							[
								151
							]
						],
						[
							[
								152
							]
						],
						[
							[
								153
							]
						],
						[
							[
								154
							]
						],
						[
							[
								155
							]
						],
						[
							[
								156
							]
						],
						[
							[
								157
							]
						],
						[
							[
								158
							]
						],
						[
							[
								159
							]
						],
						[
							[
								160
							]
						],
						[
							[
								167
							]
						],
						[
							[
								217
							]
						],
						[
							[
								218,
								220
							]
						],
						[
							[
								235
							]
						],
						[
							[
								237,
								328
							]
						],
						[
							[
								274
							]
						],
						[
							[
								275
							]
						],
						[
							[
								276
							]
						],
						[
							[
								280
							]
						],
						[
							[
								288,
								354
							]
						],
						[
							[
								289
							]
						],
						[
							[
								306
							]
						],
						[
							[
								310
							]
						],
						[
							[
								334
							]
						],
						[
							[
								336,
								571
							]
						],
						[
							[
								337
							]
						],
						[
							[
								338
							]
						],
						[
							[
								339
							]
						],
						[
							[
								340
							]
						],
						[
							[
								341
							]
						],
						[
							[
								342
							]
						],
						[
							[
								344,
								498
							]
						],
						[
							[
								345
							]
						],
						[
							[
								346
							]
						],
						[
							[
								349
							]
						],
						[
							[
								367
							]
						],
						[
							[
								374
							]
						],
						[
							[
								375
							]
						],
						[
							[
								378
							]
						],
						[
							[
								383
							]
						],
						[
							[
								384
							]
						],
						[
							[
								385
							]
						],
						[
							[
								421
							]
						],
						[
							[
								433
							]
						],
						[
							[
								466
							]
						],
						[
							[
								476
							]
						],
						[
							[
								477
							]
						],
						[
							[
								478
							]
						],
						[
							[
								479
							]
						],
						[
							[
								480
							]
						],
						[
							[
								489
							]
						],
						[
							[
								490
							]
						],
						[
							[
								491
							]
						],
						[
							[
								492
							]
						],
						[
							[
								493
							]
						],
						[
							[
								494
							]
						],
						[
							[
								495
							]
						],
						[
							[
								496
							]
						],
						[
							[
								497
							]
						],
						[
							[
								499
							]
						],
						[
							[
								504
							]
						],
						[
							[
								515
							]
						],
						[
							[
								517
							]
						],
						[
							[
								518
							]
						],
						[
							[
								519
							]
						],
						[
							[
								520
							]
						],
						[
							[
								521
							]
						],
						[
							[
								527
							]
						],
						[
							[
								528
							]
						],
						[
							[
								529
							]
						],
						[
							[
								547
							]
						],
						[
							[
								548
							]
						],
						[
							[
								549
							]
						],
						[
							[
								550
							]
						],
						[
							[
								551
							]
						],
						[
							[
								572
							]
						],
						[
							[
								576
							]
						],
						[
							[
								583
							]
						],
						[
							[
								584
							]
						],
						[
							[
								585
							]
						],
						[
							[
								586
							]
						],
						[
							[
								587
							]
						],
						[
							[
								590
							]
						],
						[
							[
								591
							]
						],
						[
							[
								592
							]
						],
						[
							[
								596
							]
						],
						[
							[
								597
							]
						]
					]
				}
			]
		}
	},
	"arcs": [
		[
			[
				67002,
				71642
			],
			[
				284,
				-224
			],
			[
				209,
				79
			],
			[
				58,
				268
			],
			[
				219,
				89
			],
			[
				157,
				180
			],
			[
				55,
				472
			],
			[
				234,
				114
			],
			[
				44,
				211
			],
			[
				131,
				-158
			],
			[
				84,
				-19
			]
		],
		[
			[
				68477,
				72654
			],
			[
				154,
				-4
			],
			[
				210,
				-124
			]
		],
		[
			[
				68841,
				72526
			],
			[
				85,
				-72
			],
			[
				201,
				189
			],
			[
				93,
				-114
			],
			[
				90,
				271
			],
			[
				166,
				-12
			],
			[
				43,
				86
			],
			[
				29,
				239
			],
			[
				120,
				205
			],
			[
				150,
				-134
			],
			[
				-30,
				-181
			],
			[
				84,
				-28
			],
			[
				-26,
				-496
			],
			[
				110,
				-194
			],
			[
				97,
				125
			],
			[
				123,
				58
			],
			[
				173,
				265
			],
			[
				192,
				-44
			],
			[
				286,
				-1
			]
		],
		[
			[
				70827,
				72688
			],
			[
				50,
				-169
			]
		],
		[
			[
				70877,
				72519
			],
			[
				-162,
				-67
			],
			[
				-141,
				-109
			],
			[
				-319,
				-68
			],
			[
				-298,
				-124
			],
			[
				-163,
				-258
			],
			[
				66,
				-250
			],
			[
				32,
				-294
			],
			[
				-139,
				-248
			],
			[
				12,
				-227
			],
			[
				-76,
				-213
			],
			[
				-265,
				18
			],
			[
				110,
				-390
			],
			[
				-177,
				-150
			],
			[
				-118,
				-356
			],
			[
				15,
				-355
			],
			[
				-108,
				-166
			],
			[
				-103,
				55
			],
			[
				-212,
				-77
			],
			[
				-31,
				-166
			],
			[
				-207,
				1
			],
			[
				-154,
				-334
			],
			[
				-10,
				-503
			],
			[
				-361,
				-246
			],
			[
				-194,
				52
			],
			[
				-56,
				-129
			],
			[
				-166,
				75
			],
			[
				-278,
				-88
			],
			[
				-465,
				301
			]
		],
		[
			[
				66909,
				68203
			],
			[
				252,
				536
			],
			[
				-23,
				380
			],
			[
				-210,
				100
			],
			[
				-22,
				375
			],
			[
				-91,
				472
			],
			[
				119,
				323
			],
			[
				-121,
				87
			],
			[
				76,
				430
			],
			[
				113,
				736
			]
		],
		[
			[
				56642,
				44124
			],
			[
				29,
				-184
			],
			[
				-32,
				-286
			],
			[
				49,
				-277
			],
			[
				-41,
				-222
			],
			[
				24,
				-203
			],
			[
				-579,
				7
			],
			[
				-13,
				-1880
			],
			[
				188,
				-483
			],
			[
				181,
				-369
			]
		],
		[
			[
				56448,
				40227
			],
			[
				-510,
				-241
			],
			[
				-673,
				83
			],
			[
				-192,
				284
			],
			[
				-1126,
				-26
			],
			[
				-42,
				-41
			],
			[
				-166,
				267
			],
			[
				-180,
				17
			],
			[
				-166,
				-100
			],
			[
				-134,
				-113
			]
		],
		[
			[
				53259,
				40357
			],
			[
				-26,
				372
			],
			[
				38,
				519
			],
			[
				96,
				541
			],
			[
				15,
				254
			],
			[
				90,
				532
			],
			[
				66,
				243
			],
			[
				159,
				386
			],
			[
				90,
				263
			],
			[
				29,
				438
			],
			[
				-15,
				335
			],
			[
				-83,
				211
			],
			[
				-74,
				358
			],
			[
				-68,
				355
			],
			[
				15,
				122
			],
			[
				85,
				235
			],
			[
				-84,
				570
			],
			[
				-57,
				396
			],
			[
				-139,
				374
			],
			[
				26,
				115
			]
		],
		[
			[
				53422,
				46976
			],
			[
				115,
				79
			],
			[
				80,
				-11
			],
			[
				98,
				71
			],
			[
				820,
				-8
			],
			[
				68,
				-440
			],
			[
				80,
				-354
			],
			[
				64,
				-191
			],
			[
				106,
				-309
			],
			[
				184,
				47
			],
			[
				91,
				83
			],
			[
				154,
				-83
			],
			[
				42,
				148
			],
			[
				69,
				344
			],
			[
				172,
				23
			],
			[
				15,
				103
			],
			[
				142,
				2
			],
			[
				-24,
				-213
			],
			[
				337,
				5
			],
			[
				5,
				-372
			],
			[
				56,
				-228
			],
			[
				-41,
				-356
			],
			[
				21,
				-363
			],
			[
				93,
				-219
			],
			[
				-15,
				-703
			],
			[
				68,
				54
			],
			[
				121,
				-15
			],
			[
				172,
				89
			],
			[
				127,
				-35
			]
		],
		[
			[
				53383,
				47159
			],
			[
				-74,
				444
			]
		],
		[
			[
				53309,
				47603
			],
			[
				112,
				255
			],
			[
				84,
				100
			],
			[
				104,
				-203
			]
		],
		[
			[
				53609,
				47755
			],
			[
				-101,
				-124
			],
			[
				-45,
				-152
			],
			[
				-9,
				-258
			],
			[
				-71,
				-62
			]
		],
		[
			[
				55719,
				75309
			],
			[
				-35,
				-201
			],
			[
				39,
				-254
			],
			[
				115,
				-144
			]
		],
		[
			[
				55838,
				74710
			],
			[
				-5,
				-155
			],
			[
				-91,
				-85
			],
			[
				-16,
				-192
			],
			[
				-129,
				-287
			]
		],
		[
			[
				55597,
				73991
			],
			[
				-48,
				41
			],
			[
				-5,
				130
			],
			[
				-154,
				199
			],
			[
				-24,
				281
			],
			[
				23,
				403
			],
			[
				38,
				184
			],
			[
				-47,
				93
			]
		],
		[
			[
				55380,
				75322
			],
			[
				-18,
				188
			],
			[
				120,
				291
			],
			[
				18,
				-111
			],
			[
				75,
				52
			]
		],
		[
			[
				55575,
				75742
			],
			[
				59,
				-159
			],
			[
				66,
				-60
			],
			[
				19,
				-214
			]
		],
		[
			[
				64327,
				64904
			],
			[
				49,
				29
			],
			[
				11,
				-162
			],
			[
				217,
				93
			],
			[
				230,
				-15
			],
			[
				168,
				-18
			],
			[
				190,
				400
			],
			[
				207,
				379
			],
			[
				176,
				364
			]
		],
		[
			[
				65575,
				65974
			],
			[
				52,
				-202
			]
		],
		[
			[
				65627,
				65772
			],
			[
				38,
				-466
			]
		],
		[
			[
				65665,
				65306
			],
			[
				-142,
				-3
			],
			[
				-23,
				-384
			],
			[
				50,
				-82
			],
			[
				-126,
				-117
			],
			[
				-1,
				-241
			],
			[
				-81,
				-245
			],
			[
				-7,
				-238
			]
		],
		[
			[
				65335,
				63996
			],
			[
				-56,
				-125
			],
			[
				-835,
				298
			],
			[
				-106,
				599
			],
			[
				-11,
				136
			]
		],
		[
			[
				31400,
				18145
			],
			[
				-168,
				16
			],
			[
				-297,
				1
			],
			[
				0,
				1319
			]
		],
		[
			[
				30935,
				19481
			],
			[
				106,
				-274
			],
			[
				139,
				-443
			],
			[
				361,
				-355
			],
			[
				389,
				-147
			],
			[
				-125,
				-296
			],
			[
				-264,
				-29
			],
			[
				-141,
				208
			]
		],
		[
			[
				32587,
				37434
			],
			[
				511,
				-964
			],
			[
				227,
				-89
			],
			[
				339,
				-437
			],
			[
				286,
				-231
			],
			[
				40,
				-261
			],
			[
				-273,
				-898
			],
			[
				280,
				-160
			],
			[
				312,
				-91
			],
			[
				220,
				95
			],
			[
				252,
				453
			],
			[
				45,
				521
			]
		],
		[
			[
				34826,
				35372
			],
			[
				138,
				114
			],
			[
				139,
				-341
			],
			[
				-6,
				-472
			],
			[
				-234,
				-326
			],
			[
				-186,
				-241
			],
			[
				-314,
				-573
			],
			[
				-370,
				-806
			]
		],
		[
			[
				33993,
				32727
			],
			[
				-70,
				-473
			],
			[
				-74,
				-607
			],
			[
				3,
				-588
			],
			[
				-61,
				-132
			],
			[
				-21,
				-382
			]
		],
		[
			[
				33770,
				30545
			],
			[
				-19,
				-308
			],
			[
				353,
				-506
			],
			[
				-38,
				-408
			],
			[
				173,
				-257
			],
			[
				-14,
				-289
			],
			[
				-267,
				-757
			],
			[
				-412,
				-317
			],
			[
				-557,
				-123
			],
			[
				-305,
				59
			],
			[
				59,
				-352
			],
			[
				-57,
				-442
			],
			[
				51,
				-298
			],
			[
				-167,
				-208
			],
			[
				-284,
				-82
			],
			[
				-267,
				216
			],
			[
				-108,
				-155
			],
			[
				39,
				-587
			],
			[
				188,
				-178
			],
			[
				152,
				186
			],
			[
				82,
				-307
			],
			[
				-255,
				-183
			],
			[
				-223,
				-367
			],
			[
				-41,
				-595
			],
			[
				-66,
				-316
			],
			[
				-262,
				-2
			],
			[
				-218,
				-302
			],
			[
				-80,
				-443
			],
			[
				273,
				-433
			],
			[
				266,
				-119
			],
			[
				-96,
				-531
			],
			[
				-328,
				-333
			],
			[
				-180,
				-692
			],
			[
				-254,
				-234
			],
			[
				-113,
				-276
			],
			[
				89,
				-614
			],
			[
				185,
				-342
			],
			[
				-117,
				30
			]
		],
		[
			[
				30952,
				19680
			],
			[
				-257,
				93
			],
			[
				-672,
				79
			],
			[
				-115,
				344
			],
			[
				6,
				443
			],
			[
				-185,
				-38
			],
			[
				-98,
				214
			],
			[
				-24,
				626
			],
			[
				213,
				260
			],
			[
				88,
				375
			],
			[
				-33,
				299
			],
			[
				148,
				504
			],
			[
				101,
				782
			],
			[
				-30,
				347
			],
			[
				122,
				112
			],
			[
				-30,
				223
			],
			[
				-129,
				118
			],
			[
				92,
				248
			],
			[
				-126,
				224
			],
			[
				-65,
				682
			],
			[
				112,
				120
			],
			[
				-47,
				720
			],
			[
				65,
				605
			],
			[
				75,
				527
			],
			[
				166,
				215
			],
			[
				-84,
				576
			],
			[
				-1,
				543
			],
			[
				210,
				386
			],
			[
				-7,
				494
			],
			[
				159,
				576
			],
			[
				1,
				544
			],
			[
				-72,
				108
			],
			[
				-128,
				1020
			],
			[
				171,
				607
			],
			[
				-27,
				572
			],
			[
				100,
				537
			],
			[
				182,
				555
			],
			[
				196,
				367
			],
			[
				-83,
				232
			],
			[
				58,
				190
			],
			[
				-9,
				985
			],
			[
				302,
				291
			],
			[
				96,
				614
			],
			[
				-34,
				148
			]
		],
		[
			[
				31359,
				37147
			],
			[
				231,
				534
			],
			[
				364,
				-144
			],
			[
				163,
				-427
			],
			[
				109,
				475
			],
			[
				316,
				-24
			],
			[
				45,
				-127
			]
		],
		[
			[
				62106,
				74858
			],
			[
				386,
				92
			]
		],
		[
			[
				62492,
				74950
			],
			[
				57,
				-155
			],
			[
				106,
				-103
			],
			[
				-56,
				-148
			],
			[
				148,
				-202
			],
			[
				-78,
				-189
			],
			[
				118,
				-160
			],
			[
				124,
				-97
			],
			[
				7,
				-410
			]
		],
		[
			[
				62918,
				73486
			],
			[
				-101,
				-17
			]
		],
		[
			[
				62817,
				73469
			],
			[
				-113,
				342
			],
			[
				1,
				91
			],
			[
				-123,
				-2
			],
			[
				-82,
				159
			],
			[
				-58,
				-16
			]
		],
		[
			[
				62442,
				74043
			],
			[
				-109,
				172
			],
			[
				-207,
				147
			],
			[
				27,
				288
			],
			[
				-47,
				208
			]
		],
		[
			[
				33452,
				3290
			],
			[
				-82,
				-301
			],
			[
				-81,
				-266
			],
			[
				-582,
				81
			],
			[
				-621,
				-35
			],
			[
				-348,
				197
			],
			[
				0,
				23
			],
			[
				-152,
				174
			],
			[
				625,
				-23
			],
			[
				599,
				-58
			],
			[
				207,
				243
			],
			[
				147,
				208
			],
			[
				288,
				-243
			]
		],
		[
			[
				5775,
				3611
			],
			[
				-533,
				-81
			],
			[
				-364,
				208
			],
			[
				-163,
				209
			],
			[
				-11,
				35
			],
			[
				-180,
				162
			],
			[
				169,
				220
			],
			[
				517,
				-93
			],
			[
				277,
				-185
			],
			[
				212,
				-209
			],
			[
				76,
				-266
			]
		],
		[
			[
				37457,
				4468
			],
			[
				342,
				-255
			],
			[
				120,
				-359
			],
			[
				33,
				-254
			],
			[
				11,
				-301
			],
			[
				-430,
				-186
			],
			[
				-452,
				-150
			],
			[
				-522,
				-139
			],
			[
				-582,
				-116
			],
			[
				-658,
				35
			],
			[
				-365,
				197
			],
			[
				49,
				243
			],
			[
				593,
				162
			],
			[
				239,
				197
			],
			[
				174,
				254
			],
			[
				126,
				220
			],
			[
				168,
				209
			],
			[
				180,
				243
			],
			[
				141,
				0
			],
			[
				414,
				127
			],
			[
				419,
				-127
			]
		],
		[
			[
				16330,
				7154
			],
			[
				359,
				-93
			],
			[
				332,
				104
			],
			[
				-158,
				-208
			],
			[
				-261,
				-151
			],
			[
				-386,
				47
			],
			[
				-278,
				208
			],
			[
				60,
				197
			],
			[
				332,
				-104
			]
		],
		[
			[
				15122,
				7165
			],
			[
				425,
				-231
			],
			[
				-164,
				23
			],
			[
				-359,
				58
			],
			[
				-381,
				162
			],
			[
				202,
				127
			],
			[
				277,
				-139
			]
		],
		[
			[
				22505,
				8080
			],
			[
				305,
				-81
			],
			[
				304,
				69
			],
			[
				163,
				-335
			],
			[
				-217,
				46
			],
			[
				-337,
				-23
			],
			[
				-343,
				23
			],
			[
				-376,
				-35
			],
			[
				-283,
				116
			],
			[
				-146,
				243
			],
			[
				174,
				104
			],
			[
				353,
				-81
			],
			[
				403,
				-46
			]
		],
		[
			[
				30985,
				8657
			],
			[
				33,
				-266
			],
			[
				-49,
				-231
			],
			[
				-76,
				-220
			],
			[
				-326,
				-81
			],
			[
				-311,
				-116
			],
			[
				-364,
				11
			],
			[
				136,
				232
			],
			[
				-327,
				-81
			],
			[
				-310,
				-81
			],
			[
				-212,
				174
			],
			[
				-16,
				243
			],
			[
				305,
				231
			],
			[
				190,
				70
			],
			[
				321,
				-23
			],
			[
				82,
				301
			],
			[
				16,
				219
			],
			[
				-6,
				475
			],
			[
				158,
				278
			],
			[
				256,
				93
			],
			[
				147,
				-220
			],
			[
				65,
				-220
			],
			[
				120,
				-267
			],
			[
				92,
				-254
			],
			[
				76,
				-267
			]
		],
		[
			[
				0,
				529
			],
			[
				16,
				-5
			],
			[
				245,
				344
			],
			[
				501,
				-185
			],
			[
				32,
				21
			],
			[
				294,
				188
			],
			[
				38,
				-7
			],
			[
				32,
				-4
			],
			[
				402,
				-246
			],
			[
				352,
				246
			],
			[
				63,
				34
			],
			[
				816,
				104
			],
			[
				265,
				-138
			],
			[
				130,
				-71
			],
			[
				419,
				-196
			],
			[
				789,
				-151
			],
			[
				625,
				-185
			],
			[
				1072,
				-139
			],
			[
				800,
				162
			],
			[
				1181,
				-116
			],
			[
				669,
				-185
			],
			[
				734,
				174
			],
			[
				773,
				162
			],
			[
				60,
				278
			],
			[
				-1094,
				23
			],
			[
				-898,
				139
			],
			[
				-234,
				231
			],
			[
				-745,
				128
			],
			[
				49,
				266
			],
			[
				103,
				243
			],
			[
				104,
				220
			],
			[
				-55,
				243
			],
			[
				-462,
				162
			],
			[
				-212,
				209
			],
			[
				-430,
				185
			],
			[
				675,
				-35
			],
			[
				642,
				93
			],
			[
				402,
				-197
			],
			[
				495,
				173
			],
			[
				457,
				220
			],
			[
				223,
				197
			],
			[
				-98,
				243
			],
			[
				-359,
				162
			],
			[
				-408,
				174
			],
			[
				-571,
				35
			],
			[
				-500,
				81
			],
			[
				-539,
				58
			],
			[
				-180,
				220
			],
			[
				-359,
				185
			],
			[
				-217,
				208
			],
			[
				-87,
				672
			],
			[
				136,
				-58
			],
			[
				250,
				-185
			],
			[
				457,
				58
			],
			[
				441,
				81
			],
			[
				228,
				-255
			],
			[
				441,
				58
			],
			[
				370,
				127
			],
			[
				348,
				162
			],
			[
				315,
				197
			],
			[
				419,
				58
			],
			[
				-11,
				220
			],
			[
				-97,
				220
			],
			[
				81,
				208
			],
			[
				359,
				104
			],
			[
				163,
				-196
			],
			[
				425,
				115
			],
			[
				321,
				151
			],
			[
				397,
				12
			],
			[
				375,
				57
			],
			[
				376,
				139
			],
			[
				299,
				128
			],
			[
				337,
				127
			],
			[
				218,
				-35
			],
			[
				190,
				-46
			],
			[
				414,
				81
			],
			[
				370,
				-104
			],
			[
				381,
				11
			],
			[
				364,
				81
			],
			[
				375,
				-57
			],
			[
				414,
				-58
			],
			[
				386,
				23
			],
			[
				403,
				-12
			],
			[
				413,
				-11
			],
			[
				381,
				23
			],
			[
				283,
				174
			],
			[
				337,
				92
			],
			[
				349,
				-127
			],
			[
				331,
				104
			],
			[
				300,
				208
			],
			[
				179,
				-185
			],
			[
				98,
				-208
			],
			[
				180,
				-197
			],
			[
				288,
				174
			],
			[
				332,
				-220
			],
			[
				375,
				-70
			],
			[
				321,
				-162
			],
			[
				392,
				35
			],
			[
				354,
				104
			],
			[
				418,
				-23
			],
			[
				376,
				-81
			],
			[
				381,
				-104
			],
			[
				147,
				254
			],
			[
				-180,
				197
			],
			[
				-136,
				209
			],
			[
				-359,
				46
			],
			[
				-158,
				220
			],
			[
				-60,
				220
			],
			[
				-98,
				440
			],
			[
				213,
				-81
			],
			[
				364,
				-35
			],
			[
				359,
				35
			],
			[
				327,
				-93
			],
			[
				283,
				-174
			],
			[
				119,
				-208
			],
			[
				376,
				-35
			],
			[
				359,
				81
			],
			[
				381,
				116
			],
			[
				342,
				70
			],
			[
				283,
				-139
			],
			[
				370,
				46
			],
			[
				239,
				451
			],
			[
				224,
				-266
			],
			[
				321,
				-104
			],
			[
				348,
				58
			],
			[
				228,
				-232
			],
			[
				365,
				-23
			],
			[
				337,
				-69
			],
			[
				332,
				-128
			],
			[
				218,
				220
			],
			[
				108,
				209
			],
			[
				278,
				-232
			],
			[
				381,
				58
			],
			[
				283,
				-127
			],
			[
				190,
				-197
			],
			[
				370,
				58
			],
			[
				288,
				127
			],
			[
				283,
				151
			],
			[
				337,
				81
			],
			[
				392,
				69
			],
			[
				354,
				81
			],
			[
				272,
				127
			],
			[
				163,
				186
			],
			[
				65,
				254
			],
			[
				-32,
				244
			],
			[
				-87,
				231
			],
			[
				-98,
				232
			],
			[
				-87,
				231
			],
			[
				-71,
				209
			],
			[
				-16,
				231
			],
			[
				27,
				232
			],
			[
				130,
				220
			],
			[
				109,
				243
			],
			[
				44,
				231
			],
			[
				-55,
				255
			],
			[
				-32,
				232
			],
			[
				136,
				266
			],
			[
				152,
				173
			],
			[
				180,
				220
			],
			[
				190,
				186
			],
			[
				223,
				173
			],
			[
				109,
				255
			],
			[
				152,
				162
			],
			[
				174,
				151
			],
			[
				267,
				34
			],
			[
				174,
				186
			],
			[
				196,
				115
			],
			[
				228,
				70
			],
			[
				202,
				150
			],
			[
				157,
				186
			],
			[
				218,
				69
			],
			[
				163,
				-151
			],
			[
				-103,
				-196
			],
			[
				-283,
				-174
			],
			[
				-120,
				-127
			],
			[
				-206,
				92
			],
			[
				-229,
				-58
			],
			[
				-190,
				-139
			],
			[
				-202,
				-150
			],
			[
				-136,
				-174
			],
			[
				-38,
				-231
			],
			[
				17,
				-220
			],
			[
				130,
				-197
			],
			[
				-190,
				-139
			],
			[
				-261,
				-46
			],
			[
				-153,
				-197
			],
			[
				-163,
				-185
			],
			[
				-174,
				-255
			],
			[
				-44,
				-220
			],
			[
				98,
				-243
			],
			[
				147,
				-185
			],
			[
				229,
				-139
			],
			[
				212,
				-185
			],
			[
				114,
				-232
			],
			[
				60,
				-220
			],
			[
				82,
				-232
			],
			[
				130,
				-196
			],
			[
				82,
				-220
			],
			[
				38,
				-544
			],
			[
				81,
				-220
			],
			[
				22,
				-232
			],
			[
				87,
				-231
			],
			[
				-38,
				-313
			],
			[
				-152,
				-243
			],
			[
				-163,
				-197
			],
			[
				-370,
				-81
			],
			[
				-125,
				-208
			],
			[
				-169,
				-197
			],
			[
				-419,
				-220
			],
			[
				-370,
				-93
			],
			[
				-348,
				-127
			],
			[
				-376,
				-128
			],
			[
				-223,
				-243
			],
			[
				-446,
				-23
			],
			[
				-489,
				23
			],
			[
				-441,
				-46
			],
			[
				-468,
				0
			],
			[
				87,
				-232
			],
			[
				424,
				-104
			],
			[
				311,
				-162
			],
			[
				174,
				-208
			],
			[
				-310,
				-185
			],
			[
				-479,
				58
			],
			[
				-397,
				-151
			],
			[
				-17,
				-243
			],
			[
				-11,
				-232
			],
			[
				327,
				-196
			],
			[
				60,
				-220
			],
			[
				353,
				-220
			],
			[
				588,
				-93
			],
			[
				500,
				-162
			],
			[
				398,
				-185
			],
			[
				506,
				-186
			],
			[
				690,
				-92
			],
			[
				681,
				-162
			],
			[
				473,
				-174
			],
			[
				517,
				-197
			],
			[
				272,
				-278
			],
			[
				136,
				-220
			],
			[
				337,
				209
			],
			[
				457,
				173
			],
			[
				484,
				186
			],
			[
				577,
				150
			],
			[
				495,
				162
			],
			[
				691,
				12
			],
			[
				680,
				-81
			],
			[
				560,
				-139
			],
			[
				180,
				255
			],
			[
				386,
				173
			],
			[
				702,
				12
			],
			[
				550,
				127
			],
			[
				522,
				128
			],
			[
				577,
				81
			],
			[
				614,
				104
			],
			[
				430,
				150
			],
			[
				-196,
				209
			],
			[
				-119,
				208
			],
			[
				0,
				220
			],
			[
				-539,
				-23
			],
			[
				-571,
				-93
			],
			[
				-544,
				0
			],
			[
				-77,
				220
			],
			[
				39,
				440
			],
			[
				125,
				128
			],
			[
				397,
				138
			],
			[
				468,
				139
			],
			[
				337,
				174
			],
			[
				337,
				174
			],
			[
				251,
				231
			],
			[
				380,
				104
			],
			[
				376,
				81
			],
			[
				190,
				47
			],
			[
				430,
				23
			],
			[
				408,
				81
			],
			[
				343,
				116
			],
			[
				337,
				139
			],
			[
				305,
				139
			],
			[
				386,
				185
			],
			[
				245,
				197
			],
			[
				261,
				173
			],
			[
				82,
				232
			],
			[
				-294,
				139
			],
			[
				98,
				243
			],
			[
				185,
				185
			],
			[
				288,
				116
			],
			[
				305,
				139
			],
			[
				283,
				185
			],
			[
				217,
				232
			],
			[
				136,
				277
			],
			[
				202,
				163
			],
			[
				331,
				-35
			],
			[
				136,
				-197
			],
			[
				332,
				-23
			],
			[
				11,
				220
			],
			[
				142,
				231
			],
			[
				299,
				-58
			],
			[
				71,
				-220
			],
			[
				331,
				-34
			],
			[
				360,
				104
			],
			[
				348,
				69
			],
			[
				315,
				-34
			],
			[
				120,
				-243
			],
			[
				305,
				196
			],
			[
				283,
				105
			],
			[
				315,
				81
			],
			[
				310,
				81
			],
			[
				283,
				139
			],
			[
				310,
				92
			],
			[
				240,
				128
			],
			[
				168,
				208
			],
			[
				207,
				-151
			],
			[
				288,
				81
			],
			[
				202,
				-277
			],
			[
				157,
				-209
			],
			[
				316,
				116
			],
			[
				125,
				232
			],
			[
				283,
				162
			],
			[
				365,
				-35
			],
			[
				108,
				-220
			],
			[
				229,
				220
			],
			[
				299,
				69
			],
			[
				326,
				23
			],
			[
				294,
				-11
			],
			[
				310,
				-70
			],
			[
				300,
				-34
			],
			[
				130,
				-197
			],
			[
				180,
				-174
			],
			[
				304,
				104
			],
			[
				327,
				24
			],
			[
				315,
				0
			],
			[
				310,
				11
			],
			[
				278,
				81
			],
			[
				294,
				70
			],
			[
				245,
				162
			],
			[
				261,
				104
			],
			[
				283,
				58
			],
			[
				212,
				162
			],
			[
				152,
				324
			],
			[
				158,
				197
			],
			[
				288,
				-93
			],
			[
				109,
				-208
			],
			[
				239,
				-139
			],
			[
				289,
				46
			],
			[
				196,
				-208
			],
			[
				206,
				-151
			],
			[
				283,
				139
			],
			[
				98,
				255
			],
			[
				250,
				104
			],
			[
				289,
				197
			],
			[
				272,
				81
			],
			[
				326,
				116
			],
			[
				218,
				127
			],
			[
				228,
				139
			],
			[
				218,
				127
			],
			[
				261,
				-69
			],
			[
				250,
				208
			],
			[
				180,
				162
			],
			[
				261,
				-11
			],
			[
				229,
				139
			],
			[
				54,
				208
			],
			[
				234,
				162
			],
			[
				228,
				116
			],
			[
				278,
				93
			],
			[
				256,
				46
			],
			[
				244,
				-35
			],
			[
				262,
				-58
			],
			[
				223,
				-162
			],
			[
				27,
				-254
			],
			[
				245,
				-197
			],
			[
				168,
				-162
			],
			[
				332,
				-70
			],
			[
				185,
				-162
			],
			[
				229,
				-162
			],
			[
				266,
				-35
			],
			[
				223,
				116
			],
			[
				240,
				243
			],
			[
				261,
				-127
			],
			[
				272,
				-70
			],
			[
				261,
				-69
			],
			[
				272,
				-46
			],
			[
				277,
				0
			],
			[
				229,
				-614
			],
			[
				-11,
				-150
			],
			[
				-33,
				-267
			],
			[
				-266,
				-150
			],
			[
				-218,
				-220
			],
			[
				38,
				-232
			],
			[
				310,
				12
			],
			[
				-38,
				-232
			],
			[
				-141,
				-220
			],
			[
				-131,
				-243
			],
			[
				212,
				-185
			],
			[
				321,
				-58
			],
			[
				321,
				104
			],
			[
				153,
				232
			],
			[
				92,
				220
			],
			[
				153,
				185
			],
			[
				174,
				174
			],
			[
				70,
				208
			],
			[
				147,
				289
			],
			[
				174,
				58
			],
			[
				316,
				24
			],
			[
				277,
				69
			],
			[
				283,
				93
			],
			[
				136,
				231
			],
			[
				82,
				220
			],
			[
				190,
				220
			],
			[
				272,
				151
			],
			[
				234,
				115
			],
			[
				153,
				197
			],
			[
				157,
				104
			],
			[
				202,
				93
			],
			[
				277,
				-58
			],
			[
				250,
				58
			],
			[
				272,
				69
			],
			[
				305,
				-34
			],
			[
				201,
				162
			],
			[
				142,
				393
			],
			[
				103,
				-162
			],
			[
				131,
				-278
			],
			[
				234,
				-115
			],
			[
				266,
				-47
			],
			[
				267,
				70
			],
			[
				283,
				-46
			],
			[
				261,
				-12
			],
			[
				174,
				58
			],
			[
				234,
				-35
			],
			[
				212,
				-127
			],
			[
				250,
				81
			],
			[
				300,
				0
			],
			[
				255,
				81
			],
			[
				289,
				-81
			],
			[
				185,
				197
			],
			[
				141,
				196
			],
			[
				191,
				163
			],
			[
				348,
				439
			],
			[
				179,
				-81
			],
			[
				212,
				-162
			],
			[
				185,
				-208
			],
			[
				354,
				-359
			],
			[
				272,
				-12
			],
			[
				256,
				0
			],
			[
				299,
				70
			],
			[
				299,
				81
			],
			[
				229,
				162
			],
			[
				190,
				174
			],
			[
				310,
				23
			],
			[
				207,
				127
			],
			[
				218,
				-116
			],
			[
				141,
				-185
			],
			[
				196,
				-185
			],
			[
				305,
				23
			],
			[
				190,
				-150
			],
			[
				332,
				-151
			],
			[
				348,
				-58
			],
			[
				288,
				47
			],
			[
				218,
				185
			],
			[
				185,
				185
			],
			[
				250,
				46
			],
			[
				251,
				-81
			],
			[
				288,
				-58
			],
			[
				261,
				93
			],
			[
				250,
				0
			],
			[
				245,
				-58
			],
			[
				256,
				-58
			],
			[
				250,
				104
			],
			[
				299,
				93
			],
			[
				283,
				23
			],
			[
				316,
				0
			],
			[
				255,
				58
			],
			[
				251,
				46
			],
			[
				76,
				290
			],
			[
				11,
				243
			],
			[
				174,
				-162
			],
			[
				49,
				-266
			],
			[
				92,
				-244
			],
			[
				115,
				-196
			],
			[
				234,
				-105
			],
			[
				315,
				35
			],
			[
				365,
				12
			],
			[
				250,
				35
			],
			[
				364,
				0
			],
			[
				262,
				11
			],
			[
				364,
				-23
			],
			[
				310,
				-46
			],
			[
				196,
				-186
			],
			[
				-54,
				-220
			],
			[
				179,
				-173
			],
			[
				299,
				-139
			],
			[
				310,
				-151
			],
			[
				360,
				-104
			],
			[
				375,
				-92
			],
			[
				283,
				-93
			],
			[
				315,
				-12
			],
			[
				180,
				197
			],
			[
				245,
				-162
			],
			[
				212,
				-185
			],
			[
				245,
				-139
			],
			[
				337,
				-58
			],
			[
				321,
				-69
			],
			[
				136,
				-232
			],
			[
				316,
				-139
			],
			[
				212,
				-208
			],
			[
				310,
				-93
			],
			[
				321,
				12
			],
			[
				299,
				-35
			],
			[
				332,
				12
			],
			[
				332,
				-47
			],
			[
				310,
				-81
			],
			[
				288,
				-139
			],
			[
				289,
				-116
			],
			[
				195,
				-173
			],
			[
				-32,
				-232
			],
			[
				-147,
				-208
			],
			[
				-125,
				-266
			],
			[
				-98,
				-209
			],
			[
				-131,
				-243
			],
			[
				-364,
				-93
			],
			[
				-163,
				-208
			],
			[
				-360,
				-127
			],
			[
				-125,
				-232
			],
			[
				-190,
				-220
			],
			[
				-201,
				-185
			],
			[
				-115,
				-243
			],
			[
				-70,
				-220
			],
			[
				-28,
				-266
			],
			[
				6,
				-220
			],
			[
				158,
				-232
			],
			[
				60,
				-220
			],
			[
				130,
				-208
			],
			[
				517,
				-81
			],
			[
				109,
				-255
			],
			[
				-501,
				-93
			],
			[
				-424,
				-127
			],
			[
				-528,
				-23
			],
			[
				-234,
				-336
			],
			[
				-49,
				-278
			],
			[
				-119,
				-220
			],
			[
				-147,
				-220
			],
			[
				370,
				-196
			],
			[
				141,
				-244
			],
			[
				239,
				-219
			],
			[
				338,
				-197
			],
			[
				386,
				-186
			],
			[
				419,
				-185
			],
			[
				636,
				-185
			],
			[
				142,
				-289
			],
			[
				800,
				-128
			],
			[
				53,
				-45
			],
			[
				208,
				-175
			],
			[
				767,
				151
			],
			[
				636,
				-186
			],
			[
				-99520,
				-142
			]
		],
		[
			[
				69148,
				21851
			],
			[
				179,
				-186
			],
			[
				263,
				-74
			],
			[
				9,
				-112
			],
			[
				-77,
				-269
			],
			[
				-427,
				-38
			],
			[
				-7,
				314
			],
			[
				41,
				244
			],
			[
				19,
				121
			]
		],
		[
			[
				90387,
				26479
			],
			[
				269,
				-204
			],
			[
				151,
				81
			],
			[
				217,
				113
			],
			[
				166,
				-39
			],
			[
				20,
				-702
			],
			[
				-95,
				-203
			],
			[
				-29,
				-476
			],
			[
				-97,
				162
			],
			[
				-193,
				-412
			],
			[
				-57,
				32
			],
			[
				-171,
				19
			],
			[
				-171,
				505
			],
			[
				-38,
				390
			],
			[
				-160,
				515
			],
			[
				7,
				271
			],
			[
				181,
				-52
			]
		],
		[
			[
				89877,
				42448
			],
			[
				100,
				-464
			],
			[
				179,
				223
			],
			[
				92,
				-250
			],
			[
				133,
				-231
			],
			[
				-29,
				-262
			],
			[
				60,
				-506
			],
			[
				42,
				-295
			],
			[
				70,
				-72
			],
			[
				75,
				-505
			],
			[
				-27,
				-307
			],
			[
				90,
				-400
			],
			[
				301,
				-309
			],
			[
				197,
				-281
			],
			[
				186,
				-257
			],
			[
				-37,
				-143
			],
			[
				159,
				-371
			],
			[
				108,
				-639
			],
			[
				111,
				130
			],
			[
				113,
				-256
			],
			[
				68,
				91
			],
			[
				48,
				-626
			],
			[
				197,
				-363
			],
			[
				129,
				-226
			],
			[
				217,
				-478
			],
			[
				78,
				-475
			],
			[
				7,
				-337
			],
			[
				-19,
				-365
			],
			[
				132,
				-502
			],
			[
				-16,
				-523
			],
			[
				-48,
				-274
			],
			[
				-75,
				-527
			],
			[
				6,
				-339
			],
			[
				-55,
				-423
			],
			[
				-123,
				-538
			],
			[
				-205,
				-290
			],
			[
				-102,
				-458
			],
			[
				-93,
				-292
			],
			[
				-82,
				-510
			],
			[
				-107,
				-294
			],
			[
				-70,
				-442
			],
			[
				-36,
				-407
			],
			[
				14,
				-187
			],
			[
				-159,
				-205
			],
			[
				-311,
				-22
			],
			[
				-257,
				-242
			],
			[
				-127,
				-229
			],
			[
				-168,
				-254
			],
			[
				-230,
				262
			],
			[
				-170,
				104
			],
			[
				43,
				308
			],
			[
				-152,
				-112
			],
			[
				-243,
				-428
			],
			[
				-240,
				160
			],
			[
				-158,
				94
			],
			[
				-159,
				42
			],
			[
				-269,
				171
			],
			[
				-179,
				364
			],
			[
				-52,
				449
			],
			[
				-64,
				298
			],
			[
				-137,
				240
			],
			[
				-267,
				71
			],
			[
				91,
				287
			],
			[
				-67,
				438
			],
			[
				-136,
				-408
			],
			[
				-247,
				-109
			],
			[
				146,
				327
			],
			[
				42,
				341
			],
			[
				107,
				289
			],
			[
				-22,
				438
			],
			[
				-226,
				-504
			],
			[
				-174,
				-202
			],
			[
				-106,
				-470
			],
			[
				-217,
				243
			],
			[
				9,
				313
			],
			[
				-174,
				429
			],
			[
				-147,
				221
			],
			[
				52,
				137
			],
			[
				-356,
				358
			],
			[
				-195,
				17
			],
			[
				-267,
				287
			],
			[
				-498,
				-56
			],
			[
				-359,
				-211
			],
			[
				-317,
				-197
			],
			[
				-265,
				39
			],
			[
				-294,
				-303
			],
			[
				-241,
				-137
			],
			[
				-53,
				-309
			],
			[
				-103,
				-240
			],
			[
				-236,
				-15
			],
			[
				-174,
				-52
			],
			[
				-246,
				107
			],
			[
				-199,
				-64
			],
			[
				-191,
				-27
			],
			[
				-165,
				-315
			],
			[
				-81,
				26
			],
			[
				-140,
				-167
			],
			[
				-133,
				-187
			],
			[
				-203,
				23
			],
			[
				-186,
				0
			],
			[
				-295,
				377
			],
			[
				-149,
				113
			],
			[
				6,
				338
			],
			[
				138,
				81
			],
			[
				47,
				134
			],
			[
				-10,
				212
			],
			[
				34,
				411
			],
			[
				-31,
				350
			],
			[
				-147,
				598
			],
			[
				-45,
				337
			],
			[
				12,
				336
			],
			[
				-111,
				385
			],
			[
				-7,
				174
			],
			[
				-123,
				235
			],
			[
				-35,
				463
			],
			[
				-158,
				467
			],
			[
				-39,
				252
			],
			[
				122,
				-255
			],
			[
				-93,
				548
			],
			[
				137,
				-171
			],
			[
				83,
				-229
			],
			[
				-5,
				303
			],
			[
				-138,
				465
			],
			[
				-26,
				186
			],
			[
				-65,
				177
			],
			[
				31,
				341
			],
			[
				56,
				146
			],
			[
				38,
				295
			],
			[
				-29,
				346
			],
			[
				114,
				425
			],
			[
				21,
				-450
			],
			[
				118,
				406
			],
			[
				225,
				198
			],
			[
				136,
				252
			],
			[
				212,
				217
			],
			[
				126,
				46
			],
			[
				77,
				-73
			],
			[
				219,
				220
			],
			[
				168,
				66
			],
			[
				42,
				129
			],
			[
				74,
				54
			],
			[
				153,
				-14
			],
			[
				292,
				173
			],
			[
				151,
				262
			],
			[
				71,
				316
			],
			[
				163,
				300
			],
			[
				13,
				236
			],
			[
				7,
				321
			],
			[
				194,
				502
			],
			[
				117,
				-510
			],
			[
				119,
				118
			],
			[
				-99,
				279
			],
			[
				87,
				287
			],
			[
				122,
				-128
			],
			[
				34,
				449
			],
			[
				152,
				291
			],
			[
				67,
				233
			],
			[
				140,
				101
			],
			[
				4,
				165
			],
			[
				122,
				-69
			],
			[
				5,
				148
			],
			[
				122,
				85
			],
			[
				134,
				80
			],
			[
				205,
				-271
			],
			[
				155,
				-350
			],
			[
				173,
				-4
			],
			[
				177,
				-56
			],
			[
				-59,
				325
			],
			[
				133,
				473
			],
			[
				126,
				155
			],
			[
				-44,
				147
			],
			[
				121,
				338
			],
			[
				168,
				208
			],
			[
				142,
				-70
			],
			[
				234,
				111
			],
			[
				-5,
				302
			],
			[
				-204,
				195
			],
			[
				148,
				86
			],
			[
				184,
				-147
			],
			[
				148,
				-242
			],
			[
				234,
				-151
			],
			[
				79,
				60
			],
			[
				172,
				-182
			],
			[
				162,
				169
			],
			[
				105,
				-51
			],
			[
				65,
				113
			],
			[
				127,
				-292
			],
			[
				-74,
				-316
			],
			[
				-105,
				-239
			],
			[
				-96,
				-20
			],
			[
				32,
				-236
			],
			[
				-81,
				-295
			],
			[
				-99,
				-291
			],
			[
				20,
				-166
			],
			[
				221,
				-327
			],
			[
				214,
				-189
			],
			[
				143,
				-204
			],
			[
				201,
				-350
			],
			[
				78,
				1
			],
			[
				145,
				-151
			],
			[
				43,
				-183
			],
			[
				265,
				-200
			],
			[
				183,
				202
			],
			[
				55,
				317
			],
			[
				56,
				262
			],
			[
				34,
				324
			],
			[
				85,
				470
			],
			[
				-39,
				286
			],
			[
				20,
				171
			],
			[
				-32,
				339
			],
			[
				37,
				445
			],
			[
				53,
				120
			],
			[
				-43,
				197
			],
			[
				67,
				313
			],
			[
				52,
				325
			],
			[
				7,
				168
			],
			[
				104,
				222
			],
			[
				78,
				-289
			],
			[
				19,
				-371
			],
			[
				70,
				-71
			],
			[
				11,
				-249
			],
			[
				101,
				-300
			],
			[
				21,
				-335
			],
			[
				-10,
				-214
			]
		],
		[
			[
				54716,
				79012
			],
			[
				-21,
				-241
			],
			[
				-156,
				-2
			],
			[
				53,
				-128
			],
			[
				-92,
				-380
			]
		],
		[
			[
				54500,
				78261
			],
			[
				-53,
				-100
			],
			[
				-243,
				-14
			],
			[
				-140,
				-134
			],
			[
				-229,
				45
			]
		],
		[
			[
				53835,
				78058
			],
			[
				-398,
				153
			],
			[
				-62,
				205
			],
			[
				-274,
				-102
			],
			[
				-32,
				-113
			],
			[
				-169,
				84
			]
		],
		[
			[
				52900,
				78285
			],
			[
				-142,
				16
			],
			[
				-125,
				108
			],
			[
				42,
				145
			],
			[
				-10,
				104
			]
		],
		[
			[
				52665,
				78658
			],
			[
				83,
				33
			],
			[
				141,
				-164
			],
			[
				39,
				156
			],
			[
				245,
				-25
			],
			[
				199,
				106
			],
			[
				133,
				-18
			],
			[
				87,
				-121
			],
			[
				26,
				100
			],
			[
				-40,
				385
			],
			[
				100,
				75
			],
			[
				98,
				272
			]
		],
		[
			[
				53776,
				79457
			],
			[
				206,
				-190
			],
			[
				157,
				242
			],
			[
				98,
				44
			],
			[
				215,
				-180
			],
			[
				131,
				30
			],
			[
				128,
				-111
			]
		],
		[
			[
				54711,
				79292
			],
			[
				-23,
				-75
			],
			[
				28,
				-205
			]
		],
		[
			[
				62817,
				73469
			],
			[
				-190,
				78
			],
			[
				-141,
				273
			],
			[
				-44,
				223
			]
		],
		[
			[
				63495,
				75281
			],
			[
				146,
				-311
			],
			[
				141,
				-419
			],
			[
				130,
				-28
			],
			[
				85,
				-159
			],
			[
				-228,
				-47
			],
			[
				-49,
				-459
			],
			[
				-48,
				-207
			],
			[
				-101,
				-138
			],
			[
				7,
				-293
			]
		],
		[
			[
				63578,
				73220
			],
			[
				-69,
				-29
			],
			[
				-173,
				309
			],
			[
				95,
				292
			],
			[
				-82,
				174
			],
			[
				-104,
				-44
			],
			[
				-327,
				-436
			]
		],
		[
			[
				62492,
				74950
			],
			[
				68,
				96
			],
			[
				207,
				-169
			],
			[
				149,
				-36
			],
			[
				38,
				70
			],
			[
				-136,
				319
			],
			[
				72,
				82
			]
		],
		[
			[
				62890,
				75312
			],
			[
				78,
				-20
			],
			[
				191,
				-359
			],
			[
				122,
				-40
			],
			[
				48,
				150
			],
			[
				166,
				238
			]
		],
		[
			[
				58149,
				47921
			],
			[
				-17,
				713
			],
			[
				-70,
				268
			]
		],
		[
			[
				58062,
				48902
			],
			[
				169,
				-46
			],
			[
				85,
				336
			],
			[
				147,
				-38
			]
		],
		[
			[
				58463,
				49154
			],
			[
				16,
				-233
			],
			[
				60,
				-134
			],
			[
				3,
				-192
			],
			[
				-69,
				-124
			],
			[
				-108,
				-308
			],
			[
				-101,
				-214
			],
			[
				-115,
				-28
			]
		],
		[
			[
				50920,
				80916
			],
			[
				204,
				-47
			],
			[
				257,
				123
			],
			[
				176,
				-258
			],
			[
				153,
				-138
			]
		],
		[
			[
				51710,
				80596
			],
			[
				-32,
				-400
			]
		],
		[
			[
				51678,
				80196
			],
			[
				-72,
				-22
			],
			[
				-30,
				-331
			]
		],
		[
			[
				51576,
				79843
			],
			[
				-243,
				269
			],
			[
				-143,
				-46
			],
			[
				-194,
				279
			],
			[
				-129,
				237
			],
			[
				-129,
				10
			],
			[
				-40,
				207
			]
		],
		[
			[
				50698,
				80799
			],
			[
				222,
				117
			]
		],
		[
			[
				50747,
				54278
			],
			[
				-229,
				-69
			]
		],
		[
			[
				50518,
				54209
			],
			[
				-69,
				407
			],
			[
				13,
				1357
			],
			[
				-56,
				122
			],
			[
				-11,
				290
			],
			[
				-96,
				207
			],
			[
				-85,
				174
			],
			[
				35,
				311
			]
		],
		[
			[
				50249,
				57077
			],
			[
				96,
				67
			],
			[
				56,
				258
			],
			[
				136,
				56
			],
			[
				61,
				176
			]
		],
		[
			[
				50598,
				57634
			],
			[
				93,
				173
			],
			[
				100,
				2
			],
			[
				212,
				-340
			]
		],
		[
			[
				51003,
				57469
			],
			[
				-11,
				-197
			],
			[
				62,
				-350
			],
			[
				-54,
				-238
			],
			[
				29,
				-159
			],
			[
				-135,
				-366
			],
			[
				-86,
				-181
			],
			[
				-52,
				-372
			],
			[
				7,
				-376
			],
			[
				-16,
				-952
			]
		],
		[
			[
				49214,
				56277
			],
			[
				-190,
				152
			],
			[
				-130,
				-22
			],
			[
				-97,
				-149
			],
			[
				-125,
				125
			],
			[
				-49,
				195
			],
			[
				-125,
				129
			]
		],
		[
			[
				48498,
				56707
			],
			[
				-18,
				343
			],
			[
				76,
				250
			],
			[
				-7,
				200
			],
			[
				221,
				490
			],
			[
				41,
				405
			],
			[
				76,
				144
			],
			[
				134,
				-79
			],
			[
				116,
				120
			],
			[
				38,
				152
			],
			[
				216,
				265
			],
			[
				53,
				184
			],
			[
				259,
				246
			],
			[
				153,
				84
			],
			[
				70,
				-114
			],
			[
				178,
				3
			]
		],
		[
			[
				50104,
				59400
			],
			[
				-22,
				-286
			],
			[
				37,
				-269
			],
			[
				156,
				-386
			],
			[
				9,
				-286
			],
			[
				320,
				-134
			],
			[
				-6,
				-405
			]
		],
		[
			[
				50249,
				57077
			],
			[
				-243,
				13
			]
		],
		[
			[
				50006,
				57090
			],
			[
				-128,
				47
			],
			[
				-90,
				-96
			],
			[
				-123,
				43
			],
			[
				-482,
				-27
			],
			[
				-7,
				-336
			],
			[
				38,
				-444
			]
		],
		[
			[
				75742,
				63602
			],
			[
				-6,
				-424
			],
			[
				-97,
				90
			],
			[
				18,
				-476
			]
		],
		[
			[
				75657,
				62792
			],
			[
				-79,
				308
			],
			[
				-16,
				301
			],
			[
				-53,
				285
			],
			[
				-116,
				344
			],
			[
				-256,
				23
			],
			[
				25,
				-243
			],
			[
				-87,
				-329
			],
			[
				-118,
				120
			],
			[
				-41,
				-108
			],
			[
				-78,
				65
			],
			[
				-108,
				53
			]
		],
		[
			[
				74730,
				63611
			],
			[
				-43,
				486
			],
			[
				-96,
				444
			],
			[
				47,
				356
			],
			[
				-171,
				159
			],
			[
				62,
				215
			],
			[
				173,
				220
			],
			[
				-200,
				313
			],
			[
				98,
				401
			],
			[
				220,
				-255
			],
			[
				133,
				-30
			],
			[
				24,
				-410
			],
			[
				265,
				-81
			],
			[
				257,
				8
			],
			[
				160,
				-101
			],
			[
				-128,
				-500
			],
			[
				-124,
				-34
			],
			[
				-86,
				-336
			],
			[
				152,
				-306
			],
			[
				46,
				377
			],
			[
				76,
				2
			],
			[
				147,
				-937
			]
		],
		[
			[
				56293,
				76715
			],
			[
				80,
				-243
			],
			[
				108,
				43
			],
			[
				213,
				-92
			],
			[
				408,
				-31
			],
			[
				138,
				150
			],
			[
				327,
				138
			],
			[
				202,
				-215
			],
			[
				163,
				-62
			]
		],
		[
			[
				57932,
				76403
			],
			[
				-144,
				-245
			],
			[
				-101,
				-422
			],
			[
				89,
				-337
			]
		],
		[
			[
				57776,
				75399
			],
			[
				-239,
				79
			],
			[
				-283,
				-186
			]
		],
		[
			[
				57254,
				75292
			],
			[
				-3,
				-294
			],
			[
				-252,
				-56
			],
			[
				-196,
				206
			],
			[
				-222,
				-162
			],
			[
				-206,
				17
			]
		],
		[
			[
				56375,
				75003
			],
			[
				-20,
				391
			],
			[
				-139,
				189
			]
		],
		[
			[
				56216,
				75583
			],
			[
				46,
				84
			],
			[
				-30,
				70
			],
			[
				47,
				188
			],
			[
				105,
				185
			],
			[
				-135,
				255
			],
			[
				-24,
				216
			],
			[
				68,
				134
			]
		],
		[
			[
				28462,
				64617
			],
			[
				-68,
				-29
			],
			[
				-70,
				340
			],
			[
				-104,
				171
			],
			[
				60,
				375
			],
			[
				84,
				-23
			],
			[
				97,
				-491
			],
			[
				1,
				-343
			]
		],
		[
			[
				28383,
				66284
			],
			[
				-303,
				-95
			],
			[
				-19,
				219
			],
			[
				130,
				47
			],
			[
				184,
				-18
			],
			[
				8,
				-153
			]
		],
		[
			[
				28611,
				66290
			],
			[
				-48,
				-420
			],
			[
				-51,
				75
			],
			[
				4,
				309
			],
			[
				-124,
				234
			],
			[
				-1,
				67
			],
			[
				220,
				-265
			]
		],
		[
			[
				55279,
				77084
			],
			[
				100,
				2
			],
			[
				-69,
				-260
			],
			[
				134,
				-227
			],
			[
				-41,
				-278
			],
			[
				-65,
				-27
			]
		],
		[
			[
				55338,
				76294
			],
			[
				-52,
				-53
			],
			[
				-90,
				-138
			],
			[
				-41,
				-325
			]
		],
		[
			[
				55155,
				75778
			],
			[
				-246,
				224
			],
			[
				-105,
				247
			],
			[
				-106,
				130
			],
			[
				-127,
				221
			],
			[
				-61,
				183
			],
			[
				-136,
				277
			],
			[
				59,
				245
			],
			[
				99,
				-136
			],
			[
				60,
				123
			],
			[
				130,
				13
			],
			[
				239,
				-98
			],
			[
				192,
				8
			],
			[
				126,
				-131
			]
		],
		[
			[
				56523,
				82432
			],
			[
				268,
				-4
			],
			[
				302,
				223
			],
			[
				64,
				333
			],
			[
				228,
				190
			],
			[
				-26,
				264
			]
		],
		[
			[
				57359,
				83438
			],
			[
				169,
				100
			],
			[
				298,
				228
			]
		],
		[
			[
				57826,
				83766
			],
			[
				293,
				-149
			],
			[
				39,
				-146
			],
			[
				146,
				70
			],
			[
				272,
				-141
			],
			[
				27,
				-277
			],
			[
				-60,
				-159
			],
			[
				174,
				-387
			],
			[
				113,
				-108
			],
			[
				-16,
				-107
			],
			[
				187,
				-104
			],
			[
				80,
				-157
			],
			[
				-108,
				-129
			],
			[
				-224,
				20
			],
			[
				-54,
				-55
			],
			[
				66,
				-196
			],
			[
				68,
				-379
			]
		],
		[
			[
				58829,
				81362
			],
			[
				-239,
				-35
			],
			[
				-85,
				-129
			],
			[
				-18,
				-298
			],
			[
				-111,
				57
			],
			[
				-250,
				-28
			],
			[
				-73,
				138
			],
			[
				-104,
				-103
			],
			[
				-105,
				86
			],
			[
				-218,
				12
			],
			[
				-310,
				141
			],
			[
				-281,
				47
			],
			[
				-215,
				-14
			],
			[
				-152,
				-160
			],
			[
				-133,
				-23
			]
		],
		[
			[
				56535,
				81053
			],
			[
				-6,
				263
			],
			[
				-85,
				274
			],
			[
				166,
				121
			],
			[
				2,
				235
			],
			[
				-77,
				225
			],
			[
				-12,
				261
			]
		],
		[
			[
				25238,
				61101
			],
			[
				-2,
				87
			],
			[
				33,
				27
			],
			[
				51,
				-70
			],
			[
				99,
				357
			],
			[
				53,
				8
			]
		],
		[
			[
				25472,
				61510
			],
			[
				1,
				-87
			],
			[
				53,
				-3
			],
			[
				-5,
				-160
			],
			[
				-45,
				-256
			],
			[
				24,
				-91
			],
			[
				-29,
				-212
			],
			[
				18,
				-56
			],
			[
				-32,
				-299
			],
			[
				-55,
				-156
			],
			[
				-50,
				-19
			],
			[
				-55,
				-205
			]
		],
		[
			[
				25297,
				59966
			],
			[
				-83,
				0
			],
			[
				22,
				667
			],
			[
				2,
				468
			]
		],
		[
			[
				31359,
				37147
			],
			[
				-200,
				-81
			],
			[
				-109,
				814
			],
			[
				-150,
				663
			],
			[
				88,
				572
			],
			[
				-146,
				250
			],
			[
				-37,
				426
			],
			[
				-136,
				402
			]
		],
		[
			[
				30669,
				40193
			],
			[
				175,
				638
			],
			[
				-119,
				496
			],
			[
				63,
				199
			],
			[
				-49,
				219
			],
			[
				108,
				295
			],
			[
				6,
				503
			],
			[
				13,
				415
			],
			[
				60,
				200
			],
			[
				-240,
				951
			]
		],
		[
			[
				30686,
				44109
			],
			[
				206,
				-50
			],
			[
				143,
				13
			],
			[
				62,
				179
			],
			[
				243,
				239
			],
			[
				147,
				222
			],
			[
				363,
				100
			],
			[
				-29,
				-443
			],
			[
				34,
				-227
			],
			[
				-23,
				-396
			],
			[
				302,
				-529
			],
			[
				311,
				-98
			],
			[
				109,
				-220
			],
			[
				188,
				-117
			],
			[
				115,
				-172
			],
			[
				175,
				6
			],
			[
				161,
				-175
			],
			[
				12,
				-342
			],
			[
				55,
				-172
			],
			[
				3,
				-255
			],
			[
				-81,
				-10
			],
			[
				107,
				-688
			],
			[
				533,
				-24
			],
			[
				-41,
				-342
			],
			[
				30,
				-233
			],
			[
				151,
				-166
			],
			[
				66,
				-367
			],
			[
				-49,
				-465
			],
			[
				-77,
				-259
			],
			[
				27,
				-337
			],
			[
				-87,
				-122
			]
		],
		[
			[
				33842,
				38659
			],
			[
				-4,
				182
			],
			[
				-259,
				302
			],
			[
				-258,
				9
			],
			[
				-484,
				-172
			],
			[
				-133,
				-520
			],
			[
				-7,
				-318
			],
			[
				-110,
				-708
			]
		],
		[
			[
				34826,
				35372
			],
			[
				54,
				341
			],
			[
				38,
				350
			],
			[
				0,
				325
			],
			[
				-100,
				107
			],
			[
				-104,
				-96
			],
			[
				-103,
				26
			],
			[
				-33,
				228
			],
			[
				-26,
				541
			],
			[
				-52,
				177
			],
			[
				-187,
				160
			],
			[
				-114,
				-116
			],
			[
				-293,
				113
			],
			[
				18,
				802
			],
			[
				-82,
				329
			]
		],
		[
			[
				30686,
				44109
			],
			[
				-157,
				-102
			],
			[
				-126,
				68
			],
			[
				18,
				898
			],
			[
				-228,
				-348
			],
			[
				-245,
				15
			],
			[
				-105,
				315
			],
			[
				-184,
				34
			],
			[
				59,
				254
			],
			[
				-155,
				359
			],
			[
				-115,
				532
			],
			[
				73,
				108
			],
			[
				0,
				250
			],
			[
				168,
				171
			],
			[
				-28,
				319
			],
			[
				71,
				206
			],
			[
				20,
				275
			],
			[
				318,
				402
			],
			[
				227,
				114
			],
			[
				37,
				89
			],
			[
				251,
				-28
			]
		],
		[
			[
				30585,
				48040
			],
			[
				125,
				1620
			],
			[
				6,
				256
			],
			[
				-43,
				339
			],
			[
				-123,
				215
			],
			[
				1,
				430
			],
			[
				156,
				97
			],
			[
				56,
				-61
			],
			[
				9,
				226
			],
			[
				-162,
				61
			],
			[
				-4,
				370
			],
			[
				541,
				-13
			],
			[
				92,
				203
			],
			[
				77,
				-187
			],
			[
				55,
				-349
			],
			[
				52,
				73
			]
		],
		[
			[
				31423,
				51320
			],
			[
				153,
				-312
			],
			[
				216,
				38
			],
			[
				54,
				181
			],
			[
				206,
				138
			],
			[
				115,
				97
			],
			[
				32,
				250
			],
			[
				198,
				168
			],
			[
				-15,
				124
			],
			[
				-235,
				51
			],
			[
				-39,
				372
			],
			[
				12,
				396
			],
			[
				-125,
				153
			],
			[
				52,
				55
			],
			[
				206,
				-76
			],
			[
				221,
				-148
			],
			[
				80,
				140
			],
			[
				200,
				92
			],
			[
				310,
				221
			],
			[
				102,
				225
			],
			[
				-37,
				167
			]
		],
		[
			[
				33129,
				53652
			],
			[
				145,
				26
			],
			[
				64,
				-136
			],
			[
				-36,
				-259
			],
			[
				96,
				-90
			],
			[
				63,
				-274
			],
			[
				-77,
				-209
			],
			[
				-44,
				-502
			],
			[
				71,
				-299
			],
			[
				20,
				-274
			],
			[
				171,
				-277
			],
			[
				137,
				-29
			],
			[
				30,
				116
			],
			[
				88,
				25
			],
			[
				126,
				104
			],
			[
				90,
				157
			],
			[
				154,
				-50
			],
			[
				67,
				21
			]
		],
		[
			[
				34294,
				51702
			],
			[
				151,
				-48
			],
			[
				25,
				120
			],
			[
				-46,
				118
			],
			[
				28,
				171
			],
			[
				112,
				-53
			],
			[
				131,
				61
			],
			[
				159,
				-125
			]
		],
		[
			[
				34854,
				51946
			],
			[
				121,
				-122
			],
			[
				86,
				160
			],
			[
				62,
				-25
			],
			[
				38,
				-166
			],
			[
				133,
				42
			],
			[
				107,
				224
			],
			[
				85,
				436
			],
			[
				164,
				540
			]
		],
		[
			[
				35650,
				53035
			],
			[
				95,
				28
			],
			[
				69,
				-327
			],
			[
				155,
				-1033
			],
			[
				149,
				-97
			],
			[
				7,
				-408
			],
			[
				-208,
				-487
			],
			[
				86,
				-178
			],
			[
				491,
				-92
			],
			[
				10,
				-593
			],
			[
				211,
				388
			],
			[
				349,
				-212
			],
			[
				462,
				-361
			],
			[
				135,
				-346
			],
			[
				-45,
				-327
			],
			[
				323,
				182
			],
			[
				540,
				-313
			],
			[
				415,
				23
			],
			[
				411,
				-489
			],
			[
				355,
				-662
			],
			[
				214,
				-170
			],
			[
				237,
				-24
			],
			[
				101,
				-186
			],
			[
				94,
				-752
			],
			[
				46,
				-358
			],
			[
				-110,
				-977
			],
			[
				-142,
				-385
			],
			[
				-391,
				-822
			],
			[
				-177,
				-668
			],
			[
				-206,
				-513
			],
			[
				-69,
				-11
			],
			[
				-78,
				-435
			],
			[
				20,
				-1107
			],
			[
				-77,
				-910
			],
			[
				-30,
				-390
			],
			[
				-88,
				-233
			],
			[
				-49,
				-790
			],
			[
				-282,
				-771
			],
			[
				-47,
				-610
			],
			[
				-225,
				-256
			],
			[
				-65,
				-355
			],
			[
				-302,
				2
			],
			[
				-437,
				-227
			],
			[
				-195,
				-263
			],
			[
				-311,
				-173
			],
			[
				-327,
				-470
			],
			[
				-235,
				-586
			],
			[
				-41,
				-441
			],
			[
				46,
				-326
			],
			[
				-51,
				-597
			],
			[
				-63,
				-289
			],
			[
				-195,
				-325
			],
			[
				-308,
				-1040
			],
			[
				-244,
				-468
			],
			[
				-189,
				-277
			],
			[
				-127,
				-562
			],
			[
				-183,
				-337
			]
		],
		[
			[
				35174,
				30629
			],
			[
				-77,
				334
			],
			[
				122,
				280
			],
			[
				-160,
				402
			],
			[
				-218,
				327
			],
			[
				-286,
				379
			],
			[
				-103,
				-18
			],
			[
				-279,
				457
			],
			[
				-180,
				-63
			]
		],
		[
			[
				81723,
				53254
			],
			[
				110,
				221
			],
			[
				236,
				323
			]
		],
		[
			[
				82069,
				53798
			],
			[
				-13,
				-291
			],
			[
				-16,
				-377
			],
			[
				-133,
				19
			],
			[
				-58,
				-202
			],
			[
				-126,
				307
			]
		],
		[
			[
				75471,
				66988
			],
			[
				113,
				-189
			],
			[
				-20,
				-363
			],
			[
				-227,
				-17
			],
			[
				-234,
				39
			],
			[
				-175,
				-92
			],
			[
				-252,
				224
			],
			[
				-6,
				119
			]
		],
		[
			[
				74670,
				66709
			],
			[
				184,
				439
			],
			[
				150,
				150
			],
			[
				198,
				-137
			],
			[
				147,
				-14
			],
			[
				122,
				-159
			]
		],
		[
			[
				58175,
				37528
			],
			[
				-393,
				-435
			],
			[
				-249,
				-442
			],
			[
				-93,
				-393
			],
			[
				-83,
				-222
			],
			[
				-152,
				-47
			],
			[
				-48,
				-283
			],
			[
				-28,
				-184
			],
			[
				-178,
				-138
			],
			[
				-226,
				29
			],
			[
				-133,
				166
			],
			[
				-117,
				71
			],
			[
				-135,
				-137
			],
			[
				-68,
				-283
			],
			[
				-132,
				-177
			],
			[
				-139,
				-264
			],
			[
				-199,
				-60
			],
			[
				-62,
				207
			],
			[
				26,
				360
			],
			[
				-165,
				562
			],
			[
				-75,
				88
			]
		],
		[
			[
				55526,
				35946
			],
			[
				0,
				1725
			],
			[
				274,
				20
			],
			[
				8,
				2105
			],
			[
				207,
				19
			],
			[
				428,
				207
			],
			[
				106,
				-243
			],
			[
				177,
				231
			],
			[
				85,
				2
			],
			[
				156,
				133
			]
		],
		[
			[
				56967,
				40145
			],
			[
				50,
				-44
			]
		],
		[
			[
				57017,
				40101
			],
			[
				107,
				-473
			],
			[
				56,
				-105
			],
			[
				87,
				-342
			],
			[
				315,
				-649
			],
			[
				119,
				-64
			],
			[
				0,
				-208
			],
			[
				82,
				-375
			],
			[
				215,
				-90
			],
			[
				177,
				-267
			]
		],
		[
			[
				54244,
				54965
			],
			[
				229,
				44
			],
			[
				52,
				152
			],
			[
				46,
				-11
			],
			[
				69,
				-134
			],
			[
				350,
				226
			],
			[
				118,
				230
			],
			[
				145,
				207
			],
			[
				-28,
				208
			],
			[
				78,
				54
			],
			[
				269,
				-36
			],
			[
				261,
				273
			],
			[
				201,
				645
			],
			[
				141,
				239
			],
			[
				176,
				101
			]
		],
		[
			[
				56351,
				57163
			],
			[
				31,
				-253
			],
			[
				160,
				-369
			],
			[
				1,
				-241
			],
			[
				-45,
				-246
			],
			[
				18,
				-184
			],
			[
				96,
				-170
			]
		],
		[
			[
				56612,
				55700
			],
			[
				212,
				-258
			]
		],
		[
			[
				56824,
				55442
			],
			[
				152,
				-239
			],
			[
				2,
				-192
			],
			[
				187,
				-308
			],
			[
				116,
				-255
			],
			[
				70,
				-355
			],
			[
				208,
				-234
			],
			[
				44,
				-187
			]
		],
		[
			[
				57603,
				53672
			],
			[
				-91,
				-63
			],
			[
				-178,
				14
			],
			[
				-209,
				62
			],
			[
				-104,
				-51
			],
			[
				-41,
				-143
			],
			[
				-90,
				-18
			],
			[
				-110,
				125
			],
			[
				-309,
				-295
			],
			[
				-127,
				60
			],
			[
				-38,
				-46
			],
			[
				-83,
				-357
			],
			[
				-207,
				115
			],
			[
				-203,
				59
			],
			[
				-177,
				218
			],
			[
				-229,
				200
			],
			[
				-149,
				-190
			],
			[
				-108,
				-300
			],
			[
				-25,
				-412
			]
		],
		[
			[
				55125,
				52650
			],
			[
				-178,
				33
			],
			[
				-188,
				99
			],
			[
				-166,
				-313
			],
			[
				-146,
				-550
			]
		],
		[
			[
				54447,
				51919
			],
			[
				-29,
				172
			],
			[
				-12,
				269
			],
			[
				-127,
				190
			],
			[
				-103,
				305
			],
			[
				-23,
				212
			],
			[
				-132,
				309
			],
			[
				23,
				176
			],
			[
				-28,
				249
			],
			[
				21,
				458
			],
			[
				67,
				107
			],
			[
				140,
				599
			]
		],
		[
			[
				32315,
				78082
			],
			[
				202,
				-79
			],
			[
				257,
				16
			],
			[
				-137,
				-242
			],
			[
				-102,
				-38
			],
			[
				-353,
				250
			],
			[
				-69,
				198
			],
			[
				105,
				183
			],
			[
				97,
				-288
			]
		],
		[
			[
				32831,
				79592
			],
			[
				-135,
				-11
			],
			[
				-360,
				186
			],
			[
				-258,
				279
			],
			[
				96,
				49
			],
			[
				365,
				-148
			],
			[
				284,
				-247
			],
			[
				8,
				-108
			]
		],
		[
			[
				15692,
				79240
			],
			[
				-140,
				-82
			],
			[
				-456,
				269
			],
			[
				-84,
				209
			],
			[
				-248,
				207
			],
			[
				-50,
				168
			],
			[
				-286,
				107
			],
			[
				-107,
				321
			],
			[
				24,
				137
			],
			[
				291,
				-129
			],
			[
				171,
				-89
			],
			[
				261,
				-63
			],
			[
				94,
				-204
			],
			[
				138,
				-280
			],
			[
				277,
				-244
			],
			[
				115,
				-327
			]
		],
		[
			[
				34407,
				80527
			],
			[
				-184,
				-517
			],
			[
				181,
				199
			],
			[
				187,
				-126
			],
			[
				-98,
				-206
			],
			[
				247,
				-162
			],
			[
				128,
				144
			],
			[
				277,
				-182
			],
			[
				-86,
				-433
			],
			[
				194,
				101
			],
			[
				36,
				-313
			],
			[
				86,
				-367
			],
			[
				-117,
				-520
			],
			[
				-125,
				-22
			],
			[
				-183,
				111
			],
			[
				60,
				484
			],
			[
				-77,
				75
			],
			[
				-322,
				-513
			],
			[
				-166,
				21
			],
			[
				196,
				277
			],
			[
				-267,
				144
			],
			[
				-298,
				-35
			],
			[
				-539,
				18
			],
			[
				-43,
				175
			],
			[
				173,
				208
			],
			[
				-121,
				160
			],
			[
				234,
				356
			],
			[
				287,
				941
			],
			[
				172,
				336
			],
			[
				241,
				204
			],
			[
				129,
				-26
			],
			[
				-54,
				-160
			],
			[
				-148,
				-372
			]
		],
		[
			[
				13005,
				82584
			],
			[
				131,
				-76
			],
			[
				267,
				47
			],
			[
				-84,
				-671
			],
			[
				242,
				-475
			],
			[
				-111,
				1
			],
			[
				-167,
				270
			],
			[
				-103,
				272
			],
			[
				-140,
				184
			],
			[
				-51,
				260
			],
			[
				16,
				188
			]
		],
		[
			[
				27981,
				87304
			],
			[
				-108,
				-310
			],
			[
				-123,
				50
			],
			[
				-73,
				176
			],
			[
				13,
				41
			],
			[
				107,
				177
			],
			[
				114,
				-13
			],
			[
				70,
				-121
			]
		],
		[
			[
				27250,
				87631
			],
			[
				-325,
				-326
			],
			[
				-196,
				13
			],
			[
				-61,
				160
			],
			[
				207,
				273
			],
			[
				381,
				-6
			],
			[
				-6,
				-114
			]
		],
		[
			[
				26344,
				89371
			],
			[
				51,
				-259
			],
			[
				143,
				91
			],
			[
				161,
				-155
			],
			[
				304,
				-203
			],
			[
				318,
				-184
			],
			[
				25,
				-281
			],
			[
				204,
				46
			],
			[
				199,
				-196
			],
			[
				-247,
				-186
			],
			[
				-432,
				142
			],
			[
				-156,
				266
			],
			[
				-275,
				-314
			],
			[
				-396,
				-306
			],
			[
				-95,
				346
			],
			[
				-377,
				-57
			],
			[
				242,
				292
			],
			[
				35,
				465
			],
			[
				95,
				542
			],
			[
				201,
				-49
			]
		],
		[
			[
				28926,
				90253
			],
			[
				-312,
				-30
			],
			[
				-69,
				289
			],
			[
				118,
				331
			],
			[
				255,
				82
			],
			[
				217,
				-163
			],
			[
				3,
				-253
			],
			[
				-32,
				-82
			],
			[
				-180,
				-174
			]
		],
		[
			[
				23431,
				91410
			],
			[
				-173,
				-207
			],
			[
				-374,
				179
			],
			[
				-226,
				-65
			],
			[
				-380,
				266
			],
			[
				245,
				183
			],
			[
				194,
				256
			],
			[
				295,
				-168
			],
			[
				166,
				-106
			],
			[
				84,
				-112
			],
			[
				169,
				-226
			]
		],
		[
			[
				31350,
				77248
			],
			[
				-181,
				334
			],
			[
				0,
				805
			],
			[
				-123,
				171
			],
			[
				-187,
				-100
			],
			[
				-92,
				155
			],
			[
				-212,
				-446
			],
			[
				-84,
				-460
			],
			[
				-99,
				-269
			],
			[
				-118,
				-91
			],
			[
				-89,
				-30
			],
			[
				-28,
				-146
			],
			[
				-512,
				0
			],
			[
				-422,
				-4
			],
			[
				-125,
				-109
			],
			[
				-294,
				-425
			],
			[
				-34,
				-46
			],
			[
				-89,
				-231
			],
			[
				-255,
				1
			],
			[
				-273,
				-3
			],
			[
				-125,
				-93
			],
			[
				44,
				-116
			],
			[
				25,
				-181
			],
			[
				-5,
				-60
			],
			[
				-363,
				-293
			],
			[
				-286,
				-93
			],
			[
				-323,
				-316
			],
			[
				-70,
				0
			],
			[
				-94,
				93
			],
			[
				-31,
				85
			],
			[
				6,
				61
			],
			[
				61,
				207
			],
			[
				131,
				325
			],
			[
				81,
				349
			],
			[
				-56,
				514
			],
			[
				-59,
				536
			],
			[
				-290,
				277
			],
			[
				35,
				105
			],
			[
				-41,
				73
			],
			[
				-76,
				0
			],
			[
				-56,
				93
			],
			[
				-14,
				140
			],
			[
				-54,
				-61
			],
			[
				-75,
				18
			],
			[
				17,
				59
			],
			[
				-65,
				58
			],
			[
				-27,
				155
			],
			[
				-216,
				189
			],
			[
				-224,
				197
			],
			[
				-272,
				229
			],
			[
				-261,
				214
			],
			[
				-248,
				-167
			],
			[
				-91,
				-6
			],
			[
				-342,
				154
			],
			[
				-225,
				-77
			],
			[
				-269,
				183
			],
			[
				-284,
				94
			],
			[
				-194,
				36
			],
			[
				-86,
				100
			],
			[
				-49,
				325
			],
			[
				-94,
				-3
			],
			[
				-1,
				-227
			],
			[
				-575,
				0
			],
			[
				-951,
				0
			],
			[
				-944,
				0
			],
			[
				-833,
				0
			],
			[
				-834,
				0
			],
			[
				-819,
				0
			],
			[
				-847,
				0
			],
			[
				-273,
				0
			],
			[
				-825,
				0
			],
			[
				-788,
				0
			]
		],
		[
			[
				15878,
				79530
			],
			[
				-38,
				1
			],
			[
				-537,
				581
			],
			[
				-199,
				255
			],
			[
				-503,
				244
			],
			[
				-155,
				523
			],
			[
				40,
				363
			],
			[
				-356,
				252
			],
			[
				-48,
				476
			],
			[
				-336,
				429
			],
			[
				-6,
				304
			]
		],
		[
			[
				13740,
				82958
			],
			[
				154,
				285
			],
			[
				-7,
				373
			],
			[
				-473,
				376
			],
			[
				-284,
				674
			],
			[
				-173,
				424
			],
			[
				-255,
				266
			],
			[
				-187,
				242
			],
			[
				-147,
				306
			],
			[
				-279,
				-192
			],
			[
				-270,
				-330
			],
			[
				-247,
				388
			],
			[
				-194,
				259
			],
			[
				-271,
				164
			],
			[
				-273,
				17
			],
			[
				1,
				3364
			],
			[
				2,
				2193
			]
		],
		[
			[
				10837,
				91767
			],
			[
				518,
				-142
			],
			[
				438,
				-285
			],
			[
				289,
				-54
			],
			[
				244,
				247
			],
			[
				336,
				184
			],
			[
				413,
				-72
			],
			[
				416,
				259
			],
			[
				455,
				148
			],
			[
				191,
				-245
			],
			[
				207,
				138
			],
			[
				62,
				278
			],
			[
				192,
				-63
			],
			[
				470,
				-530
			],
			[
				369,
				401
			],
			[
				38,
				-449
			],
			[
				341,
				97
			],
			[
				105,
				173
			],
			[
				337,
				-34
			],
			[
				424,
				-248
			],
			[
				650,
				-217
			],
			[
				383,
				-100
			],
			[
				272,
				38
			],
			[
				374,
				-300
			],
			[
				-390,
				-293
			],
			[
				502,
				-127
			],
			[
				750,
				70
			],
			[
				236,
				103
			],
			[
				296,
				-354
			],
			[
				302,
				299
			],
			[
				-283,
				251
			],
			[
				179,
				202
			],
			[
				338,
				27
			],
			[
				223,
				59
			],
			[
				224,
				-141
			],
			[
				279,
				-321
			],
			[
				310,
				47
			],
			[
				491,
				-266
			],
			[
				431,
				94
			],
			[
				405,
				-14
			],
			[
				-32,
				367
			],
			[
				247,
				103
			],
			[
				431,
				-200
			],
			[
				-2,
				-559
			],
			[
				177,
				471
			],
			[
				223,
				-16
			],
			[
				126,
				594
			],
			[
				-298,
				364
			],
			[
				-324,
				239
			],
			[
				22,
				653
			],
			[
				329,
				429
			],
			[
				366,
				-95
			],
			[
				281,
				-261
			],
			[
				378,
				-666
			],
			[
				-247,
				-290
			],
			[
				517,
				-120
			],
			[
				-1,
				-604
			],
			[
				371,
				463
			],
			[
				332,
				-380
			],
			[
				-83,
				-438
			],
			[
				269,
				-399
			],
			[
				290,
				427
			],
			[
				202,
				510
			],
			[
				16,
				649
			],
			[
				394,
				-46
			],
			[
				411,
				-87
			],
			[
				373,
				-293
			],
			[
				17,
				-293
			],
			[
				-207,
				-315
			],
			[
				196,
				-316
			],
			[
				-36,
				-288
			],
			[
				-544,
				-413
			],
			[
				-386,
				-91
			],
			[
				-287,
				178
			],
			[
				-83,
				-297
			],
			[
				-268,
				-498
			],
			[
				-81,
				-259
			],
			[
				-322,
				-399
			],
			[
				-397,
				-39
			],
			[
				-220,
				-250
			],
			[
				-18,
				-384
			],
			[
				-323,
				-74
			],
			[
				-340,
				-479
			],
			[
				-301,
				-665
			],
			[
				-108,
				-466
			],
			[
				-16,
				-686
			],
			[
				409,
				-99
			],
			[
				125,
				-553
			],
			[
				130,
				-448
			],
			[
				388,
				117
			],
			[
				517,
				-256
			],
			[
				277,
				-225
			],
			[
				199,
				-279
			],
			[
				348,
				-163
			],
			[
				294,
				-248
			],
			[
				459,
				-34
			],
			[
				302,
				-58
			],
			[
				-45,
				-511
			],
			[
				86,
				-594
			],
			[
				201,
				-661
			],
			[
				414,
				-561
			],
			[
				214,
				192
			],
			[
				150,
				607
			],
			[
				-145,
				934
			],
			[
				-196,
				311
			],
			[
				445,
				276
			],
			[
				314,
				415
			],
			[
				154,
				411
			],
			[
				-23,
				395
			],
			[
				-188,
				502
			],
			[
				-338,
				445
			],
			[
				328,
				619
			],
			[
				-121,
				535
			],
			[
				-93,
				922
			],
			[
				194,
				137
			],
			[
				476,
				-161
			],
			[
				286,
				-57
			],
			[
				230,
				155
			],
			[
				258,
				-200
			],
			[
				342,
				-343
			],
			[
				85,
				-229
			],
			[
				495,
				-45
			],
			[
				-8,
				-496
			],
			[
				92,
				-747
			],
			[
				254,
				-92
			],
			[
				201,
				-348
			],
			[
				402,
				328
			],
			[
				266,
				652
			],
			[
				184,
				274
			],
			[
				216,
				-527
			],
			[
				362,
				-754
			],
			[
				307,
				-709
			],
			[
				-112,
				-371
			],
			[
				370,
				-333
			],
			[
				250,
				-338
			],
			[
				442,
				-152
			],
			[
				179,
				-189
			],
			[
				110,
				-500
			],
			[
				216,
				-78
			],
			[
				112,
				-223
			],
			[
				20,
				-664
			],
			[
				-202,
				-222
			],
			[
				-199,
				-207
			],
			[
				-458,
				-210
			],
			[
				-349,
				-486
			],
			[
				-470,
				-96
			],
			[
				-594,
				125
			],
			[
				-417,
				4
			],
			[
				-287,
				-41
			],
			[
				-233,
				-424
			],
			[
				-354,
				-262
			],
			[
				-401,
				-782
			],
			[
				-320,
				-545
			],
			[
				236,
				97
			],
			[
				446,
				776
			],
			[
				583,
				493
			],
			[
				415,
				58
			],
			[
				246,
				-289
			],
			[
				-262,
				-397
			],
			[
				88,
				-637
			],
			[
				91,
				-446
			],
			[
				361,
				-295
			],
			[
				459,
				86
			],
			[
				278,
				664
			],
			[
				19,
				-429
			],
			[
				180,
				-214
			],
			[
				-344,
				-387
			],
			[
				-615,
				-351
			],
			[
				-276,
				-239
			],
			[
				-310,
				-426
			],
			[
				-211,
				44
			],
			[
				-11,
				500
			],
			[
				483,
				488
			],
			[
				-445,
				-19
			],
			[
				-309,
				-72
			]
		],
		[
			[
				18287,
				93781
			],
			[
				-139,
				-277
			],
			[
				618,
				179
			],
			[
				386,
				-298
			],
			[
				314,
				302
			],
			[
				254,
				-194
			],
			[
				227,
				-580
			],
			[
				140,
				244
			],
			[
				-197,
				606
			],
			[
				244,
				86
			],
			[
				276,
				-94
			],
			[
				311,
				-239
			],
			[
				175,
				-575
			],
			[
				86,
				-417
			],
			[
				466,
				-293
			],
			[
				502,
				-279
			],
			[
				-31,
				-260
			],
			[
				-456,
				-48
			],
			[
				178,
				-227
			],
			[
				-94,
				-217
			],
			[
				-503,
				93
			],
			[
				-478,
				160
			],
			[
				-322,
				-36
			],
			[
				-522,
				-201
			],
			[
				-704,
				-88
			],
			[
				-494,
				-56
			],
			[
				-151,
				279
			],
			[
				-379,
				161
			],
			[
				-246,
				-66
			],
			[
				-343,
				468
			],
			[
				185,
				62
			],
			[
				429,
				101
			],
			[
				392,
				-26
			],
			[
				362,
				103
			],
			[
				-537,
				138
			],
			[
				-594,
				-47
			],
			[
				-394,
				12
			],
			[
				-146,
				217
			],
			[
				644,
				237
			],
			[
				-428,
				-9
			],
			[
				-485,
				156
			],
			[
				233,
				443
			],
			[
				193,
				235
			],
			[
				744,
				359
			],
			[
				284,
				-114
			]
		],
		[
			[
				20972,
				93958
			],
			[
				-244,
				-390
			],
			[
				-434,
				413
			],
			[
				95,
				83
			],
			[
				372,
				24
			],
			[
				211,
				-130
			]
		],
		[
			[
				28794,
				93770
			],
			[
				25,
				-163
			],
			[
				-296,
				17
			],
			[
				-299,
				13
			],
			[
				-304,
				-80
			],
			[
				-80,
				36
			],
			[
				-306,
				313
			],
			[
				12,
				213
			],
			[
				133,
				39
			],
			[
				636,
				-63
			],
			[
				479,
				-325
			]
		],
		[
			[
				25955,
				93803
			],
			[
				219,
				-369
			],
			[
				256,
				477
			],
			[
				704,
				242
			],
			[
				477,
				-611
			],
			[
				-42,
				-387
			],
			[
				550,
				172
			],
			[
				263,
				235
			],
			[
				616,
				-299
			],
			[
				383,
				-282
			],
			[
				36,
				-258
			],
			[
				515,
				134
			],
			[
				290,
				-376
			],
			[
				670,
				-234
			],
			[
				242,
				-238
			],
			[
				263,
				-553
			],
			[
				-510,
				-275
			],
			[
				654,
				-386
			],
			[
				441,
				-130
			],
			[
				400,
				-543
			],
			[
				437,
				-39
			],
			[
				-87,
				-414
			],
			[
				-487,
				-687
			],
			[
				-342,
				253
			],
			[
				-437,
				568
			],
			[
				-359,
				-74
			],
			[
				-35,
				-338
			],
			[
				292,
				-344
			],
			[
				377,
				-272
			],
			[
				114,
				-157
			],
			[
				181,
				-584
			],
			[
				-96,
				-425
			],
			[
				-350,
				160
			],
			[
				-697,
				473
			],
			[
				393,
				-509
			],
			[
				289,
				-357
			],
			[
				45,
				-206
			],
			[
				-753,
				236
			],
			[
				-596,
				343
			],
			[
				-337,
				287
			],
			[
				97,
				167
			],
			[
				-414,
				304
			],
			[
				-405,
				286
			],
			[
				5,
				-171
			],
			[
				-803,
				-94
			],
			[
				-235,
				203
			],
			[
				183,
				435
			],
			[
				522,
				10
			],
			[
				571,
				76
			],
			[
				-92,
				211
			],
			[
				96,
				294
			],
			[
				360,
				576
			],
			[
				-77,
				261
			],
			[
				-107,
				203
			],
			[
				-425,
				286
			],
			[
				-563,
				201
			],
			[
				178,
				150
			],
			[
				-294,
				367
			],
			[
				-245,
				34
			],
			[
				-219,
				201
			],
			[
				-149,
				-175
			],
			[
				-503,
				-76
			],
			[
				-1011,
				132
			],
			[
				-588,
				174
			],
			[
				-450,
				89
			],
			[
				-231,
				207
			],
			[
				290,
				270
			],
			[
				-394,
				2
			],
			[
				-88,
				599
			],
			[
				213,
				528
			],
			[
				286,
				241
			],
			[
				717,
				158
			],
			[
				-204,
				-382
			]
		],
		[
			[
				22123,
				94208
			],
			[
				331,
				-124
			],
			[
				496,
				75
			],
			[
				72,
				-172
			],
			[
				-259,
				-283
			],
			[
				420,
				-254
			],
			[
				-50,
				-532
			],
			[
				-455,
				-229
			],
			[
				-268,
				50
			],
			[
				-192,
				225
			],
			[
				-690,
				456
			],
			[
				5,
				189
			],
			[
				567,
				-73
			],
			[
				-306,
				386
			],
			[
				329,
				286
			]
		],
		[
			[
				24112,
				93575
			],
			[
				-298,
				-442
			],
			[
				-317,
				22
			],
			[
				-173,
				519
			],
			[
				4,
				294
			],
			[
				145,
				251
			],
			[
				276,
				161
			],
			[
				579,
				-20
			],
			[
				530,
				-144
			],
			[
				-415,
				-526
			],
			[
				-331,
				-115
			]
		],
		[
			[
				16539,
				92755
			],
			[
				-731,
				-285
			],
			[
				-147,
				259
			],
			[
				-641,
				312
			],
			[
				119,
				250
			],
			[
				192,
				432
			],
			[
				241,
				388
			],
			[
				-272,
				362
			],
			[
				939,
				93
			],
			[
				397,
				-123
			],
			[
				709,
				-33
			],
			[
				270,
				-171
			],
			[
				298,
				-249
			],
			[
				-349,
				-149
			],
			[
				-681,
				-415
			],
			[
				-344,
				-414
			],
			[
				0,
				-257
			]
		],
		[
			[
				23996,
				94879
			],
			[
				-151,
				-229
			],
			[
				-403,
				44
			],
			[
				-337,
				155
			],
			[
				148,
				266
			],
			[
				399,
				159
			],
			[
				243,
				-208
			],
			[
				101,
				-187
			]
		],
		[
			[
				22639,
				95907
			],
			[
				212,
				-273
			],
			[
				9,
				-303
			],
			[
				-127,
				-440
			],
			[
				-458,
				-60
			],
			[
				-298,
				94
			],
			[
				5,
				345
			],
			[
				-455,
				-46
			],
			[
				-18,
				457
			],
			[
				299,
				-18
			],
			[
				419,
				201
			],
			[
				390,
				-34
			],
			[
				22,
				77
			]
		],
		[
			[
				19941,
				95601
			],
			[
				109,
				-210
			],
			[
				247,
				99
			],
			[
				291,
				-26
			],
			[
				49,
				-289
			],
			[
				-169,
				-281
			],
			[
				-940,
				-91
			],
			[
				-701,
				-256
			],
			[
				-423,
				-14
			],
			[
				-35,
				193
			],
			[
				577,
				261
			],
			[
				-1255,
				-70
			],
			[
				-389,
				106
			],
			[
				379,
				577
			],
			[
				262,
				165
			],
			[
				782,
				-199
			],
			[
				493,
				-350
			],
			[
				485,
				-45
			],
			[
				-397,
				565
			],
			[
				255,
				215
			],
			[
				286,
				-68
			],
			[
				94,
				-282
			]
		],
		[
			[
				23699,
				96131
			],
			[
				308,
				-190
			],
			[
				547,
				1
			],
			[
				240,
				-194
			],
			[
				-64,
				-222
			],
			[
				319,
				-134
			],
			[
				177,
				-140
			],
			[
				374,
				-26
			],
			[
				406,
				-50
			],
			[
				441,
				128
			],
			[
				566,
				51
			],
			[
				451,
				-42
			],
			[
				298,
				-223
			],
			[
				62,
				-244
			],
			[
				-174,
				-157
			],
			[
				-414,
				-127
			],
			[
				-355,
				72
			],
			[
				-797,
				-91
			],
			[
				-570,
				-11
			],
			[
				-449,
				73
			],
			[
				-738,
				190
			],
			[
				-96,
				325
			],
			[
				-34,
				293
			],
			[
				-279,
				258
			],
			[
				-574,
				72
			],
			[
				-322,
				183
			],
			[
				104,
				242
			],
			[
				573,
				-37
			]
		],
		[
			[
				17722,
				96454
			],
			[
				-38,
				-454
			],
			[
				-214,
				-205
			],
			[
				-259,
				-29
			],
			[
				-517,
				-252
			],
			[
				-444,
				-91
			],
			[
				-377,
				128
			],
			[
				472,
				442
			],
			[
				570,
				383
			],
			[
				426,
				-9
			],
			[
				381,
				87
			]
		],
		[
			[
				23933,
				96380
			],
			[
				-126,
				-17
			],
			[
				-521,
				38
			],
			[
				-74,
				165
			],
			[
				559,
				-9
			],
			[
				195,
				-109
			],
			[
				-33,
				-68
			]
		],
		[
			[
				19392,
				96485
			],
			[
				-518,
				-170
			],
			[
				-411,
				191
			],
			[
				224,
				188
			],
			[
				406,
				60
			],
			[
				392,
				-92
			],
			[
				-93,
				-177
			]
		],
		[
			[
				19538,
				97019
			],
			[
				-339,
				-115
			],
			[
				-461,
				1
			],
			[
				5,
				84
			],
			[
				285,
				177
			],
			[
				149,
				-27
			],
			[
				361,
				-120
			]
		],
		[
			[
				23380,
				96697
			],
			[
				-411,
				-122
			],
			[
				-226,
				138
			],
			[
				-119,
				221
			],
			[
				-22,
				245
			],
			[
				360,
				-24
			],
			[
				162,
				-39
			],
			[
				332,
				-205
			],
			[
				-76,
				-214
			]
		],
		[
			[
				22205,
				96856
			],
			[
				108,
				-247
			],
			[
				-453,
				66
			],
			[
				-457,
				192
			],
			[
				-619,
				21
			],
			[
				268,
				176
			],
			[
				-335,
				142
			],
			[
				-21,
				227
			],
			[
				546,
				-81
			],
			[
				751,
				-215
			],
			[
				212,
				-281
			]
		],
		[
			[
				25828,
				97644
			],
			[
				334,
				-190
			],
			[
				-381,
				-176
			],
			[
				-513,
				-445
			],
			[
				-492,
				-42
			],
			[
				-575,
				76
			],
			[
				-299,
				240
			],
			[
				4,
				215
			],
			[
				220,
				157
			],
			[
				-508,
				-4
			],
			[
				-306,
				196
			],
			[
				-176,
				268
			],
			[
				193,
				262
			],
			[
				192,
				180
			],
			[
				285,
				42
			],
			[
				-122,
				135
			],
			[
				646,
				30
			],
			[
				355,
				-315
			],
			[
				468,
				-127
			],
			[
				455,
				-112
			],
			[
				220,
				-390
			]
		],
		[
			[
				30972,
				99681
			],
			[
				742,
				-47
			],
			[
				597,
				-75
			],
			[
				508,
				-161
			],
			[
				-12,
				-157
			],
			[
				-678,
				-257
			],
			[
				-672,
				-119
			],
			[
				-251,
				-133
			],
			[
				605,
				3
			],
			[
				-656,
				-358
			],
			[
				-452,
				-167
			],
			[
				-476,
				-483
			],
			[
				-573,
				-98
			],
			[
				-177,
				-120
			],
			[
				-841,
				-64
			],
			[
				383,
				-74
			],
			[
				-192,
				-105
			],
			[
				230,
				-292
			],
			[
				-264,
				-202
			],
			[
				-429,
				-167
			],
			[
				-132,
				-232
			],
			[
				-388,
				-176
			],
			[
				39,
				-134
			],
			[
				475,
				23
			],
			[
				6,
				-144
			],
			[
				-742,
				-355
			],
			[
				-726,
				163
			],
			[
				-816,
				-91
			],
			[
				-414,
				71
			],
			[
				-525,
				31
			],
			[
				-35,
				284
			],
			[
				514,
				133
			],
			[
				-137,
				427
			],
			[
				170,
				41
			],
			[
				742,
				-255
			],
			[
				-379,
				379
			],
			[
				-450,
				113
			],
			[
				225,
				229
			],
			[
				492,
				141
			],
			[
				79,
				206
			],
			[
				-392,
				231
			],
			[
				-118,
				304
			],
			[
				759,
				-26
			],
			[
				220,
				-64
			],
			[
				433,
				216
			],
			[
				-625,
				68
			],
			[
				-972,
				-38
			],
			[
				-491,
				201
			],
			[
				-232,
				239
			],
			[
				-324,
				173
			],
			[
				-61,
				202
			],
			[
				413,
				112
			],
			[
				324,
				19
			],
			[
				545,
				96
			],
			[
				409,
				220
			],
			[
				344,
				-30
			],
			[
				300,
				-166
			],
			[
				211,
				319
			],
			[
				367,
				95
			],
			[
				498,
				65
			],
			[
				849,
				24
			],
			[
				148,
				-63
			],
			[
				802,
				100
			],
			[
				601,
				-38
			],
			[
				602,
				-37
			]
		],
		[
			[
				52900,
				78285
			],
			[
				-22,
				-242
			],
			[
				-122,
				-100
			],
			[
				-206,
				75
			],
			[
				-60,
				-239
			],
			[
				-132,
				-19
			],
			[
				-48,
				94
			],
			[
				-156,
				-200
			],
			[
				-134,
				-28
			],
			[
				-120,
				126
			]
		],
		[
			[
				51900,
				77752
			],
			[
				-95,
				259
			],
			[
				-133,
				-92
			],
			[
				5,
				267
			],
			[
				203,
				332
			],
			[
				-9,
				150
			],
			[
				126,
				-54
			],
			[
				77,
				101
			]
		],
		[
			[
				52074,
				78715
			],
			[
				236,
				-4
			],
			[
				57,
				128
			],
			[
				298,
				-181
			]
		],
		[
			[
				31400,
				18145
			],
			[
				-92,
				-239
			],
			[
				-238,
				-183
			],
			[
				-137,
				19
			],
			[
				-164,
				48
			],
			[
				-202,
				177
			],
			[
				-291,
				86
			],
			[
				-350,
				330
			],
			[
				-283,
				317
			],
			[
				-383,
				662
			],
			[
				229,
				-124
			],
			[
				390,
				-395
			],
			[
				369,
				-212
			],
			[
				143,
				271
			],
			[
				90,
				405
			],
			[
				256,
				244
			],
			[
				198,
				-70
			]
		],
		[
			[
				30952,
				19680
			],
			[
				-247,
				4
			],
			[
				-134,
				-145
			],
			[
				-250,
				-213
			],
			[
				-45,
				-552
			],
			[
				-118,
				-14
			],
			[
				-313,
				192
			],
			[
				-318,
				412
			],
			[
				-346,
				338
			],
			[
				-87,
				374
			],
			[
				79,
				346
			],
			[
				-140,
				393
			],
			[
				-36,
				1007
			],
			[
				119,
				568
			],
			[
				293,
				457
			],
			[
				-422,
				172
			],
			[
				265,
				522
			],
			[
				94,
				982
			],
			[
				309,
				-208
			],
			[
				145,
				1224
			],
			[
				-186,
				157
			],
			[
				-87,
				-738
			],
			[
				-175,
				83
			],
			[
				87,
				845
			],
			[
				95,
				1095
			],
			[
				127,
				404
			],
			[
				-80,
				576
			],
			[
				-22,
				666
			],
			[
				117,
				19
			],
			[
				170,
				954
			],
			[
				192,
				945
			],
			[
				118,
				881
			],
			[
				-64,
				885
			],
			[
				83,
				487
			],
			[
				-34,
				730
			],
			[
				163,
				721
			],
			[
				50,
				1143
			],
			[
				89,
				1227
			],
			[
				87,
				1321
			],
			[
				-20,
				967
			],
			[
				-58,
				832
			]
		],
		[
			[
				30452,
				39739
			],
			[
				143,
				151
			],
			[
				74,
				303
			]
		],
		[
			[
				80649,
				61615
			],
			[
				-240,
				-284
			],
			[
				-228,
				183
			],
			[
				-8,
				509
			],
			[
				137,
				267
			],
			[
				304,
				166
			],
			[
				159,
				-14
			],
			[
				62,
				-226
			],
			[
				-122,
				-260
			],
			[
				-64,
				-341
			]
		],
		[
			[
				86288,
				75628
			],
			[
				-179,
				348
			],
			[
				-111,
				-331
			],
			[
				-429,
				-254
			],
			[
				44,
				-312
			],
			[
				-241,
				22
			],
			[
				-131,
				185
			],
			[
				-191,
				-419
			],
			[
				-306,
				-318
			],
			[
				-227,
				-379
			]
		],
		[
			[
				84517,
				74170
			],
			[
				-388,
				-171
			],
			[
				-204,
				-277
			],
			[
				-300,
				-161
			],
			[
				148,
				274
			],
			[
				-58,
				230
			],
			[
				220,
				397
			],
			[
				-147,
				310
			],
			[
				-242,
				-209
			],
			[
				-314,
				-411
			],
			[
				-171,
				-381
			],
			[
				-272,
				-29
			],
			[
				-142,
				-275
			],
			[
				147,
				-400
			],
			[
				227,
				-97
			],
			[
				9,
				-265
			],
			[
				220,
				-173
			],
			[
				311,
				422
			],
			[
				247,
				-230
			],
			[
				179,
				-15
			],
			[
				45,
				-310
			],
			[
				-393,
				-165
			],
			[
				-130,
				-319
			],
			[
				-270,
				-296
			],
			[
				-142,
				-414
			],
			[
				299,
				-325
			],
			[
				109,
				-581
			],
			[
				169,
				-541
			],
			[
				189,
				-454
			],
			[
				-5,
				-439
			],
			[
				-174,
				-161
			],
			[
				66,
				-315
			],
			[
				164,
				-184
			],
			[
				-43,
				-481
			],
			[
				-71,
				-468
			],
			[
				-155,
				-53
			],
			[
				-203,
				-640
			],
			[
				-225,
				-775
			],
			[
				-258,
				-705
			],
			[
				-382,
				-545
			],
			[
				-386,
				-498
			],
			[
				-313,
				-68
			],
			[
				-170,
				-262
			],
			[
				-96,
				192
			],
			[
				-157,
				-294
			],
			[
				-388,
				-296
			],
			[
				-294,
				-90
			],
			[
				-95,
				-624
			],
			[
				-154,
				-35
			],
			[
				-73,
				429
			],
			[
				66,
				228
			],
			[
				-373,
				189
			],
			[
				-131,
				-96
			]
		],
		[
			[
				80013,
				63313
			],
			[
				-280,
				154
			],
			[
				-132,
				240
			],
			[
				44,
				340
			],
			[
				-254,
				108
			],
			[
				-134,
				222
			],
			[
				-236,
				-315
			],
			[
				-271,
				-68
			],
			[
				-221,
				3
			],
			[
				-149,
				-145
			]
		],
		[
			[
				78380,
				63852
			],
			[
				-144,
				-86
			],
			[
				42,
				-676
			],
			[
				-148,
				16
			],
			[
				-25,
				139
			]
		],
		[
			[
				78105,
				63245
			],
			[
				-9,
				244
			],
			[
				-203,
				-172
			],
			[
				-121,
				109
			],
			[
				-206,
				222
			],
			[
				81,
				490
			],
			[
				-176,
				115
			],
			[
				-66,
				544
			],
			[
				-293,
				-98
			],
			[
				33,
				701
			],
			[
				263,
				493
			],
			[
				11,
				487
			],
			[
				-8,
				452
			],
			[
				-121,
				141
			],
			[
				-93,
				348
			],
			[
				-162,
				-44
			]
		],
		[
			[
				77035,
				67277
			],
			[
				-300,
				89
			],
			[
				94,
				248
			],
			[
				-130,
				367
			],
			[
				-198,
				-249
			],
			[
				-233,
				145
			],
			[
				-321,
				-376
			],
			[
				-252,
				-439
			],
			[
				-224,
				-74
			]
		],
		[
			[
				74670,
				66709
			],
			[
				-23,
				465
			],
			[
				-170,
				-124
			]
		],
		[
			[
				74477,
				67050
			],
			[
				-324,
				57
			],
			[
				-314,
				136
			],
			[
				-225,
				259
			],
			[
				-216,
				117
			],
			[
				-93,
				284
			],
			[
				-157,
				84
			],
			[
				-280,
				385
			],
			[
				-223,
				182
			],
			[
				-115,
				-141
			]
		],
		[
			[
				72530,
				68413
			],
			[
				-386,
				413
			],
			[
				-273,
				374
			],
			[
				-78,
				651
			],
			[
				200,
				-79
			],
			[
				9,
				301
			],
			[
				-111,
				303
			],
			[
				28,
				482
			],
			[
				-298,
				692
			]
		],
		[
			[
				71621,
				71550
			],
			[
				-457,
				239
			],
			[
				-82,
				454
			],
			[
				-205,
				276
			]
		],
		[
			[
				70827,
				72688
			],
			[
				-42,
				337
			],
			[
				10,
				230
			],
			[
				-169,
				134
			],
			[
				-91,
				-59
			],
			[
				-70,
				546
			]
		],
		[
			[
				70465,
				73876
			],
			[
				79,
				136
			],
			[
				-39,
				138
			],
			[
				266,
				279
			],
			[
				192,
				116
			],
			[
				294,
				-80
			],
			[
				105,
				378
			],
			[
				356,
				70
			],
			[
				99,
				234
			],
			[
				438,
				320
			],
			[
				39,
				134
			]
		],
		[
			[
				72294,
				75601
			],
			[
				-22,
				337
			],
			[
				190,
				154
			],
			[
				-250,
				1026
			],
			[
				550,
				236
			],
			[
				143,
				131
			],
			[
				200,
				1058
			],
			[
				551,
				-194
			],
			[
				155,
				267
			],
			[
				13,
				592
			],
			[
				230,
				56
			],
			[
				212,
				393
			]
		],
		[
			[
				74266,
				79657
			],
			[
				109,
				49
			]
		],
		[
			[
				74375,
				79706
			],
			[
				73,
				-413
			],
			[
				233,
				-313
			],
			[
				396,
				-222
			],
			[
				192,
				-476
			],
			[
				-107,
				-690
			],
			[
				100,
				-256
			],
			[
				330,
				-101
			],
			[
				374,
				-83
			],
			[
				336,
				-368
			],
			[
				171,
				-66
			],
			[
				127,
				-544
			],
			[
				163,
				-351
			],
			[
				306,
				14
			],
			[
				574,
				-133
			],
			[
				369,
				82
			],
			[
				274,
				-88
			],
			[
				411,
				-359
			],
			[
				336,
				1
			],
			[
				123,
				-184
			],
			[
				324,
				318
			],
			[
				448,
				205
			],
			[
				417,
				22
			],
			[
				324,
				208
			],
			[
				200,
				316
			],
			[
				194,
				199
			],
			[
				-45,
				195
			],
			[
				-89,
				227
			],
			[
				146,
				381
			],
			[
				156,
				-53
			],
			[
				286,
				-120
			],
			[
				277,
				313
			],
			[
				423,
				229
			],
			[
				204,
				391
			],
			[
				195,
				168
			],
			[
				404,
				78
			],
			[
				219,
				-66
			],
			[
				30,
				210
			],
			[
				-251,
				413
			],
			[
				-223,
				189
			],
			[
				-214,
				-219
			],
			[
				-274,
				92
			],
			[
				-157,
				-74
			],
			[
				-72,
				241
			],
			[
				197,
				590
			],
			[
				135,
				446
			]
		],
		[
			[
				82410,
				80055
			],
			[
				333,
				-223
			],
			[
				392,
				373
			],
			[
				-3,
				260
			],
			[
				251,
				627
			],
			[
				155,
				189
			],
			[
				-4,
				326
			],
			[
				-152,
				141
			],
			[
				229,
				294
			],
			[
				345,
				106
			],
			[
				369,
				16
			],
			[
				415,
				-176
			],
			[
				244,
				-217
			],
			[
				172,
				-596
			],
			[
				104,
				-254
			],
			[
				97,
				-363
			],
			[
				103,
				-579
			],
			[
				483,
				-189
			],
			[
				329,
				-420
			],
			[
				112,
				-555
			],
			[
				423,
				-1
			],
			[
				240,
				233
			],
			[
				459,
				175
			],
			[
				-146,
				-532
			],
			[
				-107,
				-216
			],
			[
				-96,
				-647
			],
			[
				-186,
				-575
			],
			[
				-338,
				104
			],
			[
				-238,
				-208
			],
			[
				73,
				-506
			],
			[
				-40,
				-698
			],
			[
				-142,
				-16
			],
			[
				2,
				-300
			]
		],
		[
			[
				49206,
				53531
			],
			[
				-126,
				-7
			],
			[
				-194,
				116
			],
			[
				-178,
				-7
			],
			[
				-329,
				-103
			],
			[
				-193,
				-170
			],
			[
				-275,
				-217
			],
			[
				-54,
				15
			]
		],
		[
			[
				47857,
				53158
			],
			[
				22,
				487
			],
			[
				26,
				74
			],
			[
				-8,
				233
			],
			[
				-118,
				247
			],
			[
				-88,
				40
			],
			[
				-81,
				162
			],
			[
				60,
				262
			],
			[
				-28,
				286
			],
			[
				13,
				172
			]
		],
		[
			[
				47655,
				55121
			],
			[
				44,
				0
			],
			[
				17,
				258
			],
			[
				-22,
				114
			],
			[
				27,
				82
			],
			[
				103,
				71
			],
			[
				-69,
				473
			],
			[
				-64,
				245
			],
			[
				23,
				200
			],
			[
				55,
				46
			]
		],
		[
			[
				47769,
				56610
			],
			[
				36,
				54
			],
			[
				77,
				-89
			],
			[
				215,
				-5
			],
			[
				51,
				172
			],
			[
				48,
				-11
			],
			[
				80,
				67
			],
			[
				43,
				-253
			],
			[
				65,
				74
			],
			[
				114,
				88
			]
		],
		[
			[
				49214,
				56277
			],
			[
				74,
				-841
			],
			[
				-117,
				-496
			],
			[
				-73,
				-667
			],
			[
				121,
				-509
			],
			[
				-13,
				-233
			]
		],
		[
			[
				53632,
				51919
			],
			[
				-35,
				32
			],
			[
				-164,
				-76
			],
			[
				-169,
				79
			],
			[
				-132,
				-38
			]
		],
		[
			[
				53132,
				51916
			],
			[
				-452,
				13
			]
		],
		[
			[
				52680,
				51929
			],
			[
				40,
				466
			],
			[
				-108,
				391
			],
			[
				-127,
				100
			],
			[
				-56,
				265
			],
			[
				-72,
				85
			],
			[
				4,
				163
			]
		],
		[
			[
				52361,
				53399
			],
			[
				71,
				418
			],
			[
				132,
				570
			],
			[
				81,
				6
			],
			[
				165,
				345
			],
			[
				105,
				10
			],
			[
				156,
				-243
			],
			[
				191,
				199
			],
			[
				26,
				246
			],
			[
				63,
				238
			],
			[
				43,
				299
			],
			[
				148,
				243
			],
			[
				56,
				414
			],
			[
				59,
				132
			],
			[
				39,
				307
			],
			[
				74,
				377
			],
			[
				234,
				457
			],
			[
				14,
				196
			],
			[
				31,
				107
			],
			[
				-110,
				235
			]
		],
		[
			[
				53939,
				57955
			],
			[
				9,
				188
			],
			[
				78,
				34
			]
		],
		[
			[
				54026,
				58177
			],
			[
				111,
				-378
			],
			[
				18,
				-392
			],
			[
				-10,
				-393
			],
			[
				151,
				-537
			],
			[
				-155,
				6
			],
			[
				-78,
				-42
			],
			[
				-127,
				60
			],
			[
				-60,
				-279
			],
			[
				164,
				-345
			],
			[
				121,
				-100
			],
			[
				39,
				-245
			],
			[
				87,
				-407
			],
			[
				-43,
				-160
			]
		],
		[
			[
				54447,
				51919
			],
			[
				-20,
				-319
			],
			[
				-220,
				140
			],
			[
				-225,
				156
			],
			[
				-350,
				23
			]
		],
		[
			[
				58564,
				52653
			],
			[
				-16,
				-691
			],
			[
				111,
				-80
			],
			[
				-89,
				-210
			],
			[
				-107,
				-157
			],
			[
				-106,
				-308
			],
			[
				-59,
				-274
			],
			[
				-15,
				-475
			],
			[
				-65,
				-225
			],
			[
				-2,
				-446
			]
		],
		[
			[
				58216,
				49787
			],
			[
				-80,
				-165
			],
			[
				-10,
				-351
			],
			[
				-38,
				-46
			],
			[
				-26,
				-323
			]
		],
		[
			[
				58149,
				47921
			],
			[
				50,
				-544
			],
			[
				-27,
				-307
			]
		],
		[
			[
				58172,
				47070
			],
			[
				55,
				-343
			],
			[
				161,
				-330
			]
		],
		[
			[
				58388,
				46397
			],
			[
				150,
				-745
			]
		],
		[
			[
				58538,
				45652
			],
			[
				-109,
				60
			],
			[
				-373,
				-99
			],
			[
				-75,
				-71
			],
			[
				-79,
				-377
			],
			[
				62,
				-261
			],
			[
				-49,
				-699
			],
			[
				-34,
				-593
			],
			[
				75,
				-105
			],
			[
				194,
				-230
			],
			[
				76,
				107
			],
			[
				23,
				-637
			],
			[
				-212,
				5
			],
			[
				-114,
				325
			],
			[
				-103,
				252
			],
			[
				-213,
				82
			],
			[
				-62,
				310
			],
			[
				-170,
				-187
			],
			[
				-222,
				83
			],
			[
				-93,
				268
			],
			[
				-176,
				55
			],
			[
				-131,
				-15
			],
			[
				-15,
				184
			],
			[
				-96,
				15
			]
		],
		[
			[
				53422,
				46976
			],
			[
				-39,
				183
			]
		],
		[
			[
				53609,
				47755
			],
			[
				73,
				-60
			],
			[
				95,
				226
			],
			[
				152,
				-6
			],
			[
				17,
				-167
			],
			[
				104,
				-105
			],
			[
				164,
				370
			],
			[
				161,
				289
			],
			[
				71,
				189
			],
			[
				-10,
				486
			],
			[
				121,
				574
			],
			[
				127,
				304
			],
			[
				183,
				285
			],
			[
				32,
				189
			],
			[
				7,
				216
			],
			[
				45,
				205
			],
			[
				-14,
				335
			],
			[
				34,
				524
			],
			[
				55,
				368
			],
			[
				83,
				316
			],
			[
				16,
				357
			]
		],
		[
			[
				57603,
				53672
			],
			[
				169,
				-488
			],
			[
				124,
				-71
			],
			[
				75,
				99
			],
			[
				128,
				-39
			],
			[
				155,
				125
			],
			[
				66,
				-252
			],
			[
				244,
				-393
			]
		],
		[
			[
				53309,
				47603
			],
			[
				-228,
				626
			]
		],
		[
			[
				53081,
				48229
			],
			[
				212,
				326
			],
			[
				-105,
				391
			],
			[
				95,
				148
			],
			[
				187,
				73
			],
			[
				23,
				261
			],
			[
				148,
				-283
			],
			[
				245,
				-25
			],
			[
				85,
				279
			],
			[
				36,
				393
			],
			[
				-31,
				461
			],
			[
				-131,
				350
			],
			[
				120,
				684
			],
			[
				-69,
				117
			],
			[
				-207,
				-48
			],
			[
				-78,
				305
			],
			[
				21,
				258
			]
		],
		[
			[
				29063,
				50490
			],
			[
				-119,
				140
			],
			[
				-137,
				195
			],
			[
				-79,
				-94
			],
			[
				-235,
				82
			],
			[
				-68,
				255
			],
			[
				-52,
				-10
			],
			[
				-278,
				338
			]
		],
		[
			[
				28095,
				51396
			],
			[
				-37,
				183
			],
			[
				103,
				44
			],
			[
				-12,
				296
			],
			[
				65,
				214
			],
			[
				138,
				40
			],
			[
				117,
				371
			],
			[
				106,
				310
			],
			[
				-102,
				141
			],
			[
				52,
				343
			],
			[
				-62,
				540
			],
			[
				59,
				155
			],
			[
				-44,
				500
			],
			[
				-112,
				315
			]
		],
		[
			[
				28366,
				54848
			],
			[
				36,
				287
			],
			[
				89,
				-43
			],
			[
				52,
				176
			],
			[
				-64,
				348
			],
			[
				34,
				86
			]
		],
		[
			[
				28513,
				55702
			],
			[
				143,
				-18
			],
			[
				209,
				412
			],
			[
				114,
				63
			],
			[
				3,
				195
			],
			[
				51,
				500
			],
			[
				159,
				274
			],
			[
				175,
				11
			],
			[
				22,
				123
			],
			[
				218,
				-49
			],
			[
				218,
				298
			],
			[
				109,
				132
			],
			[
				134,
				285
			],
			[
				98,
				-36
			],
			[
				73,
				-156
			],
			[
				-54,
				-199
			]
		],
		[
			[
				30185,
				57537
			],
			[
				-178,
				-99
			],
			[
				-71,
				-295
			],
			[
				-107,
				-169
			],
			[
				-81,
				-220
			],
			[
				-34,
				-422
			],
			[
				-77,
				-345
			],
			[
				144,
				-40
			],
			[
				35,
				-271
			],
			[
				62,
				-130
			],
			[
				21,
				-238
			],
			[
				-33,
				-219
			],
			[
				10,
				-123
			],
			[
				69,
				-49
			],
			[
				66,
				-207
			],
			[
				357,
				57
			],
			[
				161,
				-75
			],
			[
				196,
				-508
			],
			[
				112,
				63
			],
			[
				200,
				-32
			],
			[
				158,
				68
			],
			[
				99,
				-102
			],
			[
				-50,
				-318
			],
			[
				-62,
				-199
			],
			[
				-22,
				-423
			],
			[
				56,
				-393
			],
			[
				79,
				-175
			],
			[
				9,
				-133
			],
			[
				-140,
				-294
			],
			[
				100,
				-130
			],
			[
				74,
				-207
			],
			[
				85,
				-589
			]
		],
		[
			[
				30585,
				48040
			],
			[
				-139,
				314
			],
			[
				-83,
				14
			],
			[
				179,
				602
			],
			[
				-213,
				276
			],
			[
				-166,
				-51
			],
			[
				-101,
				103
			],
			[
				-153,
				-157
			],
			[
				-207,
				74
			],
			[
				-163,
				620
			],
			[
				-129,
				152
			],
			[
				-89,
				279
			],
			[
				-184,
				280
			],
			[
				-74,
				-56
			]
		],
		[
			[
				26954,
				55439
			],
			[
				-151,
				131
			],
			[
				-56,
				124
			],
			[
				32,
				103
			],
			[
				-11,
				130
			],
			[
				-77,
				142
			],
			[
				-109,
				116
			],
			[
				-95,
				76
			],
			[
				-19,
				173
			],
			[
				-73,
				105
			],
			[
				18,
				-172
			],
			[
				-55,
				-141
			],
			[
				-64,
				164
			],
			[
				-89,
				58
			],
			[
				-38,
				120
			],
			[
				2,
				179
			],
			[
				36,
				187
			],
			[
				-78,
				83
			],
			[
				64,
				114
			]
		],
		[
			[
				26191,
				57131
			],
			[
				42,
				76
			],
			[
				183,
				-156
			],
			[
				63,
				77
			],
			[
				89,
				-50
			],
			[
				46,
				-121
			],
			[
				82,
				-40
			],
			[
				66,
				126
			]
		],
		[
			[
				26762,
				57043
			],
			[
				70,
				-321
			],
			[
				108,
				-238
			],
			[
				130,
				-252
			]
		],
		[
			[
				27070,
				56232
			],
			[
				-107,
				-53
			],
			[
				1,
				-238
			],
			[
				58,
				-88
			],
			[
				-41,
				-70
			],
			[
				10,
				-107
			],
			[
				-23,
				-120
			],
			[
				-14,
				-117
			]
		],
		[
			[
				27147,
				64280
			],
			[
				240,
				-42
			],
			[
				219,
				-7
			],
			[
				261,
				-201
			],
			[
				110,
				-216
			],
			[
				260,
				66
			],
			[
				98,
				-138
			],
			[
				235,
				-366
			],
			[
				173,
				-267
			],
			[
				92,
				8
			],
			[
				165,
				-120
			],
			[
				-20,
				-167
			],
			[
				205,
				-24
			],
			[
				210,
				-242
			],
			[
				-33,
				-138
			],
			[
				-185,
				-75
			],
			[
				-187,
				-29
			],
			[
				-191,
				46
			],
			[
				-398,
				-57
			],
			[
				186,
				329
			],
			[
				-113,
				154
			],
			[
				-179,
				39
			],
			[
				-96,
				171
			],
			[
				-66,
				336
			],
			[
				-157,
				-23
			],
			[
				-259,
				159
			],
			[
				-83,
				124
			],
			[
				-362,
				91
			],
			[
				-97,
				115
			],
			[
				104,
				148
			],
			[
				-273,
				30
			],
			[
				-199,
				-307
			],
			[
				-115,
				-8
			],
			[
				-40,
				-144
			],
			[
				-138,
				-65
			],
			[
				-118,
				56
			],
			[
				146,
				183
			],
			[
				60,
				213
			],
			[
				126,
				131
			],
			[
				142,
				116
			],
			[
				210,
				56
			],
			[
				67,
				65
			]
		],
		[
			[
				59092,
				71341
			],
			[
				19,
				3
			],
			[
				40,
				143
			],
			[
				200,
				-8
			],
			[
				253,
				176
			],
			[
				-188,
				-251
			],
			[
				21,
				-111
			]
		],
		[
			[
				59437,
				71293
			],
			[
				-30,
				21
			],
			[
				-53,
				-45
			],
			[
				-42,
				12
			],
			[
				-14,
				-22
			],
			[
				-5,
				59
			],
			[
				-20,
				37
			],
			[
				-54,
				6
			],
			[
				-75,
				-51
			],
			[
				-52,
				31
			]
		],
		[
			[
				59437,
				71293
			],
			[
				8,
				-48
			],
			[
				-285,
				-240
			],
			[
				-136,
				77
			],
			[
				-64,
				237
			],
			[
				132,
				22
			]
		],
		[
			[
				53776,
				79457
			],
			[
				-157,
				254
			],
			[
				-141,
				142
			],
			[
				-30,
				249
			],
			[
				-49,
				176
			],
			[
				202,
				129
			],
			[
				103,
				147
			],
			[
				200,
				114
			],
			[
				70,
				113
			],
			[
				73,
				-68
			],
			[
				124,
				62
			]
		],
		[
			[
				54171,
				80775
			],
			[
				132,
				-191
			],
			[
				207,
				-51
			],
			[
				-17,
				-163
			],
			[
				151,
				-122
			],
			[
				41,
				153
			],
			[
				191,
				-66
			],
			[
				26,
				-185
			],
			[
				207,
				-36
			],
			[
				127,
				-291
			]
		],
		[
			[
				55236,
				79823
			],
			[
				-82,
				-1
			],
			[
				-43,
				-106
			],
			[
				-64,
				-26
			],
			[
				-18,
				-134
			],
			[
				-54,
				-28
			],
			[
				-7,
				-55
			],
			[
				-95,
				-61
			],
			[
				-123,
				10
			],
			[
				-39,
				-130
			]
		],
		[
			[
				52756,
				83065
			],
			[
				4,
				-228
			],
			[
				281,
				-138
			],
			[
				-3,
				-210
			],
			[
				283,
				111
			],
			[
				156,
				162
			],
			[
				313,
				-233
			],
			[
				132,
				-189
			]
		],
		[
			[
				53922,
				82340
			],
			[
				64,
				-300
			],
			[
				-77,
				-158
			],
			[
				101,
				-210
			],
			[
				69,
				-316
			],
			[
				-22,
				-204
			],
			[
				114,
				-377
			]
		],
		[
			[
				52074,
				78715
			],
			[
				35,
				421
			],
			[
				140,
				404
			],
			[
				-400,
				109
			],
			[
				-131,
				155
			]
		],
		[
			[
				51718,
				79804
			],
			[
				16,
				259
			],
			[
				-56,
				133
			]
		],
		[
			[
				51710,
				80596
			],
			[
				-47,
				619
			],
			[
				167,
				0
			],
			[
				70,
				222
			],
			[
				69,
				541
			],
			[
				-51,
				200
			]
		],
		[
			[
				51918,
				82178
			],
			[
				54,
				125
			],
			[
				232,
				32
			],
			[
				52,
				-130
			],
			[
				188,
				291
			],
			[
				-63,
				222
			],
			[
				-13,
				335
			]
		],
		[
			[
				52368,
				83053
			],
			[
				210,
				-78
			],
			[
				178,
				90
			]
		],
		[
			[
				61966,
				58083
			],
			[
				66,
				-183
			],
			[
				-9,
				-245
			],
			[
				-158,
				-142
			],
			[
				119,
				-161
			]
		],
		[
			[
				61984,
				57352
			],
			[
				-102,
				-317
			]
		],
		[
			[
				61882,
				57035
			],
			[
				-62,
				106
			],
			[
				-67,
				-42
			],
			[
				-155,
				10
			],
			[
				-4,
				180
			],
			[
				-22,
				163
			],
			[
				94,
				277
			],
			[
				98,
				261
			]
		],
		[
			[
				61764,
				57990
			],
			[
				119,
				-51
			],
			[
				83,
				144
			]
		],
		[
			[
				53524,
				83435
			],
			[
				-166,
				-478
			],
			[
				-291,
				333
			],
			[
				-39,
				246
			],
			[
				408,
				195
			],
			[
				88,
				-296
			]
		],
		[
			[
				52368,
				83053
			],
			[
				-113,
				328
			],
			[
				-8,
				604
			],
			[
				46,
				159
			],
			[
				80,
				177
			],
			[
				244,
				37
			],
			[
				98,
				163
			],
			[
				223,
				167
			],
			[
				-9,
				-304
			],
			[
				-82,
				-192
			],
			[
				33,
				-166
			],
			[
				151,
				-89
			],
			[
				-68,
				-223
			],
			[
				-83,
				64
			],
			[
				-200,
				-425
			],
			[
				76,
				-288
			]
		],
		[
			[
				30080,
				62227
			],
			[
				34,
				101
			],
			[
				217,
				-3
			],
			[
				165,
				-152
			],
			[
				73,
				15
			],
			[
				50,
				-209
			],
			[
				152,
				11
			],
			[
				-9,
				-176
			],
			[
				124,
				-21
			],
			[
				136,
				-217
			],
			[
				-103,
				-240
			],
			[
				-132,
				128
			],
			[
				-127,
				-25
			],
			[
				-92,
				28
			],
			[
				-50,
				-107
			],
			[
				-106,
				-37
			],
			[
				-43,
				144
			],
			[
				-92,
				-85
			],
			[
				-111,
				-405
			],
			[
				-71,
				94
			],
			[
				-14,
				170
			]
		],
		[
			[
				30081,
				61241
			],
			[
				5,
				161
			],
			[
				-71,
				177
			],
			[
				68,
				99
			],
			[
				21,
				228
			],
			[
				-24,
				321
			]
		],
		[
			[
				53333,
				64447
			],
			[
				-952,
				-1126
			],
			[
				-804,
				-1161
			],
			[
				-392,
				-263
			]
		],
		[
			[
				51185,
				61897
			],
			[
				-308,
				-58
			],
			[
				-3,
				376
			],
			[
				-129,
				96
			],
			[
				-173,
				169
			],
			[
				-66,
				277
			],
			[
				-937,
				1289
			],
			[
				-937,
				1289
			]
		],
		[
			[
				48632,
				65335
			],
			[
				-1045,
				1431
			]
		],
		[
			[
				47587,
				66766
			],
			[
				6,
				114
			],
			[
				-1,
				40
			]
		],
		[
			[
				47592,
				66920
			],
			[
				-2,
				700
			],
			[
				449,
				436
			],
			[
				277,
				90
			],
			[
				227,
				159
			],
			[
				107,
				295
			],
			[
				324,
				234
			],
			[
				12,
				438
			],
			[
				161,
				51
			],
			[
				126,
				219
			],
			[
				363,
				99
			],
			[
				51,
				230
			],
			[
				-73,
				125
			],
			[
				-96,
				624
			],
			[
				-17,
				359
			],
			[
				-104,
				379
			]
		],
		[
			[
				49397,
				71358
			],
			[
				267,
				323
			],
			[
				300,
				102
			],
			[
				175,
				244
			],
			[
				268,
				180
			],
			[
				471,
				105
			],
			[
				459,
				48
			],
			[
				140,
				-87
			],
			[
				262,
				232
			],
			[
				297,
				5
			],
			[
				113,
				-137
			],
			[
				190,
				35
			]
		],
		[
			[
				52339,
				72408
			],
			[
				-57,
				-303
			],
			[
				44,
				-563
			],
			[
				-65,
				-487
			],
			[
				-171,
				-330
			],
			[
				24,
				-445
			],
			[
				227,
				-352
			],
			[
				3,
				-143
			],
			[
				171,
				-238
			],
			[
				118,
				-1061
			]
		],
		[
			[
				52633,
				68486
			],
			[
				90,
				-522
			],
			[
				15,
				-274
			],
			[
				-49,
				-482
			],
			[
				21,
				-270
			],
			[
				-36,
				-323
			],
			[
				24,
				-371
			],
			[
				-110,
				-247
			],
			[
				164,
				-431
			],
			[
				11,
				-253
			],
			[
				99,
				-330
			],
			[
				130,
				109
			],
			[
				219,
				-275
			],
			[
				122,
				-370
			]
		],
		[
			[
				27693,
				48568
			],
			[
				148,
				442
			],
			[
				-60,
				258
			],
			[
				-106,
				-275
			],
			[
				-166,
				259
			],
			[
				56,
				167
			],
			[
				-47,
				536
			],
			[
				97,
				89
			],
			[
				52,
				368
			],
			[
				105,
				381
			],
			[
				-20,
				241
			],
			[
				153,
				126
			],
			[
				190,
				236
			]
		],
		[
			[
				29063,
				50490
			],
			[
				38,
				-449
			],
			[
				-86,
				-384
			],
			[
				-303,
				-619
			],
			[
				-334,
				-233
			],
			[
				-170,
				-514
			],
			[
				-53,
				-398
			],
			[
				-157,
				-243
			],
			[
				-116,
				298
			],
			[
				-113,
				64
			],
			[
				-114,
				-47
			],
			[
				-8,
				216
			],
			[
				79,
				141
			],
			[
				-33,
				246
			]
		],
		[
			[
				59700,
				68010
			],
			[
				-78,
				-238
			],
			[
				-60,
				-446
			],
			[
				-75,
				-308
			],
			[
				-65,
				-103
			],
			[
				-93,
				191
			],
			[
				-125,
				263
			],
			[
				-198,
				847
			],
			[
				-29,
				-53
			],
			[
				115,
				-624
			],
			[
				171,
				-594
			],
			[
				210,
				-920
			],
			[
				102,
				-321
			],
			[
				90,
				-334
			],
			[
				249,
				-654
			],
			[
				-55,
				-103
			],
			[
				9,
				-384
			],
			[
				323,
				-530
			],
			[
				49,
				-121
			]
		],
		[
			[
				60240,
				63578
			],
			[
				-1102,
				0
			],
			[
				-1077,
				0
			],
			[
				-1117,
				0
			]
		],
		[
			[
				56944,
				63578
			],
			[
				0,
				2175
			],
			[
				0,
				2101
			],
			[
				-83,
				476
			],
			[
				71,
				365
			],
			[
				-43,
				253
			],
			[
				101,
				283
			]
		],
		[
			[
				56990,
				69231
			],
			[
				369,
				10
			],
			[
				268,
				-156
			],
			[
				275,
				-175
			],
			[
				129,
				-92
			],
			[
				214,
				188
			],
			[
				114,
				169
			],
			[
				245,
				49
			],
			[
				198,
				-75
			],
			[
				75,
				-293
			],
			[
				65,
				193
			],
			[
				222,
				-140
			],
			[
				217,
				-33
			],
			[
				137,
				149
			]
		],
		[
			[
				59518,
				69025
			],
			[
				182,
				-1015
			]
		],
		[
			[
				61764,
				57990
			],
			[
				-95,
				191
			],
			[
				-114,
				346
			],
			[
				-124,
				190
			],
			[
				-71,
				204
			],
			[
				-242,
				237
			],
			[
				-191,
				7
			],
			[
				-67,
				124
			],
			[
				-163,
				-139
			],
			[
				-168,
				268
			],
			[
				-87,
				-441
			],
			[
				-323,
				124
			]
		],
		[
			[
				60119,
				59101
			],
			[
				-30,
				236
			],
			[
				120,
				868
			],
			[
				27,
				393
			],
			[
				88,
				181
			],
			[
				204,
				97
			],
			[
				141,
				337
			]
		],
		[
			[
				60669,
				61213
			],
			[
				161,
				-684
			],
			[
				77,
				-542
			],
			[
				152,
				-288
			],
			[
				379,
				-558
			],
			[
				154,
				-336
			],
			[
				151,
				-341
			],
			[
				87,
				-203
			],
			[
				136,
				-178
			]
		],
		[
			[
				47490,
				75324
			],
			[
				14,
				420
			],
			[
				-114,
				257
			],
			[
				393,
				426
			],
			[
				340,
				-106
			],
			[
				373,
				3
			],
			[
				296,
				-101
			],
			[
				230,
				31
			],
			[
				449,
				-19
			]
		],
		[
			[
				49471,
				76235
			],
			[
				111,
				-230
			],
			[
				511,
				-268
			],
			[
				101,
				127
			],
			[
				313,
				-267
			],
			[
				322,
				77
			]
		],
		[
			[
				50829,
				75674
			],
			[
				15,
				-344
			],
			[
				-263,
				-393
			],
			[
				-356,
				-125
			],
			[
				-25,
				-199
			],
			[
				-171,
				-327
			],
			[
				-107,
				-481
			],
			[
				108,
				-338
			],
			[
				-160,
				-263
			],
			[
				-60,
				-384
			],
			[
				-210,
				-118
			],
			[
				-197,
				-454
			],
			[
				-352,
				-9
			],
			[
				-265,
				11
			],
			[
				-174,
				-209
			],
			[
				-106,
				-223
			],
			[
				-136,
				49
			],
			[
				-103,
				199
			],
			[
				-79,
				340
			],
			[
				-259,
				92
			]
		],
		[
			[
				47929,
				72498
			],
			[
				-23,
				195
			],
			[
				103,
				222
			],
			[
				38,
				161
			],
			[
				-96,
				175
			],
			[
				77,
				388
			],
			[
				-111,
				355
			],
			[
				120,
				48
			],
			[
				11,
				280
			],
			[
				45,
				86
			],
			[
				3,
				461
			],
			[
				129,
				160
			],
			[
				-78,
				296
			],
			[
				-162,
				21
			],
			[
				-47,
				-75
			],
			[
				-164,
				0
			],
			[
				-70,
				289
			],
			[
				-113,
				-86
			],
			[
				-101,
				-150
			]
		],
		[
			[
				56753,
				84725
			],
			[
				32,
				349
			],
			[
				-102,
				-75
			],
			[
				-176,
				210
			],
			[
				-24,
				340
			],
			[
				351,
				164
			],
			[
				350,
				86
			],
			[
				301,
				-97
			],
			[
				287,
				17
			]
		],
		[
			[
				57772,
				85719
			],
			[
				42,
				-103
			],
			[
				-198,
				-341
			],
			[
				83,
				-551
			],
			[
				-120,
				-187
			]
		],
		[
			[
				57579,
				84537
			],
			[
				-229,
				1
			],
			[
				-239,
				219
			],
			[
				-121,
				73
			],
			[
				-237,
				-105
			]
		],
		[
			[
				61882,
				57035
			],
			[
				-61,
				-209
			],
			[
				103,
				-325
			],
			[
				102,
				-285
			],
			[
				106,
				-210
			],
			[
				909,
				-702
			],
			[
				233,
				4
			]
		],
		[
			[
				63274,
				55308
			],
			[
				-785,
				-1773
			],
			[
				-362,
				-26
			],
			[
				-247,
				-417
			],
			[
				-178,
				-11
			],
			[
				-76,
				-186
			]
		],
		[
			[
				61626,
				52895
			],
			[
				-190,
				0
			],
			[
				-112,
				200
			],
			[
				-254,
				-247
			],
			[
				-82,
				-247
			],
			[
				-185,
				47
			],
			[
				-62,
				68
			],
			[
				-65,
				-16
			],
			[
				-87,
				6
			],
			[
				-352,
				502
			],
			[
				-193,
				0
			],
			[
				-95,
				194
			],
			[
				0,
				332
			],
			[
				-145,
				99
			]
		],
		[
			[
				59804,
				53833
			],
			[
				-164,
				643
			],
			[
				-127,
				137
			],
			[
				-48,
				236
			],
			[
				-141,
				288
			],
			[
				-171,
				42
			],
			[
				95,
				337
			],
			[
				147,
				14
			],
			[
				42,
				181
			]
		],
		[
			[
				59437,
				55711
			],
			[
				-4,
				531
			]
		],
		[
			[
				59433,
				56242
			],
			[
				82,
				618
			],
			[
				132,
				166
			],
			[
				28,
				241
			],
			[
				119,
				451
			],
			[
				168,
				293
			],
			[
				112,
				582
			],
			[
				45,
				508
			]
		],
		[
			[
				57942,
				91385
			],
			[
				-41,
				-414
			],
			[
				425,
				-394
			],
			[
				-256,
				-445
			],
			[
				323,
				-673
			],
			[
				-187,
				-506
			],
			[
				250,
				-440
			],
			[
				-113,
				-385
			],
			[
				411,
				-405
			],
			[
				-105,
				-301
			],
			[
				-258,
				-341
			],
			[
				-594,
				-755
			]
		],
		[
			[
				57797,
				86326
			],
			[
				-504,
				-47
			],
			[
				-489,
				-216
			],
			[
				-452,
				-125
			],
			[
				-161,
				323
			],
			[
				-269,
				193
			],
			[
				62,
				582
			],
			[
				-135,
				533
			],
			[
				133,
				345
			],
			[
				252,
				371
			],
			[
				635,
				640
			],
			[
				185,
				124
			],
			[
				-28,
				250
			],
			[
				-387,
				279
			]
		],
		[
			[
				56639,
				89578
			],
			[
				-93,
				230
			],
			[
				-8,
				910
			],
			[
				-433,
				402
			],
			[
				-371,
				289
			]
		],
		[
			[
				55734,
				91409
			],
			[
				167,
				156
			],
			[
				309,
				-312
			],
			[
				362,
				29
			],
			[
				298,
				-143
			],
			[
				265,
				262
			],
			[
				137,
				433
			],
			[
				431,
				200
			],
			[
				356,
				-235
			],
			[
				-117,
				-414
			]
		],
		[
			[
				99547,
				40335
			],
			[
				96,
				-171
			],
			[
				-46,
				-308
			],
			[
				-172,
				-81
			],
			[
				-153,
				73
			],
			[
				-27,
				260
			],
			[
				107,
				203
			],
			[
				126,
				-74
			],
			[
				69,
				98
			]
		],
		[
			[
				0,
				41087
			],
			[
				57,
				27
			],
			[
				-34,
				-284
			],
			[
				-23,
				-32
			],
			[
				99822,
				-145
			],
			[
				-177,
				-124
			],
			[
				-36,
				220
			],
			[
				139,
				121
			],
			[
				88,
				33
			],
			[
				-99836,
				184
			]
		],
		[
			[
				33000,
				19946
			],
			[
				333,
				354
			],
			[
				236,
				-148
			],
			[
				167,
				237
			],
			[
				222,
				-266
			],
			[
				-83,
				-207
			],
			[
				-375,
				-177
			],
			[
				-125,
				207
			],
			[
				-236,
				-266
			],
			[
				-139,
				266
			]
		],
		[
			[
				34854,
				51946
			],
			[
				70,
				252
			],
			[
				24,
				269
			],
			[
				48,
				253
			],
			[
				-107,
				349
			]
		],
		[
			[
				34889,
				53069
			],
			[
				-22,
				404
			],
			[
				144,
				508
			]
		],
		[
			[
				35011,
				53981
			],
			[
				95,
				-65
			],
			[
				204,
				-140
			],
			[
				294,
				-499
			],
			[
				46,
				-242
			]
		],
		[
			[
				52655,
				75484
			],
			[
				-92,
				-456
			],
			[
				-126,
				120
			],
			[
				-64,
				398
			],
			[
				56,
				219
			],
			[
				179,
				226
			],
			[
				47,
				-507
			]
		],
		[
			[
				51576,
				79843
			],
			[
				62,
				-52
			],
			[
				80,
				13
			]
		],
		[
			[
				51900,
				77752
			],
			[
				-11,
				-167
			],
			[
				82,
				-222
			],
			[
				-97,
				-180
			],
			[
				72,
				-457
			],
			[
				151,
				-75
			],
			[
				-32,
				-256
			]
		],
		[
			[
				52065,
				76395
			],
			[
				-252,
				-334
			],
			[
				-548,
				160
			],
			[
				-404,
				-192
			],
			[
				-32,
				-355
			]
		],
		[
			[
				49471,
				76235
			],
			[
				144,
				354
			],
			[
				53,
				1177
			],
			[
				-287,
				620
			],
			[
				-205,
				299
			],
			[
				-424,
				227
			],
			[
				-28,
				431
			],
			[
				360,
				129
			],
			[
				466,
				-152
			],
			[
				-88,
				669
			],
			[
				263,
				-254
			],
			[
				646,
				461
			],
			[
				84,
				484
			],
			[
				243,
				119
			]
		],
		[
			[
				53081,
				48229
			],
			[
				-285,
				596
			],
			[
				-184,
				488
			],
			[
				-169,
				610
			],
			[
				9,
				196
			],
			[
				61,
				189
			],
			[
				67,
				430
			],
			[
				56,
				438
			]
		],
		[
			[
				52636,
				51176
			],
			[
				94,
				35
			],
			[
				404,
				-6
			],
			[
				-2,
				711
			]
		],
		[
			[
				48278,
				82406
			],
			[
				-210,
				122
			],
			[
				-172,
				-9
			],
			[
				57,
				317
			],
			[
				-57,
				317
			]
		],
		[
			[
				47896,
				83153
			],
			[
				233,
				24
			],
			[
				298,
				-365
			],
			[
				-149,
				-406
			]
		],
		[
			[
				49165,
				85222
			],
			[
				-297,
				-639
			],
			[
				283,
				81
			],
			[
				304,
				-3
			],
			[
				-72,
				-481
			],
			[
				-250,
				-530
			],
			[
				287,
				-38
			],
			[
				22,
				-62
			],
			[
				248,
				-697
			],
			[
				190,
				-95
			],
			[
				171,
				-673
			],
			[
				79,
				-233
			],
			[
				337,
				-113
			],
			[
				-34,
				-378
			],
			[
				-142,
				-173
			],
			[
				111,
				-305
			],
			[
				-250,
				-310
			],
			[
				-371,
				6
			],
			[
				-473,
				-163
			],
			[
				-130,
				116
			],
			[
				-183,
				-276
			],
			[
				-257,
				67
			],
			[
				-195,
				-226
			],
			[
				-148,
				118
			],
			[
				407,
				621
			],
			[
				249,
				127
			],
			[
				-2,
				1
			],
			[
				-434,
				98
			],
			[
				-79,
				235
			],
			[
				291,
				183
			],
			[
				-152,
				319
			],
			[
				52,
				387
			],
			[
				413,
				-54
			],
			[
				1,
				0
			],
			[
				40,
				343
			],
			[
				-186,
				364
			],
			[
				-4,
				8
			],
			[
				-337,
				104
			],
			[
				-66,
				160
			],
			[
				101,
				264
			],
			[
				-92,
				163
			],
			[
				-149,
				-279
			],
			[
				-17,
				569
			],
			[
				-140,
				301
			],
			[
				101,
				611
			],
			[
				216,
				480
			],
			[
				222,
				-47
			],
			[
				335,
				49
			]
		],
		[
			[
				61542,
				75120
			],
			[
				42,
				252
			],
			[
				-70,
				403
			],
			[
				-160,
				218
			],
			[
				-154,
				68
			],
			[
				-102,
				181
			]
		],
		[
			[
				61098,
				76242
			],
			[
				34,
				70
			],
			[
				235,
				-101
			],
			[
				409,
				-96
			],
			[
				378,
				-283
			],
			[
				48,
				-110
			],
			[
				169,
				93
			],
			[
				259,
				-124
			],
			[
				85,
				-242
			],
			[
				175,
				-137
			]
		],
		[
			[
				62106,
				74858
			],
			[
				-268,
				290
			],
			[
				-296,
				-28
			]
		],
		[
			[
				50294,
				54083
			],
			[
				-436,
				-346
			],
			[
				-154,
				-203
			],
			[
				-250,
				-171
			],
			[
				-248,
				168
			]
		],
		[
			[
				50006,
				57090
			],
			[
				-20,
				-184
			],
			[
				116,
				-305
			],
			[
				-1,
				-429
			],
			[
				27,
				-466
			],
			[
				69,
				-215
			],
			[
				-61,
				-532
			],
			[
				22,
				-294
			],
			[
				74,
				-375
			],
			[
				62,
				-207
			]
		],
		[
			[
				47655,
				55121
			],
			[
				-78,
				15
			],
			[
				-57,
				-238
			],
			[
				-78,
				3
			],
			[
				-55,
				126
			],
			[
				19,
				237
			],
			[
				-116,
				362
			],
			[
				-73,
				-67
			],
			[
				-59,
				-13
			]
		],
		[
			[
				47158,
				55546
			],
			[
				-77,
				-34
			],
			[
				3,
				217
			],
			[
				-44,
				155
			],
			[
				9,
				171
			],
			[
				-60,
				249
			],
			[
				-78,
				211
			],
			[
				-222,
				1
			],
			[
				-65,
				-112
			],
			[
				-76,
				-13
			],
			[
				-48,
				-128
			],
			[
				-32,
				-163
			],
			[
				-148,
				-260
			]
		],
		[
			[
				46320,
				55840
			],
			[
				-122,
				349
			],
			[
				-108,
				232
			],
			[
				-71,
				76
			],
			[
				-69,
				118
			],
			[
				-32,
				261
			],
			[
				-41,
				130
			],
			[
				-80,
				97
			]
		],
		[
			[
				45797,
				57103
			],
			[
				123,
				288
			],
			[
				84,
				-11
			],
			[
				73,
				99
			],
			[
				61,
				1
			],
			[
				44,
				78
			],
			[
				-24,
				196
			],
			[
				31,
				62
			],
			[
				5,
				200
			]
		],
		[
			[
				46194,
				58016
			],
			[
				134,
				-6
			],
			[
				200,
				-144
			],
			[
				61,
				13
			],
			[
				21,
				66
			],
			[
				151,
				-47
			],
			[
				40,
				33
			]
		],
		[
			[
				46801,
				57931
			],
			[
				16,
				-216
			],
			[
				44,
				1
			],
			[
				73,
				78
			],
			[
				46,
				-19
			],
			[
				77,
				-150
			],
			[
				119,
				-48
			],
			[
				76,
				128
			],
			[
				90,
				79
			],
			[
				67,
				83
			],
			[
				55,
				-15
			],
			[
				62,
				-130
			],
			[
				33,
				-163
			],
			[
				114,
				-248
			],
			[
				-57,
				-152
			],
			[
				-11,
				-192
			],
			[
				59,
				58
			],
			[
				35,
				-69
			],
			[
				-15,
				-176
			],
			[
				85,
				-170
			]
		],
		[
			[
				45321,
				58350
			],
			[
				36,
				262
			]
		],
		[
			[
				45357,
				58612
			],
			[
				302,
				17
			],
			[
				63,
				140
			],
			[
				88,
				9
			],
			[
				110,
				-145
			],
			[
				86,
				-3
			],
			[
				92,
				99
			],
			[
				56,
				-170
			],
			[
				-120,
				-133
			],
			[
				-121,
				11
			],
			[
				-119,
				124
			],
			[
				-103,
				-136
			],
			[
				-50,
				-5
			],
			[
				-67,
				-83
			],
			[
				-253,
				13
			]
		],
		[
			[
				45797,
				57103
			],
			[
				-149,
				247
			],
			[
				-117,
				39
			],
			[
				-63,
				166
			],
			[
				1,
				90
			],
			[
				-84,
				125
			],
			[
				-18,
				127
			]
		],
		[
			[
				45367,
				57897
			],
			[
				147,
				96
			],
			[
				92,
				-19
			],
			[
				75,
				67
			],
			[
				513,
				-25
			]
		],
		[
			[
				52636,
				51176
			],
			[
				-52,
				90
			],
			[
				96,
				663
			]
		],
		[
			[
				56583,
				71675
			],
			[
				152,
				-199
			],
			[
				216,
				34
			],
			[
				207,
				-42
			],
			[
				-7,
				-103
			],
			[
				151,
				71
			],
			[
				-35,
				-175
			],
			[
				-400,
				-50
			],
			[
				3,
				98
			],
			[
				-339,
				115
			],
			[
				52,
				251
			]
		],
		[
			[
				57237,
				74699
			],
			[
				-169,
				17
			],
			[
				-145,
				56
			],
			[
				-336,
				-154
			],
			[
				192,
				-332
			],
			[
				-141,
				-96
			],
			[
				-154,
				-1
			],
			[
				-147,
				305
			],
			[
				-52,
				-130
			],
			[
				62,
				-353
			],
			[
				139,
				-277
			],
			[
				-105,
				-129
			],
			[
				155,
				-273
			],
			[
				137,
				-171
			],
			[
				4,
				-334
			],
			[
				-257,
				157
			],
			[
				82,
				-302
			],
			[
				-176,
				-62
			],
			[
				105,
				-521
			],
			[
				-184,
				-8
			],
			[
				-228,
				257
			],
			[
				-104,
				473
			],
			[
				-49,
				393
			],
			[
				-108,
				272
			],
			[
				-143,
				337
			],
			[
				-18,
				168
			]
		],
		[
			[
				55838,
				74710
			],
			[
				182,
				53
			],
			[
				106,
				129
			],
			[
				150,
				-12
			],
			[
				46,
				103
			],
			[
				53,
				20
			]
		],
		[
			[
				57254,
				75292
			],
			[
				135,
				-157
			],
			[
				-86,
				-369
			],
			[
				-66,
				-67
			]
		],
		[
			[
				37010,
				99398
			],
			[
				932,
				353
			],
			[
				975,
				-27
			],
			[
				354,
				218
			],
			[
				982,
				57
			],
			[
				2219,
				-74
			],
			[
				1737,
				-469
			],
			[
				-513,
				-227
			],
			[
				-1062,
				-26
			],
			[
				-1496,
				-58
			],
			[
				140,
				-105
			],
			[
				984,
				65
			],
			[
				836,
				-204
			],
			[
				540,
				181
			],
			[
				231,
				-212
			],
			[
				-305,
				-344
			],
			[
				707,
				220
			],
			[
				1348,
				229
			],
			[
				833,
				-114
			],
			[
				156,
				-253
			],
			[
				-1132,
				-420
			],
			[
				-157,
				-136
			],
			[
				-888,
				-102
			],
			[
				643,
				-28
			],
			[
				-324,
				-431
			],
			[
				-224,
				-383
			],
			[
				9,
				-658
			],
			[
				333,
				-386
			],
			[
				-434,
				-24
			],
			[
				-457,
				-187
			],
			[
				513,
				-313
			],
			[
				65,
				-502
			],
			[
				-297,
				-55
			],
			[
				360,
				-508
			],
			[
				-617,
				-42
			],
			[
				322,
				-241
			],
			[
				-91,
				-208
			],
			[
				-391,
				-91
			],
			[
				-388,
				-2
			],
			[
				348,
				-400
			],
			[
				4,
				-263
			],
			[
				-549,
				244
			],
			[
				-143,
				-158
			],
			[
				375,
				-148
			],
			[
				364,
				-361
			],
			[
				105,
				-476
			],
			[
				-495,
				-114
			],
			[
				-214,
				228
			],
			[
				-344,
				340
			],
			[
				95,
				-401
			],
			[
				-322,
				-311
			],
			[
				732,
				-25
			],
			[
				383,
				-32
			],
			[
				-745,
				-515
			],
			[
				-755,
				-466
			],
			[
				-813,
				-204
			],
			[
				-306,
				-2
			],
			[
				-288,
				-228
			],
			[
				-386,
				-624
			],
			[
				-597,
				-414
			],
			[
				-192,
				-24
			],
			[
				-370,
				-145
			],
			[
				-399,
				-138
			],
			[
				-238,
				-365
			],
			[
				-4,
				-415
			],
			[
				-141,
				-388
			],
			[
				-453,
				-472
			],
			[
				112,
				-462
			],
			[
				-125,
				-488
			],
			[
				-142,
				-577
			],
			[
				-391,
				-36
			],
			[
				-410,
				482
			],
			[
				-556,
				3
			],
			[
				-269,
				324
			],
			[
				-186,
				577
			],
			[
				-481,
				735
			],
			[
				-141,
				385
			],
			[
				-38,
				530
			],
			[
				-384,
				546
			],
			[
				100,
				435
			],
			[
				-186,
				208
			],
			[
				275,
				691
			],
			[
				418,
				220
			],
			[
				110,
				247
			],
			[
				58,
				461
			],
			[
				-318,
				-209
			],
			[
				-151,
				-88
			],
			[
				-249,
				-84
			],
			[
				-341,
				193
			],
			[
				-19,
				401
			],
			[
				109,
				314
			],
			[
				258,
				9
			],
			[
				567,
				-157
			],
			[
				-478,
				375
			],
			[
				-249,
				202
			],
			[
				-276,
				-83
			],
			[
				-232,
				147
			],
			[
				310,
				550
			],
			[
				-169,
				220
			],
			[
				-220,
				409
			],
			[
				-335,
				626
			],
			[
				-353,
				230
			],
			[
				3,
				247
			],
			[
				-745,
				346
			],
			[
				-590,
				43
			],
			[
				-743,
				-24
			],
			[
				-677,
				-44
			],
			[
				-323,
				188
			],
			[
				-482,
				372
			],
			[
				729,
				186
			],
			[
				559,
				31
			],
			[
				-1188,
				154
			],
			[
				-627,
				241
			],
			[
				39,
				229
			],
			[
				1051,
				285
			],
			[
				1018,
				284
			],
			[
				107,
				214
			],
			[
				-750,
				213
			],
			[
				243,
				235
			],
			[
				961,
				413
			],
			[
				404,
				63
			],
			[
				-115,
				265
			],
			[
				658,
				156
			],
			[
				854,
				93
			],
			[
				853,
				5
			],
			[
				303,
				-184
			],
			[
				737,
				325
			],
			[
				663,
				-221
			],
			[
				390,
				-46
			],
			[
				577,
				-192
			],
			[
				-660,
				318
			],
			[
				38,
				253
			]
		],
		[
			[
				24973,
				58695
			],
			[
				-142,
				103
			],
			[
				-174,
				11
			],
			[
				-127,
				117
			],
			[
				-149,
				244
			]
		],
		[
			[
				24381,
				59170
			],
			[
				7,
				172
			],
			[
				32,
				138
			],
			[
				-39,
				111
			],
			[
				133,
				481
			],
			[
				357,
				2
			],
			[
				7,
				201
			],
			[
				-45,
				36
			],
			[
				-31,
				128
			],
			[
				-103,
				136
			],
			[
				-103,
				198
			],
			[
				125,
				1
			],
			[
				1,
				333
			],
			[
				259,
				1
			],
			[
				257,
				-7
			]
		],
		[
			[
				25297,
				59966
			],
			[
				90,
				-107
			],
			[
				24,
				88
			],
			[
				82,
				-75
			]
		],
		[
			[
				25493,
				59872
			],
			[
				-127,
				-225
			],
			[
				-131,
				-166
			],
			[
				-20,
				-113
			],
			[
				22,
				-116
			],
			[
				-58,
				-150
			]
		],
		[
			[
				25179,
				59102
			],
			[
				-65,
				-37
			],
			[
				15,
				-69
			],
			[
				-52,
				-66
			],
			[
				-95,
				-149
			],
			[
				-9,
				-86
			]
		],
		[
			[
				33400,
				55523
			],
			[
				183,
				-217
			],
			[
				171,
				-385
			],
			[
				8,
				-304
			],
			[
				105,
				-14
			],
			[
				149,
				-289
			],
			[
				109,
				-205
			]
		],
		[
			[
				34125,
				54109
			],
			[
				-44,
				-532
			],
			[
				-169,
				-154
			],
			[
				15,
				-139
			],
			[
				-51,
				-305
			],
			[
				123,
				-429
			],
			[
				89,
				-1
			],
			[
				37,
				-333
			],
			[
				169,
				-514
			]
		],
		[
			[
				33129,
				53652
			],
			[
				-188,
				448
			],
			[
				75,
				163
			],
			[
				-5,
				273
			],
			[
				171,
				95
			],
			[
				69,
				110
			],
			[
				-95,
				220
			],
			[
				24,
				215
			],
			[
				220,
				347
			]
		],
		[
			[
				25745,
				58251
			],
			[
				-48,
				185
			],
			[
				-84,
				51
			]
		],
		[
			[
				25613,
				58487
			],
			[
				19,
				237
			],
			[
				-38,
				64
			],
			[
				-57,
				42
			],
			[
				-122,
				-70
			],
			[
				-10,
				79
			],
			[
				-84,
				95
			],
			[
				-60,
				118
			],
			[
				-82,
				50
			]
		],
		[
			[
				25493,
				59872
			],
			[
				29,
				-23
			],
			[
				61,
				104
			],
			[
				79,
				8
			],
			[
				26,
				-48
			],
			[
				43,
				29
			],
			[
				129,
				-53
			],
			[
				128,
				15
			],
			[
				90,
				66
			],
			[
				32,
				66
			],
			[
				89,
				-31
			],
			[
				66,
				-40
			],
			[
				73,
				14
			],
			[
				55,
				51
			],
			[
				127,
				-82
			],
			[
				44,
				-13
			],
			[
				85,
				-110
			],
			[
				80,
				-132
			],
			[
				101,
				-91
			],
			[
				73,
				-162
			]
		],
		[
			[
				26903,
				59440
			],
			[
				-95,
				12
			],
			[
				-38,
				-81
			],
			[
				-97,
				-77
			],
			[
				-70,
				0
			],
			[
				-61,
				-76
			],
			[
				-56,
				27
			],
			[
				-47,
				90
			],
			[
				-29,
				-17
			],
			[
				-36,
				-141
			],
			[
				-27,
				5
			],
			[
				-4,
				-121
			],
			[
				-97,
				-163
			],
			[
				-51,
				-70
			],
			[
				-29,
				-74
			],
			[
				-82,
				120
			],
			[
				-60,
				-158
			],
			[
				-58,
				4
			],
			[
				-65,
				-14
			],
			[
				6,
				-290
			],
			[
				-41,
				-5
			],
			[
				-35,
				-135
			],
			[
				-86,
				-25
			]
		],
		[
			[
				55230,
				77704
			],
			[
				67,
				-229
			],
			[
				89,
				-169
			],
			[
				-107,
				-222
			]
		],
		[
			[
				55155,
				75778
			],
			[
				-31,
				-100
			]
		],
		[
			[
				55124,
				75678
			],
			[
				-261,
				218
			],
			[
				-161,
				213
			],
			[
				-254,
				176
			],
			[
				-233,
				434
			],
			[
				56,
				45
			],
			[
				-127,
				248
			],
			[
				-5,
				200
			],
			[
				-179,
				93
			],
			[
				-85,
				-255
			],
			[
				-82,
				198
			],
			[
				6,
				205
			],
			[
				10,
				9
			]
		],
		[
			[
				53809,
				77462
			],
			[
				194,
				-20
			],
			[
				51,
				100
			],
			[
				94,
				-97
			],
			[
				109,
				-11
			],
			[
				-1,
				165
			],
			[
				97,
				60
			],
			[
				27,
				239
			],
			[
				221,
				157
			]
		],
		[
			[
				54601,
				78055
			],
			[
				88,
				-73
			],
			[
				208,
				-253
			],
			[
				229,
				-114
			],
			[
				104,
				89
			]
		],
		[
			[
				30081,
				61241
			],
			[
				-185,
				100
			],
			[
				-131,
				-41
			],
			[
				-169,
				43
			],
			[
				-130,
				-110
			],
			[
				-149,
				184
			],
			[
				24,
				190
			],
			[
				256,
				-82
			],
			[
				210,
				-47
			],
			[
				100,
				131
			],
			[
				-127,
				256
			],
			[
				2,
				226
			],
			[
				-175,
				92
			],
			[
				62,
				163
			],
			[
				170,
				-26
			],
			[
				241,
				-93
			]
		],
		[
			[
				54716,
				79012
			],
			[
				141,
				-151
			],
			[
				103,
				-65
			],
			[
				233,
				73
			],
			[
				22,
				118
			],
			[
				111,
				18
			],
			[
				135,
				92
			],
			[
				30,
				-38
			],
			[
				130,
				74
			],
			[
				66,
				139
			],
			[
				91,
				36
			],
			[
				297,
				-180
			],
			[
				59,
				61
			]
		],
		[
			[
				56134,
				79189
			],
			[
				155,
				-161
			],
			[
				19,
				-159
			]
		],
		[
			[
				56308,
				78869
			],
			[
				-170,
				-123
			],
			[
				-131,
				-401
			],
			[
				-168,
				-401
			],
			[
				-223,
				-111
			]
		],
		[
			[
				55616,
				77833
			],
			[
				-173,
				26
			],
			[
				-213,
				-155
			]
		],
		[
			[
				54601,
				78055
			],
			[
				-54,
				200
			],
			[
				-47,
				6
			]
		],
		[
			[
				83531,
				44530
			],
			[
				-117,
				-11
			],
			[
				-368,
				414
			],
			[
				259,
				116
			],
			[
				146,
				-180
			],
			[
				97,
				-180
			],
			[
				-17,
				-159
			]
		],
		[
			[
				84713,
				45326
			],
			[
				28,
				-117
			],
			[
				5,
				-179
			]
		],
		[
			[
				84746,
				45030
			],
			[
				-181,
				-441
			],
			[
				-238,
				-130
			],
			[
				-33,
				71
			],
			[
				25,
				201
			],
			[
				119,
				360
			],
			[
				275,
				235
			]
		],
		[
			[
				82749,
				45797
			],
			[
				100,
				-158
			],
			[
				172,
				48
			],
			[
				69,
				-251
			],
			[
				-321,
				-119
			],
			[
				-193,
				-79
			],
			[
				-149,
				5
			],
			[
				95,
				340
			],
			[
				153,
				5
			],
			[
				74,
				209
			]
		],
		[
			[
				84139,
				45797
			],
			[
				-41,
				-328
			],
			[
				-417,
				-168
			],
			[
				-370,
				73
			],
			[
				0,
				216
			],
			[
				220,
				123
			],
			[
				174,
				-177
			],
			[
				185,
				45
			],
			[
				249,
				216
			]
		],
		[
			[
				80172,
				46575
			],
			[
				533,
				-59
			],
			[
				61,
				244
			],
			[
				515,
				-284
			],
			[
				101,
				-383
			],
			[
				417,
				-108
			],
			[
				341,
				-351
			],
			[
				-317,
				-225
			],
			[
				-306,
				238
			],
			[
				-251,
				-16
			],
			[
				-288,
				44
			],
			[
				-260,
				106
			],
			[
				-322,
				225
			],
			[
				-204,
				59
			],
			[
				-116,
				-74
			],
			[
				-506,
				243
			],
			[
				-48,
				254
			],
			[
				-255,
				44
			],
			[
				191,
				564
			],
			[
				337,
				-35
			],
			[
				224,
				-231
			],
			[
				115,
				-45
			],
			[
				38,
				-210
			]
		],
		[
			[
				87423,
				46908
			],
			[
				-143,
				-402
			],
			[
				-27,
				445
			],
			[
				49,
				212
			],
			[
				58,
				200
			],
			[
				63,
				-173
			],
			[
				0,
				-282
			]
		],
		[
			[
				85346,
				48536
			],
			[
				-104,
				-196
			],
			[
				-192,
				108
			],
			[
				-54,
				254
			],
			[
				281,
				29
			],
			[
				69,
				-195
			]
		],
		[
			[
				86241,
				48752
			],
			[
				101,
				-452
			],
			[
				-234,
				244
			],
			[
				-232,
				49
			],
			[
				-157,
				-39
			],
			[
				-192,
				21
			],
			[
				65,
				325
			],
			[
				344,
				24
			],
			[
				305,
				-172
			]
		],
		[
			[
				89166,
				49043
			],
			[
				5,
				-1925
			],
			[
				4,
				-1925
			]
		],
		[
			[
				89175,
				45193
			],
			[
				-247,
				485
			],
			[
				-282,
				118
			],
			[
				-69,
				-168
			],
			[
				-352,
				-18
			],
			[
				118,
				481
			],
			[
				175,
				164
			],
			[
				-72,
				642
			],
			[
				-134,
				496
			],
			[
				-538,
				500
			],
			[
				-229,
				50
			],
			[
				-417,
				546
			],
			[
				-82,
				-287
			],
			[
				-107,
				-52
			],
			[
				-63,
				216
			],
			[
				-1,
				257
			],
			[
				-212,
				290
			],
			[
				299,
				213
			],
			[
				198,
				-11
			],
			[
				-23,
				156
			],
			[
				-407,
				1
			],
			[
				-110,
				352
			],
			[
				-248,
				109
			],
			[
				-117,
				293
			],
			[
				374,
				143
			],
			[
				142,
				192
			],
			[
				446,
				-242
			],
			[
				44,
				-220
			],
			[
				78,
				-955
			],
			[
				287,
				-354
			],
			[
				232,
				627
			],
			[
				319,
				356
			],
			[
				247,
				1
			],
			[
				238,
				-206
			],
			[
				206,
				-212
			],
			[
				298,
				-113
			]
		],
		[
			[
				84788,
				51419
			],
			[
				-223,
				-587
			],
			[
				-209,
				-113
			],
			[
				-267,
				115
			],
			[
				-463,
				-29
			],
			[
				-243,
				-85
			],
			[
				-39,
				-447
			],
			[
				248,
				-526
			],
			[
				150,
				268
			],
			[
				518,
				201
			],
			[
				-22,
				-272
			],
			[
				-121,
				86
			],
			[
				-121,
				-347
			],
			[
				-245,
				-229
			],
			[
				263,
				-757
			],
			[
				-50,
				-203
			],
			[
				249,
				-682
			],
			[
				-2,
				-388
			],
			[
				-148,
				-173
			],
			[
				-109,
				207
			],
			[
				134,
				484
			],
			[
				-273,
				-229
			],
			[
				-69,
				164
			],
			[
				36,
				228
			],
			[
				-200,
				346
			],
			[
				21,
				576
			],
			[
				-186,
				-179
			],
			[
				24,
				-689
			],
			[
				11,
				-846
			],
			[
				-176,
				-85
			],
			[
				-119,
				173
			],
			[
				79,
				544
			],
			[
				-43,
				570
			],
			[
				-117,
				4
			],
			[
				-86,
				405
			],
			[
				115,
				387
			],
			[
				40,
				469
			],
			[
				139,
				891
			],
			[
				58,
				243
			],
			[
				237,
				439
			],
			[
				217,
				-174
			],
			[
				350,
				-82
			],
			[
				319,
				25
			],
			[
				275,
				429
			],
			[
				48,
				-132
			]
		],
		[
			[
				85746,
				51249
			],
			[
				-15,
				-517
			],
			[
				-143,
				58
			],
			[
				-42,
				-359
			],
			[
				114,
				-312
			],
			[
				-78,
				-71
			],
			[
				-112,
				374
			],
			[
				-82,
				755
			],
			[
				56,
				472
			],
			[
				92,
				215
			],
			[
				20,
				-322
			],
			[
				164,
				-52
			],
			[
				26,
				-241
			]
		],
		[
			[
				80461,
				51765
			],
			[
				47,
				-395
			],
			[
				190,
				-334
			],
			[
				179,
				121
			],
			[
				177,
				-43
			],
			[
				162,
				299
			],
			[
				133,
				52
			],
			[
				263,
				-166
			],
			[
				226,
				126
			],
			[
				143,
				822
			],
			[
				107,
				205
			],
			[
				96,
				672
			],
			[
				319,
				0
			],
			[
				241,
				-100
			]
		],
		[
			[
				82744,
				53024
			],
			[
				-158,
				-533
			],
			[
				204,
				-560
			],
			[
				-48,
				-272
			],
			[
				312,
				-546
			],
			[
				-329,
				-70
			],
			[
				-93,
				-403
			],
			[
				12,
				-535
			],
			[
				-267,
				-404
			],
			[
				-7,
				-589
			],
			[
				-107,
				-903
			],
			[
				-41,
				210
			],
			[
				-316,
				-266
			],
			[
				-110,
				361
			],
			[
				-198,
				34
			],
			[
				-139,
				189
			],
			[
				-330,
				-212
			],
			[
				-101,
				285
			],
			[
				-182,
				-32
			],
			[
				-229,
				68
			],
			[
				-43,
				793
			],
			[
				-138,
				164
			],
			[
				-134,
				505
			],
			[
				-38,
				517
			],
			[
				32,
				548
			],
			[
				165,
				392
			]
		],
		[
			[
				79393,
				47122
			],
			[
				-308,
				-12
			],
			[
				-234,
				494
			],
			[
				-356,
				482
			],
			[
				-119,
				358
			],
			[
				-210,
				481
			],
			[
				-138,
				443
			],
			[
				-212,
				827
			],
			[
				-244,
				493
			],
			[
				-81,
				508
			],
			[
				-103,
				461
			],
			[
				-250,
				372
			],
			[
				-145,
				506
			],
			[
				-209,
				330
			],
			[
				-290,
				652
			],
			[
				-24,
				300
			],
			[
				178,
				-24
			],
			[
				430,
				-114
			],
			[
				246,
				-577
			],
			[
				215,
				-401
			],
			[
				153,
				-246
			],
			[
				263,
				-635
			],
			[
				283,
				-9
			],
			[
				233,
				-405
			],
			[
				161,
				-495
			],
			[
				211,
				-270
			],
			[
				-111,
				-482
			],
			[
				159,
				-205
			],
			[
				100,
				-15
			],
			[
				47,
				-412
			],
			[
				97,
				-330
			],
			[
				204,
				-52
			],
			[
				135,
				-374
			],
			[
				-70,
				-735
			],
			[
				-11,
				-914
			]
		],
		[
			[
				72530,
				68413
			],
			[
				-176,
				-268
			],
			[
				-108,
				-553
			],
			[
				269,
				-224
			],
			[
				262,
				-289
			],
			[
				362,
				-332
			],
			[
				381,
				-76
			],
			[
				160,
				-301
			],
			[
				215,
				-56
			],
			[
				334,
				-138
			],
			[
				231,
				10
			],
			[
				32,
				234
			],
			[
				-36,
				375
			],
			[
				21,
				255
			]
		],
		[
			[
				77035,
				67277
			],
			[
				20,
				-224
			],
			[
				-97,
				-108
			],
			[
				23,
				-364
			],
			[
				-199,
				107
			],
			[
				-359,
				-408
			],
			[
				8,
				-338
			],
			[
				-153,
				-496
			],
			[
				-14,
				-288
			],
			[
				-124,
				-487
			],
			[
				-217,
				135
			],
			[
				-11,
				-612
			],
			[
				-63,
				-201
			],
			[
				30,
				-251
			],
			[
				-137,
				-140
			]
		],
		[
			[
				74730,
				63611
			],
			[
				-39,
				-216
			],
			[
				-189,
				7
			],
			[
				-343,
				-122
			],
			[
				16,
				-445
			],
			[
				-148,
				-349
			],
			[
				-400,
				-398
			],
			[
				-311,
				-695
			],
			[
				-209,
				-373
			],
			[
				-276,
				-387
			],
			[
				-1,
				-271
			],
			[
				-138,
				-146
			],
			[
				-251,
				-212
			],
			[
				-129,
				-31
			],
			[
				-84,
				-450
			],
			[
				58,
				-769
			],
			[
				15,
				-490
			],
			[
				-118,
				-561
			],
			[
				-1,
				-1004
			],
			[
				-144,
				-29
			],
			[
				-126,
				-450
			],
			[
				84,
				-195
			],
			[
				-253,
				-168
			],
			[
				-93,
				-401
			],
			[
				-112,
				-170
			],
			[
				-263,
				552
			],
			[
				-128,
				827
			],
			[
				-107,
				596
			],
			[
				-97,
				279
			],
			[
				-148,
				568
			],
			[
				-69,
				739
			],
			[
				-48,
				369
			],
			[
				-253,
				811
			],
			[
				-115,
				1145
			],
			[
				-83,
				756
			],
			[
				1,
				716
			],
			[
				-54,
				553
			],
			[
				-404,
				-353
			],
			[
				-196,
				70
			],
			[
				-362,
				716
			],
			[
				133,
				214
			],
			[
				-82,
				232
			],
			[
				-326,
				501
			]
		],
		[
			[
				68937,
				64577
			],
			[
				185,
				395
			],
			[
				612,
				-2
			],
			[
				-56,
				507
			],
			[
				-156,
				300
			],
			[
				-31,
				455
			],
			[
				-182,
				265
			],
			[
				306,
				619
			],
			[
				323,
				-45
			],
			[
				290,
				620
			],
			[
				174,
				599
			],
			[
				270,
				593
			],
			[
				-4,
				421
			],
			[
				236,
				342
			],
			[
				-224,
				292
			],
			[
				-96,
				400
			],
			[
				-99,
				517
			],
			[
				137,
				255
			],
			[
				421,
				-144
			],
			[
				310,
				88
			],
			[
				268,
				496
			]
		],
		[
			[
				48278,
				82406
			],
			[
				46,
				-422
			],
			[
				-210,
				-528
			],
			[
				-493,
				-349
			],
			[
				-393,
				89
			],
			[
				225,
				617
			],
			[
				-145,
				601
			],
			[
				378,
				463
			],
			[
				210,
				276
			]
		],
		[
			[
				64978,
				72558
			],
			[
				244,
				114
			],
			[
				197,
				338
			],
			[
				186,
				-17
			],
			[
				122,
				110
			],
			[
				197,
				-55
			],
			[
				308,
				-299
			],
			[
				221,
				-65
			],
			[
				318,
				-523
			],
			[
				207,
				-21
			],
			[
				24,
				-498
			]
		],
		[
			[
				66909,
				68203
			],
			[
				137,
				-310
			],
			[
				112,
				-357
			],
			[
				266,
				-260
			],
			[
				7,
				-520
			],
			[
				133,
				-96
			],
			[
				23,
				-272
			],
			[
				-400,
				-305
			],
			[
				-105,
				-687
			]
		],
		[
			[
				67082,
				65396
			],
			[
				-523,
				179
			],
			[
				-303,
				136
			],
			[
				-313,
				76
			],
			[
				-118,
				725
			],
			[
				-133,
				105
			],
			[
				-214,
				-106
			],
			[
				-280,
				-286
			],
			[
				-339,
				196
			],
			[
				-281,
				454
			],
			[
				-267,
				168
			],
			[
				-186,
				561
			],
			[
				-205,
				788
			],
			[
				-149,
				-96
			],
			[
				-177,
				196
			],
			[
				-104,
				-231
			]
		],
		[
			[
				63490,
				68261
			],
			[
				-153,
				311
			],
			[
				-3,
				314
			],
			[
				-89,
				0
			],
			[
				46,
				428
			],
			[
				-143,
				449
			],
			[
				-340,
				324
			],
			[
				-193,
				562
			],
			[
				65,
				461
			],
			[
				139,
				204
			],
			[
				-21,
				345
			],
			[
				-182,
				177
			],
			[
				-180,
				705
			]
		],
		[
			[
				62436,
				72541
			],
			[
				-152,
				473
			],
			[
				55,
				183
			],
			[
				-87,
				678
			],
			[
				190,
				168
			]
		],
		[
			[
				63578,
				73220
			],
			[
				88,
				-436
			],
			[
				263,
				-123
			],
			[
				193,
				-296
			],
			[
				395,
				-102
			],
			[
				434,
				156
			],
			[
				27,
				139
			]
		],
		[
			[
				63490,
				68261
			],
			[
				-164,
				29
			]
		],
		[
			[
				63326,
				68290
			],
			[
				-187,
				49
			],
			[
				-204,
				-567
			]
		],
		[
			[
				62935,
				67772
			],
			[
				-516,
				47
			],
			[
				-784,
				1188
			],
			[
				-413,
				414
			],
			[
				-335,
				160
			]
		],
		[
			[
				60887,
				69581
			],
			[
				-112,
				720
			]
		],
		[
			[
				60775,
				70301
			],
			[
				615,
				614
			],
			[
				105,
				715
			],
			[
				-26,
				431
			],
			[
				152,
				146
			],
			[
				142,
				369
			]
		],
		[
			[
				61763,
				72576
			],
			[
				119,
				92
			],
			[
				324,
				-77
			],
			[
				97,
				-150
			],
			[
				133,
				100
			]
		],
		[
			[
				45969,
				89843
			],
			[
				-64,
				-382
			],
			[
				314,
				-403
			],
			[
				-361,
				-451
			],
			[
				-801,
				-405
			],
			[
				-240,
				-107
			],
			[
				-365,
				87
			],
			[
				-775,
				187
			],
			[
				273,
				261
			],
			[
				-605,
				289
			],
			[
				492,
				114
			],
			[
				-12,
				174
			],
			[
				-583,
				137
			],
			[
				188,
				385
			],
			[
				421,
				87
			],
			[
				433,
				-400
			],
			[
				422,
				321
			],
			[
				349,
				-167
			],
			[
				453,
				315
			],
			[
				461,
				-42
			]
		],
		[
			[
				59922,
				69905
			],
			[
				-49,
				-186
			]
		],
		[
			[
				59873,
				69719
			],
			[
				-100,
				82
			],
			[
				-58,
				-394
			],
			[
				69,
				-66
			],
			[
				-71,
				-81
			],
			[
				-12,
				-156
			],
			[
				131,
				80
			]
		],
		[
			[
				59832,
				69184
			],
			[
				7,
				-230
			],
			[
				-139,
				-944
			]
		],
		[
			[
				59518,
				69025
			],
			[
				80,
				194
			],
			[
				-19,
				34
			],
			[
				74,
				276
			],
			[
				56,
				446
			],
			[
				40,
				149
			],
			[
				8,
				6
			]
		],
		[
			[
				59757,
				70130
			],
			[
				93,
				-1
			],
			[
				25,
				104
			],
			[
				75,
				8
			]
		],
		[
			[
				59950,
				70241
			],
			[
				4,
				-242
			],
			[
				-38,
				-90
			],
			[
				6,
				-4
			]
		],
		[
			[
				54311,
				73167
			],
			[
				-100,
				-465
			],
			[
				41,
				-183
			],
			[
				-58,
				-303
			],
			[
				-213,
				222
			],
			[
				-141,
				64
			],
			[
				-387,
				300
			],
			[
				38,
				304
			],
			[
				325,
				-54
			],
			[
				284,
				64
			],
			[
				211,
				51
			]
		],
		[
			[
				52558,
				74927
			],
			[
				166,
				-419
			],
			[
				-39,
				-782
			],
			[
				-126,
				38
			],
			[
				-113,
				-197
			],
			[
				-105,
				156
			],
			[
				-11,
				713
			],
			[
				-64,
				338
			],
			[
				153,
				-30
			],
			[
				139,
				183
			]
		],
		[
			[
				53835,
				78058
			],
			[
				-31,
				-291
			],
			[
				67,
				-251
			]
		],
		[
			[
				53871,
				77516
			],
			[
				-221,
				86
			],
			[
				-226,
				-210
			],
			[
				15,
				-293
			],
			[
				-34,
				-168
			],
			[
				91,
				-301
			],
			[
				261,
				-298
			],
			[
				140,
				-488
			],
			[
				309,
				-476
			],
			[
				217,
				3
			],
			[
				68,
				-130
			],
			[
				-78,
				-118
			],
			[
				249,
				-214
			],
			[
				204,
				-178
			],
			[
				238,
				-308
			],
			[
				29,
				-111
			],
			[
				-52,
				-211
			],
			[
				-154,
				276
			],
			[
				-242,
				97
			],
			[
				-116,
				-382
			],
			[
				200,
				-219
			],
			[
				-33,
				-309
			],
			[
				-116,
				-35
			],
			[
				-148,
				-506
			],
			[
				-116,
				-46
			],
			[
				1,
				181
			],
			[
				57,
				317
			],
			[
				60,
				126
			],
			[
				-108,
				342
			],
			[
				-85,
				298
			],
			[
				-115,
				74
			],
			[
				-82,
				255
			],
			[
				-179,
				107
			],
			[
				-120,
				238
			],
			[
				-206,
				38
			],
			[
				-217,
				267
			],
			[
				-254,
				384
			],
			[
				-189,
				340
			],
			[
				-86,
				585
			],
			[
				-138,
				68
			],
			[
				-226,
				195
			],
			[
				-128,
				-80
			],
			[
				-161,
				-274
			],
			[
				-115,
				-43
			]
		],
		[
			[
				28453,
				61504
			],
			[
				187,
				-53
			],
			[
				147,
				-142
			],
			[
				46,
				-161
			],
			[
				-195,
				-11
			],
			[
				-84,
				-99
			],
			[
				-156,
				95
			],
			[
				-159,
				215
			],
			[
				34,
				135
			],
			[
				116,
				41
			],
			[
				64,
				-20
			]
		],
		[
			[
				59922,
				69905
			],
			[
				309,
				-234
			],
			[
				544,
				630
			]
		],
		[
			[
				60887,
				69581
			],
			[
				-53,
				-89
			],
			[
				-556,
				-296
			],
			[
				277,
				-591
			],
			[
				-92,
				-101
			],
			[
				-46,
				-197
			],
			[
				-212,
				-82
			],
			[
				-66,
				-213
			],
			[
				-120,
				-182
			],
			[
				-310,
				94
			]
		],
		[
			[
				59709,
				67924
			],
			[
				-9,
				86
			]
		],
		[
			[
				59832,
				69184
			],
			[
				41,
				173
			],
			[
				0,
				362
			]
		],
		[
			[
				87399,
				70756
			],
			[
				35,
				-203
			],
			[
				-156,
				-357
			],
			[
				-114,
				189
			],
			[
				-143,
				-137
			],
			[
				-73,
				-346
			],
			[
				-181,
				168
			],
			[
				2,
				281
			],
			[
				154,
				352
			],
			[
				158,
				-68
			],
			[
				114,
				248
			],
			[
				204,
				-127
			]
		],
		[
			[
				89159,
				72524
			],
			[
				-104,
				-472
			],
			[
				48,
				-296
			],
			[
				-145,
				-416
			],
			[
				-355,
				-278
			],
			[
				-488,
				-36
			],
			[
				-396,
				-675
			],
			[
				-186,
				227
			],
			[
				-12,
				442
			],
			[
				-483,
				-130
			],
			[
				-329,
				-279
			],
			[
				-325,
				-11
			],
			[
				282,
				-435
			],
			[
				-186,
				-1004
			],
			[
				-179,
				-248
			],
			[
				-135,
				229
			],
			[
				69,
				533
			],
			[
				-176,
				172
			],
			[
				-113,
				405
			],
			[
				263,
				182
			],
			[
				145,
				371
			],
			[
				280,
				306
			],
			[
				203,
				403
			],
			[
				553,
				177
			],
			[
				297,
				-121
			],
			[
				291,
				1050
			],
			[
				185,
				-282
			],
			[
				408,
				591
			],
			[
				158,
				229
			],
			[
				174,
				723
			],
			[
				-47,
				664
			],
			[
				117,
				374
			],
			[
				295,
				108
			],
			[
				152,
				-819
			],
			[
				-9,
				-479
			],
			[
				-256,
				-595
			],
			[
				4,
				-610
			]
		],
		[
			[
				89974,
				76679
			],
			[
				195,
				-126
			],
			[
				197,
				250
			],
			[
				62,
				-663
			],
			[
				-412,
				-162
			],
			[
				-244,
				-587
			],
			[
				-436,
				404
			],
			[
				-152,
				-646
			],
			[
				-308,
				-9
			],
			[
				-39,
				587
			],
			[
				138,
				455
			],
			[
				296,
				33
			],
			[
				81,
				817
			],
			[
				83,
				460
			],
			[
				326,
				-615
			],
			[
				213,
				-198
			]
		],
		[
			[
				69711,
				75551
			],
			[
				-159,
				-109
			],
			[
				-367,
				-412
			],
			[
				-121,
				-422
			],
			[
				-104,
				-4
			],
			[
				-76,
				280
			],
			[
				-353,
				19
			],
			[
				-57,
				484
			],
			[
				-135,
				4
			],
			[
				21,
				593
			],
			[
				-333,
				431
			],
			[
				-476,
				-46
			],
			[
				-326,
				-86
			],
			[
				-265,
				533
			],
			[
				-227,
				223
			],
			[
				-431,
				423
			],
			[
				-52,
				51
			],
			[
				-715,
				-349
			],
			[
				11,
				-2178
			]
		],
		[
			[
				65546,
				74986
			],
			[
				-142,
				-29
			],
			[
				-195,
				463
			],
			[
				-188,
				166
			],
			[
				-315,
				-123
			],
			[
				-123,
				-197
			]
		],
		[
			[
				64583,
				75266
			],
			[
				-15,
				144
			],
			[
				68,
				246
			],
			[
				-53,
				206
			],
			[
				-322,
				202
			],
			[
				-125,
				530
			],
			[
				-154,
				150
			],
			[
				-9,
				192
			],
			[
				270,
				-56
			],
			[
				11,
				432
			],
			[
				236,
				96
			],
			[
				243,
				-88
			],
			[
				50,
				576
			],
			[
				-50,
				365
			],
			[
				-278,
				-28
			],
			[
				-236,
				144
			],
			[
				-321,
				-260
			],
			[
				-259,
				-124
			]
		],
		[
			[
				63639,
				77993
			],
			[
				-142,
				96
			],
			[
				29,
				304
			],
			[
				-177,
				395
			],
			[
				-207,
				-17
			],
			[
				-235,
				401
			],
			[
				160,
				448
			],
			[
				-81,
				120
			],
			[
				222,
				649
			],
			[
				285,
				-342
			],
			[
				35,
				431
			],
			[
				573,
				643
			],
			[
				434,
				15
			],
			[
				612,
				-409
			],
			[
				329,
				-239
			],
			[
				295,
				249
			],
			[
				440,
				12
			],
			[
				356,
				-306
			],
			[
				80,
				175
			],
			[
				391,
				-25
			],
			[
				69,
				280
			],
			[
				-450,
				406
			],
			[
				267,
				288
			],
			[
				-52,
				161
			],
			[
				266,
				153
			],
			[
				-200,
				405
			],
			[
				127,
				202
			],
			[
				1039,
				205
			],
			[
				136,
				146
			],
			[
				695,
				218
			],
			[
				250,
				245
			],
			[
				499,
				-127
			],
			[
				88,
				-612
			],
			[
				290,
				144
			],
			[
				356,
				-202
			],
			[
				-23,
				-322
			],
			[
				267,
				33
			],
			[
				696,
				558
			],
			[
				-102,
				-185
			],
			[
				355,
				-457
			],
			[
				620,
				-1500
			],
			[
				148,
				309
			],
			[
				383,
				-340
			],
			[
				399,
				151
			],
			[
				154,
				-106
			],
			[
				133,
				-341
			],
			[
				194,
				-115
			],
			[
				119,
				-251
			],
			[
				358,
				79
			],
			[
				147,
				-361
			]
		],
		[
			[
				72294,
				75601
			],
			[
				-171,
				87
			],
			[
				-140,
				212
			],
			[
				-412,
				62
			],
			[
				-461,
				16
			],
			[
				-100,
				-65
			],
			[
				-396,
				248
			],
			[
				-158,
				-122
			],
			[
				-43,
				-349
			],
			[
				-457,
				204
			],
			[
				-183,
				-84
			],
			[
				-62,
				-259
			]
		],
		[
			[
				61551,
				49585
			],
			[
				-195,
				-236
			],
			[
				-68,
				-246
			],
			[
				-104,
				-44
			],
			[
				-40,
				-416
			],
			[
				-89,
				-238
			],
			[
				-54,
				-393
			],
			[
				-112,
				-195
			]
		],
		[
			[
				60889,
				47817
			],
			[
				-399,
				590
			],
			[
				-19,
				343
			],
			[
				-1007,
				1203
			],
			[
				-47,
				65
			]
		],
		[
			[
				59417,
				50018
			],
			[
				-3,
				627
			],
			[
				80,
				239
			],
			[
				137,
				391
			],
			[
				101,
				431
			],
			[
				-123,
				678
			],
			[
				-32,
				296
			],
			[
				-132,
				411
			]
		],
		[
			[
				59445,
				53091
			],
			[
				171,
				352
			],
			[
				188,
				390
			]
		],
		[
			[
				61626,
				52895
			],
			[
				-243,
				-670
			],
			[
				3,
				-2152
			],
			[
				165,
				-488
			]
		],
		[
			[
				70465,
				73876
			],
			[
				-526,
				-89
			],
			[
				-343,
				192
			],
			[
				-301,
				-46
			],
			[
				26,
				340
			],
			[
				303,
				-98
			],
			[
				101,
				182
			]
		],
		[
			[
				69725,
				74357
			],
			[
				212,
				-58
			],
			[
				355,
				425
			],
			[
				-329,
				311
			],
			[
				-198,
				-147
			],
			[
				-205,
				223
			],
			[
				234,
				382
			],
			[
				-83,
				58
			]
		],
		[
			[
				78495,
				57780
			],
			[
				-66,
				713
			],
			[
				178,
				492
			],
			[
				359,
				112
			],
			[
				261,
				-84
			]
		],
		[
			[
				79227,
				59013
			],
			[
				229,
				-232
			],
			[
				126,
				407
			],
			[
				246,
				-217
			]
		],
		[
			[
				79828,
				58971
			],
			[
				64,
				-394
			],
			[
				-34,
				-708
			],
			[
				-467,
				-455
			],
			[
				122,
				-358
			],
			[
				-292,
				-43
			],
			[
				-240,
				-238
			]
		],
		[
			[
				78981,
				56775
			],
			[
				-233,
				87
			],
			[
				-112,
				307
			],
			[
				-141,
				611
			]
		],
		[
			[
				85652,
				73393
			],
			[
				240,
				-697
			],
			[
				68,
				-383
			],
			[
				3,
				-681
			],
			[
				-105,
				-325
			],
			[
				-252,
				-113
			],
			[
				-222,
				-245
			],
			[
				-250,
				-51
			],
			[
				-31,
				322
			],
			[
				51,
				443
			],
			[
				-122,
				615
			],
			[
				206,
				99
			],
			[
				-190,
				506
			]
		],
		[
			[
				85048,
				72883
			],
			[
				17,
				54
			],
			[
				124,
				-21
			],
			[
				108,
				266
			],
			[
				197,
				29
			],
			[
				118,
				39
			],
			[
				40,
				143
			]
		],
		[
			[
				55575,
				75742
			],
			[
				52,
				132
			]
		],
		[
			[
				55627,
				75874
			],
			[
				66,
				43
			],
			[
				38,
				196
			],
			[
				50,
				33
			],
			[
				40,
				-84
			],
			[
				52,
				-36
			],
			[
				36,
				-94
			],
			[
				46,
				-28
			],
			[
				54,
				-110
			],
			[
				39,
				4
			],
			[
				-31,
				-144
			],
			[
				-33,
				-71
			],
			[
				9,
				-44
			]
		],
		[
			[
				55993,
				75539
			],
			[
				-62,
				-23
			],
			[
				-164,
				-91
			],
			[
				-13,
				-121
			],
			[
				-35,
				5
			]
		],
		[
			[
				63326,
				68290
			],
			[
				58,
				-261
			],
			[
				-25,
				-135
			],
			[
				89,
				-445
			]
		],
		[
			[
				63448,
				67449
			],
			[
				-196,
				-16
			],
			[
				-69,
				282
			],
			[
				-248,
				57
			]
		],
		[
			[
				79227,
				59013
			],
			[
				90,
				266
			],
			[
				12,
				500
			],
			[
				-224,
				515
			],
			[
				-18,
				583
			],
			[
				-211,
				480
			],
			[
				-210,
				40
			],
			[
				-56,
				-205
			],
			[
				-163,
				-17
			],
			[
				-83,
				104
			],
			[
				-293,
				-353
			],
			[
				-6,
				530
			],
			[
				68,
				623
			],
			[
				-188,
				27
			],
			[
				-16,
				355
			],
			[
				-120,
				182
			]
		],
		[
			[
				77809,
				62643
			],
			[
				59,
				218
			],
			[
				237,
				384
			]
		],
		[
			[
				78380,
				63852
			],
			[
				162,
				-466
			],
			[
				125,
				-537
			],
			[
				342,
				-5
			],
			[
				108,
				-515
			],
			[
				-178,
				-155
			],
			[
				-80,
				-212
			],
			[
				333,
				-353
			],
			[
				231,
				-699
			],
			[
				175,
				-520
			],
			[
				210,
				-411
			],
			[
				70,
				-418
			],
			[
				-50,
				-590
			]
		],
		[
			[
				59757,
				70130
			],
			[
				99,
				482
			],
			[
				138,
				416
			],
			[
				5,
				21
			]
		],
		[
			[
				59999,
				71049
			],
			[
				125,
				-31
			],
			[
				45,
				-231
			],
			[
				-151,
				-223
			],
			[
				-68,
				-323
			]
		],
		[
			[
				47857,
				53158
			],
			[
				-73,
				-5
			],
			[
				-286,
				282
			],
			[
				-252,
				449
			],
			[
				-237,
				324
			],
			[
				-187,
				381
			]
		],
		[
			[
				46822,
				54589
			],
			[
				66,
				189
			],
			[
				15,
				172
			],
			[
				126,
				320
			],
			[
				129,
				276
			]
		],
		[
			[
				54125,
				64088
			],
			[
				-197,
				-220
			],
			[
				-156,
				324
			],
			[
				-439,
				255
			]
		],
		[
			[
				52633,
				68486
			],
			[
				136,
				137
			],
			[
				24,
				250
			],
			[
				-30,
				244
			],
			[
				191,
				228
			],
			[
				86,
				189
			],
			[
				135,
				170
			],
			[
				16,
				454
			]
		],
		[
			[
				53191,
				70158
			],
			[
				326,
				-204
			],
			[
				117,
				51
			],
			[
				232,
				-98
			],
			[
				368,
				-264
			],
			[
				130,
				-526
			],
			[
				250,
				-114
			],
			[
				391,
				-248
			],
			[
				296,
				-293
			],
			[
				136,
				153
			],
			[
				133,
				272
			],
			[
				-65,
				452
			],
			[
				87,
				288
			],
			[
				200,
				277
			],
			[
				192,
				80
			],
			[
				375,
				-121
			],
			[
				95,
				-264
			],
			[
				104,
				-2
			],
			[
				88,
				-101
			],
			[
				276,
				-70
			],
			[
				68,
				-195
			]
		],
		[
			[
				56944,
				63578
			],
			[
				0,
				-1180
			],
			[
				-320,
				-2
			],
			[
				-3,
				-248
			]
		],
		[
			[
				56621,
				62148
			],
			[
				-1108,
				1131
			],
			[
				-1108,
				1132
			],
			[
				-280,
				-323
			]
		],
		[
			[
				72718,
				55024
			],
			[
				-42,
				-615
			],
			[
				-116,
				-168
			],
			[
				-242,
				-135
			],
			[
				-132,
				470
			],
			[
				-49,
				849
			],
			[
				126,
				959
			],
			[
				192,
				-328
			],
			[
				129,
				-416
			],
			[
				134,
				-616
			]
		],
		[
			[
				58049,
				33472
			],
			[
				96,
				-178
			],
			[
				-85,
				-288
			],
			[
				-47,
				-192
			],
			[
				-155,
				-93
			],
			[
				-51,
				-188
			],
			[
				-99,
				-59
			],
			[
				-209,
				454
			],
			[
				148,
				374
			],
			[
				151,
				232
			],
			[
				130,
				120
			],
			[
				121,
				-182
			]
		],
		[
			[
				56314,
				82678
			],
			[
				-23,
				150
			],
			[
				30,
				162
			],
			[
				-123,
				94
			],
			[
				-291,
				103
			]
		],
		[
			[
				55907,
				83187
			],
			[
				-59,
				497
			]
		],
		[
			[
				55848,
				83684
			],
			[
				318,
				181
			],
			[
				466,
				-38
			],
			[
				273,
				59
			],
			[
				39,
				-123
			],
			[
				148,
				-38
			],
			[
				267,
				-287
			]
		],
		[
			[
				56523,
				82432
			],
			[
				-67,
				182
			],
			[
				-142,
				64
			]
		],
		[
			[
				55848,
				83684
			],
			[
				10,
				445
			],
			[
				136,
				371
			],
			[
				262,
				202
			],
			[
				221,
				-442
			],
			[
				223,
				12
			],
			[
				53,
				453
			]
		],
		[
			[
				57579,
				84537
			],
			[
				134,
				-136
			],
			[
				24,
				-287
			],
			[
				89,
				-348
			]
		],
		[
			[
				47592,
				66920
			],
			[
				-42,
				0
			],
			[
				7,
				-317
			],
			[
				-172,
				-19
			],
			[
				-90,
				-134
			],
			[
				-126,
				0
			],
			[
				-100,
				76
			],
			[
				-234,
				-63
			],
			[
				-91,
				-460
			],
			[
				-86,
				-44
			],
			[
				-131,
				-745
			],
			[
				-386,
				-637
			],
			[
				-92,
				-816
			],
			[
				-114,
				-265
			],
			[
				-33,
				-213
			],
			[
				-625,
				-48
			],
			[
				-5,
				1
			]
		],
		[
			[
				45272,
				63236
			],
			[
				13,
				274
			],
			[
				106,
				161
			],
			[
				91,
				308
			],
			[
				-18,
				200
			],
			[
				96,
				417
			],
			[
				155,
				376
			],
			[
				93,
				95
			],
			[
				74,
				344
			],
			[
				6,
				315
			],
			[
				100,
				365
			],
			[
				185,
				216
			],
			[
				177,
				603
			],
			[
				5,
				8
			],
			[
				139,
				227
			],
			[
				259,
				65
			],
			[
				218,
				404
			],
			[
				140,
				158
			],
			[
				232,
				493
			],
			[
				-70,
				735
			],
			[
				106,
				508
			],
			[
				37,
				312
			],
			[
				179,
				399
			],
			[
				278,
				270
			],
			[
				206,
				244
			],
			[
				186,
				612
			],
			[
				87,
				362
			],
			[
				205,
				-2
			],
			[
				167,
				-251
			],
			[
				264,
				41
			],
			[
				288,
				-131
			],
			[
				121,
				-6
			]
		],
		[
			[
				57394,
				79070
			],
			[
				66,
				87
			],
			[
				185,
				58
			],
			[
				204,
				-184
			],
			[
				115,
				-22
			],
			[
				125,
				-159
			],
			[
				-20,
				-200
			],
			[
				101,
				-97
			],
			[
				40,
				-247
			],
			[
				97,
				-150
			],
			[
				-19,
				-88
			],
			[
				52,
				-60
			],
			[
				-74,
				-44
			],
			[
				-164,
				18
			],
			[
				-27,
				81
			],
			[
				-58,
				-47
			],
			[
				20,
				-106
			],
			[
				-76,
				-188
			],
			[
				-49,
				-203
			],
			[
				-70,
				-64
			]
		],
		[
			[
				57842,
				77455
			],
			[
				-50,
				270
			],
			[
				30,
				252
			],
			[
				-9,
				259
			],
			[
				-160,
				352
			],
			[
				-89,
				249
			],
			[
				-86,
				175
			],
			[
				-84,
				58
			]
		],
		[
			[
				63761,
				43212
			],
			[
				74,
				-251
			],
			[
				69,
				-390
			],
			[
				45,
				-711
			],
			[
				72,
				-276
			],
			[
				-28,
				-284
			],
			[
				-49,
				-174
			],
			[
				-94,
				347
			],
			[
				-53,
				-175
			],
			[
				53,
				-438
			],
			[
				-24,
				-250
			],
			[
				-77,
				-137
			],
			[
				-18,
				-500
			],
			[
				-109,
				-689
			],
			[
				-137,
				-814
			],
			[
				-172,
				-1120
			],
			[
				-106,
				-821
			],
			[
				-125,
				-685
			],
			[
				-226,
				-140
			],
			[
				-243,
				-250
			],
			[
				-160,
				151
			],
			[
				-220,
				211
			],
			[
				-77,
				312
			],
			[
				-18,
				524
			],
			[
				-98,
				471
			],
			[
				-26,
				425
			],
			[
				50,
				426
			],
			[
				128,
				102
			],
			[
				1,
				197
			],
			[
				133,
				447
			],
			[
				25,
				377
			],
			[
				-65,
				280
			],
			[
				-52,
				372
			],
			[
				-23,
				544
			],
			[
				97,
				331
			],
			[
				38,
				375
			],
			[
				138,
				22
			],
			[
				155,
				121
			],
			[
				103,
				107
			],
			[
				122,
				7
			],
			[
				158,
				337
			],
			[
				229,
				364
			],
			[
				83,
				297
			],
			[
				-38,
				253
			],
			[
				118,
				-71
			],
			[
				153,
				410
			],
			[
				6,
				356
			],
			[
				92,
				264
			],
			[
				96,
				-254
			]
		],
		[
			[
				23016,
				65864
			],
			[
				-107,
				-518
			],
			[
				-49,
				-426
			],
			[
				-20,
				-791
			],
			[
				-27,
				-289
			],
			[
				48,
				-322
			],
			[
				86,
				-288
			],
			[
				56,
				-458
			],
			[
				184,
				-440
			],
			[
				65,
				-337
			],
			[
				109,
				-291
			],
			[
				295,
				-157
			],
			[
				114,
				-247
			],
			[
				244,
				165
			],
			[
				212,
				60
			],
			[
				208,
				106
			],
			[
				175,
				101
			],
			[
				176,
				241
			],
			[
				67,
				345
			],
			[
				22,
				496
			],
			[
				48,
				173
			],
			[
				188,
				155
			],
			[
				294,
				137
			],
			[
				246,
				-21
			],
			[
				169,
				50
			],
			[
				66,
				-125
			],
			[
				-9,
				-285
			],
			[
				-149,
				-351
			],
			[
				-66,
				-360
			],
			[
				51,
				-103
			],
			[
				-42,
				-255
			],
			[
				-69,
				-461
			],
			[
				-71,
				152
			],
			[
				-58,
				-10
			]
		],
		[
			[
				24381,
				59170
			],
			[
				-314,
				636
			],
			[
				-144,
				191
			],
			[
				-226,
				155
			],
			[
				-156,
				-43
			],
			[
				-223,
				-223
			],
			[
				-140,
				-58
			],
			[
				-196,
				156
			],
			[
				-208,
				112
			],
			[
				-260,
				271
			],
			[
				-208,
				83
			],
			[
				-314,
				275
			],
			[
				-233,
				282
			],
			[
				-70,
				158
			],
			[
				-155,
				35
			],
			[
				-284,
				187
			],
			[
				-116,
				270
			],
			[
				-299,
				335
			],
			[
				-139,
				373
			],
			[
				-66,
				288
			],
			[
				93,
				57
			],
			[
				-29,
				169
			],
			[
				64,
				153
			],
			[
				1,
				204
			],
			[
				-93,
				266
			],
			[
				-25,
				235
			],
			[
				-94,
				298
			],
			[
				-244,
				587
			],
			[
				-280,
				462
			],
			[
				-135,
				368
			],
			[
				-238,
				241
			],
			[
				-51,
				145
			],
			[
				42,
				365
			],
			[
				-142,
				138
			],
			[
				-164,
				287
			],
			[
				-69,
				412
			],
			[
				-149,
				48
			],
			[
				-162,
				311
			],
			[
				-130,
				288
			],
			[
				-12,
				184
			],
			[
				-149,
				446
			],
			[
				-99,
				452
			],
			[
				5,
				227
			],
			[
				-201,
				234
			],
			[
				-93,
				-25
			],
			[
				-159,
				163
			],
			[
				-44,
				-240
			],
			[
				46,
				-284
			],
			[
				27,
				-444
			],
			[
				95,
				-243
			],
			[
				206,
				-407
			],
			[
				46,
				-139
			],
			[
				42,
				-42
			],
			[
				37,
				-203
			],
			[
				49,
				8
			],
			[
				56,
				-381
			],
			[
				85,
				-150
			],
			[
				59,
				-210
			],
			[
				174,
				-300
			],
			[
				92,
				-550
			],
			[
				83,
				-259
			],
			[
				77,
				-277
			],
			[
				15,
				-311
			],
			[
				134,
				-20
			],
			[
				112,
				-268
			],
			[
				100,
				-264
			],
			[
				-6,
				-106
			],
			[
				-117,
				-217
			],
			[
				-49,
				3
			],
			[
				-74,
				359
			],
			[
				-181,
				337
			],
			[
				-201,
				286
			],
			[
				-142,
				150
			],
			[
				9,
				432
			],
			[
				-42,
				320
			],
			[
				-132,
				183
			],
			[
				-191,
				264
			],
			[
				-37,
				-76
			],
			[
				-70,
				154
			],
			[
				-171,
				143
			],
			[
				-164,
				343
			],
			[
				20,
				44
			],
			[
				115,
				-33
			],
			[
				103,
				221
			],
			[
				10,
				266
			],
			[
				-214,
				422
			],
			[
				-163,
				163
			],
			[
				-102,
				369
			],
			[
				-103,
				388
			],
			[
				-129,
				472
			],
			[
				-113,
				531
			]
		],
		[
			[
				17464,
				69802
			],
			[
				316,
				46
			],
			[
				353,
				64
			],
			[
				-26,
				-116
			],
			[
				419,
				-287
			],
			[
				634,
				-416
			],
			[
				552,
				4
			],
			[
				221,
				0
			],
			[
				0,
				244
			],
			[
				481,
				0
			],
			[
				102,
				-210
			],
			[
				142,
				-186
			],
			[
				165,
				-260
			],
			[
				92,
				-309
			],
			[
				69,
				-325
			],
			[
				144,
				-178
			],
			[
				230,
				-177
			],
			[
				175,
				467
			],
			[
				227,
				11
			],
			[
				196,
				-236
			],
			[
				139,
				-404
			],
			[
				96,
				-346
			],
			[
				164,
				-337
			],
			[
				61,
				-414
			],
			[
				78,
				-277
			],
			[
				217,
				-184
			],
			[
				197,
				-130
			],
			[
				108,
				18
			]
		],
		[
			[
				55993,
				75539
			],
			[
				95,
				35
			],
			[
				128,
				9
			]
		],
		[
			[
				46619,
				59216
			],
			[
				93,
				107
			],
			[
				47,
				348
			],
			[
				88,
				14
			],
			[
				194,
				-165
			],
			[
				157,
				117
			],
			[
				107,
				-39
			],
			[
				42,
				131
			],
			[
				1114,
				9
			],
			[
				62,
				414
			],
			[
				-48,
				73
			],
			[
				-134,
				2550
			],
			[
				-134,
				2550
			],
			[
				425,
				10
			]
		],
		[
			[
				51185,
				61897
			],
			[
				1,
				-1361
			],
			[
				-152,
				-394
			],
			[
				-24,
				-364
			],
			[
				-247,
				-94
			],
			[
				-379,
				-51
			],
			[
				-102,
				-210
			],
			[
				-178,
				-23
			]
		],
		[
			[
				46801,
				57931
			],
			[
				13,
				184
			],
			[
				-24,
				229
			],
			[
				-104,
				166
			],
			[
				-54,
				338
			],
			[
				-13,
				368
			]
		],
		[
			[
				77375,
				56448
			],
			[
				-27,
				439
			],
			[
				86,
				452
			],
			[
				-94,
				350
			],
			[
				23,
				644
			],
			[
				-113,
				306
			],
			[
				-90,
				707
			],
			[
				-50,
				746
			],
			[
				-121,
				490
			],
			[
				-183,
				-297
			],
			[
				-315,
				-421
			],
			[
				-156,
				53
			],
			[
				-172,
				138
			],
			[
				96,
				732
			],
			[
				-58,
				554
			],
			[
				-218,
				681
			],
			[
				34,
				213
			],
			[
				-163,
				76
			],
			[
				-197,
				481
			]
		],
		[
			[
				77809,
				62643
			],
			[
				-159,
				-137
			],
			[
				-162,
				-256
			],
			[
				-196,
				-26
			],
			[
				-127,
				-639
			],
			[
				-117,
				-107
			],
			[
				134,
				-519
			],
			[
				177,
				-431
			],
			[
				113,
				-390
			],
			[
				-101,
				-514
			],
			[
				-96,
				-109
			],
			[
				66,
				-296
			],
			[
				185,
				-470
			],
			[
				32,
				-330
			],
			[
				-4,
				-274
			],
			[
				108,
				-539
			],
			[
				-152,
				-551
			],
			[
				-135,
				-607
			]
		],
		[
			[
				55380,
				75322
			],
			[
				-58,
				46
			],
			[
				-78,
				192
			],
			[
				-120,
				118
			]
		],
		[
			[
				55338,
				76294
			],
			[
				74,
				-101
			],
			[
				40,
				-82
			],
			[
				91,
				-63
			],
			[
				106,
				-123
			],
			[
				-22,
				-51
			]
		],
		[
			[
				74375,
				79706
			],
			[
				292,
				102
			],
			[
				530,
				509
			],
			[
				423,
				278
			],
			[
				242,
				-182
			],
			[
				289,
				-8
			],
			[
				186,
				-276
			],
			[
				277,
				-22
			],
			[
				402,
				-148
			],
			[
				270,
				411
			],
			[
				-113,
				348
			],
			[
				288,
				612
			],
			[
				311,
				-244
			],
			[
				252,
				-69
			],
			[
				327,
				-152
			],
			[
				53,
				-443
			],
			[
				394,
				-248
			],
			[
				263,
				109
			],
			[
				351,
				78
			],
			[
				279,
				-78
			],
			[
				272,
				-284
			],
			[
				168,
				-302
			],
			[
				258,
				6
			],
			[
				350,
				-96
			],
			[
				255,
				146
			],
			[
				366,
				98
			],
			[
				407,
				416
			],
			[
				166,
				-63
			],
			[
				146,
				-198
			],
			[
				331,
				49
			]
		],
		[
			[
				59599,
				43773
			],
			[
				209,
				48
			],
			[
				334,
				-166
			],
			[
				73,
				74
			],
			[
				193,
				16
			],
			[
				99,
				177
			],
			[
				167,
				-10
			],
			[
				303,
				230
			],
			[
				221,
				342
			]
		],
		[
			[
				61198,
				44484
			],
			[
				45,
				-265
			],
			[
				-11,
				-588
			],
			[
				34,
				-519
			],
			[
				11,
				-923
			],
			[
				49,
				-290
			],
			[
				-83,
				-422
			],
			[
				-108,
				-410
			],
			[
				-177,
				-366
			],
			[
				-254,
				-225
			],
			[
				-313,
				-287
			],
			[
				-313,
				-634
			],
			[
				-107,
				-108
			],
			[
				-194,
				-420
			],
			[
				-115,
				-136
			],
			[
				-23,
				-421
			],
			[
				132,
				-448
			],
			[
				54,
				-346
			],
			[
				4,
				-177
			],
			[
				49,
				29
			],
			[
				-8,
				-579
			],
			[
				-45,
				-275
			],
			[
				65,
				-101
			],
			[
				-41,
				-245
			],
			[
				-116,
				-211
			],
			[
				-229,
				-199
			],
			[
				-334,
				-320
			],
			[
				-122,
				-219
			],
			[
				24,
				-248
			],
			[
				71,
				-40
			],
			[
				-24,
				-311
			]
		],
		[
			[
				59119,
				34780
			],
			[
				-211,
				5
			]
		],
		[
			[
				58908,
				34785
			],
			[
				-24,
				261
			],
			[
				-41,
				265
			]
		],
		[
			[
				58843,
				35311
			],
			[
				-23,
				212
			],
			[
				49,
				659
			],
			[
				-72,
				419
			],
			[
				-133,
				832
			]
		],
		[
			[
				58664,
				37433
			],
			[
				292,
				671
			],
			[
				74,
				426
			],
			[
				42,
				53
			],
			[
				31,
				348
			],
			[
				-45,
				175
			],
			[
				12,
				442
			],
			[
				54,
				409
			],
			[
				0,
				748
			],
			[
				-145,
				190
			],
			[
				-132,
				43
			],
			[
				-60,
				146
			],
			[
				-128,
				125
			],
			[
				-232,
				-12
			],
			[
				-18,
				220
			]
		],
		[
			[
				58409,
				41417
			],
			[
				-26,
				421
			],
			[
				843,
				487
			]
		],
		[
			[
				59226,
				42325
			],
			[
				159,
				-284
			],
			[
				77,
				54
			],
			[
				110,
				-149
			],
			[
				16,
				-237
			],
			[
				-59,
				-274
			],
			[
				21,
				-417
			],
			[
				181,
				-365
			],
			[
				85,
				410
			],
			[
				120,
				124
			],
			[
				-24,
				760
			],
			[
				-116,
				427
			],
			[
				-100,
				191
			],
			[
				-97,
				-9
			],
			[
				-77,
				768
			],
			[
				77,
				449
			]
		],
		[
			[
				46619,
				59216
			],
			[
				-184,
				405
			],
			[
				-168,
				435
			],
			[
				-184,
				157
			],
			[
				-133,
				173
			],
			[
				-155,
				-6
			],
			[
				-135,
				-129
			],
			[
				-138,
				51
			],
			[
				-96,
				-189
			]
		],
		[
			[
				45426,
				60113
			],
			[
				-24,
				318
			],
			[
				78,
				291
			],
			[
				34,
				557
			],
			[
				-30,
				583
			],
			[
				-34,
				294
			],
			[
				28,
				295
			],
			[
				-72,
				281
			],
			[
				-146,
				255
			]
		],
		[
			[
				45260,
				62987
			],
			[
				60,
				197
			],
			[
				1088,
				-4
			],
			[
				-53,
				853
			],
			[
				68,
				304
			],
			[
				261,
				53
			],
			[
				-9,
				1512
			],
			[
				911,
				-31
			],
			[
				1,
				895
			]
		],
		[
			[
				59226,
				42325
			],
			[
				-147,
				153
			],
			[
				85,
				549
			],
			[
				87,
				205
			],
			[
				-53,
				490
			],
			[
				56,
				479
			],
			[
				47,
				160
			],
			[
				-71,
				501
			],
			[
				-131,
				264
			]
		],
		[
			[
				59099,
				45126
			],
			[
				273,
				-110
			],
			[
				55,
				-164
			],
			[
				95,
				-275
			],
			[
				77,
				-804
			]
		],
		[
			[
				78372,
				54256
			],
			[
				64,
				-56
			],
			[
				164,
				-356
			],
			[
				116,
				-396
			],
			[
				16,
				-398
			],
			[
				-29,
				-269
			],
			[
				27,
				-203
			],
			[
				20,
				-349
			],
			[
				98,
				-163
			],
			[
				109,
				-523
			],
			[
				-5,
				-199
			],
			[
				-197,
				-40
			],
			[
				-263,
				438
			],
			[
				-329,
				469
			],
			[
				-32,
				301
			],
			[
				-161,
				395
			],
			[
				-38,
				489
			],
			[
				-100,
				322
			],
			[
				30,
				431
			],
			[
				-61,
				250
			]
		],
		[
			[
				77801,
				54399
			],
			[
				48,
				105
			],
			[
				227,
				-258
			],
			[
				22,
				-304
			],
			[
				183,
				71
			],
			[
				91,
				243
			]
		],
		[
			[
				80461,
				51765
			],
			[
				204,
				-202
			],
			[
				214,
				110
			],
			[
				56,
				500
			],
			[
				119,
				112
			],
			[
				333,
				128
			],
			[
				199,
				467
			],
			[
				137,
				374
			]
		],
		[
			[
				82069,
				53798
			],
			[
				214,
				411
			],
			[
				140,
				462
			],
			[
				112,
				2
			],
			[
				143,
				-299
			],
			[
				13,
				-257
			],
			[
				183,
				-165
			],
			[
				231,
				-177
			],
			[
				-20,
				-232
			],
			[
				-186,
				-29
			],
			[
				50,
				-289
			],
			[
				-205,
				-201
			]
		],
		[
			[
				54540,
				33696
			],
			[
				-207,
				446
			],
			[
				-108,
				432
			],
			[
				-62,
				575
			],
			[
				-68,
				428
			],
			[
				-93,
				910
			],
			[
				-7,
				707
			],
			[
				-35,
				322
			],
			[
				-108,
				243
			],
			[
				-144,
				489
			],
			[
				-146,
				708
			],
			[
				-60,
				371
			],
			[
				-226,
				577
			],
			[
				-17,
				453
			]
		],
		[
			[
				56448,
				40227
			],
			[
				228,
				134
			],
			[
				180,
				-34
			],
			[
				109,
				-133
			],
			[
				2,
				-49
			]
		],
		[
			[
				55526,
				35946
			],
			[
				0,
				-2182
			],
			[
				-248,
				-302
			],
			[
				-149,
				-43
			],
			[
				-175,
				112
			],
			[
				-125,
				43
			],
			[
				-47,
				252
			],
			[
				-109,
				162
			],
			[
				-133,
				-292
			]
		],
		[
			[
				96049,
				38125
			],
			[
				228,
				-366
			],
			[
				144,
				-272
			],
			[
				-105,
				-142
			],
			[
				-153,
				160
			],
			[
				-199,
				266
			],
			[
				-179,
				313
			],
			[
				-184,
				416
			],
			[
				-38,
				201
			],
			[
				119,
				-9
			],
			[
				156,
				-201
			],
			[
				122,
				-200
			],
			[
				89,
				-166
			]
		],
		[
			[
				54125,
				64088
			],
			[
				68,
				-919
			],
			[
				104,
				-153
			],
			[
				4,
				-188
			],
			[
				116,
				-203
			],
			[
				-60,
				-254
			],
			[
				-107,
				-1199
			],
			[
				-15,
				-769
			],
			[
				-354,
				-557
			],
			[
				-120,
				-778
			],
			[
				115,
				-219
			],
			[
				0,
				-380
			],
			[
				178,
				-13
			],
			[
				-28,
				-279
			]
		],
		[
			[
				53939,
				57955
			],
			[
				-52,
				-13
			],
			[
				-188,
				647
			],
			[
				-65,
				24
			],
			[
				-217,
				-331
			],
			[
				-215,
				173
			],
			[
				-150,
				34
			],
			[
				-80,
				-83
			],
			[
				-163,
				18
			],
			[
				-164,
				-252
			],
			[
				-141,
				-14
			],
			[
				-337,
				305
			],
			[
				-131,
				-145
			],
			[
				-142,
				10
			],
			[
				-104,
				223
			],
			[
				-279,
				221
			],
			[
				-298,
				-70
			],
			[
				-72,
				-128
			],
			[
				-39,
				-340
			],
			[
				-80,
				-238
			],
			[
				-19,
				-527
			]
		],
		[
			[
				52361,
				53399
			],
			[
				-289,
				-213
			],
			[
				-105,
				31
			],
			[
				-107,
				-132
			],
			[
				-222,
				13
			],
			[
				-149,
				370
			],
			[
				-91,
				427
			],
			[
				-197,
				389
			],
			[
				-209,
				-7
			],
			[
				-245,
				1
			]
		],
		[
			[
				26191,
				57131
			],
			[
				-96,
				186
			],
			[
				-130,
				238
			],
			[
				-61,
				200
			],
			[
				-117,
				185
			],
			[
				-140,
				267
			],
			[
				31,
				91
			],
			[
				46,
				-88
			],
			[
				21,
				41
			]
		],
		[
			[
				26903,
				59440
			],
			[
				-24,
				-57
			],
			[
				-14,
				-132
			],
			[
				29,
				-216
			],
			[
				-64,
				-202
			],
			[
				-30,
				-237
			],
			[
				-9,
				-261
			],
			[
				15,
				-152
			],
			[
				7,
				-266
			],
			[
				-43,
				-58
			],
			[
				-26,
				-253
			],
			[
				19,
				-156
			],
			[
				-56,
				-151
			],
			[
				12,
				-159
			],
			[
				43,
				-97
			]
		],
		[
			[
				50920,
				80916
			],
			[
				143,
				162
			],
			[
				244,
				869
			],
			[
				380,
				248
			],
			[
				231,
				-17
			]
		],
		[
			[
				58639,
				91676
			],
			[
				-473,
				-237
			],
			[
				-224,
				-54
			]
		],
		[
			[
				55734,
				91409
			],
			[
				-172,
				-24
			],
			[
				-41,
				-389
			],
			[
				-523,
				95
			],
			[
				-74,
				-329
			],
			[
				-267,
				2
			],
			[
				-183,
				-421
			],
			[
				-278,
				-655
			],
			[
				-431,
				-831
			],
			[
				101,
				-202
			],
			[
				-97,
				-234
			],
			[
				-275,
				10
			],
			[
				-180,
				-554
			],
			[
				17,
				-784
			],
			[
				177,
				-300
			],
			[
				-92,
				-694
			],
			[
				-231,
				-405
			],
			[
				-122,
				-341
			]
		],
		[
			[
				53063,
				85353
			],
			[
				-187,
				363
			],
			[
				-548,
				-684
			],
			[
				-371,
				-138
			],
			[
				-384,
				301
			],
			[
				-99,
				635
			],
			[
				-88,
				1363
			],
			[
				256,
				381
			],
			[
				733,
				496
			],
			[
				549,
				609
			],
			[
				508,
				824
			],
			[
				668,
				1141
			],
			[
				465,
				444
			],
			[
				763,
				741
			],
			[
				610,
				259
			],
			[
				457,
				-31
			],
			[
				423,
				489
			],
			[
				506,
				-26
			],
			[
				499,
				118
			],
			[
				869,
				-433
			],
			[
				-358,
				-158
			],
			[
				305,
				-371
			]
		],
		[
			[
				56867,
				96577
			],
			[
				-620,
				-241
			],
			[
				-490,
				137
			],
			[
				191,
				152
			],
			[
				-167,
				189
			],
			[
				575,
				119
			],
			[
				110,
				-222
			],
			[
				401,
				-134
			]
		],
		[
			[
				55069,
				97669
			],
			[
				915,
				-440
			],
			[
				-699,
				-233
			],
			[
				-155,
				-435
			],
			[
				-243,
				-111
			],
			[
				-132,
				-490
			],
			[
				-335,
				-23
			],
			[
				-598,
				361
			],
			[
				252,
				210
			],
			[
				-416,
				170
			],
			[
				-541,
				499
			],
			[
				-216,
				463
			],
			[
				757,
				212
			],
			[
				152,
				-207
			],
			[
				396,
				8
			],
			[
				105,
				202
			],
			[
				408,
				20
			],
			[
				350,
				-206
			]
		],
		[
			[
				57068,
				98086
			],
			[
				545,
				-207
			],
			[
				-412,
				-318
			],
			[
				-806,
				-70
			],
			[
				-819,
				98
			],
			[
				-50,
				163
			],
			[
				-398,
				11
			],
			[
				-304,
				271
			],
			[
				858,
				165
			],
			[
				403,
				-142
			],
			[
				281,
				177
			],
			[
				702,
				-148
			]
		],
		[
			[
				98060,
				26404
			],
			[
				63,
				-244
			],
			[
				198,
				239
			],
			[
				80,
				-249
			],
			[
				0,
				-249
			],
			[
				-103,
				-274
			],
			[
				-182,
				-435
			],
			[
				-142,
				-238
			],
			[
				103,
				-284
			],
			[
				-214,
				-7
			],
			[
				-238,
				-223
			],
			[
				-75,
				-387
			],
			[
				-157,
				-597
			],
			[
				-219,
				-264
			],
			[
				-138,
				-169
			],
			[
				-256,
				13
			],
			[
				-180,
				194
			],
			[
				-302,
				42
			],
			[
				-46,
				217
			],
			[
				149,
				438
			],
			[
				349,
				583
			],
			[
				179,
				111
			],
			[
				200,
				225
			],
			[
				238,
				310
			],
			[
				167,
				306
			],
			[
				123,
				441
			],
			[
				106,
				149
			],
			[
				41,
				330
			],
			[
				195,
				273
			],
			[
				61,
				-251
			]
		],
		[
			[
				98502,
				29218
			],
			[
				202,
				-622
			],
			[
				5,
				403
			],
			[
				126,
				-161
			],
			[
				41,
				-447
			],
			[
				224,
				-192
			],
			[
				188,
				-48
			],
			[
				158,
				226
			],
			[
				141,
				-69
			],
			[
				-67,
				-524
			],
			[
				-85,
				-345
			],
			[
				-212,
				12
			],
			[
				-74,
				-179
			],
			[
				26,
				-254
			],
			[
				-41,
				-110
			],
			[
				-105,
				-319
			],
			[
				-138,
				-404
			],
			[
				-214,
				-236
			],
			[
				-48,
				155
			],
			[
				-116,
				85
			],
			[
				160,
				486
			],
			[
				-91,
				326
			],
			[
				-299,
				236
			],
			[
				8,
				214
			],
			[
				201,
				206
			],
			[
				47,
				455
			],
			[
				-13,
				382
			],
			[
				-113,
				396
			],
			[
				8,
				104
			],
			[
				-133,
				244
			],
			[
				-218,
				523
			],
			[
				-117,
				418
			],
			[
				104,
				46
			],
			[
				151,
				-328
			],
			[
				216,
				-153
			],
			[
				78,
				-526
			]
		],
		[
			[
				64752,
				60417
			],
			[
				-91,
				413
			],
			[
				-217,
				975
			]
		],
		[
			[
				64444,
				61805
			],
			[
				833,
				591
			],
			[
				185,
				1182
			],
			[
				-127,
				418
			]
		],
		[
			[
				65665,
				65306
			],
			[
				125,
				-404
			],
			[
				155,
				-214
			],
			[
				203,
				-78
			],
			[
				165,
				-107
			],
			[
				125,
				-339
			],
			[
				75,
				-196
			],
			[
				100,
				-75
			],
			[
				-1,
				-132
			],
			[
				-101,
				-352
			],
			[
				-44,
				-166
			],
			[
				-117,
				-189
			],
			[
				-104,
				-404
			],
			[
				-126,
				31
			],
			[
				-58,
				-141
			],
			[
				-44,
				-300
			],
			[
				34,
				-395
			],
			[
				-26,
				-72
			],
			[
				-128,
				2
			],
			[
				-174,
				-221
			],
			[
				-27,
				-288
			],
			[
				-63,
				-125
			],
			[
				-173,
				5
			],
			[
				-109,
				-149
			],
			[
				1,
				-238
			],
			[
				-134,
				-165
			],
			[
				-153,
				56
			],
			[
				-186,
				-199
			],
			[
				-128,
				-34
			]
		],
		[
			[
				65575,
				65974
			],
			[
				80,
				201
			],
			[
				35,
				-51
			],
			[
				-26,
				-244
			],
			[
				-37,
				-108
			]
		],
		[
			[
				68937,
				64577
			],
			[
				-203,
				150
			],
			[
				-83,
				424
			],
			[
				-215,
				450
			],
			[
				-512,
				-111
			],
			[
				-451,
				-11
			],
			[
				-391,
				-83
			]
		],
		[
			[
				28366,
				54848
			],
			[
				-93,
				170
			],
			[
				-59,
				319
			],
			[
				68,
				158
			],
			[
				-70,
				40
			],
			[
				-52,
				196
			],
			[
				-138,
				164
			],
			[
				-122,
				-38
			],
			[
				-56,
				-205
			],
			[
				-112,
				-149
			],
			[
				-61,
				-20
			],
			[
				-27,
				-123
			],
			[
				132,
				-321
			],
			[
				-75,
				-76
			],
			[
				-40,
				-87
			],
			[
				-130,
				-30
			],
			[
				-48,
				353
			],
			[
				-36,
				-101
			],
			[
				-92,
				35
			],
			[
				-56,
				238
			],
			[
				-114,
				39
			],
			[
				-72,
				69
			],
			[
				-119,
				-1
			],
			[
				-8,
				-128
			],
			[
				-32,
				89
			]
		],
		[
			[
				27070,
				56232
			],
			[
				100,
				-212
			],
			[
				-6,
				-126
			],
			[
				111,
				-26
			],
			[
				26,
				48
			],
			[
				77,
				-145
			],
			[
				136,
				42
			],
			[
				119,
				150
			],
			[
				168,
				119
			],
			[
				95,
				176
			],
			[
				153,
				-34
			],
			[
				-10,
				-58
			],
			[
				155,
				-21
			],
			[
				124,
				-102
			],
			[
				90,
				-177
			],
			[
				105,
				-164
			]
		],
		[
			[
				30452,
				39739
			],
			[
				-279,
				340
			],
			[
				-24,
				242
			],
			[
				-551,
				593
			],
			[
				-498,
				646
			],
			[
				-214,
				365
			],
			[
				-115,
				488
			],
			[
				46,
				170
			],
			[
				-236,
				775
			],
			[
				-274,
				1090
			],
			[
				-262,
				1177
			],
			[
				-114,
				269
			],
			[
				-87,
				435
			],
			[
				-216,
				386
			],
			[
				-198,
				239
			],
			[
				90,
				264
			],
			[
				-134,
				563
			],
			[
				86,
				414
			],
			[
				221,
				373
			]
		],
		[
			[
				85104,
				55551
			],
			[
				28,
				-392
			],
			[
				16,
				-332
			],
			[
				-94,
				-540
			],
			[
				-102,
				602
			],
			[
				-130,
				-300
			],
			[
				89,
				-435
			],
			[
				-79,
				-277
			],
			[
				-327,
				343
			],
			[
				-78,
				428
			],
			[
				84,
				280
			],
			[
				-176,
				280
			],
			[
				-87,
				-245
			],
			[
				-131,
				23
			],
			[
				-205,
				-330
			],
			[
				-46,
				173
			],
			[
				109,
				498
			],
			[
				175,
				166
			],
			[
				151,
				223
			],
			[
				98,
				-268
			],
			[
				212,
				162
			],
			[
				45,
				264
			],
			[
				196,
				15
			],
			[
				-16,
				457
			],
			[
				225,
				-280
			],
			[
				23,
				-297
			],
			[
				20,
				-218
			]
		],
		[
			[
				84439,
				56653
			],
			[
				-100,
				-195
			],
			[
				-87,
				-373
			],
			[
				-87,
				-175
			],
			[
				-171,
				409
			],
			[
				57,
				158
			],
			[
				70,
				165
			],
			[
				30,
				367
			],
			[
				153,
				35
			],
			[
				-44,
				-398
			],
			[
				205,
				570
			],
			[
				-26,
				-563
			]
		],
		[
			[
				82917,
				56084
			],
			[
				-369,
				-561
			],
			[
				136,
				414
			],
			[
				200,
				364
			],
			[
				167,
				409
			],
			[
				146,
				587
			],
			[
				49,
				-482
			],
			[
				-183,
				-325
			],
			[
				-146,
				-406
			]
		],
		[
			[
				83856,
				57606
			],
			[
				166,
				-183
			],
			[
				177,
				1
			],
			[
				-5,
				-247
			],
			[
				-129,
				-251
			],
			[
				-176,
				-178
			],
			[
				-10,
				275
			],
			[
				20,
				301
			],
			[
				-43,
				282
			]
		],
		[
			[
				84861,
				57766
			],
			[
				78,
				-660
			],
			[
				-214,
				157
			],
			[
				5,
				-199
			],
			[
				68,
				-364
			],
			[
				-132,
				-133
			],
			[
				-11,
				416
			],
			[
				-84,
				31
			],
			[
				-43,
				357
			],
			[
				163,
				-47
			],
			[
				-4,
				224
			],
			[
				-169,
				451
			],
			[
				266,
				-13
			],
			[
				77,
				-220
			]
		],
		[
			[
				83757,
				58301
			],
			[
				-74,
				-510
			],
			[
				-119,
				295
			],
			[
				-142,
				450
			],
			[
				238,
				-22
			],
			[
				97,
				-213
			]
		],
		[
			[
				83700,
				61512
			],
			[
				171,
				-168
			],
			[
				85,
				153
			],
			[
				26,
				-150
			],
			[
				-46,
				-245
			],
			[
				95,
				-423
			],
			[
				-73,
				-491
			],
			[
				-164,
				-196
			],
			[
				-43,
				-476
			],
			[
				62,
				-471
			],
			[
				147,
				-65
			],
			[
				123,
				70
			],
			[
				347,
				-328
			],
			[
				-27,
				-321
			],
			[
				91,
				-142
			],
			[
				-29,
				-272
			],
			[
				-216,
				290
			],
			[
				-103,
				310
			],
			[
				-71,
				-217
			],
			[
				-177,
				354
			],
			[
				-253,
				-87
			],
			[
				-138,
				130
			],
			[
				14,
				244
			],
			[
				87,
				151
			],
			[
				-83,
				136
			],
			[
				-36,
				-213
			],
			[
				-137,
				340
			],
			[
				-41,
				257
			],
			[
				-11,
				566
			],
			[
				112,
				-195
			],
			[
				29,
				925
			],
			[
				90,
				535
			],
			[
				169,
				-1
			]
		],
		[
			[
				93299,
				46550
			],
			[
				-78,
				-59
			],
			[
				-120,
				227
			],
			[
				-122,
				375
			],
			[
				-59,
				450
			],
			[
				38,
				57
			],
			[
				30,
				-175
			],
			[
				84,
				-134
			],
			[
				135,
				-375
			],
			[
				131,
				-200
			],
			[
				-39,
				-166
			]
		],
		[
			[
				92217,
				47343
			],
			[
				-146,
				-48
			],
			[
				-44,
				-166
			],
			[
				-152,
				-144
			],
			[
				-142,
				-138
			],
			[
				-148,
				1
			],
			[
				-228,
				171
			],
			[
				-158,
				165
			],
			[
				23,
				183
			],
			[
				249,
				-86
			],
			[
				152,
				46
			],
			[
				42,
				283
			],
			[
				40,
				15
			],
			[
				27,
				-314
			],
			[
				158,
				45
			],
			[
				78,
				202
			],
			[
				155,
				211
			],
			[
				-30,
				348
			],
			[
				166,
				11
			],
			[
				56,
				-97
			],
			[
				-5,
				-327
			],
			[
				-93,
				-361
			]
		],
		[
			[
				89166,
				49043
			],
			[
				482,
				-407
			],
			[
				513,
				-338
			],
			[
				192,
				-302
			],
			[
				154,
				-297
			],
			[
				43,
				-349
			],
			[
				462,
				-365
			],
			[
				68,
				-313
			],
			[
				-256,
				-64
			],
			[
				62,
				-393
			],
			[
				248,
				-388
			],
			[
				180,
				-627
			],
			[
				159,
				20
			],
			[
				-11,
				-262
			],
			[
				215,
				-100
			],
			[
				-84,
				-111
			],
			[
				295,
				-249
			],
			[
				-30,
				-171
			],
			[
				-184,
				-41
			],
			[
				-69,
				153
			],
			[
				-238,
				66
			],
			[
				-281,
				89
			],
			[
				-216,
				377
			],
			[
				-158,
				325
			],
			[
				-144,
				517
			],
			[
				-362,
				259
			],
			[
				-235,
				-169
			],
			[
				-170,
				-195
			],
			[
				35,
				-436
			],
			[
				-218,
				-203
			],
			[
				-155,
				99
			],
			[
				-288,
				25
			]
		],
		[
			[
				92538,
				47921
			],
			[
				-87,
				-157
			],
			[
				-52,
				348
			],
			[
				-65,
				229
			],
			[
				-126,
				193
			],
			[
				-158,
				252
			],
			[
				-200,
				174
			],
			[
				77,
				143
			],
			[
				150,
				-166
			],
			[
				94,
				-130
			],
			[
				117,
				-142
			],
			[
				111,
				-248
			],
			[
				106,
				-189
			],
			[
				33,
				-307
			]
		],
		[
			[
				53922,
				82340
			],
			[
				189,
				174
			],
			[
				434,
				273
			],
			[
				350,
				200
			],
			[
				277,
				-100
			],
			[
				21,
				-144
			],
			[
				268,
				-7
			]
		],
		[
			[
				55461,
				82736
			],
			[
				342,
				-67
			],
			[
				511,
				9
			]
		],
		[
			[
				56535,
				81053
			],
			[
				139,
				-515
			],
			[
				-29,
				-166
			],
			[
				-138,
				-69
			],
			[
				-252,
				-491
			],
			[
				71,
				-266
			],
			[
				-60,
				35
			]
		],
		[
			[
				56266,
				79581
			],
			[
				-264,
				227
			],
			[
				-200,
				-84
			],
			[
				-131,
				61
			],
			[
				-165,
				-127
			],
			[
				-140,
				210
			],
			[
				-114,
				-81
			],
			[
				-16,
				36
			]
		],
		[
			[
				31588,
				61519
			],
			[
				142,
				-52
			],
			[
				50,
				-118
			],
			[
				-71,
				-149
			],
			[
				-209,
				4
			],
			[
				-163,
				-21
			],
			[
				-16,
				253
			],
			[
				40,
				86
			],
			[
				227,
				-3
			]
		],
		[
			[
				86288,
				75628
			],
			[
				39,
				-104
			]
		],
		[
			[
				86327,
				75524
			],
			[
				-106,
				36
			],
			[
				-120,
				-200
			],
			[
				-83,
				-202
			],
			[
				10,
				-424
			],
			[
				-143,
				-130
			],
			[
				-50,
				-105
			],
			[
				-104,
				-174
			],
			[
				-185,
				-97
			],
			[
				-121,
				-159
			],
			[
				-9,
				-256
			],
			[
				-32,
				-65
			],
			[
				111,
				-96
			],
			[
				157,
				-259
			]
		],
		[
			[
				85048,
				72883
			],
			[
				-135,
				112
			],
			[
				-34,
				-111
			],
			[
				-81,
				-49
			],
			[
				-10,
				112
			],
			[
				-72,
				54
			],
			[
				-75,
				94
			],
			[
				76,
				260
			],
			[
				66,
				69
			],
			[
				-25,
				108
			],
			[
				71,
				319
			],
			[
				-18,
				96
			],
			[
				-163,
				65
			],
			[
				-131,
				158
			]
		],
		[
			[
				47929,
				72498
			],
			[
				-112,
				-153
			],
			[
				-146,
				83
			],
			[
				-143,
				-65
			],
			[
				42,
				462
			],
			[
				-26,
				363
			],
			[
				-124,
				55
			],
			[
				-67,
				224
			],
			[
				22,
				386
			],
			[
				111,
				215
			],
			[
				20,
				239
			],
			[
				58,
				355
			],
			[
				-6,
				250
			],
			[
				-56,
				212
			],
			[
				-12,
				200
			]
		],
		[
			[
				64113,
				65205
			],
			[
				-18,
				430
			],
			[
				75,
				310
			],
			[
				76,
				64
			],
			[
				84,
				-185
			],
			[
				5,
				-346
			],
			[
				-61,
				-348
			]
		],
		[
			[
				64274,
				65130
			],
			[
				-77,
				-42
			],
			[
				-84,
				117
			]
		],
		[
			[
				56308,
				78869
			],
			[
				120,
				127
			],
			[
				172,
				-65
			],
			[
				178,
				-3
			],
			[
				129,
				-144
			],
			[
				95,
				91
			],
			[
				205,
				56
			],
			[
				69,
				139
			],
			[
				118,
				0
			]
		],
		[
			[
				57842,
				77455
			],
			[
				124,
				-109
			],
			[
				131,
				95
			],
			[
				126,
				-101
			]
		],
		[
			[
				58223,
				77340
			],
			[
				6,
				-152
			],
			[
				-135,
				-128
			],
			[
				-84,
				56
			],
			[
				-78,
				-713
			]
		],
		[
			[
				56293,
				76715
			],
			[
				-51,
				103
			],
			[
				65,
				99
			],
			[
				-69,
				74
			],
			[
				-87,
				-133
			],
			[
				-162,
				172
			],
			[
				-22,
				244
			],
			[
				-169,
				139
			],
			[
				-31,
				188
			],
			[
				-151,
				232
			]
		],
		[
			[
				89901,
				80562
			],
			[
				280,
				-1046
			],
			[
				-411,
				195
			],
			[
				-171,
				-854
			],
			[
				271,
				-605
			],
			[
				-8,
				-413
			],
			[
				-211,
				356
			],
			[
				-182,
				-457
			],
			[
				-51,
				496
			],
			[
				31,
				575
			],
			[
				-32,
				638
			],
			[
				64,
				446
			],
			[
				13,
				790
			],
			[
				-163,
				581
			],
			[
				24,
				808
			],
			[
				257,
				271
			],
			[
				-110,
				274
			],
			[
				123,
				83
			],
			[
				73,
				-391
			],
			[
				96,
				-569
			],
			[
				-7,
				-581
			],
			[
				114,
				-597
			]
		],
		[
			[
				55461,
				82736
			],
			[
				63,
				260
			],
			[
				383,
				191
			]
		],
		[
			[
				99999,
				92429
			],
			[
				-305,
				-30
			],
			[
				-49,
				187
			],
			[
				-99645,
				247
			],
			[
				36,
				24
			],
			[
				235,
				-1
			],
			[
				402,
				-169
			],
			[
				-24,
				-81
			],
			[
				-286,
				-141
			],
			[
				-363,
				-36
			],
			[
				99999,
				0
			]
		],
		[
			[
				89889,
				93835
			],
			[
				-421,
				-4
			],
			[
				-569,
				66
			],
			[
				-49,
				31
			],
			[
				263,
				234
			],
			[
				348,
				54
			],
			[
				394,
				-226
			],
			[
				34,
				-155
			]
		],
		[
			[
				91869,
				94941
			],
			[
				-321,
				-234
			],
			[
				-444,
				53
			],
			[
				-516,
				233
			],
			[
				66,
				192
			],
			[
				518,
				-89
			],
			[
				697,
				-155
			]
		],
		[
			[
				90301,
				95224
			],
			[
				-219,
				-439
			],
			[
				-1023,
				16
			],
			[
				-461,
				-139
			],
			[
				-550,
				384
			],
			[
				149,
				406
			],
			[
				366,
				111
			],
			[
				734,
				-26
			],
			[
				1004,
				-313
			]
		],
		[
			[
				65981,
				92363
			],
			[
				-164,
				-52
			],
			[
				-907,
				77
			],
			[
				-74,
				262
			],
			[
				-503,
				158
			],
			[
				-40,
				320
			],
			[
				284,
				126
			],
			[
				-10,
				323
			],
			[
				551,
				503
			],
			[
				-255,
				73
			],
			[
				665,
				518
			],
			[
				-75,
				268
			],
			[
				621,
				312
			],
			[
				917,
				380
			],
			[
				925,
				110
			],
			[
				475,
				220
			],
			[
				541,
				76
			],
			[
				193,
				-233
			],
			[
				-187,
				-184
			],
			[
				-984,
				-293
			],
			[
				-848,
				-282
			],
			[
				-863,
				-562
			],
			[
				-414,
				-577
			],
			[
				-435,
				-568
			],
			[
				56,
				-491
			],
			[
				531,
				-484
			]
		],
		[
			[
				63639,
				77993
			],
			[
				-127,
				-350
			],
			[
				-269,
				-97
			],
			[
				-276,
				-610
			],
			[
				252,
				-561
			],
			[
				-27,
				-398
			],
			[
				303,
				-696
			]
		],
		[
			[
				61098,
				76242
			],
			[
				-354,
				499
			],
			[
				-317,
				223
			],
			[
				-240,
				347
			],
			[
				202,
				95
			],
			[
				231,
				494
			],
			[
				-156,
				234
			],
			[
				410,
				241
			],
			[
				-8,
				129
			],
			[
				-249,
				-95
			]
		],
		[
			[
				60617,
				78409
			],
			[
				9,
				262
			],
			[
				143,
				165
			],
			[
				269,
				43
			],
			[
				44,
				197
			],
			[
				-62,
				326
			],
			[
				113,
				310
			],
			[
				-3,
				173
			],
			[
				-410,
				192
			],
			[
				-162,
				-6
			],
			[
				-172,
				277
			],
			[
				-213,
				-94
			],
			[
				-352,
				208
			],
			[
				6,
				116
			],
			[
				-99,
				256
			],
			[
				-222,
				29
			],
			[
				-23,
				183
			],
			[
				70,
				120
			],
			[
				-178,
				334
			],
			[
				-288,
				-57
			],
			[
				-84,
				30
			],
			[
				-70,
				-134
			],
			[
				-104,
				23
			]
		],
		[
			[
				57772,
				85719
			],
			[
				316,
				327
			],
			[
				-291,
				280
			]
		],
		[
			[
				58639,
				91676
			],
			[
				286,
				206
			],
			[
				456,
				-358
			],
			[
				761,
				-140
			],
			[
				1050,
				-668
			],
			[
				213,
				-281
			],
			[
				18,
				-393
			],
			[
				-308,
				-311
			],
			[
				-454,
				-157
			],
			[
				-1240,
				449
			],
			[
				-204,
				-75
			],
			[
				453,
				-433
			],
			[
				18,
				-274
			],
			[
				18,
				-604
			],
			[
				358,
				-180
			],
			[
				217,
				-153
			],
			[
				36,
				286
			],
			[
				-168,
				254
			],
			[
				177,
				224
			],
			[
				672,
				-368
			],
			[
				233,
				144
			],
			[
				-186,
				433
			],
			[
				647,
				578
			],
			[
				256,
				-34
			],
			[
				260,
				-206
			],
			[
				161,
				406
			],
			[
				-231,
				352
			],
			[
				136,
				353
			],
			[
				-204,
				367
			],
			[
				777,
				-190
			],
			[
				158,
				-331
			],
			[
				-351,
				-73
			],
			[
				1,
				-328
			],
			[
				219,
				-203
			],
			[
				429,
				128
			],
			[
				68,
				377
			],
			[
				580,
				282
			],
			[
				970,
				507
			],
			[
				209,
				-29
			],
			[
				-273,
				-359
			],
			[
				344,
				-61
			],
			[
				199,
				202
			],
			[
				521,
				16
			],
			[
				412,
				245
			],
			[
				317,
				-356
			],
			[
				315,
				391
			],
			[
				-291,
				343
			],
			[
				145,
				195
			],
			[
				820,
				-179
			],
			[
				385,
				-185
			],
			[
				1006,
				-675
			],
			[
				186,
				309
			],
			[
				-282,
				313
			],
			[
				-8,
				125
			],
			[
				-335,
				58
			],
			[
				92,
				280
			],
			[
				-149,
				461
			],
			[
				-8,
				189
			],
			[
				512,
				535
			],
			[
				183,
				537
			],
			[
				206,
				116
			],
			[
				736,
				-156
			],
			[
				57,
				-328
			],
			[
				-263,
				-479
			],
			[
				173,
				-189
			],
			[
				89,
				-413
			],
			[
				-63,
				-809
			],
			[
				307,
				-362
			],
			[
				-120,
				-395
			],
			[
				-544,
				-839
			],
			[
				318,
				-87
			],
			[
				110,
				213
			],
			[
				306,
				151
			],
			[
				74,
				293
			],
			[
				240,
				281
			],
			[
				-162,
				336
			],
			[
				130,
				390
			],
			[
				-304,
				49
			],
			[
				-67,
				328
			],
			[
				222,
				593
			],
			[
				-361,
				482
			],
			[
				497,
				398
			],
			[
				-64,
				421
			],
			[
				139,
				13
			],
			[
				145,
				-328
			],
			[
				-109,
				-570
			],
			[
				297,
				-108
			],
			[
				-127,
				426
			],
			[
				465,
				233
			],
			[
				577,
				31
			],
			[
				513,
				-337
			],
			[
				-247,
				492
			],
			[
				-28,
				630
			],
			[
				483,
				119
			],
			[
				669,
				-26
			],
			[
				602,
				77
			],
			[
				-226,
				309
			],
			[
				321,
				388
			],
			[
				319,
				16
			],
			[
				540,
				293
			],
			[
				734,
				79
			],
			[
				93,
				162
			],
			[
				729,
				55
			],
			[
				227,
				-133
			],
			[
				624,
				314
			],
			[
				510,
				-10
			],
			[
				77,
				255
			],
			[
				265,
				252
			],
			[
				656,
				242
			],
			[
				476,
				-191
			],
			[
				-378,
				-146
			],
			[
				629,
				-90
			],
			[
				75,
				-292
			],
			[
				254,
				143
			],
			[
				812,
				-7
			],
			[
				626,
				-289
			],
			[
				223,
				-221
			],
			[
				-69,
				-307
			],
			[
				-307,
				-175
			],
			[
				-730,
				-328
			],
			[
				-209,
				-175
			],
			[
				345,
				-83
			],
			[
				410,
				-149
			],
			[
				251,
				112
			],
			[
				141,
				-379
			],
			[
				122,
				153
			],
			[
				444,
				93
			],
			[
				892,
				-97
			],
			[
				67,
				-276
			],
			[
				1162,
				-88
			],
			[
				15,
				451
			],
			[
				590,
				-104
			],
			[
				443,
				4
			],
			[
				449,
				-312
			],
			[
				128,
				-378
			],
			[
				-165,
				-247
			],
			[
				349,
				-465
			],
			[
				437,
				-240
			],
			[
				268,
				620
			],
			[
				446,
				-266
			],
			[
				473,
				159
			],
			[
				538,
				-182
			],
			[
				204,
				166
			],
			[
				455,
				-83
			],
			[
				-201,
				549
			],
			[
				367,
				256
			],
			[
				2509,
				-384
			],
			[
				236,
				-351
			],
			[
				727,
				-451
			],
			[
				1122,
				112
			],
			[
				553,
				-98
			],
			[
				231,
				-244
			],
			[
				-33,
				-432
			],
			[
				342,
				-168
			],
			[
				372,
				121
			],
			[
				492,
				15
			],
			[
				525,
				-116
			],
			[
				526,
				66
			],
			[
				484,
				-526
			],
			[
				344,
				189
			],
			[
				-224,
				378
			],
			[
				123,
				262
			],
			[
				886,
				-165
			],
			[
				578,
				36
			],
			[
				799,
				-282
			],
			[
				-99610,
				-258
			],
			[
				681,
				-451
			],
			[
				728,
				-588
			],
			[
				-24,
				-367
			],
			[
				187,
				-147
			],
			[
				-64,
				429
			],
			[
				754,
				-88
			],
			[
				544,
				-553
			],
			[
				-276,
				-257
			],
			[
				-455,
				-61
			],
			[
				-7,
				-578
			],
			[
				-111,
				-122
			],
			[
				-260,
				17
			],
			[
				-212,
				206
			],
			[
				-369,
				172
			],
			[
				-62,
				257
			],
			[
				-283,
				96
			],
			[
				-315,
				-76
			],
			[
				-151,
				207
			],
			[
				60,
				219
			],
			[
				-333,
				-140
			],
			[
				126,
				-278
			],
			[
				-158,
				-251
			],
			[
				99997,
				-3
			],
			[
				-357,
				-260
			],
			[
				-360,
				44
			],
			[
				250,
				-315
			],
			[
				166,
				-487
			],
			[
				128,
				-159
			],
			[
				32,
				-244
			],
			[
				-71,
				-157
			],
			[
				-518,
				129
			],
			[
				-777,
				-445
			],
			[
				-247,
				-69
			],
			[
				-425,
				-415
			],
			[
				-403,
				-362
			],
			[
				-102,
				-269
			],
			[
				-397,
				409
			],
			[
				-724,
				-464
			],
			[
				-126,
				219
			],
			[
				-268,
				-253
			],
			[
				-371,
				81
			],
			[
				-90,
				-388
			],
			[
				-333,
				-572
			],
			[
				10,
				-239
			],
			[
				316,
				-132
			],
			[
				-37,
				-860
			],
			[
				-258,
				-22
			],
			[
				-119,
				-494
			],
			[
				116,
				-255
			],
			[
				-486,
				-302
			],
			[
				-96,
				-674
			],
			[
				-415,
				-144
			],
			[
				-83,
				-600
			],
			[
				-400,
				-551
			],
			[
				-103,
				407
			],
			[
				-119,
				862
			],
			[
				-155,
				1313
			],
			[
				134,
				819
			],
			[
				234,
				353
			],
			[
				14,
				276
			],
			[
				432,
				132
			],
			[
				496,
				744
			],
			[
				479,
				608
			],
			[
				499,
				471
			],
			[
				223,
				833
			],
			[
				-337,
				-50
			],
			[
				-167,
				-487
			],
			[
				-705,
				-649
			],
			[
				-227,
				727
			],
			[
				-717,
				-201
			],
			[
				-696,
				-990
			],
			[
				230,
				-362
			],
			[
				-620,
				-154
			],
			[
				-430,
				-61
			],
			[
				20,
				427
			],
			[
				-431,
				90
			],
			[
				-344,
				-291
			],
			[
				-850,
				102
			],
			[
				-914,
				-175
			],
			[
				-899,
				-1153
			],
			[
				-1065,
				-1394
			],
			[
				438,
				-74
			],
			[
				136,
				-370
			],
			[
				270,
				-132
			],
			[
				178,
				295
			],
			[
				305,
				-38
			],
			[
				401,
				-650
			],
			[
				9,
				-503
			],
			[
				-217,
				-590
			],
			[
				-23,
				-705
			],
			[
				-126,
				-945
			],
			[
				-418,
				-855
			],
			[
				-94,
				-409
			],
			[
				-377,
				-688
			],
			[
				-374,
				-682
			],
			[
				-179,
				-349
			],
			[
				-370,
				-346
			],
			[
				-175,
				-8
			],
			[
				-175,
				287
			],
			[
				-373,
				-432
			],
			[
				-43,
				-197
			]
		],
		[
			[
				79187,
				96845
			],
			[
				-1566,
				-228
			],
			[
				507,
				776
			],
			[
				229,
				66
			],
			[
				208,
				-38
			],
			[
				704,
				-336
			],
			[
				-82,
				-240
			]
		],
		[
			[
				64204,
				98169
			],
			[
				-373,
				-78
			],
			[
				-250,
				-45
			],
			[
				-39,
				-97
			],
			[
				-324,
				-98
			],
			[
				-301,
				140
			],
			[
				158,
				185
			],
			[
				-618,
				18
			],
			[
				542,
				107
			],
			[
				422,
				8
			],
			[
				57,
				-160
			],
			[
				159,
				142
			],
			[
				262,
				97
			],
			[
				412,
				-129
			],
			[
				-107,
				-90
			]
		],
		[
			[
				77760,
				97184
			],
			[
				-606,
				-73
			],
			[
				-773,
				170
			],
			[
				-462,
				226
			],
			[
				-213,
				423
			],
			[
				-379,
				117
			],
			[
				722,
				404
			],
			[
				600,
				133
			],
			[
				540,
				-297
			],
			[
				640,
				-572
			],
			[
				-69,
				-531
			]
		],
		[
			[
				58449,
				49909
			],
			[
				110,
				-333
			],
			[
				-16,
				-348
			],
			[
				-80,
				-74
			]
		],
		[
			[
				58216,
				49787
			],
			[
				67,
				-60
			],
			[
				166,
				182
			]
		],
		[
			[
				45260,
				62987
			],
			[
				12,
				249
			]
		],
		[
			[
				61883,
				60238
			],
			[
				-37,
				252
			],
			[
				-83,
				178
			],
			[
				-22,
				236
			],
			[
				-143,
				212
			],
			[
				-148,
				495
			],
			[
				-79,
				482
			],
			[
				-192,
				406
			],
			[
				-124,
				97
			],
			[
				-184,
				563
			],
			[
				-32,
				411
			],
			[
				12,
				350
			],
			[
				-159,
				655
			],
			[
				-130,
				231
			],
			[
				-150,
				122
			],
			[
				-92,
				339
			],
			[
				15,
				133
			],
			[
				-77,
				306
			],
			[
				-81,
				132
			],
			[
				-108,
				440
			],
			[
				-170,
				476
			],
			[
				-141,
				406
			],
			[
				-139,
				-3
			],
			[
				44,
				325
			],
			[
				12,
				206
			],
			[
				34,
				236
			]
		],
		[
			[
				63448,
				67449
			],
			[
				109,
				-510
			],
			[
				137,
				-135
			],
			[
				47,
				-207
			],
			[
				190,
				-249
			],
			[
				16,
				-243
			],
			[
				-27,
				-197
			],
			[
				35,
				-199
			],
			[
				80,
				-165
			],
			[
				37,
				-194
			],
			[
				41,
				-145
			]
		],
		[
			[
				64274,
				65130
			],
			[
				53,
				-226
			]
		],
		[
			[
				64444,
				61805
			],
			[
				-801,
				-226
			],
			[
				-259,
				-266
			],
			[
				-199,
				-620
			],
			[
				-130,
				-99
			],
			[
				-70,
				197
			],
			[
				-106,
				-30
			],
			[
				-269,
				60
			],
			[
				-50,
				59
			],
			[
				-321,
				-14
			],
			[
				-75,
				-53
			],
			[
				-114,
				153
			],
			[
				-74,
				-290
			],
			[
				28,
				-249
			],
			[
				-121,
				-189
			]
		],
		[
			[
				59434,
				56171
			],
			[
				-39,
				12
			],
			[
				5,
				294
			],
			[
				-33,
				203
			],
			[
				-143,
				233
			],
			[
				-34,
				426
			],
			[
				34,
				436
			],
			[
				-129,
				41
			],
			[
				-19,
				-132
			],
			[
				-167,
				-30
			],
			[
				67,
				-173
			],
			[
				23,
				-355
			],
			[
				-152,
				-324
			],
			[
				-138,
				-426
			],
			[
				-144,
				-61
			],
			[
				-233,
				345
			],
			[
				-105,
				-122
			],
			[
				-29,
				-172
			],
			[
				-143,
				-112
			],
			[
				-9,
				-122
			],
			[
				-277,
				0
			],
			[
				-38,
				122
			],
			[
				-200,
				20
			],
			[
				-100,
				-101
			],
			[
				-77,
				51
			],
			[
				-143,
				344
			],
			[
				-48,
				163
			],
			[
				-200,
				-81
			],
			[
				-76,
				-274
			],
			[
				-72,
				-528
			],
			[
				-95,
				-111
			],
			[
				-85,
				-65
			]
		],
		[
			[
				56635,
				55672
			],
			[
				-23,
				28
			]
		],
		[
			[
				56351,
				57163
			],
			[
				3,
				143
			],
			[
				-102,
				174
			],
			[
				-3,
				343
			],
			[
				-58,
				228
			],
			[
				-98,
				-34
			],
			[
				28,
				217
			],
			[
				72,
				246
			],
			[
				-32,
				245
			],
			[
				92,
				181
			],
			[
				-58,
				138
			],
			[
				73,
				365
			],
			[
				127,
				435
			],
			[
				240,
				-41
			],
			[
				-14,
				2345
			]
		],
		[
			[
				60240,
				63578
			],
			[
				90,
				-580
			],
			[
				-61,
				-107
			],
			[
				40,
				-608
			],
			[
				102,
				-706
			],
			[
				106,
				-145
			],
			[
				152,
				-219
			]
		],
		[
			[
				59433,
				56242
			],
			[
				1,
				-71
			]
		],
		[
			[
				59434,
				56171
			],
			[
				3,
				-460
			]
		],
		[
			[
				59445,
				53091
			],
			[
				-171,
				-272
			],
			[
				-195,
				1
			],
			[
				-224,
				-138
			],
			[
				-176,
				132
			],
			[
				-115,
				-161
			]
		],
		[
			[
				56824,
				55442
			],
			[
				-189,
				230
			]
		],
		[
			[
				45357,
				58612
			],
			[
				-115,
				460
			],
			[
				-138,
				210
			],
			[
				122,
				112
			],
			[
				134,
				415
			],
			[
				66,
				304
			]
		],
		[
			[
				45367,
				57897
			],
			[
				-46,
				453
			]
		],
		[
			[
				95032,
				44386
			],
			[
				78,
				-203
			],
			[
				-194,
				4
			],
			[
				-106,
				363
			],
			[
				166,
				-142
			],
			[
				56,
				-22
			]
		],
		[
			[
				94680,
				44747
			],
			[
				-108,
				-14
			],
			[
				-170,
				60
			],
			[
				-58,
				91
			],
			[
				17,
				235
			],
			[
				183,
				-93
			],
			[
				91,
				-124
			],
			[
				45,
				-155
			]
		],
		[
			[
				94910,
				44908
			],
			[
				-42,
				-109
			],
			[
				-206,
				512
			],
			[
				-57,
				353
			],
			[
				94,
				0
			],
			[
				100,
				-473
			],
			[
				111,
				-283
			]
		],
		[
			[
				94409,
				45654
			],
			[
				12,
				-119
			],
			[
				-218,
				251
			],
			[
				-152,
				212
			],
			[
				-104,
				197
			],
			[
				41,
				60
			],
			[
				128,
				-142
			],
			[
				228,
				-272
			],
			[
				65,
				-187
			]
		],
		[
			[
				93760,
				46238
			],
			[
				-56,
				-33
			],
			[
				-121,
				134
			],
			[
				-114,
				243
			],
			[
				14,
				99
			],
			[
				166,
				-250
			],
			[
				111,
				-193
			]
		],
		[
			[
				46822,
				54589
			],
			[
				-75,
				44
			],
			[
				-200,
				238
			],
			[
				-144,
				316
			],
			[
				-49,
				216
			],
			[
				-34,
				437
			]
		],
		[
			[
				25613,
				58487
			],
			[
				-31,
				-139
			],
			[
				-161,
				9
			],
			[
				-100,
				57
			],
			[
				-115,
				117
			],
			[
				-154,
				37
			],
			[
				-79,
				127
			]
		],
		[
			[
				61984,
				57352
			],
			[
				91,
				-109
			],
			[
				54,
				-245
			],
			[
				125,
				-247
			],
			[
				138,
				-2
			],
			[
				262,
				151
			],
			[
				302,
				70
			],
			[
				245,
				184
			],
			[
				138,
				39
			],
			[
				99,
				108
			],
			[
				158,
				20
			]
		],
		[
			[
				63596,
				57321
			],
			[
				-2,
				-9
			],
			[
				-1,
				-244
			],
			[
				0,
				-596
			],
			[
				0,
				-308
			],
			[
				-125,
				-363
			],
			[
				-194,
				-493
			]
		],
		[
			[
				63596,
				57321
			],
			[
				89,
				12
			],
			[
				128,
				88
			],
			[
				147,
				59
			],
			[
				132,
				202
			],
			[
				105,
				2
			],
			[
				6,
				-163
			],
			[
				-25,
				-344
			],
			[
				1,
				-310
			],
			[
				-59,
				-214
			],
			[
				-78,
				-639
			],
			[
				-134,
				-659
			],
			[
				-172,
				-755
			],
			[
				-238,
				-866
			],
			[
				-237,
				-661
			],
			[
				-327,
				-806
			],
			[
				-278,
				-479
			],
			[
				-415,
				-586
			],
			[
				-259,
				-450
			],
			[
				-304,
				-715
			],
			[
				-64,
				-312
			],
			[
				-63,
				-140
			]
		],
		[
			[
				34125,
				54109
			],
			[
				333,
				-119
			],
			[
				30,
				107
			],
			[
				225,
				43
			],
			[
				298,
				-159
			]
		],
		[
			[
				34889,
				53069
			],
			[
				109,
				-351
			],
			[
				-49,
				-254
			],
			[
				-24,
				-270
			],
			[
				-71,
				-248
			]
		],
		[
			[
				56266,
				79581
			],
			[
				-77,
				-154
			],
			[
				-55,
				-238
			]
		],
		[
			[
				53809,
				77462
			],
			[
				62,
				54
			]
		],
		[
			[
				56639,
				89578
			],
			[
				-478,
				-167
			],
			[
				-269,
				-413
			],
			[
				43,
				-361
			],
			[
				-441,
				-475
			],
			[
				-537,
				-509
			],
			[
				-202,
				-832
			],
			[
				198,
				-416
			],
			[
				265,
				-328
			],
			[
				-255,
				-666
			],
			[
				-289,
				-138
			],
			[
				-106,
				-992
			],
			[
				-157,
				-554
			],
			[
				-337,
				57
			],
			[
				-158,
				-468
			],
			[
				-321,
				-27
			],
			[
				-89,
				558
			],
			[
				-232,
				671
			],
			[
				-211,
				835
			]
		],
		[
			[
				58908,
				34785
			],
			[
				-56,
				-263
			],
			[
				-163,
				-63
			],
			[
				-166,
				320
			],
			[
				-2,
				204
			],
			[
				76,
				222
			],
			[
				26,
				172
			],
			[
				80,
				42
			],
			[
				140,
				-108
			]
		],
		[
			[
				59999,
				71049
			],
			[
				-26,
				452
			],
			[
				68,
				243
			]
		],
		[
			[
				60041,
				71744
			],
			[
				74,
				129
			],
			[
				75,
				130
			],
			[
				15,
				329
			],
			[
				91,
				-115
			],
			[
				306,
				165
			],
			[
				147,
				-112
			],
			[
				229,
				2
			],
			[
				320,
				222
			],
			[
				149,
				-10
			],
			[
				316,
				92
			]
		],
		[
			[
				50518,
				54209
			],
			[
				-224,
				-126
			]
		],
		[
			[
				78495,
				57780
			],
			[
				-249,
				271
			],
			[
				-238,
				-11
			],
			[
				41,
				464
			],
			[
				-245,
				-3
			],
			[
				-22,
				-650
			],
			[
				-150,
				-863
			],
			[
				-90,
				-522
			],
			[
				19,
				-428
			],
			[
				181,
				-18
			],
			[
				113,
				-539
			],
			[
				50,
				-512
			],
			[
				155,
				-338
			],
			[
				168,
				-69
			],
			[
				144,
				-306
			]
		],
		[
			[
				77801,
				54399
			],
			[
				-110,
				227
			],
			[
				-47,
				292
			],
			[
				-148,
				334
			],
			[
				-135,
				280
			],
			[
				-45,
				-347
			],
			[
				-53,
				328
			],
			[
				30,
				369
			],
			[
				82,
				566
			]
		],
		[
			[
				68841,
				72526
			],
			[
				156,
				598
			],
			[
				-60,
				440
			],
			[
				-204,
				140
			],
			[
				72,
				261
			],
			[
				232,
				-28
			],
			[
				132,
				326
			],
			[
				89,
				380
			],
			[
				371,
				137
			],
			[
				-58,
				-274
			],
			[
				40,
				-164
			],
			[
				114,
				15
			]
		],
		[
			[
				64978,
				72558
			],
			[
				-52,
				417
			],
			[
				40,
				618
			],
			[
				-216,
				200
			],
			[
				71,
				405
			],
			[
				-184,
				34
			],
			[
				61,
				498
			],
			[
				262,
				-145
			],
			[
				244,
				189
			],
			[
				-202,
				355
			],
			[
				-80,
				338
			],
			[
				-224,
				-151
			],
			[
				-28,
				-433
			],
			[
				-87,
				383
			]
		],
		[
			[
				65546,
				74986
			],
			[
				313,
				8
			],
			[
				-45,
				297
			],
			[
				237,
				204
			],
			[
				234,
				343
			],
			[
				374,
				-312
			],
			[
				30,
				-471
			],
			[
				106,
				-121
			],
			[
				301,
				27
			],
			[
				93,
				-108
			],
			[
				137,
				-609
			],
			[
				317,
				-408
			],
			[
				181,
				-278
			],
			[
				291,
				-289
			],
			[
				369,
				-253
			],
			[
				-7,
				-362
			]
		],
		[
			[
				84713,
				45326
			],
			[
				32,
				139
			],
			[
				239,
				133
			],
			[
				194,
				20
			],
			[
				87,
				74
			],
			[
				105,
				-74
			],
			[
				-102,
				-160
			],
			[
				-289,
				-258
			],
			[
				-233,
				-170
			]
		],
		[
			[
				32866,
				56937
			],
			[
				160,
				77
			],
			[
				58,
				-21
			],
			[
				-11,
				-440
			],
			[
				-232,
				-65
			],
			[
				-50,
				53
			],
			[
				81,
				163
			],
			[
				-6,
				233
			]
		],
		[
			[
				52339,
				72408
			],
			[
				302,
				239
			],
			[
				195,
				-71
			],
			[
				-9,
				-299
			],
			[
				236,
				217
			],
			[
				20,
				-113
			],
			[
				-139,
				-290
			],
			[
				-2,
				-273
			],
			[
				96,
				-147
			],
			[
				-36,
				-511
			],
			[
				-183,
				-297
			],
			[
				53,
				-322
			],
			[
				143,
				-10
			],
			[
				70,
				-281
			],
			[
				106,
				-92
			]
		],
		[
			[
				60041,
				71744
			],
			[
				-102,
				268
			],
			[
				105,
				222
			],
			[
				-169,
				-51
			],
			[
				-233,
				136
			],
			[
				-191,
				-340
			],
			[
				-421,
				-66
			],
			[
				-225,
				317
			],
			[
				-300,
				20
			],
			[
				-64,
				-245
			],
			[
				-192,
				-70
			],
			[
				-268,
				314
			],
			[
				-303,
				-11
			],
			[
				-165,
				588
			],
			[
				-203,
				328
			],
			[
				135,
				459
			],
			[
				-176,
				283
			],
			[
				308,
				565
			],
			[
				428,
				23
			],
			[
				117,
				449
			],
			[
				529,
				-78
			],
			[
				334,
				383
			],
			[
				324,
				167
			],
			[
				459,
				13
			],
			[
				485,
				-417
			],
			[
				399,
				-228
			],
			[
				323,
				91
			],
			[
				239,
				-53
			],
			[
				328,
				309
			]
		],
		[
			[
				57776,
				75399
			],
			[
				33,
				-228
			],
			[
				243,
				-190
			],
			[
				-51,
				-145
			],
			[
				-330,
				-33
			],
			[
				-118,
				-182
			],
			[
				-232,
				-319
			],
			[
				-87,
				276
			],
			[
				3,
				121
			]
		],
		[
			[
				83826,
				64992
			],
			[
				-167,
				-947
			],
			[
				-119,
				-485
			],
			[
				-146,
				499
			],
			[
				-32,
				438
			],
			[
				163,
				581
			],
			[
				223,
				447
			],
			[
				127,
				-176
			],
			[
				-49,
				-357
			]
		],
		[
			[
				60889,
				47817
			],
			[
				-128,
				-728
			],
			[
				16,
				-335
			],
			[
				178,
				-216
			],
			[
				8,
				-153
			],
			[
				-76,
				-357
			],
			[
				16,
				-180
			],
			[
				-18,
				-282
			],
			[
				97,
				-370
			],
			[
				115,
				-583
			],
			[
				101,
				-129
			]
		],
		[
			[
				59099,
				45126
			],
			[
				-157,
				177
			],
			[
				-177,
				100
			],
			[
				-111,
				99
			],
			[
				-116,
				150
			]
		],
		[
			[
				58388,
				46397
			],
			[
				-161,
				331
			],
			[
				-55,
				342
			]
		],
		[
			[
				58449,
				49909
			],
			[
				98,
				71
			],
			[
				304,
				-7
			],
			[
				566,
				45
			]
		],
		[
			[
				60617,
				78409
			],
			[
				-222,
				-48
			],
			[
				-185,
				-191
			],
			[
				-260,
				-31
			],
			[
				-239,
				-220
			],
			[
				16,
				-368
			],
			[
				136,
				-142
			],
			[
				284,
				35
			],
			[
				-55,
				-210
			],
			[
				-304,
				-103
			],
			[
				-377,
				-342
			],
			[
				-154,
				121
			],
			[
				61,
				277
			],
			[
				-304,
				173
			],
			[
				50,
				113
			],
			[
				265,
				197
			],
			[
				-80,
				135
			],
			[
				-432,
				149
			],
			[
				-19,
				221
			],
			[
				-257,
				-73
			],
			[
				-103,
				-325
			],
			[
				-215,
				-437
			]
		],
		[
			[
				35174,
				30629
			],
			[
				-121,
				-372
			],
			[
				-313,
				-328
			],
			[
				-205,
				118
			],
			[
				-151,
				-63
			],
			[
				-256,
				253
			],
			[
				-189,
				-19
			],
			[
				-169,
				327
			]
		],
		[
			[
				6794,
				61855
			],
			[
				-41,
				-99
			],
			[
				-69,
				84
			],
			[
				8,
				165
			],
			[
				-46,
				216
			],
			[
				14,
				65
			],
			[
				48,
				97
			],
			[
				-19,
				116
			],
			[
				16,
				55
			],
			[
				21,
				-11
			],
			[
				107,
				-100
			],
			[
				49,
				-51
			],
			[
				45,
				-79
			],
			[
				71,
				-207
			],
			[
				-7,
				-33
			],
			[
				-108,
				-126
			],
			[
				-89,
				-92
			]
		],
		[
			[
				6645,
				62777
			],
			[
				-94,
				-43
			],
			[
				-47,
				125
			],
			[
				-32,
				48
			],
			[
				-3,
				37
			],
			[
				27,
				50
			],
			[
				99,
				-56
			],
			[
				73,
				-90
			],
			[
				-23,
				-71
			]
		],
		[
			[
				6456,
				63091
			],
			[
				-9,
				-63
			],
			[
				-149,
				17
			],
			[
				21,
				72
			],
			[
				137,
				-26
			]
		],
		[
			[
				6207,
				63177
			],
			[
				-15,
				-34
			],
			[
				-19,
				8
			],
			[
				-97,
				21
			],
			[
				-35,
				133
			],
			[
				-11,
				24
			],
			[
				74,
				82
			],
			[
				23,
				-38
			],
			[
				80,
				-196
			]
		],
		[
			[
				5737,
				63567
			],
			[
				-33,
				-58
			],
			[
				-93,
				107
			],
			[
				14,
				43
			],
			[
				43,
				58
			],
			[
				64,
				-12
			],
			[
				5,
				-138
			]
		],
		[
			[
				31350,
				77248
			],
			[
				48,
				-194
			],
			[
				-296,
				-286
			],
			[
				-286,
				-204
			],
			[
				-293,
				-175
			],
			[
				-147,
				-351
			],
			[
				-47,
				-133
			],
			[
				-3,
				-313
			],
			[
				92,
				-313
			],
			[
				115,
				-15
			],
			[
				-29,
				216
			],
			[
				83,
				-131
			],
			[
				-22,
				-169
			],
			[
				-188,
				-96
			],
			[
				-133,
				11
			],
			[
				-205,
				-103
			],
			[
				-121,
				-29
			],
			[
				-162,
				-29
			],
			[
				-231,
				-171
			],
			[
				408,
				111
			],
			[
				82,
				-112
			],
			[
				-389,
				-177
			],
			[
				-177,
				-1
			],
			[
				8,
				72
			],
			[
				-84,
				-164
			],
			[
				82,
				-27
			],
			[
				-60,
				-424
			],
			[
				-203,
				-455
			],
			[
				-20,
				152
			],
			[
				-61,
				30
			],
			[
				-91,
				148
			],
			[
				57,
				-318
			],
			[
				69,
				-105
			],
			[
				5,
				-223
			],
			[
				-89,
				-230
			],
			[
				-157,
				-472
			],
			[
				-25,
				24
			],
			[
				86,
				402
			],
			[
				-142,
				225
			],
			[
				-33,
				491
			],
			[
				-53,
				-255
			],
			[
				59,
				-375
			],
			[
				-183,
				93
			],
			[
				191,
				-191
			],
			[
				12,
				-562
			],
			[
				79,
				-41
			],
			[
				29,
				-204
			],
			[
				39,
				-591
			],
			[
				-176,
				-439
			],
			[
				-288,
				-175
			],
			[
				-182,
				-346
			],
			[
				-139,
				-38
			],
			[
				-141,
				-217
			],
			[
				-39,
				-199
			],
			[
				-305,
				-383
			],
			[
				-157,
				-281
			],
			[
				-131,
				-351
			],
			[
				-43,
				-419
			],
			[
				50,
				-411
			],
			[
				92,
				-505
			],
			[
				124,
				-418
			],
			[
				1,
				-256
			],
			[
				132,
				-685
			],
			[
				-9,
				-398
			],
			[
				-12,
				-230
			],
			[
				-69,
				-361
			],
			[
				-83,
				-75
			],
			[
				-137,
				72
			],
			[
				-44,
				259
			],
			[
				-105,
				136
			],
			[
				-148,
				508
			],
			[
				-129,
				452
			],
			[
				-42,
				231
			],
			[
				57,
				393
			],
			[
				-77,
				325
			],
			[
				-217,
				494
			],
			[
				-108,
				90
			],
			[
				-281,
				-268
			],
			[
				-49,
				30
			],
			[
				-135,
				275
			],
			[
				-174,
				147
			],
			[
				-314,
				-75
			],
			[
				-247,
				66
			],
			[
				-212,
				-41
			],
			[
				-114,
				-92
			],
			[
				50,
				-157
			],
			[
				-5,
				-240
			],
			[
				59,
				-117
			],
			[
				-53,
				-77
			],
			[
				-103,
				87
			],
			[
				-104,
				-112
			],
			[
				-202,
				18
			],
			[
				-207,
				312
			],
			[
				-242,
				-73
			],
			[
				-202,
				137
			],
			[
				-173,
				-42
			],
			[
				-234,
				-138
			],
			[
				-253,
				-438
			],
			[
				-276,
				-255
			],
			[
				-152,
				-282
			],
			[
				-63,
				-266
			],
			[
				-3,
				-407
			],
			[
				14,
				-284
			],
			[
				52,
				-201
			]
		],
		[
			[
				17464,
				69802
			],
			[
				-46,
				302
			],
			[
				-180,
				340
			],
			[
				-130,
				71
			],
			[
				-30,
				169
			],
			[
				-156,
				30
			],
			[
				-100,
				159
			],
			[
				-258,
				59
			],
			[
				-71,
				95
			],
			[
				-33,
				324
			],
			[
				-270,
				594
			],
			[
				-231,
				821
			],
			[
				10,
				137
			],
			[
				-123,
				195
			],
			[
				-215,
				495
			],
			[
				-38,
				482
			],
			[
				-148,
				323
			],
			[
				61,
				489
			],
			[
				-10,
				507
			],
			[
				-89,
				453
			],
			[
				109,
				557
			],
			[
				34,
				536
			],
			[
				33,
				536
			],
			[
				-50,
				792
			],
			[
				-88,
				506
			],
			[
				-80,
				274
			],
			[
				33,
				115
			],
			[
				402,
				-200
			],
			[
				148,
				-558
			],
			[
				69,
				156
			],
			[
				-45,
				484
			],
			[
				-94,
				485
			]
		],
		[
			[
				7498,
				84325
			],
			[
				-277,
				-225
			],
			[
				-142,
				152
			],
			[
				-43,
				277
			],
			[
				252,
				210
			],
			[
				148,
				90
			],
			[
				185,
				-40
			],
			[
				117,
				-183
			],
			[
				-240,
				-281
			]
		],
		[
			[
				4006,
				85976
			],
			[
				-171,
				-92
			],
			[
				-182,
				110
			],
			[
				-168,
				161
			],
			[
				274,
				101
			],
			[
				220,
				-54
			],
			[
				27,
				-226
			]
		],
		[
			[
				2297,
				88264
			],
			[
				171,
				-113
			],
			[
				173,
				61
			],
			[
				225,
				-156
			],
			[
				276,
				-79
			],
			[
				-23,
				-64
			],
			[
				-211,
				-125
			],
			[
				-211,
				128
			],
			[
				-106,
				107
			],
			[
				-245,
				-34
			],
			[
				-66,
				52
			],
			[
				17,
				223
			]
		],
		[
			[
				13740,
				82958
			],
			[
				-153,
				223
			],
			[
				-245,
				188
			],
			[
				-78,
				515
			],
			[
				-358,
				478
			],
			[
				-150,
				558
			],
			[
				-267,
				38
			],
			[
				-441,
				15
			],
			[
				-326,
				170
			],
			[
				-574,
				613
			],
			[
				-266,
				112
			],
			[
				-486,
				211
			],
			[
				-385,
				-51
			],
			[
				-546,
				272
			],
			[
				-330,
				252
			],
			[
				-309,
				-125
			],
			[
				58,
				-411
			],
			[
				-154,
				-38
			],
			[
				-321,
				-123
			],
			[
				-245,
				-199
			],
			[
				-308,
				-126
			],
			[
				-39,
				348
			],
			[
				125,
				580
			],
			[
				295,
				182
			],
			[
				-76,
				148
			],
			[
				-354,
				-329
			],
			[
				-190,
				-394
			],
			[
				-400,
				-420
			],
			[
				203,
				-287
			],
			[
				-262,
				-424
			],
			[
				-299,
				-248
			],
			[
				-278,
				-180
			],
			[
				-69,
				-261
			],
			[
				-434,
				-305
			],
			[
				-87,
				-278
			],
			[
				-325,
				-252
			],
			[
				-191,
				45
			],
			[
				-259,
				-165
			],
			[
				-282,
				-201
			],
			[
				-231,
				-197
			],
			[
				-477,
				-169
			],
			[
				-43,
				99
			],
			[
				304,
				276
			],
			[
				271,
				182
			],
			[
				296,
				324
			],
			[
				345,
				66
			],
			[
				137,
				243
			],
			[
				385,
				353
			],
			[
				62,
				119
			],
			[
				205,
				208
			],
			[
				48,
				448
			],
			[
				141,
				349
			],
			[
				-320,
				-179
			],
			[
				-90,
				102
			],
			[
				-150,
				-215
			],
			[
				-181,
				300
			],
			[
				-75,
				-212
			],
			[
				-104,
				294
			],
			[
				-278,
				-236
			],
			[
				-170,
				0
			],
			[
				-24,
				352
			],
			[
				50,
				216
			],
			[
				-179,
				211
			],
			[
				-361,
				-113
			],
			[
				-235,
				277
			],
			[
				-190,
				142
			],
			[
				-1,
				334
			],
			[
				-214,
				252
			],
			[
				108,
				340
			],
			[
				226,
				330
			],
			[
				99,
				303
			],
			[
				225,
				43
			],
			[
				191,
				-94
			],
			[
				224,
				285
			],
			[
				201,
				-51
			],
			[
				212,
				183
			],
			[
				-52,
				270
			],
			[
				-155,
				106
			],
			[
				205,
				228
			],
			[
				-170,
				-7
			],
			[
				-295,
				-128
			],
			[
				-85,
				-131
			],
			[
				-219,
				131
			],
			[
				-392,
				-67
			],
			[
				-407,
				142
			],
			[
				-117,
				238
			],
			[
				-351,
				343
			],
			[
				390,
				247
			],
			[
				620,
				289
			],
			[
				228,
				0
			],
			[
				-38,
				-296
			],
			[
				586,
				23
			],
			[
				-225,
				366
			],
			[
				-342,
				225
			],
			[
				-197,
				296
			],
			[
				-267,
				252
			],
			[
				-381,
				187
			],
			[
				155,
				309
			],
			[
				493,
				19
			],
			[
				350,
				270
			],
			[
				66,
				287
			],
			[
				284,
				281
			],
			[
				271,
				68
			],
			[
				526,
				262
			],
			[
				256,
				-40
			],
			[
				427,
				315
			],
			[
				421,
				-124
			],
			[
				201,
				-266
			],
			[
				123,
				114
			],
			[
				469,
				-35
			],
			[
				-16,
				-136
			],
			[
				425,
				-101
			],
			[
				283,
				59
			],
			[
				585,
				-186
			],
			[
				534,
				-56
			],
			[
				214,
				-77
			],
			[
				370,
				96
			],
			[
				421,
				-177
			],
			[
				302,
				-83
			]
		],
		[
			[
				30185,
				57537
			],
			[
				-8,
				-139
			],
			[
				-163,
				-69
			],
			[
				91,
				-268
			],
			[
				-3,
				-309
			],
			[
				-123,
				-344
			],
			[
				105,
				-468
			],
			[
				120,
				38
			],
			[
				62,
				427
			],
			[
				-86,
				208
			],
			[
				-14,
				447
			],
			[
				346,
				241
			],
			[
				-38,
				278
			],
			[
				97,
				186
			],
			[
				100,
				-415
			],
			[
				195,
				-9
			],
			[
				180,
				-330
			],
			[
				11,
				-195
			],
			[
				249,
				-6
			],
			[
				297,
				61
			],
			[
				159,
				-264
			],
			[
				213,
				-74
			],
			[
				155,
				185
			],
			[
				4,
				149
			],
			[
				344,
				35
			],
			[
				333,
				9
			],
			[
				-236,
				-175
			],
			[
				95,
				-279
			],
			[
				222,
				-44
			],
			[
				210,
				-291
			],
			[
				45,
				-473
			],
			[
				144,
				13
			],
			[
				109,
				-139
			]
		],
		[
			[
				80013,
				63313
			],
			[
				-371,
				-505
			],
			[
				-231,
				-558
			],
			[
				-61,
				-410
			],
			[
				212,
				-623
			],
			[
				260,
				-772
			],
			[
				252,
				-365
			],
			[
				169,
				-475
			],
			[
				127,
				-1093
			],
			[
				-37,
				-1039
			],
			[
				-232,
				-389
			],
			[
				-318,
				-381
			],
			[
				-227,
				-492
			],
			[
				-346,
				-550
			],
			[
				-101,
				378
			],
			[
				78,
				401
			],
			[
				-206,
				335
			]
		],
		[
			[
				96623,
				40851
			],
			[
				-92,
				-78
			],
			[
				-93,
				259
			],
			[
				10,
				158
			],
			[
				175,
				-339
			]
		],
		[
			[
				96418,
				41756
			],
			[
				45,
				-476
			],
			[
				-75,
				74
			],
			[
				-58,
				-32
			],
			[
				-39,
				163
			],
			[
				-6,
				453
			],
			[
				133,
				-182
			]
		],
		[
			[
				64752,
				60417
			],
			[
				-201,
				-158
			],
			[
				-54,
				-263
			],
			[
				-6,
				-201
			],
			[
				-277,
				-249
			],
			[
				-444,
				-276
			],
			[
				-249,
				-417
			],
			[
				-122,
				-33
			],
			[
				-83,
				35
			],
			[
				-163,
				-245
			],
			[
				-177,
				-114
			],
			[
				-233,
				-30
			],
			[
				-70,
				-34
			],
			[
				-61,
				-156
			],
			[
				-73,
				-43
			],
			[
				-43,
				-150
			],
			[
				-137,
				13
			],
			[
				-89,
				-80
			],
			[
				-192,
				30
			],
			[
				-72,
				345
			],
			[
				8,
				323
			],
			[
				-46,
				174
			],
			[
				-54,
				437
			],
			[
				-80,
				243
			],
			[
				56,
				29
			],
			[
				-29,
				270
			],
			[
				34,
				114
			],
			[
				-12,
				257
			]
		],
		[
			[
				58175,
				37528
			],
			[
				113,
				-7
			],
			[
				134,
				-100
			],
			[
				94,
				71
			],
			[
				148,
				-59
			]
		],
		[
			[
				59119,
				34780
			],
			[
				-70,
				-430
			],
			[
				-32,
				-491
			],
			[
				-72,
				-267
			],
			[
				-190,
				-298
			],
			[
				-54,
				-86
			],
			[
				-118,
				-300
			],
			[
				-77,
				-303
			],
			[
				-158,
				-424
			],
			[
				-314,
				-609
			],
			[
				-196,
				-355
			],
			[
				-210,
				-269
			],
			[
				-290,
				-229
			],
			[
				-141,
				-31
			],
			[
				-36,
				-164
			],
			[
				-169,
				88
			],
			[
				-138,
				-113
			],
			[
				-301,
				114
			],
			[
				-168,
				-72
			],
			[
				-115,
				31
			],
			[
				-286,
				-233
			],
			[
				-238,
				-94
			],
			[
				-171,
				-223
			],
			[
				-127,
				-14
			],
			[
				-117,
				210
			],
			[
				-94,
				11
			],
			[
				-120,
				264
			],
			[
				-13,
				-82
			],
			[
				-37,
				159
			],
			[
				2,
				346
			],
			[
				-90,
				396
			],
			[
				89,
				108
			],
			[
				-7,
				453
			],
			[
				-182,
				553
			],
			[
				-139,
				501
			],
			[
				-1,
				1
			],
			[
				-199,
				768
			]
		],
		[
			[
				58409,
				41417
			],
			[
				-210,
				-81
			],
			[
				-159,
				-235
			],
			[
				-33,
				-205
			],
			[
				-100,
				-46
			],
			[
				-241,
				-486
			],
			[
				-154,
				-383
			],
			[
				-94,
				-13
			],
			[
				-90,
				68
			],
			[
				-311,
				65
			]
		]
	],
	"bbox": [
		-180,
		-85.60903777459767,
		180,
		83.64513000000001
	],
	"transform": {
		"scale": [
			0.0036000360003600037,
			0.00169255860333201
		],
		"translate": [
			-180,
			-85.60903777459767
		]
	}
};

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {
	"VCT": "NA",
	"PER": "SA",
	"GEO": "AS",
	"SLE": "AF",
	"AGO": "AF",
	"GNB": "AF",
	"STP": "AF",
	"NIU": "OC",
	"CIV": "AF",
	"AFG": "AS",
	"VAT": "EU",
	"BLZ": "NA",
	"BGD": "AS",
	"SHN": "AF",
	"BHS": "NA",
	"MYS": "AS",
	"RWA": "AF",
	"LTU": "EU",
	"CZE": "EU",
	"ESH": "AF",
	"CYM": "NA",
	"BES": "NA",
	"BTN": "AS",
	"ARE": "AS",
	"IRQ": "AS",
	"COG": "AF",
	"UMI": "OC",
	"HKG": "AS",
	"VGB": "NA",
	"VEN": "SA",
	"COM": "AF",
	"PYF": "OC",
	"BRB": "NA",
	"NGA": "AF",
	"LUX": "EU",
	"NZL": "OC",
	"TGO": "AF",
	"LAO": "AS",
	"CCK": "AS",
	"TWN": "AS",
	"ZMB": "AF",
	"PRK": "AS",
	"QAT": "AS",
	"BIH": "EU",
	"TUV": "OC",
	"SYR": "AS",
	"ZWE": "AF",
	"ATA": "AN",
	"LBN": "AS",
	"BDI": "AF",
	"MDG": "AF",
	"BGR": "EU",
	"ISR": "AS",
	"UGA": "AF",
	"LKA": "AS",
	"AUS": "OC",
	"HRV": "EU",
	"EST": "EU",
	"EGY": "AF",
	"UKR": "EU",
	"REU": "AF",
	"GMB": "AF",
	"TKL": "OC",
	"NER": "AF",
	"FLK": "SA",
	"IDN": "AS",
	"GAB": "AF",
	"NCL": "OC",
	"CUB": "NA",
	"LCA": "NA",
	"PRI": "NA",
	"MHL": "OC",
	"JOR": "AS",
	"SYC": "AF",
	"ETH": "AF",
	"UZB": "AS",
	"DMA": "NA",
	"BRA": "SA",
	"SRB": "EU",
	"BFA": "AF",
	"YEM": "AS",
	"DOM": "NA",
	"MAC": "AS",
	"JAM": "NA",
	"MYT": "AF",
	"DJI": "AF",
	"ISL": "EU",
	"SVN": "EU",
	"ITA": "EU",
	"HMD": "AN",
	"AUT": "EU",
	"AND": "EU",
	"WSM": "OC",
	"SLB": "OC",
	"BRN": "AS",
	"KWT": "AS",
	"SGS": "AN",
	"ATG": "NA",
	"TON": "OC",
	"FRA": "EU",
	"COL": "SA",
	"FJI": "OC",
	"LBR": "AF",
	"CAN": "NA",
	"IRL": "EU",
	"NLD": "EU",
	"IOT": "AS",
	"HND": "NA",
	"ESP": "EU",
	"TUR": "AS",
	"NFK": "OC",
	"PLW": "OC",
	"KNA": "NA",
	"IRN": "AS",
	"CXR": "AS",
	"MTQ": "NA",
	"JPN": "AS",
	"KHM": "AS",
	"PCN": "OC",
	"KEN": "AF",
	"VNM": "AS",
	"TJK": "AS",
	"GNQ": "AF",
	"TTO": "NA",
	"JEY": "EU",
	"RUS": "EU",
	"USA": "NA",
	"FSM": "OC",
	"SOM": "AF",
	"PRT": "EU",
	"BLR": "EU",
	"MOZ": "AF",
	"PAK": "AS",
	"MLI": "AF",
	"AZE": "AS",
	"CHE": "EU",
	"GUF": "SA",
	"GHA": "AF",
	"SWE": "EU",
	"CMR": "AF",
	"COK": "OC",
	"BOL": "SA",
	"TUN": "AF",
	"MCO": "EU",
	"ABW": "NA",
	"GRD": "NA",
	"NOR": "EU",
	"NRU": "OC",
	"PSE": "AS",
	"CPV": "AF",
	"SSD": "AF",
	"IMN": "EU",
	"ARG": "SA",
	"GIN": "AF",
	"GIB": "EU",
	"ALA": "EU",
	"CHL": "SA",
	"SUR": "SA",
	"CHN": "AS",
	"SPM": "NA",
	"BLM": "NA",
	"VUT": "OC",
	"GTM": "NA",
	"HUN": "EU",
	"SJM": "EU",
	"MRT": "AF",
	"GUY": "SA",
	"MDV": "AS",
	"WLF": "OC",
	"TKM": "AS",
	"GRL": "NA",
	"ERI": "AF",
	"PHL": "AS",
	"SGP": "AS",
	"ALB": "EU",
	"KAZ": "AS",
	"URY": "SA",
	"ROU": "EU",
	"BHR": "AS",
	"MAF": "NA",
	"LBY": "AF",
	"COD": "AF",
	"MEX": "NA",
	"CRI": "NA",
	"NAM": "AF",
	"MWI": "AF",
	"CYP": "EU",
	"BEN": "AF",
	"ASM": "OC",
	"SEN": "AF",
	"MAR": "AF",
	"TZA": "AF",
	"GBR": "EU",
	"PRY": "SA",
	"MMR": "AS",
	"LIE": "EU",
	"SLV": "NA",
	"BMU": "NA",
	"DNK": "EU",
	"DZA": "AF",
	"FRO": "EU",
	"ZAF": "AF",
	"MKD": "EU",
	"DEU": "EU",
	"MNP": "OC",
	"POL": "EU",
	"NPL": "AS",
	"IND": "AS",
	"KGZ": "AS",
	"ARM": "AS",
	"CAF": "AF",
	"CUW": "NA",
	"ATF": "AN",
	"BEL": "EU",
	"MUS": "AF",
	"GLP": "NA",
	"TLS": "OC",
	"ECU": "SA",
	"MDA": "EU",
	"TCA": "NA",
	"GUM": "OC",
	"FIN": "EU",
	"THA": "AS",
	"SVK": "EU",
	"BWA": "AF",
	"SMR": "EU",
	"PNG": "OC",
	"BVT": "AN",
	"LVA": "EU",
	"HTI": "NA",
	"AIA": "NA",
	"MNG": "AS",
	"SDN": "AF",
	"OMN": "AS",
	"GGY": "EU",
	"SWZ": "AF",
	"TCD": "AF",
	"MLT": "EU",
	"GRC": "EU",
	"MSR": "NA",
	"PAN": "NA",
	"NIC": "NA",
	"VIR": "NA",
	"SAU": "AS",
	"KIR": "OC",
	"SXM": "NA",
	"KOR": "AS",
	"LSO": "AF",
	"MNE": "EU"
};

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {
	"ETH": "Ethiopia",
	"BOL": "Bolivia",
	"NOR": "Norway",
	"HRV": "Croatia",
	"COD": "DR Congo",
	"ZAF": "South Africa",
	"VNM": "Vietnam",
	"BRN": "Brunei",
	"CZE": "Czechia",
	"BDI": "Burundi",
	"BHR": "Bahrain",
	"LKA": "Sri Lanka",
	"ECU": "Ecuador",
	"JPN": "Japan",
	"SVK": "Slovakia",
	"MYS": "Malaysia",
	"KOR": "South Korea",
	"AZE": "Azerbaijan",
	"IRL": "Ireland",
	"JAM": "Jamaica",
	"SYR": "Syria",
	"NGA": "Nigeria",
	"POL": "Poland",
	"URY": "Uruguay",
	"SWE": "Sweden",
	"KAZ": "Kazakhstan",
	"HND": "Honduras",
	"CRI": "Costa Rica",
	"GTM": "Guatemala",
	"GRC": "Greece",
	"DZA": "Algeria",
	"ARM": "Armenia",
	"ALB": "Albania",
	"MOZ": "Mozambique",
	"NIC": "Nicaragua",
	"OMN": "Oman",
	"ISR": "Israel",
	"KHM": "Cambodia",
	"MMR": "Myanmar",
	"PHL": "Philippines",
	"SWZ": "Swaziland",
	"BLR": "Belarus",
	"KEN": "Kenya",
	"LSO": "Lesotho",
	"ITA": "Italy",
	"NLD": "Netherlands",
	"MEX": "Mexico",
	"BGD": "Bangladesh",
	"AUT": "Austria",
	"ROU": "Romania",
	"CYP": "Cyprus",
	"ZMB": "Zambia",
	"MUS": "Mauritius",
	"PRI": "Puerto Rico",
	"CHL": "Chile",
	"UGA": "Uganda",
	"LVA": "Latvia",
	"CPV": "Cape Verde",
	"AGO": "Angola",
	"SGP": "Singapore",
	"MNG": "Mongolia",
	"PRT": "Portugal",
	"AFG": "Afghanistan",
	"FIN": "Finland",
	"LBN": "Lebanon",
	"TUN": "Tunisia",
	"QAT": "Qatar",
	"EGY": "Egypt",
	"PRY": "Paraguay",
	"LBR": "Liberia",
	"SAU": "Saudi Arabia",
	"MNE": "Montenegro",
	"IRN": "Iran",
	"FRA": "France",
	"MWI": "Malawi",
	"SEN": "Senegal",
	"GEO": "Georgia",
	"MLI": "Mali",
	"BLZ": "Belize",
	"BGR": "Bulgaria",
	"BFA": "Burkina Faso",
	"IND": "India",
	"MRT": "Mauritania",
	"MDA": "Moldova",
	"RUS": "Russia",
	"THA": "Thailand",
	"GHA": "Ghana",
	"EST": "Estonia",
	"HTI": "Haiti",
	"CHN": "China",
	"CHE": "Switzerland",
	"BRA": "Brazil",
	"LAO": "Laos",
	"LBY": "Libya",
	"TUR": "Turkey",
	"JOR": "Jordan",
	"KGZ": "Kyrgyzstan",
	"BRB": "Barbados",
	"PER": "Peru",
	"VEN": "Venezuela",
	"SVN": "Slovenia",
	"DEU": "Germany",
	"SUR": "Suriname",
	"SRB": "Serbia",
	"UKR": "Ukraine",
	"DOM": "Dominican Republic",
	"MKD": "Macedonia",
	"TTO": "Trinidad and Tobago",
	"TJK": "Tajikistan",
	"BEN": "Benin",
	"COL": "Colombia",
	"YEM": "Yemen",
	"ISL": "Iceland",
	"PAN": "Panama",
	"LUX": "Luxembourg",
	"BEL": "Belgium",
	"GAB": "Gabon",
	"GMB": "Gambia",
	"AUS": "Australia",
	"SLE": "Sierra Leone",
	"DNK": "Denmark",
	"ARE": "United Arab Emirates",
	"MAR": "Morocco",
	"NPL": "Nepal",
	"BIH": "Bosnia and Herzegovina",
	"HUN": "Hungary",
	"USA": "United States",
	"SYC": "Seychelles",
	"UZB": "Uzbekistan",
	"CIV": "Ivory Coast",
	"SLV": "El Salvador",
	"ESP": "Spain",
	"ZWE": "Zimbabwe",
	"KWT": "Kuwait",
	"GUY": "Guyana",
	"CMR": "Cameroon",
	"BTN": "Bhutan",
	"ARG": "Argentina",
	"GBR": "United Kingdom",
	"TWN": "Taiwan",
	"MLT": "Malta",
	"BWA": "Botswana",
	"TZA": "Tanzania",
	"HKG": "Hong Kong",
	"TCD": "Chad",
	"IDN": "Indonesia",
	"LTU": "Lithuania",
	"PAK": "Pakistan",
	"MDG": "Madagascar",
	"CAN": "Canada",
	"NZL": "New Zealand",
	"TLS": "Timor-Leste",
	"RWA": "Rwanda",
	"NAM": "Namibia",
	"GIN": "Guinea"
};

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {
	"EOSQ051": {
		"descriptionQuestion": "In your country, to what extent are property rights, including financial assets, protected? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ051",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.52,
			6.67
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Property rights (1-7)",
		"shortTitle": "Property rights",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_PROPERTYPROTECT",
		"includedDashboard": "YES",
		"titleWithUnits": "Property rights*",
		"fullDescription": "",
		"GETR2016Number": "7.01.a"
	},
	"ETIB03": {
		"descriptionQuestion": "Pillar 3: Efficiency and transparency of border administration",
		"dataType": "AGGREG",
		"globalId": "ETIB03",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Efficiency and transparency of border administration (1–7)",
		"shortTitle": "Pillar 3: Efficiency and transparency of border administration",
		"otherShortTitle": "Efficiency & transparency of border administration",
		"parentCategoryGlobalId": "ETI.B",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 3: Efficiency and transparency of border administration (1–7)",
		"fullDescription": "This pillar assesses the efficiency and transparency of border administration. More specifically, it captures efficiency, transparency and costs associated with importing and exporting goods. It includes an assessment of the range, quality and comprehensiveness of key services offered by customs and related agencies, and the average time, costs and number of documents required to, respectively, import and export goods. The pillar also assesses the time predictability of border procedures, as well as the transparency of the process—as measured by the availability and quality of information provided by border agencies—and the prevalence of corruption",
		"GETR2016Number": "B.03"
	},
	"int_cooperation": {
		"descriptionQuestion": "Co-operation between various border agencies of the country; control delegation to customs authorities",
		"dataType": "HARD",
		"globalId": "int_cooperation",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Border agency cooperation - internal (0–2)",
		"shortTitle": "Border agency cooperation - internal",
		"otherShortTitle": "Border agency cooperation - internal",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Border agency cooperation - internal (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TFA Article 6": {
		"descriptionQuestion": "Disciplines on fees and charges imposed on or in connection with importation and exportation and penalties",
		"dataType": "HARD",
		"globalId": "TFA Article 6",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 6 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ146": {
		"descriptionQuestion": "In your country, how common is illegal diversion of public funds to companies, individuals or groups? (1 = very commonly occurs; 7 = never occurs)",
		"dataType": "SURVEY",
		"globalId": "EOSQ146",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.22,
			6.63
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Diversion of public funds (1-7)",
		"shortTitle": "Diversion of public funds",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_INSTITQUALITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Diversion of public funds*",
		"fullDescription": "",
		"GETR2016Number": "7.02.b"
	},
	"EOSQ366": {
		"descriptionQuestion": "In your country, to what extent do businesses use the Internet for selling their goods and services to consumers? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ366",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.2,
			6.4
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Internet use for business-to-consumer transactions (1–7)",
		"shortTitle": "Internet use for business-to-consumer transactions",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Internet use for business-to-consumer transactions*",
		"fullDescription": "",
		"GETR2016Number": "6.06"
	},
	"TABTIMEIMPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABTIMEIMPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0.5,
			1090
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Documentary compliance (hours)",
		"shortTitle": "Time to import: Documentary compliance",
		"otherShortTitle": "Time to import: Documentary compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Documentary compliance (hours)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.03"
	},
	"TABTIMEEXPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABTIMEEXPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			515.04
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Border compliance (hours)",
		"shortTitle": "Time to export: Border compliance",
		"otherShortTitle": "Time to export: Border compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Border compliance (hours)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.08"
	},
	"EOSQ033": {
		"descriptionQuestion": "In your country, to what extent does the threat of terrorism impose costs on businesses? (1 = to a great extent, imposes huge costs; 7 = no costs at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ033",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.74,
			6.8
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Business costs of terrorism (1-7)",
		"shortTitle": "Business costs of terrorism",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Business costs of terrorism*",
		"fullDescription": "",
		"GETR2016Number": "7.05.c"
	},
	"CUSTSERVIND": {
		"descriptionQuestion": "Index of extent of quality and comprehensiveness of services provided by customs authorities and related agencies (0 = worst, 1 = best)",
		"dataType": "HARD",
		"globalId": "CUSTSERVIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association (GEA) Customs Capabilities Database",
		"title": "Customs services index (0–1)",
		"shortTitle": "Customs services index",
		"otherShortTitle": "Customs services index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs services index (0–1)",
		"fullDescription": "This indicator is based on 17 survey questions taken from the GEA Customs Capabilities Reports, which evaluate the quality and comprehensiveness of services offered by customs and related agencies. The services included: clearance of shipments via electronic data interchange; separation of physical release of goods from fiscal control; full-time (24 hours/7 days a week) automated processing; customs working hours adapted to commercial needs; fee for services conducted during normal service hours; inspection and release of goods arriving by air by the operator's facility; automated risk assessment as primary basis for physical examination of shipments; multiple inspections (inspections by agencies other than customs) and the promptness of those inspections; exemptions from full customs formalities for shipments of minimal value; exemptions from a duties and taxes for shipments of minimal value; clearance of shipments by a third party; appeal of customs decisions to a higher level or an independent tribunal; and use of reference prices or arbitrary uplifts to invoice values. The maximum score an economy can obtain is 1.",
		"GETR2016Number": "3.01"
	},
	"TOTTARIFRT": {
		"descriptionQuestion": "Trade-weighted average applied tariff rate (%)",
		"dataType": "HARD",
		"globalId": "TOTTARIFRT",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariff rate (%)",
		"shortTitle": "Tariff rate",
		"otherShortTitle": "Tariff rate",
		"parentCategoryGlobalId": "ETI.A.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariff rate (%)",
		"fullDescription": "This indicator is calculated as a trade-weighted average of all the applied tariff rates, including preferential rates that a country applies to the rest of the world. The weights are the trade patterns of the importing country's reference group (2014 data). An applied tariff is a customs duty that is levied on imports of merchandise goods.",
		"GETR2016Number": "1.01"
	},
	"HOMICIDERT": {
		"descriptionQuestion": "Number of homicide cases per 100,000 population",
		"dataType": "HARD",
		"globalId": "HOMICIDERT",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			92.7
		],
		"sources": "United Nations Office on Drugs and Crime (UNODC)",
		"title": "Homicide cases/100,000 pop.",
		"shortTitle": "Homicide rate",
		"otherShortTitle": "Homicide rate",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Homicide cases/100,000 pop.",
		"fullDescription": "The United Nations Office on Drugs and Crime (UNODC) collects statistics on homicide occurrences worldwide, pooling information from national sources as well as other international institutions such as Interpol, Eurostat, the Organization of American States, UNICEF and the World Health Organization (WHO).",
		"GETR2016Number": "7.05.d"
	},
	"LINERSHIPIDX": {
		"descriptionQuestion": "Quantity of services provided by liner companies",
		"dataType": "HARD",
		"globalId": "LINERSHIPIDX",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			7,
			1
		],
		"sources": "United Nations Conference on Trade and Development (UNCTAD), Transport Section, Trade Logistics Branch ",
		"title": "Liner Shipping Connectivity Index (0–157.1)",
		"shortTitle": "Liner Shipping Connectivity Index",
		"otherShortTitle": "Liner Shipping Connectivity Index",
		"parentCategoryGlobalId": "ETI.C.04.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Liner Shipping Connectivity Index (0–157.1)",
		"fullDescription": "This indicator captures how well countries are connected to global shipping networks. It is based on five components of the maritime transport sector: number of ships, their container-carrying capacity, maximum vessel size, number of services and number of companies that deploy container ships in a country's ports. For each component, a country's value is divided by the maximum value of each component in 2004. The five components are then averaged for each country, and the average is divided by the maximum average for 2004 and multiplied by 100. The index generates a value of 100 for the country with the highest average index in 2004.",
		"GETR2016Number": "4.04"
	},
	"BBSUBPC": {
		"descriptionQuestion": "Fixed broadband Internet subscriptions per 100 population",
		"dataType": "HARD",
		"globalId": "BBSUBPC",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			44.79
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Fixed broadband Internet subscriptions/100 pop.",
		"shortTitle": "Fixed broadband Internet subscriptions",
		"otherShortTitle": "Broadband Internet subscriptions",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Fixed broadband Internet subscriptions/100 pop.",
		"fullDescription": "The International Telecommunication Union considers broadband to be any dedicated connection to the Internet of 256 kilobits per second or faster, in both directions. Broadband subscribers refers to the sum of DSL, cable modem and other broadband (for example, fiber optic, fixed wireless, apartment LANs, satellite connections) subscribers.",
		"GETR2016Number": "6.03"
	},
	"TFA Article 11": {
		"descriptionQuestion": "Freedom of transit",
		"dataType": "HARD",
		"globalId": "TFA Article 11",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 11 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"inv_community": {
		"descriptionQuestion": "Consultations with traders",
		"dataType": "HARD",
		"globalId": "inv_community",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Involvement of the trade community (0–2)",
		"shortTitle": "Involvement of the trade community",
		"otherShortTitle": "Involvement of the trade community",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Involvement of the trade community (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TFA Article 8": {
		"descriptionQuestion": "Border agency cooperation",
		"dataType": "HARD",
		"globalId": "TFA Article 8",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 8 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"CLEAREFF": {
		"descriptionQuestion": "Efficiency of the clearance process by customs and border control agencies (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "CLEAREFF",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Efficiency of the clearance process (1–5)",
		"shortTitle": "Efficiency of the clearance process",
		"otherShortTitle": "Efficiency of the clearance process",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Efficiency of the clearance process (1–5)",
		"fullDescription": "This indicator assesses the effectiveness and efficiency of the clearance process by customs and other border control agencies in the eight major trading partners of each country. Respondents to the LPI survey were asked to evaluate the effectiveness and efficiency of clearance in the country in which they work, based on their experience in international logistics, on a 1-5 scale compared with generally accepted industry standards or practices.",
		"GETR2016Number": "3.02"
	},
	"TFA Article 1": {
		"descriptionQuestion": "Publication and availability of information",
		"dataType": "HARD",
		"globalId": "TFA Article 1",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 1 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TFA Article 2": {
		"descriptionQuestion": "Opportunity to comment, information before entry into force and consultations",
		"dataType": "HARD",
		"globalId": "TFA Article 2",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 2 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"DBENFORCECONTRACTS": {
		"descriptionQuestion": "Enforcing contracts: efficiency and quality of commercial dispute resolution (0 = worst, 100 = best)",
		"dataType": "HARD",
		"globalId": "DBENFORCECONTRACTS",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			0
		],
		"sources": "The World Bank, [i]Doing Business Enforcing Contracts[i] ",
		"title": "Enforcing contract (0–100)",
		"shortTitle": "Enforcing contracts",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_INSTITQUALITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Enforcing contract (0–100)",
		"fullDescription": "The index is the result of the aggregation, with equal weighting, of three elements: number of days to resolve a commercial sale dispute through the courts; attorney, court and enforcement costs as a percentage of the claim value; and overall quality of judicial processes as measured through the application of good practices to promote quality and efficiency of the judicial system (in particular, this assesses the court structure and proceedings, case management practices, level of cour automation, and alternative dispute resolution framework). For more details about the methodology employed and the assumptions made to compute this indicator, visit http://www.doingbusiness.org/Methodology/Enforcing-Contracts",
		"GETR2016Number": "7.02.a"
	},
	"adv_rulings": {
		"descriptionQuestion": "Prior statements by the administration to requesting traders concerning the classification, origin, valuation method, etc., applied to specific goods at the time of importation; the rules and process applied to such statements",
		"dataType": "HARD",
		"globalId": "adv_rulings",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Advance rulings (0–2)",
		"shortTitle": "Advance rulings",
		"otherShortTitle": "Advance rulings",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Advance rulings (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"SUN-TABCOSTEXPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTEXPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Documentary compliance (1-7)",
		"shortTitle": "Cost to export: Documentary compliance",
		"otherShortTitle": "Cost to export: Documentary compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Documentary compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.09"
	},
	"form_proc": {
		"descriptionQuestion": "Streamlining of border controls; single submission points for all required documentation (single windows); post-clearance audits; authorised economic operators",
		"dataType": "HARD",
		"globalId": "form_proc",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Formalities - procedures (0–2)",
		"shortTitle": "Formalities - procedures",
		"otherShortTitle": "Formalities - procedures",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Formalities - procedures (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"NETUSERPCT": {
		"descriptionQuestion": "Percentage of individuals using the Internet",
		"dataType": "HARD",
		"globalId": "NETUSERPCT",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Individuals using Internet (%)",
		"shortTitle": "Internet users",
		"otherShortTitle": "Internet users",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Individuals using Internet (%)",
		"fullDescription": "Internet users are people with access to the worldwide network.",
		"GETR2016Number": "6.02"
	},
	"ETIC0401": {
		"descriptionQuestion": "Availability and quality of air transport infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0401",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of air transport infrastructure (1–7)",
		"shortTitle": "Availability and quality of air transport infrastructure",
		"otherShortTitle": "Availability and quality of air transport infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of air transport infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.01"
	},
	"EOSQ061": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for air transport (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ061",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.05,
			6.92
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of air transport infrastructure (1–7)",
		"shortTitle": "Quality of air transport infrastructure",
		"otherShortTitle": "Quality of air transport infrastructure",
		"parentCategoryGlobalId": "ETI.C.04.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of air transport infrastructure*",
		"fullDescription": "",
		"GETR2016Number": "4.02"
	},
	"ETIC04": {
		"descriptionQuestion": "Pillar 4: Availability and quality of transport infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC04",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of transport infrastructure (1–7)",
		"shortTitle": "Pillar 4: Availability and quality of transport infrastructure",
		"otherShortTitle": "Availability & quality of transport infrastructure",
		"parentCategoryGlobalId": "ETI.C",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 4: Availability and quality of transport infrastructure (1-7)",
		"fullDescription": "This pillar measures the availability and quality of domestic infrastructure for each of the four main modes of transport: road, air, railroad and seaport infrastructures. Air connectivity and sea line connectivity are also assessed.",
		"GETR2016Number": "C.04"
	},
	"ETIA01": {
		"descriptionQuestion": "Pillar 1: Domestic market access",
		"dataType": "AGGREG",
		"globalId": "ETIA01",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Domestic market access (1–7)",
		"shortTitle": "Pillar 1: Domestic market access",
		"otherShortTitle": "Domestic market access",
		"parentCategoryGlobalId": "ETI.A",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 1: Domestic market access (1–7)",
		"fullDescription": "This pillar assesses the level and complexity of a country’s tariff protection as a result of its trade policy. This component includes the effective trade-weighted average tariff applied by a country, the share of goods imported duty free and the complexity of the tariff regime, measured through tariff variance, the prevalence of tariff peaks and specific tariffs, and the number of distinct tariffs",
		"GETR2016Number": "A.01"
	},
	"appeal_proc": {
		"descriptionQuestion": "The possibility and modalities to appeal administrative decisions by border agencies",
		"dataType": "HARD",
		"globalId": "appeal_proc",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Appeal procedures (0–2)",
		"shortTitle": "Appeal procedures",
		"otherShortTitle": "Appeal procedures",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Appeal procedures (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EXPTIMECOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "EXPTIMECOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Time for documentary and border compliance for exporting (hours)",
		"shortTitle": "Time for documentary and border compliance for exporting",
		"otherShortTitle": "Time to comply with documentary and border compliance for exporting",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Time for documentary and border compliance for exporting (hours)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"TARIFNUMB": {
		"descriptionQuestion": "Number of distinct tariffs for all sectors",
		"dataType": "HARD",
		"globalId": "TARIFNUMB",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			6710
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Number of distinct tariffs",
		"shortTitle": "Number of distinct tariffs",
		"otherShortTitle": "Number of distinct tariffs",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Number of distinct tariffs",
		"fullDescription": "This indicator reflects the number of distinct tariff rates applied by a country to its imports across all sectors.",
		"GETR2016Number": "1.02.d"
	},
	"IMPTIMECOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "IMPTIMECOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Time for documentary & border compliance for importing (hours)",
		"shortTitle": "Time for documentary & border compliance for importing",
		"otherShortTitle": "Time to comply with documentary and border compliance for importing",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Time for documentary & border compliance for importing (hours)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"TFA Article 9": {
		"descriptionQuestion": "Movement of goods intended for import under customs control",
		"dataType": "HARD",
		"globalId": "TFA Article 9",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 9 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ058": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for railroads (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ058",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.1,
			6.8
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of railroad infrastructure (1–7)",
		"shortTitle": "Quality of railroad infrastructure",
		"otherShortTitle": "Quality of railroad infrastructure",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of railroad infrastructure, 1–7 (best) (all countries)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"EOSQ394": {
		"descriptionQuestion": "In your country, how efficient is the postal system? (1 = not efficient at all; 7 = extremely efficient)",
		"dataType": "SURVEY",
		"globalId": "EOSQ394",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.19,
			6.77
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2013 and 2014 editions",
		"title": "Postal services efficiency (1–7)",
		"shortTitle": "Postal service efficiency",
		"otherShortTitle": "Postal service efficiency",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Postal services efficiency*",
		"fullDescription": "",
		"GETR2016Number": "5.05"
	},
	"EXPCOSTCOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "EXPCOSTCOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Cost for documentary and border compliance for exporting (USD)",
		"shortTitle": "Cost for documentary and border compliance for exporting",
		"otherShortTitle": "Cost to comply with documentary and border compliance for exporting",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Cost for documentary and border compliance for exporting (USD)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"SHAREDUTYFREE": {
		"descriptionQuestion": "Duty-free imports as a share of total imports (%)",
		"dataType": "HARD",
		"globalId": "SHAREDUTYFREE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Share of duty-free imports (%)",
		"shortTitle": "Share of duty-free imports",
		"otherShortTitle": "Share of duty-free imports",
		"parentCategoryGlobalId": "ETI.A.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Share of duty-free imports (%)",
		"fullDescription": "Share of trade, excluding petroleum, that is imported free of tariff duties, taking into account MFN tariffs and preferential agreements. Tariff data is from 2015 or most recent year available and imports data is from 2014.",
		"GETR2016Number": "1.03"
	},
	"fees_charges": {
		"descriptionQuestion": "Disciplines on the fees and charges imposed on imports and exports",
		"dataType": "HARD",
		"globalId": "fees_charges",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Fees and charges (0–2)",
		"shortTitle": "Fees and charges",
		"otherShortTitle": "Fees and charges",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Fees and charges (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ469": {
		"descriptionQuestion": "In your country, to what extent does the cost of financial services (e.g. insurance, loans, trade finance) impede business activity? (1 = impedes business to a great extent; 7 = not at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ469",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.77,
			5.81
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Affordability of financial services (1-7)",
		"shortTitle": "Affordability of financial services",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_FINANCE",
		"includedDashboard": "YES",
		"titleWithUnits": "Affordability of financial services*  ",
		"fullDescription": "",
		"GETR2016Number": "7.03.b"
	},
	"form_docs": {
		"descriptionQuestion": "Simplification of trade documents; harmonisation in accordance with international standards; acceptance of copies",
		"dataType": "HARD",
		"globalId": "form_docs",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Formalities - documents (0–2)",
		"shortTitle": "Formalities - documents",
		"otherShortTitle": "Formalities - documents",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Formalities - documents (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABTIMEIMPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABTIMEIMPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			588
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Border compliance (hours)",
		"shortTitle": "Time to import: Border compliance",
		"otherShortTitle": "Time to import: Border compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Border compliance (hours)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.04"
	},
	"ETIC0402": {
		"descriptionQuestion": "Availability and quality of railroad infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0402",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of railroad infrastructure (1–7)",
		"shortTitle": "Availability and quality of railroad infrastructure",
		"otherShortTitle": "Availability and quality of railroad infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of railroad infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.02"
	},
	"TERRORISMINCIDENCE": {
		"descriptionQuestion": "Simple average of the number of terrorism-related casualties (injuries and fatalities) and the number of terrorist attacks, each normalized on a scale of 1 to 7",
		"dataType": "HARD",
		"globalId": "TERRORISMINCIDENCE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from National Consortium for the Study of Terrorism and Responses to Terrorism (START). Global Terrorism Database. Retrieved from http://www.start.umd.edu/gtd on 28 September 2016.",
		"title": "Index of terrorism incidence (1-7)",
		"shortTitle": "Terrorism incidence",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Index of terrorism incidence (1-7)",
		"fullDescription": "This index has been created on the basis of data contained in the START Database (National Consortium for the Study of Terrorism and Responses to Terrorism). It is the average of the three-year (2013-2015) total number of “terrorism attacks” and “terrorism casualties” (fatalities plus injured people) normalized according to the min-max methodology, with the maximum value corresponding to the 95th percentile of each of the two datasets. ",
		"GETR2016Number": "7.05.e"
	},
	"EOSQ034": {
		"descriptionQuestion": "In your country, to what extent does the incidence of crime and violence impose costs on businesses? (1 = to a great extent, imposes huge costs; 7 = no costs at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ034",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.59,
			6.8
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Business costs of crime and violence (1-7)",
		"shortTitle": "Business costs of crime and violence",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Business costs of crime and violence*",
		"fullDescription": "",
		"GETR2016Number": "7.05.b"
	},
	"EOSQ048": {
		"descriptionQuestion": "In your country, how burdensome is it for companies to comply with public administration’s requirements (e.g. permits, regulations, reporting)? (1 = extremely burdensome; 7 = not burdensome at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ048",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.32,
			5.66
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Ease of compliance with government regulation (1-7)",
		"shortTitle": "Burden of government regulation",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_INSTITQUALITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease of compliance with government regulation*",
		"fullDescription": "",
		"GETR2016Number": "7.02.c"
	},
	"EOSQ055": {
		"descriptionQuestion": "In your country, to what extent can police services be relied upon to enforce law and order? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ055",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.73,
			6.79
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Reliability of police services (1-7)",
		"shortTitle": "Reliability of police services",
		"otherShortTitle": "Reliability of police services",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Reliability of police services*",
		"fullDescription": "",
		"GETR2016Number": "7.05.a"
	},
	"EOSQ147": {
		"descriptionQuestion": "In your country, how common is it for companies to make undocumented extra payments or bribes in connection with imports and exports (1 = very common; 7 = never occurs)",
		"dataType": "SURVEY",
		"globalId": "EOSQ147",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.56,
			6.83
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Irregular payments in exports and imports (1–7)",
		"shortTitle": "Irregular payments in exports and imports",
		"otherShortTitle": "Irregular payments in exports and imports",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Irregular payments in exports and imports*",
		"fullDescription": "",
		"GETR2016Number": "3.11"
	},
	"SUN-CLEAREFF": {
		"descriptionQuestion": "Efficiency of the clearance process by customs and border control agencies (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-CLEAREFF",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Efficiency of the clearance process (1–7)",
		"shortTitle": "Efficiency of the clearance process",
		"otherShortTitle": "Efficiency of the clearance process",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Efficiency of the clearance process (1-7)",
		"fullDescription": "This indicator assesses the effectiveness and efficiency of the clearance process by customs and other border control agencies in the eight major trading partners of each country. Respondents to the LPI survey were asked to evaluate the effectiveness and efficiency of clearance in the country in which they work, based on their experience in international logistics, on a 1-7 scale compared with generally accepted industry standards or practices.",
		"GETR2016Number": "3.02"
	},
	"SUN-TABTIMEIMPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEIMPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Border compliance (1-7)",
		"shortTitle": "Time to import: Border compliance",
		"otherShortTitle": "Time to import: Border compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Border compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.04"
	},
	"SUN-TABTIMEEXPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEEXPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Documentary compliance (1-7)",
		"shortTitle": "Time to export: Documentary compliance",
		"otherShortTitle": "Time to export: Documentary compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Documentary compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.07"
	},
	"OPENMULTRDRULE": {
		"descriptionQuestion": "Index of openness to multilateral trade rules (0 = lowest, 100 = highest)",
		"dataType": "HARD",
		"globalId": "OPENMULTRDRULE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			0
		],
		"sources": "International Trade Centre, based on data from the Trade Treaties map - LegaCarta database",
		"title": "Openness to multilateral trade rules (0–100)",
		"shortTitle": "Openness to multilateral trade rules",
		"otherShortTitle": "Openness to multilateral trade rules",
		"parentCategoryGlobalId": "ETI_OPENFRXPART",
		"includedDashboard": "YES",
		"titleWithUnits": "Openness to multilateral trade rules (0–100)",
		"fullDescription": "This index evaluates the overall participation of countries in multilateral trade rules or instruments (MTRs). These rules are all internationally elaborated legal standards currently regulating trade in specific areas. MTRs are primarily comprised of conventions and treaties that countries ratify or accede to, and international model laws that are incorporated into national law. The index is based on ITC’s Trade Treaties map - LegaCarta system, which analyzes the position of each country (accession/nonaccession and incorporation/nonincorporation) regarding some 280 MTRs as well as 450 protocols or amendments overseen by 28 different international organizations. For the purposes of this index, 40 core MTRs were selected, and each was rated with a score depending on its importance and relevance to trade. The 40 core instruments belong to seven categories (contracts, customs, dispute resolution, governance, intellectual property, investment and air transport). Each category is given an equal weight in the calculation of the index. Selection of the core instruments is based on their importance and relevance to trade and their universality. The importance and relevance to trade of an instrument is determined by taking into account several criteria including: the impact of its provisions on international trade (reduction of transactional costs, trade facilitation, harmonization, transparency, predictability, creation of a business-friendly business climate, support of private-sector activities and encouragement of foreign direct investment), the opinion of international legal experts and the views of the international bodies administering these instruments. Universality means that the selected MTRs can potentially be applied by all countries, notwithstanding their geographical position or economic level. For example, maritime transport conventions, however important, were not taken into account because of their weak relevance for landlocked countries; treaties dealing with securities and insider trading were not included because they do not represent a priority in countries that have not developed sophisticated financial markets. Accession to the WTO Agreements is not taken into account in this index as WTO accession does not depend exclusively on the will of a non-member state to join the WTO.",
		"GETR2016Number": "7.04.c"
	},
	"SUN-TABCOSTEXPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTEXPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Border compliance (1-7)",
		"shortTitle": "Cost to export: Border compliance",
		"otherShortTitle": "Cost to export: Border compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Border compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.10"
	},
	"EOSQ095": {
		"descriptionQuestion": "In your country, how restrictive are rules and regulations on foreign direct investment (FDI)? (1 = extremely restrictive; 7 = not restrictive at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ095",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.41,
			6.68
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Business impact of rules on FDI (1-7)",
		"shortTitle": "Business impact of rules on FDI",
		"otherShortTitle": "Business impact of rules on FDI",
		"parentCategoryGlobalId": "ETI_OPENFRXPART",
		"includedDashboard": "YES",
		"titleWithUnits": "Business impact of rules on FDI*",
		"fullDescription": "",
		"GETR2016Number": "7.04.b"
	},
	"gov_impartiality": {
		"descriptionQuestion": "Customs structures and functions; accountability; ethics policy",
		"dataType": "HARD",
		"globalId": "gov_impartiality",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Governance and impartiality (0–2)",
		"shortTitle": "Governance and impartiality",
		"otherShortTitle": "Governance and impartiality",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Governance and impartiality (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABTIMEEXPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABTIMEEXPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0.5,
			698
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Documentary compliance (hours)",
		"shortTitle": "Time to export: Documentary compliance",
		"otherShortTitle": "Time to export: Documentary compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Documentary compliance (hours)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.07"
	},
	"ETI_INSTITQUALITY": {
		"descriptionQuestion": "Index of efficiency and accountability of public institutions (1 = worst, 7 = best)",
		"dataType": "AGGREG",
		"globalId": "ETI_INSTITQUALITY",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from World Economic Forum and World Bank.",
		"title": "Efficiency and accountability of public institutions (1–7)",
		"shortTitle": "Efficiency and accountability of public institutions",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Efficiency and accountability of public institutions index (1–7)",
		"fullDescription": "This indicator is a combination of three indicators derived from the World Bank's [i]Doing Business Database[i] and the World Economic Forum's [i]Executive Opinion Survey[i]: Enforcing contracts; Diversion of public funds and Burden of government regulation. See description of each individual indicator for more details.",
		"GETR2016Number": "7.02"
	},
	"EOSQ052": {
		"descriptionQuestion": "In your country, to what extent is intellectual property protected? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ052",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.57,
			6.48
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Intellectual property protection (1-7)",
		"shortTitle": "Intellectual property protection",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_PROPERTYPROTECT",
		"includedDashboard": "YES",
		"titleWithUnits": "Intellectual property protection*",
		"fullDescription": "",
		"GETR2016Number": "7.01.b"
	},
	"ext_cooperation": {
		"descriptionQuestion": "Co-operation with neighbouring and third countries",
		"dataType": "HARD",
		"globalId": "ext_cooperation",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Border agency cooperation - external (0–2)",
		"shortTitle": "Border agency cooperation - external",
		"otherShortTitle": "Border agency cooperation - external",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Border agency cooperation - external (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TARIFDISP": {
		"descriptionQuestion": "Standard deviation of applied tariff rates",
		"dataType": "HARD",
		"globalId": "TARIFDISP",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			143.99
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariff dispersion (standard deviation)",
		"shortTitle": "Tariff dispersion",
		"otherShortTitle": "Tariff dispersion",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariff dispersion (standard deviation)",
		"fullDescription": "This indicator reflects differences in tariffs across product categories in a country’s tariff structure. The variance is calculated across all the tariffs on imported merchandise goods, at the 6-digit level of the Harmonized Schedule.",
		"GETR2016Number": "1.02.a"
	},
	"ETIB": {
		"descriptionQuestion": "Subindex B: Border administration",
		"dataType": "AGGREG",
		"globalId": "ETIB",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Border administration (1–7)",
		"shortTitle": "Border Administration: overall indicator",
		"otherShortTitle": "Border administration",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex B: Border administration (1–7)",
		"fullDescription": "This sub-index assesses the efficiency and transparency of border administration. More specifically, it captures efficiency, transparency and costs associated with importing and exporting goods. It includes an assessment of the range, quality and comprehensiveness of key services offered by customs and related agencies, and the average time, costs and number of documents required to, respectively, import and export goods. The pillar also assesses the time predictability of border procedures, as well as the transparency of the process—as measured by the availability and quality of information provided by border agencies—and the prevalence of corruption",
		"GETR2016Number": "B"
	},
	"TRACKTRACE": {
		"descriptionQuestion": "Ability to track and trace consignments (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "TRACKTRACE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Tracking and tracing ability (1–5)",
		"shortTitle": "Tracking and tracing ability",
		"otherShortTitle": "Tracking and tracing ability",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Tracking and tracing ability (1–5)",
		"fullDescription": "This indicator assesses the ability to track and trace international shipments (consignments). Respondents to the LPI survey were asked to evaluate the ability to track and trace international shipments (consignments) when shipping to or from eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.03"
	},
	"TARIFPEAK": {
		"descriptionQuestion": "Share of tariff lines with domestic peaks (%)",
		"dataType": "HARD",
		"globalId": "TARIFPEAK",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariff peaks (% of tariff lines)",
		"shortTitle": "Tariff peaks",
		"otherShortTitle": "Tariff peaks",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariff peaks (% of tariff lines)",
		"fullDescription": "This indicator is the ratio of the number of tariff lines exceeding three times the average domestic tariff (across all products) to the MFN (most-favoured nation) tariff schedule. The tariff schedule is equal to the total number of tariff lines for each country. These tariffs are revised on a yearly basis.",
		"GETR2016Number": "1.02.b"
	},
	"TFA Article 5": {
		"descriptionQuestion": "Other measures to enhance impartiality, non-discrimination and transparency",
		"dataType": "HARD",
		"globalId": "TFA Article 5",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 5 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"LOGICOMP": {
		"descriptionQuestion": "Competence and quality of logistics services, e.g. transport operators and customs brokers (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "LOGICOMP",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Logistics competence (1–5)",
		"shortTitle": "Logistics competence",
		"otherShortTitle": "Logistics competence",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Logistics competence (1–5)",
		"fullDescription": "This indicator evaluates the competence of the local logistics industry. Respondents to the LPI survey were asked to evaluate the competence of the local logistics industry in the eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.02"
	},
	"GOVONLINESERVIDX": {
		"descriptionQuestion": "The Government Online Service Index assesses the quality of government’s delivery of online services (0 = very low, 1 = very high)",
		"dataType": "HARD",
		"globalId": "GOVONLINESERVIDX",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1
		],
		"sources": "United Nations, [i]UN E-Government Survey 2016: E-Government in support of sustainable development[i]",
		"title": "Government Online Service Index (0–1)",
		"shortTitle": "Government Online Service Index",
		"otherShortTitle": "Government Online Service Index",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Government Online Service Index (0–1)",
		"fullDescription": "The Index captures a government’s performance in delivering online services to the citizens. There are four stages of service delivery (Emerging, Enhanced, Transactional and Connected). Online services are assigned to each stage according to their degree of sophistication, from the more basic to the more sophisticated. In each country, the performance of the government in each of the four stages is measured as the number of services provided as a percentage of the maximum services in the corresponding stage. Examples of services include online presence, deployment of multimedia content, governments’ solicitation of citizen input, widespread data sharing and use of social networking. For more details about the methodology employed and the assumptions made to compute this indicator, please consult the UN’s Global E-Government Survey 2012’s dedicated page at http://www2.unpan.org/egovkb/global_reports/12report.htm.",
		"GETR2016Number": "6.07"
	},
	"EOSQ088": {
		"descriptionQuestion": "In your country, how easy is it for businesses to obtain a bank loan? (1 = extremely difficult; 7 = extremely easy)",
		"dataType": "SURVEY",
		"globalId": "EOSQ088",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.25,
			5.74
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Ease of access to loans (1-7)",
		"shortTitle": "Ease of access to loans",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_FINANCE",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease of access to loans*",
		"fullDescription": "",
		"GETR2016Number": "7.03.c"
	},
	"inf_availability": {
		"descriptionQuestion": "Publication of trade information, including on internet; enquiry points",
		"dataType": "HARD",
		"globalId": "inf_availability",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Information availability (0–2)",
		"shortTitle": "Information availability",
		"otherShortTitle": "Information availability",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Information availability (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TARIFACED": {
		"descriptionQuestion": "Trade-weighted average tariff faced in destination markets (%)",
		"dataType": "HARD",
		"globalId": "TARIFACED",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariffs faced (%)",
		"shortTitle": "Tariffs faced",
		"otherShortTitle": "Tariffs faced",
		"parentCategoryGlobalId": "ETI.A.02",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariffs faced (%)",
		"fullDescription": "This indicator is calculated as the trade-weighted average of the applied tariff rates, including preferential rates that the rest of the world applies to each country. The weights are the trade patterns of the importing country's reference group (2014 trade data). The reference year for tariffs changes according to the destination market. The majority of countries reports 2015 tariff data. A tariff is a customs duty that is levied by the destination country on imports of merchandise goods.",
		"GETR2016Number": "2.01"
	},
	"ETIA": {
		"descriptionQuestion": "Subindex A: Market access",
		"dataType": "AGGREG",
		"globalId": "ETIA",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Market access (1–7)",
		"shortTitle": "Subindex A: Market access",
		"otherShortTitle": "Market access",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex A: Market access (1–7)",
		"fullDescription": "This subindex measures the extent and complexity of a country’s tariff regime, as well as tariff barriers faced and preferences enjoyed by a country’s exporters in foreign markets",
		"GETR2016Number": "A"
	},
	"ROADQUALIDX": {
		"descriptionQuestion": "Average speed and straightness of a driving itinerary connecting the 10 or more largest cities that together account for at least 15 percent of the economy's total population (1 = worst, 7 = best).",
		"dataType": "HARD",
		"globalId": "ROADQUALIDX",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations",
		"title": "Road Quality Index (1–7)",
		"shortTitle": "Road Quality Index",
		"otherShortTitle": "Road Quality Index",
		"parentCategoryGlobalId": "ETI.C.04.04",
		"includedDashboard": "YES",
		"titleWithUnits": "Road Quality Index (1–7)",
		"fullDescription": "The Road Quality Index developed by the World Economic Forum comprises two elements: a measure of the average speed of a driving itinerary connecting the 10 or more largest cities in an economy accounting for at least 15 percent of the economy’s total population; and a measure of road straightness.The itinerary was not optimized and connects the cities from the largest to the smallest. Any leg involving a ferry is excluded from the average speed calculation. As a first step to the identification of cities to include in the itinerary. pairwise distances (“ as the crow flies” ) were calculated, and when the distance was less than 20 kilometers, the smallest city in the pair was excluded. The road straightness corresponds to the ratio of the sum of driving distances between each city in the journey to the sum of crow fly distances between each city in the journey. For this component, legs involving a ferry were included. The APIs of Google Directions and Open Street Map were used to compute the itinerary. The Geonames database was used for city populations and coordinates. For more information about this indicator, email tge@weforum.org.",
		"GETR2016Number": "4.06"
	},
	"ETI_PROPERTYPROTECT": {
		"descriptionQuestion": "Index of protection of property (1 = extremely weak, 7 = extremely strong)",
		"dataType": "AGGREG",
		"globalId": "ETI_PROPERTYPROTECT",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Protection of property (1–7)",
		"shortTitle": "Protection of property",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Protection of property index (1–7)",
		"fullDescription": "This indicator is a combination of two indicators derived from the World Economic Forum's [i]Executive Opinion Survey[i]: Protection of property rights and Intellectual property protection. See description of each individual indicator for more details.",
		"GETR2016Number": "7.01"
	},
	"SUN-TABCOSTIMPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTIMPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Documentary compliance (1-7)",
		"shortTitle": "Cost to import: Documentary compliance",
		"otherShortTitle": "Cost to import: Documentary compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Documentary compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.05"
	},
	"TABCOSTEXPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABCOSTEXPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			2223
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Border compliance (US$)",
		"shortTitle": "Cost to export: Border compliance",
		"otherShortTitle": "Cost to export: Border compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Border compliance (US$)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.1"
	},
	"SUN-CUSTTRANSPIND": {
		"descriptionQuestion": "Index of transparency of procedures and regulations related to customs clearance (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-CUSTTRANSPIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association",
		"title": "Customs transparency index (1-7)",
		"shortTitle": "Customs transparency index",
		"otherShortTitle": "Customs transparency index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs transparency index (1-7)",
		"fullDescription": "This indicator is based on 7 survey questions taken from the GEA Customs Capabilities Reports, evaluating the overall transparency of the procedures and regulations related to customs clearance. The maximum score an economy can obtain is 1.",
		"GETR2016Number": "3.13"
	},
	"TFA Article 4": {
		"descriptionQuestion": "Procedures for appeal or review",
		"dataType": "HARD",
		"globalId": "TFA Article 4",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 4 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABCOSTIMPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABCOSTIMPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			3039
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Border compliance (US$)",
		"shortTitle": "Cost to import: Border compliance",
		"otherShortTitle": "Cost to import: Border compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Border compliance (US$)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.06"
	},
	"SUN-EOSQ147": {
		"descriptionQuestion": "In your country, how common is it for companies to make undocumented extra payments or bribes in connection with imports and exports  (1 = very low, 7  = very high)",
		"dataType": "SURVEY",
		"globalId": "SUN-EOSQ147",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Irregular payments in exports and imports (1–7)",
		"shortTitle": "Irregular payments in exports and imports",
		"otherShortTitle": "Irregular payments in exports and imports",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Irregular payments in exports and imports (1-7)",
		"fullDescription": "",
		"GETR2016Number": "3.11"
	},
	"TARIFCOMPL": {
		"descriptionQuestion": "Index of complexity of tariffs, 1–7 (least complex) scale",
		"dataType": "AGGREG",
		"globalId": "TARIFCOMPL",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Complexity of tariffs index (1–7)",
		"shortTitle": "Complexity of tariffs",
		"otherShortTitle": "Complexity of tariffs",
		"parentCategoryGlobalId": "ETI.A.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Complexity of tariffs index (1–7)",
		"fullDescription": "This indicator is calculated as the average of the following indicators: Tariff dispersion, Specific tariffs and Number of distinct tariffs. See description of each individual indicator for more details. Prior to averaging, values for each indicator were transformed to a 1-to-7 score, using the min-max method.",
		"GETR2016Number": "1.02"
	},
	"RAILROADQUALITY": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for railroads (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "RAILROADQUALITY",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.18,
			6.72
		],
		"sources": "World Economic Forum,[i] Executive Opinion Survey[i], 2015 and 2016 editions\n[6]Note: N/Appl. is used for economies where the railroad network totals less than 50 km.",
		"title": "Quality of railroad infrastructure (1–7)",
		"shortTitle": "Quality of railroad infrastructure",
		"otherShortTitle": "Quality of railroad infrastructure",
		"parentCategoryGlobalId": "ETI.C.04.02",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of railroad infrastructure*",
		"fullDescription": "N/Appl. is used for economies where the railroad network totals less than 50 km. Assessment of the existence of a network was conducted by the World Economic Forum based on various sources.",
		"GETR2016Number": "4.03"
	},
	"EOSQ360": {
		"descriptionQuestion": "In your country, how efficient are changes between different modes of transport for cargo (e.g. from port to rail or airport to roads)? (1 = extremely inefficient; 7 = extremely efficient)",
		"dataType": "SURVEY",
		"globalId": "EOSQ360",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.55,
			6.54
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Efficiency of transport mode change (1–7)",
		"shortTitle": "Efficiency of transport mode change",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Efficiency of transport mode change*",
		"fullDescription": "",
		"GETR2016Number": "5.06"
	},
	"ETIC06": {
		"descriptionQuestion": "Pillar 6: Availability and use of ICTs",
		"dataType": "AGGREG",
		"globalId": "ETIC06",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and use of ICTs (1–7)",
		"shortTitle": "Pillar 6: Availability and use of ICTs",
		"otherShortTitle": "Availability & use of ICTs",
		"parentCategoryGlobalId": "ETI.C",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 6: Availability and use of ICTs (1–7)",
		"fullDescription": "This pillar evaluates the availability and quality of information and communication technologies (ICTs) in a country, as approximated by the use of mobile telephony and Internet by the population at large, by companies for business transactions, and by the government for interacting with citizens. It also takes into account the quality of internet access, as broadband access has become the norm, to fully leverage the potential of the internet",
		"GETR2016Number": "C.06"
	},
	"ETIC0404": {
		"descriptionQuestion": "Availability and quality of road infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0404",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of road infrastructure (1–7)",
		"shortTitle": "Availability and quality of road infrastructure",
		"otherShortTitle": "Availability and quality of road infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of road infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.04"
	},
	"ETIC": {
		"descriptionQuestion": "Subindex C: Infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Infrastructure (1–7)",
		"shortTitle": "Subindex C: Infrastructure",
		"otherShortTitle": "Infrastructure",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex C: Infrastructure (1–7)",
		"fullDescription": "This subindex assesses the availability and quality of transport infrastructure of a country, associated services, and communication infrastructure, necessary to facilitate the movement of goods within the country and across the border",
		"GETR2016Number": "C"
	},
	"MARGINPREF": {
		"descriptionQuestion": "Index of margin of preference in destination markets, 0–100 (best)",
		"dataType": "HARD",
		"globalId": "MARGINPREF",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			0
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Index of margin of preference in destination markets (0–100)",
		"shortTitle": "Margin of preference in destination markets",
		"otherShortTitle": "Margin of preference in destination markets",
		"parentCategoryGlobalId": "ETI.A.02",
		"includedDashboard": "YES",
		"titleWithUnits": "Index of margin of preference in destination mkts (0–100)",
		"fullDescription": "This indicator measures the percentage by which particular imports from one country are subject to lower tariffs than the MFN rate. It is calculated as the average of two components: 1) the trade-weighted average difference between the MFN tariff and the most advantageous preferential duty (advantage score), and 2) the ratio of the advantage score to the trade-weighted average MFN tariff level. This allows capturing both the absolute and the relative margin of preference.  The reference year for tariffs changes according to the destination market. The majority of countries reports 2015 tariff data",
		"GETR2016Number": "2.02"
	},
	"form_auto": {
		"descriptionQuestion": "Electronic exchange of data; automated border procedures; use of risk management",
		"dataType": "HARD",
		"globalId": "form_auto",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Formalities - automation (0–2)",
		"shortTitle": "Formalities - automation",
		"otherShortTitle": "Formalities - automation",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Formalities - automation (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"ETI": {
		"descriptionQuestion": "Enabling Trade Index",
		"dataType": "AGGREG",
		"globalId": "ETI",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Enabling trade Index (1–7)",
		"shortTitle": "Enabling Trade Index",
		"otherShortTitle": "Enabling Trade Index",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Enabling Trade Index (1–7)",
		"fullDescription": "The Enabling Trade Index assesses the extent to which economies have in place institutions, policies, infrastructures and services facilitating the free flow of goods over borders and to their destination",
		"GETR2016Number": "ETI"
	},
	"ETIC05": {
		"descriptionQuestion": "Pillar 5: Availability and quality of transport services",
		"dataType": "AGGREG",
		"globalId": "ETIC05",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of transport services (1–7)",
		"shortTitle": "Pillar 5: Availability and quality of transport services",
		"otherShortTitle": "Availability & quality of transport services",
		"parentCategoryGlobalId": "ETI.C",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 5: Availability and quality of transport services (1–7)",
		"fullDescription": "A necessary complement to the previous one, this pillar assesses the availability and quality of transport services, including the presence and competencies of shipping and logistics companies in the country, as well as the ease, cost and timeliness of shipment. In addition, this pillar includes a measure of postal efficiency",
		"GETR2016Number": "C.05"
	},
	"CUSTTRANSPIND": {
		"descriptionQuestion": "Index of transparency of procedures and regulations related to customs clearance (0 = worst, 1 = best)",
		"dataType": "HARD",
		"globalId": "CUSTTRANSPIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association",
		"title": "Customs transparency index (0–1)",
		"shortTitle": "Customs transparency index",
		"otherShortTitle": "Customs transparency index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs transparency index (0–1)",
		"fullDescription": "This indicator is based on 7 survey questions taken from the GEA Customs Capabilities Reports, evaluating the overall transparency of the procedures and regulations related to customs clearance. The maximum score an economy can obtain is 1.",
		"GETR2016Number": "3.13"
	},
	"INTLAIRSEATKM": {
		"descriptionQuestion": "Scheduled available international airline seat kilometres per week originating in country (in millions)",
		"dataType": "HARD",
		"globalId": "INTLAIRSEATKM",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0.25,
			13928.58
		],
		"sources": "International Air Transport Association, SRS Analyser",
		"title": "Available international airline seat km/week, millions",
		"shortTitle": "Available airline seat kilometres",
		"otherShortTitle": "Available airline seat kilometers",
		"parentCategoryGlobalId": "ETI.C.04.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Available int'l airline seat km/week, millions",
		"fullDescription": "This variable measures the total passenger-carrying capacity of all scheduled international flights originating in a country. It is computed by taking the number of seats available on each flight multiplied by the flight distance in kilometres, summing the result across all scheduled flights in a week during January (winter schedule) and July (summer schedule) 2013, and taking the average capacity of the two weeks.",
		"GETR2016Number": "4.01"
	},
	"EOSQ138": {
		"descriptionQuestion": "In your country, how restrictive are regulations related to the hiring of foreign labor? (1 = highly restrictive; 7 = not restrictive at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ138",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.05,
			6.18
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Ease of hiring foreign labour (1-7)",
		"shortTitle": "Ease of hiring foreign labour",
		"otherShortTitle": "Ease of hiring foreign labour",
		"parentCategoryGlobalId": "ETI_OPENFRXPART",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease of hiring foreign labour*",
		"fullDescription": "",
		"GETR2016Number": "7.04.a"
	},
	"ETI_FINANCE": {
		"descriptionQuestion": "Index of access to finance (1 = worst, 7 = best)",
		"dataType": "AGGREG",
		"globalId": "ETI_FINANCE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Access to finance (1–7)",
		"shortTitle": "Access to finance",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Access to finance index (1–7) ",
		"fullDescription": "This indicator is a combination of three indicators derived from the World Economic Forum's [i]Executive Opinion Surve[i]y: Financial services meeting business needs, Affordability of financial services, Availability of financial services and Ease of access to loans. See description of each individual indicator for more details.",
		"GETR2016Number": "7.03"
	},
	"EOSQ057": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for foads (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ057",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.32,
			6.72
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of roads (1–7)",
		"shortTitle": "Quality of roads",
		"otherShortTitle": "Quality of roads",
		"parentCategoryGlobalId": "ETI.C.04.04",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of roads*",
		"fullDescription": "",
		"GETR2016Number": "4.07"
	},
	"ETID07": {
		"descriptionQuestion": "Pillar 7: Operating environment",
		"dataType": "AGGREG",
		"globalId": "ETID07",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Operating environment (1–7)",
		"shortTitle": "Pillar 7: Operating environment",
		"otherShortTitle": "Operating environment",
		"parentCategoryGlobalId": "ETI.D",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 7: Operating environment (1–7)",
		"fullDescription": "This pillar assesses the quality of a country’s operating environment, which significantly impacts the capacity of companies that export, import, trade and/or transport merchandise to do business. It assesses a country’s level of protection of property rights, the quality and impartiality of its public institutions, efficiency in enforcing contracts, the availability of finance, openness to foreign participation in terms of foreign investments and labour, as well as the level of personal security approximated by the incidence of crime and terrorism",
		"GETR2016Number": "D.07"
	},
	"TABCOSTEXPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABCOSTEXPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			2500
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Documentary compliance (US$)",
		"shortTitle": "Cost to export: Documentary compliance",
		"otherShortTitle": "Cost to export: Documentary compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Documentary compliance (US$)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.09"
	},
	"TIMESHIP": {
		"descriptionQuestion": "Frequency of shipments reaching the consignee within the scheduled delivery (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "TIMESHIP",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Timeliness of shipments in reaching destination (1–5)",
		"shortTitle": "Timeliness of shipments in reaching destination",
		"otherShortTitle": "Timeliness of shipments in reaching destination",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Timeliness of shipments in reaching destination (1–5)",
		"fullDescription": "This indicator assesses how often shipments reach the consignee within the scheduled delivery time. Respondents to the LPI survey were asked to evaluate the timeliness of shipments in reaching their destination when arranging shipments to eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.04"
	},
	"EOSQ365": {
		"descriptionQuestion": "In your country, to what extent do businesses use ICTs for transactions with other businesses? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ365",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.66,
			6.36
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "ICT use for business-to-business transactions (1–7)",
		"shortTitle": "ICT use for business-to-business transactions",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "ICT use for business-to-business transactions*",
		"fullDescription": "",
		"GETR2016Number": "6.05"
	},
	"EOSQ395": {
		"descriptionQuestion": "In your country, how much does the time required for border clearance of imported goods fluctuate? (1 = fluctuates significantly; 7 = hardly fluctuates at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ395",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.9,
			6.08
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Time predictability of import procedures (1–7)",
		"shortTitle": "Time predictability of import procedures",
		"otherShortTitle": "Time predictability of import procedures",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Time predictability of import procedures*",
		"fullDescription": "",
		"GETR2016Number": "3.12"
	},
	"SUN-CUSTSERVIND": {
		"descriptionQuestion": "Index of extent of quality and comprehensiveness of services provided by customs authorities and related agencies (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-CUSTSERVIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association (GEA) Customs Capabilities Database",
		"title": "Customs services index (1-7)",
		"shortTitle": "Customs services index",
		"otherShortTitle": "Customs services index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs services index (1-7)",
		"fullDescription": "This indicator is based on 17 survey questions taken from the GEA Customs Capabilities Reports, which evaluate the quality and comprehensiveness of services offered by customs and related agencies. The services included: clearance of shipments via electronic data interchange; separation of physical release of goods from fiscal control; full-time (24 hours/7 days a week) automated processing; customs working hours adapted to commercial needs; fee for services conducted during normal service hours; inspection and release of goods arriving by air by the operator's facility; automated risk assessment as primary basis for physical examination of shipments; multiple inspections (inspections by agencies other than customs) and the promptness of those inspections; exemptions from full customs formalities for shipments of minimal value; exemptions from a duties and taxes for shipments of minimal value; clearance of shipments by a third party; appeal of customs decisions to a higher level or an independent tribunal; and use of reference prices or arbitrary uplifts to invoice values. The maximum score an economy can obtain is 7.",
		"GETR2016Number": "3.01"
	},
	"IMPCOSTCOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "IMPCOSTCOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Cost for documentary and border compliance for importing (USD)",
		"shortTitle": "Cost for documentary and border compliance for importing",
		"otherShortTitle": "Cost to comply with documentary and border compliance for importing",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Cost for documentary and border compliance for importing (USD)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"MOBSUBPC": {
		"descriptionQuestion": "Mobile telephone subscriptions (post-paid and pre-paid) per 100 population",
		"dataType": "HARD",
		"globalId": "MOBSUBPC",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			4151900
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Mobile phone subscriptions/100 pop.",
		"shortTitle": "Mobile telephone subscriptions",
		"otherShortTitle": "Mobile telephone subscriptions",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Mobile phone subscriptions/100 pop.",
		"fullDescription": "According to the World Bank, mobile cellular telephone subscriptions are subscriptions to a public mobile telephone service using cellular technology, which provides access to switched telephone technology. Postpaid and prepaid subscriptions are included. This can also include analogue and digital cellular systems but should not include non-cellular systems. Subscribers to fixed wireless, public mobile data services or radio paging services are not included.",
		"GETR2016Number": "6.01"
	},
	"MOBBBSUBPC": {
		"descriptionQuestion": "Active mobile broadband Internet subscriptions per 100 population",
		"dataType": "HARD",
		"globalId": "MOBBBSUBPC",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			291900
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Active mobile broadband Internet subscriptions/100 pop.",
		"shortTitle": "Active mobile broadband subscriptions",
		"otherShortTitle": "Active mobile broadband subscriptions",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Active mobile broadband Internet subscriptions/100 pop.",
		"fullDescription": "The International Telecommunication Union considers active mobile broadband internet subscriptions all “Standard mobile-broadband subscriptions (via a mobile-cellular telephone)” and “Dedicated mobile-broadband subscriptions (via UBS dongle/modem or as add-on data package to voice package”. Other wireless-broadband subscriptions, such as “Terrestrial fixed (wireless)-broadband subscriptions” (e.g. WiMAX) and “Satellite-broadband subscriptions”, are excluded from this indicator.",
		"GETR2016Number": "6.04"
	},
	"TFA Article 7": {
		"descriptionQuestion": "Release and clearance of goods",
		"dataType": "HARD",
		"globalId": "TFA Article 7",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 7 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"SHIPAFFORD": {
		"descriptionQuestion": "Ease of arranging competitively priced international shipments (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "SHIPAFFORD",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Ease and affordability of shipment (1–5)",
		"shortTitle": "Ease and affordability of shipment",
		"otherShortTitle": "Ease and affordability of shipment",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease and affordability of shipment (1–5)",
		"fullDescription": "This indicator assesses the ease and affordability associated with arranging international shipments. Respondents to the LPI survey were asked to evaluate the ease and affordability associated with arranging international shipments to or from eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.01"
	},
	"TFA Article 12": {
		"descriptionQuestion": "Customs cooperation",
		"dataType": "HARD",
		"globalId": "TFA Article 12",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 12 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABCOSTIMPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABCOSTIMPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1025
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Documentary compliance (US$)",
		"shortTitle": "Cost to import: Documentary compliance",
		"otherShortTitle": "Cost to import: Documentary compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Documentary compliance (US$)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.05"
	},
	"SUN-TABCOSTIMPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTIMPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Border compliance (1-7)",
		"shortTitle": "Cost to import: Border compliance",
		"otherShortTitle": "Cost to import: Border compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Border compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.06"
	},
	"TARIFSPECIAL": {
		"descriptionQuestion": "Share of tariff lines with specific tariffs (%)",
		"dataType": "HARD",
		"globalId": "TARIFSPECIAL",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Specific tariffs (% of tariff lines)",
		"shortTitle": "Specific tariffs",
		"otherShortTitle": "Specific tariffs",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Specific tariffs (% of tariff lines)",
		"fullDescription": "This indicator is the ratio of the number of Harmonized System (HS) tariff lines, with at least one specific tariff, to the total number of HS tariff lines. A specific tariff is a tariff rate charged on fixed amount per quantity (as opposed to ad valorem).",
		"GETR2016Number": "1.02.c"
	},
	"SUN-EOSQ395": {
		"descriptionQuestion": "In your country, how much does the time required for border clearance of imported goods fluctuate?  (1 = very low, 7  = very high)",
		"dataType": "SURVEY",
		"globalId": "SUN-EOSQ395",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Time predictability of import procedures (1–7)",
		"shortTitle": "Time predictability of import procedures",
		"otherShortTitle": "Time predictability of import procedures",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Time predictability of import procedures (1-7)",
		"fullDescription": "",
		"GETR2016Number": "3.12"
	},
	"ETI_OPENFRXPART": {
		"descriptionQuestion": "Index of openness to foreign participation (1 = worst, 7 = best)",
		"dataType": "AGGREG",
		"globalId": "ETI_OPENFRXPART",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from World Economic Forum and International Trade Centre.",
		"title": "Openness to foreign participation (1–7)",
		"shortTitle": "Openness to foreign participation",
		"otherShortTitle": "Openness to foreign participation",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Openness to foreign participation index (1–7)",
		"fullDescription": "This indicator is a combination of the Ease of hiring foreign labour, Business impact of rules on FDI (both derived from the World Economic Forum's Executive Opinion Survey) and Openness to multilateral trade rules (International Trade Centre) indicators. See description of each individual indicator for more details.",
		"GETR2016Number": "7.04"
	},
	"SUN-TABTIMEEXPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEEXPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Border compliance (1-7)",
		"shortTitle": "Time to export: Border compliance",
		"otherShortTitle": "Time to export: Border compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Border compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.08"
	},
	"ETID": {
		"descriptionQuestion": "Subindex D: Operating environment",
		"dataType": "AGGREG",
		"globalId": "ETID",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Operating environment (1–7)",
		"shortTitle": "Subindex D: Operating environment",
		"otherShortTitle": "Operating environment",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex D: Operating environment (1–7)",
		"fullDescription": "This subindex assesses the quality of a country’s operating environment, which significantly impacts the capacity of companies that export, import, trade and/or transport merchandise to do business. It assesses a country’s level of protection of property rights, the quality and impartiality of its public institutions, efficiency in enforcing contracts, the availability of finance, openness to foreign participation in terms of foreign investments and labour, as well as the level of personal security approximated by the incidence of crime and terrorism",
		"GETR2016Number": "D"
	},
	"TFA Article 3": {
		"descriptionQuestion": "Advance rulings",
		"dataType": "HARD",
		"globalId": "TFA Article 3",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 3 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"ETIA02": {
		"descriptionQuestion": "Pillar 2: Foreign market access",
		"dataType": "AGGREG",
		"globalId": "ETIA02",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Foreign market access (1–7)",
		"shortTitle": "Pillar 2: Foreign market access",
		"otherShortTitle": "Foreign market access",
		"parentCategoryGlobalId": "ETI.A",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 2: Foreign market access (1–7)",
		"fullDescription": "This pillar assesses tariff barriers faced by a country’s exporters in destination markets. It includes the average tariffs faced by the country as well as the margin of preference in destination markets negotiated through bilateral or regional trade agreements, or granted in the form of trade preferences.",
		"GETR2016Number": "A.02"
	},
	"ETI_SECURITY": {
		"descriptionQuestion": "Index of physical security (1 = lowest, 7 = highest)",
		"dataType": "AGGREG",
		"globalId": "ETI_SECURITY",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from World Economic Forum, United Nations Office on Drugs and Crime and START Global Terrorism Database",
		"title": "Physical security (1–7)",
		"shortTitle": "Physical security",
		"otherShortTitle": "Physical security",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Index of physical security (1–7)",
		"fullDescription": "This indicator is a combination of the Reliability of police services, Business costs of crime and violence and Business costs of terrorism (all derived from the World Economic Forum's Executive Opinion Survey), Homicide rate indicators and Incidence of terrorism. See description of each individual indicator for more details.",
		"GETR2016Number": "7.05"
	},
	"ETIC0403": {
		"descriptionQuestion": "Availability and quality of port infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0403",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of port infrastructure (1–7)",
		"shortTitle": "Availability and quality of port infrastructure",
		"otherShortTitle": "Availability and quality of port infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of port infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.03"
	},
	"TFA Article 10": {
		"descriptionQuestion": "Formalities connected with importation, exportation and transit",
		"dataType": "HARD",
		"globalId": "TFA Article 10",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 10 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ353": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for seaports (for landlocked countries – please assess access to seaports) (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ353",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.27,
			6.82
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of port infrastructure (1–7)",
		"shortTitle": "Quality of port infrastructure",
		"otherShortTitle": "Quality of port infrastructure",
		"parentCategoryGlobalId": "ETI.C.04.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of port infrastructure*",
		"fullDescription": "",
		"GETR2016Number": "4.05"
	},
	"EOSQ468": {
		"descriptionQuestion": "In your country, to what extent does the financial sector provide the products and services that meet the needs of businesses? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ468",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.27,
			5.97
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Financial services meeting business needs (1-7)",
		"shortTitle": "Financial services meeting business needs",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_FINANCE",
		"includedDashboard": "YES",
		"titleWithUnits": "Financial services meeting business needs*",
		"fullDescription": "",
		"GETR2016Number": "7.03.a"
	},
	"SUN-TABTIMEIMPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEIMPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Documentary compliance (1-7)",
		"shortTitle": "Time to import: Documentary compliance",
		"otherShortTitle": "Time to import: Documentary compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Documentary compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.03"
	}
};

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {
	"1": "International Telecommunications Union (ITU); World Telecommunication/ICT Indicators (WTI) Database (December 2016) | 01/03/2017 | ",
	"2": "Authors' calculations based on National Consortium for the Study of Terrorism and Responses to Terrorism (START); Global Terrorism Database; www.start.umd.edu/gtd | 03/03/2017 | ",
	"3": "United Nations Department of Economic and Social Affairs (UNDESA); UN E-Government Development Database | 02/03/2017 | ",
	"4": "World Bank; Doing Business Database | 02/03/2017 | ",
	"5": "World Bank and Turku School of Economics; Logistic Performance Index Surveys; World Development Indicators Database | 17/02/2017 | ",
	"6": "United Nations Office for Drugs and Crime (UNODC) | 03/03/2017 | ",
	"7": "United Nations Conference on Trade and Development (UNCTAD); World Development Indicators Database | 17/02/2017 | ",
	"8": "World Economic Forum; Executive Opinion Survey |  | 2006 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"9": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 13 available indicators out of 17",
	"10": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 7 available indicators out of 7",
	"11": "World Economic Forum; Executive Opinion Survey |  | 2010 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"12": "World Economic Forum; Executive Opinion Survey |  | 2010-2011 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"13": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators | 22/10/2016 | ",
	"14": "World Economic Forum; Executive Opinion Survey |  | 2013 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"15": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 18/02/2014 | Based on 16 available indicators out of 17",
	"16": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 18/02/2014 | Based on 7 available indicators out of 7",
	"17": "World Economic Forum; Executive Opinion Survey |  | 2013-2014 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"18": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 16 available indicators out of 17",
	"19": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 7 available indicators out of 7",
	"20": "World Economic Forum; Executive Opinion Survey |  | 2005 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"21": "World Economic Forum; Executive Opinion Survey |  | 2005-2006 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"22": "World Economic Forum; Executive Opinion Survey |  | 2006-2007 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"23": "World Economic Forum; Executive Opinion Survey |  | 2007-2008 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"24": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 16 available indicators out of 17",
	"25": "World Economic Forum; Executive Opinion Survey |  | 2008-2009 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"26": "World Economic Forum; Executive Opinion Survey |  | 2009-2010 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"27": "The World Bank;Logistics Performance Index: Connecting to Compete 2012;www.worldbank.org/lpi | 15/05/2012 | 0",
	"28": "United Nations Office on Drugs and Crime (UNODC); Crime and criminal justice statistics; http://www.unodc.org/unodc/en/data-and-analysis/statistics/crime.html | 29/07/2013 | ",
	"29": "The World Bank;Logistics Performance Index: Connecting to Compete 2012;www.worldbank.org/lpi | 15/05/2012 | ",
	"30": "National Consortium for the Study of Terrorism and Responses to Terrorism (START);Global Terrorism Database;http://www.start.umd.edu/gtd | 31/01/2014 | ",
	"31": "International Telecommunication Union (ITU), ITU World Telecommunication/ICT Indicators Database 2013 (December 2013 edition) | 06/12/2013 | ",
	"32": "United Nations Department of Economic and Social Affairs (UNDESA); UN E-Government Development Database; http://unpan3.un.org/egovkb/index.aspx | 07/11/2013 | ",
	"33": "World Economic Forum; Executive Opinion Survey |  | 2011-2012 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"34": "IATA;SRS Analyser;http://www.iata.org/publications/srs/Pages/analyser.aspx | 12/06/2013 | ",
	"35": "United Nations Conference on Trade and Development (UNCTAD); Transport Section; Trade Logistics Branch; http://unctadstat.unctad.org/TableViewer/tableView.aspx?ReportId=92 | 17/06/2013 | ",
	"36": "International Trade Centre; Market Access Map Database; www.macmap.org | 26/10/2016 | ",
	"37": "International Trade Centre; LegaCarta Database; www.legacarta.net | 01/12/2013 | ",
	"38": "International Trade Centre; Market Access Map Database; www.macmap.org | 01/11/2016 | ",
	"39": "World Economic Forum; The Global Enabling Trade Report 2014; www.weforum.org/getr | 01/04/2014 | ",
	"40": "International Trade Centre; Market Access Map Database; www.macmap.org | 01/02/2014 | ",
	"41": "World Economic Forum; Executive Opinion Survey |  | 2012-2013 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"42": "World Economic Forum's calculations based on Global Express Association (GEA) Customs Capabilities Reports; http://www.global-express.org/index.php?id=4 | 10/02/2014 | ",
	"43": "World Bank/IFC; Doing Business; www.doingbusiness.org | 02/03/2017 | ",
	"44": "World Economic Forum; The Global Enabling Trade Report 2016; www.weforum.org/getr | 02/03/2017 | ",
	"45": "World Economic Forum; The Global Enabling Trade Report 2016; www.weforum.org/getr | 30/11/2016 | ",
	"46": "United Nations Office on Drugs and Crime (UNODC) | 28/09/2016 | ",
	"47": "World Bank/IFC; Doing Business Trading Across Borders database; www.doingbusiness.org | 15/11/2016 | ",
	"48": "World Economic Forum's calculations based on data from National Consortium for the Study of Terrorism and Responses to Terrorism (START). Global Terrorism Database. Retrieved from http://www.start.umd.edu/gtd on 28 September 2016. |  9/28/2016 | ",
	"49": "International Telecommunication Union, ITU World Telecommunication/ICT Indicators Database 2016  |   7/1/2016 | ",
	"50": "World Bank; Logistics Performance Index (LPI) International Database; http://lpi.worldbank.org | 03/10/2016 | ",
	"51": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 10 available out of 17",
	"52": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 6 available out of 7",
	"53": "International Trade Centre; Market Access Map Database; www.macmap.org | 18/02/2016 | The reference year changes according to the destination market. The majority of countries reports 2015 data.",
	"54": "International Trade Centre; Market Access Map Database; www.macmap.org | 23/03/2016 | ",
	"55": "International Trade Centre; Market Access Map Database; www.macmap.org | 28/10/2016 | The reference year changes according to the destination market. The majority of countries reports 2015 data.",
	"56": "International Trade Centre; Market Access Map Database; www.macmap.org | 18/02/2016 | ",
	"57": "World Economic Forum; Executive Opinion Survey |  | 2014-2015 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"58": "World Economic Forum; Executive Opinion Survey |  | 2015 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"59": "The World Bank Group, Doing Business | 10/28/2016 | ",
	"60": "United Nations, 2016 E-Government for Sustainable Development |  7/31/2016 | ",
	"61": "IATA, SRS Analyser |  6/11/2016 | ",
	"62": "UNCTAD, Division on Technology and Logistics, based on Containerization International Online and  Lloyds List Intelligence | 04/10/2016 | ",
	"63": "International Trade Centre; Trade Treaties Map - LegaCarta database | 11/02/2016 | ",
	"64": "World Economic Forum | 10/19/2016 | ",
	"65": "World Bank/IFC; Doing Business 2017: Equal opportunity for all; www.doingbusiness.org | 24/10/2016 | ",
	"66": "World Economic Forum; Executive Opinion Survey |  | 2015-2016 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"67": "World Economic Forum; Executive Opinion Survey |  | 2016 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"68": "World Economic Forum; Executive Opinion Survey |  | 2004-2005 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"69": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 14 available indicators out of 17",
	"70": "World Economic Forum; Executive Opinion Survey |  | 2012 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"71": "The World Bank;The Logistics Performance Index 2014;www.worldbank.org/lpi | 20/03/2014 | ",
	"72": "World Economic Forum; Executive Opinion Survey |  | 2012-2014 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"73": "World Economic Forum; Executive Opinion Survey |  | 2014 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"74": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 14 available out of 17",
	"75": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 7 available out of 7",
	"76": "World Economic Forum; Executive Opinion Survey |  | 2014-2016 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"77": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 17 available out of 17",
	"78": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 15 available indicators out of 17",
	"79": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 15 available out of 17",
	"80": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 16 available out of 17",
	"81": "World Bank; Logistics Performance Index (LPI) International Database; http://lpi.worldbank.org | 03/10/2016 | 0",
	"82": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 17 available indicators out of 17",
	"83": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 6 available indicators out of 7",
	"84": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 11 available indicators out of 17",
	"85": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 18/02/2014 | Based on 17 available indicators out of 17",
	"86": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 17 available indicators out of 17",
	"87": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 12 available indicators out of 17",
	"88": "World Economic Forum; Executive Opinion Survey |  | 2011 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"89": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 4 available out of 7",
	"90": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 14 available indicators out of 17",
	"91": "World Economic Forum; Executive Opinion Survey |  | 2008 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"92": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 13 available out of 17",
	"93": "International Telecommunication Union (ITU), ITU World Telecommunication/ICT Indicators Database 2013 (December 2013 edition) | 06/12/2013 | 0",
	"94": "World Economic Forum; Executive Opinion Survey |  | 2011-2013 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"95": "United Nations Office on Drugs and Crime (UNODC); Crime and criminal justice statistics; http://www.unodc.org/unodc/en/data-and-analysis/statistics/crime.html | 29/07/2013 | Authors' elaboration based on data provided by UNODC",
	"96": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 9 available indicators out of 17",
	"97": "World Economic Forum; Executive Opinion Survey |  | 2010-2012 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"98": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 5 available out of 7",
	"99": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 12 available out of 17",
	"100": "World Economic Forum; Executive Opinion Survey |  | 2007 data. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"101": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 02/03/2017 | Based on 4 available indicators out of 7",
	"102": "n/a | n/a | ",
	"103": "Authors' calculations based on Global Express Association (GEA); Customs Capability Report | 05/10/2016 | Based on 11 available out of 17",
	"104": "World Economic Forum; Executive Opinion Survey |  | 2013-2015 weighted average. For more information about the Executive Opinion Survey, see chapter 1.3 of the Global Competitiveness Report (www.weforum.org/gcr)",
	"105": "The World Bank;Logistics Performance Index: Connecting to Compete 2010;www.worldbank.org/lpi | 03/05/2010 | "
};

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {
	"1": {
		"provisions": {
			"provision 1.3": true,
			"provision 1.1": true,
			"provision 1.4": true,
			"provision 1.2": true
		},
		"max": 400
	},
	"2": {
		"provisions": {
			"provision 2.1": true,
			"provision 2.2": true
		},
		"max": 200
	},
	"3": {
		"provisions": {
			"provision 3": true
		},
		"max": 100
	},
	"4": {
		"provisions": {
			"provision 4": true
		},
		"max": 100
	},
	"5": {
		"provisions": {
			"provision 5.2": true,
			"provision 5.1": true,
			"provision 5.3": true
		},
		"max": 300
	},
	"6": {
		"provisions": {
			"provision 6.1": true,
			"provision 6.3": true,
			"provision 6.2": true
		},
		"max": 300
	},
	"7": {
		"provisions": {
			"provision 7.2": true,
			"provision 7.6": true,
			"provision 7.1": true,
			"provision 7.9": true,
			"provision 7.5": true,
			"provision 7.3": true,
			"provision 7.7": true,
			"provision 7.8": true,
			"provision 7.4": true
		},
		"max": 900
	},
	"8": {
		"provisions": {
			"provision 8": true
		},
		"max": 100
	},
	"9": {
		"provisions": {
			"provision 9": true
		},
		"max": 100
	},
	"10": {
		"provisions": {
			"provision 10.4": true,
			"provision 10.1": true,
			"provision 10.7": true,
			"provision 10.9": true,
			"provision 10.2": true,
			"provision 10.8": true,
			"provision 10.5": true,
			"provision 10.6": true,
			"provision 10.3": true
		},
		"max": 900
	},
	"11": {
		"provisions": {
			"provision 11": true
		},
		"max": 100
	},
	"12": {
		"provisions": {
			"provision 12": true
		},
		"max": 100
	}
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(246);
module.exports = __webpack_require__(245);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.b8d1fcf2.js